/* tslint:disable */
/* eslint-disable */
/**
 * Proposed Symmons Customer Internal API
 * ## REST API This application will follow the RESTful API pattern. Each object below is a resource. Resources can be accessed via a CRUD pattern, using HTTP verbs to request actions on specific resources. Resource endpoints are named with plural and singular names to indicate the kind of query. So `GET /companies` will fetch a list of companies, whereas `GET /company/1` will fetch a single company.  ## Resources __User__ is an authenticatable user object. User authentication will be required for access to all data. Users must have at least one role: - __user__: Can access all orders within their company. Can search for all products, and see pricing specific to their company and locations - __location manager__ : Inherits user. Can onboard new users within a location. Can create and report on locations - __company manager__: Inherits user. Can onboard new users within a location. May be able to manage locations - __administrator__: Symmons Administrators. Can create companies, manage locations, view diagnostics and reports, and onboard users __Order__ is the object that contains a single order, identified by an order id. Each order will contain an array of line items. __OrderLine__ is a single line item, generally a single product. The line has a unique identifier, which is a hashed composite of the order id and the line increment number. Each order contains a short form of the product for rendering a product title, price, shipping information, and image. __Company__ is an organizational structure for users and order. Companies have many orders and many users, and any user in a company, can have access any order. Orders are accessed via a bill_to_id. Each company has one bill_to_id and we control access via that bill_to_id. __Location__ Each company also can have multiple ship_to_ids, defining multiple locations. Each company has multiple locations and users can be associated with multiple locations. This way a user can filter to see only orders associated with their location. __Product__ is a salsify product object. Order lines contain products, and products are shipped to algolia for display on the frontend product search. Products are necessary for the price lookup. __Price__ is an object that describes the special pricing for a particular product and user.  ## Authentication We will use a JWT authentication schema, powered by Laravel Passport. Users are authenticated by submitting credentials to the /oauth/token endpoint. Any client seeing JWT authentication will need to supply a client id and  ## Additional considerations ### IDs Companies and Locations have an internal middleware id and then the admin editable bill_to and ship_to ids that connect them back to the parent records in the symmons database. ### Pagination List endpoints are paginated at 30 per page. The ?page={int} query string will allow paging through the list results.  Page is indexed from 0, so 1 is the second page of results. If needed, ?perPage={int} can be used to page the results ### Responses At present we have defined the following possible responses codes for each request. - 200 indicates a successful query and returns data. - 204 indicates the request was successful and no response will be returned. - 401 indicates a bad authentication token. - 403 indicates the user cannot access a particular resource. - 404 indicates the record cannot be found. - 422 indicates the request JSON cannot be parsed. - 500 indicates a critical system error. These errors will be logged in sentry 
 *
 * The version of the OpenAPI document: v0.0.1
 * Contact: brad@convertiv.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AdminUser
 */
export interface AdminUser {
    /**
     * 
     * @type {number}
     * @memberof AdminUser
     */
    'id': number;
    /**
     * Is the user\'s company an wholesaler
     * @type {boolean}
     * @memberof AdminUser
     */
    'wholesaler'?: boolean;
    /**
     * Is the user\'s company an evolution owner
     * @type {boolean}
     * @memberof AdminUser
     */
    'evolution'?: boolean;
    /**
     * Can the user buy direct via the quote interface
     * @type {boolean}
     * @memberof AdminUser
     */
    'direct_buyer'?: boolean;
    /**
     * The company id
     * @type {number}
     * @memberof AdminUser
     */
    'company_id': number;
    /**
     * The location id
     * @type {number}
     * @memberof AdminUser
     */
    'location_id': number;
    /**
     * The agency id
     * @type {number}
     * @memberof AdminUser
     */
    'agency_id': number;
    /**
     * Whether this user has access to all territories
     * @type {boolean}
     * @memberof AdminUser
     */
    'all_territories'?: boolean;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof AdminUser
     */
    'first_name': string | null;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof AdminUser
     */
    'last_name': string | null;
    /**
     * 
     * @type {FileAvatarRelation}
     * @memberof AdminUser
     */
    'image': FileAvatarRelation | null;
    /**
     * 
     * @type {PendingQuote}
     * @memberof AdminUser
     */
    'pending_quote'?: PendingQuote | null;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof AdminUser
     */
    'email': string;
    /**
     * The phone number of the user
     * @type {string}
     * @memberof AdminUser
     */
    'phone'?: string | null;
    /**
     * 
     * @type {UserSharedPermissions}
     * @memberof AdminUser
     */
    'permissions': UserSharedPermissions;
    /**
     * The last login date
     * @type {string}
     * @memberof AdminUser
     */
    'last_login': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminUser
     */
    'login_count': number;
    /**
     * The last login date
     * @type {string}
     * @memberof AdminUser
     */
    'last_access': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminUser
     */
    'access_count': number;
    /**
     * 
     * @type {string}
     * @memberof AdminUser
     */
    'email_verified_at': string | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof AdminUser
     */
    'created_at': string;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof AdminUser
     */
    'updated_at': string;
    /**
     * Whether the user has enabled 2FA
     * @type {boolean}
     * @memberof AdminUser
     */
    'google2fa_enabled'?: boolean;
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof AdminUser
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {LocationRelation}
     * @memberof AdminUser
     */
    'location'?: LocationRelation | null;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof AdminUser
     */
    'company'?: CompanyRelation | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUser
     */
    'role': AdminUserRoleEnum;
}

export const AdminUserRoleEnum = {
    Admin: 'admin'
} as const;

export type AdminUserRoleEnum = typeof AdminUserRoleEnum[keyof typeof AdminUserRoleEnum];

/**
 * 
 * @export
 * @interface AdminUserAllOf
 */
export interface AdminUserAllOf {
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof AdminUserAllOf
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {LocationRelation}
     * @memberof AdminUserAllOf
     */
    'location'?: LocationRelation | null;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof AdminUserAllOf
     */
    'company'?: CompanyRelation | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserAllOf
     */
    'role': AdminUserAllOfRoleEnum;
}

export const AdminUserAllOfRoleEnum = {
    Admin: 'admin'
} as const;

export type AdminUserAllOfRoleEnum = typeof AdminUserAllOfRoleEnum[keyof typeof AdminUserAllOfRoleEnum];

/**
 * 
 * @export
 * @interface Agency
 */
export interface Agency {
    /**
     * 
     * @type {number}
     * @memberof Agency
     */
    'id': number;
    /**
     * The status of the task (0 = inactive | 1 = active)
     * @type {boolean}
     * @memberof Agency
     */
    'status': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agency
     */
    'index_pending': boolean;
    /**
     * The name of the customer
     * @type {string}
     * @memberof Agency
     */
    'name': string;
    /**
     * The array of users attached to this agency
     * @type {Array<UserRelation>}
     * @memberof Agency
     */
    'users': Array<UserRelation>;
    /**
     * 
     * @type {TerritoryRelation}
     * @memberof Agency
     */
    'territory'?: TerritoryRelation | null;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof Agency
     */
    'company'?: CompanyRelation | null;
    /**
     * 
     * @type {Array<AgencyGoal>}
     * @memberof Agency
     */
    'goals'?: Array<AgencyGoal>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Agency
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Agency
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface AgencyGoal
 */
export interface AgencyGoal {
    /**
     * 
     * @type {number}
     * @memberof AgencyGoal
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AgencyGoal
     */
    'agency_id': number | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyGoal
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AgencyGoal
     */
    'territory_id': number;
    /**
     * 
     * @type {string}
     * @memberof AgencyGoal
     */
    'bill_to_id': string;
    /**
     * 
     * @type {number}
     * @memberof AgencyGoal
     */
    'total_orders': number;
    /**
     * 
     * @type {string}
     * @memberof AgencyGoal
     */
    'total_revenue': string;
    /**
     * 
     * @type {string}
     * @memberof AgencyGoal
     */
    'average_order_size': string;
    /**
     * 
     * @type {string}
     * @memberof AgencyGoal
     */
    'sales_goal': string;
    /**
     * 
     * @type {string}
     * @memberof AgencyGoal
     */
    'percent_goal_achieved': string;
    /**
     * 
     * @type {number}
     * @memberof AgencyGoal
     */
    'last_fiscal_year_orders': number;
    /**
     * 
     * @type {string}
     * @memberof AgencyGoal
     */
    'last_fiscal_year_revenue': string;
    /**
     * 
     * @type {string}
     * @memberof AgencyGoal
     */
    'last_fiscal_year_average_order_size': string;
    /**
     * 
     * @type {string}
     * @memberof AgencyGoal
     */
    'order_size_growth_percent': string;
    /**
     * 
     * @type {TerritoryRelation}
     * @memberof AgencyGoal
     */
    'territory'?: TerritoryRelation | null;
}
/**
 * 
 * @export
 * @interface AgencyGoalRelationUpdate
 */
export interface AgencyGoalRelationUpdate {
    /**
     * The id of the agency goal
     * @type {number}
     * @memberof AgencyGoalRelationUpdate
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface AgencyRelation
 */
export interface AgencyRelation {
    /**
     * 
     * @type {number}
     * @memberof AgencyRelation
     */
    'id': number;
    /**
     * The name of the customer
     * @type {string}
     * @memberof AgencyRelation
     */
    'name': string;
    /**
     * The bill to address array.  Only the bill_to_id is required for submission.  The rest will be autoretrieved
     * @type {Array<BillToRelation>}
     * @memberof AgencyRelation
     */
    'addresses': Array<BillToRelation>;
    /**
     * 
     * @type {UserRelation}
     * @memberof AgencyRelation
     */
    'sales_rep': UserRelation | null;
    /**
     * 
     * @type {Array<UserRelation>}
     * @memberof AgencyRelation
     */
    'sales_reps': Array<UserRelation>;
    /**
     * The status of the task (0 = inactive | 1 = active)
     * @type {boolean}
     * @memberof AgencyRelation
     */
    'status': boolean;
    /**
     * 
     * @type {TerritoryRelation}
     * @memberof AgencyRelation
     */
    'territory'?: TerritoryRelation | null;
    /**
     * 
     * @type {RegionRelation}
     * @memberof AgencyRelation
     */
    'region'?: RegionRelation | null;
}
/**
 * 
 * @export
 * @interface AgencyRelationUpdate
 */
export interface AgencyRelationUpdate {
    /**
     * 
     * @type {number}
     * @memberof AgencyRelationUpdate
     */
    'id': number;
    /**
     * The name of the customer
     * @type {string}
     * @memberof AgencyRelationUpdate
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface AgencyRepUser
 */
export interface AgencyRepUser {
    /**
     * 
     * @type {number}
     * @memberof AgencyRepUser
     */
    'id': number;
    /**
     * Is the user\'s company an wholesaler
     * @type {boolean}
     * @memberof AgencyRepUser
     */
    'wholesaler'?: boolean;
    /**
     * Is the user\'s company an evolution owner
     * @type {boolean}
     * @memberof AgencyRepUser
     */
    'evolution'?: boolean;
    /**
     * Can the user buy direct via the quote interface
     * @type {boolean}
     * @memberof AgencyRepUser
     */
    'direct_buyer'?: boolean;
    /**
     * The company id
     * @type {number}
     * @memberof AgencyRepUser
     */
    'company_id': number;
    /**
     * The location id
     * @type {number}
     * @memberof AgencyRepUser
     */
    'location_id': number;
    /**
     * The agency id
     * @type {number}
     * @memberof AgencyRepUser
     */
    'agency_id': number;
    /**
     * Whether this user has access to all territories
     * @type {boolean}
     * @memberof AgencyRepUser
     */
    'all_territories'?: boolean;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof AgencyRepUser
     */
    'first_name': string | null;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof AgencyRepUser
     */
    'last_name': string | null;
    /**
     * 
     * @type {FileAvatarRelation}
     * @memberof AgencyRepUser
     */
    'image': FileAvatarRelation | null;
    /**
     * 
     * @type {PendingQuote}
     * @memberof AgencyRepUser
     */
    'pending_quote'?: PendingQuote | null;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof AgencyRepUser
     */
    'email': string;
    /**
     * The phone number of the user
     * @type {string}
     * @memberof AgencyRepUser
     */
    'phone': string | null;
    /**
     * 
     * @type {UserSharedPermissions}
     * @memberof AgencyRepUser
     */
    'permissions': UserSharedPermissions;
    /**
     * The last login date
     * @type {string}
     * @memberof AgencyRepUser
     */
    'last_login': string | null;
    /**
     * 
     * @type {number}
     * @memberof AgencyRepUser
     */
    'login_count': number;
    /**
     * The last login date
     * @type {string}
     * @memberof AgencyRepUser
     */
    'last_access': string | null;
    /**
     * 
     * @type {number}
     * @memberof AgencyRepUser
     */
    'access_count': number;
    /**
     * 
     * @type {string}
     * @memberof AgencyRepUser
     */
    'email_verified_at': string | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof AgencyRepUser
     */
    'created_at': string;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof AgencyRepUser
     */
    'updated_at': string;
    /**
     * Whether the user has enabled 2FA
     * @type {boolean}
     * @memberof AgencyRepUser
     */
    'google2fa_enabled'?: boolean;
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof AgencyRepUser
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {SalesRepUserAllOfRepresents}
     * @memberof AgencyRepUser
     */
    'represents': SalesRepUserAllOfRepresents;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof AgencyRepUser
     */
    'company'?: CompanyRelation | null;
    /**
     * 
     * @type {LocationRelation}
     * @memberof AgencyRepUser
     */
    'location'?: LocationRelation | null;
    /**
     * 
     * @type {Hours}
     * @memberof AgencyRepUser
     */
    'hours': Hours | null;
    /**
     * 
     * @type {AgencyRelation}
     * @memberof AgencyRepUser
     */
    'agency': AgencyRelation;
    /**
     * Does the user\'s agency have a sales goals report that the user can see?
     * @type {boolean}
     * @memberof AgencyRepUser
     */
    'agency_has_report'?: boolean;
    /**
     * 
     * @type {Array<TerritoryRelation>}
     * @memberof AgencyRepUser
     */
    'territories'?: Array<TerritoryRelation>;
    /**
     * 
     * @type {string}
     * @memberof AgencyRepUser
     */
    'role': AgencyRepUserRoleEnum;
}

export const AgencyRepUserRoleEnum = {
    AgencyRep: 'agency_rep'
} as const;

export type AgencyRepUserRoleEnum = typeof AgencyRepUserRoleEnum[keyof typeof AgencyRepUserRoleEnum];

/**
 * 
 * @export
 * @interface AgencyRepUserAllOf
 */
export interface AgencyRepUserAllOf {
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof AgencyRepUserAllOf
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {SalesRepUserAllOfRepresents}
     * @memberof AgencyRepUserAllOf
     */
    'represents': SalesRepUserAllOfRepresents;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof AgencyRepUserAllOf
     */
    'company'?: CompanyRelation | null;
    /**
     * 
     * @type {LocationRelation}
     * @memberof AgencyRepUserAllOf
     */
    'location'?: LocationRelation | null;
    /**
     * 
     * @type {Hours}
     * @memberof AgencyRepUserAllOf
     */
    'hours': Hours | null;
    /**
     * 
     * @type {AgencyRelation}
     * @memberof AgencyRepUserAllOf
     */
    'agency': AgencyRelation;
    /**
     * Does the user\'s agency have a sales goals report that the user can see?
     * @type {boolean}
     * @memberof AgencyRepUserAllOf
     */
    'agency_has_report'?: boolean;
    /**
     * 
     * @type {Array<TerritoryRelation>}
     * @memberof AgencyRepUserAllOf
     */
    'territories'?: Array<TerritoryRelation>;
    /**
     * 
     * @type {string}
     * @memberof AgencyRepUserAllOf
     */
    'role': AgencyRepUserAllOfRoleEnum;
}

export const AgencyRepUserAllOfRoleEnum = {
    AgencyRep: 'agency_rep'
} as const;

export type AgencyRepUserAllOfRoleEnum = typeof AgencyRepUserAllOfRoleEnum[keyof typeof AgencyRepUserAllOfRoleEnum];

/**
 * 
 * @export
 * @interface AutocompleteResult
 */
export interface AutocompleteResult {
    /**
     * A matching word
     * @type {string}
     * @memberof AutocompleteResult
     */
    'word'?: string;
    /**
     * How well is this matched
     * @type {number}
     * @memberof AutocompleteResult
     */
    'score'?: number;
    /**
     * Number of matching documents
     * @type {number}
     * @memberof AutocompleteResult
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface BaseBlock
 */
export interface BaseBlock {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof BaseBlock
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface BaseBlockUpdate
 */
export interface BaseBlockUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof BaseBlockUpdate
     */
    'id': number | null;
}
/**
 * 
 * @export
 * @interface BillToRelation
 */
export interface BillToRelation {
    /**
     * The Symmons bill to id
     * @type {number}
     * @memberof BillToRelation
     */
    'bill_to_id': number;
    /**
     * 
     * @type {string}
     * @memberof BillToRelation
     */
    'name'?: string | null;
    /**
     * The address of the company
     * @type {string}
     * @memberof BillToRelation
     */
    'address'?: string | null;
    /**
     * The city of the company
     * @type {string}
     * @memberof BillToRelation
     */
    'city'?: string | null;
    /**
     * The state of the company
     * @type {string}
     * @memberof BillToRelation
     */
    'state'?: string | null;
    /**
     * The zipcode of the company
     * @type {string}
     * @memberof BillToRelation
     */
    'zip_code'?: string | null;
    /**
     * The latitude of the address
     * @type {number}
     * @memberof BillToRelation
     */
    'longitude'?: number | null;
    /**
     * The latitude of the address
     * @type {number}
     * @memberof BillToRelation
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {Array<LocationRelation>}
     * @memberof BillToRelation
     */
    'locations'?: Array<LocationRelation>;
}
/**
 * @type Block
 * @export
 */
export type Block = ImageBlock | IntroductionBlock | ProductBlock | SummaryBlock | TextBlock;

/**
 * 
 * @export
 * @enum {string}
 */

export const BlockType = {
    Image: 'image',
    Product: 'product',
    Introduction: 'introduction',
    Text: 'text'
} as const;

export type BlockType = typeof BlockType[keyof typeof BlockType];


/**
 * 
 * @export
 * @interface CalculateTempControlProjectBody
 */
export interface CalculateTempControlProjectBody {
    /**
     * 
     * @type {TempControlCalculationMethod}
     * @memberof CalculateTempControlProjectBody
     */
    'method'?: TempControlCalculationMethod;
}
/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    'id': number;
    /**
     * The status of the task (0 = inactive | 1 = active)
     * @type {boolean}
     * @memberof Company
     */
    'status': boolean;
    /**
     * The id of the attached salesrep
     * @type {number}
     * @memberof Company
     */
    'sales_rep_id': number | null;
    /**
     * The territory id assigned to this company
     * @type {number}
     * @memberof Company
     */
    'territory_id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    'index_pending': boolean;
    /**
     * The name of the customer
     * @type {string}
     * @memberof Company
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    'wholesaler'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    'evolution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    'direct_buyer'?: boolean;
    /**
     * The master_id of the customer
     * @type {string}
     * @memberof Company
     */
    'master_id'?: string;
    /**
     * The master_name of the customer
     * @type {string}
     * @memberof Company
     */
    'master_name'?: string;
    /**
     * The total number of locations for this company
     * @type {number}
     * @memberof Company
     */
    'count_locations'?: number;
    /**
     * The total number of addresses for this company
     * @type {number}
     * @memberof Company
     */
    'count_addresses'?: number;
    /**
     * The array of locations attached to this company
     * @type {Array<LocationRelation>}
     * @memberof Company
     */
    'locations': Array<LocationRelation>;
    /**
     * The array of users attached to this company
     * @type {Array<UserRelation>}
     * @memberof Company
     */
    'users': Array<UserRelation>;
    /**
     * The bill to address array.  Only the bill_to_id is required for submission.  The rest will be autoretrieved
     * @type {Array<BillToRelation>}
     * @memberof Company
     */
    'addresses': Array<BillToRelation>;
    /**
     * 
     * @type {UserRelation}
     * @memberof Company
     */
    'sales_rep': UserRelation | null;
    /**
     * 
     * @type {Array<UserRelation>}
     * @memberof Company
     */
    'sales_reps': Array<UserRelation>;
    /**
     * 
     * @type {TerritoryRelation}
     * @memberof Company
     */
    'territory'?: TerritoryRelation | null;
    /**
     * the date the record was cached
     * @type {string}
     * @memberof Company
     */
    'cached_at': string | null;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Company
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Company
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface CompanyIdAddresses
 */
export interface CompanyIdAddresses {
    /**
     * The bill_to_id of the company
     * @type {number}
     * @memberof CompanyIdAddresses
     */
    'bill_to_id': number;
}
/**
 * 
 * @export
 * @interface CompanyManagerUser
 */
export interface CompanyManagerUser {
    /**
     * 
     * @type {number}
     * @memberof CompanyManagerUser
     */
    'id': number;
    /**
     * Is the user\'s company an wholesaler
     * @type {boolean}
     * @memberof CompanyManagerUser
     */
    'wholesaler'?: boolean;
    /**
     * Is the user\'s company an evolution owner
     * @type {boolean}
     * @memberof CompanyManagerUser
     */
    'evolution'?: boolean;
    /**
     * Can the user buy direct via the quote interface
     * @type {boolean}
     * @memberof CompanyManagerUser
     */
    'direct_buyer'?: boolean;
    /**
     * The company id
     * @type {number}
     * @memberof CompanyManagerUser
     */
    'company_id': number;
    /**
     * The location id
     * @type {number}
     * @memberof CompanyManagerUser
     */
    'location_id': number;
    /**
     * The agency id
     * @type {number}
     * @memberof CompanyManagerUser
     */
    'agency_id': number;
    /**
     * Whether this user has access to all territories
     * @type {boolean}
     * @memberof CompanyManagerUser
     */
    'all_territories'?: boolean;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof CompanyManagerUser
     */
    'first_name': string | null;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof CompanyManagerUser
     */
    'last_name': string | null;
    /**
     * 
     * @type {FileAvatarRelation}
     * @memberof CompanyManagerUser
     */
    'image': FileAvatarRelation | null;
    /**
     * 
     * @type {PendingQuote}
     * @memberof CompanyManagerUser
     */
    'pending_quote'?: PendingQuote | null;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof CompanyManagerUser
     */
    'email': string;
    /**
     * The phone number of the user
     * @type {string}
     * @memberof CompanyManagerUser
     */
    'phone'?: string | null;
    /**
     * 
     * @type {UserSharedPermissions}
     * @memberof CompanyManagerUser
     */
    'permissions': UserSharedPermissions;
    /**
     * The last login date
     * @type {string}
     * @memberof CompanyManagerUser
     */
    'last_login': string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyManagerUser
     */
    'login_count': number;
    /**
     * The last login date
     * @type {string}
     * @memberof CompanyManagerUser
     */
    'last_access': string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyManagerUser
     */
    'access_count': number;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUser
     */
    'email_verified_at': string | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof CompanyManagerUser
     */
    'created_at': string;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof CompanyManagerUser
     */
    'updated_at': string;
    /**
     * Whether the user has enabled 2FA
     * @type {boolean}
     * @memberof CompanyManagerUser
     */
    'google2fa_enabled'?: boolean;
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof CompanyManagerUser
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof CompanyManagerUser
     */
    'company': CompanyRelation;
    /**
     * 
     * @type {LocationRelation}
     * @memberof CompanyManagerUser
     */
    'location'?: LocationRelation | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUser
     */
    'role': CompanyManagerUserRoleEnum;
    /**
     * Is this user managed by a representative?
     * @type {boolean}
     * @memberof CompanyManagerUser
     */
    'rep_managed': boolean;
}

export const CompanyManagerUserRoleEnum = {
    CompanyManager: 'company_manager'
} as const;

export type CompanyManagerUserRoleEnum = typeof CompanyManagerUserRoleEnum[keyof typeof CompanyManagerUserRoleEnum];

/**
 * 
 * @export
 * @interface CompanyManagerUserAllOf
 */
export interface CompanyManagerUserAllOf {
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof CompanyManagerUserAllOf
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof CompanyManagerUserAllOf
     */
    'company': CompanyRelation;
    /**
     * 
     * @type {LocationRelation}
     * @memberof CompanyManagerUserAllOf
     */
    'location'?: LocationRelation | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUserAllOf
     */
    'role': CompanyManagerUserAllOfRoleEnum;
    /**
     * Is this user managed by a representative?
     * @type {boolean}
     * @memberof CompanyManagerUserAllOf
     */
    'rep_managed': boolean;
}

export const CompanyManagerUserAllOfRoleEnum = {
    CompanyManager: 'company_manager'
} as const;

export type CompanyManagerUserAllOfRoleEnum = typeof CompanyManagerUserAllOfRoleEnum[keyof typeof CompanyManagerUserAllOfRoleEnum];

/**
 * 
 * @export
 * @interface CompanyRelation
 */
export interface CompanyRelation {
    /**
     * 
     * @type {number}
     * @memberof CompanyRelation
     */
    'id': number;
    /**
     * The name of the customer
     * @type {string}
     * @memberof CompanyRelation
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyRelation
     */
    'wholesaler'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyRelation
     */
    'evolution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyRelation
     */
    'direct_buyer'?: boolean;
    /**
     * The bill to address array.  Only the bill_to_id is required for submission.  The rest will be autoretrieved
     * @type {Array<BillToRelation>}
     * @memberof CompanyRelation
     */
    'addresses': Array<BillToRelation>;
    /**
     * 
     * @type {UserRelation}
     * @memberof CompanyRelation
     */
    'sales_rep': UserRelation | null;
    /**
     * 
     * @type {Array<UserRelation>}
     * @memberof CompanyRelation
     */
    'sales_reps': Array<UserRelation>;
    /**
     * The status of the task (0 = inactive | 1 = active)
     * @type {boolean}
     * @memberof CompanyRelation
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface CompanyRelationUpdate
 */
export interface CompanyRelationUpdate {
    /**
     * 
     * @type {number}
     * @memberof CompanyRelationUpdate
     */
    'id': number;
    /**
     * The name of the customer
     * @type {string}
     * @memberof CompanyRelationUpdate
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyWithLocations
 */
export interface CompanyWithLocations {
    /**
     * 
     * @type {number}
     * @memberof CompanyWithLocations
     */
    'id': number;
    /**
     * The status of the task (0 = inactive | 1 = active)
     * @type {boolean}
     * @memberof CompanyWithLocations
     */
    'status': boolean;
    /**
     * The id of the attached salesrep
     * @type {number}
     * @memberof CompanyWithLocations
     */
    'sales_rep_id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyWithLocations
     */
    'index_pending': boolean;
    /**
     * The name of the customer
     * @type {string}
     * @memberof CompanyWithLocations
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyWithLocations
     */
    'wholesaler'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyWithLocations
     */
    'evolution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyWithLocations
     */
    'direct_buyer'?: boolean;
    /**
     * The master_id of the customer
     * @type {string}
     * @memberof CompanyWithLocations
     */
    'master_id'?: string;
    /**
     * The master_name of the customer
     * @type {string}
     * @memberof CompanyWithLocations
     */
    'master_name'?: string;
    /**
     * The total number of locations for this company
     * @type {number}
     * @memberof CompanyWithLocations
     */
    'count_locations'?: number;
    /**
     * The total number of addresses for this company
     * @type {number}
     * @memberof CompanyWithLocations
     */
    'count_addresses'?: number;
    /**
     * The array of locations attached to this company
     * @type {Array<LocationRelation>}
     * @memberof CompanyWithLocations
     */
    'locations': Array<LocationRelation>;
    /**
     * The array of users attached to this company
     * @type {Array<UserRelation>}
     * @memberof CompanyWithLocations
     */
    'users'?: Array<UserRelation>;
    /**
     * The bill to address array.  Only the bill_to_id is required for submission.  The rest will be autoretrieved
     * @type {Array<BillToRelation>}
     * @memberof CompanyWithLocations
     */
    'addresses'?: Array<BillToRelation>;
    /**
     * 
     * @type {UserRelation}
     * @memberof CompanyWithLocations
     */
    'sales_rep'?: UserRelation | null;
    /**
     * 
     * @type {Array<UserRelation>}
     * @memberof CompanyWithLocations
     */
    'sales_reps'?: Array<UserRelation>;
    /**
     * the date the record was cached
     * @type {string}
     * @memberof CompanyWithLocations
     */
    'cached_at': string | null;
    /**
     * the date the record was created
     * @type {string}
     * @memberof CompanyWithLocations
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof CompanyWithLocations
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface ConfigurationMeta
 */
export interface ConfigurationMeta {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationMeta
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationMeta
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface CoverPage
 */
export interface CoverPage {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof CoverPage
     */
    'id': number;
    /**
     * The name of the page
     * @type {string}
     * @memberof CoverPage
     */
    'name': string;
    /**
     * 
     * @type {CoverPageType}
     * @memberof CoverPage
     */
    'type': CoverPageType;
    /**
     * 
     * @type {Array<ImageBlock>}
     * @memberof CoverPage
     */
    'blocks': Array<ImageBlock>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof CoverPage
     */
    'layout': PageLayouts | null;
}
/**
 * 
 * @export
 * @interface CoverPageAllOf
 */
export interface CoverPageAllOf {
    /**
     * 
     * @type {CoverPageType}
     * @memberof CoverPageAllOf
     */
    'type': CoverPageType;
    /**
     * 
     * @type {Array<ImageBlock>}
     * @memberof CoverPageAllOf
     */
    'blocks': Array<ImageBlock>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof CoverPageAllOf
     */
    'layout': PageLayouts | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CoverPageType = {
    Cover: 'cover'
} as const;

export type CoverPageType = typeof CoverPageType[keyof typeof CoverPageType];


/**
 * 
 * @export
 * @interface CoverPageUpdate
 */
export interface CoverPageUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof CoverPageUpdate
     */
    'id': number | null;
    /**
     * The name of the page
     * @type {string}
     * @memberof CoverPageUpdate
     */
    'name': string;
    /**
     * 
     * @type {CoverPageType}
     * @memberof CoverPageUpdate
     */
    'type': CoverPageType;
    /**
     * 
     * @type {Array<ImageBlockUpdate>}
     * @memberof CoverPageUpdate
     */
    'blocks': Array<ImageBlockUpdate>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof CoverPageUpdate
     */
    'layout': PageLayouts | null;
}
/**
 * 
 * @export
 * @interface CoverPageUpdateAllOf
 */
export interface CoverPageUpdateAllOf {
    /**
     * 
     * @type {CoverPageType}
     * @memberof CoverPageUpdateAllOf
     */
    'type': CoverPageType;
    /**
     * 
     * @type {Array<ImageBlockUpdate>}
     * @memberof CoverPageUpdateAllOf
     */
    'blocks': Array<ImageBlockUpdate>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof CoverPageUpdateAllOf
     */
    'layout': PageLayouts | null;
}
/**
 * 
 * @export
 * @interface CreateAgencyBody
 */
export interface CreateAgencyBody {
    /**
     * 
     * @type {string}
     * @memberof CreateAgencyBody
     */
    'name': string;
    /**
     * The ID of the assigned territory
     * @type {number}
     * @memberof CreateAgencyBody
     */
    'territory_id'?: number | null;
    /**
     * 
     * @type {CompanyRelationUpdate}
     * @memberof CreateAgencyBody
     */
    'company'?: CompanyRelationUpdate | null;
    /**
     * A list of agency goals to attach
     * @type {Array<AgencyGoalRelationUpdate>}
     * @memberof CreateAgencyBody
     */
    'goals'?: Array<AgencyGoalRelationUpdate>;
}
/**
 * 
 * @export
 * @interface CreateCategoryBody
 */
export interface CreateCategoryBody {
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryBody
     */
    'term': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryBody
     */
    'icon'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCategoryBody
     */
    'featured'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCategoryBody
     */
    'dashboard'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateCompanyBody
 */
export interface CreateCompanyBody {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyBody
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyBody
     */
    'wholesaler'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyBody
     */
    'evolution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyBody
     */
    'direct_buyer'?: boolean;
    /**
     * 
     * @type {Array<CreateCompanyBodyAddress>}
     * @memberof CreateCompanyBody
     */
    'addresses': Array<CreateCompanyBodyAddress>;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyBody
     */
    'sales_rep_id': number | null;
    /**
     * The territory id assigned to this company
     * @type {number}
     * @memberof CreateCompanyBody
     */
    'territory_id'?: number | null;
    /**
     * 
     * @type {Array<ScormSalesReps>}
     * @memberof CreateCompanyBody
     */
    'sales_reps': Array<ScormSalesReps>;
}
/**
 * 
 * @export
 * @interface CreateCompanyBodyAddress
 */
export interface CreateCompanyBodyAddress {
    /**
     * The bill_to_id of the company
     * @type {number}
     * @memberof CreateCompanyBodyAddress
     */
    'bill_to_id': number;
}
/**
 * 
 * @export
 * @interface CreateIntroductionBody
 */
export interface CreateIntroductionBody {
    /**
     * 
     * @type {string}
     * @memberof CreateIntroductionBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateIntroductionBody
     */
    'content'?: string;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof CreateIntroductionBody
     */
    'image'?: FileRelationUpdate | null;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof CreateIntroductionBody
     */
    'image_settings'?: CropImageSettings | null;
}
/**
 * 
 * @export
 * @interface CreateQuoteBody
 */
export interface CreateQuoteBody {
    /**
     * The message with the quote
     * @type {string}
     * @memberof CreateQuoteBody
     */
    'message': string;
    /**
     * 
     * @type {QuoteStatus}
     * @memberof CreateQuoteBody
     */
    'status': QuoteStatus;
    /**
     * The user supplied project name for the quote
     * @type {string}
     * @memberof CreateQuoteBody
     */
    'project_name': string;
    /**
     * The user supplied location name for the quote
     * @type {string}
     * @memberof CreateQuoteBody
     */
    'location_name'?: string;
    /**
     * The user supplied address for the quote
     * @type {string}
     * @memberof CreateQuoteBody
     */
    'address'?: string;
    /**
     * The user supplied address2 for the quote
     * @type {string}
     * @memberof CreateQuoteBody
     */
    'address2'?: string;
    /**
     * The user supplied city for the quote
     * @type {string}
     * @memberof CreateQuoteBody
     */
    'city': string;
    /**
     * The user supplied state for the quote
     * @type {string}
     * @memberof CreateQuoteBody
     */
    'state': string;
    /**
     * The user supplied postal_code for the quote
     * @type {string}
     * @memberof CreateQuoteBody
     */
    'postal_code'?: string;
    /**
     * The user supplied country for the quote
     * @type {string}
     * @memberof CreateQuoteBody
     */
    'country'?: string;
    /**
     * The user supplied phone for the quote
     * @type {string}
     * @memberof CreateQuoteBody
     */
    'phone'?: string;
    /**
     * A list of files to attach to the quote
     * @type {Array<ResourceFiles>}
     * @memberof CreateQuoteBody
     */
    'files'?: Array<ResourceFiles>;
    /**
     * A list of products to attach to the quote
     * @type {Array<UpdateQuoteProductRelation>}
     * @memberof CreateQuoteBody
     */
    'products'?: Array<UpdateQuoteProductRelation>;
}
/**
 * 
 * @export
 * @interface CreateQuoteResponseBody
 */
export interface CreateQuoteResponseBody {
    /**
     * The message with the quote
     * @type {string}
     * @memberof CreateQuoteResponseBody
     */
    'message': string;
    /**
     * A list of files to attach to the quote
     * @type {Array<ResourceFiles>}
     * @memberof CreateQuoteResponseBody
     */
    'files'?: Array<ResourceFiles>;
}
/**
 * 
 * @export
 * @interface CreateResourceBody
 */
export interface CreateResourceBody {
    /**
     * 
     * @type {string}
     * @memberof CreateResourceBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateResourceBody
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateResourceBody
     */
    'featured'?: boolean;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof CreateResourceBody
     */
    'image'?: FileRelationUpdate | null;
    /**
     * A list of topics to attach
     * @type {Array<ResourceTopics>}
     * @memberof CreateResourceBody
     */
    'topics'?: Array<ResourceTopics>;
    /**
     * A list of files to attach to the resource
     * @type {Array<ResourceFiles>}
     * @memberof CreateResourceBody
     */
    'files'?: Array<ResourceFiles>;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof CreateResourceBody
     */
    'image_settings'?: CropImageSettings | null;
}
/**
 * 
 * @export
 * @interface CreateScormBody
 */
export interface CreateScormBody {
    /**
     * 
     * @type {string}
     * @memberof CreateScormBody
     */
    'name': string;
    /**
     * 
     * @type {Array<ScormSalesReps>}
     * @memberof CreateScormBody
     */
    'sales_reps'?: Array<ScormSalesReps>;
}
/**
 * 
 * @export
 * @interface CreateShowerConfigurationBody
 */
export interface CreateShowerConfigurationBody {
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowerConfigurationBody
     */
    'ada_compliant'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateShowerConfigurationBody
     */
    'finish'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowerConfigurationBody
     */
    'flow'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowerConfigurationBody
     */
    'tier'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowerConfigurationBody
     */
    'style'?: string;
    /**
     * 
     * @type {Array<CreateShowerConfigurationBodyProducts>}
     * @memberof CreateShowerConfigurationBody
     */
    'products'?: Array<CreateShowerConfigurationBodyProducts>;
    /**
     * 
     * @type {Array<ConfigurationMeta>}
     * @memberof CreateShowerConfigurationBody
     */
    'meta'?: Array<ConfigurationMeta>;
}
/**
 * 
 * @export
 * @interface CreateShowerConfigurationBodyProducts
 */
export interface CreateShowerConfigurationBodyProducts {
    /**
     * 
     * @type {string}
     * @memberof CreateShowerConfigurationBodyProducts
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowerConfigurationBodyProducts
     */
    'sku': string;
}
/**
 * 
 * @export
 * @interface CreateTempControlProjectBody
 */
export interface CreateTempControlProjectBody {
    /**
     * 
     * @type {string}
     * @memberof CreateTempControlProjectBody
     */
    'project_name': string;
}
/**
 * 
 * @export
 * @interface CreateUserBody
 */
export interface CreateUserBody {
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof CreateUserBody
     */
    'first_name': string;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof CreateUserBody
     */
    'last_name': string;
    /**
     * 
     * @type {UserUpdateCompany}
     * @memberof CreateUserBody
     */
    'company'?: UserUpdateCompany;
    /**
     * 
     * @type {UserUpdateLocation}
     * @memberof CreateUserBody
     */
    'location'?: UserUpdateLocation;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof CreateUserBody
     */
    'email': string;
    /**
     * 
     * @type {UserRole}
     * @memberof CreateUserBody
     */
    'role'?: UserRole;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof CreateUserBody
     */
    'image'?: FileRelationUpdate | null;
    /**
     * 
     * @type {UserSharedPermissions}
     * @memberof CreateUserBody
     */
    'permissions'?: UserSharedPermissions;
    /**
     * A list of territories to attach
     * @type {Array<UserUpdateTerritories>}
     * @memberof CreateUserBody
     */
    'territories'?: Array<UserUpdateTerritories>;
    /**
     * 
     * @type {CreateUserBodyRepresents}
     * @memberof CreateUserBody
     */
    'represents'?: CreateUserBodyRepresents;
}
/**
 * 
 * @export
 * @interface CreateUserBodyRepresents
 */
export interface CreateUserBodyRepresents {
    /**
     * 
     * @type {Array<ScormSalesReps>}
     * @memberof CreateUserBodyRepresents
     */
    'companies': Array<ScormSalesReps>;
    /**
     * 
     * @type {Array<ScormSalesReps>}
     * @memberof CreateUserBodyRepresents
     */
    'locations': Array<ScormSalesReps>;
}
/**
 * 
 * @export
 * @interface CropImageSettings
 */
export interface CropImageSettings {
    /**
     * The top offset in px.
     * @type {number}
     * @memberof CropImageSettings
     */
    'top': number;
    /**
     * The left offset in px.
     * @type {number}
     * @memberof CropImageSettings
     */
    'left': number;
    /**
     * 
     * @type {number}
     * @memberof CropImageSettings
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof CropImageSettings
     */
    'height': number;
    /**
     * The number of degrees to rotate, where 0 is no rotation, 90 is 90 degrees clockwise and -90 is 90deg counter clockwise.
     * @type {number}
     * @memberof CropImageSettings
     */
    'rotate': number;
    /**
     * Set to 1 to flip the image. Default value is 0.
     * @type {number}
     * @memberof CropImageSettings
     */
    'flip': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CurrencyCode = {
    Us: 'US',
    Ca: 'CA'
} as const;

export type CurrencyCode = typeof CurrencyCode[keyof typeof CurrencyCode];


/**
 * 
 * @export
 * @interface DividerPage
 */
export interface DividerPage {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof DividerPage
     */
    'id': number;
    /**
     * The name of the page
     * @type {string}
     * @memberof DividerPage
     */
    'name': string;
    /**
     * 
     * @type {DividerPageType}
     * @memberof DividerPage
     */
    'type': DividerPageType;
    /**
     * 
     * @type {Array<ImageBlock | TextBlock>}
     * @memberof DividerPage
     */
    'blocks': Array<ImageBlock | TextBlock>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof DividerPage
     */
    'layout': PageLayouts | null;
}
/**
 * 
 * @export
 * @interface DividerPageAllOf
 */
export interface DividerPageAllOf {
    /**
     * 
     * @type {DividerPageType}
     * @memberof DividerPageAllOf
     */
    'type': DividerPageType;
    /**
     * 
     * @type {Array<ImageBlock | TextBlock>}
     * @memberof DividerPageAllOf
     */
    'blocks': Array<ImageBlock | TextBlock>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof DividerPageAllOf
     */
    'layout': PageLayouts | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DividerPageType = {
    Divider: 'divider'
} as const;

export type DividerPageType = typeof DividerPageType[keyof typeof DividerPageType];


/**
 * 
 * @export
 * @interface DividerPageUpdate
 */
export interface DividerPageUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof DividerPageUpdate
     */
    'id': number | null;
    /**
     * The name of the page
     * @type {string}
     * @memberof DividerPageUpdate
     */
    'name': string;
    /**
     * 
     * @type {DividerPageType}
     * @memberof DividerPageUpdate
     */
    'type': DividerPageType;
    /**
     * 
     * @type {Array<ImageBlockUpdate | TextBlockUpdate>}
     * @memberof DividerPageUpdate
     */
    'blocks': Array<ImageBlockUpdate | TextBlockUpdate>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof DividerPageUpdate
     */
    'layout': PageLayouts | null;
}
/**
 * 
 * @export
 * @interface DividerPageUpdateAllOf
 */
export interface DividerPageUpdateAllOf {
    /**
     * 
     * @type {DividerPageType}
     * @memberof DividerPageUpdateAllOf
     */
    'type': DividerPageType;
    /**
     * 
     * @type {Array<ImageBlockUpdate | TextBlockUpdate>}
     * @memberof DividerPageUpdateAllOf
     */
    'blocks': Array<ImageBlockUpdate | TextBlockUpdate>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof DividerPageUpdateAllOf
     */
    'layout': PageLayouts | null;
}
/**
 * 
 * @export
 * @interface DownloadTempControlProjectBody
 */
export interface DownloadTempControlProjectBody {
    /**
     * 
     * @type {string}
     * @memberof DownloadTempControlProjectBody
     */
    'customer_name': string;
    /**
     * 
     * @type {string}
     * @memberof DownloadTempControlProjectBody
     */
    'customer_email': string;
    /**
     * 
     * @type {string}
     * @memberof DownloadTempControlProjectBody
     */
    'customer_company'?: string | null;
}
/**
 * 
 * @export
 * @interface EmptyPage
 */
export interface EmptyPage {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof EmptyPage
     */
    'id': number;
    /**
     * The name of the page
     * @type {string}
     * @memberof EmptyPage
     */
    'name': string;
    /**
     * 
     * @type {EmptyPageType}
     * @memberof EmptyPage
     */
    'type': EmptyPageType;
}
/**
 * 
 * @export
 * @interface EmptyPageAllOf
 */
export interface EmptyPageAllOf {
    /**
     * 
     * @type {EmptyPageType}
     * @memberof EmptyPageAllOf
     */
    'type': EmptyPageType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EmptyPageType = {
    Empty: ''
} as const;

export type EmptyPageType = typeof EmptyPageType[keyof typeof EmptyPageType];


/**
 * 
 * @export
 * @interface EmptyPageUpdate
 */
export interface EmptyPageUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof EmptyPageUpdate
     */
    'id': number | null;
    /**
     * The name of the page
     * @type {string}
     * @memberof EmptyPageUpdate
     */
    'name': string;
    /**
     * 
     * @type {EmptyPageType}
     * @memberof EmptyPageUpdate
     */
    'type': EmptyPageType;
}
/**
 * 
 * @export
 * @interface ErrorModel
 */
export interface ErrorModel {
    /**
     * Human readable error message
     * @type {string}
     * @memberof ErrorModel
     */
    'message': string;
    /**
     * An array of errors, keyed by an identifier.  If this is a validation failure, the identifier is the property name
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ErrorModel
     */
    'errors': { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface FetchCompanyDetails
 */
export interface FetchCompanyDetails {
    /**
     * 
     * @type {LocationLookup}
     * @memberof FetchCompanyDetails
     */
    'company': LocationLookup;
    /**
     * 
     * @type {Array<LocationLookup>}
     * @memberof FetchCompanyDetails
     */
    'locations': Array<LocationLookup>;
}
/**
 * 
 * @export
 * @interface FileAvatarRelation
 */
export interface FileAvatarRelation {
    /**
     * 
     * @type {number}
     * @memberof FileAvatarRelation
     */
    'id': number;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileAvatarRelation
     */
    'name': string;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileAvatarRelation
     */
    'mime': string;
    /**
     * The lookup safe name
     * @type {string}
     * @memberof FileAvatarRelation
     */
    'uri': string;
    /**
     * The alt text for the file
     * @type {string}
     * @memberof FileAvatarRelation
     */
    'alt': string | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileAvatarRelation
     */
    'title': string;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileAvatarRelation
     */
    'thumbnail': string;
    /**
     * Is the file public visible, or secure
     * @type {boolean}
     * @memberof FileAvatarRelation
     */
    'secure': boolean;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileAvatarRelation
     */
    'private_url': string;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileAvatarRelation
     */
    'image': string;
    /**
     * 
     * @type {UserRelation}
     * @memberof FileAvatarRelation
     */
    'user'?: UserRelation | null;
    /**
     * The file size
     * @type {number}
     * @memberof FileAvatarRelation
     */
    'size': number;
    /**
     * 
     * @type {FileModelAvatarTypeEnum}
     * @memberof FileAvatarRelation
     */
    'type': FileModelAvatarTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileAvatarRelation
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof FileAvatarRelation
     */
    'height': number;
}
/**
 * 
 * @export
 * @interface FileFileRelation
 */
export interface FileFileRelation {
    /**
     * 
     * @type {number}
     * @memberof FileFileRelation
     */
    'id': number;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileFileRelation
     */
    'name': string;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileFileRelation
     */
    'mime': string;
    /**
     * The lookup safe name
     * @type {string}
     * @memberof FileFileRelation
     */
    'uri': string;
    /**
     * The alt text for the file
     * @type {string}
     * @memberof FileFileRelation
     */
    'alt': string | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileFileRelation
     */
    'title': string;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileFileRelation
     */
    'thumbnail': string;
    /**
     * Is the file public visible, or secure
     * @type {boolean}
     * @memberof FileFileRelation
     */
    'secure': boolean;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileFileRelation
     */
    'private_url': string;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileFileRelation
     */
    'image': string;
    /**
     * 
     * @type {UserRelation}
     * @memberof FileFileRelation
     */
    'user'?: UserRelation | null;
    /**
     * The file size
     * @type {number}
     * @memberof FileFileRelation
     */
    'size': number;
    /**
     * 
     * @type {FileModelFileTypeEnum}
     * @memberof FileFileRelation
     */
    'type': FileModelFileTypeEnum;
}
/**
 * 
 * @export
 * @interface FileImageRelation
 */
export interface FileImageRelation {
    /**
     * 
     * @type {number}
     * @memberof FileImageRelation
     */
    'id': number;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileImageRelation
     */
    'name': string;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileImageRelation
     */
    'mime': string;
    /**
     * The lookup safe name
     * @type {string}
     * @memberof FileImageRelation
     */
    'uri': string;
    /**
     * The alt text for the file
     * @type {string}
     * @memberof FileImageRelation
     */
    'alt': string | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileImageRelation
     */
    'title': string;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileImageRelation
     */
    'thumbnail': string;
    /**
     * Is the file public visible, or secure
     * @type {boolean}
     * @memberof FileImageRelation
     */
    'secure': boolean;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileImageRelation
     */
    'private_url': string;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileImageRelation
     */
    'image': string;
    /**
     * 
     * @type {UserRelation}
     * @memberof FileImageRelation
     */
    'user'?: UserRelation | null;
    /**
     * The file size
     * @type {number}
     * @memberof FileImageRelation
     */
    'size': number;
    /**
     * 
     * @type {FileModelImageTypeEnum}
     * @memberof FileImageRelation
     */
    'type': FileModelImageTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileImageRelation
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof FileImageRelation
     */
    'height': number;
}
/**
 * @type FileModel
 * @export
 */
export type FileModel = FileModelAvatar | FileModelFile | FileModelImage;

/**
 * 
 * @export
 * @interface FileModelAvatar
 */
export interface FileModelAvatar {
    /**
     * 
     * @type {number}
     * @memberof FileModelAvatar
     */
    'id': number;
    /**
     * The user that created the file
     * @type {number}
     * @memberof FileModelAvatar
     */
    'user_id': number;
    /**
     * The asset (user, quote, etc) id of the owning model
     * @type {number}
     * @memberof FileModelAvatar
     */
    'asset_id': number;
    /**
     * The asset type (user, quote, etc) of the owning model
     * @type {string}
     * @memberof FileModelAvatar
     */
    'asset_type': string | null;
    /**
     * Is the file public visible, or secure
     * @type {boolean}
     * @memberof FileModelAvatar
     */
    'secure': boolean;
    /**
     * 
     * @type {string}
     * @memberof FileModelAvatar
     */
    'status': string;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileModelAvatar
     */
    'name': string;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileModelAvatar
     */
    'mime': string;
    /**
     * The lookup safe name
     * @type {string}
     * @memberof FileModelAvatar
     */
    'uri': string;
    /**
     * The lookup safe name
     * @type {number}
     * @memberof FileModelAvatar
     */
    'size': number;
    /**
     * The alt text for the file
     * @type {string}
     * @memberof FileModelAvatar
     */
    'alt': string | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileModelAvatar
     */
    'title': string;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileModelAvatar
     */
    'thumbnail': string;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileModelAvatar
     */
    'image': string;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileModelAvatar
     */
    'private_url': string;
    /**
     * This allows privileged users to set the visibility level to allow other users to see a files. This will default to hidden, which means no one will see it, even the current user.  Setting to private will add the file to my file library.  Setting to location and company will allow anyone in my location or company respectively.  Setting to public is only available to admins and will add it to the global library 
     * @type {FileVisibility}
     * @memberof FileModelAvatar
     */
    'visibility'?: FileVisibility | null;
    /**
     * 
     * @type {UserRelation}
     * @memberof FileModelAvatar
     */
    'user'?: UserRelation;
    /**
     * The date the record was created
     * @type {string}
     * @memberof FileModelAvatar
     */
    'created_at': string | null;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof FileModelAvatar
     */
    'updated_at': string | null;
    /**
     * 
     * @type {FileModelAvatarTypeEnum}
     * @memberof FileModelAvatar
     */
    'type': FileModelAvatarTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileModelAvatar
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof FileModelAvatar
     */
    'height': number;
}
/**
 * 
 * @export
 * @interface FileModelAvatarAllOf
 */
export interface FileModelAvatarAllOf {
    /**
     * 
     * @type {FileModelAvatarTypeEnum}
     * @memberof FileModelAvatarAllOf
     */
    'type': FileModelAvatarTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileModelAvatarAllOf
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof FileModelAvatarAllOf
     */
    'height': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FileModelAvatarTypeEnum = {
    Avatar: 'avatar'
} as const;

export type FileModelAvatarTypeEnum = typeof FileModelAvatarTypeEnum[keyof typeof FileModelAvatarTypeEnum];


/**
 * 
 * @export
 * @interface FileModelAvatarUpdate
 */
export interface FileModelAvatarUpdate {
    /**
     * 
     * @type {number}
     * @memberof FileModelAvatarUpdate
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof FileModelAvatarUpdate
     */
    'status'?: string | null;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileModelAvatarUpdate
     */
    'name'?: string | null;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileModelAvatarUpdate
     */
    'mime'?: string | null;
    /**
     * The file size
     * @type {number}
     * @memberof FileModelAvatarUpdate
     */
    'size'?: number | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileModelAvatarUpdate
     */
    'title'?: string | null;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileModelAvatarUpdate
     */
    'thumbnail'?: string | null;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileModelAvatarUpdate
     */
    'image'?: string | null;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileModelAvatarUpdate
     */
    'private_url'?: string | null;
    /**
     * 
     * @type {UserRelationUpdate}
     * @memberof FileModelAvatarUpdate
     */
    'user'?: UserRelationUpdate | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof FileModelAvatarUpdate
     */
    'created_at'?: string | null;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof FileModelAvatarUpdate
     */
    'updated_at'?: string | null;
    /**
     * 
     * @type {FileModelAvatarTypeEnum}
     * @memberof FileModelAvatarUpdate
     */
    'type': FileModelAvatarTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileModelAvatarUpdate
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileModelAvatarUpdate
     */
    'height'?: number | null;
}
/**
 * 
 * @export
 * @interface FileModelAvatarUpdateAllOf
 */
export interface FileModelAvatarUpdateAllOf {
    /**
     * 
     * @type {FileModelAvatarTypeEnum}
     * @memberof FileModelAvatarUpdateAllOf
     */
    'type': FileModelAvatarTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileModelAvatarUpdateAllOf
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileModelAvatarUpdateAllOf
     */
    'height'?: number | null;
}
/**
 * 
 * @export
 * @interface FileModelFile
 */
export interface FileModelFile {
    /**
     * 
     * @type {number}
     * @memberof FileModelFile
     */
    'id': number;
    /**
     * The user that created the file
     * @type {number}
     * @memberof FileModelFile
     */
    'user_id': number;
    /**
     * The asset (user, quote, etc) id of the owning model
     * @type {number}
     * @memberof FileModelFile
     */
    'asset_id': number;
    /**
     * The asset type (user, quote, etc) of the owning model
     * @type {string}
     * @memberof FileModelFile
     */
    'asset_type': string | null;
    /**
     * Is the file public visible, or secure
     * @type {boolean}
     * @memberof FileModelFile
     */
    'secure': boolean;
    /**
     * 
     * @type {string}
     * @memberof FileModelFile
     */
    'status': string;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileModelFile
     */
    'name': string;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileModelFile
     */
    'mime': string;
    /**
     * The lookup safe name
     * @type {string}
     * @memberof FileModelFile
     */
    'uri': string;
    /**
     * The lookup safe name
     * @type {number}
     * @memberof FileModelFile
     */
    'size': number;
    /**
     * The alt text for the file
     * @type {string}
     * @memberof FileModelFile
     */
    'alt': string | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileModelFile
     */
    'title': string;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileModelFile
     */
    'thumbnail': string;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileModelFile
     */
    'image': string;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileModelFile
     */
    'private_url': string;
    /**
     * This allows privileged users to set the visibility level to allow other users to see a files. This will default to hidden, which means no one will see it, even the current user.  Setting to private will add the file to my file library.  Setting to location and company will allow anyone in my location or company respectively.  Setting to public is only available to admins and will add it to the global library 
     * @type {FileVisibility}
     * @memberof FileModelFile
     */
    'visibility'?: FileVisibility | null;
    /**
     * 
     * @type {UserRelation}
     * @memberof FileModelFile
     */
    'user'?: UserRelation;
    /**
     * The date the record was created
     * @type {string}
     * @memberof FileModelFile
     */
    'created_at': string | null;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof FileModelFile
     */
    'updated_at': string | null;
    /**
     * 
     * @type {FileModelFileTypeEnum}
     * @memberof FileModelFile
     */
    'type': FileModelFileTypeEnum;
}
/**
 * 
 * @export
 * @interface FileModelFileAllOf
 */
export interface FileModelFileAllOf {
    /**
     * 
     * @type {FileModelFileTypeEnum}
     * @memberof FileModelFileAllOf
     */
    'type': FileModelFileTypeEnum;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FileModelFileTypeEnum = {
    File: 'file'
} as const;

export type FileModelFileTypeEnum = typeof FileModelFileTypeEnum[keyof typeof FileModelFileTypeEnum];


/**
 * 
 * @export
 * @interface FileModelFileUpdate
 */
export interface FileModelFileUpdate {
    /**
     * 
     * @type {number}
     * @memberof FileModelFileUpdate
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof FileModelFileUpdate
     */
    'status'?: string | null;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileModelFileUpdate
     */
    'name'?: string | null;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileModelFileUpdate
     */
    'mime'?: string | null;
    /**
     * The file size
     * @type {number}
     * @memberof FileModelFileUpdate
     */
    'size'?: number | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileModelFileUpdate
     */
    'title'?: string | null;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileModelFileUpdate
     */
    'thumbnail'?: string | null;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileModelFileUpdate
     */
    'image'?: string | null;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileModelFileUpdate
     */
    'private_url'?: string | null;
    /**
     * 
     * @type {UserRelationUpdate}
     * @memberof FileModelFileUpdate
     */
    'user'?: UserRelationUpdate | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof FileModelFileUpdate
     */
    'created_at'?: string | null;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof FileModelFileUpdate
     */
    'updated_at'?: string | null;
    /**
     * 
     * @type {FileModelFileTypeEnum}
     * @memberof FileModelFileUpdate
     */
    'type': FileModelFileTypeEnum;
}
/**
 * 
 * @export
 * @interface FileModelImage
 */
export interface FileModelImage {
    /**
     * 
     * @type {number}
     * @memberof FileModelImage
     */
    'id': number;
    /**
     * The user that created the file
     * @type {number}
     * @memberof FileModelImage
     */
    'user_id': number;
    /**
     * The asset (user, quote, etc) id of the owning model
     * @type {number}
     * @memberof FileModelImage
     */
    'asset_id': number;
    /**
     * The asset type (user, quote, etc) of the owning model
     * @type {string}
     * @memberof FileModelImage
     */
    'asset_type': string | null;
    /**
     * Is the file public visible, or secure
     * @type {boolean}
     * @memberof FileModelImage
     */
    'secure': boolean;
    /**
     * 
     * @type {string}
     * @memberof FileModelImage
     */
    'status': string;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileModelImage
     */
    'name': string;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileModelImage
     */
    'mime': string;
    /**
     * The lookup safe name
     * @type {string}
     * @memberof FileModelImage
     */
    'uri': string;
    /**
     * The lookup safe name
     * @type {number}
     * @memberof FileModelImage
     */
    'size': number;
    /**
     * The alt text for the file
     * @type {string}
     * @memberof FileModelImage
     */
    'alt': string | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileModelImage
     */
    'title': string;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileModelImage
     */
    'thumbnail': string;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileModelImage
     */
    'image': string;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileModelImage
     */
    'private_url': string;
    /**
     * This allows privileged users to set the visibility level to allow other users to see a files. This will default to hidden, which means no one will see it, even the current user.  Setting to private will add the file to my file library.  Setting to location and company will allow anyone in my location or company respectively.  Setting to public is only available to admins and will add it to the global library 
     * @type {FileVisibility}
     * @memberof FileModelImage
     */
    'visibility'?: FileVisibility | null;
    /**
     * 
     * @type {UserRelation}
     * @memberof FileModelImage
     */
    'user'?: UserRelation;
    /**
     * The date the record was created
     * @type {string}
     * @memberof FileModelImage
     */
    'created_at': string | null;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof FileModelImage
     */
    'updated_at': string | null;
    /**
     * 
     * @type {FileModelImageTypeEnum}
     * @memberof FileModelImage
     */
    'type': FileModelImageTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileModelImage
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof FileModelImage
     */
    'height': number;
}
/**
 * 
 * @export
 * @interface FileModelImageAllOf
 */
export interface FileModelImageAllOf {
    /**
     * 
     * @type {FileModelImageTypeEnum}
     * @memberof FileModelImageAllOf
     */
    'type': FileModelImageTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileModelImageAllOf
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof FileModelImageAllOf
     */
    'height': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FileModelImageTypeEnum = {
    Image: 'image'
} as const;

export type FileModelImageTypeEnum = typeof FileModelImageTypeEnum[keyof typeof FileModelImageTypeEnum];


/**
 * 
 * @export
 * @interface FileModelImageUpdate
 */
export interface FileModelImageUpdate {
    /**
     * 
     * @type {number}
     * @memberof FileModelImageUpdate
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof FileModelImageUpdate
     */
    'status'?: string | null;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileModelImageUpdate
     */
    'name'?: string | null;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileModelImageUpdate
     */
    'mime'?: string | null;
    /**
     * The file size
     * @type {number}
     * @memberof FileModelImageUpdate
     */
    'size'?: number | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileModelImageUpdate
     */
    'title'?: string | null;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileModelImageUpdate
     */
    'thumbnail'?: string | null;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileModelImageUpdate
     */
    'image'?: string | null;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileModelImageUpdate
     */
    'private_url'?: string | null;
    /**
     * 
     * @type {UserRelationUpdate}
     * @memberof FileModelImageUpdate
     */
    'user'?: UserRelationUpdate | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof FileModelImageUpdate
     */
    'created_at'?: string | null;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof FileModelImageUpdate
     */
    'updated_at'?: string | null;
    /**
     * 
     * @type {FileModelImageTypeEnum}
     * @memberof FileModelImageUpdate
     */
    'type': FileModelImageTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileModelImageUpdate
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileModelImageUpdate
     */
    'height'?: number | null;
}
/**
 * 
 * @export
 * @interface FileModelImageUpdateAllOf
 */
export interface FileModelImageUpdateAllOf {
    /**
     * 
     * @type {FileModelImageTypeEnum}
     * @memberof FileModelImageUpdateAllOf
     */
    'type': FileModelImageTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileModelImageUpdateAllOf
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileModelImageUpdateAllOf
     */
    'height'?: number | null;
}
/**
 * 
 * @export
 * @interface FileModelMetadataRequestBody
 */
export interface FileModelMetadataRequestBody {
    /**
     * 
     * @type {number}
     * @memberof FileModelMetadataRequestBody
     */
    'id'?: number;
    /**
     * 
     * @type {FileModelImageTypeEnum}
     * @memberof FileModelMetadataRequestBody
     */
    'type'?: FileModelImageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FileModelMetadataRequestBody
     */
    'status'?: string;
    /**
     * The alt text for the file
     * @type {string}
     * @memberof FileModelMetadataRequestBody
     */
    'alt'?: string;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileModelMetadataRequestBody
     */
    'title'?: string;
    /**
     * This allows privileged users to set the visibility level to allow other users to see a files. This will default to hidden, which means no one will see it, even the current user.  Setting to private will add the file to my file library.  Setting to location and company will allow anyone in my location or company respectively.  Setting to public is only available to admins and will add it to the global library 
     * @type {FileVisibility}
     * @memberof FileModelMetadataRequestBody
     */
    'visibility'?: FileVisibility | null;
}
/**
 * 
 * @export
 * @interface FileModelShared
 */
export interface FileModelShared {
    /**
     * 
     * @type {number}
     * @memberof FileModelShared
     */
    'id': number;
    /**
     * The user that created the file
     * @type {number}
     * @memberof FileModelShared
     */
    'user_id': number;
    /**
     * The asset (user, quote, etc) id of the owning model
     * @type {number}
     * @memberof FileModelShared
     */
    'asset_id': number;
    /**
     * The asset type (user, quote, etc) of the owning model
     * @type {string}
     * @memberof FileModelShared
     */
    'asset_type': string | null;
    /**
     * Is the file public visible, or secure
     * @type {boolean}
     * @memberof FileModelShared
     */
    'secure': boolean;
    /**
     * 
     * @type {string}
     * @memberof FileModelShared
     */
    'status': string;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileModelShared
     */
    'name': string;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileModelShared
     */
    'mime': string;
    /**
     * The lookup safe name
     * @type {string}
     * @memberof FileModelShared
     */
    'uri': string;
    /**
     * The lookup safe name
     * @type {number}
     * @memberof FileModelShared
     */
    'size': number;
    /**
     * The alt text for the file
     * @type {string}
     * @memberof FileModelShared
     */
    'alt': string | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileModelShared
     */
    'title': string;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileModelShared
     */
    'thumbnail': string;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileModelShared
     */
    'image': string;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileModelShared
     */
    'private_url': string;
    /**
     * This allows privileged users to set the visibility level to allow other users to see a files. This will default to hidden, which means no one will see it, even the current user.  Setting to private will add the file to my file library.  Setting to location and company will allow anyone in my location or company respectively.  Setting to public is only available to admins and will add it to the global library 
     * @type {FileVisibility}
     * @memberof FileModelShared
     */
    'visibility'?: FileVisibility | null;
    /**
     * 
     * @type {UserRelation}
     * @memberof FileModelShared
     */
    'user'?: UserRelation;
    /**
     * The date the record was created
     * @type {string}
     * @memberof FileModelShared
     */
    'created_at': string | null;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof FileModelShared
     */
    'updated_at': string | null;
}
/**
 * @type FileModelUpdate
 * @export
 */
export type FileModelUpdate = FileModelAvatarUpdate | FileModelFileUpdate | FileModelImageUpdate;

/**
 * 
 * @export
 * @interface FileModelUpdateShared
 */
export interface FileModelUpdateShared {
    /**
     * 
     * @type {number}
     * @memberof FileModelUpdateShared
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof FileModelUpdateShared
     */
    'status'?: string | null;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileModelUpdateShared
     */
    'name'?: string | null;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileModelUpdateShared
     */
    'mime'?: string | null;
    /**
     * The file size
     * @type {number}
     * @memberof FileModelUpdateShared
     */
    'size'?: number | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileModelUpdateShared
     */
    'title'?: string | null;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileModelUpdateShared
     */
    'thumbnail'?: string | null;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileModelUpdateShared
     */
    'image'?: string | null;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileModelUpdateShared
     */
    'private_url'?: string | null;
    /**
     * 
     * @type {UserRelationUpdate}
     * @memberof FileModelUpdateShared
     */
    'user'?: UserRelationUpdate | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof FileModelUpdateShared
     */
    'created_at'?: string | null;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof FileModelUpdateShared
     */
    'updated_at'?: string | null;
}
/**
 * @type FileRelation
 * @export
 */
export type FileRelation = FileAvatarRelation | FileFileRelation | FileImageRelation;

/**
 * 
 * @export
 * @interface FileRelationShared
 */
export interface FileRelationShared {
    /**
     * 
     * @type {number}
     * @memberof FileRelationShared
     */
    'id': number;
    /**
     * The name of the file, originally
     * @type {string}
     * @memberof FileRelationShared
     */
    'name': string;
    /**
     * The calculated mimetype of the file
     * @type {string}
     * @memberof FileRelationShared
     */
    'mime': string;
    /**
     * The lookup safe name
     * @type {string}
     * @memberof FileRelationShared
     */
    'uri': string;
    /**
     * The alt text for the file
     * @type {string}
     * @memberof FileRelationShared
     */
    'alt': string | null;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileRelationShared
     */
    'title': string;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileRelationShared
     */
    'thumbnail': string;
    /**
     * Is the file public visible, or secure
     * @type {boolean}
     * @memberof FileRelationShared
     */
    'secure': boolean;
    /**
     * The path that the user can download this file at, if authorized.  Especially useful for secure files
     * @type {string}
     * @memberof FileRelationShared
     */
    'private_url': string;
    /**
     * The path to the full size derivative
     * @type {string}
     * @memberof FileRelationShared
     */
    'image': string;
    /**
     * 
     * @type {UserRelation}
     * @memberof FileRelationShared
     */
    'user'?: UserRelation | null;
    /**
     * The file size
     * @type {number}
     * @memberof FileRelationShared
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface FileRelationUpdate
 */
export interface FileRelationUpdate {
    /**
     * 
     * @type {number}
     * @memberof FileRelationUpdate
     */
    'id': number;
    /**
     * The title of the file, supplied from the client
     * @type {string}
     * @memberof FileRelationUpdate
     */
    'title'?: string | null;
    /**
     * The path to a cropped thumbnail
     * @type {string}
     * @memberof FileRelationUpdate
     */
    'thumbnail'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FileStatus = {
    Inactive: 'inactive',
    Active: 'active'
} as const;

export type FileStatus = typeof FileStatus[keyof typeof FileStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const FileType = {
    Image: 'image',
    File: 'file',
    Avatar: 'avatar'
} as const;

export type FileType = typeof FileType[keyof typeof FileType];


/**
 * 
 * @export
 * @enum {string}
 */

export const FileVisibility = {
    Hidden: 'hidden',
    Private: 'private',
    Location: 'location',
    Company: 'company',
    Public: 'public'
} as const;

export type FileVisibility = typeof FileVisibility[keyof typeof FileVisibility];


/**
 * 
 * @export
 * @interface GetPasswordTokenBody
 */
export interface GetPasswordTokenBody {
    /**
     * ID of the client app accessing the resource
     * @type {string}
     * @memberof GetPasswordTokenBody
     */
    'client_id': string;
    /**
     * Secret of the client app accessing the resource
     * @type {string}
     * @memberof GetPasswordTokenBody
     */
    'client_secret': string;
    /**
     * Email of the user accessing the app (user\'s e-mail address)
     * @type {string}
     * @memberof GetPasswordTokenBody
     */
    'username': string;
    /**
     * Password of the user accessing the app
     * @type {string}
     * @memberof GetPasswordTokenBody
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof GetPasswordTokenBody
     */
    'grant_type': GetPasswordTokenBodyGrantTypeEnum;
}

export const GetPasswordTokenBodyGrantTypeEnum = {
    Password: 'password'
} as const;

export type GetPasswordTokenBodyGrantTypeEnum = typeof GetPasswordTokenBodyGrantTypeEnum[keyof typeof GetPasswordTokenBodyGrantTypeEnum];

/**
 * 
 * @export
 * @interface GetPricingResponse
 */
export interface GetPricingResponse {
    /**
     * The sku number of the product
     * @type {string}
     * @memberof GetPricingResponse
     */
    'model_number': string;
    /**
     * The location id used to make the request
     * @type {number}
     * @memberof GetPricingResponse
     */
    'location_id': number;
    /**
     * The price of the item
     * @type {number}
     * @memberof GetPricingResponse
     */
    'price': number;
    /**
     * The range formatted string value
     * @type {string}
     * @memberof GetPricingResponse
     */
    'formatted'?: string;
    /**
     * The currency symbol (CAD USD) string value
     * @type {string}
     * @memberof GetPricingResponse
     */
    'currency'?: string;
}
/**
 * 
 * @export
 * @interface GetRefreshTokenBody
 */
export interface GetRefreshTokenBody {
    /**
     * ID of the client app accessing the resource
     * @type {string}
     * @memberof GetRefreshTokenBody
     */
    'client_id': string;
    /**
     * Secret of the client app accessing the resource
     * @type {string}
     * @memberof GetRefreshTokenBody
     */
    'client_secret': string;
    /**
     * Used in combination with \'refresh_token\' grant type
     * @type {string}
     * @memberof GetRefreshTokenBody
     */
    'refresh_token': string;
    /**
     * 
     * @type {string}
     * @memberof GetRefreshTokenBody
     */
    'grant_type': GetRefreshTokenBodyGrantTypeEnum;
}

export const GetRefreshTokenBodyGrantTypeEnum = {
    RefreshToken: 'refresh_token'
} as const;

export type GetRefreshTokenBodyGrantTypeEnum = typeof GetRefreshTokenBodyGrantTypeEnum[keyof typeof GetRefreshTokenBodyGrantTypeEnum];

/**
 * 
 * @export
 * @interface GetStatusResponse
 */
export interface GetStatusResponse {
    /**
     * Is the db connected?
     * @type {boolean}
     * @memberof GetStatusResponse
     */
    'db'?: boolean;
    /**
     * How many pending jobs are in the queue?
     * @type {number}
     * @memberof GetStatusResponse
     */
    'pending'?: number;
    /**
     * How many failed jobs are there?
     * @type {number}
     * @memberof GetStatusResponse
     */
    'failed'?: number;
    /**
     * How many pending product fetches are there?
     * @type {number}
     * @memberof GetStatusResponse
     */
    'product_fetches'?: number;
    /**
     * How many validation failures are there?
     * @type {number}
     * @memberof GetStatusResponse
     */
    'validation_failures'?: number;
    /**
     * Is the cache healthy?
     * @type {boolean}
     * @memberof GetStatusResponse
     */
    'cache_health'?: boolean;
    /**
     * Which environment are we on?
     * @type {string}
     * @memberof GetStatusResponse
     */
    'env'?: string;
    /**
     * The tagged release of the api as SemVer
     * @type {string}
     * @memberof GetStatusResponse
     */
    'version'?: string;
    /**
     * The short hash code of the release
     * @type {string}
     * @memberof GetStatusResponse
     */
    'build'?: string;
}
/**
 * @type GetTokenBody
 * @export
 */
export type GetTokenBody = GetPasswordTokenBody | GetRefreshTokenBody | GetTokenWithPasswordResetBody | GetTokenWithSalesforceSSOBody;

/**
 * 
 * @export
 * @interface GetTokenResponse
 */
export interface GetTokenResponse {
    /**
     * Type of the token returned
     * @type {string}
     * @memberof GetTokenResponse
     */
    'token_type': string;
    /**
     * Number of seconds until the access token expires
     * @type {number}
     * @memberof GetTokenResponse
     */
    'expires_in': number;
    /**
     * The token used for authorizing requests
     * @type {string}
     * @memberof GetTokenResponse
     */
    'access_token': string;
    /**
     * Token used to refresh short-lived access tokens
     * @type {string}
     * @memberof GetTokenResponse
     */
    'refresh_token': string;
    /**
     * Whether the user has 2FA enabled and needs to be verified
     * @type {boolean}
     * @memberof GetTokenResponse
     */
    'two_factor_required'?: boolean;
    /**
     * 
     * @type {RegisteredUser}
     * @memberof GetTokenResponse
     */
    'user': RegisteredUser;
}
/**
 * 
 * @export
 * @interface GetTokenWithPasswordResetBody
 */
export interface GetTokenWithPasswordResetBody {
    /**
     * ID of the client app accessing the resource
     * @type {string}
     * @memberof GetTokenWithPasswordResetBody
     */
    'client_id': string;
    /**
     * Secret of the client app accessing the resource
     * @type {string}
     * @memberof GetTokenWithPasswordResetBody
     */
    'client_secret': string;
    /**
     * The token sent to the user in the reset email
     * @type {string}
     * @memberof GetTokenWithPasswordResetBody
     */
    'token': string;
    /**
     * The email of the user, also from the link
     * @type {string}
     * @memberof GetTokenWithPasswordResetBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetTokenWithPasswordResetBody
     */
    'grant_type': GetTokenWithPasswordResetBodyGrantTypeEnum;
}

export const GetTokenWithPasswordResetBodyGrantTypeEnum = {
    ResetPasswordGrant: 'reset_password_grant'
} as const;

export type GetTokenWithPasswordResetBodyGrantTypeEnum = typeof GetTokenWithPasswordResetBodyGrantTypeEnum[keyof typeof GetTokenWithPasswordResetBodyGrantTypeEnum];

/**
 * 
 * @export
 * @interface GetTokenWithSalesforceSSOBody
 */
export interface GetTokenWithSalesforceSSOBody {
    /**
     * ID of the client app accessing the resource
     * @type {string}
     * @memberof GetTokenWithSalesforceSSOBody
     */
    'client_id': string;
    /**
     * Secret of the client app accessing the resource
     * @type {string}
     * @memberof GetTokenWithSalesforceSSOBody
     */
    'client_secret': string;
    /**
     * The token sent in the query string from the salesforce redirect
     * @type {string}
     * @memberof GetTokenWithSalesforceSSOBody
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof GetTokenWithSalesforceSSOBody
     */
    'grant_type': GetTokenWithSalesforceSSOBodyGrantTypeEnum;
}

export const GetTokenWithSalesforceSSOBodyGrantTypeEnum = {
    SalesforceSso: 'salesforce_sso'
} as const;

export type GetTokenWithSalesforceSSOBodyGrantTypeEnum = typeof GetTokenWithSalesforceSSOBodyGrantTypeEnum[keyof typeof GetTokenWithSalesforceSSOBodyGrantTypeEnum];

/**
 * 
 * @export
 * @interface Hour
 */
export interface Hour {
    /**
     * 
     * @type {boolean | number}
     * @memberof Hour
     */
    'start': boolean | number;
    /**
     * 
     * @type {boolean | number}
     * @memberof Hour
     */
    'end': boolean | number;
}
/**
 * 
 * @export
 * @interface Hours
 */
export interface Hours {
    /**
     * 
     * @type {Hour | boolean}
     * @memberof Hours
     */
    'mon': Hour | boolean;
    /**
     * 
     * @type {Hour | boolean}
     * @memberof Hours
     */
    'tue': Hour | boolean;
    /**
     * 
     * @type {Hour | boolean}
     * @memberof Hours
     */
    'wed': Hour | boolean;
    /**
     * 
     * @type {Hour | boolean}
     * @memberof Hours
     */
    'thu': Hour | boolean;
    /**
     * 
     * @type {Hour | boolean}
     * @memberof Hours
     */
    'fri': Hour | boolean;
    /**
     * 
     * @type {Hour | boolean}
     * @memberof Hours
     */
    'sat': Hour | boolean;
    /**
     * 
     * @type {Hour | boolean}
     * @memberof Hours
     */
    'sun': Hour | boolean;
}
/**
 * 
 * @export
 * @interface ImageBlock
 */
export interface ImageBlock {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof ImageBlock
     */
    'id': number;
    /**
     * 
     * @type {ImageBlockType}
     * @memberof ImageBlock
     */
    'type': ImageBlockType;
    /**
     * 
     * @type {FileModelImage}
     * @memberof ImageBlock
     */
    'content': FileModelImage;
    /**
     * 
     * @type {ImageBlockSettings}
     * @memberof ImageBlock
     */
    'settings'?: ImageBlockSettings;
}
/**
 * 
 * @export
 * @interface ImageBlockAllOf
 */
export interface ImageBlockAllOf {
    /**
     * 
     * @type {ImageBlockType}
     * @memberof ImageBlockAllOf
     */
    'type': ImageBlockType;
    /**
     * 
     * @type {FileModelImage}
     * @memberof ImageBlockAllOf
     */
    'content': FileModelImage;
    /**
     * 
     * @type {ImageBlockSettings}
     * @memberof ImageBlockAllOf
     */
    'settings'?: ImageBlockSettings;
}
/**
 * 
 * @export
 * @interface ImageBlockSettings
 */
export interface ImageBlockSettings {
    /**
     * The top offset in px.
     * @type {number}
     * @memberof ImageBlockSettings
     */
    'top': number;
    /**
     * The left offset in px.
     * @type {number}
     * @memberof ImageBlockSettings
     */
    'left': number;
    /**
     * 
     * @type {number}
     * @memberof ImageBlockSettings
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof ImageBlockSettings
     */
    'height': number;
    /**
     * The number of degrees to rotate, where 0 is no rotation, 90 is 90 degrees clockwise and -90 is 90deg counter clockwise.
     * @type {number}
     * @memberof ImageBlockSettings
     */
    'rotate': number;
    /**
     * Set to 1 to flip the image. Default value is 0.
     * @type {number}
     * @memberof ImageBlockSettings
     */
    'flip': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ImageBlockType = {
    Image: 'image'
} as const;

export type ImageBlockType = typeof ImageBlockType[keyof typeof ImageBlockType];


/**
 * 
 * @export
 * @interface ImageBlockUpdate
 */
export interface ImageBlockUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof ImageBlockUpdate
     */
    'id': number | null;
    /**
     * 
     * @type {ImageBlockType}
     * @memberof ImageBlockUpdate
     */
    'type': ImageBlockType;
    /**
     * 
     * @type {FileModelImageUpdate}
     * @memberof ImageBlockUpdate
     */
    'content': FileModelImageUpdate;
    /**
     * 
     * @type {ImageBlockSettings}
     * @memberof ImageBlockUpdate
     */
    'settings'?: ImageBlockSettings;
}
/**
 * 
 * @export
 * @interface ImageBlockUpdateAllOf
 */
export interface ImageBlockUpdateAllOf {
    /**
     * 
     * @type {ImageBlockType}
     * @memberof ImageBlockUpdateAllOf
     */
    'type': ImageBlockType;
    /**
     * 
     * @type {FileModelImageUpdate}
     * @memberof ImageBlockUpdateAllOf
     */
    'content': FileModelImageUpdate;
    /**
     * 
     * @type {ImageBlockSettings}
     * @memberof ImageBlockUpdateAllOf
     */
    'settings'?: ImageBlockSettings;
}
/**
 * 
 * @export
 * @interface Introduction
 */
export interface Introduction {
    /**
     * The name of the client
     * @type {string}
     * @memberof Introduction
     */
    'name': string;
    /**
     * A markdown compatible field that contains the content of the introduction
     * @type {string}
     * @memberof Introduction
     */
    'content': string;
    /**
     * The user that created the introduction
     * @type {number}
     * @memberof Introduction
     */
    'user_id'?: number;
    /**
     * 
     * @type {IntroductionStatus}
     * @memberof Introduction
     */
    'status': IntroductionStatus;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof Introduction
     */
    'image_settings'?: CropImageSettings | null;
    /**
     * 
     * @type {IntroductionVisibility}
     * @memberof Introduction
     */
    'visibility'?: IntroductionVisibility;
    /**
     * 
     * @type {string}
     * @memberof Introduction
     */
    'link': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Introduction
     */
    'show_link': boolean;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Introduction
     */
    'created_at'?: string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Introduction
     */
    'updated_at'?: string;
    /**
     * Internal middleware record id for introduction
     * @type {number}
     * @memberof Introduction
     */
    'id': number;
    /**
     * 
     * @type {FileImageRelation}
     * @memberof Introduction
     */
    'image': FileImageRelation;
}
/**
 * A project page be an introduction page.  An intro page has between 1 and 5 introduction blocks.  These Introductions have a name, a content description, and an image. 
 * @export
 * @interface IntroductionAllOf
 */
export interface IntroductionAllOf {
    /**
     * Internal middleware record id for introduction
     * @type {number}
     * @memberof IntroductionAllOf
     */
    'id': number;
    /**
     * 
     * @type {FileImageRelation}
     * @memberof IntroductionAllOf
     */
    'image': FileImageRelation;
}
/**
 * 
 * @export
 * @interface IntroductionBlock
 */
export interface IntroductionBlock {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof IntroductionBlock
     */
    'id': number;
    /**
     * 
     * @type {IntroductionBlockType}
     * @memberof IntroductionBlock
     */
    'type': IntroductionBlockType;
    /**
     * 
     * @type {Introduction}
     * @memberof IntroductionBlock
     */
    'content': Introduction;
    /**
     * 
     * @type {IntroductionBlockSettings}
     * @memberof IntroductionBlock
     */
    'settings'?: IntroductionBlockSettings;
}
/**
 * 
 * @export
 * @interface IntroductionBlockAllOf
 */
export interface IntroductionBlockAllOf {
    /**
     * 
     * @type {IntroductionBlockType}
     * @memberof IntroductionBlockAllOf
     */
    'type': IntroductionBlockType;
    /**
     * 
     * @type {Introduction}
     * @memberof IntroductionBlockAllOf
     */
    'content': Introduction;
    /**
     * 
     * @type {IntroductionBlockSettings}
     * @memberof IntroductionBlockAllOf
     */
    'settings'?: IntroductionBlockSettings;
}
/**
 * 
 * @export
 * @interface IntroductionBlockSettings
 */
export interface IntroductionBlockSettings {
    /**
     * 
     * @type {string}
     * @memberof IntroductionBlockSettings
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntroductionBlockSettings
     */
    'content'?: string;
    /**
     * 
     * @type {FileImageRelation}
     * @memberof IntroductionBlockSettings
     */
    'image'?: FileImageRelation;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof IntroductionBlockSettings
     */
    'image_settings'?: CropImageSettings;
    /**
     * 
     * @type {string}
     * @memberof IntroductionBlockSettings
     */
    'link'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IntroductionBlockSettings
     */
    'show_link'?: boolean;
}
/**
 * 
 * @export
 * @interface IntroductionBlockSettingsUpdate
 */
export interface IntroductionBlockSettingsUpdate {
    /**
     * 
     * @type {string}
     * @memberof IntroductionBlockSettingsUpdate
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntroductionBlockSettingsUpdate
     */
    'content'?: string;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof IntroductionBlockSettingsUpdate
     */
    'image'?: FileRelationUpdate;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof IntroductionBlockSettingsUpdate
     */
    'image_settings'?: CropImageSettings;
    /**
     * 
     * @type {string}
     * @memberof IntroductionBlockSettingsUpdate
     */
    'link'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IntroductionBlockSettingsUpdate
     */
    'show_link'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IntroductionBlockType = {
    Introduction: 'introduction'
} as const;

export type IntroductionBlockType = typeof IntroductionBlockType[keyof typeof IntroductionBlockType];


/**
 * 
 * @export
 * @interface IntroductionBlockUpdate
 */
export interface IntroductionBlockUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof IntroductionBlockUpdate
     */
    'id': number | null;
    /**
     * 
     * @type {IntroductionBlockType}
     * @memberof IntroductionBlockUpdate
     */
    'type': IntroductionBlockType;
    /**
     * 
     * @type {IntroductionUpdate}
     * @memberof IntroductionBlockUpdate
     */
    'content': IntroductionUpdate;
    /**
     * 
     * @type {IntroductionBlockSettingsUpdate}
     * @memberof IntroductionBlockUpdate
     */
    'settings'?: IntroductionBlockSettingsUpdate;
}
/**
 * 
 * @export
 * @interface IntroductionBlockUpdateAllOf
 */
export interface IntroductionBlockUpdateAllOf {
    /**
     * 
     * @type {IntroductionBlockType}
     * @memberof IntroductionBlockUpdateAllOf
     */
    'type': IntroductionBlockType;
    /**
     * 
     * @type {IntroductionUpdate}
     * @memberof IntroductionBlockUpdateAllOf
     */
    'content': IntroductionUpdate;
    /**
     * 
     * @type {IntroductionBlockSettingsUpdate}
     * @memberof IntroductionBlockUpdateAllOf
     */
    'settings'?: IntroductionBlockSettingsUpdate;
}
/**
 * 
 * @export
 * @interface IntroductionPage
 */
export interface IntroductionPage {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof IntroductionPage
     */
    'id': number;
    /**
     * The name of the page
     * @type {string}
     * @memberof IntroductionPage
     */
    'name': string;
    /**
     * 
     * @type {IntroductionPageType}
     * @memberof IntroductionPage
     */
    'type': IntroductionPageType;
    /**
     * 
     * @type {Array<IntroductionBlock>}
     * @memberof IntroductionPage
     */
    'blocks': Array<IntroductionBlock>;
}
/**
 * 
 * @export
 * @interface IntroductionPageAllOf
 */
export interface IntroductionPageAllOf {
    /**
     * 
     * @type {IntroductionPageType}
     * @memberof IntroductionPageAllOf
     */
    'type': IntroductionPageType;
    /**
     * 
     * @type {Array<IntroductionBlock>}
     * @memberof IntroductionPageAllOf
     */
    'blocks': Array<IntroductionBlock>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IntroductionPageType = {
    Introduction: 'introduction'
} as const;

export type IntroductionPageType = typeof IntroductionPageType[keyof typeof IntroductionPageType];


/**
 * 
 * @export
 * @interface IntroductionPageUpdate
 */
export interface IntroductionPageUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof IntroductionPageUpdate
     */
    'id': number | null;
    /**
     * The name of the page
     * @type {string}
     * @memberof IntroductionPageUpdate
     */
    'name': string;
    /**
     * 
     * @type {IntroductionPageType}
     * @memberof IntroductionPageUpdate
     */
    'type': IntroductionPageType;
    /**
     * 
     * @type {Array<IntroductionBlockUpdate>}
     * @memberof IntroductionPageUpdate
     */
    'blocks': Array<IntroductionBlockUpdate>;
}
/**
 * 
 * @export
 * @interface IntroductionPageUpdateAllOf
 */
export interface IntroductionPageUpdateAllOf {
    /**
     * 
     * @type {IntroductionPageType}
     * @memberof IntroductionPageUpdateAllOf
     */
    'type': IntroductionPageType;
    /**
     * 
     * @type {Array<IntroductionBlockUpdate>}
     * @memberof IntroductionPageUpdateAllOf
     */
    'blocks': Array<IntroductionBlockUpdate>;
}
/**
 * 
 * @export
 * @interface IntroductionShared
 */
export interface IntroductionShared {
    /**
     * The name of the client
     * @type {string}
     * @memberof IntroductionShared
     */
    'name': string;
    /**
     * A markdown compatible field that contains the content of the introduction
     * @type {string}
     * @memberof IntroductionShared
     */
    'content': string;
    /**
     * The user that created the introduction
     * @type {number}
     * @memberof IntroductionShared
     */
    'user_id'?: number;
    /**
     * 
     * @type {IntroductionStatus}
     * @memberof IntroductionShared
     */
    'status': IntroductionStatus;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof IntroductionShared
     */
    'image_settings'?: CropImageSettings | null;
    /**
     * 
     * @type {IntroductionVisibility}
     * @memberof IntroductionShared
     */
    'visibility'?: IntroductionVisibility;
    /**
     * 
     * @type {string}
     * @memberof IntroductionShared
     */
    'link': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IntroductionShared
     */
    'show_link': boolean;
    /**
     * the date the record was created
     * @type {string}
     * @memberof IntroductionShared
     */
    'created_at'?: string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof IntroductionShared
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IntroductionStatus = {
    Inactive: 'inactive',
    Active: 'active'
} as const;

export type IntroductionStatus = typeof IntroductionStatus[keyof typeof IntroductionStatus];


/**
 * 
 * @export
 * @interface IntroductionUpdate
 */
export interface IntroductionUpdate {
    /**
     * The name of the client
     * @type {string}
     * @memberof IntroductionUpdate
     */
    'name': string;
    /**
     * A markdown compatible field that contains the content of the introduction
     * @type {string}
     * @memberof IntroductionUpdate
     */
    'content': string;
    /**
     * The user that created the introduction
     * @type {number}
     * @memberof IntroductionUpdate
     */
    'user_id'?: number;
    /**
     * 
     * @type {IntroductionStatus}
     * @memberof IntroductionUpdate
     */
    'status': IntroductionStatus;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof IntroductionUpdate
     */
    'image_settings'?: CropImageSettings | null;
    /**
     * 
     * @type {IntroductionVisibility}
     * @memberof IntroductionUpdate
     */
    'visibility'?: IntroductionVisibility;
    /**
     * 
     * @type {string}
     * @memberof IntroductionUpdate
     */
    'link': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IntroductionUpdate
     */
    'show_link': boolean;
    /**
     * the date the record was created
     * @type {string}
     * @memberof IntroductionUpdate
     */
    'created_at'?: string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof IntroductionUpdate
     */
    'updated_at'?: string;
    /**
     * Internal middleware record id for introduction
     * @type {number}
     * @memberof IntroductionUpdate
     */
    'id': number | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof IntroductionUpdate
     */
    'image': FileRelationUpdate;
}
/**
 * 
 * @export
 * @interface IntroductionUpdateAllOf
 */
export interface IntroductionUpdateAllOf {
    /**
     * Internal middleware record id for introduction
     * @type {number}
     * @memberof IntroductionUpdateAllOf
     */
    'id': number | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof IntroductionUpdateAllOf
     */
    'image': FileRelationUpdate;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IntroductionVisibility = {
    Private: 'private',
    Public: 'public'
} as const;

export type IntroductionVisibility = typeof IntroductionVisibility[keyof typeof IntroductionVisibility];


/**
 * 
 * @export
 * @interface LineItem
 */
export interface LineItem {
    /**
     * The id of the line item
     * @type {number}
     * @memberof LineItem
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    'order_id': number;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    'number': number;
    /**
     * The when the order was promised
     * @type {string}
     * @memberof LineItem
     */
    'order_date': string;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    'invoice_number': number;
    /**
     * The when the order was promised
     * @type {string}
     * @memberof LineItem
     */
    'invoice_date': string | null;
    /**
     * The when the order was promised
     * @type {string}
     * @memberof LineItem
     */
    'estimated_ship_date': string | null;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    'po_number': string | null;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    'line_number': number;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    'sku': string | null;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    'sku_description': string | null;
    /**
     * The quantity of items in this line
     * @type {number}
     * @memberof LineItem
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    'extended_price': number;
    /**
     * 
     * @type {LineItemShippedStatus}
     * @memberof LineItem
     */
    'shipped_status': LineItemShippedStatus | null;
    /**
     * A secure url to the packing slip zip
     * @type {string}
     * @memberof LineItem
     */
    'packing_slip_url': string | null;
    /**
     * A secure url to the invoice zip
     * @type {string}
     * @memberof LineItem
     */
    'invoice_url': string | null;
    /**
     * A link to the tracking page from the shipper
     * @type {string}
     * @memberof LineItem
     */
    'tracking_url': string | null;
    /**
     * A Url to the primary image for the product
     * @type {string}
     * @memberof LineItem
     */
    'main_image': string | null;
    /**
     * the date the record was created
     * @type {string}
     * @memberof LineItem
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof LineItem
     */
    'updated_at': string;
    /**
     * 
     * @type {Array<RelatedAsset>}
     * @memberof LineItem
     */
    'related_assets': Array<RelatedAsset>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LineItemShippedStatus = {
    NotShipped: 'not shipped',
    Shipped: 'shipped',
    Cancelled: 'cancelled'
} as const;

export type LineItemShippedStatus = typeof LineItemShippedStatus[keyof typeof LineItemShippedStatus];


/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'id': number;
    /**
     * The status of the task (0 = inactive | 1 = active)
     * @type {boolean}
     * @memberof Location
     */
    'status': boolean;
    /**
     * The company id of the customer location
     * @type {number}
     * @memberof Location
     */
    'company_id': number;
    /**
     * The bill_to_id of the customer location
     * @type {number}
     * @memberof Location
     */
    'bill_to_id': number;
    /**
     * The ship_to_id of the customer location
     * @type {string}
     * @memberof Location
     */
    'ship_to_id': string;
    /**
     * The name of the location
     * @type {string}
     * @memberof Location
     */
    'name': string | null;
    /**
     * The address of the location
     * @type {string}
     * @memberof Location
     */
    'address': string | null;
    /**
     * The city of the location
     * @type {string}
     * @memberof Location
     */
    'city': string | null;
    /**
     * The state of the location
     * @type {string}
     * @memberof Location
     */
    'state': string | null;
    /**
     * The zipcode of the location
     * @type {string}
     * @memberof Location
     */
    'zip_code': string | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'country': string;
    /**
     * The latitude of the address
     * @type {number}
     * @memberof Location
     */
    'longitude': number | null;
    /**
     * The latitude of the address
     * @type {number}
     * @memberof Location
     */
    'latitude': number | null;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof Location
     */
    'company'?: CompanyRelation;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'sales_rep_id': number | null;
    /**
     * 
     * @type {Array<UserRelation>}
     * @memberof Location
     */
    'sales_reps': Array<UserRelation>;
    /**
     * the date the location was last cached
     * @type {string}
     * @memberof Location
     */
    'cached_at': string | null;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Location
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Location
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface LocationLookup
 */
export interface LocationLookup {
    /**
     * 
     * @type {number}
     * @memberof LocationLookup
     */
    'bill_to_id': number;
    /**
     * The name of the location
     * @type {string}
     * @memberof LocationLookup
     */
    'name': string | null;
    /**
     * The address of the location
     * @type {string}
     * @memberof LocationLookup
     */
    'address': string | null;
    /**
     * The city of the location
     * @type {string}
     * @memberof LocationLookup
     */
    'city': string | null;
    /**
     * The state of the location
     * @type {string}
     * @memberof LocationLookup
     */
    'state': string | null;
    /**
     * The zipcode of the location
     * @type {string}
     * @memberof LocationLookup
     */
    'zip_code': string | null;
}
/**
 * 
 * @export
 * @interface LocationManagerUser
 */
export interface LocationManagerUser {
    /**
     * 
     * @type {number}
     * @memberof LocationManagerUser
     */
    'id': number;
    /**
     * Is the user\'s company an wholesaler
     * @type {boolean}
     * @memberof LocationManagerUser
     */
    'wholesaler'?: boolean;
    /**
     * Is the user\'s company an evolution owner
     * @type {boolean}
     * @memberof LocationManagerUser
     */
    'evolution'?: boolean;
    /**
     * Can the user buy direct via the quote interface
     * @type {boolean}
     * @memberof LocationManagerUser
     */
    'direct_buyer'?: boolean;
    /**
     * The company id
     * @type {number}
     * @memberof LocationManagerUser
     */
    'company_id': number;
    /**
     * The location id
     * @type {number}
     * @memberof LocationManagerUser
     */
    'location_id': number;
    /**
     * The agency id
     * @type {number}
     * @memberof LocationManagerUser
     */
    'agency_id': number;
    /**
     * Whether this user has access to all territories
     * @type {boolean}
     * @memberof LocationManagerUser
     */
    'all_territories'?: boolean;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof LocationManagerUser
     */
    'first_name': string | null;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof LocationManagerUser
     */
    'last_name': string | null;
    /**
     * 
     * @type {FileAvatarRelation}
     * @memberof LocationManagerUser
     */
    'image': FileAvatarRelation | null;
    /**
     * 
     * @type {PendingQuote}
     * @memberof LocationManagerUser
     */
    'pending_quote'?: PendingQuote | null;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof LocationManagerUser
     */
    'email': string;
    /**
     * The phone number of the user
     * @type {string}
     * @memberof LocationManagerUser
     */
    'phone'?: string | null;
    /**
     * 
     * @type {UserSharedPermissions}
     * @memberof LocationManagerUser
     */
    'permissions': UserSharedPermissions;
    /**
     * The last login date
     * @type {string}
     * @memberof LocationManagerUser
     */
    'last_login': string | null;
    /**
     * 
     * @type {number}
     * @memberof LocationManagerUser
     */
    'login_count': number;
    /**
     * The last login date
     * @type {string}
     * @memberof LocationManagerUser
     */
    'last_access': string | null;
    /**
     * 
     * @type {number}
     * @memberof LocationManagerUser
     */
    'access_count': number;
    /**
     * 
     * @type {string}
     * @memberof LocationManagerUser
     */
    'email_verified_at': string | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof LocationManagerUser
     */
    'created_at': string;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof LocationManagerUser
     */
    'updated_at': string;
    /**
     * Whether the user has enabled 2FA
     * @type {boolean}
     * @memberof LocationManagerUser
     */
    'google2fa_enabled'?: boolean;
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof LocationManagerUser
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof LocationManagerUser
     */
    'company': CompanyRelation;
    /**
     * 
     * @type {LocationRelation}
     * @memberof LocationManagerUser
     */
    'location': LocationRelation;
    /**
     * 
     * @type {string}
     * @memberof LocationManagerUser
     */
    'role': LocationManagerUserRoleEnum;
    /**
     * Is this user managed by a representative?
     * @type {boolean}
     * @memberof LocationManagerUser
     */
    'rep_managed': boolean;
}

export const LocationManagerUserRoleEnum = {
    LocationManager: 'location_manager'
} as const;

export type LocationManagerUserRoleEnum = typeof LocationManagerUserRoleEnum[keyof typeof LocationManagerUserRoleEnum];

/**
 * 
 * @export
 * @interface LocationManagerUserAllOf
 */
export interface LocationManagerUserAllOf {
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof LocationManagerUserAllOf
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof LocationManagerUserAllOf
     */
    'company': CompanyRelation;
    /**
     * 
     * @type {LocationRelation}
     * @memberof LocationManagerUserAllOf
     */
    'location': LocationRelation;
    /**
     * 
     * @type {string}
     * @memberof LocationManagerUserAllOf
     */
    'role': LocationManagerUserAllOfRoleEnum;
    /**
     * Is this user managed by a representative?
     * @type {boolean}
     * @memberof LocationManagerUserAllOf
     */
    'rep_managed': boolean;
}

export const LocationManagerUserAllOfRoleEnum = {
    LocationManager: 'location_manager'
} as const;

export type LocationManagerUserAllOfRoleEnum = typeof LocationManagerUserAllOfRoleEnum[keyof typeof LocationManagerUserAllOfRoleEnum];

/**
 * 
 * @export
 * @interface LocationRelation
 */
export interface LocationRelation {
    /**
     * 
     * @type {number}
     * @memberof LocationRelation
     */
    'id': number;
    /**
     * The company id of the customer location
     * @type {number}
     * @memberof LocationRelation
     */
    'company_id': number;
    /**
     * The bill_to_id of the customer location
     * @type {number}
     * @memberof LocationRelation
     */
    'bill_to_id': number;
    /**
     * The ship_to_id of the customer location
     * @type {string}
     * @memberof LocationRelation
     */
    'ship_to_id': string;
    /**
     * The name of the location
     * @type {string}
     * @memberof LocationRelation
     */
    'name': string | null;
    /**
     * The address of the location
     * @type {string}
     * @memberof LocationRelation
     */
    'address': string | null;
    /**
     * The city of the location
     * @type {string}
     * @memberof LocationRelation
     */
    'city': string | null;
    /**
     * The state of the location
     * @type {string}
     * @memberof LocationRelation
     */
    'state': string | null;
    /**
     * The zipcode of the location
     * @type {string}
     * @memberof LocationRelation
     */
    'zip_code': string | null;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof LocationRelation
     */
    'company': CompanyRelation;
    /**
     * 
     * @type {UserRelation}
     * @memberof LocationRelation
     */
    'sales_rep': UserRelation | null;
    /**
     * 
     * @type {Array<UserRelation>}
     * @memberof LocationRelation
     */
    'sales_reps': Array<UserRelation>;
}
/**
 * 
 * @export
 * @interface MoveBillToBody
 */
export interface MoveBillToBody {
    /**
     * 
     * @type {string}
     * @memberof MoveBillToBody
     */
    'bill_to_id': string;
}
/**
 * 
 * @export
 * @interface NotesPage
 */
export interface NotesPage {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof NotesPage
     */
    'id': number;
    /**
     * The name of the page
     * @type {string}
     * @memberof NotesPage
     */
    'name': string;
    /**
     * 
     * @type {NotesPageType}
     * @memberof NotesPage
     */
    'type': NotesPageType;
    /**
     * 
     * @type {Array<ImageBlock | TextBlock>}
     * @memberof NotesPage
     */
    'blocks': Array<ImageBlock | TextBlock>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof NotesPage
     */
    'layout'?: PageLayouts | null;
}
/**
 * 
 * @export
 * @interface NotesPageAllOf
 */
export interface NotesPageAllOf {
    /**
     * 
     * @type {NotesPageType}
     * @memberof NotesPageAllOf
     */
    'type': NotesPageType;
    /**
     * 
     * @type {Array<ImageBlock | TextBlock>}
     * @memberof NotesPageAllOf
     */
    'blocks': Array<ImageBlock | TextBlock>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof NotesPageAllOf
     */
    'layout'?: PageLayouts | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NotesPageType = {
    Notes: 'notes'
} as const;

export type NotesPageType = typeof NotesPageType[keyof typeof NotesPageType];


/**
 * 
 * @export
 * @interface NotesPageUpdate
 */
export interface NotesPageUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof NotesPageUpdate
     */
    'id': number | null;
    /**
     * The name of the page
     * @type {string}
     * @memberof NotesPageUpdate
     */
    'name': string;
    /**
     * 
     * @type {NotesPageType}
     * @memberof NotesPageUpdate
     */
    'type': NotesPageType;
    /**
     * 
     * @type {Array<ImageBlockUpdate | TextBlockUpdate>}
     * @memberof NotesPageUpdate
     */
    'blocks': Array<ImageBlockUpdate | TextBlockUpdate>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof NotesPageUpdate
     */
    'layout'?: PageLayouts | null;
}
/**
 * 
 * @export
 * @interface NotesPageUpdateAllOf
 */
export interface NotesPageUpdateAllOf {
    /**
     * 
     * @type {NotesPageType}
     * @memberof NotesPageUpdateAllOf
     */
    'type': NotesPageType;
    /**
     * 
     * @type {Array<ImageBlockUpdate | TextBlockUpdate>}
     * @memberof NotesPageUpdateAllOf
     */
    'blocks': Array<ImageBlockUpdate | TextBlockUpdate>;
    /**
     * 
     * @type {PageLayouts}
     * @memberof NotesPageUpdateAllOf
     */
    'layout'?: PageLayouts | null;
}
/**
 * An order is the top level object that describes an order.  It has metadata on the top level and an array of line items that contain Product objects.  It also contains a Bill to and a Ship To recipient.  If it can be done efficiently, we would prefer to be able to query all of this data as a single object. 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * The internal identifier for this order
     * @type {number}
     * @memberof Order
     */
    'id': number;
    /**
     * The id of the location associated with the order
     * @type {number}
     * @memberof Order
     */
    'company_id': number;
    /**
     * The id of the location associated with the order
     * @type {number}
     * @memberof Order
     */
    'location_id': number;
    /**
     * The id of the purchasing user
     * @type {number}
     * @memberof Order
     */
    'user_id': number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'agency_id': number;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'index_pending': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'partially_shipped'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'completely_shipped'?: boolean;
    /**
     * The symmons order number
     * @type {string}
     * @memberof Order
     */
    'number': string;
    /**
     * The symmons order type
     * @type {string}
     * @memberof Order
     */
    'type': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof Order
     */
    'status': OrderStatus;
    /**
     * The bill_to_id of the purchasing company
     * @type {number}
     * @memberof Order
     */
    'bill_to_id': number;
    /**
     * The id of the symmons ship_to user
     * @type {string}
     * @memberof Order
     */
    'ship_to_id': string;
    /**
     * The PO identifier for the order
     * @type {string}
     * @memberof Order
     */
    'po_number': string;
    /**
     * The id of the wholesaler
     * @type {string}
     * @memberof Order
     */
    'wholesaler_id': string;
    /**
     * The name of the wholesaler
     * @type {string}
     * @memberof Order
     */
    'wholesaler_name': string;
    /**
     * The date and time the order was placed
     * @type {string}
     * @memberof Order
     */
    'order_date': string | null;
    /**
     * The actual ship date (null if not yet shipped)
     * @type {string}
     * @memberof Order
     */
    'ship_date': string | null;
    /**
     * The total cost, excluding sales tax
     * @type {string}
     * @memberof Order
     */
    'sub_total': string | null;
    /**
     * The sales tax changed on the order
     * @type {string}
     * @memberof Order
     */
    'sales_tax': string | null;
    /**
     * The total billable amount of the order
     * @type {string}
     * @memberof Order
     */
    'total': string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'packing_slip_url': string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'invoice_url': string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'tracking_url': string | null;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof Order
     */
    'company'?: CompanyRelation | null;
    /**
     * 
     * @type {LocationRelation}
     * @memberof Order
     */
    'location'?: LocationRelation | null;
    /**
     * 
     * @type {UserRelation}
     * @memberof Order
     */
    'user'?: UserRelation | null;
    /**
     * 
     * @type {Array<LineItem>}
     * @memberof Order
     */
    'lines'?: Array<LineItem>;
    /**
     * 
     * @type {Array<LineItem>}
     * @memberof Order
     */
    'charges'?: Array<LineItem>;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'cached_at': string | null;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Order
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Order
     */
    'updated_at': string;
    /**
     * 
     * @type {OrderQuote}
     * @memberof Order
     */
    'quote'?: OrderQuote | null;
}
/**
 * 
 * @export
 * @interface OrderEvent
 */
export interface OrderEvent {
    /**
     * The message with the quote
     * @type {string}
     * @memberof OrderEvent
     */
    'message': string;
    /**
     * 
     * @type {OrderEventType}
     * @memberof OrderEvent
     */
    'type': OrderEventType;
    /**
     * A an optional reason for the request for the request
     * @type {string}
     * @memberof OrderEvent
     */
    'reason': string;
    /**
     * 
     * @type {UserRelation}
     * @memberof OrderEvent
     */
    'user'?: UserRelation | null;
    /**
     * 
     * @type {Array<FileRelation>}
     * @memberof OrderEvent
     */
    'files'?: Array<FileRelation>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof OrderEvent
     */
    'created_at': string;
    /**
     * the date the record was updated
     * @type {string}
     * @memberof OrderEvent
     */
    'updated_at': string;
}
/**
 * The type of an order event
 * @export
 * @enum {string}
 */

export const OrderEventType = {
    Created: 'created',
    Shipped: 'shipped',
    Delivered: 'delivered',
    Closed: 'closed',
    Canceled: 'canceled',
    Change: 'change',
    Changed: 'changed',
    Return: 'return',
    Returned: 'returned'
} as const;

export type OrderEventType = typeof OrderEventType[keyof typeof OrderEventType];


/**
 * 
 * @export
 * @interface OrderQuote
 */
export interface OrderQuote {
    /**
     * 
     * @type {number}
     * @memberof OrderQuote
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderQuote
     */
    'project_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderQuote
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderQuote
     */
    'updated_at'?: string;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof OrderQuote
     */
    'company'?: CompanyRelation | null;
}
/**
 * 
 * @export
 * @interface OrderRequestBody
 */
export interface OrderRequestBody {
    /**
     * The order id to link to the quote
     * @type {number}
     * @memberof OrderRequestBody
     */
    'order_id': number;
    /**
     * The message with the quote
     * @type {string}
     * @memberof OrderRequestBody
     */
    'message'?: string;
}
/**
 * The status of the order.
 * @export
 * @enum {string}
 */

export const OrderStatus = {
    Open: 'open',
    Shipped: 'shipped',
    Delivered: 'delivered',
    ReturnRequested: 'return_requested',
    Returned: 'returned',
    ChangeRequested: 'change_requested',
    Changed: 'changed',
    Canceled: 'canceled',
    Closed: 'closed'
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


/**
 * @type Page
 * @export
 */
export type Page = CoverPage | DividerPage | EmptyPage | IntroductionPage | NotesPage | ProductPage | SummaryPage | TocPage;

/**
 * 
 * @export
 * @enum {string}
 */

export const PageLayouts = {
    Alternate: 'alternate'
} as const;

export type PageLayouts = typeof PageLayouts[keyof typeof PageLayouts];


/**
 * Each version contains an order list of pages.  Each page is of a particular PageType, and contains an order list of `blocks`. These blocks are used for rendering the page 
 * @export
 * @interface PageShared
 */
export interface PageShared {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof PageShared
     */
    'id': number;
    /**
     * The name of the page
     * @type {string}
     * @memberof PageShared
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PageType = {
    Cover: 'cover',
    Toc: 'toc',
    Introduction: 'introduction',
    Divider: 'divider',
    Product: 'product',
    Summary: 'summary',
    Notes: 'notes',
    Pdf: 'pdf'
} as const;

export type PageType = typeof PageType[keyof typeof PageType];


/**
 * @type PageUpdate
 * @export
 */
export type PageUpdate = CoverPageUpdate | DividerPageUpdate | EmptyPageUpdate | IntroductionPageUpdate | NotesPageUpdate | ProductPageUpdate | SummaryPageUpdate | TocPageUpdate;

/**
 * 
 * @export
 * @interface PageUpdateShared
 */
export interface PageUpdateShared {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof PageUpdateShared
     */
    'id': number | null;
    /**
     * The name of the page
     * @type {string}
     * @memberof PageUpdateShared
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface Paginated
 */
export interface Paginated {
    /**
     * Total results counter
     * @type {number}
     * @memberof Paginated
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof Paginated
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof Paginated
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof Paginated
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof Paginated
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof Paginated
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof Paginated
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof Paginated
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof Paginated
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof Paginated
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof Paginated
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof Paginated
     */
    'links': Array<PaginationPageLink>;
}
/**
 * 
 * @export
 * @interface PaginatedAgencies
 */
export interface PaginatedAgencies {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedAgencies
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedAgencies
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedAgencies
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedAgencies
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedAgencies
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedAgencies
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedAgencies
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedAgencies
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedAgencies
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedAgencies
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedAgencies
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedAgencies
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<Agency>}
     * @memberof PaginatedAgencies
     */
    'data': Array<Agency>;
}
/**
 * 
 * @export
 * @interface PaginatedAgenciesAllOf
 */
export interface PaginatedAgenciesAllOf {
    /**
     * 
     * @type {Array<Agency>}
     * @memberof PaginatedAgenciesAllOf
     */
    'data': Array<Agency>;
}
/**
 * 
 * @export
 * @interface PaginatedAgencyGoals
 */
export interface PaginatedAgencyGoals {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedAgencyGoals
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedAgencyGoals
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedAgencyGoals
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedAgencyGoals
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedAgencyGoals
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedAgencyGoals
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedAgencyGoals
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedAgencyGoals
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedAgencyGoals
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedAgencyGoals
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedAgencyGoals
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedAgencyGoals
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<AgencyGoal>}
     * @memberof PaginatedAgencyGoals
     */
    'data': Array<AgencyGoal>;
}
/**
 * 
 * @export
 * @interface PaginatedAgencyGoalsAllOf
 */
export interface PaginatedAgencyGoalsAllOf {
    /**
     * 
     * @type {Array<AgencyGoal>}
     * @memberof PaginatedAgencyGoalsAllOf
     */
    'data': Array<AgencyGoal>;
}
/**
 * 
 * @export
 * @interface PaginatedCompanies
 */
export interface PaginatedCompanies {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedCompanies
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedCompanies
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedCompanies
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedCompanies
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedCompanies
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedCompanies
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedCompanies
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedCompanies
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedCompanies
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedCompanies
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedCompanies
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedCompanies
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<Company>}
     * @memberof PaginatedCompanies
     */
    'data': Array<Company>;
}
/**
 * 
 * @export
 * @interface PaginatedCompaniesAllOf
 */
export interface PaginatedCompaniesAllOf {
    /**
     * 
     * @type {Array<Company>}
     * @memberof PaginatedCompaniesAllOf
     */
    'data': Array<Company>;
}
/**
 * 
 * @export
 * @interface PaginatedFiles
 */
export interface PaginatedFiles {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedFiles
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedFiles
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedFiles
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedFiles
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedFiles
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedFiles
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedFiles
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedFiles
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedFiles
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedFiles
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedFiles
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedFiles
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<FileModel>}
     * @memberof PaginatedFiles
     */
    'data': Array<FileModel>;
    /**
     * 
     * @type {PaginatedFilesAllOfFilters}
     * @memberof PaginatedFiles
     */
    'filters'?: PaginatedFilesAllOfFilters;
}
/**
 * 
 * @export
 * @interface PaginatedFilesAllOf
 */
export interface PaginatedFilesAllOf {
    /**
     * 
     * @type {Array<FileModel>}
     * @memberof PaginatedFilesAllOf
     */
    'data': Array<FileModel>;
    /**
     * 
     * @type {PaginatedFilesAllOfFilters}
     * @memberof PaginatedFilesAllOf
     */
    'filters'?: PaginatedFilesAllOfFilters;
}
/**
 * 
 * @export
 * @interface PaginatedFilesAllOfFilters
 */
export interface PaginatedFilesAllOfFilters {
    /**
     * 
     * @type {PaginatedFilesAllOfFiltersVisibility}
     * @memberof PaginatedFilesAllOfFilters
     */
    'visibility': PaginatedFilesAllOfFiltersVisibility;
}
/**
 * 
 * @export
 * @interface PaginatedFilesAllOfFiltersVisibility
 */
export interface PaginatedFilesAllOfFiltersVisibility {
    /**
     * 
     * @type {number}
     * @memberof PaginatedFilesAllOfFiltersVisibility
     */
    'hidden': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedFilesAllOfFiltersVisibility
     */
    'public': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedFilesAllOfFiltersVisibility
     */
    'company': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedFilesAllOfFiltersVisibility
     */
    'location': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedFilesAllOfFiltersVisibility
     */
    'private': number;
}
/**
 * 
 * @export
 * @interface PaginatedIntroductions
 */
export interface PaginatedIntroductions {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedIntroductions
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedIntroductions
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedIntroductions
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedIntroductions
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedIntroductions
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedIntroductions
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedIntroductions
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedIntroductions
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedIntroductions
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedIntroductions
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedIntroductions
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedIntroductions
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<Introduction>}
     * @memberof PaginatedIntroductions
     */
    'data': Array<Introduction>;
    /**
     * 
     * @type {PaginatedIntroductionsAllOfFilters}
     * @memberof PaginatedIntroductions
     */
    'filters'?: PaginatedIntroductionsAllOfFilters;
}
/**
 * 
 * @export
 * @interface PaginatedIntroductionsAllOf
 */
export interface PaginatedIntroductionsAllOf {
    /**
     * 
     * @type {Array<Introduction>}
     * @memberof PaginatedIntroductionsAllOf
     */
    'data': Array<Introduction>;
    /**
     * 
     * @type {PaginatedIntroductionsAllOfFilters}
     * @memberof PaginatedIntroductionsAllOf
     */
    'filters'?: PaginatedIntroductionsAllOfFilters;
}
/**
 * 
 * @export
 * @interface PaginatedIntroductionsAllOfFilters
 */
export interface PaginatedIntroductionsAllOfFilters {
    /**
     * 
     * @type {PaginatedIntroductionsAllOfFiltersStatus}
     * @memberof PaginatedIntroductionsAllOfFilters
     */
    'status': PaginatedIntroductionsAllOfFiltersStatus;
}
/**
 * 
 * @export
 * @interface PaginatedIntroductionsAllOfFiltersStatus
 */
export interface PaginatedIntroductionsAllOfFiltersStatus {
    /**
     * 
     * @type {number}
     * @memberof PaginatedIntroductionsAllOfFiltersStatus
     */
    'active': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedIntroductionsAllOfFiltersStatus
     */
    'inactive': number;
}
/**
 * 
 * @export
 * @interface PaginatedLocations
 */
export interface PaginatedLocations {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedLocations
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedLocations
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedLocations
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedLocations
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedLocations
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedLocations
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedLocations
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedLocations
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedLocations
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedLocations
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedLocations
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedLocations
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<Location>}
     * @memberof PaginatedLocations
     */
    'data': Array<Location>;
}
/**
 * 
 * @export
 * @interface PaginatedLocationsAllOf
 */
export interface PaginatedLocationsAllOf {
    /**
     * 
     * @type {Array<Location>}
     * @memberof PaginatedLocationsAllOf
     */
    'data': Array<Location>;
}
/**
 * 
 * @export
 * @interface PaginatedOrderEvents
 */
export interface PaginatedOrderEvents {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedOrderEvents
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedOrderEvents
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedOrderEvents
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedOrderEvents
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedOrderEvents
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedOrderEvents
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedOrderEvents
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedOrderEvents
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedOrderEvents
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedOrderEvents
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedOrderEvents
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedOrderEvents
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<OrderEvent>}
     * @memberof PaginatedOrderEvents
     */
    'data': Array<OrderEvent>;
}
/**
 * 
 * @export
 * @interface PaginatedOrderEventsAllOf
 */
export interface PaginatedOrderEventsAllOf {
    /**
     * 
     * @type {Array<OrderEvent>}
     * @memberof PaginatedOrderEventsAllOf
     */
    'data': Array<OrderEvent>;
}
/**
 * 
 * @export
 * @interface PaginatedOrders
 */
export interface PaginatedOrders {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedOrders
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedOrders
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedOrders
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedOrders
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedOrders
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedOrders
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedOrders
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedOrders
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedOrders
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedOrders
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedOrders
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedOrders
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {PaginatedOrdersAllOfFilters}
     * @memberof PaginatedOrders
     */
    'filters': PaginatedOrdersAllOfFilters;
    /**
     * 
     * @type {Array<Order>}
     * @memberof PaginatedOrders
     */
    'data': Array<Order>;
}
/**
 * 
 * @export
 * @interface PaginatedOrdersAllOf
 */
export interface PaginatedOrdersAllOf {
    /**
     * 
     * @type {PaginatedOrdersAllOfFilters}
     * @memberof PaginatedOrdersAllOf
     */
    'filters': PaginatedOrdersAllOfFilters;
    /**
     * 
     * @type {Array<Order>}
     * @memberof PaginatedOrdersAllOf
     */
    'data': Array<Order>;
}
/**
 * This returns an object of filter metadata, that can be displayed on paginated listings
 * @export
 * @interface PaginatedOrdersAllOfFilters
 */
export interface PaginatedOrdersAllOfFilters {
    /**
     * 
     * @type {PaginatedOrdersAllOfFiltersStatus}
     * @memberof PaginatedOrdersAllOfFilters
     */
    'status'?: PaginatedOrdersAllOfFiltersStatus;
}
/**
 * A list of statuses with the count of the number of items that will be returned
 * @export
 * @interface PaginatedOrdersAllOfFiltersStatus
 */
export interface PaginatedOrdersAllOfFiltersStatus {
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrdersAllOfFiltersStatus
     */
    'open'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrdersAllOfFiltersStatus
     */
    'closed'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrdersAllOfFiltersStatus
     */
    'shipped'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrdersAllOfFiltersStatus
     */
    'canceled'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrdersAllOfFiltersStatus
     */
    'change_requested'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrdersAllOfFiltersStatus
     */
    'changed'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrdersAllOfFiltersStatus
     */
    'return_requested'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrdersAllOfFiltersStatus
     */
    'returned'?: number;
}
/**
 * 
 * @export
 * @interface PaginatedPriceSheets
 */
export interface PaginatedPriceSheets {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedPriceSheets
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedPriceSheets
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedPriceSheets
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedPriceSheets
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedPriceSheets
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedPriceSheets
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedPriceSheets
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedPriceSheets
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedPriceSheets
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedPriceSheets
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedPriceSheets
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedPriceSheets
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<PriceSheet>}
     * @memberof PaginatedPriceSheets
     */
    'data': Array<PriceSheet>;
}
/**
 * 
 * @export
 * @interface PaginatedPriceSheetsAllOf
 */
export interface PaginatedPriceSheetsAllOf {
    /**
     * 
     * @type {Array<PriceSheet>}
     * @memberof PaginatedPriceSheetsAllOf
     */
    'data': Array<PriceSheet>;
}
/**
 * 
 * @export
 * @interface PaginatedProducts
 */
export interface PaginatedProducts {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedProducts
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedProducts
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedProducts
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedProducts
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedProducts
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedProducts
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedProducts
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedProducts
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedProducts
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedProducts
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedProducts
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedProducts
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<Product>}
     * @memberof PaginatedProducts
     */
    'data': Array<Product>;
    /**
     * 
     * @type {PaginatedProductsAllOfFilters}
     * @memberof PaginatedProducts
     */
    'filters': PaginatedProductsAllOfFilters;
}
/**
 * 
 * @export
 * @interface PaginatedProductsAllOf
 */
export interface PaginatedProductsAllOf {
    /**
     * 
     * @type {Array<Product>}
     * @memberof PaginatedProductsAllOf
     */
    'data': Array<Product>;
    /**
     * 
     * @type {PaginatedProductsAllOfFilters}
     * @memberof PaginatedProductsAllOf
     */
    'filters': PaginatedProductsAllOfFilters;
}
/**
 * This returns an object of filter metadata, that can be displayed on paginated listings
 * @export
 * @interface PaginatedProductsAllOfFilters
 */
export interface PaginatedProductsAllOfFilters {
    /**
     * A list of tiers with counts
     * @type {{ [key: string]: number; }}
     * @memberof PaginatedProductsAllOfFilters
     */
    'tiers': { [key: string]: number; };
    /**
     * A list of categories with counts
     * @type {{ [key: string]: number; }}
     * @memberof PaginatedProductsAllOfFilters
     */
    'categories': { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface PaginatedProjects
 */
export interface PaginatedProjects {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedProjects
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedProjects
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedProjects
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedProjects
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedProjects
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedProjects
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedProjects
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedProjects
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedProjects
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedProjects
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedProjects
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedProjects
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<Project>}
     * @memberof PaginatedProjects
     */
    'data': Array<Project>;
    /**
     * 
     * @type {PaginatedProjectsAllOfFilters}
     * @memberof PaginatedProjects
     */
    'filters': PaginatedProjectsAllOfFilters;
}
/**
 * 
 * @export
 * @interface PaginatedProjectsAllOf
 */
export interface PaginatedProjectsAllOf {
    /**
     * 
     * @type {Array<Project>}
     * @memberof PaginatedProjectsAllOf
     */
    'data': Array<Project>;
    /**
     * 
     * @type {PaginatedProjectsAllOfFilters}
     * @memberof PaginatedProjectsAllOf
     */
    'filters': PaginatedProjectsAllOfFilters;
}
/**
 * 
 * @export
 * @interface PaginatedProjectsAllOfFilters
 */
export interface PaginatedProjectsAllOfFilters {
    /**
     * 
     * @type {PaginatedProjectsAllOfFiltersStatus}
     * @memberof PaginatedProjectsAllOfFilters
     */
    'status': PaginatedProjectsAllOfFiltersStatus;
}
/**
 * 
 * @export
 * @interface PaginatedProjectsAllOfFiltersStatus
 */
export interface PaginatedProjectsAllOfFiltersStatus {
    /**
     * 
     * @type {number}
     * @memberof PaginatedProjectsAllOfFiltersStatus
     */
    'published': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedProjectsAllOfFiltersStatus
     */
    'draft': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedProjectsAllOfFiltersStatus
     */
    'disabled': number;
}
/**
 * 
 * @export
 * @interface PaginatedQuotes
 */
export interface PaginatedQuotes {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedQuotes
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedQuotes
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedQuotes
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedQuotes
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedQuotes
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedQuotes
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedQuotes
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedQuotes
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedQuotes
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedQuotes
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedQuotes
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedQuotes
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<Quote>}
     * @memberof PaginatedQuotes
     */
    'data': Array<Quote>;
}
/**
 * 
 * @export
 * @interface PaginatedQuotesAllOf
 */
export interface PaginatedQuotesAllOf {
    /**
     * 
     * @type {Array<Quote>}
     * @memberof PaginatedQuotesAllOf
     */
    'data': Array<Quote>;
}
/**
 * 
 * @export
 * @interface PaginatedReports
 */
export interface PaginatedReports {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedReports
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedReports
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedReports
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedReports
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedReports
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedReports
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedReports
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedReports
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedReports
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedReports
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedReports
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedReports
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<Report>}
     * @memberof PaginatedReports
     */
    'data': Array<Report>;
}
/**
 * 
 * @export
 * @interface PaginatedReportsAllOf
 */
export interface PaginatedReportsAllOf {
    /**
     * 
     * @type {Array<Report>}
     * @memberof PaginatedReportsAllOf
     */
    'data': Array<Report>;
}
/**
 * 
 * @export
 * @interface PaginatedResources
 */
export interface PaginatedResources {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedResources
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedResources
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedResources
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedResources
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedResources
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedResources
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedResources
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedResources
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedResources
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedResources
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedResources
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedResources
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<Resource>}
     * @memberof PaginatedResources
     */
    'data': Array<Resource>;
    /**
     * 
     * @type {PaginatedIntroductionsAllOfFilters}
     * @memberof PaginatedResources
     */
    'filters'?: PaginatedIntroductionsAllOfFilters;
}
/**
 * 
 * @export
 * @interface PaginatedResourcesAllOf
 */
export interface PaginatedResourcesAllOf {
    /**
     * 
     * @type {Array<Resource>}
     * @memberof PaginatedResourcesAllOf
     */
    'data': Array<Resource>;
    /**
     * 
     * @type {PaginatedIntroductionsAllOfFilters}
     * @memberof PaginatedResourcesAllOf
     */
    'filters'?: PaginatedIntroductionsAllOfFilters;
}
/**
 * 
 * @export
 * @interface PaginatedSalesReps
 */
export interface PaginatedSalesReps {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedSalesReps
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedSalesReps
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedSalesReps
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedSalesReps
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedSalesReps
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedSalesReps
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedSalesReps
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedSalesReps
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedSalesReps
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedSalesReps
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedSalesReps
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedSalesReps
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<SalesRep>}
     * @memberof PaginatedSalesReps
     */
    'data': Array<SalesRep>;
}
/**
 * 
 * @export
 * @interface PaginatedSalesRepsAllOf
 */
export interface PaginatedSalesRepsAllOf {
    /**
     * 
     * @type {Array<SalesRep>}
     * @memberof PaginatedSalesRepsAllOf
     */
    'data': Array<SalesRep>;
}
/**
 * 
 * @export
 * @interface PaginatedSalesforceCustomers
 */
export interface PaginatedSalesforceCustomers {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedSalesforceCustomers
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedSalesforceCustomers
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedSalesforceCustomers
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedSalesforceCustomers
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedSalesforceCustomers
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedSalesforceCustomers
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedSalesforceCustomers
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedSalesforceCustomers
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedSalesforceCustomers
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedSalesforceCustomers
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedSalesforceCustomers
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedSalesforceCustomers
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<SalesforceCustomer>}
     * @memberof PaginatedSalesforceCustomers
     */
    'data': Array<SalesforceCustomer>;
}
/**
 * 
 * @export
 * @interface PaginatedSalesforceCustomersAllOf
 */
export interface PaginatedSalesforceCustomersAllOf {
    /**
     * 
     * @type {Array<SalesforceCustomer>}
     * @memberof PaginatedSalesforceCustomersAllOf
     */
    'data': Array<SalesforceCustomer>;
}
/**
 * 
 * @export
 * @interface PaginatedSalesforceOpportunities
 */
export interface PaginatedSalesforceOpportunities {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedSalesforceOpportunities
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedSalesforceOpportunities
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedSalesforceOpportunities
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedSalesforceOpportunities
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedSalesforceOpportunities
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedSalesforceOpportunities
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedSalesforceOpportunities
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedSalesforceOpportunities
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedSalesforceOpportunities
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedSalesforceOpportunities
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedSalesforceOpportunities
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedSalesforceOpportunities
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<SalesforceOpportunity>}
     * @memberof PaginatedSalesforceOpportunities
     */
    'data': Array<SalesforceOpportunity>;
}
/**
 * 
 * @export
 * @interface PaginatedSalesforceOpportunitiesAllOf
 */
export interface PaginatedSalesforceOpportunitiesAllOf {
    /**
     * 
     * @type {Array<SalesforceOpportunity>}
     * @memberof PaginatedSalesforceOpportunitiesAllOf
     */
    'data': Array<SalesforceOpportunity>;
}
/**
 * 
 * @export
 * @interface PaginatedScormScoTracking
 */
export interface PaginatedScormScoTracking {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedScormScoTracking
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedScormScoTracking
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedScormScoTracking
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedScormScoTracking
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedScormScoTracking
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedScormScoTracking
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedScormScoTracking
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedScormScoTracking
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedScormScoTracking
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedScormScoTracking
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedScormScoTracking
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedScormScoTracking
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<ScormScoTracking>}
     * @memberof PaginatedScormScoTracking
     */
    'data': Array<ScormScoTracking>;
}
/**
 * 
 * @export
 * @interface PaginatedScormScoTrackingAllOf
 */
export interface PaginatedScormScoTrackingAllOf {
    /**
     * 
     * @type {Array<ScormScoTracking>}
     * @memberof PaginatedScormScoTrackingAllOf
     */
    'data': Array<ScormScoTracking>;
}
/**
 * 
 * @export
 * @interface PaginatedScorms
 */
export interface PaginatedScorms {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedScorms
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedScorms
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedScorms
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedScorms
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedScorms
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedScorms
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedScorms
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedScorms
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedScorms
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedScorms
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedScorms
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedScorms
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<Scorm>}
     * @memberof PaginatedScorms
     */
    'data': Array<Scorm>;
}
/**
 * 
 * @export
 * @interface PaginatedScormsAllOf
 */
export interface PaginatedScormsAllOf {
    /**
     * 
     * @type {Array<Scorm>}
     * @memberof PaginatedScormsAllOf
     */
    'data': Array<Scorm>;
}
/**
 * 
 * @export
 * @interface PaginatedTaxonomyTerm
 */
export interface PaginatedTaxonomyTerm {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedTaxonomyTerm
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedTaxonomyTerm
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedTaxonomyTerm
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedTaxonomyTerm
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedTaxonomyTerm
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedTaxonomyTerm
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedTaxonomyTerm
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedTaxonomyTerm
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedTaxonomyTerm
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedTaxonomyTerm
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedTaxonomyTerm
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedTaxonomyTerm
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<TaxonomyTermConnect>}
     * @memberof PaginatedTaxonomyTerm
     */
    'data': Array<TaxonomyTermConnect>;
}
/**
 * 
 * @export
 * @interface PaginatedTaxonomyTermAllOf
 */
export interface PaginatedTaxonomyTermAllOf {
    /**
     * 
     * @type {Array<TaxonomyTermConnect>}
     * @memberof PaginatedTaxonomyTermAllOf
     */
    'data': Array<TaxonomyTermConnect>;
}
/**
 * 
 * @export
 * @interface PaginatedTempControlProjects
 */
export interface PaginatedTempControlProjects {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedTempControlProjects
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedTempControlProjects
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedTempControlProjects
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedTempControlProjects
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedTempControlProjects
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedTempControlProjects
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedTempControlProjects
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedTempControlProjects
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedTempControlProjects
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedTempControlProjects
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedTempControlProjects
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedTempControlProjects
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<TempControlProject>}
     * @memberof PaginatedTempControlProjects
     */
    'data': Array<TempControlProject>;
}
/**
 * 
 * @export
 * @interface PaginatedTempControlProjectsAllOf
 */
export interface PaginatedTempControlProjectsAllOf {
    /**
     * 
     * @type {Array<TempControlProject>}
     * @memberof PaginatedTempControlProjectsAllOf
     */
    'data': Array<TempControlProject>;
}
/**
 * 
 * @export
 * @interface PaginatedUsers
 */
export interface PaginatedUsers {
    /**
     * Total results counter
     * @type {number}
     * @memberof PaginatedUsers
     */
    'total': number;
    /**
     * Results per page
     * @type {number}
     * @memberof PaginatedUsers
     */
    'per_page': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedUsers
     */
    'current_page': number;
    /**
     * Last page number
     * @type {number}
     * @memberof PaginatedUsers
     */
    'last_page': number;
    /**
     * Direct link to first page
     * @type {string}
     * @memberof PaginatedUsers
     */
    'first_page_url': string;
    /**
     * Direct link to last page
     * @type {string}
     * @memberof PaginatedUsers
     */
    'last_page_url': string;
    /**
     * Direct link to next page
     * @type {string}
     * @memberof PaginatedUsers
     */
    'next_page_url': string | null;
    /**
     * Direct link to previous page
     * @type {string}
     * @memberof PaginatedUsers
     */
    'prev_page_url': string | null;
    /**
     * Base path
     * @type {string}
     * @memberof PaginatedUsers
     */
    'path': string;
    /**
     * Result number start
     * @type {number}
     * @memberof PaginatedUsers
     */
    'from': number | null;
    /**
     * Result number end
     * @type {number}
     * @memberof PaginatedUsers
     */
    'to': number | null;
    /**
     * 
     * @type {Array<PaginationPageLink>}
     * @memberof PaginatedUsers
     */
    'links': Array<PaginationPageLink>;
    /**
     * 
     * @type {Array<User>}
     * @memberof PaginatedUsers
     */
    'data': Array<User>;
}
/**
 * 
 * @export
 * @interface PaginatedUsersAllOf
 */
export interface PaginatedUsersAllOf {
    /**
     * 
     * @type {Array<User>}
     * @memberof PaginatedUsersAllOf
     */
    'data': Array<User>;
}
/**
 * 
 * @export
 * @interface PaginationPageLink
 */
export interface PaginationPageLink {
    /**
     * The url to the page link
     * @type {string}
     * @memberof PaginationPageLink
     */
    'url': string | null;
    /**
     * A label you can show on the page link
     * @type {string}
     * @memberof PaginationPageLink
     */
    'label': string;
    /**
     * Is this the current page
     * @type {boolean}
     * @memberof PaginationPageLink
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface PasswordUpdate
 */
export interface PasswordUpdate {
    /**
     * If a user can change a password (either the user itself or an admin) and this field is set, this will update the password
     * @type {string}
     * @memberof PasswordUpdate
     */
    'password': string;
    /**
     * This field must be present, match the password, and the above rules must validate for a password reset
     * @type {string}
     * @memberof PasswordUpdate
     */
    'password_confirmation': string;
}
/**
 * 
 * @export
 * @interface PendingQuote
 */
export interface PendingQuote {
    /**
     * 
     * @type {number}
     * @memberof PendingQuote
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PendingQuote
     */
    'status': PendingQuoteStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PendingQuote
     */
    'project_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingQuote
     */
    'location_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingQuote
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingQuote
     */
    'address2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingQuote
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingQuote
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingQuote
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingQuote
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingQuote
     */
    'state'?: string;
    /**
     * The company id of the customer location
     * @type {number}
     * @memberof PendingQuote
     */
    'company_id': number;
    /**
     * The location id of the customer location
     * @type {number}
     * @memberof PendingQuote
     */
    'location_id': number;
    /**
     * The user_id of the quote request
     * @type {number}
     * @memberof PendingQuote
     */
    'user_id': number;
    /**
     * The quote request body.  A free text field the user can use to make the quote request
     * @type {string}
     * @memberof PendingQuote
     */
    'message'?: string;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof PendingQuote
     */
    'company': CompanyRelation | null;
    /**
     * 
     * @type {LocationRelation}
     * @memberof PendingQuote
     */
    'location': LocationRelation | null;
    /**
     * The id of the order attached to this quote
     * @type {number}
     * @memberof PendingQuote
     */
    'order_id'?: number | null;
    /**
     * 
     * @type {Order}
     * @memberof PendingQuote
     */
    'order'?: Order | null;
    /**
     * 
     * @type {UserRelation}
     * @memberof PendingQuote
     */
    'user': UserRelation | null;
    /**
     * 
     * @type {Array<FileRelation>}
     * @memberof PendingQuote
     */
    'files': Array<FileRelation>;
    /**
     * 
     * @type {Array<ProductRelationWithQuotePivotData>}
     * @memberof PendingQuote
     */
    'products': Array<ProductRelationWithQuotePivotData>;
    /**
     * 
     * @type {Array<Response>}
     * @memberof PendingQuote
     */
    'responses'?: Array<Response>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof PendingQuote
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof PendingQuote
     */
    'updated_at': string;
}

export const PendingQuoteStatusEnum = {
    Deleted: 'deleted',
    Pending: 'pending'
} as const;

export type PendingQuoteStatusEnum = typeof PendingQuoteStatusEnum[keyof typeof PendingQuoteStatusEnum];

/**
 * 
 * @export
 * @interface PendingUser
 */
export interface PendingUser {
    /**
     * 
     * @type {number}
     * @memberof PendingUser
     */
    'id': number;
    /**
     * Is the user\'s company an wholesaler
     * @type {boolean}
     * @memberof PendingUser
     */
    'wholesaler'?: boolean;
    /**
     * Is the user\'s company an evolution owner
     * @type {boolean}
     * @memberof PendingUser
     */
    'evolution'?: boolean;
    /**
     * Can the user buy direct via the quote interface
     * @type {boolean}
     * @memberof PendingUser
     */
    'direct_buyer'?: boolean;
    /**
     * The company id
     * @type {number}
     * @memberof PendingUser
     */
    'company_id': number;
    /**
     * The location id
     * @type {number}
     * @memberof PendingUser
     */
    'location_id': number;
    /**
     * The agency id
     * @type {number}
     * @memberof PendingUser
     */
    'agency_id': number;
    /**
     * Whether this user has access to all territories
     * @type {boolean}
     * @memberof PendingUser
     */
    'all_territories'?: boolean;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof PendingUser
     */
    'first_name': string | null;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof PendingUser
     */
    'last_name': string | null;
    /**
     * 
     * @type {FileAvatarRelation}
     * @memberof PendingUser
     */
    'image': FileAvatarRelation | null;
    /**
     * 
     * @type {PendingQuote}
     * @memberof PendingUser
     */
    'pending_quote'?: PendingQuote | null;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof PendingUser
     */
    'email': string;
    /**
     * The phone number of the user
     * @type {string}
     * @memberof PendingUser
     */
    'phone'?: string | null;
    /**
     * 
     * @type {UserSharedPermissions}
     * @memberof PendingUser
     */
    'permissions': UserSharedPermissions;
    /**
     * The last login date
     * @type {string}
     * @memberof PendingUser
     */
    'last_login': string | null;
    /**
     * 
     * @type {number}
     * @memberof PendingUser
     */
    'login_count': number;
    /**
     * The last login date
     * @type {string}
     * @memberof PendingUser
     */
    'last_access': string | null;
    /**
     * 
     * @type {number}
     * @memberof PendingUser
     */
    'access_count': number;
    /**
     * 
     * @type {string}
     * @memberof PendingUser
     */
    'email_verified_at': string | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof PendingUser
     */
    'created_at': string;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof PendingUser
     */
    'updated_at': string;
    /**
     * Whether the user has enabled 2FA
     * @type {boolean}
     * @memberof PendingUser
     */
    'google2fa_enabled'?: boolean;
    /**
     * 
     * @type {PendingUserStatus}
     * @memberof PendingUser
     */
    'status': PendingUserStatus;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof PendingUser
     */
    'company': CompanyRelation | null;
    /**
     * 
     * @type {LocationRelation}
     * @memberof PendingUser
     */
    'location': LocationRelation | null;
    /**
     * 
     * @type {string}
     * @memberof PendingUser
     */
    'role': PendingUserRoleEnum;
    /**
     * Is this user managed by a representative?
     * @type {boolean}
     * @memberof PendingUser
     */
    'rep_managed'?: boolean;
}

export const PendingUserRoleEnum = {
    User: 'user'
} as const;

export type PendingUserRoleEnum = typeof PendingUserRoleEnum[keyof typeof PendingUserRoleEnum];

/**
 * 
 * @export
 * @interface PendingUserAllOf
 */
export interface PendingUserAllOf {
    /**
     * 
     * @type {PendingUserStatus}
     * @memberof PendingUserAllOf
     */
    'status': PendingUserStatus;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof PendingUserAllOf
     */
    'company': CompanyRelation | null;
    /**
     * 
     * @type {LocationRelation}
     * @memberof PendingUserAllOf
     */
    'location': LocationRelation | null;
    /**
     * 
     * @type {string}
     * @memberof PendingUserAllOf
     */
    'role': PendingUserAllOfRoleEnum;
    /**
     * Is this user managed by a representative?
     * @type {boolean}
     * @memberof PendingUserAllOf
     */
    'rep_managed'?: boolean;
}

export const PendingUserAllOfRoleEnum = {
    User: 'user'
} as const;

export type PendingUserAllOfRoleEnum = typeof PendingUserAllOfRoleEnum[keyof typeof PendingUserAllOfRoleEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const PendingUserStatus = {
    Pending: 'pending'
} as const;

export type PendingUserStatus = typeof PendingUserStatus[keyof typeof PendingUserStatus];


/**
 * Any user with a location can request a price sheet.  These price sheets are generated async and the admin is then emailed when the price sheet is complete. 
 * @export
 * @interface PriceSheet
 */
export interface PriceSheet {
    /**
     * Price Sheet id
     * @type {number}
     * @memberof PriceSheet
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PriceSheet
     */
    'location_id': number;
    /**
     * 
     * @type {ReportStatus}
     * @memberof PriceSheet
     */
    'status': ReportStatus;
    /**
     * 
     * @type {number}
     * @memberof PriceSheet
     */
    'user_id': number;
    /**
     * 
     * @type {UserRelation}
     * @memberof PriceSheet
     */
    'user'?: UserRelation;
    /**
     * A link to the generated price sheet that a qualified user can use to download the price sheet
     * @type {string}
     * @memberof PriceSheet
     */
    'url': string;
    /**
     * the date the record was created
     * @type {string}
     * @memberof PriceSheet
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof PriceSheet
     */
    'updated_at': string;
}
/**
 * Is the pricesheet running, completed or failed?
 * @export
 * @enum {string}
 */

export const PriceSheetStatus = {
    Requested: 'requested',
    Processing: 'processing',
    Complete: 'complete',
    Failed: 'failed'
} as const;

export type PriceSheetStatus = typeof PriceSheetStatus[keyof typeof PriceSheetStatus];


/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'price'?: number | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof Product
     */
    'main_image'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof Product
     */
    'installation_guide'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof Product
     */
    'spec_sheet'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof Product
     */
    'non_featured_images'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof Product
     */
    'a_and_d'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof Product
     */
    '3d_cad_file_rfa'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof Product
     */
    'product_sheet'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof Product
     */
    'product_brochure'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof Product
     */
    'warranty'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof Product
     */
    'parts_diagram'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof Product
     */
    'case_study'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'features'?: Array<string> | null;
    /**
     * 
     * @type {Array<TaxonomyTermRelationship>}
     * @memberof Product
     */
    'categories'?: Array<TaxonomyTermRelationship> | null;
    /**
     * 
     * @type {Array<TaxonomyTermRelationship>}
     * @memberof Product
     */
    'finishes'?: Array<TaxonomyTermRelationship> | null;
    /**
     * 
     * @type {Array<TaxonomyTermRelationship>}
     * @memberof Product
     */
    'tiers'?: Array<TaxonomyTermRelationship> | null;
    /**
     * 
     * @type {Array<TaxonomyTermRelationship>}
     * @memberof Product
     */
    'types'?: Array<TaxonomyTermRelationship> | null;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'obsolete'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'modified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'us_price'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'ca_price'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'ready_for_website'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'ada_compliant'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'assist_products'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'buy_american_act'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'watersense_certified'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'california_compliant'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'shipping_weight'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'lead_free'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'csa_cert'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'upc_cert'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'updated_at'?: string | null;
}
/**
 * 
 * @export
 * @interface ProductBlock
 */
export interface ProductBlock {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof ProductBlock
     */
    'id': number;
    /**
     * 
     * @type {ProductBlockType}
     * @memberof ProductBlock
     */
    'type': ProductBlockType;
    /**
     * 
     * @type {Product}
     * @memberof ProductBlock
     */
    'content': Product | null;
    /**
     * 
     * @type {ProductBlockSettings}
     * @memberof ProductBlock
     */
    'settings': ProductBlockSettings;
}
/**
 * 
 * @export
 * @interface ProductBlockAllOf
 */
export interface ProductBlockAllOf {
    /**
     * 
     * @type {ProductBlockType}
     * @memberof ProductBlockAllOf
     */
    'type': ProductBlockType;
    /**
     * 
     * @type {Product}
     * @memberof ProductBlockAllOf
     */
    'content': Product | null;
    /**
     * 
     * @type {ProductBlockSettings}
     * @memberof ProductBlockAllOf
     */
    'settings': ProductBlockSettings;
}
/**
 * 
 * @export
 * @interface ProductBlockSettings
 */
export interface ProductBlockSettings {
    /**
     * A sku to show.  If no sku is provided, the default sku will be used. If this is a fully custom product, and no sku is provided, a default text string will be used
     * @type {string}
     * @memberof ProductBlockSettings
     */
    'sku'?: string;
    /**
     * A title that can be stored with the product
     * @type {string}
     * @memberof ProductBlockSettings
     */
    'title'?: string;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof ProductBlockSettings
     */
    'image_settings'?: CropImageSettings;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettings
     */
    'show_features': PropertyVisibility;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBlockSettings
     */
    'features': Array<string>;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettings
     */
    'show_finishes': PropertyVisibility;
    /**
     * 
     * @type {Array<TaxonomyTermConnect>}
     * @memberof ProductBlockSettings
     */
    'finishes': Array<TaxonomyTermConnect>;
    /**
     * selected finish term
     * @type {string}
     * @memberof ProductBlockSettings
     */
    'selected_finish'?: string | null;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettings
     */
    'show_documents': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettings
     */
    'show_info': PropertyVisibility;
    /**
     * A markdown text field for holding a general info.  Defaults to empty
     * @type {string}
     * @memberof ProductBlockSettings
     */
    'heading'?: string;
    /**
     * A markdown text field for holding a general info.  Defaults to empty
     * @type {string}
     * @memberof ProductBlockSettings
     */
    'notes'?: string;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettings
     */
    'show_pricing': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettings
     */
    'show_no_of_units': PropertyVisibility;
    /**
     * Number of units included
     * @type {number}
     * @memberof ProductBlockSettings
     */
    'no_of_units': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettings
     */
    'show_list_price': PropertyVisibility;
    /**
     * List price of the unit
     * @type {number}
     * @memberof ProductBlockSettings
     */
    'list_price': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettings
     */
    'show_net_price': PropertyVisibility;
    /**
     * Net price of the unit
     * @type {number}
     * @memberof ProductBlockSettings
     */
    'net_price': number;
    /**
     * What is the label that should be used for the net price
     * @type {string}
     * @memberof ProductBlockSettings
     */
    'net_price_label': string;
    /**
     * How much should we multiply the price by to get the sale price
     * @type {number}
     * @memberof ProductBlockSettings
     */
    'multiplier': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettings
     */
    'show_ext_price': PropertyVisibility;
    /**
     * Extended price (net_price * multiplier)
     * @type {number}
     * @memberof ProductBlockSettings
     */
    'ext_price': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettings
     */
    'show_special_attributes'?: PropertyVisibility;
    /**
     * 
     * @type {FileImageRelation}
     * @memberof ProductBlockSettings
     */
    'main_image'?: FileImageRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettings
     */
    'product_sheet'?: FileRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettings
     */
    'customer_service'?: FileRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettings
     */
    'warranty'?: FileRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettings
     */
    'installation_guide'?: FileRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettings
     */
    'spec_sheet'?: FileRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettings
     */
    'parts_diagram'?: FileRelation | null;
}
/**
 * The settings that can be stored with an product block.
 * @export
 * @interface ProductBlockSettingsAllOf
 */
export interface ProductBlockSettingsAllOf {
    /**
     * 
     * @type {FileImageRelation}
     * @memberof ProductBlockSettingsAllOf
     */
    'main_image'?: FileImageRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettingsAllOf
     */
    'product_sheet'?: FileRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettingsAllOf
     */
    'customer_service'?: FileRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettingsAllOf
     */
    'warranty'?: FileRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettingsAllOf
     */
    'installation_guide'?: FileRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettingsAllOf
     */
    'spec_sheet'?: FileRelation | null;
    /**
     * 
     * @type {FileRelation}
     * @memberof ProductBlockSettingsAllOf
     */
    'parts_diagram'?: FileRelation | null;
}
/**
 * 
 * @export
 * @interface ProductBlockSettingsShared
 */
export interface ProductBlockSettingsShared {
    /**
     * A sku to show.  If no sku is provided, the default sku will be used. If this is a fully custom product, and no sku is provided, a default text string will be used
     * @type {string}
     * @memberof ProductBlockSettingsShared
     */
    'sku'?: string;
    /**
     * A title that can be stored with the product
     * @type {string}
     * @memberof ProductBlockSettingsShared
     */
    'title'?: string;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof ProductBlockSettingsShared
     */
    'image_settings'?: CropImageSettings;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsShared
     */
    'show_features': PropertyVisibility;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBlockSettingsShared
     */
    'features': Array<string>;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsShared
     */
    'show_finishes': PropertyVisibility;
    /**
     * 
     * @type {Array<TaxonomyTermConnect>}
     * @memberof ProductBlockSettingsShared
     */
    'finishes': Array<TaxonomyTermConnect>;
    /**
     * selected finish term
     * @type {string}
     * @memberof ProductBlockSettingsShared
     */
    'selected_finish'?: string | null;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsShared
     */
    'show_documents': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsShared
     */
    'show_info': PropertyVisibility;
    /**
     * A markdown text field for holding a general info.  Defaults to empty
     * @type {string}
     * @memberof ProductBlockSettingsShared
     */
    'heading'?: string;
    /**
     * A markdown text field for holding a general info.  Defaults to empty
     * @type {string}
     * @memberof ProductBlockSettingsShared
     */
    'notes'?: string;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsShared
     */
    'show_pricing': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsShared
     */
    'show_no_of_units': PropertyVisibility;
    /**
     * Number of units included
     * @type {number}
     * @memberof ProductBlockSettingsShared
     */
    'no_of_units': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsShared
     */
    'show_list_price': PropertyVisibility;
    /**
     * List price of the unit
     * @type {number}
     * @memberof ProductBlockSettingsShared
     */
    'list_price': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsShared
     */
    'show_net_price': PropertyVisibility;
    /**
     * Net price of the unit
     * @type {number}
     * @memberof ProductBlockSettingsShared
     */
    'net_price': number;
    /**
     * What is the label that should be used for the net price
     * @type {string}
     * @memberof ProductBlockSettingsShared
     */
    'net_price_label': string;
    /**
     * How much should we multiply the price by to get the sale price
     * @type {number}
     * @memberof ProductBlockSettingsShared
     */
    'multiplier': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsShared
     */
    'show_ext_price': PropertyVisibility;
    /**
     * Extended price (net_price * multiplier)
     * @type {number}
     * @memberof ProductBlockSettingsShared
     */
    'ext_price': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsShared
     */
    'show_special_attributes'?: PropertyVisibility;
}
/**
 * 
 * @export
 * @interface ProductBlockSettingsUpdate
 */
export interface ProductBlockSettingsUpdate {
    /**
     * A sku to show.  If no sku is provided, the default sku will be used. If this is a fully custom product, and no sku is provided, a default text string will be used
     * @type {string}
     * @memberof ProductBlockSettingsUpdate
     */
    'sku'?: string;
    /**
     * A title that can be stored with the product
     * @type {string}
     * @memberof ProductBlockSettingsUpdate
     */
    'title'?: string;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof ProductBlockSettingsUpdate
     */
    'image_settings'?: CropImageSettings;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsUpdate
     */
    'show_features': PropertyVisibility;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBlockSettingsUpdate
     */
    'features': Array<string>;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsUpdate
     */
    'show_finishes': PropertyVisibility;
    /**
     * 
     * @type {Array<TaxonomyTermConnect>}
     * @memberof ProductBlockSettingsUpdate
     */
    'finishes': Array<TaxonomyTermConnect>;
    /**
     * selected finish term
     * @type {string}
     * @memberof ProductBlockSettingsUpdate
     */
    'selected_finish'?: string | null;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsUpdate
     */
    'show_documents': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsUpdate
     */
    'show_info': PropertyVisibility;
    /**
     * A markdown text field for holding a general info.  Defaults to empty
     * @type {string}
     * @memberof ProductBlockSettingsUpdate
     */
    'heading'?: string;
    /**
     * A markdown text field for holding a general info.  Defaults to empty
     * @type {string}
     * @memberof ProductBlockSettingsUpdate
     */
    'notes'?: string;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsUpdate
     */
    'show_pricing': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsUpdate
     */
    'show_no_of_units': PropertyVisibility;
    /**
     * Number of units included
     * @type {number}
     * @memberof ProductBlockSettingsUpdate
     */
    'no_of_units': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsUpdate
     */
    'show_list_price': PropertyVisibility;
    /**
     * List price of the unit
     * @type {number}
     * @memberof ProductBlockSettingsUpdate
     */
    'list_price': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsUpdate
     */
    'show_net_price': PropertyVisibility;
    /**
     * Net price of the unit
     * @type {number}
     * @memberof ProductBlockSettingsUpdate
     */
    'net_price': number;
    /**
     * What is the label that should be used for the net price
     * @type {string}
     * @memberof ProductBlockSettingsUpdate
     */
    'net_price_label': string;
    /**
     * How much should we multiply the price by to get the sale price
     * @type {number}
     * @memberof ProductBlockSettingsUpdate
     */
    'multiplier': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsUpdate
     */
    'show_ext_price': PropertyVisibility;
    /**
     * Extended price (net_price * multiplier)
     * @type {number}
     * @memberof ProductBlockSettingsUpdate
     */
    'ext_price': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProductBlockSettingsUpdate
     */
    'show_special_attributes'?: PropertyVisibility;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdate
     */
    'main_image'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdate
     */
    'product_sheet'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdate
     */
    'customer_service'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdate
     */
    'warranty'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdate
     */
    'installation_guide'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdate
     */
    'spec_sheet'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdate
     */
    'parts_diagram'?: FileRelationUpdate | null;
}
/**
 * The settings that can be stored with an product block.
 * @export
 * @interface ProductBlockSettingsUpdateAllOf
 */
export interface ProductBlockSettingsUpdateAllOf {
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdateAllOf
     */
    'main_image'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdateAllOf
     */
    'product_sheet'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdateAllOf
     */
    'customer_service'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdateAllOf
     */
    'warranty'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdateAllOf
     */
    'installation_guide'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdateAllOf
     */
    'spec_sheet'?: FileRelationUpdate | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProductBlockSettingsUpdateAllOf
     */
    'parts_diagram'?: FileRelationUpdate | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProductBlockType = {
    Product: 'product'
} as const;

export type ProductBlockType = typeof ProductBlockType[keyof typeof ProductBlockType];


/**
 * 
 * @export
 * @interface ProductBlockUpdate
 */
export interface ProductBlockUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof ProductBlockUpdate
     */
    'id': number | null;
    /**
     * 
     * @type {ProductBlockType}
     * @memberof ProductBlockUpdate
     */
    'type': ProductBlockType;
    /**
     * 
     * @type {Product}
     * @memberof ProductBlockUpdate
     */
    'content': Product | null;
    /**
     * 
     * @type {ProductBlockSettingsUpdate}
     * @memberof ProductBlockUpdate
     */
    'settings': ProductBlockSettingsUpdate;
}
/**
 * 
 * @export
 * @interface ProductBlockUpdateAllOf
 */
export interface ProductBlockUpdateAllOf {
    /**
     * 
     * @type {ProductBlockType}
     * @memberof ProductBlockUpdateAllOf
     */
    'type': ProductBlockType;
    /**
     * 
     * @type {Product}
     * @memberof ProductBlockUpdateAllOf
     */
    'content': Product | null;
    /**
     * 
     * @type {ProductBlockSettingsUpdate}
     * @memberof ProductBlockUpdateAllOf
     */
    'settings': ProductBlockSettingsUpdate;
}
/**
 * 
 * @export
 * @interface ProductPage
 */
export interface ProductPage {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof ProductPage
     */
    'id': number;
    /**
     * The name of the page
     * @type {string}
     * @memberof ProductPage
     */
    'name': string;
    /**
     * 
     * @type {ProductPageType}
     * @memberof ProductPage
     */
    'type': ProductPageType;
    /**
     * 
     * @type {Array<ProductBlock>}
     * @memberof ProductPage
     */
    'blocks': Array<ProductBlock>;
}
/**
 * 
 * @export
 * @interface ProductPageAllOf
 */
export interface ProductPageAllOf {
    /**
     * 
     * @type {ProductPageType}
     * @memberof ProductPageAllOf
     */
    'type': ProductPageType;
    /**
     * 
     * @type {Array<ProductBlock>}
     * @memberof ProductPageAllOf
     */
    'blocks': Array<ProductBlock>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProductPageType = {
    Product: 'product'
} as const;

export type ProductPageType = typeof ProductPageType[keyof typeof ProductPageType];


/**
 * 
 * @export
 * @interface ProductPageUpdate
 */
export interface ProductPageUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof ProductPageUpdate
     */
    'id': number | null;
    /**
     * The name of the page
     * @type {string}
     * @memberof ProductPageUpdate
     */
    'name': string;
    /**
     * 
     * @type {ProductPageType}
     * @memberof ProductPageUpdate
     */
    'type': ProductPageType;
    /**
     * 
     * @type {Array<ProductBlockUpdate>}
     * @memberof ProductPageUpdate
     */
    'blocks': Array<ProductBlockUpdate>;
}
/**
 * 
 * @export
 * @interface ProductPageUpdateAllOf
 */
export interface ProductPageUpdateAllOf {
    /**
     * 
     * @type {ProductPageType}
     * @memberof ProductPageUpdateAllOf
     */
    'type': ProductPageType;
    /**
     * 
     * @type {Array<ProductBlockUpdate>}
     * @memberof ProductPageUpdateAllOf
     */
    'blocks': Array<ProductBlockUpdate>;
}
/**
 * 
 * @export
 * @interface ProductQuotePivot
 */
export interface ProductQuotePivot {
    /**
     * 
     * @type {number}
     * @memberof ProductQuotePivot
     */
    'quote_id': number;
    /**
     * 
     * @type {number}
     * @memberof ProductQuotePivot
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof ProductQuotePivot
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof ProductQuotePivot
     */
    'quoted_price'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductQuotePivot
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ProductQuotePivot
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface ProductRelation
 */
export interface ProductRelation {
    /**
     * 
     * @type {number}
     * @memberof ProductRelation
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ProductRelation
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof ProductRelation
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof ProductRelation
     */
    'price'?: number | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof ProductRelation
     */
    'main_image'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof ProductRelation
     */
    'installation_guide'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof ProductRelation
     */
    'spec_sheet'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof ProductRelation
     */
    'parts_diagram'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {number}
     * @memberof ProductRelation
     */
    'shipping_weight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductRelation
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductRelation
     */
    'updated_at'?: string | null;
}
/**
 * 
 * @export
 * @interface ProductRelationWithQuotePivotData
 */
export interface ProductRelationWithQuotePivotData {
    /**
     * 
     * @type {number}
     * @memberof ProductRelationWithQuotePivotData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ProductRelationWithQuotePivotData
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof ProductRelationWithQuotePivotData
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof ProductRelationWithQuotePivotData
     */
    'price'?: number | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof ProductRelationWithQuotePivotData
     */
    'main_image'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof ProductRelationWithQuotePivotData
     */
    'installation_guide'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof ProductRelationWithQuotePivotData
     */
    'spec_sheet'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {SalsifyDigitalAsset}
     * @memberof ProductRelationWithQuotePivotData
     */
    'parts_diagram'?: SalsifyDigitalAsset | null;
    /**
     * 
     * @type {number}
     * @memberof ProductRelationWithQuotePivotData
     */
    'shipping_weight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductRelationWithQuotePivotData
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductRelationWithQuotePivotData
     */
    'updated_at'?: string | null;
    /**
     * 
     * @type {ProductQuotePivot}
     * @memberof ProductRelationWithQuotePivotData
     */
    'pivot': ProductQuotePivot;
}
/**
 * 
 * @export
 * @interface ProductRelationWithQuotePivotDataAllOf
 */
export interface ProductRelationWithQuotePivotDataAllOf {
    /**
     * 
     * @type {ProductQuotePivot}
     * @memberof ProductRelationWithQuotePivotDataAllOf
     */
    'pivot': ProductQuotePivot;
}
/**
 * A project is the root object in the spec pack. It contains at least one ProjectVersion in the \"latest\" property. Each project version contains properties describing the project, a list of client names/logos for the header, and an array of pages 
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * Internal middleware record id for project
     * @type {number}
     * @memberof Project
     */
    'id': number;
    /**
     * 
     * @type {ProjectStatus}
     * @memberof Project
     */
    'status': ProjectStatus;
    /**
     * The token for project public endpoint request, generated after version with published status is present
     * @type {string}
     * @memberof Project
     */
    'public_token'?: string;
    /**
     * The name of the project
     * @type {string}
     * @memberof Project
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof Project
     */
    'index_pending': boolean;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    'draft_id': number;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    'latest_version_id': number;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    'public_version_id': number;
    /**
     * Each project has n versions.  This property contains the latest version unless you have explicitly asked for something other than the latest
     * @type {ProjectVersion}
     * @memberof Project
     */
    'latest': ProjectVersion;
    /**
     * Each project has n versions.  This property contains the latest published version
     * @type {ProjectVersion}
     * @memberof Project
     */
    'public'?: ProjectVersion;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    'user_id': number;
    /**
     * 
     * @type {UserRelation}
     * @memberof Project
     */
    'user': UserRelation | null;
    /**
     * 
     * @type {Array<ProjectVersion>}
     * @memberof Project
     */
    'versions': Array<ProjectVersion>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Project
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Project
     */
    'updated_at': string;
}
/**
 * A version has 0 - 4 Clients that supply a name and logo for use in the project header. 
 * @export
 * @interface ProjectClientRelation
 */
export interface ProjectClientRelation {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof ProjectClientRelation
     */
    'id': number;
    /**
     * The name of the client
     * @type {string}
     * @memberof ProjectClientRelation
     */
    'name': string | null;
    /**
     * 
     * @type {FileImageRelation}
     * @memberof ProjectClientRelation
     */
    'image': FileImageRelation | null;
}
/**
 * 
 * @export
 * @interface ProjectClientRelationUpdate
 */
export interface ProjectClientRelationUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof ProjectClientRelationUpdate
     */
    'id': number | null;
    /**
     * The name of the client
     * @type {string}
     * @memberof ProjectClientRelationUpdate
     */
    'name': string | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProjectClientRelationUpdate
     */
    'image': FileRelationUpdate | null;
}
/**
 * Calculated from overall version statuses
 * @export
 * @enum {string}
 */

export const ProjectStatus = {
    Draft: 'draft',
    Publishing: 'publishing',
    Published: 'published',
    PublishFailed: 'publish_failed',
    Disabled: 'disabled'
} as const;

export type ProjectStatus = typeof ProjectStatus[keyof typeof ProjectStatus];


/**
 * A project is the root object in the spec pack. It contains at least one ProjectVersion in the \"latest\" property. Each project version contains properties describing the project, a list of client names/logos for the header, and an array of pages 
 * @export
 * @interface ProjectUpdate
 */
export interface ProjectUpdate {
    /**
     * The name of the project
     * @type {string}
     * @memberof ProjectUpdate
     */
    'name': string;
    /**
     * Each project has n versions. This property contains the latest version unless you have explicitly asked for something other than the latest
     * @type {ProjectVersionUpdate}
     * @memberof ProjectUpdate
     */
    'latest': ProjectVersionUpdate;
}
/**
 * Every project contains at least one version. 
 * @export
 * @interface ProjectVersion
 */
export interface ProjectVersion {
    /**
     * Internal middleware record id for version
     * @type {number}
     * @memberof ProjectVersion
     */
    'id': number;
    /**
     * A name of this version
     * @type {string}
     * @memberof ProjectVersion
     */
    'name': string;
    /**
     * A quote number
     * @type {string}
     * @memberof ProjectVersion
     */
    'number': string;
    /**
     * 
     * @type {ProjectVersionStatus}
     * @memberof ProjectVersion
     */
    'status': ProjectVersionStatus;
    /**
     * A short description of this version
     * @type {string}
     * @memberof ProjectVersion
     */
    'description': string;
    /**
     * 
     * @type {SalesforceCustomer}
     * @memberof ProjectVersion
     */
    'customer': SalesforceCustomer | null;
    /**
     * 
     * @type {SalesforceOpportunity}
     * @memberof ProjectVersion
     */
    'opportunity': SalesforceOpportunity | null;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersion
     */
    'show_name': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersion
     */
    'show_address': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersion
     */
    'show_rep_info': PropertyVisibility;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof ProjectVersion
     */
    'currency_type': CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof ProjectVersion
     */
    'logo_text': string;
    /**
     * 
     * @type {FileModelImage}
     * @memberof ProjectVersion
     */
    'logo'?: FileModelImage;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof ProjectVersion
     */
    'logo_settings'?: CropImageSettings;
    /**
     * 
     * @type {Array<ProjectClientRelation>}
     * @memberof ProjectVersion
     */
    'clients': Array<ProjectClientRelation>;
    /**
     * 
     * @type {Array<Page>}
     * @memberof ProjectVersion
     */
    'pages': Array<Page>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof ProjectVersion
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof ProjectVersion
     */
    'updated_at': string;
    /**
     * An auto-increment number indicating the order of the versions
     * @type {number}
     * @memberof ProjectVersion
     */
    'serial': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersion
     */
    'show_default_number_units': PropertyVisibility;
    /**
     * Default number of units
     * @type {number}
     * @memberof ProjectVersion
     */
    'default_number_units': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersion
     */
    'show_list_price': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersion
     */
    'show_discount_price_label': PropertyVisibility;
    /**
     * The discount price label to be used
     * @type {string}
     * @memberof ProjectVersion
     */
    'discount_price_label': string;
    /**
     * The default multiplier to be used
     * @type {number}
     * @memberof ProjectVersion
     */
    'default_multiplier': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersion
     */
    'show_extended_price': PropertyVisibility;
    /**
     * 
     * @type {string}
     * @memberof ProjectVersion
     */
    'pricing_footer_note': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProjectVersionStatus = {
    Draft: 'draft',
    Publishing: 'publishing',
    Published: 'published',
    PublishFailed: 'publish_failed',
    Complete: 'complete'
} as const;

export type ProjectVersionStatus = typeof ProjectVersionStatus[keyof typeof ProjectVersionStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ProjectVersionStatusUpdate = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type ProjectVersionStatusUpdate = typeof ProjectVersionStatusUpdate[keyof typeof ProjectVersionStatusUpdate];


/**
 * 
 * @export
 * @interface ProjectVersionUpdate
 */
export interface ProjectVersionUpdate {
    /**
     * Internal middleware record id for version
     * @type {number}
     * @memberof ProjectVersionUpdate
     */
    'id': number | null;
    /**
     * The name of the version
     * @type {string}
     * @memberof ProjectVersionUpdate
     */
    'name': string;
    /**
     * A quote number
     * @type {string}
     * @memberof ProjectVersionUpdate
     */
    'number'?: string;
    /**
     * 
     * @type {ProjectVersionStatusUpdate}
     * @memberof ProjectVersionUpdate
     */
    'status': ProjectVersionStatusUpdate;
    /**
     * A short description of this version
     * @type {string}
     * @memberof ProjectVersionUpdate
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectVersionUpdate
     */
    'customer_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectVersionUpdate
     */
    'opportunity_id': number | null;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersionUpdate
     */
    'show_name': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersionUpdate
     */
    'show_address': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersionUpdate
     */
    'show_rep_info': PropertyVisibility;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof ProjectVersionUpdate
     */
    'currency_type': CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof ProjectVersionUpdate
     */
    'logo_text': string;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ProjectVersionUpdate
     */
    'logo'?: FileRelationUpdate;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof ProjectVersionUpdate
     */
    'logo_settings'?: CropImageSettings;
    /**
     * 
     * @type {Array<ProjectClientRelationUpdate>}
     * @memberof ProjectVersionUpdate
     */
    'clients': Array<ProjectClientRelationUpdate>;
    /**
     * 
     * @type {Array<PageUpdate>}
     * @memberof ProjectVersionUpdate
     */
    'pages': Array<PageUpdate>;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersionUpdate
     */
    'show_default_number_units': PropertyVisibility;
    /**
     * Default number of units
     * @type {number}
     * @memberof ProjectVersionUpdate
     */
    'default_number_units': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersionUpdate
     */
    'show_list_price': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersionUpdate
     */
    'show_discount_price_label': PropertyVisibility;
    /**
     * The discount price label to be used
     * @type {string}
     * @memberof ProjectVersionUpdate
     */
    'discount_price_label': string;
    /**
     * The default multiplier to be used
     * @type {number}
     * @memberof ProjectVersionUpdate
     */
    'default_multiplier': number;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof ProjectVersionUpdate
     */
    'show_extended_price': PropertyVisibility;
    /**
     * 
     * @type {string}
     * @memberof ProjectVersionUpdate
     */
    'pricing_footer_note': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PropertyVisibility = {
    Show: 'show',
    Hide: 'hide'
} as const;

export type PropertyVisibility = typeof PropertyVisibility[keyof typeof PropertyVisibility];


/**
 * @type Quote
 * @export
 */
export type Quote = PendingQuote | SentQuote;

/**
 * The available statuses for a quote
 * @export
 * @enum {string}
 */

export const QuoteStatus = {
    Deleted: 'deleted',
    Pending: 'pending',
    Sent: 'sent'
} as const;

export type QuoteStatus = typeof QuoteStatus[keyof typeof QuoteStatus];


/**
 * 
 * @export
 * @interface Region
 */
export interface Region {
    /**
     * 
     * @type {number}
     * @memberof Region
     */
    'id': number;
    /**
     * The region ID from Symmons API
     * @type {string}
     * @memberof Region
     */
    'region_id': string;
    /**
     * The region name from Symmons API
     * @type {string}
     * @memberof Region
     */
    'region_name': string;
    /**
     * The array of territories in this region
     * @type {Array<Territory>}
     * @memberof Region
     */
    'territories'?: Array<Territory>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Region
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Region
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface RegionRelation
 */
export interface RegionRelation {
    /**
     * 
     * @type {number}
     * @memberof RegionRelation
     */
    'id': number;
    /**
     * The region ID from Symmons API
     * @type {string}
     * @memberof RegionRelation
     */
    'region_id': string;
    /**
     * The region name from Symmons API
     * @type {string}
     * @memberof RegionRelation
     */
    'region_name': string;
}
/**
 * 
 * @export
 * @interface RegionResponse
 */
export interface RegionResponse {
    /**
     * 
     * @type {Region}
     * @memberof RegionResponse
     */
    'data': Region;
}
/**
 * 
 * @export
 * @interface RegionsResponse
 */
export interface RegionsResponse {
    /**
     * 
     * @type {Array<Region>}
     * @memberof RegionsResponse
     */
    'data': Array<Region>;
}
/**
 * @type RegisteredUser
 * @export
 */
export type RegisteredUser = AdminUser | AgencyRepUser | CompanyManagerUser | LocationManagerUser | RegularUser | ResourceUser | SalesRepUser;

/**
 * 
 * @export
 * @enum {string}
 */

export const RegisteredUserStatus = {
    Inactive: 'inactive',
    Active: 'active'
} as const;

export type RegisteredUserStatus = typeof RegisteredUserStatus[keyof typeof RegisteredUserStatus];


/**
 * 
 * @export
 * @interface RegularUser
 */
export interface RegularUser {
    /**
     * 
     * @type {number}
     * @memberof RegularUser
     */
    'id': number;
    /**
     * Is the user\'s company an wholesaler
     * @type {boolean}
     * @memberof RegularUser
     */
    'wholesaler'?: boolean;
    /**
     * Is the user\'s company an evolution owner
     * @type {boolean}
     * @memberof RegularUser
     */
    'evolution'?: boolean;
    /**
     * Can the user buy direct via the quote interface
     * @type {boolean}
     * @memberof RegularUser
     */
    'direct_buyer'?: boolean;
    /**
     * The company id
     * @type {number}
     * @memberof RegularUser
     */
    'company_id': number;
    /**
     * The location id
     * @type {number}
     * @memberof RegularUser
     */
    'location_id': number;
    /**
     * The agency id
     * @type {number}
     * @memberof RegularUser
     */
    'agency_id': number;
    /**
     * Whether this user has access to all territories
     * @type {boolean}
     * @memberof RegularUser
     */
    'all_territories'?: boolean;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof RegularUser
     */
    'first_name': string | null;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof RegularUser
     */
    'last_name': string | null;
    /**
     * 
     * @type {FileAvatarRelation}
     * @memberof RegularUser
     */
    'image': FileAvatarRelation | null;
    /**
     * 
     * @type {PendingQuote}
     * @memberof RegularUser
     */
    'pending_quote'?: PendingQuote | null;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof RegularUser
     */
    'email': string;
    /**
     * The phone number of the user
     * @type {string}
     * @memberof RegularUser
     */
    'phone'?: string | null;
    /**
     * 
     * @type {UserSharedPermissions}
     * @memberof RegularUser
     */
    'permissions': UserSharedPermissions;
    /**
     * The last login date
     * @type {string}
     * @memberof RegularUser
     */
    'last_login': string | null;
    /**
     * 
     * @type {number}
     * @memberof RegularUser
     */
    'login_count': number;
    /**
     * The last login date
     * @type {string}
     * @memberof RegularUser
     */
    'last_access': string | null;
    /**
     * 
     * @type {number}
     * @memberof RegularUser
     */
    'access_count': number;
    /**
     * 
     * @type {string}
     * @memberof RegularUser
     */
    'email_verified_at': string | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof RegularUser
     */
    'created_at': string;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof RegularUser
     */
    'updated_at': string;
    /**
     * Whether the user has enabled 2FA
     * @type {boolean}
     * @memberof RegularUser
     */
    'google2fa_enabled'?: boolean;
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof RegularUser
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof RegularUser
     */
    'company': CompanyRelation;
    /**
     * 
     * @type {LocationRelation}
     * @memberof RegularUser
     */
    'location': LocationRelation | null;
    /**
     * 
     * @type {string}
     * @memberof RegularUser
     */
    'role': RegularUserRoleEnum;
    /**
     * Is this user managed by a representative?
     * @type {boolean}
     * @memberof RegularUser
     */
    'rep_managed': boolean;
}

export const RegularUserRoleEnum = {
    User: 'user'
} as const;

export type RegularUserRoleEnum = typeof RegularUserRoleEnum[keyof typeof RegularUserRoleEnum];

/**
 * 
 * @export
 * @interface RegularUserAllOf
 */
export interface RegularUserAllOf {
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof RegularUserAllOf
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof RegularUserAllOf
     */
    'company': CompanyRelation;
    /**
     * 
     * @type {LocationRelation}
     * @memberof RegularUserAllOf
     */
    'location': LocationRelation | null;
    /**
     * 
     * @type {string}
     * @memberof RegularUserAllOf
     */
    'role': RegularUserAllOfRoleEnum;
    /**
     * Is this user managed by a representative?
     * @type {boolean}
     * @memberof RegularUserAllOf
     */
    'rep_managed': boolean;
}

export const RegularUserAllOfRoleEnum = {
    User: 'user'
} as const;

export type RegularUserAllOfRoleEnum = typeof RegularUserAllOfRoleEnum[keyof typeof RegularUserAllOfRoleEnum];

/**
 * 
 * @export
 * @interface RelatedAsset
 */
export interface RelatedAsset {
    /**
     * The id of the related asset
     * @type {number}
     * @memberof RelatedAsset
     */
    'id': number;
    /**
     * The name of the related asset
     * @type {string}
     * @memberof RelatedAsset
     */
    'name': string;
    /**
     * The url of the related asset
     * @type {string}
     * @memberof RelatedAsset
     */
    'url': string;
    /**
     * The type of the related asset
     * @type {string}
     * @memberof RelatedAsset
     */
    'type': string;
}
/**
 * Admins can request reports.  These reports are generated async and the admin is then emailed when the report is complete. 
 * @export
 * @interface Report
 */
export interface Report {
    /**
     * Report id
     * @type {number}
     * @memberof Report
     */
    'id': number;
    /**
     * 
     * @type {ReportType}
     * @memberof Report
     */
    'type': ReportType;
    /**
     * 
     * @type {ReportStatus}
     * @memberof Report
     */
    'status': ReportStatus;
    /**
     * 
     * @type {number}
     * @memberof Report
     */
    'user_id': number;
    /**
     * 
     * @type {UserRelation}
     * @memberof Report
     */
    'user'?: UserRelation;
    /**
     * A link to the generated report that an admin can use to download the report
     * @type {string}
     * @memberof Report
     */
    'url': string;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Report
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Report
     */
    'updated_at': string;
}
/**
 * Is the report running, completed or failed?
 * @export
 * @enum {string}
 */

export const ReportStatus = {
    Requested: 'requested',
    Processing: 'processing',
    Complete: 'complete',
    Failed: 'failed'
} as const;

export type ReportStatus = typeof ReportStatus[keyof typeof ReportStatus];


/**
 * The kind of report requested
 * @export
 * @enum {string}
 */

export const ReportType = {
    User: 'user',
    Agency: 'agency',
    Company: 'company',
    Location: 'location',
    Order: 'order',
    Quote: 'quote',
    Event: 'event'
} as const;

export type ReportType = typeof ReportType[keyof typeof ReportType];


/**
 * 
 * @export
 * @interface RequestAccountBody
 */
export interface RequestAccountBody {
    /**
     * The first_name of the registering customer
     * @type {string}
     * @memberof RequestAccountBody
     */
    'first_name': string;
    /**
     * The last_name of the registering customer
     * @type {string}
     * @memberof RequestAccountBody
     */
    'last_name': string;
    /**
     * The name of the company to attach the user to
     * @type {string}
     * @memberof RequestAccountBody
     */
    'company_name': string;
    /**
     * The email of the registering customer
     * @type {string}
     * @memberof RequestAccountBody
     */
    'email': string;
    /**
     * The phone of the registering customer
     * @type {string}
     * @memberof RequestAccountBody
     */
    'phone': string;
    /**
     * The city of the registering customer
     * @type {string}
     * @memberof RequestAccountBody
     */
    'city': string;
    /**
     * The state of the registering customer
     * @type {string}
     * @memberof RequestAccountBody
     */
    'state': string;
}
/**
 * 
 * @export
 * @interface RequestOrderChange
 */
export interface RequestOrderChange {
    /**
     * The message with the quote
     * @type {string}
     * @memberof RequestOrderChange
     */
    'message': string;
    /**
     * 
     * @type {RequestOrderChangeEventType}
     * @memberof RequestOrderChange
     */
    'type': RequestOrderChangeEventType;
    /**
     * A an optional reason for the request for the request
     * @type {string}
     * @memberof RequestOrderChange
     */
    'reason'?: string;
    /**
     * A list of files to attach to the quote
     * @type {Array<ResourceFiles>}
     * @memberof RequestOrderChange
     */
    'files'?: Array<ResourceFiles>;
}
/**
 * The type of an order change request
 * @export
 * @enum {string}
 */

export const RequestOrderChangeEventType = {
    Change: 'change',
    Changed: 'changed',
    Return: 'return',
    Returned: 'returned'
} as const;

export type RequestOrderChangeEventType = typeof RequestOrderChangeEventType[keyof typeof RequestOrderChangeEventType];


/**
 * 
 * @export
 * @interface RequestPasswordReset
 */
export interface RequestPasswordReset {
    /**
     * The email address of the user who wants to reset their password
     * @type {string}
     * @memberof RequestPasswordReset
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface RequestResourceAccountBody
 */
export interface RequestResourceAccountBody {
    /**
     * The first_name of the registering customer
     * @type {string}
     * @memberof RequestResourceAccountBody
     */
    'first_name': string;
    /**
     * The last_name of the registering customer
     * @type {string}
     * @memberof RequestResourceAccountBody
     */
    'last_name': string;
    /**
     * The email of the registering customer
     * @type {string}
     * @memberof RequestResourceAccountBody
     */
    'email': string;
    /**
     * reCAPTCHA v3 token for verification
     * @type {string}
     * @memberof RequestResourceAccountBody
     */
    'recaptcha_token': string;
}
/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * The name of the resource
     * @type {string}
     * @memberof Resource
     */
    'name': string;
    /**
     * A markdown compatible field that contains the content of the resource
     * @type {string}
     * @memberof Resource
     */
    'content': string;
    /**
     * 
     * @type {UserRelation}
     * @memberof Resource
     */
    'user': UserRelation;
    /**
     * The files that are associated with this resource
     * @type {Array<FileRelation>}
     * @memberof Resource
     */
    'files': Array<FileRelation>;
    /**
     * 
     * @type {ResourceType}
     * @memberof Resource
     */
    'type': ResourceType;
    /**
     * 
     * @type {ScormRelation}
     * @memberof Resource
     */
    'scorm': ScormRelation;
    /**
     * 
     * @type {ScormScoTrackingRelation}
     * @memberof Resource
     */
    'scorm_user_progress'?: ScormScoTrackingRelation;
    /**
     * The wistia id for the video that is associated with this resource
     * @type {string}
     * @memberof Resource
     */
    'wistia_id': string;
    /**
     * The files that are associated with this resource
     * @type {Array<CompanyRelation>}
     * @memberof Resource
     */
    'companies': Array<CompanyRelation>;
    /**
     * 
     * @type {FileImageRelation}
     * @memberof Resource
     */
    'image': FileImageRelation;
    /**
     * The topics that this resource is associated with
     * @type {Array<TaxonomyTermConnect>}
     * @memberof Resource
     */
    'topics': Array<TaxonomyTermConnect>;
    /**
     * 
     * @type {ResourceStatus}
     * @memberof Resource
     */
    'status': ResourceStatus;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof Resource
     */
    'image_settings'?: CropImageSettings | null;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'link': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    'show_link': boolean;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Resource
     */
    'created_at'?: string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Resource
     */
    'updated_at'?: string;
    /**
     * Is the resource featured
     * @type {boolean}
     * @memberof Resource
     */
    'featured': boolean;
    /**
     * Is the resource accessible to sales reps
     * @type {boolean}
     * @memberof Resource
     */
    'salesrep_access': boolean;
    /**
     * Internal middleware record id for resource
     * @type {number}
     * @memberof Resource
     */
    'id': number;
}
/**
 * A resource for the resource center 
 * @export
 * @interface ResourceAllOf
 */
export interface ResourceAllOf {
    /**
     * Internal middleware record id for resource
     * @type {number}
     * @memberof ResourceAllOf
     */
    'id': number;
    /**
     * 
     * @type {FileImageRelation}
     * @memberof ResourceAllOf
     */
    'image': FileImageRelation;
}
/**
 * 
 * @export
 * @interface ResourceFiles
 */
export interface ResourceFiles {
    /**
     * The id of the file being attached.  It must be owned by the current user
     * @type {number}
     * @memberof ResourceFiles
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface ResourceIdTopics
 */
export interface ResourceIdTopics {
    /**
     * The id of the topic being attached.
     * @type {number}
     * @memberof ResourceIdTopics
     */
    'id': number;
    /**
     * The string of the topic being attached.
     * @type {string}
     * @memberof ResourceIdTopics
     */
    'term'?: string;
}
/**
 * 
 * @export
 * @interface ResourceShared
 */
export interface ResourceShared {
    /**
     * The name of the resource
     * @type {string}
     * @memberof ResourceShared
     */
    'name': string;
    /**
     * A markdown compatible field that contains the content of the resource
     * @type {string}
     * @memberof ResourceShared
     */
    'content': string;
    /**
     * 
     * @type {UserRelation}
     * @memberof ResourceShared
     */
    'user': UserRelation;
    /**
     * The files that are associated with this resource
     * @type {Array<FileRelation>}
     * @memberof ResourceShared
     */
    'files': Array<FileRelation>;
    /**
     * 
     * @type {ResourceType}
     * @memberof ResourceShared
     */
    'type': ResourceType;
    /**
     * 
     * @type {ScormRelation}
     * @memberof ResourceShared
     */
    'scorm': ScormRelation;
    /**
     * 
     * @type {ScormScoTrackingRelation}
     * @memberof ResourceShared
     */
    'scorm_user_progress'?: ScormScoTrackingRelation;
    /**
     * The wistia id for the video that is associated with this resource
     * @type {string}
     * @memberof ResourceShared
     */
    'wistia_id': string;
    /**
     * The files that are associated with this resource
     * @type {Array<CompanyRelation>}
     * @memberof ResourceShared
     */
    'companies': Array<CompanyRelation>;
    /**
     * 
     * @type {FileImageRelation}
     * @memberof ResourceShared
     */
    'image': FileImageRelation;
    /**
     * The topics that this resource is associated with
     * @type {Array<TaxonomyTermConnect>}
     * @memberof ResourceShared
     */
    'topics': Array<TaxonomyTermConnect>;
    /**
     * 
     * @type {ResourceStatus}
     * @memberof ResourceShared
     */
    'status': ResourceStatus;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof ResourceShared
     */
    'image_settings'?: CropImageSettings | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceShared
     */
    'link': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResourceShared
     */
    'show_link': boolean;
    /**
     * the date the record was created
     * @type {string}
     * @memberof ResourceShared
     */
    'created_at'?: string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof ResourceShared
     */
    'updated_at'?: string;
    /**
     * Is the resource featured
     * @type {boolean}
     * @memberof ResourceShared
     */
    'featured': boolean;
    /**
     * Is the resource accessible to sales reps
     * @type {boolean}
     * @memberof ResourceShared
     */
    'salesrep_access': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ResourceStatus = {
    Inactive: 'inactive',
    Active: 'active'
} as const;

export type ResourceStatus = typeof ResourceStatus[keyof typeof ResourceStatus];


/**
 * 
 * @export
 * @interface ResourceTopics
 */
export interface ResourceTopics {
    /**
     * The id of the topic being attached.
     * @type {number}
     * @memberof ResourceTopics
     */
    'id': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ResourceType = {
    File: 'file',
    Scorm: 'scorm'
} as const;

export type ResourceType = typeof ResourceType[keyof typeof ResourceType];


/**
 * 
 * @export
 * @interface ResourceUpdate
 */
export interface ResourceUpdate {
    /**
     * The name of the resource
     * @type {string}
     * @memberof ResourceUpdate
     */
    'name': string;
    /**
     * A markdown compatible field that contains the content of the resource
     * @type {string}
     * @memberof ResourceUpdate
     */
    'content': string;
    /**
     * 
     * @type {UserRelation}
     * @memberof ResourceUpdate
     */
    'user': UserRelation;
    /**
     * The files that are associated with this resource
     * @type {Array<FileRelation>}
     * @memberof ResourceUpdate
     */
    'files': Array<FileRelation>;
    /**
     * 
     * @type {ResourceType}
     * @memberof ResourceUpdate
     */
    'type': ResourceType;
    /**
     * 
     * @type {ScormRelation}
     * @memberof ResourceUpdate
     */
    'scorm': ScormRelation;
    /**
     * 
     * @type {ScormScoTrackingRelation}
     * @memberof ResourceUpdate
     */
    'scorm_user_progress'?: ScormScoTrackingRelation;
    /**
     * The wistia id for the video that is associated with this resource
     * @type {string}
     * @memberof ResourceUpdate
     */
    'wistia_id': string;
    /**
     * The files that are associated with this resource
     * @type {Array<CompanyRelation>}
     * @memberof ResourceUpdate
     */
    'companies': Array<CompanyRelation>;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ResourceUpdate
     */
    'image': FileRelationUpdate;
    /**
     * The topics that this resource is associated with
     * @type {Array<TaxonomyTermConnect>}
     * @memberof ResourceUpdate
     */
    'topics': Array<TaxonomyTermConnect>;
    /**
     * 
     * @type {ResourceStatus}
     * @memberof ResourceUpdate
     */
    'status': ResourceStatus;
    /**
     * 
     * @type {CropImageSettings}
     * @memberof ResourceUpdate
     */
    'image_settings'?: CropImageSettings | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceUpdate
     */
    'link': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResourceUpdate
     */
    'show_link': boolean;
    /**
     * the date the record was created
     * @type {string}
     * @memberof ResourceUpdate
     */
    'created_at'?: string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof ResourceUpdate
     */
    'updated_at'?: string;
    /**
     * Is the resource featured
     * @type {boolean}
     * @memberof ResourceUpdate
     */
    'featured': boolean;
    /**
     * Is the resource accessible to sales reps
     * @type {boolean}
     * @memberof ResourceUpdate
     */
    'salesrep_access': boolean;
    /**
     * Internal middleware record id for resource
     * @type {number}
     * @memberof ResourceUpdate
     */
    'id': number | null;
}
/**
 * 
 * @export
 * @interface ResourceUpdateAllOf
 */
export interface ResourceUpdateAllOf {
    /**
     * Internal middleware record id for resource
     * @type {number}
     * @memberof ResourceUpdateAllOf
     */
    'id': number | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof ResourceUpdateAllOf
     */
    'image': FileRelationUpdate;
}
/**
 * 
 * @export
 * @interface ResourceUser
 */
export interface ResourceUser {
    /**
     * 
     * @type {number}
     * @memberof ResourceUser
     */
    'id': number;
    /**
     * Is the user\'s company an wholesaler
     * @type {boolean}
     * @memberof ResourceUser
     */
    'wholesaler'?: boolean;
    /**
     * Is the user\'s company an evolution owner
     * @type {boolean}
     * @memberof ResourceUser
     */
    'evolution'?: boolean;
    /**
     * Can the user buy direct via the quote interface
     * @type {boolean}
     * @memberof ResourceUser
     */
    'direct_buyer'?: boolean;
    /**
     * The company id
     * @type {number}
     * @memberof ResourceUser
     */
    'company_id': number;
    /**
     * The location id
     * @type {number}
     * @memberof ResourceUser
     */
    'location_id': number;
    /**
     * The agency id
     * @type {number}
     * @memberof ResourceUser
     */
    'agency_id': number;
    /**
     * Whether this user has access to all territories
     * @type {boolean}
     * @memberof ResourceUser
     */
    'all_territories'?: boolean;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof ResourceUser
     */
    'first_name': string | null;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof ResourceUser
     */
    'last_name': string | null;
    /**
     * 
     * @type {FileAvatarRelation}
     * @memberof ResourceUser
     */
    'image': FileAvatarRelation | null;
    /**
     * 
     * @type {PendingQuote}
     * @memberof ResourceUser
     */
    'pending_quote'?: PendingQuote | null;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof ResourceUser
     */
    'email': string;
    /**
     * The phone number of the user
     * @type {string}
     * @memberof ResourceUser
     */
    'phone'?: string | null;
    /**
     * 
     * @type {UserSharedPermissions}
     * @memberof ResourceUser
     */
    'permissions': UserSharedPermissions;
    /**
     * The last login date
     * @type {string}
     * @memberof ResourceUser
     */
    'last_login': string | null;
    /**
     * 
     * @type {number}
     * @memberof ResourceUser
     */
    'login_count': number;
    /**
     * The last login date
     * @type {string}
     * @memberof ResourceUser
     */
    'last_access': string | null;
    /**
     * 
     * @type {number}
     * @memberof ResourceUser
     */
    'access_count': number;
    /**
     * 
     * @type {string}
     * @memberof ResourceUser
     */
    'email_verified_at': string | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof ResourceUser
     */
    'created_at': string;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof ResourceUser
     */
    'updated_at': string;
    /**
     * Whether the user has enabled 2FA
     * @type {boolean}
     * @memberof ResourceUser
     */
    'google2fa_enabled'?: boolean;
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof ResourceUser
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {string}
     * @memberof ResourceUser
     */
    'role': ResourceUserRoleEnum;
    /**
     * Is this user managed by a representative?
     * @type {boolean}
     * @memberof ResourceUser
     */
    'rep_managed': boolean;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof ResourceUser
     */
    'company'?: CompanyRelation | null;
    /**
     * 
     * @type {LocationRelation}
     * @memberof ResourceUser
     */
    'location'?: LocationRelation | null;
}

export const ResourceUserRoleEnum = {
    ResourceAccess: 'resource_access'
} as const;

export type ResourceUserRoleEnum = typeof ResourceUserRoleEnum[keyof typeof ResourceUserRoleEnum];

/**
 * 
 * @export
 * @interface ResourceUserAllOf
 */
export interface ResourceUserAllOf {
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof ResourceUserAllOf
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {string}
     * @memberof ResourceUserAllOf
     */
    'role': ResourceUserAllOfRoleEnum;
    /**
     * Is this user managed by a representative?
     * @type {boolean}
     * @memberof ResourceUserAllOf
     */
    'rep_managed': boolean;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof ResourceUserAllOf
     */
    'company'?: CompanyRelation | null;
    /**
     * 
     * @type {LocationRelation}
     * @memberof ResourceUserAllOf
     */
    'location'?: LocationRelation | null;
}

export const ResourceUserAllOfRoleEnum = {
    ResourceAccess: 'resource_access'
} as const;

export type ResourceUserAllOfRoleEnum = typeof ResourceUserAllOfRoleEnum[keyof typeof ResourceUserAllOfRoleEnum];

/**
 * 
 * @export
 * @interface ResourcesDashboard
 */
export interface ResourcesDashboard {
    /**
     * 
     * @type {Array<ResourcesDashboardAllCounts>}
     * @memberof ResourcesDashboard
     */
    'all_counts'?: Array<ResourcesDashboardAllCounts>;
    /**
     * 
     * @type {Array<ResourcesDashboardAllCounts>}
     * @memberof ResourcesDashboard
     */
    'latest'?: Array<ResourcesDashboardAllCounts>;
}
/**
 * 
 * @export
 * @interface ResourcesDashboardAllCounts
 */
export interface ResourcesDashboardAllCounts {
    /**
     * 
     * @type {number}
     * @memberof ResourcesDashboardAllCounts
     */
    'taxonomy_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResourcesDashboardAllCounts
     */
    'term'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResourcesDashboardAllCounts
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResourcesDashboardAllCounts
     */
    'icon'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResourcesDashboardAllCounts
     */
    'featured'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResourcesDashboardAllCounts
     */
    'dashboard'?: boolean;
}
/**
 * 
 * @export
 * @interface Response
 */
export interface Response {
    /**
     * 
     * @type {number}
     * @memberof Response
     */
    'id': number;
    /**
     * The quote request body.  A free text field the user can use to make the quote request
     * @type {string}
     * @memberof Response
     */
    'message': string;
    /**
     * 
     * @type {UserRelation}
     * @memberof Response
     */
    'user': UserRelation;
    /**
     * 
     * @type {Array<FileRelation>}
     * @memberof Response
     */
    'files': Array<FileRelation>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Response
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Response
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface SalesRep
 */
export interface SalesRep {
    /**
     * 
     * @type {number}
     * @memberof SalesRep
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SalesRep
     */
    'first_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesRep
     */
    'last_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesRep
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesRep
     */
    'phone': string | null;
    /**
     * 
     * @type {Hours}
     * @memberof SalesRep
     */
    'hours': Hours | null;
    /**
     * the date the record was created
     * @type {string}
     * @memberof SalesRep
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof SalesRep
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface SalesRepBody
 */
export interface SalesRepBody {
    /**
     * 
     * @type {string}
     * @memberof SalesRepBody
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepBody
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepBody
     */
    'email': string;
    /**
     * 
     * @type {Hours}
     * @memberof SalesRepBody
     */
    'hours': Hours;
}
/**
 * 
 * @export
 * @interface SalesRepUser
 */
export interface SalesRepUser {
    /**
     * 
     * @type {number}
     * @memberof SalesRepUser
     */
    'id': number;
    /**
     * Is the user\'s company an wholesaler
     * @type {boolean}
     * @memberof SalesRepUser
     */
    'wholesaler'?: boolean;
    /**
     * Is the user\'s company an evolution owner
     * @type {boolean}
     * @memberof SalesRepUser
     */
    'evolution'?: boolean;
    /**
     * Can the user buy direct via the quote interface
     * @type {boolean}
     * @memberof SalesRepUser
     */
    'direct_buyer'?: boolean;
    /**
     * The company id
     * @type {number}
     * @memberof SalesRepUser
     */
    'company_id': number;
    /**
     * The location id
     * @type {number}
     * @memberof SalesRepUser
     */
    'location_id': number;
    /**
     * The agency id
     * @type {number}
     * @memberof SalesRepUser
     */
    'agency_id': number;
    /**
     * Whether this user has access to all territories
     * @type {boolean}
     * @memberof SalesRepUser
     */
    'all_territories'?: boolean;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof SalesRepUser
     */
    'first_name': string | null;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof SalesRepUser
     */
    'last_name': string | null;
    /**
     * 
     * @type {FileAvatarRelation}
     * @memberof SalesRepUser
     */
    'image': FileAvatarRelation | null;
    /**
     * 
     * @type {PendingQuote}
     * @memberof SalesRepUser
     */
    'pending_quote'?: PendingQuote | null;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof SalesRepUser
     */
    'email': string;
    /**
     * The phone number of the user
     * @type {string}
     * @memberof SalesRepUser
     */
    'phone': string | null;
    /**
     * 
     * @type {UserSharedPermissions}
     * @memberof SalesRepUser
     */
    'permissions': UserSharedPermissions;
    /**
     * The last login date
     * @type {string}
     * @memberof SalesRepUser
     */
    'last_login': string | null;
    /**
     * 
     * @type {number}
     * @memberof SalesRepUser
     */
    'login_count': number;
    /**
     * The last login date
     * @type {string}
     * @memberof SalesRepUser
     */
    'last_access': string | null;
    /**
     * 
     * @type {number}
     * @memberof SalesRepUser
     */
    'access_count': number;
    /**
     * 
     * @type {string}
     * @memberof SalesRepUser
     */
    'email_verified_at': string | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof SalesRepUser
     */
    'created_at': string;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof SalesRepUser
     */
    'updated_at': string;
    /**
     * Whether the user has enabled 2FA
     * @type {boolean}
     * @memberof SalesRepUser
     */
    'google2fa_enabled'?: boolean;
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof SalesRepUser
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {SalesRepUserAllOfRepresents}
     * @memberof SalesRepUser
     */
    'represents': SalesRepUserAllOfRepresents;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof SalesRepUser
     */
    'company': CompanyRelation | null;
    /**
     * 
     * @type {LocationRelation}
     * @memberof SalesRepUser
     */
    'location'?: LocationRelation | null;
    /**
     * 
     * @type {Hours}
     * @memberof SalesRepUser
     */
    'hours': Hours | null;
    /**
     * 
     * @type {AgencyRelation}
     * @memberof SalesRepUser
     */
    'agency'?: AgencyRelation;
    /**
     * Does the user\'s agency have a sales goals report that the user can see?
     * @type {boolean}
     * @memberof SalesRepUser
     */
    'agency_has_report'?: boolean;
    /**
     * 
     * @type {Array<TerritoryRelation>}
     * @memberof SalesRepUser
     */
    'territories'?: Array<TerritoryRelation>;
    /**
     * 
     * @type {string}
     * @memberof SalesRepUser
     */
    'role': SalesRepUserRoleEnum;
}

export const SalesRepUserRoleEnum = {
    SalesRep: 'sales_rep'
} as const;

export type SalesRepUserRoleEnum = typeof SalesRepUserRoleEnum[keyof typeof SalesRepUserRoleEnum];

/**
 * 
 * @export
 * @interface SalesRepUserAllOf
 */
export interface SalesRepUserAllOf {
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof SalesRepUserAllOf
     */
    'status': RegisteredUserStatus;
    /**
     * 
     * @type {SalesRepUserAllOfRepresents}
     * @memberof SalesRepUserAllOf
     */
    'represents': SalesRepUserAllOfRepresents;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof SalesRepUserAllOf
     */
    'company': CompanyRelation | null;
    /**
     * 
     * @type {LocationRelation}
     * @memberof SalesRepUserAllOf
     */
    'location'?: LocationRelation | null;
    /**
     * 
     * @type {Hours}
     * @memberof SalesRepUserAllOf
     */
    'hours': Hours | null;
    /**
     * 
     * @type {AgencyRelation}
     * @memberof SalesRepUserAllOf
     */
    'agency'?: AgencyRelation;
    /**
     * Does the user\'s agency have a sales goals report that the user can see?
     * @type {boolean}
     * @memberof SalesRepUserAllOf
     */
    'agency_has_report'?: boolean;
    /**
     * 
     * @type {Array<TerritoryRelation>}
     * @memberof SalesRepUserAllOf
     */
    'territories'?: Array<TerritoryRelation>;
    /**
     * 
     * @type {string}
     * @memberof SalesRepUserAllOf
     */
    'role': SalesRepUserAllOfRoleEnum;
}

export const SalesRepUserAllOfRoleEnum = {
    SalesRep: 'sales_rep'
} as const;

export type SalesRepUserAllOfRoleEnum = typeof SalesRepUserAllOfRoleEnum[keyof typeof SalesRepUserAllOfRoleEnum];

/**
 * 
 * @export
 * @interface SalesRepUserAllOfRepresents
 */
export interface SalesRepUserAllOfRepresents {
    /**
     * 
     * @type {Array<CompanyRelation>}
     * @memberof SalesRepUserAllOfRepresents
     */
    'companies': Array<CompanyRelation>;
    /**
     * 
     * @type {Array<LocationRelation>}
     * @memberof SalesRepUserAllOfRepresents
     */
    'locations': Array<LocationRelation>;
}
/**
 * Each project version can be associated with a salesforce customer. These customers are populated automatically from salesforce 
 * @export
 * @interface SalesforceCustomer
 */
export interface SalesforceCustomer {
    /**
     * Internal middleware record id for the client
     * @type {number}
     * @memberof SalesforceCustomer
     */
    'id': number;
    /**
     * The internal salesforce identifier
     * @type {string}
     * @memberof SalesforceCustomer
     */
    'salesforce_id': string;
    /**
     * The name of the customer pulled from salesforce
     * @type {string}
     * @memberof SalesforceCustomer
     */
    'name': string;
    /**
     * The address of the Customer
     * @type {string}
     * @memberof SalesforceCustomer
     */
    'address': string | null;
    /**
     * The city of the Customer
     * @type {string}
     * @memberof SalesforceCustomer
     */
    'city': string | null;
    /**
     * The state of the Customer
     * @type {string}
     * @memberof SalesforceCustomer
     */
    'state': string | null;
    /**
     * The postal code of the Customer
     * @type {string}
     * @memberof SalesforceCustomer
     */
    'postal_code': string | null;
    /**
     * The country of the Customer
     * @type {string}
     * @memberof SalesforceCustomer
     */
    'country': string | null;
    /**
     * The latitude of the Customer
     * @type {string}
     * @memberof SalesforceCustomer
     */
    'latitude': string | null;
    /**
     * The longitude of the Customer
     * @type {string}
     * @memberof SalesforceCustomer
     */
    'longitude': string | null;
    /**
     * the date the record was created
     * @type {string}
     * @memberof SalesforceCustomer
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof SalesforceCustomer
     */
    'updated_at': string;
}
/**
 * Each project version can be associated with a salesforce opportunity.  These opportunity are populated automatically from salesforce 
 * @export
 * @interface SalesforceOpportunity
 */
export interface SalesforceOpportunity {
    /**
     * Internal middleware record id for the opportunity
     * @type {number}
     * @memberof SalesforceOpportunity
     */
    'id': number;
    /**
     * Internal middleware record id for the customer
     * @type {number}
     * @memberof SalesforceOpportunity
     */
    'salesforce_customer_id'?: number;
    /**
     * The internal salesforce identifier
     * @type {string}
     * @memberof SalesforceOpportunity
     */
    'salesforce_id': string;
    /**
     * 
     * @type {string}
     * @memberof SalesforceOpportunity
     */
    'account_id': string;
    /**
     * The name of the opportunity pulled from salesforce
     * @type {string}
     * @memberof SalesforceOpportunity
     */
    'name': string;
    /**
     * The address of the opportunity
     * @type {string}
     * @memberof SalesforceOpportunity
     */
    'address': string | null;
    /**
     * The city of the opportunity
     * @type {string}
     * @memberof SalesforceOpportunity
     */
    'city': string | null;
    /**
     * The state of the opportunity
     * @type {string}
     * @memberof SalesforceOpportunity
     */
    'state': string | null;
    /**
     * The postal code of the opportunity
     * @type {string}
     * @memberof SalesforceOpportunity
     */
    'postal_code': string | null;
    /**
     * The country of the opportunity
     * @type {string}
     * @memberof SalesforceOpportunity
     */
    'country': string | null;
    /**
     * 
     * @type {SalesforceCustomer}
     * @memberof SalesforceOpportunity
     */
    'customer': SalesforceCustomer | null;
    /**
     * the date the record was created
     * @type {string}
     * @memberof SalesforceOpportunity
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof SalesforceOpportunity
     */
    'updated_at': string;
}
/**
 * When a project version is published to salesforce, a local record is created to store the data regarding the published version 
 * @export
 * @interface SalesforceProject
 */
export interface SalesforceProject {
    /**
     * Internal middleware record id for the client
     * @type {number}
     * @memberof SalesforceProject
     */
    'id': number;
    /**
     * The internal salesforce identifier
     * @type {string}
     * @memberof SalesforceProject
     */
    'salesforce_id': string;
    /**
     * The name of the customer pulled from salesforce
     * @type {string}
     * @memberof SalesforceProject
     */
    'name': string;
    /**
     * the date the record was created
     * @type {string}
     * @memberof SalesforceProject
     */
    'created_at'?: string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof SalesforceProject
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface SalsifyDigitalAsset
 */
export interface SalsifyDigitalAsset {
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_id': string;
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_url': string;
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_source_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_name': string;
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_status'?: string;
    /**
     * 
     * @type {number}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_asset_height'?: number;
    /**
     * 
     * @type {number}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_asset_width'?: number;
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_asset_resource_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_bytes': number;
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_format'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_etag'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalsifyDigitalAsset
     */
    'salsify_system_id'?: string;
}
/**
 * 
 * @export
 * @interface Scorm
 */
export interface Scorm {
    /**
     * Internal middleware record id for scorm
     * @type {number}
     * @memberof Scorm
     */
    'id': number;
    /**
     * The url of the scorm
     * @type {string}
     * @memberof Scorm
     */
    'url': string;
    /**
     * The type of resource that the scorm is associated with
     * @type {string}
     * @memberof Scorm
     */
    'resource_type': string | null;
    /**
     * The id of the resource that the scorm is associated with
     * @type {number}
     * @memberof Scorm
     */
    'resource_id': number | null;
    /**
     * The title of the scorm
     * @type {string}
     * @memberof Scorm
     */
    'title': string;
    /**
     * The original file that was uploaded
     * @type {string}
     * @memberof Scorm
     */
    'origin_file': string;
    /**
     * The version of the scorm (should be scorm_12)
     * @type {string}
     * @memberof Scorm
     */
    'version': string;
    /**
     * The ratio of the scorm
     * @type {string}
     * @memberof Scorm
     */
    'ratio': string | null;
    /**
     * The identifier of the scorm
     * @type {string}
     * @memberof Scorm
     */
    'identifier': string;
    /**
     * The entry url of the scorm
     * @type {string}
     * @memberof Scorm
     */
    'entry_url': string;
    /**
     * The scos that are associated with this scorm
     * @type {Array<ScormSco>}
     * @memberof Scorm
     */
    'scos': Array<ScormSco>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Scorm
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Scorm
     */
    'updated_at': string;
    /**
     * The number of times the scorm has been started
     * @type {number}
     * @memberof Scorm
     */
    'started_count'?: number;
    /**
     * The number of times the scorm has been passed
     * @type {number}
     * @memberof Scorm
     */
    'passed_count'?: number;
}
/**
 * A scorm is a type of resource that can be uploaded to the resource center.  A scorm has a title, an origin file, a version, a ratio, a uuid, an identifier, an entry url, and a list of scos. 
 * @export
 * @interface ScormAllOf
 */
export interface ScormAllOf {
    /**
     * Internal middleware record id for scorm
     * @type {number}
     * @memberof ScormAllOf
     */
    'id': number;
    /**
     * The number of times the scorm has been started
     * @type {number}
     * @memberof ScormAllOf
     */
    'started_count'?: number;
    /**
     * The number of times the scorm has been passed
     * @type {number}
     * @memberof ScormAllOf
     */
    'passed_count'?: number;
}
/**
 * 
 * @export
 * @interface ScormRelation
 */
export interface ScormRelation {
    /**
     * Internal middleware record id for scorm
     * @type {number}
     * @memberof ScormRelation
     */
    'id': number;
    /**
     * The title of the scorm
     * @type {string}
     * @memberof ScormRelation
     */
    'title': string;
    /**
     * The identifier of the scorm
     * @type {string}
     * @memberof ScormRelation
     */
    'identifier': string;
    /**
     * The url of the scorm
     * @type {string}
     * @memberof ScormRelation
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface ScormSalesReps
 */
export interface ScormSalesReps {
    /**
     * 
     * @type {number}
     * @memberof ScormSalesReps
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface ScormSco
 */
export interface ScormSco {
    /**
     * Internal middleware record id for scorm sco
     * @type {number}
     * @memberof ScormSco
     */
    'id': number;
    /**
     * The id of the scorm that the sco is associated with
     * @type {number}
     * @memberof ScormSco
     */
    'scorm_id': number;
    /**
     * The uuid of the sco
     * @type {string}
     * @memberof ScormSco
     */
    'uuid': string;
    /**
     * The id of the parent sco
     * @type {number}
     * @memberof ScormSco
     */
    'sco_parent_id': number | null;
    /**
     * The entry url of the sco
     * @type {string}
     * @memberof ScormSco
     */
    'entry_url': string;
    /**
     * The identifier of the sco
     * @type {string}
     * @memberof ScormSco
     */
    'identifier': string;
    /**
     * The title of the sco
     * @type {string}
     * @memberof ScormSco
     */
    'title': string;
    /**
     * Is the sco visible
     * @type {boolean}
     * @memberof ScormSco
     */
    'visible': boolean;
    /**
     * The sco parameters
     * @type {string}
     * @memberof ScormSco
     */
    'sco_parameters': string | null;
    /**
     * The launch data
     * @type {string}
     * @memberof ScormSco
     */
    'launch_data': string | null;
    /**
     * The max time allowed
     * @type {string}
     * @memberof ScormSco
     */
    'max_time_allowed': string | null;
    /**
     * The time limit action
     * @type {string}
     * @memberof ScormSco
     */
    'time_limit_action': string | null;
    /**
     * Is the sco blocked
     * @type {boolean}
     * @memberof ScormSco
     */
    'block': boolean;
    /**
     * The score int
     * @type {number}
     * @memberof ScormSco
     */
    'score_int': number | null;
    /**
     * The score decimal
     * @type {number}
     * @memberof ScormSco
     */
    'score_decimal': number | null;
    /**
     * The completion threshold
     * @type {number}
     * @memberof ScormSco
     */
    'completion_threshold': number | null;
    /**
     * The prerequisites
     * @type {string}
     * @memberof ScormSco
     */
    'prerequisites': string | null;
    /**
     * the date the record was created
     * @type {string}
     * @memberof ScormSco
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof ScormSco
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface ScormScoTracking
 */
export interface ScormScoTracking {
    /**
     * Internal middleware record id for scorm sco
     * @type {number}
     * @memberof ScormScoTracking
     */
    'id': number;
    /**
     * The id of the user that is associated with the scorm sco
     * @type {number}
     * @memberof ScormScoTracking
     */
    'user_id'?: number;
    /**
     * The id of the scorm that the sco is associated with
     * @type {number}
     * @memberof ScormScoTracking
     */
    'sco_id'?: number;
    /**
     * The uuid of the sco
     * @type {string}
     * @memberof ScormScoTracking
     */
    'uuid'?: string;
    /**
     * User\'s progression of the current scorm
     * @type {number}
     * @memberof ScormScoTracking
     */
    'progression'?: number;
    /**
     * User\'s raw score of the current scorm
     * @type {number}
     * @memberof ScormScoTracking
     */
    'score_raw'?: number;
    /**
     * User\'s min score of the current scorm
     * @type {number}
     * @memberof ScormScoTracking
     */
    'score_min'?: number;
    /**
     * User\'s max score of the current scorm
     * @type {number}
     * @memberof ScormScoTracking
     */
    'score_max'?: number;
    /**
     * User\'s scaled score of the current scorm
     * @type {number}
     * @memberof ScormScoTracking
     */
    'score_scaled'?: number;
    /**
     * User\'s status of the current scorm
     * @type {string}
     * @memberof ScormScoTracking
     */
    'lesson_status'?: string;
    /**
     * User\'s completion status of the current scorm
     * @type {string}
     * @memberof ScormScoTracking
     */
    'completion_status'?: string;
    /**
     * User\'s session time of the current scorm
     * @type {number}
     * @memberof ScormScoTracking
     */
    'session_time'?: number;
    /**
     * User\'s total time of the current scorm
     * @type {number}
     * @memberof ScormScoTracking
     */
    'total_time_int'?: number;
    /**
     * User\'s total time of the current scorm in string format
     * @type {string}
     * @memberof ScormScoTracking
     */
    'total_time_string'?: string;
    /**
     * User\'s entry of the current scorm
     * @type {string}
     * @memberof ScormScoTracking
     */
    'entry'?: string;
    /**
     * User\'s suspend data of the current scorm
     * @type {string}
     * @memberof ScormScoTracking
     */
    'suspend_data'?: string;
    /**
     * User\'s credit of the current scorm
     * @type {string}
     * @memberof ScormScoTracking
     */
    'credit'?: string;
    /**
     * User\'s exit mode of the current scorm
     * @type {string}
     * @memberof ScormScoTracking
     */
    'exit_mode'?: string;
    /**
     * User\'s lesson location of the current scorm
     * @type {string}
     * @memberof ScormScoTracking
     */
    'lesson_location'?: string;
    /**
     * User\'s lesson mode of the current scorm
     * @type {string}
     * @memberof ScormScoTracking
     */
    'lesson_mode'?: string;
    /**
     * Is the scorm sco locked
     * @type {boolean}
     * @memberof ScormScoTracking
     */
    'is_locked'?: boolean;
    /**
     * The details of the scorm sco
     * @type {string}
     * @memberof ScormScoTracking
     */
    'details'?: string;
    /**
     * The latest date of the scorm sco
     * @type {string}
     * @memberof ScormScoTracking
     */
    'latest_date'?: string;
    /**
     * the date the record was created
     * @type {string}
     * @memberof ScormScoTracking
     */
    'created_at'?: string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof ScormScoTracking
     */
    'updated_at'?: string;
    /**
     * 
     * @type {User}
     * @memberof ScormScoTracking
     */
    'user'?: User | null;
    /**
     * 
     * @type {Scorm}
     * @memberof ScormScoTracking
     */
    'scorm'?: Scorm | null;
}
/**
 * 
 * @export
 * @interface ScormScoTrackingRelation
 */
export interface ScormScoTrackingRelation {
    /**
     * Internal middleware record id for scorm sco
     * @type {number}
     * @memberof ScormScoTrackingRelation
     */
    'id': number;
    /**
     * The id of the user that is associated with the scorm sco
     * @type {number}
     * @memberof ScormScoTrackingRelation
     */
    'user_id'?: number;
    /**
     * The id of the scorm that the sco is associated with
     * @type {number}
     * @memberof ScormScoTrackingRelation
     */
    'sco_id'?: number;
    /**
     * User\'s raw score of the current scorm
     * @type {number}
     * @memberof ScormScoTrackingRelation
     */
    'score_raw'?: number;
    /**
     * Max score of the current scorm
     * @type {number}
     * @memberof ScormScoTrackingRelation
     */
    'score_max'?: number;
    /**
     * User\'s status of the current scorm
     * @type {string}
     * @memberof ScormScoTrackingRelation
     */
    'lesson_status'?: string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof ScormScoTrackingRelation
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface ScormShared
 */
export interface ScormShared {
    /**
     * Internal middleware record id for scorm
     * @type {number}
     * @memberof ScormShared
     */
    'id': number;
    /**
     * The url of the scorm
     * @type {string}
     * @memberof ScormShared
     */
    'url': string;
    /**
     * The type of resource that the scorm is associated with
     * @type {string}
     * @memberof ScormShared
     */
    'resource_type': string | null;
    /**
     * The id of the resource that the scorm is associated with
     * @type {number}
     * @memberof ScormShared
     */
    'resource_id': number | null;
    /**
     * The title of the scorm
     * @type {string}
     * @memberof ScormShared
     */
    'title': string;
    /**
     * The original file that was uploaded
     * @type {string}
     * @memberof ScormShared
     */
    'origin_file': string;
    /**
     * The version of the scorm (should be scorm_12)
     * @type {string}
     * @memberof ScormShared
     */
    'version': string;
    /**
     * The ratio of the scorm
     * @type {string}
     * @memberof ScormShared
     */
    'ratio': string | null;
    /**
     * The identifier of the scorm
     * @type {string}
     * @memberof ScormShared
     */
    'identifier': string;
    /**
     * The entry url of the scorm
     * @type {string}
     * @memberof ScormShared
     */
    'entry_url': string;
    /**
     * The scos that are associated with this scorm
     * @type {Array<ScormSco>}
     * @memberof ScormShared
     */
    'scos': Array<ScormSco>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof ScormShared
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof ScormShared
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface SentQuote
 */
export interface SentQuote {
    /**
     * 
     * @type {number}
     * @memberof SentQuote
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SentQuote
     */
    'status': SentQuoteStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SentQuote
     */
    'project_name': string;
    /**
     * 
     * @type {string}
     * @memberof SentQuote
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof SentQuote
     */
    'address2'?: string;
    /**
     * 
     * @type {string}
     * @memberof SentQuote
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof SentQuote
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof SentQuote
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof SentQuote
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof SentQuote
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SentQuote
     */
    'location_name'?: string;
    /**
     * The company id of the customer location
     * @type {number}
     * @memberof SentQuote
     */
    'company_id': number;
    /**
     * The location id of the customer location
     * @type {number}
     * @memberof SentQuote
     */
    'location_id': number;
    /**
     * The user_id of the quote request
     * @type {number}
     * @memberof SentQuote
     */
    'user_id': number;
    /**
     * The quote request body.  A free text field the user can use to make the quote request
     * @type {string}
     * @memberof SentQuote
     */
    'message'?: string;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof SentQuote
     */
    'company': CompanyRelation | null;
    /**
     * The id of the order attached to this quote
     * @type {number}
     * @memberof SentQuote
     */
    'order_id'?: number | null;
    /**
     * 
     * @type {Order}
     * @memberof SentQuote
     */
    'order'?: Order | null;
    /**
     * 
     * @type {LocationRelation}
     * @memberof SentQuote
     */
    'location': LocationRelation | null;
    /**
     * 
     * @type {UserRelation}
     * @memberof SentQuote
     */
    'user': UserRelation | null;
    /**
     * 
     * @type {Array<FileRelation>}
     * @memberof SentQuote
     */
    'files': Array<FileRelation>;
    /**
     * 
     * @type {Array<ProductRelationWithQuotePivotData>}
     * @memberof SentQuote
     */
    'products': Array<ProductRelationWithQuotePivotData>;
    /**
     * 
     * @type {Array<Response>}
     * @memberof SentQuote
     */
    'responses'?: Array<Response>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof SentQuote
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof SentQuote
     */
    'updated_at': string;
}

export const SentQuoteStatusEnum = {
    Sent: 'sent'
} as const;

export type SentQuoteStatusEnum = typeof SentQuoteStatusEnum[keyof typeof SentQuoteStatusEnum];

/**
 * 
 * @export
 * @interface ShowerConfiguration
 */
export interface ShowerConfiguration {
    /**
     * 
     * @type {string}
     * @memberof ShowerConfiguration
     */
    'key': string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowerConfiguration
     */
    'ada_compliant': boolean;
    /**
     * 
     * @type {TaxonomyTermRelationship}
     * @memberof ShowerConfiguration
     */
    'finish': TaxonomyTermRelationship | null;
    /**
     * 
     * @type {TaxonomyTermRelationship}
     * @memberof ShowerConfiguration
     */
    'flow': TaxonomyTermRelationship | null;
    /**
     * 
     * @type {TaxonomyTermRelationship}
     * @memberof ShowerConfiguration
     */
    'tier': TaxonomyTermRelationship | null;
    /**
     * 
     * @type {TaxonomyTermRelationship}
     * @memberof ShowerConfiguration
     */
    'style': TaxonomyTermRelationship | null;
    /**
     * 
     * @type {Array<ShowerConfigurationProducts>}
     * @memberof ShowerConfiguration
     */
    'products': Array<ShowerConfigurationProducts>;
    /**
     * 
     * @type {Array<ShowerConfigurationMeta>}
     * @memberof ShowerConfiguration
     */
    'meta': Array<ShowerConfigurationMeta>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof ShowerConfiguration
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof ShowerConfiguration
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface ShowerConfigurationAuthorizationKey
 */
export interface ShowerConfigurationAuthorizationKey {
    /**
     * 
     * @type {string}
     * @memberof ShowerConfigurationAuthorizationKey
     */
    'key': string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowerConfigurationAuthorizationKey
     */
    'ada_compliant': boolean;
    /**
     * 
     * @type {TaxonomyTermRelationship}
     * @memberof ShowerConfigurationAuthorizationKey
     */
    'finish': TaxonomyTermRelationship | null;
    /**
     * 
     * @type {TaxonomyTermRelationship}
     * @memberof ShowerConfigurationAuthorizationKey
     */
    'flow': TaxonomyTermRelationship | null;
    /**
     * 
     * @type {TaxonomyTermRelationship}
     * @memberof ShowerConfigurationAuthorizationKey
     */
    'tier': TaxonomyTermRelationship | null;
    /**
     * 
     * @type {TaxonomyTermRelationship}
     * @memberof ShowerConfigurationAuthorizationKey
     */
    'style': TaxonomyTermRelationship | null;
    /**
     * 
     * @type {Array<ShowerConfigurationProducts>}
     * @memberof ShowerConfigurationAuthorizationKey
     */
    'products': Array<ShowerConfigurationProducts>;
    /**
     * 
     * @type {Array<ShowerConfigurationMeta>}
     * @memberof ShowerConfigurationAuthorizationKey
     */
    'meta': Array<ShowerConfigurationMeta>;
    /**
     * the date the record was created
     * @type {string}
     * @memberof ShowerConfigurationAuthorizationKey
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof ShowerConfigurationAuthorizationKey
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof ShowerConfigurationAuthorizationKey
     */
    'authorization_key': string;
}
/**
 * 
 * @export
 * @interface ShowerConfigurationAuthorizationKeyAllOf
 */
export interface ShowerConfigurationAuthorizationKeyAllOf {
    /**
     * 
     * @type {string}
     * @memberof ShowerConfigurationAuthorizationKeyAllOf
     */
    'authorization_key': string;
}
/**
 * 
 * @export
 * @interface ShowerConfigurationMeta
 */
export interface ShowerConfigurationMeta {
    /**
     * 
     * @type {string}
     * @memberof ShowerConfigurationMeta
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ShowerConfigurationMeta
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ShowerConfigurationPivot
 */
export interface ShowerConfigurationPivot {
    /**
     * 
     * @type {string}
     * @memberof ShowerConfigurationPivot
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ShowerConfigurationProducts
 */
export interface ShowerConfigurationProducts {
    /**
     * 
     * @type {string}
     * @memberof ShowerConfigurationProducts
     */
    'sku': string;
    /**
     * 
     * @type {ShowerConfigurationPivot}
     * @memberof ShowerConfigurationProducts
     */
    'pivot': ShowerConfigurationPivot;
}
/**
 * 
 * @export
 * @interface StartImpersonatingResponse
 */
export interface StartImpersonatingResponse {
    /**
     * Type of the token returned
     * @type {string}
     * @memberof StartImpersonatingResponse
     */
    'token_type': string;
    /**
     * Number of seconds until the access token expires
     * @type {number}
     * @memberof StartImpersonatingResponse
     */
    'expires_in': number;
    /**
     * The token used for authorizing requests
     * @type {string}
     * @memberof StartImpersonatingResponse
     */
    'access_token': string;
    /**
     * 
     * @type {RegisteredUser}
     * @memberof StartImpersonatingResponse
     */
    'user': RegisteredUser;
}
/**
 * 
 * @export
 * @interface SuccessModel
 */
export interface SuccessModel {
    /**
     * 
     * @type {string}
     * @memberof SuccessModel
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface SummaryBlock
 */
export interface SummaryBlock {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof SummaryBlock
     */
    'id': number;
    /**
     * 
     * @type {SummaryBlockType}
     * @memberof SummaryBlock
     */
    'type': SummaryBlockType;
    /**
     * 
     * @type {SummaryBlockAllOfContent}
     * @memberof SummaryBlock
     */
    'content': SummaryBlockAllOfContent;
    /**
     * 
     * @type {SummaryBlockSettings}
     * @memberof SummaryBlock
     */
    'settings': SummaryBlockSettings;
}
/**
 * 
 * @export
 * @interface SummaryBlockAllOf
 */
export interface SummaryBlockAllOf {
    /**
     * 
     * @type {SummaryBlockType}
     * @memberof SummaryBlockAllOf
     */
    'type': SummaryBlockType;
    /**
     * 
     * @type {SummaryBlockAllOfContent}
     * @memberof SummaryBlockAllOf
     */
    'content': SummaryBlockAllOfContent;
    /**
     * 
     * @type {SummaryBlockSettings}
     * @memberof SummaryBlockAllOf
     */
    'settings': SummaryBlockSettings;
}
/**
 * Different kinds of pages can have text blocks.  These blocks are simple markdown text. 
 * @export
 * @interface SummaryBlockAllOfContent
 */
export interface SummaryBlockAllOfContent {
    /**
     * A markdown compatible field that contains the content of the block
     * @type {string}
     * @memberof SummaryBlockAllOfContent
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface SummaryBlockSettings
 */
export interface SummaryBlockSettings {
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof SummaryBlockSettings
     */
    'show_totals': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof SummaryBlockSettings
     */
    'show_no_of_units': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof SummaryBlockSettings
     */
    'show_list_price': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof SummaryBlockSettings
     */
    'show_net_price': PropertyVisibility;
    /**
     * 
     * @type {PropertyVisibility}
     * @memberof SummaryBlockSettings
     */
    'show_ext_price': PropertyVisibility;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SummaryBlockType = {
    Summary: 'summary'
} as const;

export type SummaryBlockType = typeof SummaryBlockType[keyof typeof SummaryBlockType];


/**
 * 
 * @export
 * @interface SummaryBlockUpdate
 */
export interface SummaryBlockUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof SummaryBlockUpdate
     */
    'id': number | null;
    /**
     * 
     * @type {SummaryBlockType}
     * @memberof SummaryBlockUpdate
     */
    'type': SummaryBlockType;
    /**
     * 
     * @type {SummaryBlockAllOfContent}
     * @memberof SummaryBlockUpdate
     */
    'content': SummaryBlockAllOfContent;
    /**
     * 
     * @type {SummaryBlockSettings}
     * @memberof SummaryBlockUpdate
     */
    'settings': SummaryBlockSettings;
}
/**
 * 
 * @export
 * @interface SummaryPage
 */
export interface SummaryPage {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof SummaryPage
     */
    'id': number;
    /**
     * The name of the page
     * @type {string}
     * @memberof SummaryPage
     */
    'name': string;
    /**
     * 
     * @type {SummaryPageType}
     * @memberof SummaryPage
     */
    'type': SummaryPageType;
    /**
     * 
     * @type {Array<SummaryBlock>}
     * @memberof SummaryPage
     */
    'blocks': Array<SummaryBlock>;
}
/**
 * 
 * @export
 * @interface SummaryPageAllOf
 */
export interface SummaryPageAllOf {
    /**
     * 
     * @type {SummaryPageType}
     * @memberof SummaryPageAllOf
     */
    'type': SummaryPageType;
    /**
     * 
     * @type {Array<SummaryBlock>}
     * @memberof SummaryPageAllOf
     */
    'blocks': Array<SummaryBlock>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SummaryPageType = {
    Summary: 'summary'
} as const;

export type SummaryPageType = typeof SummaryPageType[keyof typeof SummaryPageType];


/**
 * 
 * @export
 * @interface SummaryPageUpdate
 */
export interface SummaryPageUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof SummaryPageUpdate
     */
    'id': number | null;
    /**
     * The name of the page
     * @type {string}
     * @memberof SummaryPageUpdate
     */
    'name': string;
    /**
     * 
     * @type {SummaryPageType}
     * @memberof SummaryPageUpdate
     */
    'type': SummaryPageType;
    /**
     * 
     * @type {Array<SummaryBlockUpdate>}
     * @memberof SummaryPageUpdate
     */
    'blocks': Array<SummaryBlockUpdate>;
}
/**
 * 
 * @export
 * @interface SummaryPageUpdateAllOf
 */
export interface SummaryPageUpdateAllOf {
    /**
     * 
     * @type {SummaryPageType}
     * @memberof SummaryPageUpdateAllOf
     */
    'type': SummaryPageType;
    /**
     * 
     * @type {Array<SummaryBlockUpdate>}
     * @memberof SummaryPageUpdateAllOf
     */
    'blocks': Array<SummaryBlockUpdate>;
}
/**
 * 
 * @export
 * @interface SupportBody
 */
export interface SupportBody {
    /**
     * 
     * @type {string}
     * @memberof SupportBody
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SupportBody
     */
    'body': string;
    /**
     * A list of files to attach to the support request
     * @type {Array<SupportBodyFiles>}
     * @memberof SupportBody
     */
    'files'?: Array<SupportBodyFiles>;
}
/**
 * 
 * @export
 * @interface SupportBodyFiles
 */
export interface SupportBodyFiles {
    /**
     * The id of the file being attached. It must be owned by the current user
     * @type {number}
     * @memberof SupportBodyFiles
     */
    'id': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TaxonomyTerm = {
    Finish: 'finish',
    Flow: 'flow',
    Term: 'term',
    Style: 'style',
    Category: 'category',
    Tier: 'tier',
    Type: 'type'
} as const;

export type TaxonomyTerm = typeof TaxonomyTerm[keyof typeof TaxonomyTerm];


/**
 * 
 * @export
 * @interface TaxonomyTermConnect
 */
export interface TaxonomyTermConnect {
    /**
     * 
     * @type {number}
     * @memberof TaxonomyTermConnect
     */
    'id': number | null;
    /**
     * 
     * @type {string}
     * @memberof TaxonomyTermConnect
     */
    'term': string;
    /**
     * 
     * @type {TaxonomyTerm}
     * @memberof TaxonomyTermConnect
     */
    'type': TaxonomyTerm;
    /**
     * 
     * @type {string}
     * @memberof TaxonomyTermConnect
     */
    'icon'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaxonomyTermConnect
     */
    'featured'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaxonomyTermConnect
     */
    'dashboard'?: boolean;
}
/**
 * 
 * @export
 * @interface TaxonomyTermRelationship
 */
export interface TaxonomyTermRelationship {
    /**
     * 
     * @type {number}
     * @memberof TaxonomyTermRelationship
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TaxonomyTermRelationship
     */
    'term': string;
    /**
     * 
     * @type {TaxonomyTerm}
     * @memberof TaxonomyTermRelationship
     */
    'type': TaxonomyTerm;
    /**
     * 
     * @type {string}
     * @memberof TaxonomyTermRelationship
     */
    'icon'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaxonomyTermRelationship
     */
    'featured'?: boolean;
}
/**
 * Top-level calculation toggle on the wizard Results page. `hunters` is Hunter\'s / ASME method (implemented today). `symmons` is the proprietary Symmons method (not yet implemented). 
 * @export
 * @enum {string}
 */

export const TempControlCalculationMethod = {
    Hunters: 'hunters',
    Symmons: 'symmons'
} as const;

export type TempControlCalculationMethod = typeof TempControlCalculationMethod[keyof typeof TempControlCalculationMethod];


/**
 * 
 * @export
 * @enum {string}
 */

export const TempControlFacilityType = {
    Apartment: 'apartment',
    Hospital: 'hospital',
    Hotel: 'hotel',
    Office: 'office',
    School: 'school',
    Club: 'club',
    Gym: 'gym',
    Industrial: 'industrial',
    MaximumFlow: 'maximum_flow'
} as const;

export type TempControlFacilityType = typeof TempControlFacilityType[keyof typeof TempControlFacilityType];


/**
 * 
 * @export
 * @interface TempControlFixture
 */
export interface TempControlFixture {
    /**
     * 14 fixture types, indexed 0-13: 0=Basin (private), 1=Basin (public), 2=Bathtub, 3=Therapeutic bath, 4=Kitchen sink, 5=Pantry sink, 6=Service sink, 7=Shower, 8=Circular wash fountain, 9=Semi-circular wash fountain, 10=Residential dishwasher, 11=Commercial dishwasher, 12=Residential washing machine, 13=Commercial washing machine. 
     * @type {number}
     * @memberof TempControlFixture
     */
    'type': number;
    /**
     * 
     * @type {number}
     * @memberof TempControlFixture
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof TempControlFixture
     */
    'flow_rate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TempControlFixture
     */
    'hot_temp'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TempControlFixture
     */
    'cold_temp'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TempControlFixture
     */
    'desired_temp'?: number | null;
}
/**
 * SPB-parity PDF lifecycle. The wizard / portal poll the show endpoint and react to terminal states:  - `idle`        — no render has been requested yet. - `queued`      — a generate job has been dispatched. - `generating`  — the queue worker is rendering. - `ready`       — PDF is on the private filesystem and `GET                   /tempcontrol/projects/{key}/download` will                   return it. - `failed`      — the last render threw; trigger another                   `POST .../download` to retry. 
 * @export
 * @enum {string}
 */

export const TempControlPdfStatus = {
    Idle: 'idle',
    Queued: 'queued',
    Generating: 'generating',
    Ready: 'ready',
    Failed: 'failed'
} as const;

export type TempControlPdfStatus = typeof TempControlPdfStatus[keyof typeof TempControlPdfStatus];


/**
 * 
 * @export
 * @interface TempControlProject
 */
export interface TempControlProject {
    /**
     * 
     * @type {string}
     * @memberof TempControlProject
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof TempControlProject
     */
    'project_name': string;
    /**
     * 
     * @type {string}
     * @memberof TempControlProject
     */
    'customer_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TempControlProject
     */
    'customer_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TempControlProject
     */
    'customer_company'?: string | null;
    /**
     * Owner ID. `null` for anonymous projects created from the public wizard. Used by CASL ability rules on the frontend. 
     * @type {number}
     * @memberof TempControlProject
     */
    'user_id'?: number | null;
    /**
     * 
     * @type {TempControlProjectStatus}
     * @memberof TempControlProject
     */
    'status': TempControlProjectStatus;
    /**
     * Calculation method used for the persisted result. `hunters` = Hunter\'s / ASME (implemented). `symmons` = proprietary Symmons method (future). 
     * @type {string}
     * @memberof TempControlProject
     */
    'method'?: TempControlProjectMethodEnum;
    /**
     * 
     * @type {TempControlValveFamily}
     * @memberof TempControlProject
     */
    'valve_family'?: TempControlValveFamily;
    /**
     * 
     * @type {number}
     * @memberof TempControlProject
     */
    'current_step': number;
    /**
     * 
     * @type {TempControlProjectInputs}
     * @memberof TempControlProject
     */
    'inputs'?: TempControlProjectInputs;
    /**
     * 
     * @type {TempControlSizingResult}
     * @memberof TempControlProject
     */
    'result'?: TempControlSizingResult | null;
    /**
     * 
     * @type {string}
     * @memberof TempControlProject
     */
    'completed_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TempControlProject
     */
    'last_downloaded_at'?: string | null;
    /**
     * Set when the project has been soft-deleted from the customer portal.
     * @type {string}
     * @memberof TempControlProject
     */
    'deleted_at'?: string | null;
    /**
     * 
     * @type {TempControlPdfStatus}
     * @memberof TempControlProject
     */
    'pdf_status': TempControlPdfStatus;
    /**
     * Set when the queue-rendered PDF was uploaded to the private filesystem. Cleared whenever inputs change or a new calculation runs (the cached file is then stale). 
     * @type {string}
     * @memberof TempControlProject
     */
    'pdf_generated_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TempControlProject
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof TempControlProject
     */
    'updated_at'?: string;
    /**
     * Owner of the project. Only included for admin / sales-rep list responses; null for anonymous projects. 
     * @type {RegisteredUser}
     * @memberof TempControlProject
     */
    'user'?: RegisteredUser | null;
}

export const TempControlProjectMethodEnum = {
    Hunters: 'hunters',
    Symmons: 'symmons'
} as const;

export type TempControlProjectMethodEnum = typeof TempControlProjectMethodEnum[keyof typeof TempControlProjectMethodEnum];

/**
 * 
 * @export
 * @interface TempControlProjectAuthorizationKey
 */
export interface TempControlProjectAuthorizationKey {
    /**
     * 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'project_name': string;
    /**
     * 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'customer_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'customer_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'customer_company'?: string | null;
    /**
     * Owner ID. `null` for anonymous projects created from the public wizard. Used by CASL ability rules on the frontend. 
     * @type {number}
     * @memberof TempControlProjectAuthorizationKey
     */
    'user_id'?: number | null;
    /**
     * 
     * @type {TempControlProjectStatus}
     * @memberof TempControlProjectAuthorizationKey
     */
    'status': TempControlProjectStatus;
    /**
     * Calculation method used for the persisted result. `hunters` = Hunter\'s / ASME (implemented). `symmons` = proprietary Symmons method (future). 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'method'?: TempControlProjectAuthorizationKeyMethodEnum;
    /**
     * 
     * @type {TempControlValveFamily}
     * @memberof TempControlProjectAuthorizationKey
     */
    'valve_family'?: TempControlValveFamily;
    /**
     * 
     * @type {number}
     * @memberof TempControlProjectAuthorizationKey
     */
    'current_step': number;
    /**
     * 
     * @type {TempControlProjectInputs}
     * @memberof TempControlProjectAuthorizationKey
     */
    'inputs'?: TempControlProjectInputs;
    /**
     * 
     * @type {TempControlSizingResult}
     * @memberof TempControlProjectAuthorizationKey
     */
    'result'?: TempControlSizingResult | null;
    /**
     * 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'completed_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'last_downloaded_at'?: string | null;
    /**
     * Set when the project has been soft-deleted from the customer portal.
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'deleted_at'?: string | null;
    /**
     * 
     * @type {TempControlPdfStatus}
     * @memberof TempControlProjectAuthorizationKey
     */
    'pdf_status': TempControlPdfStatus;
    /**
     * Set when the queue-rendered PDF was uploaded to the private filesystem. Cleared whenever inputs change or a new calculation runs (the cached file is then stale). 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'pdf_generated_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'updated_at'?: string;
    /**
     * Owner of the project. Only included for admin / sales-rep list responses; null for anonymous projects. 
     * @type {RegisteredUser}
     * @memberof TempControlProjectAuthorizationKey
     */
    'user'?: RegisteredUser | null;
    /**
     * Computed hash to be sent on subsequent requests as the `Authorization-Key` header for guest edits.  **Only issued for genuinely anonymous projects** (no `user_id`). Owned projects return `null` here and rely on the bearer-token policy gate; clients must NOT attempt to persist or send an `Authorization-Key` for them. 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKey
     */
    'authorization_key': string | null;
}

export const TempControlProjectAuthorizationKeyMethodEnum = {
    Hunters: 'hunters',
    Symmons: 'symmons'
} as const;

export type TempControlProjectAuthorizationKeyMethodEnum = typeof TempControlProjectAuthorizationKeyMethodEnum[keyof typeof TempControlProjectAuthorizationKeyMethodEnum];

/**
 * 
 * @export
 * @interface TempControlProjectAuthorizationKeyAllOf
 */
export interface TempControlProjectAuthorizationKeyAllOf {
    /**
     * Computed hash to be sent on subsequent requests as the `Authorization-Key` header for guest edits.  **Only issued for genuinely anonymous projects** (no `user_id`). Owned projects return `null` here and rely on the bearer-token policy gate; clients must NOT attempt to persist or send an `Authorization-Key` for them. 
     * @type {string}
     * @memberof TempControlProjectAuthorizationKeyAllOf
     */
    'authorization_key': string | null;
}
/**
 * Persisted wizard inputs. Every property is optional so partial saves can be issued from any wizard step; calculation enforces completeness. 
 * @export
 * @interface TempControlProjectInputs
 */
export interface TempControlProjectInputs {
    /**
     * 
     * @type {TempControlFacilityType}
     * @memberof TempControlProjectInputs
     */
    'facility'?: TempControlFacilityType;
    /**
     * 
     * @type {TempControlSizingMethod}
     * @memberof TempControlProjectInputs
     */
    'method'?: TempControlSizingMethod;
    /**
     * 
     * @type {TempControlValveFamily}
     * @memberof TempControlProjectInputs
     */
    'family'?: TempControlValveFamily;
    /**
     * 
     * @type {number}
     * @memberof TempControlProjectInputs
     */
    'allowable_psi'?: number;
    /**
     * 
     * @type {Array<TempControlFixture>}
     * @memberof TempControlProjectInputs
     */
    'fixtures'?: Array<TempControlFixture>;
    /**
     * 
     * @type {TempControlValveOptions}
     * @memberof TempControlProjectInputs
     */
    'options'?: TempControlValveOptions;
}
/**
 * Lifecycle column for a TempControl project. `draft` covers any wizard state up to and including the calculated result; the project flips to `completed` the first time the user downloads a PDF. 
 * @export
 * @enum {string}
 */

export const TempControlProjectStatus = {
    Draft: 'draft',
    Completed: 'completed'
} as const;

export type TempControlProjectStatus = typeof TempControlProjectStatus[keyof typeof TempControlProjectStatus];


/**
 * Internal flow-derivation method used by the Hunter\'s sizing engine.
 * @export
 * @enum {string}
 */

export const TempControlSizingMethod = {
    Hunter: 'hunter',
    MaxUse: 'max_use',
    MixingValve: 'mixing_valve'
} as const;

export type TempControlSizingMethod = typeof TempControlSizingMethod[keyof typeof TempControlSizingMethod];


/**
 * 
 * @export
 * @interface TempControlSizingResult
 */
export interface TempControlSizingResult {
    /**
     * Symmons valve series id (e.g. \"7-400\") or null when no fit.
     * @type {string}
     * @memberof TempControlSizingResult
     */
    'valve_series'?: string | null;
    /**
     * Assembled part number with all suffixes and any [N] manifold prefix.
     * @type {string}
     * @memberof TempControlSizingResult
     */
    'part_number'?: string | null;
    /**
     * Number of additional parallel valves selected (0 = single valve).
     * @type {number}
     * @memberof TempControlSizingResult
     */
    'manifold_count': number;
    /**
     * 
     * @type {number}
     * @memberof TempControlSizingResult
     */
    'total_fixture_units': number;
    /**
     * 
     * @type {number}
     * @memberof TempControlSizingResult
     */
    'total_flow_gpm': number;
    /**
     * 
     * @type {number}
     * @memberof TempControlSizingResult
     */
    'actual_press_drop_psi': number;
    /**
     * 
     * @type {string}
     * @memberof TempControlSizingResult
     */
    'ips_label'?: string | null;
    /**
     * True when the user requested low-temp but the chosen valve series is ineligible.
     * @type {boolean}
     * @memberof TempControlSizingResult
     */
    'low_temp_cleared': boolean;
    /**
     * 
     * @type {string}
     * @memberof TempControlSizingResult
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TempControlValveFamily = {
    Digital: 'digital',
    Conventional: 'conventional'
} as const;

export type TempControlValveFamily = typeof TempControlValveFamily[keyof typeof TempControlValveFamily];


/**
 * 
 * @export
 * @interface TempControlValveOptions
 */
export interface TempControlValveOptions {
    /**
     * 
     * @type {boolean}
     * @memberof TempControlValveOptions
     */
    'piping_package'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TempControlValveOptions
     */
    'factory_assembled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TempControlValveOptions
     */
    'cold_water_bypass'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TempControlValveOptions
     */
    'wall_mounts'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TempControlValveOptions
     */
    'top_supplies'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TempControlValveOptions
     */
    'vacuum_breaker'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TempControlValveOptions
     */
    'low_temp'?: boolean;
}
/**
 * 
 * @export
 * @interface TerritoriesResponse
 */
export interface TerritoriesResponse {
    /**
     * 
     * @type {Array<Territory>}
     * @memberof TerritoriesResponse
     */
    'data': Array<Territory>;
}
/**
 * 
 * @export
 * @interface Territory
 */
export interface Territory {
    /**
     * 
     * @type {number}
     * @memberof Territory
     */
    'id': number;
    /**
     * The territory ID from Symmons API
     * @type {string}
     * @memberof Territory
     */
    'territory_id': string;
    /**
     * The territory name from Symmons API
     * @type {string}
     * @memberof Territory
     */
    'territory_name': string;
    /**
     * The ID of the associated region
     * @type {number}
     * @memberof Territory
     */
    'region_id': number;
    /**
     * 
     * @type {Region}
     * @memberof Territory
     */
    'region'?: Region | null;
    /**
     * the date the record was created
     * @type {string}
     * @memberof Territory
     */
    'created_at': string;
    /**
     * the date the record was last updated
     * @type {string}
     * @memberof Territory
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface TerritoryRelation
 */
export interface TerritoryRelation {
    /**
     * 
     * @type {number}
     * @memberof TerritoryRelation
     */
    'id': number;
    /**
     * The territory ID from Symmons API
     * @type {string}
     * @memberof TerritoryRelation
     */
    'territory_id': string;
    /**
     * The territory name from Symmons API
     * @type {string}
     * @memberof TerritoryRelation
     */
    'territory_name': string;
    /**
     * 
     * @type {RegionRelation}
     * @memberof TerritoryRelation
     */
    'region'?: RegionRelation | null;
}
/**
 * 
 * @export
 * @interface TerritoryResponse
 */
export interface TerritoryResponse {
    /**
     * 
     * @type {Territory}
     * @memberof TerritoryResponse
     */
    'data': Territory;
}
/**
 * 
 * @export
 * @interface TextBlock
 */
export interface TextBlock {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof TextBlock
     */
    'id': number;
    /**
     * 
     * @type {TextBlockType}
     * @memberof TextBlock
     */
    'type': TextBlockType;
    /**
     * 
     * @type {TextBlockAllOfContent}
     * @memberof TextBlock
     */
    'content': TextBlockAllOfContent;
}
/**
 * 
 * @export
 * @interface TextBlockAllOf
 */
export interface TextBlockAllOf {
    /**
     * 
     * @type {TextBlockType}
     * @memberof TextBlockAllOf
     */
    'type': TextBlockType;
    /**
     * 
     * @type {TextBlockAllOfContent}
     * @memberof TextBlockAllOf
     */
    'content': TextBlockAllOfContent;
}
/**
 * Different kinds of pages can have text blocks.  These blocks are simple markdown text. 
 * @export
 * @interface TextBlockAllOfContent
 */
export interface TextBlockAllOfContent {
    /**
     * A markdown compatible field that contains the content of the block
     * @type {string}
     * @memberof TextBlockAllOfContent
     */
    'content': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TextBlockType = {
    Text: 'text'
} as const;

export type TextBlockType = typeof TextBlockType[keyof typeof TextBlockType];


/**
 * 
 * @export
 * @interface TextBlockUpdate
 */
export interface TextBlockUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof TextBlockUpdate
     */
    'id': number | null;
    /**
     * 
     * @type {TextBlockType}
     * @memberof TextBlockUpdate
     */
    'type': TextBlockType;
    /**
     * 
     * @type {TextBlockAllOfContent}
     * @memberof TextBlockUpdate
     */
    'content': TextBlockAllOfContent;
}
/**
 * 
 * @export
 * @interface TocPage
 */
export interface TocPage {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof TocPage
     */
    'id': number;
    /**
     * The name of the page
     * @type {string}
     * @memberof TocPage
     */
    'name': string;
    /**
     * 
     * @type {TocPageType}
     * @memberof TocPage
     */
    'type': TocPageType;
    /**
     * 
     * @type {Array<TextBlock>}
     * @memberof TocPage
     */
    'blocks': Array<TextBlock>;
}
/**
 * 
 * @export
 * @interface TocPageAllOf
 */
export interface TocPageAllOf {
    /**
     * 
     * @type {TocPageType}
     * @memberof TocPageAllOf
     */
    'type': TocPageType;
    /**
     * 
     * @type {Array<TextBlock>}
     * @memberof TocPageAllOf
     */
    'blocks': Array<TextBlock>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TocPageType = {
    Toc: 'toc'
} as const;

export type TocPageType = typeof TocPageType[keyof typeof TocPageType];


/**
 * 
 * @export
 * @interface TocPageUpdate
 */
export interface TocPageUpdate {
    /**
     * Internal middleware record id for product
     * @type {number}
     * @memberof TocPageUpdate
     */
    'id': number | null;
    /**
     * The name of the page
     * @type {string}
     * @memberof TocPageUpdate
     */
    'name': string;
    /**
     * 
     * @type {TocPageType}
     * @memberof TocPageUpdate
     */
    'type': TocPageType;
    /**
     * 
     * @type {Array<TextBlockUpdate>}
     * @memberof TocPageUpdate
     */
    'blocks': Array<TextBlockUpdate>;
}
/**
 * 
 * @export
 * @interface TocPageUpdateAllOf
 */
export interface TocPageUpdateAllOf {
    /**
     * 
     * @type {TocPageType}
     * @memberof TocPageUpdateAllOf
     */
    'type': TocPageType;
    /**
     * 
     * @type {Array<TextBlockUpdate>}
     * @memberof TocPageUpdateAllOf
     */
    'blocks': Array<TextBlockUpdate>;
}
/**
 * 
 * @export
 * @interface UpdateAgencyBody
 */
export interface UpdateAgencyBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyBody
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgencyBody
     */
    'status'?: number;
    /**
     * The ID of the assigned territory
     * @type {number}
     * @memberof UpdateAgencyBody
     */
    'territory_id'?: number | null;
    /**
     * 
     * @type {CompanyRelationUpdate}
     * @memberof UpdateAgencyBody
     */
    'company'?: CompanyRelationUpdate | null;
    /**
     * A list of agency goals to attach
     * @type {Array<AgencyGoalRelationUpdate>}
     * @memberof UpdateAgencyBody
     */
    'goals'?: Array<AgencyGoalRelationUpdate>;
}
/**
 * 
 * @export
 * @interface UpdateCompanyBody
 */
export interface UpdateCompanyBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyBody
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyBody
     */
    'wholesaler'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyBody
     */
    'evolution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyBody
     */
    'direct_buyer'?: boolean;
    /**
     * 
     * @type {Array<CompanyIdAddresses>}
     * @memberof UpdateCompanyBody
     */
    'addresses': Array<CompanyIdAddresses>;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanyBody
     */
    'sales_rep_id': number | null;
    /**
     * The territory id assigned to this company
     * @type {number}
     * @memberof UpdateCompanyBody
     */
    'territory_id'?: number | null;
    /**
     * 
     * @type {Array<ScormSalesReps>}
     * @memberof UpdateCompanyBody
     */
    'sales_reps': Array<ScormSalesReps>;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanyBody
     */
    'status'?: number;
}
/**
 * 
 * @export
 * @interface UpdateIntroductionBody
 */
export interface UpdateIntroductionBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateIntroductionBody
     */
    'name': string;
    /**
     * 
     * @type {IntroductionStatus}
     * @memberof UpdateIntroductionBody
     */
    'status'?: IntroductionStatus;
    /**
     * 
     * @type {IntroductionVisibility}
     * @memberof UpdateIntroductionBody
     */
    'visibility'?: IntroductionVisibility;
    /**
     * 
     * @type {string}
     * @memberof UpdateIntroductionBody
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIntroductionBody
     */
    'link'?: string;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof UpdateIntroductionBody
     */
    'image'?: FileRelationUpdate | null;
}
/**
 * 
 * @export
 * @interface UpdateLocationBody
 */
export interface UpdateLocationBody {
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationBody
     */
    'sales_rep_id': number | null;
    /**
     * 
     * @type {Array<ScormSalesReps>}
     * @memberof UpdateLocationBody
     */
    'sales_reps': Array<ScormSalesReps>;
}
/**
 * 
 * @export
 * @interface UpdatePendingQuoteBody
 */
export interface UpdatePendingQuoteBody {
    /**
     * 
     * @type {string}
     * @memberof UpdatePendingQuoteBody
     */
    'status': UpdatePendingQuoteBodyStatusEnum;
    /**
     * A list of products to attach to the quote
     * @type {Array<UpdateQuoteProductRelation>}
     * @memberof UpdatePendingQuoteBody
     */
    'products'?: Array<UpdateQuoteProductRelation>;
}

export const UpdatePendingQuoteBodyStatusEnum = {
    Deleted: 'deleted',
    Pending: 'pending'
} as const;

export type UpdatePendingQuoteBodyStatusEnum = typeof UpdatePendingQuoteBodyStatusEnum[keyof typeof UpdatePendingQuoteBodyStatusEnum];

/**
 * 
 * @export
 * @interface UpdateProductWithID
 */
export interface UpdateProductWithID {
    /**
     * The id of the product being attached.
     * @type {number}
     * @memberof UpdateProductWithID
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductWithID
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface UpdateProductWithSKU
 */
export interface UpdateProductWithSKU {
    /**
     * The sku of the product being attached.
     * @type {string}
     * @memberof UpdateProductWithSKU
     */
    'sku': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductWithSKU
     */
    'quantity': number;
}
/**
 * @type UpdateQuoteBody
 * @export
 */
export type UpdateQuoteBody = UpdatePendingQuoteBody | UpdateSubmittedQuoteBody;

/**
 * @type UpdateQuoteProductRelation
 * @export
 */
export type UpdateQuoteProductRelation = UpdateProductWithID | UpdateProductWithSKU;

/**
 * 
 * @export
 * @interface UpdateResourceBody
 */
export interface UpdateResourceBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateResourceBody
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateResourceBody
     */
    'featured'?: boolean;
    /**
     * 
     * @type {ResourceStatus}
     * @memberof UpdateResourceBody
     */
    'status'?: ResourceStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateResourceBody
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateResourceBody
     */
    'link'?: string;
    /**
     * A list of topics to attach
     * @type {Array<ResourceIdTopics>}
     * @memberof UpdateResourceBody
     */
    'topics'?: Array<ResourceIdTopics>;
    /**
     * A list of files to attach to the resource
     * @type {Array<ResourceFiles>}
     * @memberof UpdateResourceBody
     */
    'files'?: Array<ResourceFiles>;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof UpdateResourceBody
     */
    'image'?: FileRelationUpdate | null;
}
/**
 * 
 * @export
 * @interface UpdateResourceCategory
 */
export interface UpdateResourceCategory {
    /**
     * 
     * @type {string}
     * @memberof UpdateResourceCategory
     */
    'term': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateResourceCategory
     */
    'icon'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateResourceCategory
     */
    'featured'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateResourceCategory
     */
    'dashboard'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateScormBody
 */
export interface UpdateScormBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateScormBody
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateScormBody
     */
    'status'?: number;
}
/**
 * 
 * @export
 * @interface UpdateScormProgressBody
 */
export interface UpdateScormProgressBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateScormProgressBody
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateScormProgressBody
     */
    'user_id': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateScormProgressBody
     */
    'lesson_id': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateScormProgressBody
     */
    'score_raw': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateScormProgressBody
     */
    'cmi.suspend_data': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateScormProgressBody
     */
    'progression': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateScormProgressBody
     */
    'cmi.core.lesson_status': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScormProgressBody
     */
    'completion_status': string;
}
/**
 * 
 * @export
 * @interface UpdateSubmittedQuoteBody
 */
export interface UpdateSubmittedQuoteBody {
    /**
     * The message with the quote
     * @type {string}
     * @memberof UpdateSubmittedQuoteBody
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmittedQuoteBody
     */
    'status': UpdateSubmittedQuoteBodyStatusEnum;
    /**
     * The user supplied project name for the quote
     * @type {string}
     * @memberof UpdateSubmittedQuoteBody
     */
    'project_name': string;
    /**
     * The user supplied city for the quote
     * @type {string}
     * @memberof UpdateSubmittedQuoteBody
     */
    'city': string;
    /**
     * The user supplied state for the quote
     * @type {string}
     * @memberof UpdateSubmittedQuoteBody
     */
    'state': string;
    /**
     * A list of files to attach to the quote
     * @type {Array<ResourceFiles>}
     * @memberof UpdateSubmittedQuoteBody
     */
    'files'?: Array<ResourceFiles>;
    /**
     * A list of products to attach to the quote
     * @type {Array<UpdateQuoteProductRelation>}
     * @memberof UpdateSubmittedQuoteBody
     */
    'products'?: Array<UpdateQuoteProductRelation>;
}

export const UpdateSubmittedQuoteBodyStatusEnum = {
    Sent: 'sent'
} as const;

export type UpdateSubmittedQuoteBodyStatusEnum = typeof UpdateSubmittedQuoteBodyStatusEnum[keyof typeof UpdateSubmittedQuoteBodyStatusEnum];

/**
 * Every field is optional. The `inputs` object is shallow-merged into the persisted inputs JSON; all other fields replace their column. 
 * @export
 * @interface UpdateTempControlProjectBody
 */
export interface UpdateTempControlProjectBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateTempControlProjectBody
     */
    'project_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTempControlProjectBody
     */
    'customer_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTempControlProjectBody
     */
    'customer_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTempControlProjectBody
     */
    'customer_company'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTempControlProjectBody
     */
    'current_step'?: number;
    /**
     * 
     * @type {TempControlProjectInputs}
     * @memberof UpdateTempControlProjectBody
     */
    'inputs'?: TempControlProjectInputs;
}
/**
 * @type User
 * @export
 */
export type User = PendingUser | RegisteredUser;

/**
 * 
 * @export
 * @interface UserRelation
 */
export interface UserRelation {
    /**
     * 
     * @type {number}
     * @memberof UserRelation
     */
    'id': number;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof UserRelation
     */
    'first_name': string | null;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof UserRelation
     */
    'last_name': string | null;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof UserRelation
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserRelation
     */
    'phone': string | null;
    /**
     * 
     * @type {Hours}
     * @memberof UserRelation
     */
    'hours': Hours | null;
    /**
     * 
     * @type {UserRole}
     * @memberof UserRelation
     */
    'role': UserRole;
    /**
     * 
     * @type {FileAvatarRelation}
     * @memberof UserRelation
     */
    'image': FileAvatarRelation | null;
    /**
     * 
     * @type {CompanyRelation}
     * @memberof UserRelation
     */
    'company': CompanyRelation | null;
    /**
     * 
     * @type {Array<TerritoryRelation>}
     * @memberof UserRelation
     */
    'territories'?: Array<TerritoryRelation>;
    /**
     * Can the user buy direct via the quote interface
     * @type {boolean}
     * @memberof UserRelation
     */
    'direct_buyer': boolean;
    /**
     * Is the user\'s company an evolution owner
     * @type {boolean}
     * @memberof UserRelation
     */
    'evolution': boolean;
    /**
     * Is the user\'s company an wholesaler
     * @type {boolean}
     * @memberof UserRelation
     */
    'wholesaler': boolean;
}
/**
 * 
 * @export
 * @interface UserRelationUpdate
 */
export interface UserRelationUpdate {
    /**
     * 
     * @type {number}
     * @memberof UserRelationUpdate
     */
    'id': number;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof UserRelationUpdate
     */
    'first_name'?: string | null;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof UserRelationUpdate
     */
    'last_name'?: string | null;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof UserRelationUpdate
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRelationUpdate
     */
    'phone'?: string | null;
    /**
     * 
     * @type {UserRole}
     * @memberof UserRelationUpdate
     */
    'role'?: UserRole | null;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof UserRelationUpdate
     */
    'image'?: FileRelationUpdate | null;
    /**
     * 
     * @type {CompanyRelationUpdate}
     * @memberof UserRelationUpdate
     */
    'company'?: CompanyRelationUpdate | null;
}
/**
 * The role this user has in the system.
 * @export
 * @enum {string}
 */

export const UserRole = {
    Admin: 'admin',
    CompanyManager: 'company_manager',
    LocationManager: 'location_manager',
    SalesRep: 'sales_rep',
    AgencyRep: 'agency_rep',
    User: 'user',
    ResourceAccess: 'resource_access'
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];


/**
 * 
 * @export
 * @interface UserShared
 */
export interface UserShared {
    /**
     * 
     * @type {number}
     * @memberof UserShared
     */
    'id': number;
    /**
     * Is the user\'s company an wholesaler
     * @type {boolean}
     * @memberof UserShared
     */
    'wholesaler'?: boolean;
    /**
     * Is the user\'s company an evolution owner
     * @type {boolean}
     * @memberof UserShared
     */
    'evolution'?: boolean;
    /**
     * Can the user buy direct via the quote interface
     * @type {boolean}
     * @memberof UserShared
     */
    'direct_buyer'?: boolean;
    /**
     * The company id
     * @type {number}
     * @memberof UserShared
     */
    'company_id': number;
    /**
     * The location id
     * @type {number}
     * @memberof UserShared
     */
    'location_id': number;
    /**
     * The agency id
     * @type {number}
     * @memberof UserShared
     */
    'agency_id': number;
    /**
     * Whether this user has access to all territories
     * @type {boolean}
     * @memberof UserShared
     */
    'all_territories'?: boolean;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof UserShared
     */
    'first_name': string | null;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof UserShared
     */
    'last_name': string | null;
    /**
     * 
     * @type {FileAvatarRelation}
     * @memberof UserShared
     */
    'image': FileAvatarRelation | null;
    /**
     * 
     * @type {PendingQuote}
     * @memberof UserShared
     */
    'pending_quote'?: PendingQuote | null;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof UserShared
     */
    'email': string;
    /**
     * The phone number of the user
     * @type {string}
     * @memberof UserShared
     */
    'phone'?: string | null;
    /**
     * 
     * @type {UserSharedPermissions}
     * @memberof UserShared
     */
    'permissions': UserSharedPermissions;
    /**
     * The last login date
     * @type {string}
     * @memberof UserShared
     */
    'last_login': string | null;
    /**
     * 
     * @type {number}
     * @memberof UserShared
     */
    'login_count': number;
    /**
     * The last login date
     * @type {string}
     * @memberof UserShared
     */
    'last_access': string | null;
    /**
     * 
     * @type {number}
     * @memberof UserShared
     */
    'access_count': number;
    /**
     * 
     * @type {string}
     * @memberof UserShared
     */
    'email_verified_at': string | null;
    /**
     * The date the record was created
     * @type {string}
     * @memberof UserShared
     */
    'created_at': string;
    /**
     * The date the record was last updated
     * @type {string}
     * @memberof UserShared
     */
    'updated_at': string;
    /**
     * Whether the user has enabled 2FA
     * @type {boolean}
     * @memberof UserShared
     */
    'google2fa_enabled'?: boolean;
}
/**
 * Base level users have togglable user permissions.  Each permission can be toggled individually. 
 * @export
 * @interface UserSharedPermissions
 */
export interface UserSharedPermissions {
    /**
     * Can user view their own orders?
     * @type {boolean}
     * @memberof UserSharedPermissions
     */
    'can_view_my_orders'?: boolean;
    /**
     * Can users view orders in their location?
     * @type {boolean}
     * @memberof UserSharedPermissions
     */
    'can_view_location_orders'?: boolean;
    /**
     * Can user view orders in the company?
     * @type {boolean}
     * @memberof UserSharedPermissions
     */
    'can_view_company_orders'?: boolean;
    /**
     * Can the user access pricing?
     * @type {boolean}
     * @memberof UserSharedPermissions
     */
    'can_view_pricing'?: boolean;
    /**
     * Can user view agency goals?
     * @type {boolean}
     * @memberof UserSharedPermissions
     */
    'can_view_agency_goals'?: boolean;
}
/**
 * @type UserStatus
 * @export
 */
export type UserStatus = PendingUserStatus | RegisteredUserStatus;

/**
 * 
 * @export
 * @interface UserUpdate
 */
export interface UserUpdate {
    /**
     * 
     * @type {RegisteredUserStatus}
     * @memberof UserUpdate
     */
    'status'?: RegisteredUserStatus;
    /**
     * The first_name of the validated customer
     * @type {string}
     * @memberof UserUpdate
     */
    'first_name'?: string;
    /**
     * The last_name of the validated customer
     * @type {string}
     * @memberof UserUpdate
     */
    'last_name'?: string;
    /**
     * 
     * @type {UserUpdateCompany}
     * @memberof UserUpdate
     */
    'company'?: UserUpdateCompany;
    /**
     * 
     * @type {UserUpdateLocation}
     * @memberof UserUpdate
     */
    'location'?: UserUpdateLocation;
    /**
     * The email of the validated customer
     * @type {string}
     * @memberof UserUpdate
     */
    'email'?: string;
    /**
     * Whether the user has enabled 2FA
     * @type {boolean}
     * @memberof UserUpdate
     */
    'google2fa_enabled'?: boolean;
    /**
     * 
     * @type {UserRole}
     * @memberof UserUpdate
     */
    'role'?: UserRole;
    /**
     * 
     * @type {FileRelationUpdate}
     * @memberof UserUpdate
     */
    'image'?: FileRelationUpdate | null;
    /**
     * 
     * @type {UserSharedPermissions}
     * @memberof UserUpdate
     */
    'permissions'?: UserSharedPermissions;
    /**
     * A list of territories to attach
     * @type {Array<UserUpdateTerritories>}
     * @memberof UserUpdate
     */
    'territories'?: Array<UserUpdateTerritories>;
}
/**
 * The company to attach the user to.  Only admins can change the company of a user
 * @export
 * @interface UserUpdateCompany
 */
export interface UserUpdateCompany {
    /**
     * The company id
     * @type {number}
     * @memberof UserUpdateCompany
     */
    'id'?: number;
}
/**
 * The location that the user is attached to.  Admins and managers can change the user location
 * @export
 * @interface UserUpdateLocation
 */
export interface UserUpdateLocation {
    /**
     * The location id
     * @type {number}
     * @memberof UserUpdateLocation
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UserUpdateTerritories
 */
export interface UserUpdateTerritories {
    /**
     * The id of the territory being attached.
     * @type {number}
     * @memberof UserUpdateTerritories
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface VerifyTwoFactorBody
 */
export interface VerifyTwoFactorBody {
    /**
     * The 2FA code to verify
     * @type {string}
     * @memberof VerifyTwoFactorBody
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface VerifyTwoFactorResponse
 */
export interface VerifyTwoFactorResponse {
    /**
     * The status of the verification
     * @type {string}
     * @memberof VerifyTwoFactorResponse
     */
    'status': string;
    /**
     * The message of the verification
     * @type {string}
     * @memberof VerifyTwoFactorResponse
     */
    'message': string;
}

/**
 * AgencyApi - axios parameter creator
 * @export
 */
export const AgencyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update a agency with a specific id 
         * @summary Create agency
         * @param {CreateAgencyBody} createAgencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgency: (createAgencyBody: CreateAgencyBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createAgencyBody' is not null or undefined
            assertParamExists('createAgency', 'createAgencyBody', createAgencyBody)
            const localVarPath = `/agency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAgencyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a agency with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Agency
         * @param {number} id The id of the Agency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgency: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAgency', 'id', id)
            const localVarPath = `/agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single agency by id 
         * @summary Get Agency
         * @param {number} id The id of the agency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgency: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgency', 'id', id)
            const localVarPath = `/agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of agencies.  This route only is available to symmons admins 
         * @summary List Agencies
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {number} [agencyId] Filters agencies.  Ignored for non-admins.  Users will see only their own agency when fetching a list
         * @param {number} [salesRepId] Filters agencies by sales rep id
         * @param {number} [territoryId] Filters agencies by territory id
         * @param {string} [state] 
         * @param {string} [name] 
         * @param {number} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgencies: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, agencyId?: number, salesRepId?: number, territoryId?: number, state?: string, name?: string, status?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/agencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (agencyId !== undefined) {
                localVarQueryParameter['agency_id'] = agencyId;
            }

            if (salesRepId !== undefined) {
                localVarQueryParameter['sales_rep_id'] = salesRepId;
            }

            if (territoryId !== undefined) {
                localVarQueryParameter['territory_id'] = territoryId;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a agency with a specific id 
         * @summary Update Agency
         * @param {number} id The id of the agency
         * @param {UpdateAgencyBody} updateAgencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgency: (id: number, updateAgencyBody: UpdateAgencyBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAgency', 'id', id)
            // verify required parameter 'updateAgencyBody' is not null or undefined
            assertParamExists('updateAgency', 'updateAgencyBody', updateAgencyBody)
            const localVarPath = `/agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAgencyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyApi - functional programming interface
 * @export
 */
export const AgencyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgencyApiAxiosParamCreator(configuration)
    return {
        /**
         * Update a agency with a specific id 
         * @summary Create agency
         * @param {AgencyApiCreateAgencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgency(requestParameters: AgencyApiCreateAgencyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Agency>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createAgency(requestParameters.createAgencyBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a agency with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Agency
         * @param {AgencyApiDeleteAgencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgency(requestParameters: AgencyApiDeleteAgencyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteAgency(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single agency by id 
         * @summary Get Agency
         * @param {AgencyApiGetAgencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgency(requestParameters: AgencyApiGetAgencyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Agency>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getAgency(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of agencies.  This route only is available to symmons admins 
         * @summary List Agencies
         * @param {AgencyApiListAgenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgencies(requestParameters: AgencyApiListAgenciesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedAgencies>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listAgencies(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.agencyId, requestParameters.salesRepId, requestParameters.territoryId, requestParameters.state, requestParameters.name, requestParameters.status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a agency with a specific id 
         * @summary Update Agency
         * @param {AgencyApiUpdateAgencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgency(requestParameters: AgencyApiUpdateAgencyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Agency>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateAgency(requestParameters.id, requestParameters.updateAgencyBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgencyApi - factory interface
 * @export
 */
export const AgencyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgencyApiFp(configuration)

    /**
      * Update a agency with a specific id 
      * @summary Create agency
      * @param {AgencyApiCreateAgencyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createAgency = (requestParameters: AgencyApiCreateAgencyRequest, options?: any): AxiosPromise<Agency> => {
        const request = localVarFp.createAgency(requestParameters, options);
        return request(axios, basePath);
    };

    createAgency.getQueryKey = (requestParameters: AgencyApiCreateAgencyRequest, options?: any) => {
        const request = localVarFp.createAgency(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a agency with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete Agency
      * @param {AgencyApiDeleteAgencyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteAgency = (requestParameters: AgencyApiDeleteAgencyRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteAgency(requestParameters, options);
        return request(axios, basePath);
    };

    deleteAgency.getQueryKey = (requestParameters: AgencyApiDeleteAgencyRequest, options?: any) => {
        const request = localVarFp.deleteAgency(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single agency by id 
      * @summary Get Agency
      * @param {AgencyApiGetAgencyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getAgency = (requestParameters: AgencyApiGetAgencyRequest, options?: any): AxiosPromise<Agency> => {
        const request = localVarFp.getAgency(requestParameters, options);
        return request(axios, basePath);
    };

    getAgency.getQueryKey = (requestParameters: AgencyApiGetAgencyRequest, options?: any) => {
        const request = localVarFp.getAgency(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of agencies.  This route only is available to symmons admins 
      * @summary List Agencies
      * @param {AgencyApiListAgenciesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listAgencies = (requestParameters: AgencyApiListAgenciesRequest = {}, options?: any): AxiosPromise<PaginatedAgencies> => {
        const request = localVarFp.listAgencies(requestParameters, options);
        return request(axios, basePath);
    };

    listAgencies.getQueryKey = (requestParameters: AgencyApiListAgenciesRequest = {}, options?: any) => {
        const request = localVarFp.listAgencies(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a agency with a specific id 
      * @summary Update Agency
      * @param {AgencyApiUpdateAgencyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateAgency = (requestParameters: AgencyApiUpdateAgencyRequest, options?: any): AxiosPromise<Agency> => {
        const request = localVarFp.updateAgency(requestParameters, options);
        return request(axios, basePath);
    };

    updateAgency.getQueryKey = (requestParameters: AgencyApiUpdateAgencyRequest, options?: any) => {
        const request = localVarFp.updateAgency(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createAgency,
        deleteAgency,
        getAgency,
        listAgencies,
        updateAgency,
    };
};

/**
 * AgencyApi - interface
 * @export
 * @interface AgencyApi
 */
export interface AgencyApiInterface {
    /**
     * Update a agency with a specific id 
     * @summary Create agency
     * @param {AgencyApiCreateAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApiInterface
     */
    createAgency(requestParameters: AgencyApiCreateAgencyRequest, options?: any): AxiosPromise<Agency>;

    /**
     * Delete a agency with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Agency
     * @param {AgencyApiDeleteAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApiInterface
     */
    deleteAgency(requestParameters: AgencyApiDeleteAgencyRequest, options?: any): AxiosPromise<void>;

    /**
     * Fetch a single agency by id 
     * @summary Get Agency
     * @param {AgencyApiGetAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApiInterface
     */
    getAgency(requestParameters: AgencyApiGetAgencyRequest, options?: any): AxiosPromise<Agency>;

    /**
     * Fetch a list of agencies.  This route only is available to symmons admins 
     * @summary List Agencies
     * @param {AgencyApiListAgenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApiInterface
     */
    listAgencies(requestParameters?: AgencyApiListAgenciesRequest, options?: any): AxiosPromise<PaginatedAgencies>;

    /**
     * Update a agency with a specific id 
     * @summary Update Agency
     * @param {AgencyApiUpdateAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApiInterface
     */
    updateAgency(requestParameters: AgencyApiUpdateAgencyRequest, options?: any): AxiosPromise<Agency>;

}

/**
 * Request parameters for createAgency operation in AgencyApi.
 * @export
 * @interface AgencyApiCreateAgencyRequest
 */
export interface AgencyApiCreateAgencyRequest {
    /**
     * 
     * @type {CreateAgencyBody}
     * @memberof AgencyApiCreateAgency
     */
    readonly createAgencyBody: CreateAgencyBody
}

/**
 * Request parameters for deleteAgency operation in AgencyApi.
 * @export
 * @interface AgencyApiDeleteAgencyRequest
 */
export interface AgencyApiDeleteAgencyRequest {
    /**
     * The id of the Agency
     * @type {number}
     * @memberof AgencyApiDeleteAgency
     */
    readonly id: number
}

/**
 * Request parameters for getAgency operation in AgencyApi.
 * @export
 * @interface AgencyApiGetAgencyRequest
 */
export interface AgencyApiGetAgencyRequest {
    /**
     * The id of the agency
     * @type {number}
     * @memberof AgencyApiGetAgency
     */
    readonly id: number
}

/**
 * Request parameters for listAgencies operation in AgencyApi.
 * @export
 * @interface AgencyApiListAgenciesRequest
 */
export interface AgencyApiListAgenciesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof AgencyApiListAgencies
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof AgencyApiListAgencies
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof AgencyApiListAgencies
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof AgencyApiListAgencies
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof AgencyApiListAgencies
     */
    readonly search?: string

    /**
     * Filters agencies.  Ignored for non-admins.  Users will see only their own agency when fetching a list
     * @type {number}
     * @memberof AgencyApiListAgencies
     */
    readonly agencyId?: number

    /**
     * Filters agencies by sales rep id
     * @type {number}
     * @memberof AgencyApiListAgencies
     */
    readonly salesRepId?: number

    /**
     * Filters agencies by territory id
     * @type {number}
     * @memberof AgencyApiListAgencies
     */
    readonly territoryId?: number

    /**
     * 
     * @type {string}
     * @memberof AgencyApiListAgencies
     */
    readonly state?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiListAgencies
     */
    readonly name?: string

    /**
     * 
     * @type {number}
     * @memberof AgencyApiListAgencies
     */
    readonly status?: number
}

/**
 * Request parameters for updateAgency operation in AgencyApi.
 * @export
 * @interface AgencyApiUpdateAgencyRequest
 */
export interface AgencyApiUpdateAgencyRequest {
    /**
     * The id of the agency
     * @type {number}
     * @memberof AgencyApiUpdateAgency
     */
    readonly id: number

    /**
     * 
     * @type {UpdateAgencyBody}
     * @memberof AgencyApiUpdateAgency
     */
    readonly updateAgencyBody: UpdateAgencyBody
}

/**
 * AgencyApi - object-oriented interface
 * @export
 * @class AgencyApi
 * @extends {BaseAPI}
 */
export class AgencyApi extends BaseAPI implements AgencyApiInterface {
    /**
     * Update a agency with a specific id 
     * @summary Create agency
     * @param {AgencyApiCreateAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public createAgency(requestParameters: AgencyApiCreateAgencyRequest, options?: any) {
        const request = AgencyApiFp(this.configuration).createAgency(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a agency with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Agency
     * @param {AgencyApiDeleteAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public deleteAgency(requestParameters: AgencyApiDeleteAgencyRequest, options?: any) {
        const request = AgencyApiFp(this.configuration).deleteAgency(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single agency by id 
     * @summary Get Agency
     * @param {AgencyApiGetAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public getAgency(requestParameters: AgencyApiGetAgencyRequest, options?: any) {
        const request = AgencyApiFp(this.configuration).getAgency(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of agencies.  This route only is available to symmons admins 
     * @summary List Agencies
     * @param {AgencyApiListAgenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public listAgencies(requestParameters: AgencyApiListAgenciesRequest = {}, options?: any) {
        const request = AgencyApiFp(this.configuration).listAgencies(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a agency with a specific id 
     * @summary Update Agency
     * @param {AgencyApiUpdateAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public updateAgency(requestParameters: AgencyApiUpdateAgencyRequest, options?: any) {
        const request = AgencyApiFp(this.configuration).updateAgency(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * AgencyGoalApi - axios parameter creator
 * @export
 */
export const AgencyGoalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a list of agency goals.  This route is only available to symmons admins 
         * @summary List Agency Goals
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Search of agency goal records the current user has access to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgencyGoals: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, options: any = {}): RequestArgs => {
            const localVarPath = `/agency-goals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyGoalApi - functional programming interface
 * @export
 */
export const AgencyGoalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgencyGoalApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a list of agency goals.  This route is only available to symmons admins 
         * @summary List Agency Goals
         * @param {AgencyGoalApiListAgencyGoalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgencyGoals(requestParameters: AgencyGoalApiListAgencyGoalsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedAgencyGoals>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listAgencyGoals(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgencyGoalApi - factory interface
 * @export
 */
export const AgencyGoalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgencyGoalApiFp(configuration)

    /**
      * Fetch a list of agency goals.  This route is only available to symmons admins 
      * @summary List Agency Goals
      * @param {AgencyGoalApiListAgencyGoalsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listAgencyGoals = (requestParameters: AgencyGoalApiListAgencyGoalsRequest = {}, options?: any): AxiosPromise<PaginatedAgencyGoals> => {
        const request = localVarFp.listAgencyGoals(requestParameters, options);
        return request(axios, basePath);
    };

    listAgencyGoals.getQueryKey = (requestParameters: AgencyGoalApiListAgencyGoalsRequest = {}, options?: any) => {
        const request = localVarFp.listAgencyGoals(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        listAgencyGoals,
    };
};

/**
 * AgencyGoalApi - interface
 * @export
 * @interface AgencyGoalApi
 */
export interface AgencyGoalApiInterface {
    /**
     * Fetch a list of agency goals.  This route is only available to symmons admins 
     * @summary List Agency Goals
     * @param {AgencyGoalApiListAgencyGoalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyGoalApiInterface
     */
    listAgencyGoals(requestParameters?: AgencyGoalApiListAgencyGoalsRequest, options?: any): AxiosPromise<PaginatedAgencyGoals>;

}

/**
 * Request parameters for listAgencyGoals operation in AgencyGoalApi.
 * @export
 * @interface AgencyGoalApiListAgencyGoalsRequest
 */
export interface AgencyGoalApiListAgencyGoalsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof AgencyGoalApiListAgencyGoals
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof AgencyGoalApiListAgencyGoals
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof AgencyGoalApiListAgencyGoals
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof AgencyGoalApiListAgencyGoals
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Search of agency goal records the current user has access to.
     * @type {string}
     * @memberof AgencyGoalApiListAgencyGoals
     */
    readonly search?: string
}

/**
 * AgencyGoalApi - object-oriented interface
 * @export
 * @class AgencyGoalApi
 * @extends {BaseAPI}
 */
export class AgencyGoalApi extends BaseAPI implements AgencyGoalApiInterface {
    /**
     * Fetch a list of agency goals.  This route is only available to symmons admins 
     * @summary List Agency Goals
     * @param {AgencyGoalApiListAgencyGoalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyGoalApi
     */
    public listAgencyGoals(requestParameters: AgencyGoalApiListAgencyGoalsRequest = {}, options?: any) {
        const request = AgencyGoalApiFp(this.configuration).listAgencyGoals(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint accepts a post body with application identification and a user identifier, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. This endpoint is used both for initial authentication and for subsequent renewals. It also can be used to validate a password reset token This endpoint will return a JSON web token which will be used in subsequent requests 
         * @summary Login & Refresh
         * @param {GetTokenBody} getTokenBody Parameters for getting an auth token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthToken: (getTokenBody: GetTokenBody, options: any = {}): RequestArgs => {
            // verify required parameter 'getTokenBody' is not null or undefined
            assertParamExists('getAuthToken', 'getTokenBody', getTokenBody)
            const localVarPath = `/oauth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTokenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current user 
         * @summary Get Current User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: (options: any = {}): RequestArgs => {
            const localVarPath = `/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint accepts an email address to reset. 
         * @summary Request Password Reset
         * @param {RequestPasswordReset} requestPasswordReset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestReset: (requestPasswordReset: RequestPasswordReset, options: any = {}): RequestArgs => {
            // verify required parameter 'requestPasswordReset' is not null or undefined
            assertParamExists('requestReset', 'requestPasswordReset', requestPasswordReset)
            const localVarPath = `/auth/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPasswordReset, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint starts the sso process.  The client should redirect the user here, and this endpoint will sign a request and redirect the user to salesforce to start the sso request.  If successful, the sso will return the user to the client app, with a code that can be sent to the api via the salesforce_sso grant request 
         * @summary Redirect user to salesforce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSalesforceSSO: (options: any = {}): RequestArgs => {
            const localVarPath = `/auth/salesforce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint resends the 2FA code to the user\'s email 
         * @summary Resend 2FA Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTwoFactorCode: (options: any = {}): RequestArgs => {
            const localVarPath = `/auth/2fa/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint accepts a post body with a code and a user id, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. 
         * @summary Verify Two Factor
         * @param {VerifyTwoFactorBody} verifyTwoFactorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwoFactor: (verifyTwoFactorBody: VerifyTwoFactorBody, options: any = {}): RequestArgs => {
            // verify required parameter 'verifyTwoFactorBody' is not null or undefined
            assertParamExists('verifyTwoFactor', 'verifyTwoFactorBody', verifyTwoFactorBody)
            const localVarPath = `/auth/2fa/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyTwoFactorBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint accepts a post body with application identification and a user identifier, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. This endpoint is used both for initial authentication and for subsequent renewals. It also can be used to validate a password reset token This endpoint will return a JSON web token which will be used in subsequent requests 
         * @summary Login & Refresh
         * @param {AuthApiGetAuthTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthToken(requestParameters: AuthApiGetAuthTokenRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<GetTokenResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getAuthToken(requestParameters.getTokenBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the current user 
         * @summary Get Current User
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegisteredUser>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getCurrentUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint accepts an email address to reset. 
         * @summary Request Password Reset
         * @param {AuthApiRequestResetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestReset(requestParameters: AuthApiRequestResetRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.requestReset(requestParameters.requestPasswordReset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint starts the sso process.  The client should redirect the user here, and this endpoint will sign a request and redirect the user to salesforce to start the sso request.  If successful, the sso will return the user to the client app, with a code that can be sent to the api via the salesforce_sso grant request 
         * @summary Redirect user to salesforce
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSalesforceSSO(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.requestSalesforceSSO(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint resends the 2FA code to the user\'s email 
         * @summary Resend 2FA Code
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTwoFactorCode(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.resendTwoFactorCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint accepts a post body with a code and a user id, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. 
         * @summary Verify Two Factor
         * @param {AuthApiVerifyTwoFactorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwoFactor(requestParameters: AuthApiVerifyTwoFactorRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<VerifyTwoFactorResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.verifyTwoFactor(requestParameters.verifyTwoFactorBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)

    /**
      * This endpoint accepts a post body with application identification and a user identifier, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. This endpoint is used both for initial authentication and for subsequent renewals. It also can be used to validate a password reset token This endpoint will return a JSON web token which will be used in subsequent requests 
      * @summary Login & Refresh
      * @param {AuthApiGetAuthTokenRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getAuthToken = (requestParameters: AuthApiGetAuthTokenRequest, options?: any): AxiosPromise<GetTokenResponse> => {
        const request = localVarFp.getAuthToken(requestParameters, options);
        return request(axios, basePath);
    };

    getAuthToken.getQueryKey = (requestParameters: AuthApiGetAuthTokenRequest, options?: any) => {
        const request = localVarFp.getAuthToken(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get the current user 
      * @summary Get Current User
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getCurrentUser = (requestParameters?: undefined, options?: any): AxiosPromise<RegisteredUser> => {
        const request = localVarFp.getCurrentUser(requestParameters, options);
        return request(axios, basePath);
    };

    getCurrentUser.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.getCurrentUser(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * This endpoint accepts an email address to reset. 
      * @summary Request Password Reset
      * @param {AuthApiRequestResetRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const requestReset = (requestParameters: AuthApiRequestResetRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.requestReset(requestParameters, options);
        return request(axios, basePath);
    };

    requestReset.getQueryKey = (requestParameters: AuthApiRequestResetRequest, options?: any) => {
        const request = localVarFp.requestReset(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * This endpoint starts the sso process.  The client should redirect the user here, and this endpoint will sign a request and redirect the user to salesforce to start the sso request.  If successful, the sso will return the user to the client app, with a code that can be sent to the api via the salesforce_sso grant request 
      * @summary Redirect user to salesforce
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const requestSalesforceSSO = (requestParameters?: undefined, options?: any): AxiosPromise<void> => {
        const request = localVarFp.requestSalesforceSSO(requestParameters, options);
        return request(axios, basePath);
    };

    requestSalesforceSSO.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.requestSalesforceSSO(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * This endpoint resends the 2FA code to the user\'s email 
      * @summary Resend 2FA Code
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const resendTwoFactorCode = (requestParameters?: undefined, options?: any): AxiosPromise<void> => {
        const request = localVarFp.resendTwoFactorCode(requestParameters, options);
        return request(axios, basePath);
    };

    resendTwoFactorCode.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.resendTwoFactorCode(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * This endpoint accepts a post body with a code and a user id, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. 
      * @summary Verify Two Factor
      * @param {AuthApiVerifyTwoFactorRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const verifyTwoFactor = (requestParameters: AuthApiVerifyTwoFactorRequest, options?: any): AxiosPromise<VerifyTwoFactorResponse> => {
        const request = localVarFp.verifyTwoFactor(requestParameters, options);
        return request(axios, basePath);
    };

    verifyTwoFactor.getQueryKey = (requestParameters: AuthApiVerifyTwoFactorRequest, options?: any) => {
        const request = localVarFp.verifyTwoFactor(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        getAuthToken,
        getCurrentUser,
        requestReset,
        requestSalesforceSSO,
        resendTwoFactorCode,
        verifyTwoFactor,
    };
};

/**
 * AuthApi - interface
 * @export
 * @interface AuthApi
 */
export interface AuthApiInterface {
    /**
     * This endpoint accepts a post body with application identification and a user identifier, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. This endpoint is used both for initial authentication and for subsequent renewals. It also can be used to validate a password reset token This endpoint will return a JSON web token which will be used in subsequent requests 
     * @summary Login & Refresh
     * @param {AuthApiGetAuthTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    getAuthToken(requestParameters: AuthApiGetAuthTokenRequest, options?: any): AxiosPromise<GetTokenResponse>;

    /**
     * Get the current user 
     * @summary Get Current User
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    getCurrentUser(requestParameters?: undefined, options?: any): AxiosPromise<RegisteredUser>;

    /**
     * This endpoint accepts an email address to reset. 
     * @summary Request Password Reset
     * @param {AuthApiRequestResetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    requestReset(requestParameters: AuthApiRequestResetRequest, options?: any): AxiosPromise<void>;

    /**
     * This endpoint starts the sso process.  The client should redirect the user here, and this endpoint will sign a request and redirect the user to salesforce to start the sso request.  If successful, the sso will return the user to the client app, with a code that can be sent to the api via the salesforce_sso grant request 
     * @summary Redirect user to salesforce
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    requestSalesforceSSO(requestParameters?: undefined, options?: any): AxiosPromise<void>;

    /**
     * This endpoint resends the 2FA code to the user\'s email 
     * @summary Resend 2FA Code
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    resendTwoFactorCode(requestParameters?: undefined, options?: any): AxiosPromise<void>;

    /**
     * This endpoint accepts a post body with a code and a user id, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. 
     * @summary Verify Two Factor
     * @param {AuthApiVerifyTwoFactorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    verifyTwoFactor(requestParameters: AuthApiVerifyTwoFactorRequest, options?: any): AxiosPromise<VerifyTwoFactorResponse>;

}

/**
 * Request parameters for getAuthToken operation in AuthApi.
 * @export
 * @interface AuthApiGetAuthTokenRequest
 */
export interface AuthApiGetAuthTokenRequest {
    /**
     * Parameters for getting an auth token
     * @type {GetTokenBody}
     * @memberof AuthApiGetAuthToken
     */
    readonly getTokenBody: GetTokenBody
}

/**
 * Request parameters for requestReset operation in AuthApi.
 * @export
 * @interface AuthApiRequestResetRequest
 */
export interface AuthApiRequestResetRequest {
    /**
     * 
     * @type {RequestPasswordReset}
     * @memberof AuthApiRequestReset
     */
    readonly requestPasswordReset: RequestPasswordReset
}

/**
 * Request parameters for verifyTwoFactor operation in AuthApi.
 * @export
 * @interface AuthApiVerifyTwoFactorRequest
 */
export interface AuthApiVerifyTwoFactorRequest {
    /**
     * 
     * @type {VerifyTwoFactorBody}
     * @memberof AuthApiVerifyTwoFactor
     */
    readonly verifyTwoFactorBody: VerifyTwoFactorBody
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
    /**
     * This endpoint accepts a post body with application identification and a user identifier, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. This endpoint is used both for initial authentication and for subsequent renewals. It also can be used to validate a password reset token This endpoint will return a JSON web token which will be used in subsequent requests 
     * @summary Login & Refresh
     * @param {AuthApiGetAuthTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getAuthToken(requestParameters: AuthApiGetAuthTokenRequest, options?: any) {
        const request = AuthApiFp(this.configuration).getAuthToken(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get the current user 
     * @summary Get Current User
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getCurrentUser(requestParameters?: undefined, options?: any) {
        const request = AuthApiFp(this.configuration).getCurrentUser(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * This endpoint accepts an email address to reset. 
     * @summary Request Password Reset
     * @param {AuthApiRequestResetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public requestReset(requestParameters: AuthApiRequestResetRequest, options?: any) {
        const request = AuthApiFp(this.configuration).requestReset(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * This endpoint starts the sso process.  The client should redirect the user here, and this endpoint will sign a request and redirect the user to salesforce to start the sso request.  If successful, the sso will return the user to the client app, with a code that can be sent to the api via the salesforce_sso grant request 
     * @summary Redirect user to salesforce
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public requestSalesforceSSO(requestParameters?: undefined, options?: any) {
        const request = AuthApiFp(this.configuration).requestSalesforceSSO(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * This endpoint resends the 2FA code to the user\'s email 
     * @summary Resend 2FA Code
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resendTwoFactorCode(requestParameters?: undefined, options?: any) {
        const request = AuthApiFp(this.configuration).resendTwoFactorCode(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * This endpoint accepts a post body with a code and a user id, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. 
     * @summary Verify Two Factor
     * @param {AuthApiVerifyTwoFactorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verifyTwoFactor(requestParameters: AuthApiVerifyTwoFactorRequest, options?: any) {
        const request = AuthApiFp(this.configuration).verifyTwoFactor(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * CategoryApi - axios parameter creator
 * @export
 */
export const CategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a category with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete category
         * @param {number} id The id of the category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResourceCategory: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteResourceCategory', 'id', id)
            const localVarPath = `/resource/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a resource with a specific id 
         * @summary Update Category
         * @param {number} id The id of the category
         * @param {UpdateResourceCategory} updateResourceCategory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResourceCategory: (id: number, updateResourceCategory: UpdateResourceCategory, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateResourceCategory', 'id', id)
            // verify required parameter 'updateResourceCategory' is not null or undefined
            assertParamExists('updateResourceCategory', 'updateResourceCategory', updateResourceCategory)
            const localVarPath = `/resource/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateResourceCategory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryApi - functional programming interface
 * @export
 */
export const CategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a category with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete category
         * @param {CategoryApiDeleteResourceCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResourceCategory(requestParameters: CategoryApiDeleteResourceCategoryRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteResourceCategory(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a resource with a specific id 
         * @summary Update Category
         * @param {CategoryApiUpdateResourceCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResourceCategory(requestParameters: CategoryApiUpdateResourceCategoryRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TaxonomyTermConnect>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateResourceCategory(requestParameters.id, requestParameters.updateResourceCategory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CategoryApi - factory interface
 * @export
 */
export const CategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryApiFp(configuration)

    /**
      * Delete a category with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete category
      * @param {CategoryApiDeleteResourceCategoryRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteResourceCategory = (requestParameters: CategoryApiDeleteResourceCategoryRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteResourceCategory(requestParameters, options);
        return request(axios, basePath);
    };

    deleteResourceCategory.getQueryKey = (requestParameters: CategoryApiDeleteResourceCategoryRequest, options?: any) => {
        const request = localVarFp.deleteResourceCategory(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a resource with a specific id 
      * @summary Update Category
      * @param {CategoryApiUpdateResourceCategoryRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateResourceCategory = (requestParameters: CategoryApiUpdateResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect> => {
        const request = localVarFp.updateResourceCategory(requestParameters, options);
        return request(axios, basePath);
    };

    updateResourceCategory.getQueryKey = (requestParameters: CategoryApiUpdateResourceCategoryRequest, options?: any) => {
        const request = localVarFp.updateResourceCategory(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        deleteResourceCategory,
        updateResourceCategory,
    };
};

/**
 * CategoryApi - interface
 * @export
 * @interface CategoryApi
 */
export interface CategoryApiInterface {
    /**
     * Delete a category with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete category
     * @param {CategoryApiDeleteResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApiInterface
     */
    deleteResourceCategory(requestParameters: CategoryApiDeleteResourceCategoryRequest, options?: any): AxiosPromise<void>;

    /**
     * Update a resource with a specific id 
     * @summary Update Category
     * @param {CategoryApiUpdateResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApiInterface
     */
    updateResourceCategory(requestParameters: CategoryApiUpdateResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect>;

}

/**
 * Request parameters for deleteResourceCategory operation in CategoryApi.
 * @export
 * @interface CategoryApiDeleteResourceCategoryRequest
 */
export interface CategoryApiDeleteResourceCategoryRequest {
    /**
     * The id of the category
     * @type {number}
     * @memberof CategoryApiDeleteResourceCategory
     */
    readonly id: number
}

/**
 * Request parameters for updateResourceCategory operation in CategoryApi.
 * @export
 * @interface CategoryApiUpdateResourceCategoryRequest
 */
export interface CategoryApiUpdateResourceCategoryRequest {
    /**
     * The id of the category
     * @type {number}
     * @memberof CategoryApiUpdateResourceCategory
     */
    readonly id: number

    /**
     * 
     * @type {UpdateResourceCategory}
     * @memberof CategoryApiUpdateResourceCategory
     */
    readonly updateResourceCategory: UpdateResourceCategory
}

/**
 * CategoryApi - object-oriented interface
 * @export
 * @class CategoryApi
 * @extends {BaseAPI}
 */
export class CategoryApi extends BaseAPI implements CategoryApiInterface {
    /**
     * Delete a category with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete category
     * @param {CategoryApiDeleteResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public deleteResourceCategory(requestParameters: CategoryApiDeleteResourceCategoryRequest, options?: any) {
        const request = CategoryApiFp(this.configuration).deleteResourceCategory(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a resource with a specific id 
     * @summary Update Category
     * @param {CategoryApiUpdateResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public updateResourceCategory(requestParameters: CategoryApiUpdateResourceCategoryRequest, options?: any) {
        const request = CategoryApiFp(this.configuration).updateResourceCategory(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update a company with a specific id 
         * @summary Create company
         * @param {CreateCompanyBody} createCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany: (createCompanyBody: CreateCompanyBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createCompanyBody' is not null or undefined
            assertParamExists('createCompany', 'createCompanyBody', createCompanyBody)
            const localVarPath = `/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a company with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Company
         * @param {number} id The id of the Company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCompany', 'id', id)
            const localVarPath = `/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches company details from symmons api 
         * @summary Fetch company by bill_to
         * @param {string} billTo The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddresses: (billTo: string, options: any = {}): RequestArgs => {
            // verify required parameter 'billTo' is not null or undefined
            assertParamExists('fetchCompanyAddresses', 'billTo', billTo)
            const localVarPath = `/company/fetch/{bill_to}`
                .replace(`{${"bill_to"}}`, encodeURIComponent(String(billTo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single company by id 
         * @summary Get Company
         * @param {number} id The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompany', 'id', id)
            const localVarPath = `/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of companies.  This route only is available to symmons admins 
         * @summary List Companies
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {number} [companyId] Filters companies.  Ignored for non-admins.  Users will see only their own company when fetching a list
         * @param {boolean} [wholesaler] Filter companies by evolution status
         * @param {boolean} [evolution] Filter companies by evolution status
         * @param {number} [salesRepId] Filters companies by sales rep id
         * @param {number} [territoryId] Filters companies by territory id
         * @param {string} [state] 
         * @param {string} [name] 
         * @param {number} [status] 
         * @param {boolean} [unrestricted] When true, sales reps are not limited to their territory or assignments (admins are always unrestricted). Intended for trusted flows such as the price sheet picker.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, companyId?: number, wholesaler?: boolean, evolution?: boolean, salesRepId?: number, territoryId?: number, state?: string, name?: string, status?: number, unrestricted?: boolean, options: any = {}): RequestArgs => {
            const localVarPath = `/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (wholesaler !== undefined) {
                localVarQueryParameter['wholesaler'] = wholesaler;
            }

            if (evolution !== undefined) {
                localVarQueryParameter['evolution'] = evolution;
            }

            if (salesRepId !== undefined) {
                localVarQueryParameter['sales_rep_id'] = salesRepId;
            }

            if (territoryId !== undefined) {
                localVarQueryParameter['territory_id'] = territoryId;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (unrestricted !== undefined) {
                localVarQueryParameter['unrestricted'] = unrestricted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move Billto to new company 
         * @summary Move Billto
         * @param {number} id The id of the company
         * @param {MoveBillToBody} moveBillToBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveBillToCompany: (id: number, moveBillToBody: MoveBillToBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moveBillToCompany', 'id', id)
            // verify required parameter 'moveBillToBody' is not null or undefined
            assertParamExists('moveBillToCompany', 'moveBillToBody', moveBillToBody)
            const localVarPath = `/company/{id}/billto`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveBillToBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a company with a specific id 
         * @summary Update Company
         * @param {number} id The id of the company
         * @param {UpdateCompanyBody} updateCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: (id: number, updateCompanyBody: UpdateCompanyBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCompany', 'id', id)
            // verify required parameter 'updateCompanyBody' is not null or undefined
            assertParamExists('updateCompany', 'updateCompanyBody', updateCompanyBody)
            const localVarPath = `/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * Update a company with a specific id 
         * @summary Create company
         * @param {CompanyApiCreateCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany(requestParameters: CompanyApiCreateCompanyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Company>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createCompany(requestParameters.createCompanyBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a company with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Company
         * @param {CompanyApiDeleteCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany(requestParameters: CompanyApiDeleteCompanyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteCompany(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetches company details from symmons api 
         * @summary Fetch company by bill_to
         * @param {CompanyApiFetchCompanyAddressesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddresses(requestParameters: CompanyApiFetchCompanyAddressesRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<FetchCompanyDetails>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.fetchCompanyAddresses(requestParameters.billTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single company by id 
         * @summary Get Company
         * @param {CompanyApiGetCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(requestParameters: CompanyApiGetCompanyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Company>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getCompany(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of companies.  This route only is available to symmons admins 
         * @summary List Companies
         * @param {CompanyApiListCompaniesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies(requestParameters: CompanyApiListCompaniesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedCompanies>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listCompanies(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.companyId, requestParameters.wholesaler, requestParameters.evolution, requestParameters.salesRepId, requestParameters.territoryId, requestParameters.state, requestParameters.name, requestParameters.status, requestParameters.unrestricted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Move Billto to new company 
         * @summary Move Billto
         * @param {CompanyApiMoveBillToCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveBillToCompany(requestParameters: CompanyApiMoveBillToCompanyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Company>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.moveBillToCompany(requestParameters.id, requestParameters.moveBillToBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a company with a specific id 
         * @summary Update Company
         * @param {CompanyApiUpdateCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(requestParameters: CompanyApiUpdateCompanyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Company>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateCompany(requestParameters.id, requestParameters.updateCompanyBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyApiFp(configuration)

    /**
      * Update a company with a specific id 
      * @summary Create company
      * @param {CompanyApiCreateCompanyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createCompany = (requestParameters: CompanyApiCreateCompanyRequest, options?: any): AxiosPromise<Company> => {
        const request = localVarFp.createCompany(requestParameters, options);
        return request(axios, basePath);
    };

    createCompany.getQueryKey = (requestParameters: CompanyApiCreateCompanyRequest, options?: any) => {
        const request = localVarFp.createCompany(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a company with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete Company
      * @param {CompanyApiDeleteCompanyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteCompany = (requestParameters: CompanyApiDeleteCompanyRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteCompany(requestParameters, options);
        return request(axios, basePath);
    };

    deleteCompany.getQueryKey = (requestParameters: CompanyApiDeleteCompanyRequest, options?: any) => {
        const request = localVarFp.deleteCompany(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetches company details from symmons api 
      * @summary Fetch company by bill_to
      * @param {CompanyApiFetchCompanyAddressesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const fetchCompanyAddresses = (requestParameters: CompanyApiFetchCompanyAddressesRequest, options?: any): AxiosPromise<FetchCompanyDetails> => {
        const request = localVarFp.fetchCompanyAddresses(requestParameters, options);
        return request(axios, basePath);
    };

    fetchCompanyAddresses.getQueryKey = (requestParameters: CompanyApiFetchCompanyAddressesRequest, options?: any) => {
        const request = localVarFp.fetchCompanyAddresses(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single company by id 
      * @summary Get Company
      * @param {CompanyApiGetCompanyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getCompany = (requestParameters: CompanyApiGetCompanyRequest, options?: any): AxiosPromise<Company> => {
        const request = localVarFp.getCompany(requestParameters, options);
        return request(axios, basePath);
    };

    getCompany.getQueryKey = (requestParameters: CompanyApiGetCompanyRequest, options?: any) => {
        const request = localVarFp.getCompany(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of companies.  This route only is available to symmons admins 
      * @summary List Companies
      * @param {CompanyApiListCompaniesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listCompanies = (requestParameters: CompanyApiListCompaniesRequest = {}, options?: any): AxiosPromise<PaginatedCompanies> => {
        const request = localVarFp.listCompanies(requestParameters, options);
        return request(axios, basePath);
    };

    listCompanies.getQueryKey = (requestParameters: CompanyApiListCompaniesRequest = {}, options?: any) => {
        const request = localVarFp.listCompanies(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Move Billto to new company 
      * @summary Move Billto
      * @param {CompanyApiMoveBillToCompanyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const moveBillToCompany = (requestParameters: CompanyApiMoveBillToCompanyRequest, options?: any): AxiosPromise<Company> => {
        const request = localVarFp.moveBillToCompany(requestParameters, options);
        return request(axios, basePath);
    };

    moveBillToCompany.getQueryKey = (requestParameters: CompanyApiMoveBillToCompanyRequest, options?: any) => {
        const request = localVarFp.moveBillToCompany(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a company with a specific id 
      * @summary Update Company
      * @param {CompanyApiUpdateCompanyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateCompany = (requestParameters: CompanyApiUpdateCompanyRequest, options?: any): AxiosPromise<Company> => {
        const request = localVarFp.updateCompany(requestParameters, options);
        return request(axios, basePath);
    };

    updateCompany.getQueryKey = (requestParameters: CompanyApiUpdateCompanyRequest, options?: any) => {
        const request = localVarFp.updateCompany(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createCompany,
        deleteCompany,
        fetchCompanyAddresses,
        getCompany,
        listCompanies,
        moveBillToCompany,
        updateCompany,
    };
};

/**
 * CompanyApi - interface
 * @export
 * @interface CompanyApi
 */
export interface CompanyApiInterface {
    /**
     * Update a company with a specific id 
     * @summary Create company
     * @param {CompanyApiCreateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApiInterface
     */
    createCompany(requestParameters: CompanyApiCreateCompanyRequest, options?: any): AxiosPromise<Company>;

    /**
     * Delete a company with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Company
     * @param {CompanyApiDeleteCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApiInterface
     */
    deleteCompany(requestParameters: CompanyApiDeleteCompanyRequest, options?: any): AxiosPromise<void>;

    /**
     * Fetches company details from symmons api 
     * @summary Fetch company by bill_to
     * @param {CompanyApiFetchCompanyAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApiInterface
     */
    fetchCompanyAddresses(requestParameters: CompanyApiFetchCompanyAddressesRequest, options?: any): AxiosPromise<FetchCompanyDetails>;

    /**
     * Fetch a single company by id 
     * @summary Get Company
     * @param {CompanyApiGetCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApiInterface
     */
    getCompany(requestParameters: CompanyApiGetCompanyRequest, options?: any): AxiosPromise<Company>;

    /**
     * Fetch a list of companies.  This route only is available to symmons admins 
     * @summary List Companies
     * @param {CompanyApiListCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApiInterface
     */
    listCompanies(requestParameters?: CompanyApiListCompaniesRequest, options?: any): AxiosPromise<PaginatedCompanies>;

    /**
     * Move Billto to new company 
     * @summary Move Billto
     * @param {CompanyApiMoveBillToCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApiInterface
     */
    moveBillToCompany(requestParameters: CompanyApiMoveBillToCompanyRequest, options?: any): AxiosPromise<Company>;

    /**
     * Update a company with a specific id 
     * @summary Update Company
     * @param {CompanyApiUpdateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApiInterface
     */
    updateCompany(requestParameters: CompanyApiUpdateCompanyRequest, options?: any): AxiosPromise<Company>;

}

/**
 * Request parameters for createCompany operation in CompanyApi.
 * @export
 * @interface CompanyApiCreateCompanyRequest
 */
export interface CompanyApiCreateCompanyRequest {
    /**
     * 
     * @type {CreateCompanyBody}
     * @memberof CompanyApiCreateCompany
     */
    readonly createCompanyBody: CreateCompanyBody
}

/**
 * Request parameters for deleteCompany operation in CompanyApi.
 * @export
 * @interface CompanyApiDeleteCompanyRequest
 */
export interface CompanyApiDeleteCompanyRequest {
    /**
     * The id of the Company
     * @type {number}
     * @memberof CompanyApiDeleteCompany
     */
    readonly id: number
}

/**
 * Request parameters for fetchCompanyAddresses operation in CompanyApi.
 * @export
 * @interface CompanyApiFetchCompanyAddressesRequest
 */
export interface CompanyApiFetchCompanyAddressesRequest {
    /**
     * The id of the company
     * @type {string}
     * @memberof CompanyApiFetchCompanyAddresses
     */
    readonly billTo: string
}

/**
 * Request parameters for getCompany operation in CompanyApi.
 * @export
 * @interface CompanyApiGetCompanyRequest
 */
export interface CompanyApiGetCompanyRequest {
    /**
     * The id of the company
     * @type {number}
     * @memberof CompanyApiGetCompany
     */
    readonly id: number
}

/**
 * Request parameters for listCompanies operation in CompanyApi.
 * @export
 * @interface CompanyApiListCompaniesRequest
 */
export interface CompanyApiListCompaniesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof CompanyApiListCompanies
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof CompanyApiListCompanies
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof CompanyApiListCompanies
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof CompanyApiListCompanies
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof CompanyApiListCompanies
     */
    readonly search?: string

    /**
     * Filters companies.  Ignored for non-admins.  Users will see only their own company when fetching a list
     * @type {number}
     * @memberof CompanyApiListCompanies
     */
    readonly companyId?: number

    /**
     * Filter companies by evolution status
     * @type {boolean}
     * @memberof CompanyApiListCompanies
     */
    readonly wholesaler?: boolean

    /**
     * Filter companies by evolution status
     * @type {boolean}
     * @memberof CompanyApiListCompanies
     */
    readonly evolution?: boolean

    /**
     * Filters companies by sales rep id
     * @type {number}
     * @memberof CompanyApiListCompanies
     */
    readonly salesRepId?: number

    /**
     * Filters companies by territory id
     * @type {number}
     * @memberof CompanyApiListCompanies
     */
    readonly territoryId?: number

    /**
     * 
     * @type {string}
     * @memberof CompanyApiListCompanies
     */
    readonly state?: string

    /**
     * 
     * @type {string}
     * @memberof CompanyApiListCompanies
     */
    readonly name?: string

    /**
     * 
     * @type {number}
     * @memberof CompanyApiListCompanies
     */
    readonly status?: number

    /**
     * When true, sales reps are not limited to their territory or assignments (admins are always unrestricted). Intended for trusted flows such as the price sheet picker.
     * @type {boolean}
     * @memberof CompanyApiListCompanies
     */
    readonly unrestricted?: boolean
}

/**
 * Request parameters for moveBillToCompany operation in CompanyApi.
 * @export
 * @interface CompanyApiMoveBillToCompanyRequest
 */
export interface CompanyApiMoveBillToCompanyRequest {
    /**
     * The id of the company
     * @type {number}
     * @memberof CompanyApiMoveBillToCompany
     */
    readonly id: number

    /**
     * 
     * @type {MoveBillToBody}
     * @memberof CompanyApiMoveBillToCompany
     */
    readonly moveBillToBody: MoveBillToBody
}

/**
 * Request parameters for updateCompany operation in CompanyApi.
 * @export
 * @interface CompanyApiUpdateCompanyRequest
 */
export interface CompanyApiUpdateCompanyRequest {
    /**
     * The id of the company
     * @type {number}
     * @memberof CompanyApiUpdateCompany
     */
    readonly id: number

    /**
     * 
     * @type {UpdateCompanyBody}
     * @memberof CompanyApiUpdateCompany
     */
    readonly updateCompanyBody: UpdateCompanyBody
}

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI implements CompanyApiInterface {
    /**
     * Update a company with a specific id 
     * @summary Create company
     * @param {CompanyApiCreateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public createCompany(requestParameters: CompanyApiCreateCompanyRequest, options?: any) {
        const request = CompanyApiFp(this.configuration).createCompany(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a company with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Company
     * @param {CompanyApiDeleteCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteCompany(requestParameters: CompanyApiDeleteCompanyRequest, options?: any) {
        const request = CompanyApiFp(this.configuration).deleteCompany(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetches company details from symmons api 
     * @summary Fetch company by bill_to
     * @param {CompanyApiFetchCompanyAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyAddresses(requestParameters: CompanyApiFetchCompanyAddressesRequest, options?: any) {
        const request = CompanyApiFp(this.configuration).fetchCompanyAddresses(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single company by id 
     * @summary Get Company
     * @param {CompanyApiGetCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public getCompany(requestParameters: CompanyApiGetCompanyRequest, options?: any) {
        const request = CompanyApiFp(this.configuration).getCompany(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of companies.  This route only is available to symmons admins 
     * @summary List Companies
     * @param {CompanyApiListCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public listCompanies(requestParameters: CompanyApiListCompaniesRequest = {}, options?: any) {
        const request = CompanyApiFp(this.configuration).listCompanies(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Move Billto to new company 
     * @summary Move Billto
     * @param {CompanyApiMoveBillToCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public moveBillToCompany(requestParameters: CompanyApiMoveBillToCompanyRequest, options?: any) {
        const request = CompanyApiFp(this.configuration).moveBillToCompany(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a company with a specific id 
     * @summary Update Company
     * @param {CompanyApiUpdateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public updateCompany(requestParameters: CompanyApiUpdateCompanyRequest, options?: any) {
        const request = CompanyApiFp(this.configuration).updateCompany(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * CreateApi - axios parameter creator
 * @export
 */
export const CreateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update a agency with a specific id 
         * @summary Create agency
         * @param {CreateAgencyBody} createAgencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgency: (createAgencyBody: CreateAgencyBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createAgencyBody' is not null or undefined
            assertParamExists('createAgency', 'createAgencyBody', createAgencyBody)
            const localVarPath = `/agency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAgencyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a company with a specific id 
         * @summary Create company
         * @param {CreateCompanyBody} createCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany: (createCompanyBody: CreateCompanyBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createCompanyBody' is not null or undefined
            assertParamExists('createCompany', 'createCompanyBody', createCompanyBody)
            const localVarPath = `/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a introduction 
         * @summary Create introduction
         * @param {CreateIntroductionBody} createIntroductionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntroduction: (createIntroductionBody: CreateIntroductionBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createIntroductionBody' is not null or undefined
            assertParamExists('createIntroduction', 'createIntroductionBody', createIntroductionBody)
            const localVarPath = `/introduction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIntroductionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a project.  This route will create a project and a new version.  Accepts pages, clients and blocks, but mostly these objects won\'t be available until some editing is done. 
         * @summary Create project
         * @param {ProjectUpdate} projectUpdate Request body for creating a project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: (projectUpdate: ProjectUpdate, options: any = {}): RequestArgs => {
            // verify required parameter 'projectUpdate' is not null or undefined
            assertParamExists('createProject', 'projectUpdate', projectUpdate)
            const localVarPath = `/project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method creates a quote request for the current user.  This will not automatically update a pending request.  Use POST /quote/pending 
         * @summary Create Quote
         * @param {CreateQuoteBody} createQuoteBody Parameters for requesting a quote request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuote: (createQuoteBody: CreateQuoteBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createQuoteBody' is not null or undefined
            assertParamExists('createQuote', 'createQuoteBody', createQuoteBody)
            const localVarPath = `/quote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuoteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a resource 
         * @summary Create resource
         * @param {CreateResourceBody} createResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResource: (createResourceBody: CreateResourceBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createResourceBody' is not null or undefined
            assertParamExists('createResource', 'createResourceBody', createResourceBody)
            const localVarPath = `/resource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createResourceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a resource category 
         * @summary Create resource category
         * @param {CreateCategoryBody} createCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResourceCategory: (createCategoryBody: CreateCategoryBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createCategoryBody' is not null or undefined
            assertParamExists('createResourceCategory', 'createCategoryBody', createCategoryBody)
            const localVarPath = `/resource/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a scorm with a specific id 
         * @summary Create Scorm File
         * @param {CreateScormBody} createScormBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScorm: (createScormBody: CreateScormBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createScormBody' is not null or undefined
            assertParamExists('createScorm', 'createScormBody', createScormBody)
            const localVarPath = `/scorm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createScormBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create product configuration for showers 
         * @summary Create shower configuration
         * @param {CreateShowerConfigurationBody} createShowerConfigurationBody Request body for creating shower configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShowerConfiguration: (createShowerConfigurationBody: CreateShowerConfigurationBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createShowerConfigurationBody' is not null or undefined
            assertParamExists('createShowerConfiguration', 'createShowerConfigurationBody', createShowerConfigurationBody)
            const localVarPath = `/configuration/shower`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShowerConfigurationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start a new TempControl sizing project.  For anonymous callers the response includes a non-null `authorization_key` that the client must store (typically in localStorage) and present via the `Authorization-Key` header on subsequent edits.  For authenticated callers the project is hard-bound to their user, no key is issued (`authorization_key` is `null`), and access goes through the bearer-token policy. This prevents a leaked computed key from being used to bypass ownership. 
         * @summary Create TempControl project
         * @param {CreateTempControlProjectBody} createTempControlProjectBody Request body for creating a TempControl project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTempControlProject: (createTempControlProjectBody: CreateTempControlProjectBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createTempControlProjectBody' is not null or undefined
            assertParamExists('createTempControlProject', 'createTempControlProjectBody', createTempControlProjectBody)
            const localVarPath = `/tempcontrol/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTempControlProjectBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new user for a company 
         * @summary Create User
         * @param {CreateUserBody} createUserBody Request body for creating user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: (createUserBody: CreateUserBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createUserBody' is not null or undefined
            assertParamExists('createUser', 'createUserBody', createUserBody)
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Links a quote or submitted order to a real order 
         * @summary Order a quote
         * @param {number} id The id of the quote
         * @param {OrderRequestBody} orderRequestBody Parameters for requesting a quote request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderQuote: (id: number, orderRequestBody: OrderRequestBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderQuote', 'id', id)
            // verify required parameter 'orderRequestBody' is not null or undefined
            assertParamExists('orderQuote', 'orderRequestBody', orderRequestBody)
            const localVarPath = `/quote/{id}/order`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
         * @summary Respond to a quote
         * @param {number} id The id of the order
         * @param {CreateQuoteResponseBody} createQuoteResponseBody Parameters for requesting a quote request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondQuote: (id: number, createQuoteResponseBody: CreateQuoteResponseBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('respondQuote', 'id', id)
            // verify required parameter 'createQuoteResponseBody' is not null or undefined
            assertParamExists('respondQuote', 'createQuoteResponseBody', createQuoteResponseBody)
            const localVarPath = `/quote/{id}/respond`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuoteResponseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a support request 
         * @summary Send Sales Support Request
         * @param {SupportBody} supportBody Send a support request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportRequest: (supportBody: SupportBody, options: any = {}): RequestArgs => {
            // verify required parameter 'supportBody' is not null or undefined
            assertParamExists('supportRequest', 'supportBody', supportBody)
            const localVarPath = `/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreateApi - functional programming interface
 * @export
 */
export const CreateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update a agency with a specific id 
         * @summary Create agency
         * @param {CreateApiCreateAgencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgency(requestParameters: CreateApiCreateAgencyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Agency>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createAgency(requestParameters.createAgencyBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a company with a specific id 
         * @summary Create company
         * @param {CreateApiCreateCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany(requestParameters: CreateApiCreateCompanyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Company>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createCompany(requestParameters.createCompanyBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a introduction 
         * @summary Create introduction
         * @param {CreateApiCreateIntroductionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntroduction(requestParameters: CreateApiCreateIntroductionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Introduction>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createIntroduction(requestParameters.createIntroductionBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a project.  This route will create a project and a new version.  Accepts pages, clients and blocks, but mostly these objects won\'t be available until some editing is done. 
         * @summary Create project
         * @param {CreateApiCreateProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(requestParameters: CreateApiCreateProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Project>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createProject(requestParameters.projectUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This method creates a quote request for the current user.  This will not automatically update a pending request.  Use POST /quote/pending 
         * @summary Create Quote
         * @param {CreateApiCreateQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuote(requestParameters: CreateApiCreateQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Quote>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createQuote(requestParameters.createQuoteBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a resource 
         * @summary Create resource
         * @param {CreateApiCreateResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResource(requestParameters: CreateApiCreateResourceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Resource>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createResource(requestParameters.createResourceBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a resource category 
         * @summary Create resource category
         * @param {CreateApiCreateResourceCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResourceCategory(requestParameters: CreateApiCreateResourceCategoryRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TaxonomyTermConnect>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createResourceCategory(requestParameters.createCategoryBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a scorm with a specific id 
         * @summary Create Scorm File
         * @param {CreateApiCreateScormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScorm(requestParameters: CreateApiCreateScormRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Scorm>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createScorm(requestParameters.createScormBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create product configuration for showers 
         * @summary Create shower configuration
         * @param {CreateApiCreateShowerConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShowerConfiguration(requestParameters: CreateApiCreateShowerConfigurationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ShowerConfigurationAuthorizationKey>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createShowerConfiguration(requestParameters.createShowerConfigurationBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Start a new TempControl sizing project.  For anonymous callers the response includes a non-null `authorization_key` that the client must store (typically in localStorage) and present via the `Authorization-Key` header on subsequent edits.  For authenticated callers the project is hard-bound to their user, no key is issued (`authorization_key` is `null`), and access goes through the bearer-token policy. This prevents a leaked computed key from being used to bypass ownership. 
         * @summary Create TempControl project
         * @param {CreateApiCreateTempControlProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTempControlProject(requestParameters: CreateApiCreateTempControlProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TempControlProjectAuthorizationKey>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createTempControlProject(requestParameters.createTempControlProjectBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new user for a company 
         * @summary Create User
         * @param {CreateApiCreateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(requestParameters: CreateApiCreateUserRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<User>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createUser(requestParameters.createUserBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Links a quote or submitted order to a real order 
         * @summary Order a quote
         * @param {CreateApiOrderQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderQuote(requestParameters: CreateApiOrderQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Quote>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.orderQuote(requestParameters.id, requestParameters.orderRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
         * @summary Respond to a quote
         * @param {CreateApiRespondQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondQuote(requestParameters: CreateApiRespondQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Response>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.respondQuote(requestParameters.id, requestParameters.createQuoteResponseBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send a support request 
         * @summary Send Sales Support Request
         * @param {CreateApiSupportRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportRequest(requestParameters: CreateApiSupportRequestRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.supportRequest(requestParameters.supportBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CreateApi - factory interface
 * @export
 */
export const CreateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreateApiFp(configuration)

    /**
      * Update a agency with a specific id 
      * @summary Create agency
      * @param {CreateApiCreateAgencyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createAgency = (requestParameters: CreateApiCreateAgencyRequest, options?: any): AxiosPromise<Agency> => {
        const request = localVarFp.createAgency(requestParameters, options);
        return request(axios, basePath);
    };

    createAgency.getQueryKey = (requestParameters: CreateApiCreateAgencyRequest, options?: any) => {
        const request = localVarFp.createAgency(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a company with a specific id 
      * @summary Create company
      * @param {CreateApiCreateCompanyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createCompany = (requestParameters: CreateApiCreateCompanyRequest, options?: any): AxiosPromise<Company> => {
        const request = localVarFp.createCompany(requestParameters, options);
        return request(axios, basePath);
    };

    createCompany.getQueryKey = (requestParameters: CreateApiCreateCompanyRequest, options?: any) => {
        const request = localVarFp.createCompany(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a introduction 
      * @summary Create introduction
      * @param {CreateApiCreateIntroductionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createIntroduction = (requestParameters: CreateApiCreateIntroductionRequest, options?: any): AxiosPromise<Introduction> => {
        const request = localVarFp.createIntroduction(requestParameters, options);
        return request(axios, basePath);
    };

    createIntroduction.getQueryKey = (requestParameters: CreateApiCreateIntroductionRequest, options?: any) => {
        const request = localVarFp.createIntroduction(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Create a project.  This route will create a project and a new version.  Accepts pages, clients and blocks, but mostly these objects won\'t be available until some editing is done. 
      * @summary Create project
      * @param {CreateApiCreateProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createProject = (requestParameters: CreateApiCreateProjectRequest, options?: any): AxiosPromise<Project> => {
        const request = localVarFp.createProject(requestParameters, options);
        return request(axios, basePath);
    };

    createProject.getQueryKey = (requestParameters: CreateApiCreateProjectRequest, options?: any) => {
        const request = localVarFp.createProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * This method creates a quote request for the current user.  This will not automatically update a pending request.  Use POST /quote/pending 
      * @summary Create Quote
      * @param {CreateApiCreateQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createQuote = (requestParameters: CreateApiCreateQuoteRequest, options?: any): AxiosPromise<Quote> => {
        const request = localVarFp.createQuote(requestParameters, options);
        return request(axios, basePath);
    };

    createQuote.getQueryKey = (requestParameters: CreateApiCreateQuoteRequest, options?: any) => {
        const request = localVarFp.createQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a resource 
      * @summary Create resource
      * @param {CreateApiCreateResourceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createResource = (requestParameters: CreateApiCreateResourceRequest, options?: any): AxiosPromise<Resource> => {
        const request = localVarFp.createResource(requestParameters, options);
        return request(axios, basePath);
    };

    createResource.getQueryKey = (requestParameters: CreateApiCreateResourceRequest, options?: any) => {
        const request = localVarFp.createResource(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a resource category 
      * @summary Create resource category
      * @param {CreateApiCreateResourceCategoryRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createResourceCategory = (requestParameters: CreateApiCreateResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect> => {
        const request = localVarFp.createResourceCategory(requestParameters, options);
        return request(axios, basePath);
    };

    createResourceCategory.getQueryKey = (requestParameters: CreateApiCreateResourceCategoryRequest, options?: any) => {
        const request = localVarFp.createResourceCategory(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Create a scorm with a specific id 
      * @summary Create Scorm File
      * @param {CreateApiCreateScormRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createScorm = (requestParameters: CreateApiCreateScormRequest, options?: any): AxiosPromise<Scorm> => {
        const request = localVarFp.createScorm(requestParameters, options);
        return request(axios, basePath);
    };

    createScorm.getQueryKey = (requestParameters: CreateApiCreateScormRequest, options?: any) => {
        const request = localVarFp.createScorm(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Create product configuration for showers 
      * @summary Create shower configuration
      * @param {CreateApiCreateShowerConfigurationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createShowerConfiguration = (requestParameters: CreateApiCreateShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfigurationAuthorizationKey> => {
        const request = localVarFp.createShowerConfiguration(requestParameters, options);
        return request(axios, basePath);
    };

    createShowerConfiguration.getQueryKey = (requestParameters: CreateApiCreateShowerConfigurationRequest, options?: any) => {
        const request = localVarFp.createShowerConfiguration(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Start a new TempControl sizing project.  For anonymous callers the response includes a non-null `authorization_key` that the client must store (typically in localStorage) and present via the `Authorization-Key` header on subsequent edits.  For authenticated callers the project is hard-bound to their user, no key is issued (`authorization_key` is `null`), and access goes through the bearer-token policy. This prevents a leaked computed key from being used to bypass ownership. 
      * @summary Create TempControl project
      * @param {CreateApiCreateTempControlProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createTempControlProject = (requestParameters: CreateApiCreateTempControlProjectRequest, options?: any): AxiosPromise<TempControlProjectAuthorizationKey> => {
        const request = localVarFp.createTempControlProject(requestParameters, options);
        return request(axios, basePath);
    };

    createTempControlProject.getQueryKey = (requestParameters: CreateApiCreateTempControlProjectRequest, options?: any) => {
        const request = localVarFp.createTempControlProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Create a new user for a company 
      * @summary Create User
      * @param {CreateApiCreateUserRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createUser = (requestParameters: CreateApiCreateUserRequest, options?: any): AxiosPromise<User> => {
        const request = localVarFp.createUser(requestParameters, options);
        return request(axios, basePath);
    };

    createUser.getQueryKey = (requestParameters: CreateApiCreateUserRequest, options?: any) => {
        const request = localVarFp.createUser(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Links a quote or submitted order to a real order 
      * @summary Order a quote
      * @param {CreateApiOrderQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const orderQuote = (requestParameters: CreateApiOrderQuoteRequest, options?: any): AxiosPromise<Quote> => {
        const request = localVarFp.orderQuote(requestParameters, options);
        return request(axios, basePath);
    };

    orderQuote.getQueryKey = (requestParameters: CreateApiOrderQuoteRequest, options?: any) => {
        const request = localVarFp.orderQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
      * @summary Respond to a quote
      * @param {CreateApiRespondQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const respondQuote = (requestParameters: CreateApiRespondQuoteRequest, options?: any): AxiosPromise<Response> => {
        const request = localVarFp.respondQuote(requestParameters, options);
        return request(axios, basePath);
    };

    respondQuote.getQueryKey = (requestParameters: CreateApiRespondQuoteRequest, options?: any) => {
        const request = localVarFp.respondQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Send a support request 
      * @summary Send Sales Support Request
      * @param {CreateApiSupportRequestRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const supportRequest = (requestParameters: CreateApiSupportRequestRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.supportRequest(requestParameters, options);
        return request(axios, basePath);
    };

    supportRequest.getQueryKey = (requestParameters: CreateApiSupportRequestRequest, options?: any) => {
        const request = localVarFp.supportRequest(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createAgency,
        createCompany,
        createIntroduction,
        createProject,
        createQuote,
        createResource,
        createResourceCategory,
        createScorm,
        createShowerConfiguration,
        createTempControlProject,
        createUser,
        orderQuote,
        respondQuote,
        supportRequest,
    };
};

/**
 * CreateApi - interface
 * @export
 * @interface CreateApi
 */
export interface CreateApiInterface {
    /**
     * Update a agency with a specific id 
     * @summary Create agency
     * @param {CreateApiCreateAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    createAgency(requestParameters: CreateApiCreateAgencyRequest, options?: any): AxiosPromise<Agency>;

    /**
     * Update a company with a specific id 
     * @summary Create company
     * @param {CreateApiCreateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    createCompany(requestParameters: CreateApiCreateCompanyRequest, options?: any): AxiosPromise<Company>;

    /**
     * Update a introduction 
     * @summary Create introduction
     * @param {CreateApiCreateIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    createIntroduction(requestParameters: CreateApiCreateIntroductionRequest, options?: any): AxiosPromise<Introduction>;

    /**
     * Create a project.  This route will create a project and a new version.  Accepts pages, clients and blocks, but mostly these objects won\'t be available until some editing is done. 
     * @summary Create project
     * @param {CreateApiCreateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    createProject(requestParameters: CreateApiCreateProjectRequest, options?: any): AxiosPromise<Project>;

    /**
     * This method creates a quote request for the current user.  This will not automatically update a pending request.  Use POST /quote/pending 
     * @summary Create Quote
     * @param {CreateApiCreateQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    createQuote(requestParameters: CreateApiCreateQuoteRequest, options?: any): AxiosPromise<Quote>;

    /**
     * Update a resource 
     * @summary Create resource
     * @param {CreateApiCreateResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    createResource(requestParameters: CreateApiCreateResourceRequest, options?: any): AxiosPromise<Resource>;

    /**
     * Update a resource category 
     * @summary Create resource category
     * @param {CreateApiCreateResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    createResourceCategory(requestParameters: CreateApiCreateResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect>;

    /**
     * Create a scorm with a specific id 
     * @summary Create Scorm File
     * @param {CreateApiCreateScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    createScorm(requestParameters: CreateApiCreateScormRequest, options?: any): AxiosPromise<Scorm>;

    /**
     * Create product configuration for showers 
     * @summary Create shower configuration
     * @param {CreateApiCreateShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    createShowerConfiguration(requestParameters: CreateApiCreateShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfigurationAuthorizationKey>;

    /**
     * Start a new TempControl sizing project.  For anonymous callers the response includes a non-null `authorization_key` that the client must store (typically in localStorage) and present via the `Authorization-Key` header on subsequent edits.  For authenticated callers the project is hard-bound to their user, no key is issued (`authorization_key` is `null`), and access goes through the bearer-token policy. This prevents a leaked computed key from being used to bypass ownership. 
     * @summary Create TempControl project
     * @param {CreateApiCreateTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    createTempControlProject(requestParameters: CreateApiCreateTempControlProjectRequest, options?: any): AxiosPromise<TempControlProjectAuthorizationKey>;

    /**
     * Create a new user for a company 
     * @summary Create User
     * @param {CreateApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    createUser(requestParameters: CreateApiCreateUserRequest, options?: any): AxiosPromise<User>;

    /**
     * Links a quote or submitted order to a real order 
     * @summary Order a quote
     * @param {CreateApiOrderQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    orderQuote(requestParameters: CreateApiOrderQuoteRequest, options?: any): AxiosPromise<Quote>;

    /**
     * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
     * @summary Respond to a quote
     * @param {CreateApiRespondQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    respondQuote(requestParameters: CreateApiRespondQuoteRequest, options?: any): AxiosPromise<Response>;

    /**
     * Send a support request 
     * @summary Send Sales Support Request
     * @param {CreateApiSupportRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApiInterface
     */
    supportRequest(requestParameters: CreateApiSupportRequestRequest, options?: any): AxiosPromise<void>;

}

/**
 * Request parameters for createAgency operation in CreateApi.
 * @export
 * @interface CreateApiCreateAgencyRequest
 */
export interface CreateApiCreateAgencyRequest {
    /**
     * 
     * @type {CreateAgencyBody}
     * @memberof CreateApiCreateAgency
     */
    readonly createAgencyBody: CreateAgencyBody
}

/**
 * Request parameters for createCompany operation in CreateApi.
 * @export
 * @interface CreateApiCreateCompanyRequest
 */
export interface CreateApiCreateCompanyRequest {
    /**
     * 
     * @type {CreateCompanyBody}
     * @memberof CreateApiCreateCompany
     */
    readonly createCompanyBody: CreateCompanyBody
}

/**
 * Request parameters for createIntroduction operation in CreateApi.
 * @export
 * @interface CreateApiCreateIntroductionRequest
 */
export interface CreateApiCreateIntroductionRequest {
    /**
     * 
     * @type {CreateIntroductionBody}
     * @memberof CreateApiCreateIntroduction
     */
    readonly createIntroductionBody: CreateIntroductionBody
}

/**
 * Request parameters for createProject operation in CreateApi.
 * @export
 * @interface CreateApiCreateProjectRequest
 */
export interface CreateApiCreateProjectRequest {
    /**
     * Request body for creating a project
     * @type {ProjectUpdate}
     * @memberof CreateApiCreateProject
     */
    readonly projectUpdate: ProjectUpdate
}

/**
 * Request parameters for createQuote operation in CreateApi.
 * @export
 * @interface CreateApiCreateQuoteRequest
 */
export interface CreateApiCreateQuoteRequest {
    /**
     * Parameters for requesting a quote request
     * @type {CreateQuoteBody}
     * @memberof CreateApiCreateQuote
     */
    readonly createQuoteBody: CreateQuoteBody
}

/**
 * Request parameters for createResource operation in CreateApi.
 * @export
 * @interface CreateApiCreateResourceRequest
 */
export interface CreateApiCreateResourceRequest {
    /**
     * 
     * @type {CreateResourceBody}
     * @memberof CreateApiCreateResource
     */
    readonly createResourceBody: CreateResourceBody
}

/**
 * Request parameters for createResourceCategory operation in CreateApi.
 * @export
 * @interface CreateApiCreateResourceCategoryRequest
 */
export interface CreateApiCreateResourceCategoryRequest {
    /**
     * 
     * @type {CreateCategoryBody}
     * @memberof CreateApiCreateResourceCategory
     */
    readonly createCategoryBody: CreateCategoryBody
}

/**
 * Request parameters for createScorm operation in CreateApi.
 * @export
 * @interface CreateApiCreateScormRequest
 */
export interface CreateApiCreateScormRequest {
    /**
     * 
     * @type {CreateScormBody}
     * @memberof CreateApiCreateScorm
     */
    readonly createScormBody: CreateScormBody
}

/**
 * Request parameters for createShowerConfiguration operation in CreateApi.
 * @export
 * @interface CreateApiCreateShowerConfigurationRequest
 */
export interface CreateApiCreateShowerConfigurationRequest {
    /**
     * Request body for creating shower configuration
     * @type {CreateShowerConfigurationBody}
     * @memberof CreateApiCreateShowerConfiguration
     */
    readonly createShowerConfigurationBody: CreateShowerConfigurationBody
}

/**
 * Request parameters for createTempControlProject operation in CreateApi.
 * @export
 * @interface CreateApiCreateTempControlProjectRequest
 */
export interface CreateApiCreateTempControlProjectRequest {
    /**
     * Request body for creating a TempControl project
     * @type {CreateTempControlProjectBody}
     * @memberof CreateApiCreateTempControlProject
     */
    readonly createTempControlProjectBody: CreateTempControlProjectBody
}

/**
 * Request parameters for createUser operation in CreateApi.
 * @export
 * @interface CreateApiCreateUserRequest
 */
export interface CreateApiCreateUserRequest {
    /**
     * Request body for creating user
     * @type {CreateUserBody}
     * @memberof CreateApiCreateUser
     */
    readonly createUserBody: CreateUserBody
}

/**
 * Request parameters for orderQuote operation in CreateApi.
 * @export
 * @interface CreateApiOrderQuoteRequest
 */
export interface CreateApiOrderQuoteRequest {
    /**
     * The id of the quote
     * @type {number}
     * @memberof CreateApiOrderQuote
     */
    readonly id: number

    /**
     * Parameters for requesting a quote request
     * @type {OrderRequestBody}
     * @memberof CreateApiOrderQuote
     */
    readonly orderRequestBody: OrderRequestBody
}

/**
 * Request parameters for respondQuote operation in CreateApi.
 * @export
 * @interface CreateApiRespondQuoteRequest
 */
export interface CreateApiRespondQuoteRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof CreateApiRespondQuote
     */
    readonly id: number

    /**
     * Parameters for requesting a quote request
     * @type {CreateQuoteResponseBody}
     * @memberof CreateApiRespondQuote
     */
    readonly createQuoteResponseBody: CreateQuoteResponseBody
}

/**
 * Request parameters for supportRequest operation in CreateApi.
 * @export
 * @interface CreateApiSupportRequestRequest
 */
export interface CreateApiSupportRequestRequest {
    /**
     * Send a support request
     * @type {SupportBody}
     * @memberof CreateApiSupportRequest
     */
    readonly supportBody: SupportBody
}

/**
 * CreateApi - object-oriented interface
 * @export
 * @class CreateApi
 * @extends {BaseAPI}
 */
export class CreateApi extends BaseAPI implements CreateApiInterface {
    /**
     * Update a agency with a specific id 
     * @summary Create agency
     * @param {CreateApiCreateAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public createAgency(requestParameters: CreateApiCreateAgencyRequest, options?: any) {
        const request = CreateApiFp(this.configuration).createAgency(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a company with a specific id 
     * @summary Create company
     * @param {CreateApiCreateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public createCompany(requestParameters: CreateApiCreateCompanyRequest, options?: any) {
        const request = CreateApiFp(this.configuration).createCompany(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a introduction 
     * @summary Create introduction
     * @param {CreateApiCreateIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public createIntroduction(requestParameters: CreateApiCreateIntroductionRequest, options?: any) {
        const request = CreateApiFp(this.configuration).createIntroduction(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Create a project.  This route will create a project and a new version.  Accepts pages, clients and blocks, but mostly these objects won\'t be available until some editing is done. 
     * @summary Create project
     * @param {CreateApiCreateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public createProject(requestParameters: CreateApiCreateProjectRequest, options?: any) {
        const request = CreateApiFp(this.configuration).createProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * This method creates a quote request for the current user.  This will not automatically update a pending request.  Use POST /quote/pending 
     * @summary Create Quote
     * @param {CreateApiCreateQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public createQuote(requestParameters: CreateApiCreateQuoteRequest, options?: any) {
        const request = CreateApiFp(this.configuration).createQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a resource 
     * @summary Create resource
     * @param {CreateApiCreateResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public createResource(requestParameters: CreateApiCreateResourceRequest, options?: any) {
        const request = CreateApiFp(this.configuration).createResource(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a resource category 
     * @summary Create resource category
     * @param {CreateApiCreateResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public createResourceCategory(requestParameters: CreateApiCreateResourceCategoryRequest, options?: any) {
        const request = CreateApiFp(this.configuration).createResourceCategory(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Create a scorm with a specific id 
     * @summary Create Scorm File
     * @param {CreateApiCreateScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public createScorm(requestParameters: CreateApiCreateScormRequest, options?: any) {
        const request = CreateApiFp(this.configuration).createScorm(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Create product configuration for showers 
     * @summary Create shower configuration
     * @param {CreateApiCreateShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public createShowerConfiguration(requestParameters: CreateApiCreateShowerConfigurationRequest, options?: any) {
        const request = CreateApiFp(this.configuration).createShowerConfiguration(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Start a new TempControl sizing project.  For anonymous callers the response includes a non-null `authorization_key` that the client must store (typically in localStorage) and present via the `Authorization-Key` header on subsequent edits.  For authenticated callers the project is hard-bound to their user, no key is issued (`authorization_key` is `null`), and access goes through the bearer-token policy. This prevents a leaked computed key from being used to bypass ownership. 
     * @summary Create TempControl project
     * @param {CreateApiCreateTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public createTempControlProject(requestParameters: CreateApiCreateTempControlProjectRequest, options?: any) {
        const request = CreateApiFp(this.configuration).createTempControlProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Create a new user for a company 
     * @summary Create User
     * @param {CreateApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public createUser(requestParameters: CreateApiCreateUserRequest, options?: any) {
        const request = CreateApiFp(this.configuration).createUser(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Links a quote or submitted order to a real order 
     * @summary Order a quote
     * @param {CreateApiOrderQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public orderQuote(requestParameters: CreateApiOrderQuoteRequest, options?: any) {
        const request = CreateApiFp(this.configuration).orderQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
     * @summary Respond to a quote
     * @param {CreateApiRespondQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public respondQuote(requestParameters: CreateApiRespondQuoteRequest, options?: any) {
        const request = CreateApiFp(this.configuration).respondQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Send a support request 
     * @summary Send Sales Support Request
     * @param {CreateApiSupportRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateApi
     */
    public supportRequest(requestParameters: CreateApiSupportRequestRequest, options?: any) {
        const request = CreateApiFp(this.configuration).supportRequest(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * CustomersApi - axios parameter creator
 * @export
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a single salesforce customer by id 
         * @summary Get a single Salesforce Customer
         * @param {number} id The id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceCustomer: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesforceCustomer', 'id', id)
            const localVarPath = `/salesforce/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
         * @summary List Salesforce Customers
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of salesforce customer records the current user has access to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceCustomers: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, options: any = {}): RequestArgs => {
            const localVarPath = `/salesforce/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fire a background task to fetch all the salesforce data from the last two days 
         * @summary Refresh the salesforce data
         * @param {string} id The salesforce id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSalesforce: (id: string, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshSalesforce', 'id', id)
            const localVarPath = `/salesforce/refresh`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh a single salesforce customer in the db 
         * @summary Refresh a single salesforce customer in the db
         * @param {string} id The salesforce id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceCustomer: (id: string, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('syncSalesforceCustomer', 'id', id)
            const localVarPath = `/salesforce/customer/{id}/sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 * @export
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a single salesforce customer by id 
         * @summary Get a single Salesforce Customer
         * @param {CustomersApiGetSalesforceCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceCustomer(requestParameters: CustomersApiGetSalesforceCustomerRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceCustomer>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getSalesforceCustomer(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
         * @summary List Salesforce Customers
         * @param {CustomersApiListSalesforceCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceCustomers(requestParameters: CustomersApiListSalesforceCustomersRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedSalesforceCustomers>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listSalesforceCustomers(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fire a background task to fetch all the salesforce data from the last two days 
         * @summary Refresh the salesforce data
         * @param {CustomersApiRefreshSalesforceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSalesforce(requestParameters: CustomersApiRefreshSalesforceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.refreshSalesforce(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Refresh a single salesforce customer in the db 
         * @summary Refresh a single salesforce customer in the db
         * @param {CustomersApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceCustomer(requestParameters: CustomersApiSyncSalesforceCustomerRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceCustomer>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.syncSalesforceCustomer(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomersApi - factory interface
 * @export
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)

    /**
      * Fetch a single salesforce customer by id 
      * @summary Get a single Salesforce Customer
      * @param {CustomersApiGetSalesforceCustomerRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getSalesforceCustomer = (requestParameters: CustomersApiGetSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer> => {
        const request = localVarFp.getSalesforceCustomer(requestParameters, options);
        return request(axios, basePath);
    };

    getSalesforceCustomer.getQueryKey = (requestParameters: CustomersApiGetSalesforceCustomerRequest, options?: any) => {
        const request = localVarFp.getSalesforceCustomer(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
      * @summary List Salesforce Customers
      * @param {CustomersApiListSalesforceCustomersRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listSalesforceCustomers = (requestParameters: CustomersApiListSalesforceCustomersRequest = {}, options?: any): AxiosPromise<PaginatedSalesforceCustomers> => {
        const request = localVarFp.listSalesforceCustomers(requestParameters, options);
        return request(axios, basePath);
    };

    listSalesforceCustomers.getQueryKey = (requestParameters: CustomersApiListSalesforceCustomersRequest = {}, options?: any) => {
        const request = localVarFp.listSalesforceCustomers(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fire a background task to fetch all the salesforce data from the last two days 
      * @summary Refresh the salesforce data
      * @param {CustomersApiRefreshSalesforceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const refreshSalesforce = (requestParameters: CustomersApiRefreshSalesforceRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.refreshSalesforce(requestParameters, options);
        return request(axios, basePath);
    };

    refreshSalesforce.getQueryKey = (requestParameters: CustomersApiRefreshSalesforceRequest, options?: any) => {
        const request = localVarFp.refreshSalesforce(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Refresh a single salesforce customer in the db 
      * @summary Refresh a single salesforce customer in the db
      * @param {CustomersApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const syncSalesforceCustomer = (requestParameters: CustomersApiSyncSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer> => {
        const request = localVarFp.syncSalesforceCustomer(requestParameters, options);
        return request(axios, basePath);
    };

    syncSalesforceCustomer.getQueryKey = (requestParameters: CustomersApiSyncSalesforceCustomerRequest, options?: any) => {
        const request = localVarFp.syncSalesforceCustomer(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        getSalesforceCustomer,
        listSalesforceCustomers,
        refreshSalesforce,
        syncSalesforceCustomer,
    };
};

/**
 * CustomersApi - interface
 * @export
 * @interface CustomersApi
 */
export interface CustomersApiInterface {
    /**
     * Fetch a single salesforce customer by id 
     * @summary Get a single Salesforce Customer
     * @param {CustomersApiGetSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    getSalesforceCustomer(requestParameters: CustomersApiGetSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer>;

    /**
     * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
     * @summary List Salesforce Customers
     * @param {CustomersApiListSalesforceCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    listSalesforceCustomers(requestParameters?: CustomersApiListSalesforceCustomersRequest, options?: any): AxiosPromise<PaginatedSalesforceCustomers>;

    /**
     * Fire a background task to fetch all the salesforce data from the last two days 
     * @summary Refresh the salesforce data
     * @param {CustomersApiRefreshSalesforceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    refreshSalesforce(requestParameters: CustomersApiRefreshSalesforceRequest, options?: any): AxiosPromise<void>;

    /**
     * Refresh a single salesforce customer in the db 
     * @summary Refresh a single salesforce customer in the db
     * @param {CustomersApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApiInterface
     */
    syncSalesforceCustomer(requestParameters: CustomersApiSyncSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer>;

}

/**
 * Request parameters for getSalesforceCustomer operation in CustomersApi.
 * @export
 * @interface CustomersApiGetSalesforceCustomerRequest
 */
export interface CustomersApiGetSalesforceCustomerRequest {
    /**
     * The id of the customer
     * @type {number}
     * @memberof CustomersApiGetSalesforceCustomer
     */
    readonly id: number
}

/**
 * Request parameters for listSalesforceCustomers operation in CustomersApi.
 * @export
 * @interface CustomersApiListSalesforceCustomersRequest
 */
export interface CustomersApiListSalesforceCustomersRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof CustomersApiListSalesforceCustomers
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof CustomersApiListSalesforceCustomers
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof CustomersApiListSalesforceCustomers
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof CustomersApiListSalesforceCustomers
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of salesforce customer records the current user has access to.
     * @type {string}
     * @memberof CustomersApiListSalesforceCustomers
     */
    readonly search?: string
}

/**
 * Request parameters for refreshSalesforce operation in CustomersApi.
 * @export
 * @interface CustomersApiRefreshSalesforceRequest
 */
export interface CustomersApiRefreshSalesforceRequest {
    /**
     * The salesforce id of the customer
     * @type {string}
     * @memberof CustomersApiRefreshSalesforce
     */
    readonly id: string
}

/**
 * Request parameters for syncSalesforceCustomer operation in CustomersApi.
 * @export
 * @interface CustomersApiSyncSalesforceCustomerRequest
 */
export interface CustomersApiSyncSalesforceCustomerRequest {
    /**
     * The salesforce id of the customer
     * @type {string}
     * @memberof CustomersApiSyncSalesforceCustomer
     */
    readonly id: string
}

/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
export class CustomersApi extends BaseAPI implements CustomersApiInterface {
    /**
     * Fetch a single salesforce customer by id 
     * @summary Get a single Salesforce Customer
     * @param {CustomersApiGetSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getSalesforceCustomer(requestParameters: CustomersApiGetSalesforceCustomerRequest, options?: any) {
        const request = CustomersApiFp(this.configuration).getSalesforceCustomer(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
     * @summary List Salesforce Customers
     * @param {CustomersApiListSalesforceCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public listSalesforceCustomers(requestParameters: CustomersApiListSalesforceCustomersRequest = {}, options?: any) {
        const request = CustomersApiFp(this.configuration).listSalesforceCustomers(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fire a background task to fetch all the salesforce data from the last two days 
     * @summary Refresh the salesforce data
     * @param {CustomersApiRefreshSalesforceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public refreshSalesforce(requestParameters: CustomersApiRefreshSalesforceRequest, options?: any) {
        const request = CustomersApiFp(this.configuration).refreshSalesforce(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Refresh a single salesforce customer in the db 
     * @summary Refresh a single salesforce customer in the db
     * @param {CustomersApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public syncSalesforceCustomer(requestParameters: CustomersApiSyncSalesforceCustomerRequest, options?: any) {
        const request = CustomersApiFp(this.configuration).syncSalesforceCustomer(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a list of resources counts groupped by topic. 
         * @summary Get Resources Dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesDashboard: (options: any = {}): RequestArgs => {
            const localVarPath = `/resources/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a list of resources counts groupped by topic. 
         * @summary Get Resources Dashboard
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesDashboard(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ResourcesDashboard>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getResourcesDashboard(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)

    /**
      * Fetch a list of resources counts groupped by topic. 
      * @summary Get Resources Dashboard
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getResourcesDashboard = (requestParameters?: undefined, options?: any): AxiosPromise<ResourcesDashboard> => {
        const request = localVarFp.getResourcesDashboard(requestParameters, options);
        return request(axios, basePath);
    };

    getResourcesDashboard.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.getResourcesDashboard(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        getResourcesDashboard,
    };
};

/**
 * DashboardApi - interface
 * @export
 * @interface DashboardApi
 */
export interface DashboardApiInterface {
    /**
     * Fetch a list of resources counts groupped by topic. 
     * @summary Get Resources Dashboard
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    getResourcesDashboard(requestParameters?: undefined, options?: any): AxiosPromise<ResourcesDashboard>;

}

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI implements DashboardApiInterface {
    /**
     * Fetch a list of resources counts groupped by topic. 
     * @summary Get Resources Dashboard
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getResourcesDashboard(requestParameters?: undefined, options?: any) {
        const request = DashboardApiFp(this.configuration).getResourcesDashboard(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * DeleteApi - axios parameter creator
 * @export
 */
export const DeleteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a agency with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Agency
         * @param {number} id The id of the Agency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgency: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAgency', 'id', id)
            const localVarPath = `/agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a company with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Company
         * @param {number} id The id of the Company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCompany', 'id', id)
            const localVarPath = `/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a file with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete File
         * @param {number} id The id of the File
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFile', 'id', id)
            const localVarPath = `/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a introduction with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete introduction
         * @param {number} id The id of the introduction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntroduction: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteIntroduction', 'id', id)
            const localVarPath = `/introduction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a location with a specific id 
         * @summary Delete Location
         * @param {number} locationId The id of the location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation: (locationId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteLocation', 'locationId', locationId)
            const localVarPath = `/location/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a price sheet
         * @param {number} pricesheetId The id of the price sheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriceSheet: (pricesheetId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'pricesheetId' is not null or undefined
            assertParamExists('deletePriceSheet', 'pricesheetId', pricesheetId)
            const localVarPath = `/pricesheet/{pricesheet_id}`
                .replace(`{${"pricesheet_id"}}`, encodeURIComponent(String(pricesheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a project with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Project
         * @param {number} id The id of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProject', 'id', id)
            const localVarPath = `/project/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a report
         * @param {number} reportId The id of the report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReport: (reportId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('deleteReport', 'reportId', reportId)
            const localVarPath = `/report/{report_id}`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a resource with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete resource
         * @param {number} id The id of the resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteResource', 'id', id)
            const localVarPath = `/resource/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a category with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete category
         * @param {number} id The id of the category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResourceCategory: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteResourceCategory', 'id', id)
            const localVarPath = `/resource/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a scorm with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Scorm
         * @param {number} id The id of the Scorm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScorm: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteScorm', 'id', id)
            const localVarPath = `/scorm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a user
         * @param {number} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: (userId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset all user progress 
         * @summary Reset all user progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAllUserProgress: (options: any = {}): RequestArgs => {
            const localVarPath = `/scorm/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeleteApi - functional programming interface
 * @export
 */
export const DeleteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeleteApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a agency with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Agency
         * @param {DeleteApiDeleteAgencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgency(requestParameters: DeleteApiDeleteAgencyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteAgency(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a company with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Company
         * @param {DeleteApiDeleteCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany(requestParameters: DeleteApiDeleteCompanyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteCompany(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a file with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete File
         * @param {DeleteApiDeleteFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(requestParameters: DeleteApiDeleteFileRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteFile(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a introduction with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete introduction
         * @param {DeleteApiDeleteIntroductionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntroduction(requestParameters: DeleteApiDeleteIntroductionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteIntroduction(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a location with a specific id 
         * @summary Delete Location
         * @param {DeleteApiDeleteLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation(requestParameters: DeleteApiDeleteLocationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteLocation(requestParameters.locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a price sheet
         * @param {DeleteApiDeletePriceSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriceSheet(requestParameters: DeleteApiDeletePriceSheetRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deletePriceSheet(requestParameters.pricesheetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a project with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Project
         * @param {DeleteApiDeleteProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject(requestParameters: DeleteApiDeleteProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteProject(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a report
         * @param {DeleteApiDeleteReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReport(requestParameters: DeleteApiDeleteReportRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteReport(requestParameters.reportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a resource with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete resource
         * @param {DeleteApiDeleteResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(requestParameters: DeleteApiDeleteResourceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteResource(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a category with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete category
         * @param {DeleteApiDeleteResourceCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResourceCategory(requestParameters: DeleteApiDeleteResourceCategoryRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteResourceCategory(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a scorm with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Scorm
         * @param {DeleteApiDeleteScormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScorm(requestParameters: DeleteApiDeleteScormRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteScorm(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a user
         * @param {DeleteApiDeleteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(requestParameters: DeleteApiDeleteUserRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteUser(requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reset all user progress 
         * @summary Reset all user progress
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAllUserProgress(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SuccessModel>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.resetAllUserProgress(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DeleteApi - factory interface
 * @export
 */
export const DeleteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeleteApiFp(configuration)

    /**
      * Delete a agency with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete Agency
      * @param {DeleteApiDeleteAgencyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteAgency = (requestParameters: DeleteApiDeleteAgencyRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteAgency(requestParameters, options);
        return request(axios, basePath);
    };

    deleteAgency.getQueryKey = (requestParameters: DeleteApiDeleteAgencyRequest, options?: any) => {
        const request = localVarFp.deleteAgency(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a company with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete Company
      * @param {DeleteApiDeleteCompanyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteCompany = (requestParameters: DeleteApiDeleteCompanyRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteCompany(requestParameters, options);
        return request(axios, basePath);
    };

    deleteCompany.getQueryKey = (requestParameters: DeleteApiDeleteCompanyRequest, options?: any) => {
        const request = localVarFp.deleteCompany(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a file with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete File
      * @param {DeleteApiDeleteFileRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteFile = (requestParameters: DeleteApiDeleteFileRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteFile(requestParameters, options);
        return request(axios, basePath);
    };

    deleteFile.getQueryKey = (requestParameters: DeleteApiDeleteFileRequest, options?: any) => {
        const request = localVarFp.deleteFile(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a introduction with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete introduction
      * @param {DeleteApiDeleteIntroductionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteIntroduction = (requestParameters: DeleteApiDeleteIntroductionRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteIntroduction(requestParameters, options);
        return request(axios, basePath);
    };

    deleteIntroduction.getQueryKey = (requestParameters: DeleteApiDeleteIntroductionRequest, options?: any) => {
        const request = localVarFp.deleteIntroduction(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a location with a specific id 
      * @summary Delete Location
      * @param {DeleteApiDeleteLocationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteLocation = (requestParameters: DeleteApiDeleteLocationRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteLocation(requestParameters, options);
        return request(axios, basePath);
    };

    deleteLocation.getQueryKey = (requestParameters: DeleteApiDeleteLocationRequest, options?: any) => {
        const request = localVarFp.deleteLocation(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a user with a specific id 
      * @summary Delete a price sheet
      * @param {DeleteApiDeletePriceSheetRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deletePriceSheet = (requestParameters: DeleteApiDeletePriceSheetRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deletePriceSheet(requestParameters, options);
        return request(axios, basePath);
    };

    deletePriceSheet.getQueryKey = (requestParameters: DeleteApiDeletePriceSheetRequest, options?: any) => {
        const request = localVarFp.deletePriceSheet(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a project with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete Project
      * @param {DeleteApiDeleteProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteProject = (requestParameters: DeleteApiDeleteProjectRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteProject(requestParameters, options);
        return request(axios, basePath);
    };

    deleteProject.getQueryKey = (requestParameters: DeleteApiDeleteProjectRequest, options?: any) => {
        const request = localVarFp.deleteProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a user with a specific id 
      * @summary Delete a report
      * @param {DeleteApiDeleteReportRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteReport = (requestParameters: DeleteApiDeleteReportRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteReport(requestParameters, options);
        return request(axios, basePath);
    };

    deleteReport.getQueryKey = (requestParameters: DeleteApiDeleteReportRequest, options?: any) => {
        const request = localVarFp.deleteReport(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a resource with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete resource
      * @param {DeleteApiDeleteResourceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteResource = (requestParameters: DeleteApiDeleteResourceRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteResource(requestParameters, options);
        return request(axios, basePath);
    };

    deleteResource.getQueryKey = (requestParameters: DeleteApiDeleteResourceRequest, options?: any) => {
        const request = localVarFp.deleteResource(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a category with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete category
      * @param {DeleteApiDeleteResourceCategoryRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteResourceCategory = (requestParameters: DeleteApiDeleteResourceCategoryRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteResourceCategory(requestParameters, options);
        return request(axios, basePath);
    };

    deleteResourceCategory.getQueryKey = (requestParameters: DeleteApiDeleteResourceCategoryRequest, options?: any) => {
        const request = localVarFp.deleteResourceCategory(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a scorm with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete Scorm
      * @param {DeleteApiDeleteScormRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteScorm = (requestParameters: DeleteApiDeleteScormRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteScorm(requestParameters, options);
        return request(axios, basePath);
    };

    deleteScorm.getQueryKey = (requestParameters: DeleteApiDeleteScormRequest, options?: any) => {
        const request = localVarFp.deleteScorm(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a user with a specific id 
      * @summary Delete a user
      * @param {DeleteApiDeleteUserRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteUser = (requestParameters: DeleteApiDeleteUserRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteUser(requestParameters, options);
        return request(axios, basePath);
    };

    deleteUser.getQueryKey = (requestParameters: DeleteApiDeleteUserRequest, options?: any) => {
        const request = localVarFp.deleteUser(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Reset all user progress 
      * @summary Reset all user progress
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const resetAllUserProgress = (requestParameters?: undefined, options?: any): AxiosPromise<SuccessModel> => {
        const request = localVarFp.resetAllUserProgress(requestParameters, options);
        return request(axios, basePath);
    };

    resetAllUserProgress.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.resetAllUserProgress(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        deleteAgency,
        deleteCompany,
        deleteFile,
        deleteIntroduction,
        deleteLocation,
        deletePriceSheet,
        deleteProject,
        deleteReport,
        deleteResource,
        deleteResourceCategory,
        deleteScorm,
        deleteUser,
        resetAllUserProgress,
    };
};

/**
 * DeleteApi - interface
 * @export
 * @interface DeleteApi
 */
export interface DeleteApiInterface {
    /**
     * Delete a agency with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Agency
     * @param {DeleteApiDeleteAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deleteAgency(requestParameters: DeleteApiDeleteAgencyRequest, options?: any): AxiosPromise<void>;

    /**
     * Delete a company with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Company
     * @param {DeleteApiDeleteCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deleteCompany(requestParameters: DeleteApiDeleteCompanyRequest, options?: any): AxiosPromise<void>;

    /**
     * Delete a file with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete File
     * @param {DeleteApiDeleteFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deleteFile(requestParameters: DeleteApiDeleteFileRequest, options?: any): AxiosPromise<void>;

    /**
     * Delete a introduction with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete introduction
     * @param {DeleteApiDeleteIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deleteIntroduction(requestParameters: DeleteApiDeleteIntroductionRequest, options?: any): AxiosPromise<void>;

    /**
     * Delete a location with a specific id 
     * @summary Delete Location
     * @param {DeleteApiDeleteLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deleteLocation(requestParameters: DeleteApiDeleteLocationRequest, options?: any): AxiosPromise<void>;

    /**
     * Delete a user with a specific id 
     * @summary Delete a price sheet
     * @param {DeleteApiDeletePriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deletePriceSheet(requestParameters: DeleteApiDeletePriceSheetRequest, options?: any): AxiosPromise<void>;

    /**
     * Delete a project with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Project
     * @param {DeleteApiDeleteProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deleteProject(requestParameters: DeleteApiDeleteProjectRequest, options?: any): AxiosPromise<void>;

    /**
     * Delete a user with a specific id 
     * @summary Delete a report
     * @param {DeleteApiDeleteReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deleteReport(requestParameters: DeleteApiDeleteReportRequest, options?: any): AxiosPromise<void>;

    /**
     * Delete a resource with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete resource
     * @param {DeleteApiDeleteResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deleteResource(requestParameters: DeleteApiDeleteResourceRequest, options?: any): AxiosPromise<void>;

    /**
     * Delete a category with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete category
     * @param {DeleteApiDeleteResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deleteResourceCategory(requestParameters: DeleteApiDeleteResourceCategoryRequest, options?: any): AxiosPromise<void>;

    /**
     * Delete a scorm with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Scorm
     * @param {DeleteApiDeleteScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deleteScorm(requestParameters: DeleteApiDeleteScormRequest, options?: any): AxiosPromise<void>;

    /**
     * Delete a user with a specific id 
     * @summary Delete a user
     * @param {DeleteApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    deleteUser(requestParameters: DeleteApiDeleteUserRequest, options?: any): AxiosPromise<void>;

    /**
     * Reset all user progress 
     * @summary Reset all user progress
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApiInterface
     */
    resetAllUserProgress(requestParameters?: undefined, options?: any): AxiosPromise<SuccessModel>;

}

/**
 * Request parameters for deleteAgency operation in DeleteApi.
 * @export
 * @interface DeleteApiDeleteAgencyRequest
 */
export interface DeleteApiDeleteAgencyRequest {
    /**
     * The id of the Agency
     * @type {number}
     * @memberof DeleteApiDeleteAgency
     */
    readonly id: number
}

/**
 * Request parameters for deleteCompany operation in DeleteApi.
 * @export
 * @interface DeleteApiDeleteCompanyRequest
 */
export interface DeleteApiDeleteCompanyRequest {
    /**
     * The id of the Company
     * @type {number}
     * @memberof DeleteApiDeleteCompany
     */
    readonly id: number
}

/**
 * Request parameters for deleteFile operation in DeleteApi.
 * @export
 * @interface DeleteApiDeleteFileRequest
 */
export interface DeleteApiDeleteFileRequest {
    /**
     * The id of the File
     * @type {number}
     * @memberof DeleteApiDeleteFile
     */
    readonly id: number
}

/**
 * Request parameters for deleteIntroduction operation in DeleteApi.
 * @export
 * @interface DeleteApiDeleteIntroductionRequest
 */
export interface DeleteApiDeleteIntroductionRequest {
    /**
     * The id of the introduction
     * @type {number}
     * @memberof DeleteApiDeleteIntroduction
     */
    readonly id: number
}

/**
 * Request parameters for deleteLocation operation in DeleteApi.
 * @export
 * @interface DeleteApiDeleteLocationRequest
 */
export interface DeleteApiDeleteLocationRequest {
    /**
     * The id of the location
     * @type {number}
     * @memberof DeleteApiDeleteLocation
     */
    readonly locationId: number
}

/**
 * Request parameters for deletePriceSheet operation in DeleteApi.
 * @export
 * @interface DeleteApiDeletePriceSheetRequest
 */
export interface DeleteApiDeletePriceSheetRequest {
    /**
     * The id of the price sheet
     * @type {number}
     * @memberof DeleteApiDeletePriceSheet
     */
    readonly pricesheetId: number
}

/**
 * Request parameters for deleteProject operation in DeleteApi.
 * @export
 * @interface DeleteApiDeleteProjectRequest
 */
export interface DeleteApiDeleteProjectRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof DeleteApiDeleteProject
     */
    readonly id: number
}

/**
 * Request parameters for deleteReport operation in DeleteApi.
 * @export
 * @interface DeleteApiDeleteReportRequest
 */
export interface DeleteApiDeleteReportRequest {
    /**
     * The id of the report
     * @type {number}
     * @memberof DeleteApiDeleteReport
     */
    readonly reportId: number
}

/**
 * Request parameters for deleteResource operation in DeleteApi.
 * @export
 * @interface DeleteApiDeleteResourceRequest
 */
export interface DeleteApiDeleteResourceRequest {
    /**
     * The id of the resource
     * @type {number}
     * @memberof DeleteApiDeleteResource
     */
    readonly id: number
}

/**
 * Request parameters for deleteResourceCategory operation in DeleteApi.
 * @export
 * @interface DeleteApiDeleteResourceCategoryRequest
 */
export interface DeleteApiDeleteResourceCategoryRequest {
    /**
     * The id of the category
     * @type {number}
     * @memberof DeleteApiDeleteResourceCategory
     */
    readonly id: number
}

/**
 * Request parameters for deleteScorm operation in DeleteApi.
 * @export
 * @interface DeleteApiDeleteScormRequest
 */
export interface DeleteApiDeleteScormRequest {
    /**
     * The id of the Scorm
     * @type {number}
     * @memberof DeleteApiDeleteScorm
     */
    readonly id: number
}

/**
 * Request parameters for deleteUser operation in DeleteApi.
 * @export
 * @interface DeleteApiDeleteUserRequest
 */
export interface DeleteApiDeleteUserRequest {
    /**
     * The id of the user
     * @type {number}
     * @memberof DeleteApiDeleteUser
     */
    readonly userId: number
}

/**
 * DeleteApi - object-oriented interface
 * @export
 * @class DeleteApi
 * @extends {BaseAPI}
 */
export class DeleteApi extends BaseAPI implements DeleteApiInterface {
    /**
     * Delete a agency with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Agency
     * @param {DeleteApiDeleteAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deleteAgency(requestParameters: DeleteApiDeleteAgencyRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deleteAgency(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a company with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Company
     * @param {DeleteApiDeleteCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deleteCompany(requestParameters: DeleteApiDeleteCompanyRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deleteCompany(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a file with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete File
     * @param {DeleteApiDeleteFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deleteFile(requestParameters: DeleteApiDeleteFileRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deleteFile(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a introduction with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete introduction
     * @param {DeleteApiDeleteIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deleteIntroduction(requestParameters: DeleteApiDeleteIntroductionRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deleteIntroduction(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a location with a specific id 
     * @summary Delete Location
     * @param {DeleteApiDeleteLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deleteLocation(requestParameters: DeleteApiDeleteLocationRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deleteLocation(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a user with a specific id 
     * @summary Delete a price sheet
     * @param {DeleteApiDeletePriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deletePriceSheet(requestParameters: DeleteApiDeletePriceSheetRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deletePriceSheet(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a project with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Project
     * @param {DeleteApiDeleteProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deleteProject(requestParameters: DeleteApiDeleteProjectRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deleteProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a user with a specific id 
     * @summary Delete a report
     * @param {DeleteApiDeleteReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deleteReport(requestParameters: DeleteApiDeleteReportRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deleteReport(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a resource with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete resource
     * @param {DeleteApiDeleteResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deleteResource(requestParameters: DeleteApiDeleteResourceRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deleteResource(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a category with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete category
     * @param {DeleteApiDeleteResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deleteResourceCategory(requestParameters: DeleteApiDeleteResourceCategoryRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deleteResourceCategory(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a scorm with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Scorm
     * @param {DeleteApiDeleteScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deleteScorm(requestParameters: DeleteApiDeleteScormRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deleteScorm(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a user with a specific id 
     * @summary Delete a user
     * @param {DeleteApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public deleteUser(requestParameters: DeleteApiDeleteUserRequest, options?: any) {
        const request = DeleteApiFp(this.configuration).deleteUser(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Reset all user progress 
     * @summary Reset all user progress
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteApi
     */
    public resetAllUserProgress(requestParameters?: undefined, options?: any) {
        const request = DeleteApiFp(this.configuration).resetAllUserProgress(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a file with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete File
         * @param {number} id The id of the File
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFile', 'id', id)
            const localVarPath = `/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single file 
         * @summary Get File
         * @param {number} id The id of the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFile', 'id', id)
            const localVarPath = `/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of files.  Each file has ownership and visibility settings. 
         * @summary List Files
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of file records the current user has access to.
         * @param {number} [companyId] Filter files by company.  Ignored for non-admins.  Users will see only their own files
         * @param {number} [locationId] Filter files by location.  Will only filter by locations the current user has access to
         * @param {FileStatus} [status] Filter files by status
         * @param {FileType} [type] Filter files by type
         * @param {Array<FileVisibility>} [visibility] Filter files by visibility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiles: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, companyId?: number, locationId?: number, status?: FileStatus, type?: FileType, visibility?: Array<FileVisibility>, options: any = {}): RequestArgs => {
            const localVarPath = `/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (visibility) {
                localVarQueryParameter['visibility[]'] = visibility;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a file you own 
         * @summary Update File
         * @param {number} id The id of the order
         * @param {FileModelMetadataRequestBody} fileModelMetadataRequestBody Parameters for requesting an order change
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFile: (id: number, fileModelMetadataRequestBody: FileModelMetadataRequestBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFile', 'id', id)
            // verify required parameter 'fileModelMetadataRequestBody' is not null or undefined
            assertParamExists('updateFile', 'fileModelMetadataRequestBody', fileModelMetadataRequestBody)
            const localVarPath = `/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileModelMetadataRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a file attached to a specific user, and returns a 
         * @summary Upload a File
         * @param {any} image 
         * @param {FileType} type 
         * @param {string} [title] 
         * @param {string} [alt] 
         * @param {FileStatus} [status] 
         * @param {FileVisibility} [visibility] This allows privileged users to set the visibility level to allow other users to see a files. This will default to hidden, which means no one will see it, even the current user.  Setting to private will add the file to my file library.  Setting to location and company will allow anyone in my location or company respectively.  Setting to public is only available to admins and will add it to the global library 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: (image: any, type: FileType, title?: string, alt?: string, status?: FileStatus, visibility?: FileVisibility, options: any = {}): RequestArgs => {
            // verify required parameter 'image' is not null or undefined
            assertParamExists('upload', 'image', image)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('upload', 'type', type)
            const localVarPath = `/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
    
            if (alt !== undefined) { 
                localVarFormParams.append('alt', alt as any);
            }
    
            if (status !== undefined) { 
                localVarFormParams.append('status', status as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.append('type', type as any);
            }
    
            if (visibility !== undefined) { 
                localVarFormParams.append('visibility', visibility as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a file with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete File
         * @param {FileApiDeleteFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(requestParameters: FileApiDeleteFileRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteFile(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a single file 
         * @summary Get File
         * @param {FileApiGetFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile(requestParameters: FileApiGetFileRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<FileModel>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getFile(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of files.  Each file has ownership and visibility settings. 
         * @summary List Files
         * @param {FileApiListFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiles(requestParameters: FileApiListFilesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedFiles>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listFiles(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.companyId, requestParameters.locationId, requestParameters.status, requestParameters.type, requestParameters.visibility, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a file you own 
         * @summary Update File
         * @param {FileApiUpdateFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFile(requestParameters: FileApiUpdateFileRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<FileModel>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateFile(requestParameters.id, requestParameters.fileModelMetadataRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a file attached to a specific user, and returns a 
         * @summary Upload a File
         * @param {FileApiUploadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(requestParameters: FileApiUploadRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<FileModel>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.upload(requestParameters.image, requestParameters.type, requestParameters.title, requestParameters.alt, requestParameters.status, requestParameters.visibility, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileApiFp(configuration)

    /**
      * Delete a file with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete File
      * @param {FileApiDeleteFileRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteFile = (requestParameters: FileApiDeleteFileRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteFile(requestParameters, options);
        return request(axios, basePath);
    };

    deleteFile.getQueryKey = (requestParameters: FileApiDeleteFileRequest, options?: any) => {
        const request = localVarFp.deleteFile(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a single file 
      * @summary Get File
      * @param {FileApiGetFileRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getFile = (requestParameters: FileApiGetFileRequest, options?: any): AxiosPromise<FileModel> => {
        const request = localVarFp.getFile(requestParameters, options);
        return request(axios, basePath);
    };

    getFile.getQueryKey = (requestParameters: FileApiGetFileRequest, options?: any) => {
        const request = localVarFp.getFile(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of files.  Each file has ownership and visibility settings. 
      * @summary List Files
      * @param {FileApiListFilesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listFiles = (requestParameters: FileApiListFilesRequest = {}, options?: any): AxiosPromise<PaginatedFiles> => {
        const request = localVarFp.listFiles(requestParameters, options);
        return request(axios, basePath);
    };

    listFiles.getQueryKey = (requestParameters: FileApiListFilesRequest = {}, options?: any) => {
        const request = localVarFp.listFiles(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a file you own 
      * @summary Update File
      * @param {FileApiUpdateFileRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateFile = (requestParameters: FileApiUpdateFileRequest, options?: any): AxiosPromise<FileModel> => {
        const request = localVarFp.updateFile(requestParameters, options);
        return request(axios, basePath);
    };

    updateFile.getQueryKey = (requestParameters: FileApiUpdateFileRequest, options?: any) => {
        const request = localVarFp.updateFile(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Creates a file attached to a specific user, and returns a 
      * @summary Upload a File
      * @param {FileApiUploadRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const upload = (requestParameters: FileApiUploadRequest, options?: any): AxiosPromise<FileModel> => {
        const request = localVarFp.upload(requestParameters, options);
        return request(axios, basePath);
    };

    upload.getQueryKey = (requestParameters: FileApiUploadRequest, options?: any) => {
        const request = localVarFp.upload(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        deleteFile,
        getFile,
        listFiles,
        updateFile,
        upload,
    };
};

/**
 * FileApi - interface
 * @export
 * @interface FileApi
 */
export interface FileApiInterface {
    /**
     * Delete a file with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete File
     * @param {FileApiDeleteFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApiInterface
     */
    deleteFile(requestParameters: FileApiDeleteFileRequest, options?: any): AxiosPromise<void>;

    /**
     * Get a single file 
     * @summary Get File
     * @param {FileApiGetFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApiInterface
     */
    getFile(requestParameters: FileApiGetFileRequest, options?: any): AxiosPromise<FileModel>;

    /**
     * Fetch a list of files.  Each file has ownership and visibility settings. 
     * @summary List Files
     * @param {FileApiListFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApiInterface
     */
    listFiles(requestParameters?: FileApiListFilesRequest, options?: any): AxiosPromise<PaginatedFiles>;

    /**
     * Update a file you own 
     * @summary Update File
     * @param {FileApiUpdateFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApiInterface
     */
    updateFile(requestParameters: FileApiUpdateFileRequest, options?: any): AxiosPromise<FileModel>;

    /**
     * Creates a file attached to a specific user, and returns a 
     * @summary Upload a File
     * @param {FileApiUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApiInterface
     */
    upload(requestParameters: FileApiUploadRequest, options?: any): AxiosPromise<FileModel>;

}

/**
 * Request parameters for deleteFile operation in FileApi.
 * @export
 * @interface FileApiDeleteFileRequest
 */
export interface FileApiDeleteFileRequest {
    /**
     * The id of the File
     * @type {number}
     * @memberof FileApiDeleteFile
     */
    readonly id: number
}

/**
 * Request parameters for getFile operation in FileApi.
 * @export
 * @interface FileApiGetFileRequest
 */
export interface FileApiGetFileRequest {
    /**
     * The id of the file
     * @type {number}
     * @memberof FileApiGetFile
     */
    readonly id: number
}

/**
 * Request parameters for listFiles operation in FileApi.
 * @export
 * @interface FileApiListFilesRequest
 */
export interface FileApiListFilesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof FileApiListFiles
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof FileApiListFiles
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof FileApiListFiles
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof FileApiListFiles
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of file records the current user has access to.
     * @type {string}
     * @memberof FileApiListFiles
     */
    readonly search?: string

    /**
     * Filter files by company.  Ignored for non-admins.  Users will see only their own files
     * @type {number}
     * @memberof FileApiListFiles
     */
    readonly companyId?: number

    /**
     * Filter files by location.  Will only filter by locations the current user has access to
     * @type {number}
     * @memberof FileApiListFiles
     */
    readonly locationId?: number

    /**
     * Filter files by status
     * @type {FileStatus}
     * @memberof FileApiListFiles
     */
    readonly status?: FileStatus

    /**
     * Filter files by type
     * @type {FileType}
     * @memberof FileApiListFiles
     */
    readonly type?: FileType

    /**
     * Filter files by visibility
     * @type {Array<FileVisibility>}
     * @memberof FileApiListFiles
     */
    readonly visibility?: Array<FileVisibility>
}

/**
 * Request parameters for updateFile operation in FileApi.
 * @export
 * @interface FileApiUpdateFileRequest
 */
export interface FileApiUpdateFileRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof FileApiUpdateFile
     */
    readonly id: number

    /**
     * Parameters for requesting an order change
     * @type {FileModelMetadataRequestBody}
     * @memberof FileApiUpdateFile
     */
    readonly fileModelMetadataRequestBody: FileModelMetadataRequestBody
}

/**
 * Request parameters for upload operation in FileApi.
 * @export
 * @interface FileApiUploadRequest
 */
export interface FileApiUploadRequest {
    /**
     * 
     * @type {any}
     * @memberof FileApiUpload
     */
    readonly image: any

    /**
     * 
     * @type {FileType}
     * @memberof FileApiUpload
     */
    readonly type: FileType

    /**
     * 
     * @type {string}
     * @memberof FileApiUpload
     */
    readonly title?: string

    /**
     * 
     * @type {string}
     * @memberof FileApiUpload
     */
    readonly alt?: string

    /**
     * 
     * @type {FileStatus}
     * @memberof FileApiUpload
     */
    readonly status?: FileStatus

    /**
     * This allows privileged users to set the visibility level to allow other users to see a files. This will default to hidden, which means no one will see it, even the current user.  Setting to private will add the file to my file library.  Setting to location and company will allow anyone in my location or company respectively.  Setting to public is only available to admins and will add it to the global library 
     * @type {FileVisibility}
     * @memberof FileApiUpload
     */
    readonly visibility?: FileVisibility
}

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI implements FileApiInterface {
    /**
     * Delete a file with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete File
     * @param {FileApiDeleteFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public deleteFile(requestParameters: FileApiDeleteFileRequest, options?: any) {
        const request = FileApiFp(this.configuration).deleteFile(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a single file 
     * @summary Get File
     * @param {FileApiGetFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public getFile(requestParameters: FileApiGetFileRequest, options?: any) {
        const request = FileApiFp(this.configuration).getFile(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of files.  Each file has ownership and visibility settings. 
     * @summary List Files
     * @param {FileApiListFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public listFiles(requestParameters: FileApiListFilesRequest = {}, options?: any) {
        const request = FileApiFp(this.configuration).listFiles(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a file you own 
     * @summary Update File
     * @param {FileApiUpdateFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public updateFile(requestParameters: FileApiUpdateFileRequest, options?: any) {
        const request = FileApiFp(this.configuration).updateFile(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Creates a file attached to a specific user, and returns a 
     * @summary Upload a File
     * @param {FileApiUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public upload(requestParameters: FileApiUploadRequest, options?: any) {
        const request = FileApiFp(this.configuration).upload(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * GetApi - axios parameter creator
 * @export
 */
export const GetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Give a type of content to search on and a partial match, this will return common search terms that match 
         * @summary Autocomplete Search
         * @param {string} type The entity type that we want to autocomplete on
         * @param {string} query A short string to do a partial match on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autocomplete: (type: string, query: string, options: any = {}): RequestArgs => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('autocomplete', 'type', type)
            // verify required parameter 'query' is not null or undefined
            assertParamExists('autocomplete', 'query', query)
            const localVarPath = `/autocomplete/{type}/{query}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"query"}}`, encodeURIComponent(String(query)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the current invoice, or package of packing slips 
         * @summary Download Invoice
         * @param {number} id The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInvoice: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadInvoice', 'id', id)
            const localVarPath = `/order/{id}/invoice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the current packing slip, or package of packing slips 
         * @summary Download packing slip
         * @param {number} id The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPackSlip: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadPackSlip', 'id', id)
            const localVarPath = `/order/{id}/packing_slip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a given id, if the project is published, stream the contents out with the right mime type to force the file to download 
         * @summary Download a published project
         * @param {number} id The id of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProject: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadProject', 'id', id)
            const localVarPath = `/project/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a given id, if the project is published, fetch a particular version and stream the contents out with the right mime type to force the file to download 
         * @summary Download a published project at a particular version
         * @param {number} id The id of the project
         * @param {number} versionId The version_id of the version in the project you want
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProjectVersion: (id: number, versionId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadProjectVersion', 'id', id)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('downloadProjectVersion', 'versionId', versionId)
            const localVarPath = `/project/{id}/download/version/{version_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a given token try to download a project 
         * @summary Download a published project
         * @param {string} publicToken The public_token of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPublicProject: (publicToken: string, options: any = {}): RequestArgs => {
            // verify required parameter 'publicToken' is not null or undefined
            assertParamExists('downloadPublicProject', 'publicToken', publicToken)
            const localVarPath = `/project/public/{public_token}/download`
                .replace(`{${"public_token"}}`, encodeURIComponent(String(publicToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a given token try to download a project at a particular version 
         * @summary Download a specific version of a published project
         * @param {string} publicToken The public_token of the project
         * @param {string} versionId The version_id of the version of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPublicProjectVersion: (publicToken: string, versionId: string, options: any = {}): RequestArgs => {
            // verify required parameter 'publicToken' is not null or undefined
            assertParamExists('downloadPublicProjectVersion', 'publicToken', publicToken)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('downloadPublicProjectVersion', 'versionId', versionId)
            const localVarPath = `/project/public/{public_token}/download/version/{version_id}`
                .replace(`{${"public_token"}}`, encodeURIComponent(String(publicToken)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches company details from symmons api 
         * @summary Fetch company by bill_to
         * @param {string} billTo The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddresses: (billTo: string, options: any = {}): RequestArgs => {
            // verify required parameter 'billTo' is not null or undefined
            assertParamExists('fetchCompanyAddresses', 'billTo', billTo)
            const localVarPath = `/company/fetch/{bill_to}`
                .replace(`{${"bill_to"}}`, encodeURIComponent(String(billTo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single agency by id 
         * @summary Get Agency
         * @param {number} id The id of the agency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgency: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgency', 'id', id)
            const localVarPath = `/agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single company by id 
         * @summary Get Company
         * @param {number} id The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompany', 'id', id)
            const localVarPath = `/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Each user can only have one pending quote at a time.  The quote acts as a cart.  While the quote is pending, this method will return the current quote object.  When the quote is moved from status 1 (pending) to status 2 (sent) the quote will be sent, and this method will return an empty quote object, ready to start a new quote. 
         * @summary Get Current Quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentQuote: (options: any = {}): RequestArgs => {
            const localVarPath = `/quote/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single file 
         * @summary Get File
         * @param {number} id The id of the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFile', 'id', id)
            const localVarPath = `/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single introduction by id 
         * @summary Get Introduction
         * @param {number} id The id of the introduction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntroduction: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIntroduction', 'id', id)
            const localVarPath = `/introduction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single location by id 
         * @summary Get Location
         * @param {number} locationId The id of the location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation: (locationId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLocation', 'locationId', locationId)
            const localVarPath = `/location/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single order 
         * @summary Get Order
         * @param {number} id The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrder', 'id', id)
            const localVarPath = `/order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single price sheet by id 
         * @summary Get PriceSheet
         * @param {number} pricesheetId The id of the price sheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceSheet: (pricesheetId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'pricesheetId' is not null or undefined
            assertParamExists('getPriceSheet', 'pricesheetId', pricesheetId)
            const localVarPath = `/pricesheet/{pricesheet_id}`
                .replace(`{${"pricesheet_id"}}`, encodeURIComponent(String(pricesheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the pricing for a product for the current user 
         * @summary Get Pricing
         * @param {string} modelNumber The product model number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricing: (modelNumber: string, options: any = {}): RequestArgs => {
            // verify required parameter 'modelNumber' is not null or undefined
            assertParamExists('getPricing', 'modelNumber', modelNumber)
            const localVarPath = `/pricing/{model_number}`
                .replace(`{${"model_number"}}`, encodeURIComponent(String(modelNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single scorm by id 
         * @summary Get Scorm Progress for authenticated user
         * @param {number} id The id of the scorm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgress: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProgress', 'id', id)
            const localVarPath = `/scorm/progress/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single project by id 
         * @summary Get Project
         * @param {number} id The id of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProject', 'id', id)
            const localVarPath = `/project/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a specific version of of a project. The version property will contain the full version object. 
         * @summary Get Specific project version
         * @param {number} project The id of the project
         * @param {number} version The id of the version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectVersion: (project: number, version: number, options: any = {}): RequestArgs => {
            // verify required parameter 'project' is not null or undefined
            assertParamExists('getProjectVersion', 'project', project)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getProjectVersion', 'version', version)
            const localVarPath = `/project/{project}/version/{version}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the public version of a project by token 
         * @summary Get Public Project
         * @param {string} token The token of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicProject: (token: string, options: any = {}): RequestArgs => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getPublicProject', 'token', token)
            const localVarPath = `/project/public/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single region by id with its associated territories 
         * @summary Get Region
         * @param {number} id The id of the region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegion: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRegion', 'id', id)
            const localVarPath = `/regions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single report by id 
         * @summary Get Report
         * @param {number} reportId The id of the report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport: (reportId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReport', 'reportId', reportId)
            const localVarPath = `/report/{report_id}`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single resource by id 
         * @summary Get Resource
         * @param {number} id The id of the resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getResource', 'id', id)
            const localVarPath = `/resource/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single resource by id 
         * @summary Get Resource
         * @param {number} id The id of the category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceCategory: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getResourceCategory', 'id', id)
            const localVarPath = `/resource/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single salesforce customer by id 
         * @summary Get a single Salesforce Customer
         * @param {number} id The id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceCustomer: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesforceCustomer', 'id', id)
            const localVarPath = `/salesforce/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single salesforce opportunity by id 
         * @summary Get a single Salesforce opportunity
         * @param {number} id The id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceOpportunity: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesforceOpportunity', 'id', id)
            const localVarPath = `/salesforce/opportunity/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single scorm by id 
         * @summary Get Scorm File
         * @param {number} id The id of the scorm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScorm: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getScorm', 'id', id)
            const localVarPath = `/scorm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return requested shower configuration type record by id 
         * @summary Get shower configuration record
         * @param {string} configurationKey The key of the shower configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowerConfiguration: (configurationKey: string, options: any = {}): RequestArgs => {
            // verify required parameter 'configurationKey' is not null or undefined
            assertParamExists('getShowerConfiguration', 'configurationKey', configurationKey)
            const localVarPath = `/configuration/shower/{configuration_key}`
                .replace(`{${"configuration_key"}}`, encodeURIComponent(String(configurationKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current health status of the application, including pending jobs, api version, cache status, and validation failures 
         * @summary Health Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: (options: any = {}): RequestArgs => {
            const localVarPath = `/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the TempControl project identified by `key`. Requires either ownership (authenticated user) or a matching `Authorization-Key` header. 
         * @summary Get TempControl project
         * @param {string} key TempControl project key
         * @param {string} [authorizationKey] Hashed md5 string used to authenticate guest access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempControlProject: (key: string, authorizationKey?: string, options: any = {}): RequestArgs => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getTempControlProject', 'key', key)
            const localVarPath = `/tempcontrol/projects/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (authorizationKey !== undefined && authorizationKey !== null) {
                localVarHeaderParameter['Authorization-Key'] = String(authorizationKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single territory by id with its associated region 
         * @summary Get Territory
         * @param {number} id The id of the territory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerritory: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTerritory', 'id', id)
            const localVarPath = `/territories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single user by id 
         * @summary Get User
         * @param {number} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: (userId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of the price sheet requests the current user has made 
         * @summary List Price Sheets
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [user] 
         * @param {PriceSheetStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPriceSheets: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', user?: string, status?: PriceSheetStatus, options: any = {}): RequestArgs => {
            const localVarPath = `/pricesheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search the product database.  This endpoint won\'t be used for the frontend app, but will be designed to support eventual product consumers 
         * @summary Search products
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of products records the current user has access to.
         * @param {string} [title] 
         * @param {string} [sku] 
         * @param {string} [status] 
         * @param {Array<string>} [categories] 
         * @param {Array<string>} [tiers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, title?: string, sku?: string, status?: string, categories?: Array<string>, tiers?: Array<string>, options: any = {}): RequestArgs => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (sku !== undefined) {
                localVarQueryParameter['sku'] = sku;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (categories) {
                localVarQueryParameter['categories[]'] = categories;
            }

            if (tiers) {
                localVarQueryParameter['tiers[]'] = tiers;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single quote 
         * @summary Get Quote
         * @param {number} id The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuote: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listQuote', 'id', id)
            const localVarPath = `/quote/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of reports 
         * @summary List Reports
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [user] 
         * @param {ReportType} [type] 
         * @param {ReportStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReports: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', user?: string, type?: ReportType, status?: ReportStatus, options: any = {}): RequestArgs => {
            const localVarPath = `/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of scores for a scorm or a user 
         * @summary Get scores list
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {string} [state] Filters scorm list by passed/incomplete state
         * @param {number} [scormId] The id of the scorm
         * @param {number} [userId] The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScormTrackings: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, state?: string, scormId?: number, userId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/scorm/tracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (scormId !== undefined) {
                localVarQueryParameter['scorm_id'] = scormId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If an order is stale, this will refresh the order from the upstream api 
         * @summary Refresh Order
         * @param {number} id The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshOrder: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshOrder', 'id', id)
            const localVarPath = `/order/{id}/refresh`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fire a background task to fetch all the salesforce data from the last two days 
         * @summary Refresh the salesforce data
         * @param {string} id The salesforce id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSalesforce: (id: string, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshSalesforce', 'id', id)
            const localVarPath = `/salesforce/refresh`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh a single salesforce customer in the db 
         * @summary Refresh a single salesforce customer in the db
         * @param {string} id The salesforce id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceCustomer: (id: string, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('syncSalesforceCustomer', 'id', id)
            const localVarPath = `/salesforce/customer/{id}/sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single salesforce customer while resyncing the customer from the db 
         * @summary Sync a single Salesforce opportunity
         * @param {string} id The salesforce id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceOpportunity: (id: string, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('syncSalesforceOpportunity', 'id', id)
            const localVarPath = `/salesforce/opportunity/{id}/sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetApi - functional programming interface
 * @export
 */
export const GetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetApiAxiosParamCreator(configuration)
    return {
        /**
         * Give a type of content to search on and a partial match, this will return common search terms that match 
         * @summary Autocomplete Search
         * @param {GetApiAutocompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autocomplete(requestParameters: GetApiAutocompleteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Array<AutocompleteResult>>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.autocomplete(requestParameters.type, requestParameters.query, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download the current invoice, or package of packing slips 
         * @summary Download Invoice
         * @param {GetApiDownloadInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInvoice(requestParameters: GetApiDownloadInvoiceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadInvoice(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download the current packing slip, or package of packing slips 
         * @summary Download packing slip
         * @param {GetApiDownloadPackSlipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPackSlip(requestParameters: GetApiDownloadPackSlipRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadPackSlip(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For a given id, if the project is published, stream the contents out with the right mime type to force the file to download 
         * @summary Download a published project
         * @param {GetApiDownloadProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProject(requestParameters: GetApiDownloadProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadProject(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For a given id, if the project is published, fetch a particular version and stream the contents out with the right mime type to force the file to download 
         * @summary Download a published project at a particular version
         * @param {GetApiDownloadProjectVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProjectVersion(requestParameters: GetApiDownloadProjectVersionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadProjectVersion(requestParameters.id, requestParameters.versionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For a given token try to download a project 
         * @summary Download a published project
         * @param {GetApiDownloadPublicProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPublicProject(requestParameters: GetApiDownloadPublicProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadPublicProject(requestParameters.publicToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For a given token try to download a project at a particular version 
         * @summary Download a specific version of a published project
         * @param {GetApiDownloadPublicProjectVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPublicProjectVersion(requestParameters: GetApiDownloadPublicProjectVersionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadPublicProjectVersion(requestParameters.publicToken, requestParameters.versionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetches company details from symmons api 
         * @summary Fetch company by bill_to
         * @param {GetApiFetchCompanyAddressesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddresses(requestParameters: GetApiFetchCompanyAddressesRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<FetchCompanyDetails>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.fetchCompanyAddresses(requestParameters.billTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single agency by id 
         * @summary Get Agency
         * @param {GetApiGetAgencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgency(requestParameters: GetApiGetAgencyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Agency>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getAgency(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single company by id 
         * @summary Get Company
         * @param {GetApiGetCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(requestParameters: GetApiGetCompanyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Company>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getCompany(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Each user can only have one pending quote at a time.  The quote acts as a cart.  While the quote is pending, this method will return the current quote object.  When the quote is moved from status 1 (pending) to status 2 (sent) the quote will be sent, and this method will return an empty quote object, ready to start a new quote. 
         * @summary Get Current Quote
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentQuote(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PendingQuote>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getCurrentQuote(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a single file 
         * @summary Get File
         * @param {GetApiGetFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile(requestParameters: GetApiGetFileRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<FileModel>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getFile(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single introduction by id 
         * @summary Get Introduction
         * @param {GetApiGetIntroductionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntroduction(requestParameters: GetApiGetIntroductionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Introduction>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getIntroduction(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single location by id 
         * @summary Get Location
         * @param {GetApiGetLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation(requestParameters: GetApiGetLocationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Location>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getLocation(requestParameters.locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a single order 
         * @summary Get Order
         * @param {GetApiGetOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder(requestParameters: GetApiGetOrderRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Order>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getOrder(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single price sheet by id 
         * @summary Get PriceSheet
         * @param {GetApiGetPriceSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceSheet(requestParameters: GetApiGetPriceSheetRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PriceSheet>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getPriceSheet(requestParameters.pricesheetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch the pricing for a product for the current user 
         * @summary Get Pricing
         * @param {GetApiGetPricingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricing(requestParameters: GetApiGetPricingRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<GetPricingResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getPricing(requestParameters.modelNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single scorm by id 
         * @summary Get Scorm Progress for authenticated user
         * @param {GetApiGetProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgress(requestParameters: GetApiGetProgressRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ScormScoTracking>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getProgress(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single project by id 
         * @summary Get Project
         * @param {GetApiGetProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject(requestParameters: GetApiGetProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Project>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getProject(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a specific version of of a project. The version property will contain the full version object. 
         * @summary Get Specific project version
         * @param {GetApiGetProjectVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectVersion(requestParameters: GetApiGetProjectVersionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Project>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getProjectVersion(requestParameters.project, requestParameters.version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch the public version of a project by token 
         * @summary Get Public Project
         * @param {GetApiGetPublicProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicProject(requestParameters: GetApiGetPublicProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Project>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getPublicProject(requestParameters.token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single region by id with its associated territories 
         * @summary Get Region
         * @param {GetApiGetRegionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegion(requestParameters: GetApiGetRegionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegionResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getRegion(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single report by id 
         * @summary Get Report
         * @param {GetApiGetReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(requestParameters: GetApiGetReportRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Report>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getReport(requestParameters.reportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single resource by id 
         * @summary Get Resource
         * @param {GetApiGetResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource(requestParameters: GetApiGetResourceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Resource>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getResource(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single resource by id 
         * @summary Get Resource
         * @param {GetApiGetResourceCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceCategory(requestParameters: GetApiGetResourceCategoryRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TaxonomyTermConnect>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getResourceCategory(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single salesforce customer by id 
         * @summary Get a single Salesforce Customer
         * @param {GetApiGetSalesforceCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceCustomer(requestParameters: GetApiGetSalesforceCustomerRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceCustomer>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getSalesforceCustomer(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single salesforce opportunity by id 
         * @summary Get a single Salesforce opportunity
         * @param {GetApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceOpportunity(requestParameters: GetApiGetSalesforceOpportunityRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceOpportunity>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getSalesforceOpportunity(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single scorm by id 
         * @summary Get Scorm File
         * @param {GetApiGetScormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScorm(requestParameters: GetApiGetScormRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Scorm>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getScorm(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return requested shower configuration type record by id 
         * @summary Get shower configuration record
         * @param {GetApiGetShowerConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowerConfiguration(requestParameters: GetApiGetShowerConfigurationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ShowerConfiguration>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getShowerConfiguration(requestParameters.configurationKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the current health status of the application, including pending jobs, api version, cache status, and validation failures 
         * @summary Health Status
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<GetStatusResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the TempControl project identified by `key`. Requires either ownership (authenticated user) or a matching `Authorization-Key` header. 
         * @summary Get TempControl project
         * @param {GetApiGetTempControlProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempControlProject(requestParameters: GetApiGetTempControlProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TempControlProject>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getTempControlProject(requestParameters.key, requestParameters.authorizationKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single territory by id with its associated region 
         * @summary Get Territory
         * @param {GetApiGetTerritoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerritory(requestParameters: GetApiGetTerritoryRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TerritoryResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getTerritory(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single user by id 
         * @summary Get User
         * @param {GetApiGetUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(requestParameters: GetApiGetUserRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<User>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getUser(requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a list of the price sheet requests the current user has made 
         * @summary List Price Sheets
         * @param {GetApiListPriceSheetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPriceSheets(requestParameters: GetApiListPriceSheetsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedPriceSheets>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listPriceSheets(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.user, requestParameters.status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search the product database.  This endpoint won\'t be used for the frontend app, but will be designed to support eventual product consumers 
         * @summary Search products
         * @param {GetApiListProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts(requestParameters: GetApiListProductsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedProducts>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listProducts(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.title, requestParameters.sku, requestParameters.status, requestParameters.categories, requestParameters.tiers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a single quote 
         * @summary Get Quote
         * @param {GetApiListQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuote(requestParameters: GetApiListQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Quote>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listQuote(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a list of reports 
         * @summary List Reports
         * @param {GetApiListReportsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReports(requestParameters: GetApiListReportsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedReports>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listReports(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.user, requestParameters.type, requestParameters.status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of scores for a scorm or a user 
         * @summary Get scores list
         * @param {GetApiListScormTrackingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScormTrackings(requestParameters: GetApiListScormTrackingsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedScormScoTracking>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listScormTrackings(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.state, requestParameters.scormId, requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * If an order is stale, this will refresh the order from the upstream api 
         * @summary Refresh Order
         * @param {GetApiRefreshOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshOrder(requestParameters: GetApiRefreshOrderRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Order>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.refreshOrder(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fire a background task to fetch all the salesforce data from the last two days 
         * @summary Refresh the salesforce data
         * @param {GetApiRefreshSalesforceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSalesforce(requestParameters: GetApiRefreshSalesforceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.refreshSalesforce(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Refresh a single salesforce customer in the db 
         * @summary Refresh a single salesforce customer in the db
         * @param {GetApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceCustomer(requestParameters: GetApiSyncSalesforceCustomerRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceCustomer>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.syncSalesforceCustomer(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single salesforce customer while resyncing the customer from the db 
         * @summary Sync a single Salesforce opportunity
         * @param {GetApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceOpportunity(requestParameters: GetApiSyncSalesforceOpportunityRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceOpportunity>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.syncSalesforceOpportunity(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GetApi - factory interface
 * @export
 */
export const GetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetApiFp(configuration)

    /**
      * Give a type of content to search on and a partial match, this will return common search terms that match 
      * @summary Autocomplete Search
      * @param {GetApiAutocompleteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const autocomplete = (requestParameters: GetApiAutocompleteRequest, options?: any): AxiosPromise<Array<AutocompleteResult>> => {
        const request = localVarFp.autocomplete(requestParameters, options);
        return request(axios, basePath);
    };

    autocomplete.getQueryKey = (requestParameters: GetApiAutocompleteRequest, options?: any) => {
        const request = localVarFp.autocomplete(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Download the current invoice, or package of packing slips 
      * @summary Download Invoice
      * @param {GetApiDownloadInvoiceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadInvoice = (requestParameters: GetApiDownloadInvoiceRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadInvoice(requestParameters, options);
        return request(axios, basePath);
    };

    downloadInvoice.getQueryKey = (requestParameters: GetApiDownloadInvoiceRequest, options?: any) => {
        const request = localVarFp.downloadInvoice(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Download the current packing slip, or package of packing slips 
      * @summary Download packing slip
      * @param {GetApiDownloadPackSlipRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadPackSlip = (requestParameters: GetApiDownloadPackSlipRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadPackSlip(requestParameters, options);
        return request(axios, basePath);
    };

    downloadPackSlip.getQueryKey = (requestParameters: GetApiDownloadPackSlipRequest, options?: any) => {
        const request = localVarFp.downloadPackSlip(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * For a given id, if the project is published, stream the contents out with the right mime type to force the file to download 
      * @summary Download a published project
      * @param {GetApiDownloadProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadProject = (requestParameters: GetApiDownloadProjectRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadProject(requestParameters, options);
        return request(axios, basePath);
    };

    downloadProject.getQueryKey = (requestParameters: GetApiDownloadProjectRequest, options?: any) => {
        const request = localVarFp.downloadProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * For a given id, if the project is published, fetch a particular version and stream the contents out with the right mime type to force the file to download 
      * @summary Download a published project at a particular version
      * @param {GetApiDownloadProjectVersionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadProjectVersion = (requestParameters: GetApiDownloadProjectVersionRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadProjectVersion(requestParameters, options);
        return request(axios, basePath);
    };

    downloadProjectVersion.getQueryKey = (requestParameters: GetApiDownloadProjectVersionRequest, options?: any) => {
        const request = localVarFp.downloadProjectVersion(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * For a given token try to download a project 
      * @summary Download a published project
      * @param {GetApiDownloadPublicProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadPublicProject = (requestParameters: GetApiDownloadPublicProjectRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadPublicProject(requestParameters, options);
        return request(axios, basePath);
    };

    downloadPublicProject.getQueryKey = (requestParameters: GetApiDownloadPublicProjectRequest, options?: any) => {
        const request = localVarFp.downloadPublicProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * For a given token try to download a project at a particular version 
      * @summary Download a specific version of a published project
      * @param {GetApiDownloadPublicProjectVersionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadPublicProjectVersion = (requestParameters: GetApiDownloadPublicProjectVersionRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadPublicProjectVersion(requestParameters, options);
        return request(axios, basePath);
    };

    downloadPublicProjectVersion.getQueryKey = (requestParameters: GetApiDownloadPublicProjectVersionRequest, options?: any) => {
        const request = localVarFp.downloadPublicProjectVersion(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetches company details from symmons api 
      * @summary Fetch company by bill_to
      * @param {GetApiFetchCompanyAddressesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const fetchCompanyAddresses = (requestParameters: GetApiFetchCompanyAddressesRequest, options?: any): AxiosPromise<FetchCompanyDetails> => {
        const request = localVarFp.fetchCompanyAddresses(requestParameters, options);
        return request(axios, basePath);
    };

    fetchCompanyAddresses.getQueryKey = (requestParameters: GetApiFetchCompanyAddressesRequest, options?: any) => {
        const request = localVarFp.fetchCompanyAddresses(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single agency by id 
      * @summary Get Agency
      * @param {GetApiGetAgencyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getAgency = (requestParameters: GetApiGetAgencyRequest, options?: any): AxiosPromise<Agency> => {
        const request = localVarFp.getAgency(requestParameters, options);
        return request(axios, basePath);
    };

    getAgency.getQueryKey = (requestParameters: GetApiGetAgencyRequest, options?: any) => {
        const request = localVarFp.getAgency(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single company by id 
      * @summary Get Company
      * @param {GetApiGetCompanyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getCompany = (requestParameters: GetApiGetCompanyRequest, options?: any): AxiosPromise<Company> => {
        const request = localVarFp.getCompany(requestParameters, options);
        return request(axios, basePath);
    };

    getCompany.getQueryKey = (requestParameters: GetApiGetCompanyRequest, options?: any) => {
        const request = localVarFp.getCompany(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Each user can only have one pending quote at a time.  The quote acts as a cart.  While the quote is pending, this method will return the current quote object.  When the quote is moved from status 1 (pending) to status 2 (sent) the quote will be sent, and this method will return an empty quote object, ready to start a new quote. 
      * @summary Get Current Quote
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getCurrentQuote = (requestParameters?: undefined, options?: any): AxiosPromise<PendingQuote> => {
        const request = localVarFp.getCurrentQuote(requestParameters, options);
        return request(axios, basePath);
    };

    getCurrentQuote.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.getCurrentQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a single file 
      * @summary Get File
      * @param {GetApiGetFileRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getFile = (requestParameters: GetApiGetFileRequest, options?: any): AxiosPromise<FileModel> => {
        const request = localVarFp.getFile(requestParameters, options);
        return request(axios, basePath);
    };

    getFile.getQueryKey = (requestParameters: GetApiGetFileRequest, options?: any) => {
        const request = localVarFp.getFile(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single introduction by id 
      * @summary Get Introduction
      * @param {GetApiGetIntroductionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getIntroduction = (requestParameters: GetApiGetIntroductionRequest, options?: any): AxiosPromise<Introduction> => {
        const request = localVarFp.getIntroduction(requestParameters, options);
        return request(axios, basePath);
    };

    getIntroduction.getQueryKey = (requestParameters: GetApiGetIntroductionRequest, options?: any) => {
        const request = localVarFp.getIntroduction(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single location by id 
      * @summary Get Location
      * @param {GetApiGetLocationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getLocation = (requestParameters: GetApiGetLocationRequest, options?: any): AxiosPromise<Location> => {
        const request = localVarFp.getLocation(requestParameters, options);
        return request(axios, basePath);
    };

    getLocation.getQueryKey = (requestParameters: GetApiGetLocationRequest, options?: any) => {
        const request = localVarFp.getLocation(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a single order 
      * @summary Get Order
      * @param {GetApiGetOrderRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getOrder = (requestParameters: GetApiGetOrderRequest, options?: any): AxiosPromise<Order> => {
        const request = localVarFp.getOrder(requestParameters, options);
        return request(axios, basePath);
    };

    getOrder.getQueryKey = (requestParameters: GetApiGetOrderRequest, options?: any) => {
        const request = localVarFp.getOrder(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single price sheet by id 
      * @summary Get PriceSheet
      * @param {GetApiGetPriceSheetRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getPriceSheet = (requestParameters: GetApiGetPriceSheetRequest, options?: any): AxiosPromise<PriceSheet> => {
        const request = localVarFp.getPriceSheet(requestParameters, options);
        return request(axios, basePath);
    };

    getPriceSheet.getQueryKey = (requestParameters: GetApiGetPriceSheetRequest, options?: any) => {
        const request = localVarFp.getPriceSheet(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch the pricing for a product for the current user 
      * @summary Get Pricing
      * @param {GetApiGetPricingRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getPricing = (requestParameters: GetApiGetPricingRequest, options?: any): AxiosPromise<GetPricingResponse> => {
        const request = localVarFp.getPricing(requestParameters, options);
        return request(axios, basePath);
    };

    getPricing.getQueryKey = (requestParameters: GetApiGetPricingRequest, options?: any) => {
        const request = localVarFp.getPricing(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single scorm by id 
      * @summary Get Scorm Progress for authenticated user
      * @param {GetApiGetProgressRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getProgress = (requestParameters: GetApiGetProgressRequest, options?: any): AxiosPromise<ScormScoTracking> => {
        const request = localVarFp.getProgress(requestParameters, options);
        return request(axios, basePath);
    };

    getProgress.getQueryKey = (requestParameters: GetApiGetProgressRequest, options?: any) => {
        const request = localVarFp.getProgress(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single project by id 
      * @summary Get Project
      * @param {GetApiGetProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getProject = (requestParameters: GetApiGetProjectRequest, options?: any): AxiosPromise<Project> => {
        const request = localVarFp.getProject(requestParameters, options);
        return request(axios, basePath);
    };

    getProject.getQueryKey = (requestParameters: GetApiGetProjectRequest, options?: any) => {
        const request = localVarFp.getProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a specific version of of a project. The version property will contain the full version object. 
      * @summary Get Specific project version
      * @param {GetApiGetProjectVersionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getProjectVersion = (requestParameters: GetApiGetProjectVersionRequest, options?: any): AxiosPromise<Project> => {
        const request = localVarFp.getProjectVersion(requestParameters, options);
        return request(axios, basePath);
    };

    getProjectVersion.getQueryKey = (requestParameters: GetApiGetProjectVersionRequest, options?: any) => {
        const request = localVarFp.getProjectVersion(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch the public version of a project by token 
      * @summary Get Public Project
      * @param {GetApiGetPublicProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getPublicProject = (requestParameters: GetApiGetPublicProjectRequest, options?: any): AxiosPromise<Project> => {
        const request = localVarFp.getPublicProject(requestParameters, options);
        return request(axios, basePath);
    };

    getPublicProject.getQueryKey = (requestParameters: GetApiGetPublicProjectRequest, options?: any) => {
        const request = localVarFp.getPublicProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single region by id with its associated territories 
      * @summary Get Region
      * @param {GetApiGetRegionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getRegion = (requestParameters: GetApiGetRegionRequest, options?: any): AxiosPromise<RegionResponse> => {
        const request = localVarFp.getRegion(requestParameters, options);
        return request(axios, basePath);
    };

    getRegion.getQueryKey = (requestParameters: GetApiGetRegionRequest, options?: any) => {
        const request = localVarFp.getRegion(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single report by id 
      * @summary Get Report
      * @param {GetApiGetReportRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getReport = (requestParameters: GetApiGetReportRequest, options?: any): AxiosPromise<Report> => {
        const request = localVarFp.getReport(requestParameters, options);
        return request(axios, basePath);
    };

    getReport.getQueryKey = (requestParameters: GetApiGetReportRequest, options?: any) => {
        const request = localVarFp.getReport(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single resource by id 
      * @summary Get Resource
      * @param {GetApiGetResourceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getResource = (requestParameters: GetApiGetResourceRequest, options?: any): AxiosPromise<Resource> => {
        const request = localVarFp.getResource(requestParameters, options);
        return request(axios, basePath);
    };

    getResource.getQueryKey = (requestParameters: GetApiGetResourceRequest, options?: any) => {
        const request = localVarFp.getResource(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single resource by id 
      * @summary Get Resource
      * @param {GetApiGetResourceCategoryRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getResourceCategory = (requestParameters: GetApiGetResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect> => {
        const request = localVarFp.getResourceCategory(requestParameters, options);
        return request(axios, basePath);
    };

    getResourceCategory.getQueryKey = (requestParameters: GetApiGetResourceCategoryRequest, options?: any) => {
        const request = localVarFp.getResourceCategory(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single salesforce customer by id 
      * @summary Get a single Salesforce Customer
      * @param {GetApiGetSalesforceCustomerRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getSalesforceCustomer = (requestParameters: GetApiGetSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer> => {
        const request = localVarFp.getSalesforceCustomer(requestParameters, options);
        return request(axios, basePath);
    };

    getSalesforceCustomer.getQueryKey = (requestParameters: GetApiGetSalesforceCustomerRequest, options?: any) => {
        const request = localVarFp.getSalesforceCustomer(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single salesforce opportunity by id 
      * @summary Get a single Salesforce opportunity
      * @param {GetApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getSalesforceOpportunity = (requestParameters: GetApiGetSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity> => {
        const request = localVarFp.getSalesforceOpportunity(requestParameters, options);
        return request(axios, basePath);
    };

    getSalesforceOpportunity.getQueryKey = (requestParameters: GetApiGetSalesforceOpportunityRequest, options?: any) => {
        const request = localVarFp.getSalesforceOpportunity(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single scorm by id 
      * @summary Get Scorm File
      * @param {GetApiGetScormRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getScorm = (requestParameters: GetApiGetScormRequest, options?: any): AxiosPromise<Scorm> => {
        const request = localVarFp.getScorm(requestParameters, options);
        return request(axios, basePath);
    };

    getScorm.getQueryKey = (requestParameters: GetApiGetScormRequest, options?: any) => {
        const request = localVarFp.getScorm(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Return requested shower configuration type record by id 
      * @summary Get shower configuration record
      * @param {GetApiGetShowerConfigurationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getShowerConfiguration = (requestParameters: GetApiGetShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfiguration> => {
        const request = localVarFp.getShowerConfiguration(requestParameters, options);
        return request(axios, basePath);
    };

    getShowerConfiguration.getQueryKey = (requestParameters: GetApiGetShowerConfigurationRequest, options?: any) => {
        const request = localVarFp.getShowerConfiguration(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get the current health status of the application, including pending jobs, api version, cache status, and validation failures 
      * @summary Health Status
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getStatus = (requestParameters?: undefined, options?: any): AxiosPromise<GetStatusResponse> => {
        const request = localVarFp.getStatus(requestParameters, options);
        return request(axios, basePath);
    };

    getStatus.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.getStatus(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Return the TempControl project identified by `key`. Requires either ownership (authenticated user) or a matching `Authorization-Key` header. 
      * @summary Get TempControl project
      * @param {GetApiGetTempControlProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getTempControlProject = (requestParameters: GetApiGetTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject> => {
        const request = localVarFp.getTempControlProject(requestParameters, options);
        return request(axios, basePath);
    };

    getTempControlProject.getQueryKey = (requestParameters: GetApiGetTempControlProjectRequest, options?: any) => {
        const request = localVarFp.getTempControlProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single territory by id with its associated region 
      * @summary Get Territory
      * @param {GetApiGetTerritoryRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getTerritory = (requestParameters: GetApiGetTerritoryRequest, options?: any): AxiosPromise<TerritoryResponse> => {
        const request = localVarFp.getTerritory(requestParameters, options);
        return request(axios, basePath);
    };

    getTerritory.getQueryKey = (requestParameters: GetApiGetTerritoryRequest, options?: any) => {
        const request = localVarFp.getTerritory(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single user by id 
      * @summary Get User
      * @param {GetApiGetUserRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getUser = (requestParameters: GetApiGetUserRequest, options?: any): AxiosPromise<User> => {
        const request = localVarFp.getUser(requestParameters, options);
        return request(axios, basePath);
    };

    getUser.getQueryKey = (requestParameters: GetApiGetUserRequest, options?: any) => {
        const request = localVarFp.getUser(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a list of the price sheet requests the current user has made 
      * @summary List Price Sheets
      * @param {GetApiListPriceSheetsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listPriceSheets = (requestParameters: GetApiListPriceSheetsRequest = {}, options?: any): AxiosPromise<PaginatedPriceSheets> => {
        const request = localVarFp.listPriceSheets(requestParameters, options);
        return request(axios, basePath);
    };

    listPriceSheets.getQueryKey = (requestParameters: GetApiListPriceSheetsRequest = {}, options?: any) => {
        const request = localVarFp.listPriceSheets(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Search the product database.  This endpoint won\'t be used for the frontend app, but will be designed to support eventual product consumers 
      * @summary Search products
      * @param {GetApiListProductsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listProducts = (requestParameters: GetApiListProductsRequest = {}, options?: any): AxiosPromise<PaginatedProducts> => {
        const request = localVarFp.listProducts(requestParameters, options);
        return request(axios, basePath);
    };

    listProducts.getQueryKey = (requestParameters: GetApiListProductsRequest = {}, options?: any) => {
        const request = localVarFp.listProducts(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a single quote 
      * @summary Get Quote
      * @param {GetApiListQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listQuote = (requestParameters: GetApiListQuoteRequest, options?: any): AxiosPromise<Quote> => {
        const request = localVarFp.listQuote(requestParameters, options);
        return request(axios, basePath);
    };

    listQuote.getQueryKey = (requestParameters: GetApiListQuoteRequest, options?: any) => {
        const request = localVarFp.listQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a list of reports 
      * @summary List Reports
      * @param {GetApiListReportsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listReports = (requestParameters: GetApiListReportsRequest = {}, options?: any): AxiosPromise<PaginatedReports> => {
        const request = localVarFp.listReports(requestParameters, options);
        return request(axios, basePath);
    };

    listReports.getQueryKey = (requestParameters: GetApiListReportsRequest = {}, options?: any) => {
        const request = localVarFp.listReports(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of scores for a scorm or a user 
      * @summary Get scores list
      * @param {GetApiListScormTrackingsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listScormTrackings = (requestParameters: GetApiListScormTrackingsRequest = {}, options?: any): AxiosPromise<PaginatedScormScoTracking> => {
        const request = localVarFp.listScormTrackings(requestParameters, options);
        return request(axios, basePath);
    };

    listScormTrackings.getQueryKey = (requestParameters: GetApiListScormTrackingsRequest = {}, options?: any) => {
        const request = localVarFp.listScormTrackings(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * If an order is stale, this will refresh the order from the upstream api 
      * @summary Refresh Order
      * @param {GetApiRefreshOrderRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const refreshOrder = (requestParameters: GetApiRefreshOrderRequest, options?: any): AxiosPromise<Order> => {
        const request = localVarFp.refreshOrder(requestParameters, options);
        return request(axios, basePath);
    };

    refreshOrder.getQueryKey = (requestParameters: GetApiRefreshOrderRequest, options?: any) => {
        const request = localVarFp.refreshOrder(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fire a background task to fetch all the salesforce data from the last two days 
      * @summary Refresh the salesforce data
      * @param {GetApiRefreshSalesforceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const refreshSalesforce = (requestParameters: GetApiRefreshSalesforceRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.refreshSalesforce(requestParameters, options);
        return request(axios, basePath);
    };

    refreshSalesforce.getQueryKey = (requestParameters: GetApiRefreshSalesforceRequest, options?: any) => {
        const request = localVarFp.refreshSalesforce(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Refresh a single salesforce customer in the db 
      * @summary Refresh a single salesforce customer in the db
      * @param {GetApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const syncSalesforceCustomer = (requestParameters: GetApiSyncSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer> => {
        const request = localVarFp.syncSalesforceCustomer(requestParameters, options);
        return request(axios, basePath);
    };

    syncSalesforceCustomer.getQueryKey = (requestParameters: GetApiSyncSalesforceCustomerRequest, options?: any) => {
        const request = localVarFp.syncSalesforceCustomer(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single salesforce customer while resyncing the customer from the db 
      * @summary Sync a single Salesforce opportunity
      * @param {GetApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const syncSalesforceOpportunity = (requestParameters: GetApiSyncSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity> => {
        const request = localVarFp.syncSalesforceOpportunity(requestParameters, options);
        return request(axios, basePath);
    };

    syncSalesforceOpportunity.getQueryKey = (requestParameters: GetApiSyncSalesforceOpportunityRequest, options?: any) => {
        const request = localVarFp.syncSalesforceOpportunity(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        autocomplete,
        downloadInvoice,
        downloadPackSlip,
        downloadProject,
        downloadProjectVersion,
        downloadPublicProject,
        downloadPublicProjectVersion,
        fetchCompanyAddresses,
        getAgency,
        getCompany,
        getCurrentQuote,
        getFile,
        getIntroduction,
        getLocation,
        getOrder,
        getPriceSheet,
        getPricing,
        getProgress,
        getProject,
        getProjectVersion,
        getPublicProject,
        getRegion,
        getReport,
        getResource,
        getResourceCategory,
        getSalesforceCustomer,
        getSalesforceOpportunity,
        getScorm,
        getShowerConfiguration,
        getStatus,
        getTempControlProject,
        getTerritory,
        getUser,
        listPriceSheets,
        listProducts,
        listQuote,
        listReports,
        listScormTrackings,
        refreshOrder,
        refreshSalesforce,
        syncSalesforceCustomer,
        syncSalesforceOpportunity,
    };
};

/**
 * GetApi - interface
 * @export
 * @interface GetApi
 */
export interface GetApiInterface {
    /**
     * Give a type of content to search on and a partial match, this will return common search terms that match 
     * @summary Autocomplete Search
     * @param {GetApiAutocompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    autocomplete(requestParameters: GetApiAutocompleteRequest, options?: any): AxiosPromise<Array<AutocompleteResult>>;

    /**
     * Download the current invoice, or package of packing slips 
     * @summary Download Invoice
     * @param {GetApiDownloadInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    downloadInvoice(requestParameters: GetApiDownloadInvoiceRequest, options?: any): AxiosPromise<any>;

    /**
     * Download the current packing slip, or package of packing slips 
     * @summary Download packing slip
     * @param {GetApiDownloadPackSlipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    downloadPackSlip(requestParameters: GetApiDownloadPackSlipRequest, options?: any): AxiosPromise<any>;

    /**
     * For a given id, if the project is published, stream the contents out with the right mime type to force the file to download 
     * @summary Download a published project
     * @param {GetApiDownloadProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    downloadProject(requestParameters: GetApiDownloadProjectRequest, options?: any): AxiosPromise<any>;

    /**
     * For a given id, if the project is published, fetch a particular version and stream the contents out with the right mime type to force the file to download 
     * @summary Download a published project at a particular version
     * @param {GetApiDownloadProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    downloadProjectVersion(requestParameters: GetApiDownloadProjectVersionRequest, options?: any): AxiosPromise<any>;

    /**
     * For a given token try to download a project 
     * @summary Download a published project
     * @param {GetApiDownloadPublicProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    downloadPublicProject(requestParameters: GetApiDownloadPublicProjectRequest, options?: any): AxiosPromise<any>;

    /**
     * For a given token try to download a project at a particular version 
     * @summary Download a specific version of a published project
     * @param {GetApiDownloadPublicProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    downloadPublicProjectVersion(requestParameters: GetApiDownloadPublicProjectVersionRequest, options?: any): AxiosPromise<any>;

    /**
     * Fetches company details from symmons api 
     * @summary Fetch company by bill_to
     * @param {GetApiFetchCompanyAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    fetchCompanyAddresses(requestParameters: GetApiFetchCompanyAddressesRequest, options?: any): AxiosPromise<FetchCompanyDetails>;

    /**
     * Fetch a single agency by id 
     * @summary Get Agency
     * @param {GetApiGetAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getAgency(requestParameters: GetApiGetAgencyRequest, options?: any): AxiosPromise<Agency>;

    /**
     * Fetch a single company by id 
     * @summary Get Company
     * @param {GetApiGetCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getCompany(requestParameters: GetApiGetCompanyRequest, options?: any): AxiosPromise<Company>;

    /**
     * Each user can only have one pending quote at a time.  The quote acts as a cart.  While the quote is pending, this method will return the current quote object.  When the quote is moved from status 1 (pending) to status 2 (sent) the quote will be sent, and this method will return an empty quote object, ready to start a new quote. 
     * @summary Get Current Quote
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getCurrentQuote(requestParameters?: undefined, options?: any): AxiosPromise<PendingQuote>;

    /**
     * Get a single file 
     * @summary Get File
     * @param {GetApiGetFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getFile(requestParameters: GetApiGetFileRequest, options?: any): AxiosPromise<FileModel>;

    /**
     * Fetch a single introduction by id 
     * @summary Get Introduction
     * @param {GetApiGetIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getIntroduction(requestParameters: GetApiGetIntroductionRequest, options?: any): AxiosPromise<Introduction>;

    /**
     * Fetch a single location by id 
     * @summary Get Location
     * @param {GetApiGetLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getLocation(requestParameters: GetApiGetLocationRequest, options?: any): AxiosPromise<Location>;

    /**
     * Get a single order 
     * @summary Get Order
     * @param {GetApiGetOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getOrder(requestParameters: GetApiGetOrderRequest, options?: any): AxiosPromise<Order>;

    /**
     * Fetch a single price sheet by id 
     * @summary Get PriceSheet
     * @param {GetApiGetPriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getPriceSheet(requestParameters: GetApiGetPriceSheetRequest, options?: any): AxiosPromise<PriceSheet>;

    /**
     * Fetch the pricing for a product for the current user 
     * @summary Get Pricing
     * @param {GetApiGetPricingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getPricing(requestParameters: GetApiGetPricingRequest, options?: any): AxiosPromise<GetPricingResponse>;

    /**
     * Fetch a single scorm by id 
     * @summary Get Scorm Progress for authenticated user
     * @param {GetApiGetProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getProgress(requestParameters: GetApiGetProgressRequest, options?: any): AxiosPromise<ScormScoTracking>;

    /**
     * Fetch a single project by id 
     * @summary Get Project
     * @param {GetApiGetProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getProject(requestParameters: GetApiGetProjectRequest, options?: any): AxiosPromise<Project>;

    /**
     * Fetch a specific version of of a project. The version property will contain the full version object. 
     * @summary Get Specific project version
     * @param {GetApiGetProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getProjectVersion(requestParameters: GetApiGetProjectVersionRequest, options?: any): AxiosPromise<Project>;

    /**
     * Fetch the public version of a project by token 
     * @summary Get Public Project
     * @param {GetApiGetPublicProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getPublicProject(requestParameters: GetApiGetPublicProjectRequest, options?: any): AxiosPromise<Project>;

    /**
     * Fetch a single region by id with its associated territories 
     * @summary Get Region
     * @param {GetApiGetRegionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getRegion(requestParameters: GetApiGetRegionRequest, options?: any): AxiosPromise<RegionResponse>;

    /**
     * Fetch a single report by id 
     * @summary Get Report
     * @param {GetApiGetReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getReport(requestParameters: GetApiGetReportRequest, options?: any): AxiosPromise<Report>;

    /**
     * Fetch a single resource by id 
     * @summary Get Resource
     * @param {GetApiGetResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getResource(requestParameters: GetApiGetResourceRequest, options?: any): AxiosPromise<Resource>;

    /**
     * Fetch a single resource by id 
     * @summary Get Resource
     * @param {GetApiGetResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getResourceCategory(requestParameters: GetApiGetResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect>;

    /**
     * Fetch a single salesforce customer by id 
     * @summary Get a single Salesforce Customer
     * @param {GetApiGetSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getSalesforceCustomer(requestParameters: GetApiGetSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer>;

    /**
     * Fetch a single salesforce opportunity by id 
     * @summary Get a single Salesforce opportunity
     * @param {GetApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getSalesforceOpportunity(requestParameters: GetApiGetSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity>;

    /**
     * Fetch a single scorm by id 
     * @summary Get Scorm File
     * @param {GetApiGetScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getScorm(requestParameters: GetApiGetScormRequest, options?: any): AxiosPromise<Scorm>;

    /**
     * Return requested shower configuration type record by id 
     * @summary Get shower configuration record
     * @param {GetApiGetShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getShowerConfiguration(requestParameters: GetApiGetShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfiguration>;

    /**
     * Get the current health status of the application, including pending jobs, api version, cache status, and validation failures 
     * @summary Health Status
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getStatus(requestParameters?: undefined, options?: any): AxiosPromise<GetStatusResponse>;

    /**
     * Return the TempControl project identified by `key`. Requires either ownership (authenticated user) or a matching `Authorization-Key` header. 
     * @summary Get TempControl project
     * @param {GetApiGetTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getTempControlProject(requestParameters: GetApiGetTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject>;

    /**
     * Fetch a single territory by id with its associated region 
     * @summary Get Territory
     * @param {GetApiGetTerritoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getTerritory(requestParameters: GetApiGetTerritoryRequest, options?: any): AxiosPromise<TerritoryResponse>;

    /**
     * Fetch a single user by id 
     * @summary Get User
     * @param {GetApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    getUser(requestParameters: GetApiGetUserRequest, options?: any): AxiosPromise<User>;

    /**
     * Get a list of the price sheet requests the current user has made 
     * @summary List Price Sheets
     * @param {GetApiListPriceSheetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    listPriceSheets(requestParameters?: GetApiListPriceSheetsRequest, options?: any): AxiosPromise<PaginatedPriceSheets>;

    /**
     * Search the product database.  This endpoint won\'t be used for the frontend app, but will be designed to support eventual product consumers 
     * @summary Search products
     * @param {GetApiListProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    listProducts(requestParameters?: GetApiListProductsRequest, options?: any): AxiosPromise<PaginatedProducts>;

    /**
     * Get a single quote 
     * @summary Get Quote
     * @param {GetApiListQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    listQuote(requestParameters: GetApiListQuoteRequest, options?: any): AxiosPromise<Quote>;

    /**
     * Get a list of reports 
     * @summary List Reports
     * @param {GetApiListReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    listReports(requestParameters?: GetApiListReportsRequest, options?: any): AxiosPromise<PaginatedReports>;

    /**
     * Fetch a list of scores for a scorm or a user 
     * @summary Get scores list
     * @param {GetApiListScormTrackingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    listScormTrackings(requestParameters?: GetApiListScormTrackingsRequest, options?: any): AxiosPromise<PaginatedScormScoTracking>;

    /**
     * If an order is stale, this will refresh the order from the upstream api 
     * @summary Refresh Order
     * @param {GetApiRefreshOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    refreshOrder(requestParameters: GetApiRefreshOrderRequest, options?: any): AxiosPromise<Order>;

    /**
     * Fire a background task to fetch all the salesforce data from the last two days 
     * @summary Refresh the salesforce data
     * @param {GetApiRefreshSalesforceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    refreshSalesforce(requestParameters: GetApiRefreshSalesforceRequest, options?: any): AxiosPromise<void>;

    /**
     * Refresh a single salesforce customer in the db 
     * @summary Refresh a single salesforce customer in the db
     * @param {GetApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    syncSalesforceCustomer(requestParameters: GetApiSyncSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer>;

    /**
     * Fetch a single salesforce customer while resyncing the customer from the db 
     * @summary Sync a single Salesforce opportunity
     * @param {GetApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApiInterface
     */
    syncSalesforceOpportunity(requestParameters: GetApiSyncSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity>;

}

/**
 * Request parameters for autocomplete operation in GetApi.
 * @export
 * @interface GetApiAutocompleteRequest
 */
export interface GetApiAutocompleteRequest {
    /**
     * The entity type that we want to autocomplete on
     * @type {string}
     * @memberof GetApiAutocomplete
     */
    readonly type: string

    /**
     * A short string to do a partial match on
     * @type {string}
     * @memberof GetApiAutocomplete
     */
    readonly query: string
}

/**
 * Request parameters for downloadInvoice operation in GetApi.
 * @export
 * @interface GetApiDownloadInvoiceRequest
 */
export interface GetApiDownloadInvoiceRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof GetApiDownloadInvoice
     */
    readonly id: number
}

/**
 * Request parameters for downloadPackSlip operation in GetApi.
 * @export
 * @interface GetApiDownloadPackSlipRequest
 */
export interface GetApiDownloadPackSlipRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof GetApiDownloadPackSlip
     */
    readonly id: number
}

/**
 * Request parameters for downloadProject operation in GetApi.
 * @export
 * @interface GetApiDownloadProjectRequest
 */
export interface GetApiDownloadProjectRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof GetApiDownloadProject
     */
    readonly id: number
}

/**
 * Request parameters for downloadProjectVersion operation in GetApi.
 * @export
 * @interface GetApiDownloadProjectVersionRequest
 */
export interface GetApiDownloadProjectVersionRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof GetApiDownloadProjectVersion
     */
    readonly id: number

    /**
     * The version_id of the version in the project you want
     * @type {number}
     * @memberof GetApiDownloadProjectVersion
     */
    readonly versionId: number
}

/**
 * Request parameters for downloadPublicProject operation in GetApi.
 * @export
 * @interface GetApiDownloadPublicProjectRequest
 */
export interface GetApiDownloadPublicProjectRequest {
    /**
     * The public_token of the project
     * @type {string}
     * @memberof GetApiDownloadPublicProject
     */
    readonly publicToken: string
}

/**
 * Request parameters for downloadPublicProjectVersion operation in GetApi.
 * @export
 * @interface GetApiDownloadPublicProjectVersionRequest
 */
export interface GetApiDownloadPublicProjectVersionRequest {
    /**
     * The public_token of the project
     * @type {string}
     * @memberof GetApiDownloadPublicProjectVersion
     */
    readonly publicToken: string

    /**
     * The version_id of the version of the project
     * @type {string}
     * @memberof GetApiDownloadPublicProjectVersion
     */
    readonly versionId: string
}

/**
 * Request parameters for fetchCompanyAddresses operation in GetApi.
 * @export
 * @interface GetApiFetchCompanyAddressesRequest
 */
export interface GetApiFetchCompanyAddressesRequest {
    /**
     * The id of the company
     * @type {string}
     * @memberof GetApiFetchCompanyAddresses
     */
    readonly billTo: string
}

/**
 * Request parameters for getAgency operation in GetApi.
 * @export
 * @interface GetApiGetAgencyRequest
 */
export interface GetApiGetAgencyRequest {
    /**
     * The id of the agency
     * @type {number}
     * @memberof GetApiGetAgency
     */
    readonly id: number
}

/**
 * Request parameters for getCompany operation in GetApi.
 * @export
 * @interface GetApiGetCompanyRequest
 */
export interface GetApiGetCompanyRequest {
    /**
     * The id of the company
     * @type {number}
     * @memberof GetApiGetCompany
     */
    readonly id: number
}

/**
 * Request parameters for getFile operation in GetApi.
 * @export
 * @interface GetApiGetFileRequest
 */
export interface GetApiGetFileRequest {
    /**
     * The id of the file
     * @type {number}
     * @memberof GetApiGetFile
     */
    readonly id: number
}

/**
 * Request parameters for getIntroduction operation in GetApi.
 * @export
 * @interface GetApiGetIntroductionRequest
 */
export interface GetApiGetIntroductionRequest {
    /**
     * The id of the introduction
     * @type {number}
     * @memberof GetApiGetIntroduction
     */
    readonly id: number
}

/**
 * Request parameters for getLocation operation in GetApi.
 * @export
 * @interface GetApiGetLocationRequest
 */
export interface GetApiGetLocationRequest {
    /**
     * The id of the location
     * @type {number}
     * @memberof GetApiGetLocation
     */
    readonly locationId: number
}

/**
 * Request parameters for getOrder operation in GetApi.
 * @export
 * @interface GetApiGetOrderRequest
 */
export interface GetApiGetOrderRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof GetApiGetOrder
     */
    readonly id: number
}

/**
 * Request parameters for getPriceSheet operation in GetApi.
 * @export
 * @interface GetApiGetPriceSheetRequest
 */
export interface GetApiGetPriceSheetRequest {
    /**
     * The id of the price sheet
     * @type {number}
     * @memberof GetApiGetPriceSheet
     */
    readonly pricesheetId: number
}

/**
 * Request parameters for getPricing operation in GetApi.
 * @export
 * @interface GetApiGetPricingRequest
 */
export interface GetApiGetPricingRequest {
    /**
     * The product model number
     * @type {string}
     * @memberof GetApiGetPricing
     */
    readonly modelNumber: string
}

/**
 * Request parameters for getProgress operation in GetApi.
 * @export
 * @interface GetApiGetProgressRequest
 */
export interface GetApiGetProgressRequest {
    /**
     * The id of the scorm
     * @type {number}
     * @memberof GetApiGetProgress
     */
    readonly id: number
}

/**
 * Request parameters for getProject operation in GetApi.
 * @export
 * @interface GetApiGetProjectRequest
 */
export interface GetApiGetProjectRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof GetApiGetProject
     */
    readonly id: number
}

/**
 * Request parameters for getProjectVersion operation in GetApi.
 * @export
 * @interface GetApiGetProjectVersionRequest
 */
export interface GetApiGetProjectVersionRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof GetApiGetProjectVersion
     */
    readonly project: number

    /**
     * The id of the version
     * @type {number}
     * @memberof GetApiGetProjectVersion
     */
    readonly version: number
}

/**
 * Request parameters for getPublicProject operation in GetApi.
 * @export
 * @interface GetApiGetPublicProjectRequest
 */
export interface GetApiGetPublicProjectRequest {
    /**
     * The token of the project
     * @type {string}
     * @memberof GetApiGetPublicProject
     */
    readonly token: string
}

/**
 * Request parameters for getRegion operation in GetApi.
 * @export
 * @interface GetApiGetRegionRequest
 */
export interface GetApiGetRegionRequest {
    /**
     * The id of the region
     * @type {number}
     * @memberof GetApiGetRegion
     */
    readonly id: number
}

/**
 * Request parameters for getReport operation in GetApi.
 * @export
 * @interface GetApiGetReportRequest
 */
export interface GetApiGetReportRequest {
    /**
     * The id of the report
     * @type {number}
     * @memberof GetApiGetReport
     */
    readonly reportId: number
}

/**
 * Request parameters for getResource operation in GetApi.
 * @export
 * @interface GetApiGetResourceRequest
 */
export interface GetApiGetResourceRequest {
    /**
     * The id of the resource
     * @type {number}
     * @memberof GetApiGetResource
     */
    readonly id: number
}

/**
 * Request parameters for getResourceCategory operation in GetApi.
 * @export
 * @interface GetApiGetResourceCategoryRequest
 */
export interface GetApiGetResourceCategoryRequest {
    /**
     * The id of the category
     * @type {number}
     * @memberof GetApiGetResourceCategory
     */
    readonly id: number
}

/**
 * Request parameters for getSalesforceCustomer operation in GetApi.
 * @export
 * @interface GetApiGetSalesforceCustomerRequest
 */
export interface GetApiGetSalesforceCustomerRequest {
    /**
     * The id of the customer
     * @type {number}
     * @memberof GetApiGetSalesforceCustomer
     */
    readonly id: number
}

/**
 * Request parameters for getSalesforceOpportunity operation in GetApi.
 * @export
 * @interface GetApiGetSalesforceOpportunityRequest
 */
export interface GetApiGetSalesforceOpportunityRequest {
    /**
     * The id of the customer
     * @type {number}
     * @memberof GetApiGetSalesforceOpportunity
     */
    readonly id: number
}

/**
 * Request parameters for getScorm operation in GetApi.
 * @export
 * @interface GetApiGetScormRequest
 */
export interface GetApiGetScormRequest {
    /**
     * The id of the scorm
     * @type {number}
     * @memberof GetApiGetScorm
     */
    readonly id: number
}

/**
 * Request parameters for getShowerConfiguration operation in GetApi.
 * @export
 * @interface GetApiGetShowerConfigurationRequest
 */
export interface GetApiGetShowerConfigurationRequest {
    /**
     * The key of the shower configuration
     * @type {string}
     * @memberof GetApiGetShowerConfiguration
     */
    readonly configurationKey: string
}

/**
 * Request parameters for getTempControlProject operation in GetApi.
 * @export
 * @interface GetApiGetTempControlProjectRequest
 */
export interface GetApiGetTempControlProjectRequest {
    /**
     * TempControl project key
     * @type {string}
     * @memberof GetApiGetTempControlProject
     */
    readonly key: string

    /**
     * Hashed md5 string used to authenticate guest access
     * @type {string}
     * @memberof GetApiGetTempControlProject
     */
    readonly authorizationKey?: string
}

/**
 * Request parameters for getTerritory operation in GetApi.
 * @export
 * @interface GetApiGetTerritoryRequest
 */
export interface GetApiGetTerritoryRequest {
    /**
     * The id of the territory
     * @type {number}
     * @memberof GetApiGetTerritory
     */
    readonly id: number
}

/**
 * Request parameters for getUser operation in GetApi.
 * @export
 * @interface GetApiGetUserRequest
 */
export interface GetApiGetUserRequest {
    /**
     * The id of the user
     * @type {number}
     * @memberof GetApiGetUser
     */
    readonly userId: number
}

/**
 * Request parameters for listPriceSheets operation in GetApi.
 * @export
 * @interface GetApiListPriceSheetsRequest
 */
export interface GetApiListPriceSheetsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof GetApiListPriceSheets
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof GetApiListPriceSheets
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof GetApiListPriceSheets
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof GetApiListPriceSheets
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * 
     * @type {string}
     * @memberof GetApiListPriceSheets
     */
    readonly user?: string

    /**
     * 
     * @type {PriceSheetStatus}
     * @memberof GetApiListPriceSheets
     */
    readonly status?: PriceSheetStatus
}

/**
 * Request parameters for listProducts operation in GetApi.
 * @export
 * @interface GetApiListProductsRequest
 */
export interface GetApiListProductsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof GetApiListProducts
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof GetApiListProducts
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof GetApiListProducts
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof GetApiListProducts
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of products records the current user has access to.
     * @type {string}
     * @memberof GetApiListProducts
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof GetApiListProducts
     */
    readonly title?: string

    /**
     * 
     * @type {string}
     * @memberof GetApiListProducts
     */
    readonly sku?: string

    /**
     * 
     * @type {string}
     * @memberof GetApiListProducts
     */
    readonly status?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof GetApiListProducts
     */
    readonly categories?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof GetApiListProducts
     */
    readonly tiers?: Array<string>
}

/**
 * Request parameters for listQuote operation in GetApi.
 * @export
 * @interface GetApiListQuoteRequest
 */
export interface GetApiListQuoteRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof GetApiListQuote
     */
    readonly id: number
}

/**
 * Request parameters for listReports operation in GetApi.
 * @export
 * @interface GetApiListReportsRequest
 */
export interface GetApiListReportsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof GetApiListReports
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof GetApiListReports
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof GetApiListReports
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof GetApiListReports
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * 
     * @type {string}
     * @memberof GetApiListReports
     */
    readonly user?: string

    /**
     * 
     * @type {ReportType}
     * @memberof GetApiListReports
     */
    readonly type?: ReportType

    /**
     * 
     * @type {ReportStatus}
     * @memberof GetApiListReports
     */
    readonly status?: ReportStatus
}

/**
 * Request parameters for listScormTrackings operation in GetApi.
 * @export
 * @interface GetApiListScormTrackingsRequest
 */
export interface GetApiListScormTrackingsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof GetApiListScormTrackings
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof GetApiListScormTrackings
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof GetApiListScormTrackings
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof GetApiListScormTrackings
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof GetApiListScormTrackings
     */
    readonly search?: string

    /**
     * Filters scorm list by passed/incomplete state
     * @type {string}
     * @memberof GetApiListScormTrackings
     */
    readonly state?: string

    /**
     * The id of the scorm
     * @type {number}
     * @memberof GetApiListScormTrackings
     */
    readonly scormId?: number

    /**
     * The id of the user
     * @type {number}
     * @memberof GetApiListScormTrackings
     */
    readonly userId?: number
}

/**
 * Request parameters for refreshOrder operation in GetApi.
 * @export
 * @interface GetApiRefreshOrderRequest
 */
export interface GetApiRefreshOrderRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof GetApiRefreshOrder
     */
    readonly id: number
}

/**
 * Request parameters for refreshSalesforce operation in GetApi.
 * @export
 * @interface GetApiRefreshSalesforceRequest
 */
export interface GetApiRefreshSalesforceRequest {
    /**
     * The salesforce id of the customer
     * @type {string}
     * @memberof GetApiRefreshSalesforce
     */
    readonly id: string
}

/**
 * Request parameters for syncSalesforceCustomer operation in GetApi.
 * @export
 * @interface GetApiSyncSalesforceCustomerRequest
 */
export interface GetApiSyncSalesforceCustomerRequest {
    /**
     * The salesforce id of the customer
     * @type {string}
     * @memberof GetApiSyncSalesforceCustomer
     */
    readonly id: string
}

/**
 * Request parameters for syncSalesforceOpportunity operation in GetApi.
 * @export
 * @interface GetApiSyncSalesforceOpportunityRequest
 */
export interface GetApiSyncSalesforceOpportunityRequest {
    /**
     * The salesforce id of the customer
     * @type {string}
     * @memberof GetApiSyncSalesforceOpportunity
     */
    readonly id: string
}

/**
 * GetApi - object-oriented interface
 * @export
 * @class GetApi
 * @extends {BaseAPI}
 */
export class GetApi extends BaseAPI implements GetApiInterface {
    /**
     * Give a type of content to search on and a partial match, this will return common search terms that match 
     * @summary Autocomplete Search
     * @param {GetApiAutocompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public autocomplete(requestParameters: GetApiAutocompleteRequest, options?: any) {
        const request = GetApiFp(this.configuration).autocomplete(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Download the current invoice, or package of packing slips 
     * @summary Download Invoice
     * @param {GetApiDownloadInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public downloadInvoice(requestParameters: GetApiDownloadInvoiceRequest, options?: any) {
        const request = GetApiFp(this.configuration).downloadInvoice(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Download the current packing slip, or package of packing slips 
     * @summary Download packing slip
     * @param {GetApiDownloadPackSlipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public downloadPackSlip(requestParameters: GetApiDownloadPackSlipRequest, options?: any) {
        const request = GetApiFp(this.configuration).downloadPackSlip(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * For a given id, if the project is published, stream the contents out with the right mime type to force the file to download 
     * @summary Download a published project
     * @param {GetApiDownloadProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public downloadProject(requestParameters: GetApiDownloadProjectRequest, options?: any) {
        const request = GetApiFp(this.configuration).downloadProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * For a given id, if the project is published, fetch a particular version and stream the contents out with the right mime type to force the file to download 
     * @summary Download a published project at a particular version
     * @param {GetApiDownloadProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public downloadProjectVersion(requestParameters: GetApiDownloadProjectVersionRequest, options?: any) {
        const request = GetApiFp(this.configuration).downloadProjectVersion(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * For a given token try to download a project 
     * @summary Download a published project
     * @param {GetApiDownloadPublicProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public downloadPublicProject(requestParameters: GetApiDownloadPublicProjectRequest, options?: any) {
        const request = GetApiFp(this.configuration).downloadPublicProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * For a given token try to download a project at a particular version 
     * @summary Download a specific version of a published project
     * @param {GetApiDownloadPublicProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public downloadPublicProjectVersion(requestParameters: GetApiDownloadPublicProjectVersionRequest, options?: any) {
        const request = GetApiFp(this.configuration).downloadPublicProjectVersion(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetches company details from symmons api 
     * @summary Fetch company by bill_to
     * @param {GetApiFetchCompanyAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public fetchCompanyAddresses(requestParameters: GetApiFetchCompanyAddressesRequest, options?: any) {
        const request = GetApiFp(this.configuration).fetchCompanyAddresses(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single agency by id 
     * @summary Get Agency
     * @param {GetApiGetAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getAgency(requestParameters: GetApiGetAgencyRequest, options?: any) {
        const request = GetApiFp(this.configuration).getAgency(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single company by id 
     * @summary Get Company
     * @param {GetApiGetCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getCompany(requestParameters: GetApiGetCompanyRequest, options?: any) {
        const request = GetApiFp(this.configuration).getCompany(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Each user can only have one pending quote at a time.  The quote acts as a cart.  While the quote is pending, this method will return the current quote object.  When the quote is moved from status 1 (pending) to status 2 (sent) the quote will be sent, and this method will return an empty quote object, ready to start a new quote. 
     * @summary Get Current Quote
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getCurrentQuote(requestParameters?: undefined, options?: any) {
        const request = GetApiFp(this.configuration).getCurrentQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a single file 
     * @summary Get File
     * @param {GetApiGetFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getFile(requestParameters: GetApiGetFileRequest, options?: any) {
        const request = GetApiFp(this.configuration).getFile(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single introduction by id 
     * @summary Get Introduction
     * @param {GetApiGetIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getIntroduction(requestParameters: GetApiGetIntroductionRequest, options?: any) {
        const request = GetApiFp(this.configuration).getIntroduction(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single location by id 
     * @summary Get Location
     * @param {GetApiGetLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getLocation(requestParameters: GetApiGetLocationRequest, options?: any) {
        const request = GetApiFp(this.configuration).getLocation(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a single order 
     * @summary Get Order
     * @param {GetApiGetOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getOrder(requestParameters: GetApiGetOrderRequest, options?: any) {
        const request = GetApiFp(this.configuration).getOrder(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single price sheet by id 
     * @summary Get PriceSheet
     * @param {GetApiGetPriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getPriceSheet(requestParameters: GetApiGetPriceSheetRequest, options?: any) {
        const request = GetApiFp(this.configuration).getPriceSheet(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch the pricing for a product for the current user 
     * @summary Get Pricing
     * @param {GetApiGetPricingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getPricing(requestParameters: GetApiGetPricingRequest, options?: any) {
        const request = GetApiFp(this.configuration).getPricing(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single scorm by id 
     * @summary Get Scorm Progress for authenticated user
     * @param {GetApiGetProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getProgress(requestParameters: GetApiGetProgressRequest, options?: any) {
        const request = GetApiFp(this.configuration).getProgress(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single project by id 
     * @summary Get Project
     * @param {GetApiGetProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getProject(requestParameters: GetApiGetProjectRequest, options?: any) {
        const request = GetApiFp(this.configuration).getProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a specific version of of a project. The version property will contain the full version object. 
     * @summary Get Specific project version
     * @param {GetApiGetProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getProjectVersion(requestParameters: GetApiGetProjectVersionRequest, options?: any) {
        const request = GetApiFp(this.configuration).getProjectVersion(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch the public version of a project by token 
     * @summary Get Public Project
     * @param {GetApiGetPublicProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getPublicProject(requestParameters: GetApiGetPublicProjectRequest, options?: any) {
        const request = GetApiFp(this.configuration).getPublicProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single region by id with its associated territories 
     * @summary Get Region
     * @param {GetApiGetRegionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getRegion(requestParameters: GetApiGetRegionRequest, options?: any) {
        const request = GetApiFp(this.configuration).getRegion(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single report by id 
     * @summary Get Report
     * @param {GetApiGetReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getReport(requestParameters: GetApiGetReportRequest, options?: any) {
        const request = GetApiFp(this.configuration).getReport(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single resource by id 
     * @summary Get Resource
     * @param {GetApiGetResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getResource(requestParameters: GetApiGetResourceRequest, options?: any) {
        const request = GetApiFp(this.configuration).getResource(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single resource by id 
     * @summary Get Resource
     * @param {GetApiGetResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getResourceCategory(requestParameters: GetApiGetResourceCategoryRequest, options?: any) {
        const request = GetApiFp(this.configuration).getResourceCategory(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single salesforce customer by id 
     * @summary Get a single Salesforce Customer
     * @param {GetApiGetSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getSalesforceCustomer(requestParameters: GetApiGetSalesforceCustomerRequest, options?: any) {
        const request = GetApiFp(this.configuration).getSalesforceCustomer(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single salesforce opportunity by id 
     * @summary Get a single Salesforce opportunity
     * @param {GetApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getSalesforceOpportunity(requestParameters: GetApiGetSalesforceOpportunityRequest, options?: any) {
        const request = GetApiFp(this.configuration).getSalesforceOpportunity(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single scorm by id 
     * @summary Get Scorm File
     * @param {GetApiGetScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getScorm(requestParameters: GetApiGetScormRequest, options?: any) {
        const request = GetApiFp(this.configuration).getScorm(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Return requested shower configuration type record by id 
     * @summary Get shower configuration record
     * @param {GetApiGetShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getShowerConfiguration(requestParameters: GetApiGetShowerConfigurationRequest, options?: any) {
        const request = GetApiFp(this.configuration).getShowerConfiguration(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get the current health status of the application, including pending jobs, api version, cache status, and validation failures 
     * @summary Health Status
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getStatus(requestParameters?: undefined, options?: any) {
        const request = GetApiFp(this.configuration).getStatus(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Return the TempControl project identified by `key`. Requires either ownership (authenticated user) or a matching `Authorization-Key` header. 
     * @summary Get TempControl project
     * @param {GetApiGetTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getTempControlProject(requestParameters: GetApiGetTempControlProjectRequest, options?: any) {
        const request = GetApiFp(this.configuration).getTempControlProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single territory by id with its associated region 
     * @summary Get Territory
     * @param {GetApiGetTerritoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getTerritory(requestParameters: GetApiGetTerritoryRequest, options?: any) {
        const request = GetApiFp(this.configuration).getTerritory(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single user by id 
     * @summary Get User
     * @param {GetApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public getUser(requestParameters: GetApiGetUserRequest, options?: any) {
        const request = GetApiFp(this.configuration).getUser(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a list of the price sheet requests the current user has made 
     * @summary List Price Sheets
     * @param {GetApiListPriceSheetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public listPriceSheets(requestParameters: GetApiListPriceSheetsRequest = {}, options?: any) {
        const request = GetApiFp(this.configuration).listPriceSheets(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Search the product database.  This endpoint won\'t be used for the frontend app, but will be designed to support eventual product consumers 
     * @summary Search products
     * @param {GetApiListProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public listProducts(requestParameters: GetApiListProductsRequest = {}, options?: any) {
        const request = GetApiFp(this.configuration).listProducts(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a single quote 
     * @summary Get Quote
     * @param {GetApiListQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public listQuote(requestParameters: GetApiListQuoteRequest, options?: any) {
        const request = GetApiFp(this.configuration).listQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a list of reports 
     * @summary List Reports
     * @param {GetApiListReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public listReports(requestParameters: GetApiListReportsRequest = {}, options?: any) {
        const request = GetApiFp(this.configuration).listReports(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of scores for a scorm or a user 
     * @summary Get scores list
     * @param {GetApiListScormTrackingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public listScormTrackings(requestParameters: GetApiListScormTrackingsRequest = {}, options?: any) {
        const request = GetApiFp(this.configuration).listScormTrackings(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * If an order is stale, this will refresh the order from the upstream api 
     * @summary Refresh Order
     * @param {GetApiRefreshOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public refreshOrder(requestParameters: GetApiRefreshOrderRequest, options?: any) {
        const request = GetApiFp(this.configuration).refreshOrder(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fire a background task to fetch all the salesforce data from the last two days 
     * @summary Refresh the salesforce data
     * @param {GetApiRefreshSalesforceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public refreshSalesforce(requestParameters: GetApiRefreshSalesforceRequest, options?: any) {
        const request = GetApiFp(this.configuration).refreshSalesforce(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Refresh a single salesforce customer in the db 
     * @summary Refresh a single salesforce customer in the db
     * @param {GetApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public syncSalesforceCustomer(requestParameters: GetApiSyncSalesforceCustomerRequest, options?: any) {
        const request = GetApiFp(this.configuration).syncSalesforceCustomer(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single salesforce customer while resyncing the customer from the db 
     * @summary Sync a single Salesforce opportunity
     * @param {GetApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApi
     */
    public syncSalesforceOpportunity(requestParameters: GetApiSyncSalesforceOpportunityRequest, options?: any) {
        const request = GetApiFp(this.configuration).syncSalesforceOpportunity(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ImpersonateApi - axios parameter creator
 * @export
 */
export const ImpersonateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Impersonate a user 
         * @summary Impersonate a user
         * @param {number} userId The id of the user to impersonate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonate: (userId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('impersonate', 'userId', userId)
            const localVarPath = `/auth/impersonate/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stop impersonating a user 
         * @summary Stop impersonating a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopImpersonate: (options: any = {}): RequestArgs => {
            const localVarPath = `/auth/stop-impersonate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImpersonateApi - functional programming interface
 * @export
 */
export const ImpersonateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImpersonateApiAxiosParamCreator(configuration)
    return {
        /**
         * Impersonate a user 
         * @summary Impersonate a user
         * @param {ImpersonateApiImpersonateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonate(requestParameters: ImpersonateApiImpersonateRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<StartImpersonatingResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.impersonate(requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Stop impersonating a user 
         * @summary Stop impersonating a user
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopImpersonate(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegisteredUser>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.stopImpersonate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImpersonateApi - factory interface
 * @export
 */
export const ImpersonateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImpersonateApiFp(configuration)

    /**
      * Impersonate a user 
      * @summary Impersonate a user
      * @param {ImpersonateApiImpersonateRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const impersonate = (requestParameters: ImpersonateApiImpersonateRequest, options?: any): AxiosPromise<StartImpersonatingResponse> => {
        const request = localVarFp.impersonate(requestParameters, options);
        return request(axios, basePath);
    };

    impersonate.getQueryKey = (requestParameters: ImpersonateApiImpersonateRequest, options?: any) => {
        const request = localVarFp.impersonate(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Stop impersonating a user 
      * @summary Stop impersonating a user
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const stopImpersonate = (requestParameters?: undefined, options?: any): AxiosPromise<RegisteredUser> => {
        const request = localVarFp.stopImpersonate(requestParameters, options);
        return request(axios, basePath);
    };

    stopImpersonate.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.stopImpersonate(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        impersonate,
        stopImpersonate,
    };
};

/**
 * ImpersonateApi - interface
 * @export
 * @interface ImpersonateApi
 */
export interface ImpersonateApiInterface {
    /**
     * Impersonate a user 
     * @summary Impersonate a user
     * @param {ImpersonateApiImpersonateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpersonateApiInterface
     */
    impersonate(requestParameters: ImpersonateApiImpersonateRequest, options?: any): AxiosPromise<StartImpersonatingResponse>;

    /**
     * Stop impersonating a user 
     * @summary Stop impersonating a user
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpersonateApiInterface
     */
    stopImpersonate(requestParameters?: undefined, options?: any): AxiosPromise<RegisteredUser>;

}

/**
 * Request parameters for impersonate operation in ImpersonateApi.
 * @export
 * @interface ImpersonateApiImpersonateRequest
 */
export interface ImpersonateApiImpersonateRequest {
    /**
     * The id of the user to impersonate
     * @type {number}
     * @memberof ImpersonateApiImpersonate
     */
    readonly userId: number
}

/**
 * ImpersonateApi - object-oriented interface
 * @export
 * @class ImpersonateApi
 * @extends {BaseAPI}
 */
export class ImpersonateApi extends BaseAPI implements ImpersonateApiInterface {
    /**
     * Impersonate a user 
     * @summary Impersonate a user
     * @param {ImpersonateApiImpersonateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpersonateApi
     */
    public impersonate(requestParameters: ImpersonateApiImpersonateRequest, options?: any) {
        const request = ImpersonateApiFp(this.configuration).impersonate(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Stop impersonating a user 
     * @summary Stop impersonating a user
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpersonateApi
     */
    public stopImpersonate(requestParameters?: undefined, options?: any) {
        const request = ImpersonateApiFp(this.configuration).stopImpersonate(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * IntroductionApi - axios parameter creator
 * @export
 */
export const IntroductionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update a introduction 
         * @summary Create introduction
         * @param {CreateIntroductionBody} createIntroductionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntroduction: (createIntroductionBody: CreateIntroductionBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createIntroductionBody' is not null or undefined
            assertParamExists('createIntroduction', 'createIntroductionBody', createIntroductionBody)
            const localVarPath = `/introduction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIntroductionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a introduction with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete introduction
         * @param {number} id The id of the introduction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntroduction: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteIntroduction', 'id', id)
            const localVarPath = `/introduction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single introduction by id 
         * @summary Get Introduction
         * @param {number} id The id of the introduction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntroduction: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIntroduction', 'id', id)
            const localVarPath = `/introduction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of introductions. 
         * @summary List Introductions
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {Array<IntroductionStatus>} [status] 
         * @param {Array<IntroductionVisibility>} [visibility] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntroductions: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, status?: Array<IntroductionStatus>, visibility?: Array<IntroductionVisibility>, options: any = {}): RequestArgs => {
            const localVarPath = `/introductions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (visibility) {
                localVarQueryParameter['visibility[]'] = visibility;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Introduction with a specific id 
         * @summary Update Introduction
         * @param {number} id The id of the Introduction
         * @param {UpdateIntroductionBody} updateIntroductionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntroduction: (id: number, updateIntroductionBody: UpdateIntroductionBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateIntroduction', 'id', id)
            // verify required parameter 'updateIntroductionBody' is not null or undefined
            assertParamExists('updateIntroduction', 'updateIntroductionBody', updateIntroductionBody)
            const localVarPath = `/introduction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateIntroductionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntroductionApi - functional programming interface
 * @export
 */
export const IntroductionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntroductionApiAxiosParamCreator(configuration)
    return {
        /**
         * Update a introduction 
         * @summary Create introduction
         * @param {IntroductionApiCreateIntroductionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntroduction(requestParameters: IntroductionApiCreateIntroductionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Introduction>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createIntroduction(requestParameters.createIntroductionBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a introduction with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete introduction
         * @param {IntroductionApiDeleteIntroductionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntroduction(requestParameters: IntroductionApiDeleteIntroductionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteIntroduction(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single introduction by id 
         * @summary Get Introduction
         * @param {IntroductionApiGetIntroductionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntroduction(requestParameters: IntroductionApiGetIntroductionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Introduction>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getIntroduction(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of introductions. 
         * @summary List Introductions
         * @param {IntroductionApiListIntroductionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntroductions(requestParameters: IntroductionApiListIntroductionsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedIntroductions>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listIntroductions(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.status, requestParameters.visibility, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a Introduction with a specific id 
         * @summary Update Introduction
         * @param {IntroductionApiUpdateIntroductionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntroduction(requestParameters: IntroductionApiUpdateIntroductionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Introduction>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateIntroduction(requestParameters.id, requestParameters.updateIntroductionBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntroductionApi - factory interface
 * @export
 */
export const IntroductionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntroductionApiFp(configuration)

    /**
      * Update a introduction 
      * @summary Create introduction
      * @param {IntroductionApiCreateIntroductionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createIntroduction = (requestParameters: IntroductionApiCreateIntroductionRequest, options?: any): AxiosPromise<Introduction> => {
        const request = localVarFp.createIntroduction(requestParameters, options);
        return request(axios, basePath);
    };

    createIntroduction.getQueryKey = (requestParameters: IntroductionApiCreateIntroductionRequest, options?: any) => {
        const request = localVarFp.createIntroduction(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a introduction with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete introduction
      * @param {IntroductionApiDeleteIntroductionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteIntroduction = (requestParameters: IntroductionApiDeleteIntroductionRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteIntroduction(requestParameters, options);
        return request(axios, basePath);
    };

    deleteIntroduction.getQueryKey = (requestParameters: IntroductionApiDeleteIntroductionRequest, options?: any) => {
        const request = localVarFp.deleteIntroduction(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single introduction by id 
      * @summary Get Introduction
      * @param {IntroductionApiGetIntroductionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getIntroduction = (requestParameters: IntroductionApiGetIntroductionRequest, options?: any): AxiosPromise<Introduction> => {
        const request = localVarFp.getIntroduction(requestParameters, options);
        return request(axios, basePath);
    };

    getIntroduction.getQueryKey = (requestParameters: IntroductionApiGetIntroductionRequest, options?: any) => {
        const request = localVarFp.getIntroduction(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of introductions. 
      * @summary List Introductions
      * @param {IntroductionApiListIntroductionsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listIntroductions = (requestParameters: IntroductionApiListIntroductionsRequest = {}, options?: any): AxiosPromise<PaginatedIntroductions> => {
        const request = localVarFp.listIntroductions(requestParameters, options);
        return request(axios, basePath);
    };

    listIntroductions.getQueryKey = (requestParameters: IntroductionApiListIntroductionsRequest = {}, options?: any) => {
        const request = localVarFp.listIntroductions(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a Introduction with a specific id 
      * @summary Update Introduction
      * @param {IntroductionApiUpdateIntroductionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateIntroduction = (requestParameters: IntroductionApiUpdateIntroductionRequest, options?: any): AxiosPromise<Introduction> => {
        const request = localVarFp.updateIntroduction(requestParameters, options);
        return request(axios, basePath);
    };

    updateIntroduction.getQueryKey = (requestParameters: IntroductionApiUpdateIntroductionRequest, options?: any) => {
        const request = localVarFp.updateIntroduction(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createIntroduction,
        deleteIntroduction,
        getIntroduction,
        listIntroductions,
        updateIntroduction,
    };
};

/**
 * IntroductionApi - interface
 * @export
 * @interface IntroductionApi
 */
export interface IntroductionApiInterface {
    /**
     * Update a introduction 
     * @summary Create introduction
     * @param {IntroductionApiCreateIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionApiInterface
     */
    createIntroduction(requestParameters: IntroductionApiCreateIntroductionRequest, options?: any): AxiosPromise<Introduction>;

    /**
     * Delete a introduction with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete introduction
     * @param {IntroductionApiDeleteIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionApiInterface
     */
    deleteIntroduction(requestParameters: IntroductionApiDeleteIntroductionRequest, options?: any): AxiosPromise<void>;

    /**
     * Fetch a single introduction by id 
     * @summary Get Introduction
     * @param {IntroductionApiGetIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionApiInterface
     */
    getIntroduction(requestParameters: IntroductionApiGetIntroductionRequest, options?: any): AxiosPromise<Introduction>;

    /**
     * Fetch a list of introductions. 
     * @summary List Introductions
     * @param {IntroductionApiListIntroductionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionApiInterface
     */
    listIntroductions(requestParameters?: IntroductionApiListIntroductionsRequest, options?: any): AxiosPromise<PaginatedIntroductions>;

    /**
     * Update a Introduction with a specific id 
     * @summary Update Introduction
     * @param {IntroductionApiUpdateIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionApiInterface
     */
    updateIntroduction(requestParameters: IntroductionApiUpdateIntroductionRequest, options?: any): AxiosPromise<Introduction>;

}

/**
 * Request parameters for createIntroduction operation in IntroductionApi.
 * @export
 * @interface IntroductionApiCreateIntroductionRequest
 */
export interface IntroductionApiCreateIntroductionRequest {
    /**
     * 
     * @type {CreateIntroductionBody}
     * @memberof IntroductionApiCreateIntroduction
     */
    readonly createIntroductionBody: CreateIntroductionBody
}

/**
 * Request parameters for deleteIntroduction operation in IntroductionApi.
 * @export
 * @interface IntroductionApiDeleteIntroductionRequest
 */
export interface IntroductionApiDeleteIntroductionRequest {
    /**
     * The id of the introduction
     * @type {number}
     * @memberof IntroductionApiDeleteIntroduction
     */
    readonly id: number
}

/**
 * Request parameters for getIntroduction operation in IntroductionApi.
 * @export
 * @interface IntroductionApiGetIntroductionRequest
 */
export interface IntroductionApiGetIntroductionRequest {
    /**
     * The id of the introduction
     * @type {number}
     * @memberof IntroductionApiGetIntroduction
     */
    readonly id: number
}

/**
 * Request parameters for listIntroductions operation in IntroductionApi.
 * @export
 * @interface IntroductionApiListIntroductionsRequest
 */
export interface IntroductionApiListIntroductionsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof IntroductionApiListIntroductions
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof IntroductionApiListIntroductions
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof IntroductionApiListIntroductions
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof IntroductionApiListIntroductions
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof IntroductionApiListIntroductions
     */
    readonly search?: string

    /**
     * 
     * @type {Array<IntroductionStatus>}
     * @memberof IntroductionApiListIntroductions
     */
    readonly status?: Array<IntroductionStatus>

    /**
     * 
     * @type {Array<IntroductionVisibility>}
     * @memberof IntroductionApiListIntroductions
     */
    readonly visibility?: Array<IntroductionVisibility>
}

/**
 * Request parameters for updateIntroduction operation in IntroductionApi.
 * @export
 * @interface IntroductionApiUpdateIntroductionRequest
 */
export interface IntroductionApiUpdateIntroductionRequest {
    /**
     * The id of the Introduction
     * @type {number}
     * @memberof IntroductionApiUpdateIntroduction
     */
    readonly id: number

    /**
     * 
     * @type {UpdateIntroductionBody}
     * @memberof IntroductionApiUpdateIntroduction
     */
    readonly updateIntroductionBody: UpdateIntroductionBody
}

/**
 * IntroductionApi - object-oriented interface
 * @export
 * @class IntroductionApi
 * @extends {BaseAPI}
 */
export class IntroductionApi extends BaseAPI implements IntroductionApiInterface {
    /**
     * Update a introduction 
     * @summary Create introduction
     * @param {IntroductionApiCreateIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionApi
     */
    public createIntroduction(requestParameters: IntroductionApiCreateIntroductionRequest, options?: any) {
        const request = IntroductionApiFp(this.configuration).createIntroduction(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a introduction with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete introduction
     * @param {IntroductionApiDeleteIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionApi
     */
    public deleteIntroduction(requestParameters: IntroductionApiDeleteIntroductionRequest, options?: any) {
        const request = IntroductionApiFp(this.configuration).deleteIntroduction(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single introduction by id 
     * @summary Get Introduction
     * @param {IntroductionApiGetIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionApi
     */
    public getIntroduction(requestParameters: IntroductionApiGetIntroductionRequest, options?: any) {
        const request = IntroductionApiFp(this.configuration).getIntroduction(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of introductions. 
     * @summary List Introductions
     * @param {IntroductionApiListIntroductionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionApi
     */
    public listIntroductions(requestParameters: IntroductionApiListIntroductionsRequest = {}, options?: any) {
        const request = IntroductionApiFp(this.configuration).listIntroductions(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a Introduction with a specific id 
     * @summary Update Introduction
     * @param {IntroductionApiUpdateIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionApi
     */
    public updateIntroduction(requestParameters: IntroductionApiUpdateIntroductionRequest, options?: any) {
        const request = IntroductionApiFp(this.configuration).updateIntroduction(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ListApi - axios parameter creator
 * @export
 */
export const ListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a list of resources counts groupped by topic. 
         * @summary Get Resources Dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesDashboard: (options: any = {}): RequestArgs => {
            const localVarPath = `/resources/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of agencies.  This route only is available to symmons admins 
         * @summary List Agencies
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {number} [agencyId] Filters agencies.  Ignored for non-admins.  Users will see only their own agency when fetching a list
         * @param {number} [salesRepId] Filters agencies by sales rep id
         * @param {number} [territoryId] Filters agencies by territory id
         * @param {string} [state] 
         * @param {string} [name] 
         * @param {number} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgencies: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, agencyId?: number, salesRepId?: number, territoryId?: number, state?: string, name?: string, status?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/agencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (agencyId !== undefined) {
                localVarQueryParameter['agency_id'] = agencyId;
            }

            if (salesRepId !== undefined) {
                localVarQueryParameter['sales_rep_id'] = salesRepId;
            }

            if (territoryId !== undefined) {
                localVarQueryParameter['territory_id'] = territoryId;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of agency goals.  This route is only available to symmons admins 
         * @summary List Agency Goals
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Search of agency goal records the current user has access to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgencyGoals: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, options: any = {}): RequestArgs => {
            const localVarPath = `/agency-goals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of companies.  This route only is available to symmons admins 
         * @summary List Companies
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {number} [companyId] Filters companies.  Ignored for non-admins.  Users will see only their own company when fetching a list
         * @param {boolean} [wholesaler] Filter companies by evolution status
         * @param {boolean} [evolution] Filter companies by evolution status
         * @param {number} [salesRepId] Filters companies by sales rep id
         * @param {number} [territoryId] Filters companies by territory id
         * @param {string} [state] 
         * @param {string} [name] 
         * @param {number} [status] 
         * @param {boolean} [unrestricted] When true, sales reps are not limited to their territory or assignments (admins are always unrestricted). Intended for trusted flows such as the price sheet picker.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, companyId?: number, wholesaler?: boolean, evolution?: boolean, salesRepId?: number, territoryId?: number, state?: string, name?: string, status?: number, unrestricted?: boolean, options: any = {}): RequestArgs => {
            const localVarPath = `/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (wholesaler !== undefined) {
                localVarQueryParameter['wholesaler'] = wholesaler;
            }

            if (evolution !== undefined) {
                localVarQueryParameter['evolution'] = evolution;
            }

            if (salesRepId !== undefined) {
                localVarQueryParameter['sales_rep_id'] = salesRepId;
            }

            if (territoryId !== undefined) {
                localVarQueryParameter['territory_id'] = territoryId;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (unrestricted !== undefined) {
                localVarQueryParameter['unrestricted'] = unrestricted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of files.  Each file has ownership and visibility settings. 
         * @summary List Files
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of file records the current user has access to.
         * @param {number} [companyId] Filter files by company.  Ignored for non-admins.  Users will see only their own files
         * @param {number} [locationId] Filter files by location.  Will only filter by locations the current user has access to
         * @param {FileStatus} [status] Filter files by status
         * @param {FileType} [type] Filter files by type
         * @param {Array<FileVisibility>} [visibility] Filter files by visibility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiles: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, companyId?: number, locationId?: number, status?: FileStatus, type?: FileType, visibility?: Array<FileVisibility>, options: any = {}): RequestArgs => {
            const localVarPath = `/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (visibility) {
                localVarQueryParameter['visibility[]'] = visibility;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of introductions. 
         * @summary List Introductions
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {Array<IntroductionStatus>} [status] 
         * @param {Array<IntroductionVisibility>} [visibility] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntroductions: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, status?: Array<IntroductionStatus>, visibility?: Array<IntroductionVisibility>, options: any = {}): RequestArgs => {
            const localVarPath = `/introductions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (visibility) {
                localVarQueryParameter['visibility[]'] = visibility;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of locations 
         * @summary List Locations
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {number} [companyId] The id of the company.  This this will only be callable by admins and company managers
         * @param {string} [search] Search for a location by fulltext
         * @param {number} [locationId] 
         * @param {string} [name] 
         * @param {string} [state] 
         * @param {number} [salesRepId] Filters locations by sales rep id
         * @param {number} [territoryId] Filters locations by territory id
         * @param {boolean} [unrestricted] When true, sales reps are not limited to their territory or assignments (admins are always unrestricted). Intended for trusted flows such as the price sheet picker.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', companyId?: number, search?: string, locationId?: number, name?: string, state?: string, salesRepId?: number, territoryId?: number, unrestricted?: boolean, options: any = {}): RequestArgs => {
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (salesRepId !== undefined) {
                localVarQueryParameter['sales_rep_id'] = salesRepId;
            }

            if (territoryId !== undefined) {
                localVarQueryParameter['territory_id'] = territoryId;
            }

            if (unrestricted !== undefined) {
                localVarQueryParameter['unrestricted'] = unrestricted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a paginated list of orders for an event 
         * @summary Order events list
         * @param {number} id The id of the order
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {RequestOrderChangeEventType} [type] Filter events by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrderEvents: (id: number, page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', type?: RequestOrderChangeEventType, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listOrderEvents', 'id', id)
            const localVarPath = `/order/{id}/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of orders.  This will either fetch the orders for the current user, or the list of orders for all customers, if you are an admin 
         * @summary List Orders
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {number} [companyId] Filter orders by company.  Ignored for non-admins.  Users will see only their own orders
         * @param {number} [locationId] Filter orders by location
         * @param {boolean} [wholesaler] Filter companies by wholesaler status
         * @param {boolean} [evolution] Filter companies by evolution status
         * @param {string} [orderNumber] Partial match filter on order number
         * @param {OrderStatus} [status] Filter orders by status
         * @param {string} [orderDateStart] Filter by order date, bound by start date
         * @param {string} [orderDateEnd] Filter by order date, bound by end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, companyId?: number, locationId?: number, wholesaler?: boolean, evolution?: boolean, orderNumber?: string, status?: OrderStatus, orderDateStart?: string, orderDateEnd?: string, options: any = {}): RequestArgs => {
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (wholesaler !== undefined) {
                localVarQueryParameter['wholesaler'] = wholesaler;
            }

            if (evolution !== undefined) {
                localVarQueryParameter['evolution'] = evolution;
            }

            if (orderNumber !== undefined) {
                localVarQueryParameter['order_number'] = orderNumber;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderDateStart !== undefined) {
                localVarQueryParameter['order_date_start'] = (orderDateStart as any instanceof Date) ?
                    (orderDateStart as any).toISOString() :
                    orderDateStart;
            }

            if (orderDateEnd !== undefined) {
                localVarQueryParameter['order_date_end'] = (orderDateEnd as any instanceof Date) ?
                    (orderDateEnd as any).toISOString() :
                    orderDateEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of projects. 
         * @summary List Projects
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {Array<ProjectStatus>} [status] 
         * @param {number} [userId] 
         * @param {number} [customerId] 
         * @param {number} [opportunityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, status?: Array<ProjectStatus>, userId?: number, customerId?: number, opportunityId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customer_id'] = customerId;
            }

            if (opportunityId !== undefined) {
                localVarQueryParameter['opportunity_id'] = opportunityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of quote requests. 
         * @summary List Quote Requests
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of quote requests the current user has access to.
         * @param {string} [modelNumber] Filters the quotes by a particular model number.
         * @param {string} [city] Partial match on city name
         * @param {string} [state] Two letter ISO state code
         * @param {QuoteStatus} [status] Filters the quotes by a particular status (deleted, pending, sent).  Will only show my quotes unless admin
         * @param {number} [companyId] Filter quote request by company.  Only will have effect for admins.  All others will see only their own company data 
         * @param {number} [locationId] Filter quotes by location.  This will only have effect for an admin now 
         * @param {number} [userId] Fetch quotes for a user.
         * @param {boolean} [directBuyer] Filter quotes by direct buyer status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuotes: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, modelNumber?: string, city?: string, state?: string, status?: QuoteStatus, companyId?: number, locationId?: number, userId?: number, directBuyer?: boolean, options: any = {}): RequestArgs => {
            const localVarPath = `/quotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (modelNumber !== undefined) {
                localVarQueryParameter['model_number'] = modelNumber;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (directBuyer !== undefined) {
                localVarQueryParameter['direct_buyer'] = directBuyer;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of regions with their associated territories 
         * @summary List Regions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegions: (options: any = {}): RequestArgs => {
            const localVarPath = `/regions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of resource categories. 
         * @summary List Resource Categories
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourceCategories: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', options: any = {}): RequestArgs => {
            const localVarPath = `/resources/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of resources. 
         * @summary List Resources
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {Array<ResourceStatus>} [status] 
         * @param {string} [topic] 
         * @param {string} [type] 
         * @param {boolean} [featured] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, status?: Array<ResourceStatus>, topic?: string, type?: string, featured?: boolean, options: any = {}): RequestArgs => {
            const localVarPath = `/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (featured !== undefined) {
                localVarQueryParameter['featured'] = featured;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
         * @summary List Salesforce Customers
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of salesforce customer records the current user has access to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceCustomers: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, options: any = {}): RequestArgs => {
            const localVarPath = `/salesforce/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
         * @summary List Salesforce opportunities
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of salesforce customer opportunities the current user has access to.
         * @param {number} [salesforceCustomerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceOpportunities: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, salesforceCustomerId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/salesforce/opportunities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (salesforceCustomerId !== undefined) {
                localVarQueryParameter['salesforce_customer_id'] = salesforceCustomerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of scorms.  This route only is available to symmons admins 
         * @summary List Scorms
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {number} [scormId] Filters scorm files
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScorms: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, scormId?: number, state?: string, options: any = {}): RequestArgs => {
            const localVarPath = `/scorms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (scormId !== undefined) {
                localVarQueryParameter['scorm_id'] = scormId;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of territories with their associated regions 
         * @summary List Territories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTerritories: (options: any = {}): RequestArgs => {
            const localVarPath = `/territories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of users, open only to admins and managers 
         * @summary List users
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {number} [agencyId] The id of the agency.  This this will only be callable by admins
         * @param {number} [companyId] The id of the company.  This this will only be callable by admins and company managers
         * @param {number} [locationId] The id of the location.  This this will only be callable by admins and company managers
         * @param {number} [territoryId] The id of the territory.  This will only be callable by admins and company managers
         * @param {number} [userId] The id of the company.  This this will only be callable by admins and company managers
         * @param {UserStatus} [status] The status of the user.  This this will only be callable by admins and company managers
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {boolean} [withProjects] Only show users that have at least one project
         * @param {UserRole} [role] The role the user belongs to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', agencyId?: number, companyId?: number, locationId?: number, territoryId?: number, userId?: number, status?: UserStatus, search?: string, withProjects?: boolean, role?: UserRole, options: any = {}): RequestArgs => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (agencyId !== undefined) {
                localVarQueryParameter['agency_id'] = agencyId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (territoryId !== undefined) {
                localVarQueryParameter['territory_id'] = territoryId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (withProjects !== undefined) {
                localVarQueryParameter['with_projects'] = withProjects;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of locations to use in a filter 
         * @summary List Locations
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {number} [companyId] The id of the company.  This this will only be callable by admins and company managers
         * @param {string} [search] Search for a location by fulltext
         * @param {number} [locationId] 
         * @param {string} [name] 
         * @param {string} [state] 
         * @param {number} [territoryId] Filters locations by territory id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsFilter: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', companyId?: number, search?: string, locationId?: number, name?: string, state?: string, territoryId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/locations/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (territoryId !== undefined) {
                localVarQueryParameter['territory_id'] = territoryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ListApi - functional programming interface
 * @export
 */
export const ListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ListApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a list of resources counts groupped by topic. 
         * @summary Get Resources Dashboard
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesDashboard(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ResourcesDashboard>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getResourcesDashboard(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of agencies.  This route only is available to symmons admins 
         * @summary List Agencies
         * @param {ListApiListAgenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgencies(requestParameters: ListApiListAgenciesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedAgencies>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listAgencies(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.agencyId, requestParameters.salesRepId, requestParameters.territoryId, requestParameters.state, requestParameters.name, requestParameters.status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of agency goals.  This route is only available to symmons admins 
         * @summary List Agency Goals
         * @param {ListApiListAgencyGoalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgencyGoals(requestParameters: ListApiListAgencyGoalsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedAgencyGoals>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listAgencyGoals(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of companies.  This route only is available to symmons admins 
         * @summary List Companies
         * @param {ListApiListCompaniesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies(requestParameters: ListApiListCompaniesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedCompanies>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listCompanies(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.companyId, requestParameters.wholesaler, requestParameters.evolution, requestParameters.salesRepId, requestParameters.territoryId, requestParameters.state, requestParameters.name, requestParameters.status, requestParameters.unrestricted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of files.  Each file has ownership and visibility settings. 
         * @summary List Files
         * @param {ListApiListFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiles(requestParameters: ListApiListFilesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedFiles>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listFiles(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.companyId, requestParameters.locationId, requestParameters.status, requestParameters.type, requestParameters.visibility, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of introductions. 
         * @summary List Introductions
         * @param {ListApiListIntroductionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntroductions(requestParameters: ListApiListIntroductionsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedIntroductions>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listIntroductions(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.status, requestParameters.visibility, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of locations 
         * @summary List Locations
         * @param {ListApiListLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations(requestParameters: ListApiListLocationsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedLocations>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listLocations(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.companyId, requestParameters.search, requestParameters.locationId, requestParameters.name, requestParameters.state, requestParameters.salesRepId, requestParameters.territoryId, requestParameters.unrestricted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a paginated list of orders for an event 
         * @summary Order events list
         * @param {ListApiListOrderEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrderEvents(requestParameters: ListApiListOrderEventsRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedOrderEvents>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listOrderEvents(requestParameters.id, requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of orders.  This will either fetch the orders for the current user, or the list of orders for all customers, if you are an admin 
         * @summary List Orders
         * @param {ListApiListOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders(requestParameters: ListApiListOrdersRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedOrders>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listOrders(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.companyId, requestParameters.locationId, requestParameters.wholesaler, requestParameters.evolution, requestParameters.orderNumber, requestParameters.status, requestParameters.orderDateStart, requestParameters.orderDateEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of projects. 
         * @summary List Projects
         * @param {ListApiListProjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects(requestParameters: ListApiListProjectsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedProjects>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listProjects(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.status, requestParameters.userId, requestParameters.customerId, requestParameters.opportunityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of quote requests. 
         * @summary List Quote Requests
         * @param {ListApiListQuotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuotes(requestParameters: ListApiListQuotesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedQuotes>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listQuotes(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.modelNumber, requestParameters.city, requestParameters.state, requestParameters.status, requestParameters.companyId, requestParameters.locationId, requestParameters.userId, requestParameters.directBuyer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of regions with their associated territories 
         * @summary List Regions
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegions(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegionsResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listRegions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of resource categories. 
         * @summary List Resource Categories
         * @param {ListApiListResourceCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourceCategories(requestParameters: ListApiListResourceCategoriesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedTaxonomyTerm>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listResourceCategories(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of resources. 
         * @summary List Resources
         * @param {ListApiListResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(requestParameters: ListApiListResourcesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedResources>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listResources(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.status, requestParameters.topic, requestParameters.type, requestParameters.featured, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
         * @summary List Salesforce Customers
         * @param {ListApiListSalesforceCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceCustomers(requestParameters: ListApiListSalesforceCustomersRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedSalesforceCustomers>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listSalesforceCustomers(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
         * @summary List Salesforce opportunities
         * @param {ListApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceOpportunities(requestParameters: ListApiListSalesforceOpportunitiesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedSalesforceOpportunities>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listSalesforceOpportunities(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.salesforceCustomerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of scorms.  This route only is available to symmons admins 
         * @summary List Scorms
         * @param {ListApiListScormsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScorms(requestParameters: ListApiListScormsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedScorms>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listScorms(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.scormId, requestParameters.state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of territories with their associated regions 
         * @summary List Territories
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTerritories(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TerritoriesResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listTerritories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of users, open only to admins and managers 
         * @summary List users
         * @param {ListApiListUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(requestParameters: ListApiListUsersRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedUsers>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listUsers(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.agencyId, requestParameters.companyId, requestParameters.locationId, requestParameters.territoryId, requestParameters.userId, requestParameters.status, requestParameters.search, requestParameters.withProjects, requestParameters.role, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a list of locations to use in a filter 
         * @summary List Locations
         * @param {ListApiLocationsFilterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsFilter(requestParameters: ListApiLocationsFilterRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedLocations>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.locationsFilter(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.companyId, requestParameters.search, requestParameters.locationId, requestParameters.name, requestParameters.state, requestParameters.territoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ListApi - factory interface
 * @export
 */
export const ListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ListApiFp(configuration)

    /**
      * Fetch a list of resources counts groupped by topic. 
      * @summary Get Resources Dashboard
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getResourcesDashboard = (requestParameters?: undefined, options?: any): AxiosPromise<ResourcesDashboard> => {
        const request = localVarFp.getResourcesDashboard(requestParameters, options);
        return request(axios, basePath);
    };

    getResourcesDashboard.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.getResourcesDashboard(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of agencies.  This route only is available to symmons admins 
      * @summary List Agencies
      * @param {ListApiListAgenciesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listAgencies = (requestParameters: ListApiListAgenciesRequest = {}, options?: any): AxiosPromise<PaginatedAgencies> => {
        const request = localVarFp.listAgencies(requestParameters, options);
        return request(axios, basePath);
    };

    listAgencies.getQueryKey = (requestParameters: ListApiListAgenciesRequest = {}, options?: any) => {
        const request = localVarFp.listAgencies(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of agency goals.  This route is only available to symmons admins 
      * @summary List Agency Goals
      * @param {ListApiListAgencyGoalsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listAgencyGoals = (requestParameters: ListApiListAgencyGoalsRequest = {}, options?: any): AxiosPromise<PaginatedAgencyGoals> => {
        const request = localVarFp.listAgencyGoals(requestParameters, options);
        return request(axios, basePath);
    };

    listAgencyGoals.getQueryKey = (requestParameters: ListApiListAgencyGoalsRequest = {}, options?: any) => {
        const request = localVarFp.listAgencyGoals(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of companies.  This route only is available to symmons admins 
      * @summary List Companies
      * @param {ListApiListCompaniesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listCompanies = (requestParameters: ListApiListCompaniesRequest = {}, options?: any): AxiosPromise<PaginatedCompanies> => {
        const request = localVarFp.listCompanies(requestParameters, options);
        return request(axios, basePath);
    };

    listCompanies.getQueryKey = (requestParameters: ListApiListCompaniesRequest = {}, options?: any) => {
        const request = localVarFp.listCompanies(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of files.  Each file has ownership and visibility settings. 
      * @summary List Files
      * @param {ListApiListFilesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listFiles = (requestParameters: ListApiListFilesRequest = {}, options?: any): AxiosPromise<PaginatedFiles> => {
        const request = localVarFp.listFiles(requestParameters, options);
        return request(axios, basePath);
    };

    listFiles.getQueryKey = (requestParameters: ListApiListFilesRequest = {}, options?: any) => {
        const request = localVarFp.listFiles(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of introductions. 
      * @summary List Introductions
      * @param {ListApiListIntroductionsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listIntroductions = (requestParameters: ListApiListIntroductionsRequest = {}, options?: any): AxiosPromise<PaginatedIntroductions> => {
        const request = localVarFp.listIntroductions(requestParameters, options);
        return request(axios, basePath);
    };

    listIntroductions.getQueryKey = (requestParameters: ListApiListIntroductionsRequest = {}, options?: any) => {
        const request = localVarFp.listIntroductions(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of locations 
      * @summary List Locations
      * @param {ListApiListLocationsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listLocations = (requestParameters: ListApiListLocationsRequest = {}, options?: any): AxiosPromise<PaginatedLocations> => {
        const request = localVarFp.listLocations(requestParameters, options);
        return request(axios, basePath);
    };

    listLocations.getQueryKey = (requestParameters: ListApiListLocationsRequest = {}, options?: any) => {
        const request = localVarFp.listLocations(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a paginated list of orders for an event 
      * @summary Order events list
      * @param {ListApiListOrderEventsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listOrderEvents = (requestParameters: ListApiListOrderEventsRequest, options?: any): AxiosPromise<PaginatedOrderEvents> => {
        const request = localVarFp.listOrderEvents(requestParameters, options);
        return request(axios, basePath);
    };

    listOrderEvents.getQueryKey = (requestParameters: ListApiListOrderEventsRequest, options?: any) => {
        const request = localVarFp.listOrderEvents(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of orders.  This will either fetch the orders for the current user, or the list of orders for all customers, if you are an admin 
      * @summary List Orders
      * @param {ListApiListOrdersRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listOrders = (requestParameters: ListApiListOrdersRequest = {}, options?: any): AxiosPromise<PaginatedOrders> => {
        const request = localVarFp.listOrders(requestParameters, options);
        return request(axios, basePath);
    };

    listOrders.getQueryKey = (requestParameters: ListApiListOrdersRequest = {}, options?: any) => {
        const request = localVarFp.listOrders(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of projects. 
      * @summary List Projects
      * @param {ListApiListProjectsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listProjects = (requestParameters: ListApiListProjectsRequest = {}, options?: any): AxiosPromise<PaginatedProjects> => {
        const request = localVarFp.listProjects(requestParameters, options);
        return request(axios, basePath);
    };

    listProjects.getQueryKey = (requestParameters: ListApiListProjectsRequest = {}, options?: any) => {
        const request = localVarFp.listProjects(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of quote requests. 
      * @summary List Quote Requests
      * @param {ListApiListQuotesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listQuotes = (requestParameters: ListApiListQuotesRequest = {}, options?: any): AxiosPromise<PaginatedQuotes> => {
        const request = localVarFp.listQuotes(requestParameters, options);
        return request(axios, basePath);
    };

    listQuotes.getQueryKey = (requestParameters: ListApiListQuotesRequest = {}, options?: any) => {
        const request = localVarFp.listQuotes(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of regions with their associated territories 
      * @summary List Regions
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listRegions = (requestParameters?: undefined, options?: any): AxiosPromise<RegionsResponse> => {
        const request = localVarFp.listRegions(requestParameters, options);
        return request(axios, basePath);
    };

    listRegions.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.listRegions(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of resource categories. 
      * @summary List Resource Categories
      * @param {ListApiListResourceCategoriesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listResourceCategories = (requestParameters: ListApiListResourceCategoriesRequest = {}, options?: any): AxiosPromise<PaginatedTaxonomyTerm> => {
        const request = localVarFp.listResourceCategories(requestParameters, options);
        return request(axios, basePath);
    };

    listResourceCategories.getQueryKey = (requestParameters: ListApiListResourceCategoriesRequest = {}, options?: any) => {
        const request = localVarFp.listResourceCategories(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of resources. 
      * @summary List Resources
      * @param {ListApiListResourcesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listResources = (requestParameters: ListApiListResourcesRequest = {}, options?: any): AxiosPromise<PaginatedResources> => {
        const request = localVarFp.listResources(requestParameters, options);
        return request(axios, basePath);
    };

    listResources.getQueryKey = (requestParameters: ListApiListResourcesRequest = {}, options?: any) => {
        const request = localVarFp.listResources(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
      * @summary List Salesforce Customers
      * @param {ListApiListSalesforceCustomersRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listSalesforceCustomers = (requestParameters: ListApiListSalesforceCustomersRequest = {}, options?: any): AxiosPromise<PaginatedSalesforceCustomers> => {
        const request = localVarFp.listSalesforceCustomers(requestParameters, options);
        return request(axios, basePath);
    };

    listSalesforceCustomers.getQueryKey = (requestParameters: ListApiListSalesforceCustomersRequest = {}, options?: any) => {
        const request = localVarFp.listSalesforceCustomers(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
      * @summary List Salesforce opportunities
      * @param {ListApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listSalesforceOpportunities = (requestParameters: ListApiListSalesforceOpportunitiesRequest = {}, options?: any): AxiosPromise<PaginatedSalesforceOpportunities> => {
        const request = localVarFp.listSalesforceOpportunities(requestParameters, options);
        return request(axios, basePath);
    };

    listSalesforceOpportunities.getQueryKey = (requestParameters: ListApiListSalesforceOpportunitiesRequest = {}, options?: any) => {
        const request = localVarFp.listSalesforceOpportunities(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of scorms.  This route only is available to symmons admins 
      * @summary List Scorms
      * @param {ListApiListScormsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listScorms = (requestParameters: ListApiListScormsRequest = {}, options?: any): AxiosPromise<PaginatedScorms> => {
        const request = localVarFp.listScorms(requestParameters, options);
        return request(axios, basePath);
    };

    listScorms.getQueryKey = (requestParameters: ListApiListScormsRequest = {}, options?: any) => {
        const request = localVarFp.listScorms(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of territories with their associated regions 
      * @summary List Territories
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listTerritories = (requestParameters?: undefined, options?: any): AxiosPromise<TerritoriesResponse> => {
        const request = localVarFp.listTerritories(requestParameters, options);
        return request(axios, basePath);
    };

    listTerritories.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.listTerritories(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of users, open only to admins and managers 
      * @summary List users
      * @param {ListApiListUsersRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listUsers = (requestParameters: ListApiListUsersRequest = {}, options?: any): AxiosPromise<PaginatedUsers> => {
        const request = localVarFp.listUsers(requestParameters, options);
        return request(axios, basePath);
    };

    listUsers.getQueryKey = (requestParameters: ListApiListUsersRequest = {}, options?: any) => {
        const request = localVarFp.listUsers(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a list of locations to use in a filter 
      * @summary List Locations
      * @param {ListApiLocationsFilterRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const locationsFilter = (requestParameters: ListApiLocationsFilterRequest = {}, options?: any): AxiosPromise<PaginatedLocations> => {
        const request = localVarFp.locationsFilter(requestParameters, options);
        return request(axios, basePath);
    };

    locationsFilter.getQueryKey = (requestParameters: ListApiLocationsFilterRequest = {}, options?: any) => {
        const request = localVarFp.locationsFilter(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        getResourcesDashboard,
        listAgencies,
        listAgencyGoals,
        listCompanies,
        listFiles,
        listIntroductions,
        listLocations,
        listOrderEvents,
        listOrders,
        listProjects,
        listQuotes,
        listRegions,
        listResourceCategories,
        listResources,
        listSalesforceCustomers,
        listSalesforceOpportunities,
        listScorms,
        listTerritories,
        listUsers,
        locationsFilter,
    };
};

/**
 * ListApi - interface
 * @export
 * @interface ListApi
 */
export interface ListApiInterface {
    /**
     * Fetch a list of resources counts groupped by topic. 
     * @summary Get Resources Dashboard
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    getResourcesDashboard(requestParameters?: undefined, options?: any): AxiosPromise<ResourcesDashboard>;

    /**
     * Fetch a list of agencies.  This route only is available to symmons admins 
     * @summary List Agencies
     * @param {ListApiListAgenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listAgencies(requestParameters?: ListApiListAgenciesRequest, options?: any): AxiosPromise<PaginatedAgencies>;

    /**
     * Fetch a list of agency goals.  This route is only available to symmons admins 
     * @summary List Agency Goals
     * @param {ListApiListAgencyGoalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listAgencyGoals(requestParameters?: ListApiListAgencyGoalsRequest, options?: any): AxiosPromise<PaginatedAgencyGoals>;

    /**
     * Fetch a list of companies.  This route only is available to symmons admins 
     * @summary List Companies
     * @param {ListApiListCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listCompanies(requestParameters?: ListApiListCompaniesRequest, options?: any): AxiosPromise<PaginatedCompanies>;

    /**
     * Fetch a list of files.  Each file has ownership and visibility settings. 
     * @summary List Files
     * @param {ListApiListFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listFiles(requestParameters?: ListApiListFilesRequest, options?: any): AxiosPromise<PaginatedFiles>;

    /**
     * Fetch a list of introductions. 
     * @summary List Introductions
     * @param {ListApiListIntroductionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listIntroductions(requestParameters?: ListApiListIntroductionsRequest, options?: any): AxiosPromise<PaginatedIntroductions>;

    /**
     * Fetch a list of locations 
     * @summary List Locations
     * @param {ListApiListLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listLocations(requestParameters?: ListApiListLocationsRequest, options?: any): AxiosPromise<PaginatedLocations>;

    /**
     * Get a paginated list of orders for an event 
     * @summary Order events list
     * @param {ListApiListOrderEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listOrderEvents(requestParameters: ListApiListOrderEventsRequest, options?: any): AxiosPromise<PaginatedOrderEvents>;

    /**
     * Fetch a list of orders.  This will either fetch the orders for the current user, or the list of orders for all customers, if you are an admin 
     * @summary List Orders
     * @param {ListApiListOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listOrders(requestParameters?: ListApiListOrdersRequest, options?: any): AxiosPromise<PaginatedOrders>;

    /**
     * Fetch a list of projects. 
     * @summary List Projects
     * @param {ListApiListProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listProjects(requestParameters?: ListApiListProjectsRequest, options?: any): AxiosPromise<PaginatedProjects>;

    /**
     * Fetch a list of quote requests. 
     * @summary List Quote Requests
     * @param {ListApiListQuotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listQuotes(requestParameters?: ListApiListQuotesRequest, options?: any): AxiosPromise<PaginatedQuotes>;

    /**
     * Fetch a list of regions with their associated territories 
     * @summary List Regions
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listRegions(requestParameters?: undefined, options?: any): AxiosPromise<RegionsResponse>;

    /**
     * Fetch a list of resource categories. 
     * @summary List Resource Categories
     * @param {ListApiListResourceCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listResourceCategories(requestParameters?: ListApiListResourceCategoriesRequest, options?: any): AxiosPromise<PaginatedTaxonomyTerm>;

    /**
     * Fetch a list of resources. 
     * @summary List Resources
     * @param {ListApiListResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listResources(requestParameters?: ListApiListResourcesRequest, options?: any): AxiosPromise<PaginatedResources>;

    /**
     * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
     * @summary List Salesforce Customers
     * @param {ListApiListSalesforceCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listSalesforceCustomers(requestParameters?: ListApiListSalesforceCustomersRequest, options?: any): AxiosPromise<PaginatedSalesforceCustomers>;

    /**
     * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
     * @summary List Salesforce opportunities
     * @param {ListApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listSalesforceOpportunities(requestParameters?: ListApiListSalesforceOpportunitiesRequest, options?: any): AxiosPromise<PaginatedSalesforceOpportunities>;

    /**
     * Fetch a list of scorms.  This route only is available to symmons admins 
     * @summary List Scorms
     * @param {ListApiListScormsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listScorms(requestParameters?: ListApiListScormsRequest, options?: any): AxiosPromise<PaginatedScorms>;

    /**
     * Fetch a list of territories with their associated regions 
     * @summary List Territories
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listTerritories(requestParameters?: undefined, options?: any): AxiosPromise<TerritoriesResponse>;

    /**
     * Fetch a list of users, open only to admins and managers 
     * @summary List users
     * @param {ListApiListUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    listUsers(requestParameters?: ListApiListUsersRequest, options?: any): AxiosPromise<PaginatedUsers>;

    /**
     * Get a list of locations to use in a filter 
     * @summary List Locations
     * @param {ListApiLocationsFilterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApiInterface
     */
    locationsFilter(requestParameters?: ListApiLocationsFilterRequest, options?: any): AxiosPromise<PaginatedLocations>;

}

/**
 * Request parameters for listAgencies operation in ListApi.
 * @export
 * @interface ListApiListAgenciesRequest
 */
export interface ListApiListAgenciesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListAgencies
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListAgencies
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListAgencies
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListAgencies
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ListApiListAgencies
     */
    readonly search?: string

    /**
     * Filters agencies.  Ignored for non-admins.  Users will see only their own agency when fetching a list
     * @type {number}
     * @memberof ListApiListAgencies
     */
    readonly agencyId?: number

    /**
     * Filters agencies by sales rep id
     * @type {number}
     * @memberof ListApiListAgencies
     */
    readonly salesRepId?: number

    /**
     * Filters agencies by territory id
     * @type {number}
     * @memberof ListApiListAgencies
     */
    readonly territoryId?: number

    /**
     * 
     * @type {string}
     * @memberof ListApiListAgencies
     */
    readonly state?: string

    /**
     * 
     * @type {string}
     * @memberof ListApiListAgencies
     */
    readonly name?: string

    /**
     * 
     * @type {number}
     * @memberof ListApiListAgencies
     */
    readonly status?: number
}

/**
 * Request parameters for listAgencyGoals operation in ListApi.
 * @export
 * @interface ListApiListAgencyGoalsRequest
 */
export interface ListApiListAgencyGoalsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListAgencyGoals
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListAgencyGoals
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListAgencyGoals
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListAgencyGoals
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Search of agency goal records the current user has access to.
     * @type {string}
     * @memberof ListApiListAgencyGoals
     */
    readonly search?: string
}

/**
 * Request parameters for listCompanies operation in ListApi.
 * @export
 * @interface ListApiListCompaniesRequest
 */
export interface ListApiListCompaniesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListCompanies
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListCompanies
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListCompanies
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListCompanies
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ListApiListCompanies
     */
    readonly search?: string

    /**
     * Filters companies.  Ignored for non-admins.  Users will see only their own company when fetching a list
     * @type {number}
     * @memberof ListApiListCompanies
     */
    readonly companyId?: number

    /**
     * Filter companies by evolution status
     * @type {boolean}
     * @memberof ListApiListCompanies
     */
    readonly wholesaler?: boolean

    /**
     * Filter companies by evolution status
     * @type {boolean}
     * @memberof ListApiListCompanies
     */
    readonly evolution?: boolean

    /**
     * Filters companies by sales rep id
     * @type {number}
     * @memberof ListApiListCompanies
     */
    readonly salesRepId?: number

    /**
     * Filters companies by territory id
     * @type {number}
     * @memberof ListApiListCompanies
     */
    readonly territoryId?: number

    /**
     * 
     * @type {string}
     * @memberof ListApiListCompanies
     */
    readonly state?: string

    /**
     * 
     * @type {string}
     * @memberof ListApiListCompanies
     */
    readonly name?: string

    /**
     * 
     * @type {number}
     * @memberof ListApiListCompanies
     */
    readonly status?: number

    /**
     * When true, sales reps are not limited to their territory or assignments (admins are always unrestricted). Intended for trusted flows such as the price sheet picker.
     * @type {boolean}
     * @memberof ListApiListCompanies
     */
    readonly unrestricted?: boolean
}

/**
 * Request parameters for listFiles operation in ListApi.
 * @export
 * @interface ListApiListFilesRequest
 */
export interface ListApiListFilesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListFiles
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListFiles
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListFiles
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListFiles
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of file records the current user has access to.
     * @type {string}
     * @memberof ListApiListFiles
     */
    readonly search?: string

    /**
     * Filter files by company.  Ignored for non-admins.  Users will see only their own files
     * @type {number}
     * @memberof ListApiListFiles
     */
    readonly companyId?: number

    /**
     * Filter files by location.  Will only filter by locations the current user has access to
     * @type {number}
     * @memberof ListApiListFiles
     */
    readonly locationId?: number

    /**
     * Filter files by status
     * @type {FileStatus}
     * @memberof ListApiListFiles
     */
    readonly status?: FileStatus

    /**
     * Filter files by type
     * @type {FileType}
     * @memberof ListApiListFiles
     */
    readonly type?: FileType

    /**
     * Filter files by visibility
     * @type {Array<FileVisibility>}
     * @memberof ListApiListFiles
     */
    readonly visibility?: Array<FileVisibility>
}

/**
 * Request parameters for listIntroductions operation in ListApi.
 * @export
 * @interface ListApiListIntroductionsRequest
 */
export interface ListApiListIntroductionsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListIntroductions
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListIntroductions
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListIntroductions
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListIntroductions
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ListApiListIntroductions
     */
    readonly search?: string

    /**
     * 
     * @type {Array<IntroductionStatus>}
     * @memberof ListApiListIntroductions
     */
    readonly status?: Array<IntroductionStatus>

    /**
     * 
     * @type {Array<IntroductionVisibility>}
     * @memberof ListApiListIntroductions
     */
    readonly visibility?: Array<IntroductionVisibility>
}

/**
 * Request parameters for listLocations operation in ListApi.
 * @export
 * @interface ListApiListLocationsRequest
 */
export interface ListApiListLocationsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListLocations
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListLocations
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListLocations
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListLocations
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * The id of the company.  This this will only be callable by admins and company managers
     * @type {number}
     * @memberof ListApiListLocations
     */
    readonly companyId?: number

    /**
     * Search for a location by fulltext
     * @type {string}
     * @memberof ListApiListLocations
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof ListApiListLocations
     */
    readonly locationId?: number

    /**
     * 
     * @type {string}
     * @memberof ListApiListLocations
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ListApiListLocations
     */
    readonly state?: string

    /**
     * Filters locations by sales rep id
     * @type {number}
     * @memberof ListApiListLocations
     */
    readonly salesRepId?: number

    /**
     * Filters locations by territory id
     * @type {number}
     * @memberof ListApiListLocations
     */
    readonly territoryId?: number

    /**
     * When true, sales reps are not limited to their territory or assignments (admins are always unrestricted). Intended for trusted flows such as the price sheet picker.
     * @type {boolean}
     * @memberof ListApiListLocations
     */
    readonly unrestricted?: boolean
}

/**
 * Request parameters for listOrderEvents operation in ListApi.
 * @export
 * @interface ListApiListOrderEventsRequest
 */
export interface ListApiListOrderEventsRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof ListApiListOrderEvents
     */
    readonly id: number

    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListOrderEvents
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListOrderEvents
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListOrderEvents
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListOrderEvents
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Filter events by type
     * @type {RequestOrderChangeEventType}
     * @memberof ListApiListOrderEvents
     */
    readonly type?: RequestOrderChangeEventType
}

/**
 * Request parameters for listOrders operation in ListApi.
 * @export
 * @interface ListApiListOrdersRequest
 */
export interface ListApiListOrdersRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListOrders
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListOrders
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListOrders
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListOrders
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ListApiListOrders
     */
    readonly search?: string

    /**
     * Filter orders by company.  Ignored for non-admins.  Users will see only their own orders
     * @type {number}
     * @memberof ListApiListOrders
     */
    readonly companyId?: number

    /**
     * Filter orders by location
     * @type {number}
     * @memberof ListApiListOrders
     */
    readonly locationId?: number

    /**
     * Filter companies by wholesaler status
     * @type {boolean}
     * @memberof ListApiListOrders
     */
    readonly wholesaler?: boolean

    /**
     * Filter companies by evolution status
     * @type {boolean}
     * @memberof ListApiListOrders
     */
    readonly evolution?: boolean

    /**
     * Partial match filter on order number
     * @type {string}
     * @memberof ListApiListOrders
     */
    readonly orderNumber?: string

    /**
     * Filter orders by status
     * @type {OrderStatus}
     * @memberof ListApiListOrders
     */
    readonly status?: OrderStatus

    /**
     * Filter by order date, bound by start date
     * @type {string}
     * @memberof ListApiListOrders
     */
    readonly orderDateStart?: string

    /**
     * Filter by order date, bound by end date
     * @type {string}
     * @memberof ListApiListOrders
     */
    readonly orderDateEnd?: string
}

/**
 * Request parameters for listProjects operation in ListApi.
 * @export
 * @interface ListApiListProjectsRequest
 */
export interface ListApiListProjectsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListProjects
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListProjects
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListProjects
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListProjects
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ListApiListProjects
     */
    readonly search?: string

    /**
     * 
     * @type {Array<ProjectStatus>}
     * @memberof ListApiListProjects
     */
    readonly status?: Array<ProjectStatus>

    /**
     * 
     * @type {number}
     * @memberof ListApiListProjects
     */
    readonly userId?: number

    /**
     * 
     * @type {number}
     * @memberof ListApiListProjects
     */
    readonly customerId?: number

    /**
     * 
     * @type {number}
     * @memberof ListApiListProjects
     */
    readonly opportunityId?: number
}

/**
 * Request parameters for listQuotes operation in ListApi.
 * @export
 * @interface ListApiListQuotesRequest
 */
export interface ListApiListQuotesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListQuotes
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListQuotes
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListQuotes
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListQuotes
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of quote requests the current user has access to.
     * @type {string}
     * @memberof ListApiListQuotes
     */
    readonly search?: string

    /**
     * Filters the quotes by a particular model number.
     * @type {string}
     * @memberof ListApiListQuotes
     */
    readonly modelNumber?: string

    /**
     * Partial match on city name
     * @type {string}
     * @memberof ListApiListQuotes
     */
    readonly city?: string

    /**
     * Two letter ISO state code
     * @type {string}
     * @memberof ListApiListQuotes
     */
    readonly state?: string

    /**
     * Filters the quotes by a particular status (deleted, pending, sent).  Will only show my quotes unless admin
     * @type {QuoteStatus}
     * @memberof ListApiListQuotes
     */
    readonly status?: QuoteStatus

    /**
     * Filter quote request by company.  Only will have effect for admins.  All others will see only their own company data 
     * @type {number}
     * @memberof ListApiListQuotes
     */
    readonly companyId?: number

    /**
     * Filter quotes by location.  This will only have effect for an admin now 
     * @type {number}
     * @memberof ListApiListQuotes
     */
    readonly locationId?: number

    /**
     * Fetch quotes for a user.
     * @type {number}
     * @memberof ListApiListQuotes
     */
    readonly userId?: number

    /**
     * Filter quotes by direct buyer status
     * @type {boolean}
     * @memberof ListApiListQuotes
     */
    readonly directBuyer?: boolean
}

/**
 * Request parameters for listResourceCategories operation in ListApi.
 * @export
 * @interface ListApiListResourceCategoriesRequest
 */
export interface ListApiListResourceCategoriesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListResourceCategories
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListResourceCategories
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListResourceCategories
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListResourceCategories
     */
    readonly direction?: 'asc' | 'desc'
}

/**
 * Request parameters for listResources operation in ListApi.
 * @export
 * @interface ListApiListResourcesRequest
 */
export interface ListApiListResourcesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListResources
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListResources
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListResources
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListResources
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ListApiListResources
     */
    readonly search?: string

    /**
     * 
     * @type {Array<ResourceStatus>}
     * @memberof ListApiListResources
     */
    readonly status?: Array<ResourceStatus>

    /**
     * 
     * @type {string}
     * @memberof ListApiListResources
     */
    readonly topic?: string

    /**
     * 
     * @type {string}
     * @memberof ListApiListResources
     */
    readonly type?: string

    /**
     * 
     * @type {boolean}
     * @memberof ListApiListResources
     */
    readonly featured?: boolean
}

/**
 * Request parameters for listSalesforceCustomers operation in ListApi.
 * @export
 * @interface ListApiListSalesforceCustomersRequest
 */
export interface ListApiListSalesforceCustomersRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListSalesforceCustomers
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListSalesforceCustomers
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListSalesforceCustomers
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListSalesforceCustomers
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of salesforce customer records the current user has access to.
     * @type {string}
     * @memberof ListApiListSalesforceCustomers
     */
    readonly search?: string
}

/**
 * Request parameters for listSalesforceOpportunities operation in ListApi.
 * @export
 * @interface ListApiListSalesforceOpportunitiesRequest
 */
export interface ListApiListSalesforceOpportunitiesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListSalesforceOpportunities
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListSalesforceOpportunities
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListSalesforceOpportunities
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListSalesforceOpportunities
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of salesforce customer opportunities the current user has access to.
     * @type {string}
     * @memberof ListApiListSalesforceOpportunities
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof ListApiListSalesforceOpportunities
     */
    readonly salesforceCustomerId?: number
}

/**
 * Request parameters for listScorms operation in ListApi.
 * @export
 * @interface ListApiListScormsRequest
 */
export interface ListApiListScormsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListScorms
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListScorms
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListScorms
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListScorms
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ListApiListScorms
     */
    readonly search?: string

    /**
     * Filters scorm files
     * @type {number}
     * @memberof ListApiListScorms
     */
    readonly scormId?: number

    /**
     * 
     * @type {string}
     * @memberof ListApiListScorms
     */
    readonly state?: string
}

/**
 * Request parameters for listUsers operation in ListApi.
 * @export
 * @interface ListApiListUsersRequest
 */
export interface ListApiListUsersRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiListUsers
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiListUsers
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiListUsers
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiListUsers
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * The id of the agency.  This this will only be callable by admins
     * @type {number}
     * @memberof ListApiListUsers
     */
    readonly agencyId?: number

    /**
     * The id of the company.  This this will only be callable by admins and company managers
     * @type {number}
     * @memberof ListApiListUsers
     */
    readonly companyId?: number

    /**
     * The id of the location.  This this will only be callable by admins and company managers
     * @type {number}
     * @memberof ListApiListUsers
     */
    readonly locationId?: number

    /**
     * The id of the territory.  This will only be callable by admins and company managers
     * @type {number}
     * @memberof ListApiListUsers
     */
    readonly territoryId?: number

    /**
     * The id of the company.  This this will only be callable by admins and company managers
     * @type {number}
     * @memberof ListApiListUsers
     */
    readonly userId?: number

    /**
     * The status of the user.  This this will only be callable by admins and company managers
     * @type {UserStatus}
     * @memberof ListApiListUsers
     */
    readonly status?: UserStatus

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ListApiListUsers
     */
    readonly search?: string

    /**
     * Only show users that have at least one project
     * @type {boolean}
     * @memberof ListApiListUsers
     */
    readonly withProjects?: boolean

    /**
     * The role the user belongs to.
     * @type {UserRole}
     * @memberof ListApiListUsers
     */
    readonly role?: UserRole
}

/**
 * Request parameters for locationsFilter operation in ListApi.
 * @export
 * @interface ListApiLocationsFilterRequest
 */
export interface ListApiLocationsFilterRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ListApiLocationsFilter
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ListApiLocationsFilter
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ListApiLocationsFilter
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ListApiLocationsFilter
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * The id of the company.  This this will only be callable by admins and company managers
     * @type {number}
     * @memberof ListApiLocationsFilter
     */
    readonly companyId?: number

    /**
     * Search for a location by fulltext
     * @type {string}
     * @memberof ListApiLocationsFilter
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof ListApiLocationsFilter
     */
    readonly locationId?: number

    /**
     * 
     * @type {string}
     * @memberof ListApiLocationsFilter
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ListApiLocationsFilter
     */
    readonly state?: string

    /**
     * Filters locations by territory id
     * @type {number}
     * @memberof ListApiLocationsFilter
     */
    readonly territoryId?: number
}

/**
 * ListApi - object-oriented interface
 * @export
 * @class ListApi
 * @extends {BaseAPI}
 */
export class ListApi extends BaseAPI implements ListApiInterface {
    /**
     * Fetch a list of resources counts groupped by topic. 
     * @summary Get Resources Dashboard
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public getResourcesDashboard(requestParameters?: undefined, options?: any) {
        const request = ListApiFp(this.configuration).getResourcesDashboard(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of agencies.  This route only is available to symmons admins 
     * @summary List Agencies
     * @param {ListApiListAgenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listAgencies(requestParameters: ListApiListAgenciesRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listAgencies(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of agency goals.  This route is only available to symmons admins 
     * @summary List Agency Goals
     * @param {ListApiListAgencyGoalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listAgencyGoals(requestParameters: ListApiListAgencyGoalsRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listAgencyGoals(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of companies.  This route only is available to symmons admins 
     * @summary List Companies
     * @param {ListApiListCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listCompanies(requestParameters: ListApiListCompaniesRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listCompanies(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of files.  Each file has ownership and visibility settings. 
     * @summary List Files
     * @param {ListApiListFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listFiles(requestParameters: ListApiListFilesRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listFiles(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of introductions. 
     * @summary List Introductions
     * @param {ListApiListIntroductionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listIntroductions(requestParameters: ListApiListIntroductionsRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listIntroductions(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of locations 
     * @summary List Locations
     * @param {ListApiListLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listLocations(requestParameters: ListApiListLocationsRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listLocations(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a paginated list of orders for an event 
     * @summary Order events list
     * @param {ListApiListOrderEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listOrderEvents(requestParameters: ListApiListOrderEventsRequest, options?: any) {
        const request = ListApiFp(this.configuration).listOrderEvents(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of orders.  This will either fetch the orders for the current user, or the list of orders for all customers, if you are an admin 
     * @summary List Orders
     * @param {ListApiListOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listOrders(requestParameters: ListApiListOrdersRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listOrders(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of projects. 
     * @summary List Projects
     * @param {ListApiListProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listProjects(requestParameters: ListApiListProjectsRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listProjects(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of quote requests. 
     * @summary List Quote Requests
     * @param {ListApiListQuotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listQuotes(requestParameters: ListApiListQuotesRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listQuotes(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of regions with their associated territories 
     * @summary List Regions
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listRegions(requestParameters?: undefined, options?: any) {
        const request = ListApiFp(this.configuration).listRegions(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of resource categories. 
     * @summary List Resource Categories
     * @param {ListApiListResourceCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listResourceCategories(requestParameters: ListApiListResourceCategoriesRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listResourceCategories(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of resources. 
     * @summary List Resources
     * @param {ListApiListResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listResources(requestParameters: ListApiListResourcesRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listResources(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
     * @summary List Salesforce Customers
     * @param {ListApiListSalesforceCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listSalesforceCustomers(requestParameters: ListApiListSalesforceCustomersRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listSalesforceCustomers(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
     * @summary List Salesforce opportunities
     * @param {ListApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listSalesforceOpportunities(requestParameters: ListApiListSalesforceOpportunitiesRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listSalesforceOpportunities(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of scorms.  This route only is available to symmons admins 
     * @summary List Scorms
     * @param {ListApiListScormsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listScorms(requestParameters: ListApiListScormsRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listScorms(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of territories with their associated regions 
     * @summary List Territories
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listTerritories(requestParameters?: undefined, options?: any) {
        const request = ListApiFp(this.configuration).listTerritories(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of users, open only to admins and managers 
     * @summary List users
     * @param {ListApiListUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public listUsers(requestParameters: ListApiListUsersRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).listUsers(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a list of locations to use in a filter 
     * @summary List Locations
     * @param {ListApiLocationsFilterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListApi
     */
    public locationsFilter(requestParameters: ListApiLocationsFilterRequest = {}, options?: any) {
        const request = ListApiFp(this.configuration).locationsFilter(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * LocationApi - axios parameter creator
 * @export
 */
export const LocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a location with a specific id 
         * @summary Delete Location
         * @param {number} locationId The id of the location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation: (locationId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteLocation', 'locationId', locationId)
            const localVarPath = `/location/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single location by id 
         * @summary Get Location
         * @param {number} locationId The id of the location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation: (locationId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLocation', 'locationId', locationId)
            const localVarPath = `/location/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of locations 
         * @summary List Locations
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {number} [companyId] The id of the company.  This this will only be callable by admins and company managers
         * @param {string} [search] Search for a location by fulltext
         * @param {number} [locationId] 
         * @param {string} [name] 
         * @param {string} [state] 
         * @param {number} [salesRepId] Filters locations by sales rep id
         * @param {number} [territoryId] Filters locations by territory id
         * @param {boolean} [unrestricted] When true, sales reps are not limited to their territory or assignments (admins are always unrestricted). Intended for trusted flows such as the price sheet picker.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', companyId?: number, search?: string, locationId?: number, name?: string, state?: string, salesRepId?: number, territoryId?: number, unrestricted?: boolean, options: any = {}): RequestArgs => {
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (salesRepId !== undefined) {
                localVarQueryParameter['sales_rep_id'] = salesRepId;
            }

            if (territoryId !== undefined) {
                localVarQueryParameter['territory_id'] = territoryId;
            }

            if (unrestricted !== undefined) {
                localVarQueryParameter['unrestricted'] = unrestricted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of locations to use in a filter 
         * @summary List Locations
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {number} [companyId] The id of the company.  This this will only be callable by admins and company managers
         * @param {string} [search] Search for a location by fulltext
         * @param {number} [locationId] 
         * @param {string} [name] 
         * @param {string} [state] 
         * @param {number} [territoryId] Filters locations by territory id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsFilter: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', companyId?: number, search?: string, locationId?: number, name?: string, state?: string, territoryId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/locations/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (territoryId !== undefined) {
                localVarQueryParameter['territory_id'] = territoryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a location with a specific id 
         * @summary Update Location
         * @param {number} locationId The id of the location
         * @param {UpdateLocationBody} updateLocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: (locationId: number, updateLocationBody: UpdateLocationBody, options: any = {}): RequestArgs => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateLocation', 'locationId', locationId)
            // verify required parameter 'updateLocationBody' is not null or undefined
            assertParamExists('updateLocation', 'updateLocationBody', updateLocationBody)
            const localVarPath = `/location/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationApi - functional programming interface
 * @export
 */
export const LocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a location with a specific id 
         * @summary Delete Location
         * @param {LocationApiDeleteLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation(requestParameters: LocationApiDeleteLocationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteLocation(requestParameters.locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single location by id 
         * @summary Get Location
         * @param {LocationApiGetLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation(requestParameters: LocationApiGetLocationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Location>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getLocation(requestParameters.locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of locations 
         * @summary List Locations
         * @param {LocationApiListLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations(requestParameters: LocationApiListLocationsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedLocations>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listLocations(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.companyId, requestParameters.search, requestParameters.locationId, requestParameters.name, requestParameters.state, requestParameters.salesRepId, requestParameters.territoryId, requestParameters.unrestricted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a list of locations to use in a filter 
         * @summary List Locations
         * @param {LocationApiLocationsFilterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsFilter(requestParameters: LocationApiLocationsFilterRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedLocations>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.locationsFilter(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.companyId, requestParameters.search, requestParameters.locationId, requestParameters.name, requestParameters.state, requestParameters.territoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a location with a specific id 
         * @summary Update Location
         * @param {LocationApiUpdateLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(requestParameters: LocationApiUpdateLocationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Location>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateLocation(requestParameters.locationId, requestParameters.updateLocationBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationApi - factory interface
 * @export
 */
export const LocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationApiFp(configuration)

    /**
      * Delete a location with a specific id 
      * @summary Delete Location
      * @param {LocationApiDeleteLocationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteLocation = (requestParameters: LocationApiDeleteLocationRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteLocation(requestParameters, options);
        return request(axios, basePath);
    };

    deleteLocation.getQueryKey = (requestParameters: LocationApiDeleteLocationRequest, options?: any) => {
        const request = localVarFp.deleteLocation(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single location by id 
      * @summary Get Location
      * @param {LocationApiGetLocationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getLocation = (requestParameters: LocationApiGetLocationRequest, options?: any): AxiosPromise<Location> => {
        const request = localVarFp.getLocation(requestParameters, options);
        return request(axios, basePath);
    };

    getLocation.getQueryKey = (requestParameters: LocationApiGetLocationRequest, options?: any) => {
        const request = localVarFp.getLocation(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of locations 
      * @summary List Locations
      * @param {LocationApiListLocationsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listLocations = (requestParameters: LocationApiListLocationsRequest = {}, options?: any): AxiosPromise<PaginatedLocations> => {
        const request = localVarFp.listLocations(requestParameters, options);
        return request(axios, basePath);
    };

    listLocations.getQueryKey = (requestParameters: LocationApiListLocationsRequest = {}, options?: any) => {
        const request = localVarFp.listLocations(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a list of locations to use in a filter 
      * @summary List Locations
      * @param {LocationApiLocationsFilterRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const locationsFilter = (requestParameters: LocationApiLocationsFilterRequest = {}, options?: any): AxiosPromise<PaginatedLocations> => {
        const request = localVarFp.locationsFilter(requestParameters, options);
        return request(axios, basePath);
    };

    locationsFilter.getQueryKey = (requestParameters: LocationApiLocationsFilterRequest = {}, options?: any) => {
        const request = localVarFp.locationsFilter(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a location with a specific id 
      * @summary Update Location
      * @param {LocationApiUpdateLocationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateLocation = (requestParameters: LocationApiUpdateLocationRequest, options?: any): AxiosPromise<Location> => {
        const request = localVarFp.updateLocation(requestParameters, options);
        return request(axios, basePath);
    };

    updateLocation.getQueryKey = (requestParameters: LocationApiUpdateLocationRequest, options?: any) => {
        const request = localVarFp.updateLocation(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        deleteLocation,
        getLocation,
        listLocations,
        locationsFilter,
        updateLocation,
    };
};

/**
 * LocationApi - interface
 * @export
 * @interface LocationApi
 */
export interface LocationApiInterface {
    /**
     * Delete a location with a specific id 
     * @summary Delete Location
     * @param {LocationApiDeleteLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApiInterface
     */
    deleteLocation(requestParameters: LocationApiDeleteLocationRequest, options?: any): AxiosPromise<void>;

    /**
     * Fetch a single location by id 
     * @summary Get Location
     * @param {LocationApiGetLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApiInterface
     */
    getLocation(requestParameters: LocationApiGetLocationRequest, options?: any): AxiosPromise<Location>;

    /**
     * Fetch a list of locations 
     * @summary List Locations
     * @param {LocationApiListLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApiInterface
     */
    listLocations(requestParameters?: LocationApiListLocationsRequest, options?: any): AxiosPromise<PaginatedLocations>;

    /**
     * Get a list of locations to use in a filter 
     * @summary List Locations
     * @param {LocationApiLocationsFilterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApiInterface
     */
    locationsFilter(requestParameters?: LocationApiLocationsFilterRequest, options?: any): AxiosPromise<PaginatedLocations>;

    /**
     * Update a location with a specific id 
     * @summary Update Location
     * @param {LocationApiUpdateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApiInterface
     */
    updateLocation(requestParameters: LocationApiUpdateLocationRequest, options?: any): AxiosPromise<Location>;

}

/**
 * Request parameters for deleteLocation operation in LocationApi.
 * @export
 * @interface LocationApiDeleteLocationRequest
 */
export interface LocationApiDeleteLocationRequest {
    /**
     * The id of the location
     * @type {number}
     * @memberof LocationApiDeleteLocation
     */
    readonly locationId: number
}

/**
 * Request parameters for getLocation operation in LocationApi.
 * @export
 * @interface LocationApiGetLocationRequest
 */
export interface LocationApiGetLocationRequest {
    /**
     * The id of the location
     * @type {number}
     * @memberof LocationApiGetLocation
     */
    readonly locationId: number
}

/**
 * Request parameters for listLocations operation in LocationApi.
 * @export
 * @interface LocationApiListLocationsRequest
 */
export interface LocationApiListLocationsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof LocationApiListLocations
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof LocationApiListLocations
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof LocationApiListLocations
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof LocationApiListLocations
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * The id of the company.  This this will only be callable by admins and company managers
     * @type {number}
     * @memberof LocationApiListLocations
     */
    readonly companyId?: number

    /**
     * Search for a location by fulltext
     * @type {string}
     * @memberof LocationApiListLocations
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof LocationApiListLocations
     */
    readonly locationId?: number

    /**
     * 
     * @type {string}
     * @memberof LocationApiListLocations
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof LocationApiListLocations
     */
    readonly state?: string

    /**
     * Filters locations by sales rep id
     * @type {number}
     * @memberof LocationApiListLocations
     */
    readonly salesRepId?: number

    /**
     * Filters locations by territory id
     * @type {number}
     * @memberof LocationApiListLocations
     */
    readonly territoryId?: number

    /**
     * When true, sales reps are not limited to their territory or assignments (admins are always unrestricted). Intended for trusted flows such as the price sheet picker.
     * @type {boolean}
     * @memberof LocationApiListLocations
     */
    readonly unrestricted?: boolean
}

/**
 * Request parameters for locationsFilter operation in LocationApi.
 * @export
 * @interface LocationApiLocationsFilterRequest
 */
export interface LocationApiLocationsFilterRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof LocationApiLocationsFilter
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof LocationApiLocationsFilter
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof LocationApiLocationsFilter
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof LocationApiLocationsFilter
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * The id of the company.  This this will only be callable by admins and company managers
     * @type {number}
     * @memberof LocationApiLocationsFilter
     */
    readonly companyId?: number

    /**
     * Search for a location by fulltext
     * @type {string}
     * @memberof LocationApiLocationsFilter
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof LocationApiLocationsFilter
     */
    readonly locationId?: number

    /**
     * 
     * @type {string}
     * @memberof LocationApiLocationsFilter
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof LocationApiLocationsFilter
     */
    readonly state?: string

    /**
     * Filters locations by territory id
     * @type {number}
     * @memberof LocationApiLocationsFilter
     */
    readonly territoryId?: number
}

/**
 * Request parameters for updateLocation operation in LocationApi.
 * @export
 * @interface LocationApiUpdateLocationRequest
 */
export interface LocationApiUpdateLocationRequest {
    /**
     * The id of the location
     * @type {number}
     * @memberof LocationApiUpdateLocation
     */
    readonly locationId: number

    /**
     * 
     * @type {UpdateLocationBody}
     * @memberof LocationApiUpdateLocation
     */
    readonly updateLocationBody: UpdateLocationBody
}

/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
export class LocationApi extends BaseAPI implements LocationApiInterface {
    /**
     * Delete a location with a specific id 
     * @summary Delete Location
     * @param {LocationApiDeleteLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public deleteLocation(requestParameters: LocationApiDeleteLocationRequest, options?: any) {
        const request = LocationApiFp(this.configuration).deleteLocation(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single location by id 
     * @summary Get Location
     * @param {LocationApiGetLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getLocation(requestParameters: LocationApiGetLocationRequest, options?: any) {
        const request = LocationApiFp(this.configuration).getLocation(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of locations 
     * @summary List Locations
     * @param {LocationApiListLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public listLocations(requestParameters: LocationApiListLocationsRequest = {}, options?: any) {
        const request = LocationApiFp(this.configuration).listLocations(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a list of locations to use in a filter 
     * @summary List Locations
     * @param {LocationApiLocationsFilterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationsFilter(requestParameters: LocationApiLocationsFilterRequest = {}, options?: any) {
        const request = LocationApiFp(this.configuration).locationsFilter(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a location with a specific id 
     * @summary Update Location
     * @param {LocationApiUpdateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public updateLocation(requestParameters: LocationApiUpdateLocationRequest, options?: any) {
        const request = LocationApiFp(this.configuration).updateLocation(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * LoginApi - axios parameter creator
 * @export
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint accepts a post body with application identification and a user identifier, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. This endpoint is used both for initial authentication and for subsequent renewals. It also can be used to validate a password reset token This endpoint will return a JSON web token which will be used in subsequent requests 
         * @summary Login & Refresh
         * @param {GetTokenBody} getTokenBody Parameters for getting an auth token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthToken: (getTokenBody: GetTokenBody, options: any = {}): RequestArgs => {
            // verify required parameter 'getTokenBody' is not null or undefined
            assertParamExists('getAuthToken', 'getTokenBody', getTokenBody)
            const localVarPath = `/oauth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTokenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint resends the 2FA code to the user\'s email 
         * @summary Resend 2FA Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTwoFactorCode: (options: any = {}): RequestArgs => {
            const localVarPath = `/auth/2fa/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint accepts a post body with a code and a user id, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. 
         * @summary Verify Two Factor
         * @param {VerifyTwoFactorBody} verifyTwoFactorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwoFactor: (verifyTwoFactorBody: VerifyTwoFactorBody, options: any = {}): RequestArgs => {
            // verify required parameter 'verifyTwoFactorBody' is not null or undefined
            assertParamExists('verifyTwoFactor', 'verifyTwoFactorBody', verifyTwoFactorBody)
            const localVarPath = `/auth/2fa/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyTwoFactorBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint accepts a post body with application identification and a user identifier, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. This endpoint is used both for initial authentication and for subsequent renewals. It also can be used to validate a password reset token This endpoint will return a JSON web token which will be used in subsequent requests 
         * @summary Login & Refresh
         * @param {LoginApiGetAuthTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthToken(requestParameters: LoginApiGetAuthTokenRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<GetTokenResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getAuthToken(requestParameters.getTokenBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint resends the 2FA code to the user\'s email 
         * @summary Resend 2FA Code
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTwoFactorCode(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.resendTwoFactorCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint accepts a post body with a code and a user id, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. 
         * @summary Verify Two Factor
         * @param {LoginApiVerifyTwoFactorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwoFactor(requestParameters: LoginApiVerifyTwoFactorRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<VerifyTwoFactorResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.verifyTwoFactor(requestParameters.verifyTwoFactorBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginApiFp(configuration)

    /**
      * This endpoint accepts a post body with application identification and a user identifier, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. This endpoint is used both for initial authentication and for subsequent renewals. It also can be used to validate a password reset token This endpoint will return a JSON web token which will be used in subsequent requests 
      * @summary Login & Refresh
      * @param {LoginApiGetAuthTokenRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getAuthToken = (requestParameters: LoginApiGetAuthTokenRequest, options?: any): AxiosPromise<GetTokenResponse> => {
        const request = localVarFp.getAuthToken(requestParameters, options);
        return request(axios, basePath);
    };

    getAuthToken.getQueryKey = (requestParameters: LoginApiGetAuthTokenRequest, options?: any) => {
        const request = localVarFp.getAuthToken(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * This endpoint resends the 2FA code to the user\'s email 
      * @summary Resend 2FA Code
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const resendTwoFactorCode = (requestParameters?: undefined, options?: any): AxiosPromise<void> => {
        const request = localVarFp.resendTwoFactorCode(requestParameters, options);
        return request(axios, basePath);
    };

    resendTwoFactorCode.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.resendTwoFactorCode(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * This endpoint accepts a post body with a code and a user id, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. 
      * @summary Verify Two Factor
      * @param {LoginApiVerifyTwoFactorRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const verifyTwoFactor = (requestParameters: LoginApiVerifyTwoFactorRequest, options?: any): AxiosPromise<VerifyTwoFactorResponse> => {
        const request = localVarFp.verifyTwoFactor(requestParameters, options);
        return request(axios, basePath);
    };

    verifyTwoFactor.getQueryKey = (requestParameters: LoginApiVerifyTwoFactorRequest, options?: any) => {
        const request = localVarFp.verifyTwoFactor(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        getAuthToken,
        resendTwoFactorCode,
        verifyTwoFactor,
    };
};

/**
 * LoginApi - interface
 * @export
 * @interface LoginApi
 */
export interface LoginApiInterface {
    /**
     * This endpoint accepts a post body with application identification and a user identifier, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. This endpoint is used both for initial authentication and for subsequent renewals. It also can be used to validate a password reset token This endpoint will return a JSON web token which will be used in subsequent requests 
     * @summary Login & Refresh
     * @param {LoginApiGetAuthTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApiInterface
     */
    getAuthToken(requestParameters: LoginApiGetAuthTokenRequest, options?: any): AxiosPromise<GetTokenResponse>;

    /**
     * This endpoint resends the 2FA code to the user\'s email 
     * @summary Resend 2FA Code
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApiInterface
     */
    resendTwoFactorCode(requestParameters?: undefined, options?: any): AxiosPromise<void>;

    /**
     * This endpoint accepts a post body with a code and a user id, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. 
     * @summary Verify Two Factor
     * @param {LoginApiVerifyTwoFactorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApiInterface
     */
    verifyTwoFactor(requestParameters: LoginApiVerifyTwoFactorRequest, options?: any): AxiosPromise<VerifyTwoFactorResponse>;

}

/**
 * Request parameters for getAuthToken operation in LoginApi.
 * @export
 * @interface LoginApiGetAuthTokenRequest
 */
export interface LoginApiGetAuthTokenRequest {
    /**
     * Parameters for getting an auth token
     * @type {GetTokenBody}
     * @memberof LoginApiGetAuthToken
     */
    readonly getTokenBody: GetTokenBody
}

/**
 * Request parameters for verifyTwoFactor operation in LoginApi.
 * @export
 * @interface LoginApiVerifyTwoFactorRequest
 */
export interface LoginApiVerifyTwoFactorRequest {
    /**
     * 
     * @type {VerifyTwoFactorBody}
     * @memberof LoginApiVerifyTwoFactor
     */
    readonly verifyTwoFactorBody: VerifyTwoFactorBody
}

/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI implements LoginApiInterface {
    /**
     * This endpoint accepts a post body with application identification and a user identifier, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. This endpoint is used both for initial authentication and for subsequent renewals. It also can be used to validate a password reset token This endpoint will return a JSON web token which will be used in subsequent requests 
     * @summary Login & Refresh
     * @param {LoginApiGetAuthTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public getAuthToken(requestParameters: LoginApiGetAuthTokenRequest, options?: any) {
        const request = LoginApiFp(this.configuration).getAuthToken(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * This endpoint resends the 2FA code to the user\'s email 
     * @summary Resend 2FA Code
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public resendTwoFactorCode(requestParameters?: undefined, options?: any) {
        const request = LoginApiFp(this.configuration).resendTwoFactorCode(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * This endpoint accepts a post body with a code and a user id, and returns a token if the authentication is valid, or a 401 if the token is invalid for some reason. 
     * @summary Verify Two Factor
     * @param {LoginApiVerifyTwoFactorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public verifyTwoFactor(requestParameters: LoginApiVerifyTwoFactorRequest, options?: any) {
        const request = LoginApiFp(this.configuration).verifyTwoFactor(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * OpportunitiesApi - axios parameter creator
 * @export
 */
export const OpportunitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a single salesforce opportunity by id 
         * @summary Get a single Salesforce opportunity
         * @param {number} id The id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceOpportunity: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesforceOpportunity', 'id', id)
            const localVarPath = `/salesforce/opportunity/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
         * @summary List Salesforce opportunities
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of salesforce customer opportunities the current user has access to.
         * @param {number} [salesforceCustomerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceOpportunities: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, salesforceCustomerId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/salesforce/opportunities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (salesforceCustomerId !== undefined) {
                localVarQueryParameter['salesforce_customer_id'] = salesforceCustomerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fire a background task to fetch all the salesforce data from the last two days 
         * @summary Refresh the salesforce data
         * @param {string} id The salesforce id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSalesforce: (id: string, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshSalesforce', 'id', id)
            const localVarPath = `/salesforce/refresh`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single salesforce customer while resyncing the customer from the db 
         * @summary Sync a single Salesforce opportunity
         * @param {string} id The salesforce id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceOpportunity: (id: string, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('syncSalesforceOpportunity', 'id', id)
            const localVarPath = `/salesforce/opportunity/{id}/sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OpportunitiesApi - functional programming interface
 * @export
 */
export const OpportunitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OpportunitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a single salesforce opportunity by id 
         * @summary Get a single Salesforce opportunity
         * @param {OpportunitiesApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceOpportunity(requestParameters: OpportunitiesApiGetSalesforceOpportunityRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceOpportunity>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getSalesforceOpportunity(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
         * @summary List Salesforce opportunities
         * @param {OpportunitiesApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceOpportunities(requestParameters: OpportunitiesApiListSalesforceOpportunitiesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedSalesforceOpportunities>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listSalesforceOpportunities(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.salesforceCustomerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fire a background task to fetch all the salesforce data from the last two days 
         * @summary Refresh the salesforce data
         * @param {OpportunitiesApiRefreshSalesforceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSalesforce(requestParameters: OpportunitiesApiRefreshSalesforceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.refreshSalesforce(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single salesforce customer while resyncing the customer from the db 
         * @summary Sync a single Salesforce opportunity
         * @param {OpportunitiesApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceOpportunity(requestParameters: OpportunitiesApiSyncSalesforceOpportunityRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceOpportunity>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.syncSalesforceOpportunity(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OpportunitiesApi - factory interface
 * @export
 */
export const OpportunitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OpportunitiesApiFp(configuration)

    /**
      * Fetch a single salesforce opportunity by id 
      * @summary Get a single Salesforce opportunity
      * @param {OpportunitiesApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getSalesforceOpportunity = (requestParameters: OpportunitiesApiGetSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity> => {
        const request = localVarFp.getSalesforceOpportunity(requestParameters, options);
        return request(axios, basePath);
    };

    getSalesforceOpportunity.getQueryKey = (requestParameters: OpportunitiesApiGetSalesforceOpportunityRequest, options?: any) => {
        const request = localVarFp.getSalesforceOpportunity(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
      * @summary List Salesforce opportunities
      * @param {OpportunitiesApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listSalesforceOpportunities = (requestParameters: OpportunitiesApiListSalesforceOpportunitiesRequest = {}, options?: any): AxiosPromise<PaginatedSalesforceOpportunities> => {
        const request = localVarFp.listSalesforceOpportunities(requestParameters, options);
        return request(axios, basePath);
    };

    listSalesforceOpportunities.getQueryKey = (requestParameters: OpportunitiesApiListSalesforceOpportunitiesRequest = {}, options?: any) => {
        const request = localVarFp.listSalesforceOpportunities(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fire a background task to fetch all the salesforce data from the last two days 
      * @summary Refresh the salesforce data
      * @param {OpportunitiesApiRefreshSalesforceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const refreshSalesforce = (requestParameters: OpportunitiesApiRefreshSalesforceRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.refreshSalesforce(requestParameters, options);
        return request(axios, basePath);
    };

    refreshSalesforce.getQueryKey = (requestParameters: OpportunitiesApiRefreshSalesforceRequest, options?: any) => {
        const request = localVarFp.refreshSalesforce(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single salesforce customer while resyncing the customer from the db 
      * @summary Sync a single Salesforce opportunity
      * @param {OpportunitiesApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const syncSalesforceOpportunity = (requestParameters: OpportunitiesApiSyncSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity> => {
        const request = localVarFp.syncSalesforceOpportunity(requestParameters, options);
        return request(axios, basePath);
    };

    syncSalesforceOpportunity.getQueryKey = (requestParameters: OpportunitiesApiSyncSalesforceOpportunityRequest, options?: any) => {
        const request = localVarFp.syncSalesforceOpportunity(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        getSalesforceOpportunity,
        listSalesforceOpportunities,
        refreshSalesforce,
        syncSalesforceOpportunity,
    };
};

/**
 * OpportunitiesApi - interface
 * @export
 * @interface OpportunitiesApi
 */
export interface OpportunitiesApiInterface {
    /**
     * Fetch a single salesforce opportunity by id 
     * @summary Get a single Salesforce opportunity
     * @param {OpportunitiesApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunitiesApiInterface
     */
    getSalesforceOpportunity(requestParameters: OpportunitiesApiGetSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity>;

    /**
     * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
     * @summary List Salesforce opportunities
     * @param {OpportunitiesApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunitiesApiInterface
     */
    listSalesforceOpportunities(requestParameters?: OpportunitiesApiListSalesforceOpportunitiesRequest, options?: any): AxiosPromise<PaginatedSalesforceOpportunities>;

    /**
     * Fire a background task to fetch all the salesforce data from the last two days 
     * @summary Refresh the salesforce data
     * @param {OpportunitiesApiRefreshSalesforceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunitiesApiInterface
     */
    refreshSalesforce(requestParameters: OpportunitiesApiRefreshSalesforceRequest, options?: any): AxiosPromise<void>;

    /**
     * Fetch a single salesforce customer while resyncing the customer from the db 
     * @summary Sync a single Salesforce opportunity
     * @param {OpportunitiesApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunitiesApiInterface
     */
    syncSalesforceOpportunity(requestParameters: OpportunitiesApiSyncSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity>;

}

/**
 * Request parameters for getSalesforceOpportunity operation in OpportunitiesApi.
 * @export
 * @interface OpportunitiesApiGetSalesforceOpportunityRequest
 */
export interface OpportunitiesApiGetSalesforceOpportunityRequest {
    /**
     * The id of the customer
     * @type {number}
     * @memberof OpportunitiesApiGetSalesforceOpportunity
     */
    readonly id: number
}

/**
 * Request parameters for listSalesforceOpportunities operation in OpportunitiesApi.
 * @export
 * @interface OpportunitiesApiListSalesforceOpportunitiesRequest
 */
export interface OpportunitiesApiListSalesforceOpportunitiesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof OpportunitiesApiListSalesforceOpportunities
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof OpportunitiesApiListSalesforceOpportunities
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof OpportunitiesApiListSalesforceOpportunities
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof OpportunitiesApiListSalesforceOpportunities
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of salesforce customer opportunities the current user has access to.
     * @type {string}
     * @memberof OpportunitiesApiListSalesforceOpportunities
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof OpportunitiesApiListSalesforceOpportunities
     */
    readonly salesforceCustomerId?: number
}

/**
 * Request parameters for refreshSalesforce operation in OpportunitiesApi.
 * @export
 * @interface OpportunitiesApiRefreshSalesforceRequest
 */
export interface OpportunitiesApiRefreshSalesforceRequest {
    /**
     * The salesforce id of the customer
     * @type {string}
     * @memberof OpportunitiesApiRefreshSalesforce
     */
    readonly id: string
}

/**
 * Request parameters for syncSalesforceOpportunity operation in OpportunitiesApi.
 * @export
 * @interface OpportunitiesApiSyncSalesforceOpportunityRequest
 */
export interface OpportunitiesApiSyncSalesforceOpportunityRequest {
    /**
     * The salesforce id of the customer
     * @type {string}
     * @memberof OpportunitiesApiSyncSalesforceOpportunity
     */
    readonly id: string
}

/**
 * OpportunitiesApi - object-oriented interface
 * @export
 * @class OpportunitiesApi
 * @extends {BaseAPI}
 */
export class OpportunitiesApi extends BaseAPI implements OpportunitiesApiInterface {
    /**
     * Fetch a single salesforce opportunity by id 
     * @summary Get a single Salesforce opportunity
     * @param {OpportunitiesApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunitiesApi
     */
    public getSalesforceOpportunity(requestParameters: OpportunitiesApiGetSalesforceOpportunityRequest, options?: any) {
        const request = OpportunitiesApiFp(this.configuration).getSalesforceOpportunity(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
     * @summary List Salesforce opportunities
     * @param {OpportunitiesApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunitiesApi
     */
    public listSalesforceOpportunities(requestParameters: OpportunitiesApiListSalesforceOpportunitiesRequest = {}, options?: any) {
        const request = OpportunitiesApiFp(this.configuration).listSalesforceOpportunities(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fire a background task to fetch all the salesforce data from the last two days 
     * @summary Refresh the salesforce data
     * @param {OpportunitiesApiRefreshSalesforceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunitiesApi
     */
    public refreshSalesforce(requestParameters: OpportunitiesApiRefreshSalesforceRequest, options?: any) {
        const request = OpportunitiesApiFp(this.configuration).refreshSalesforce(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single salesforce customer while resyncing the customer from the db 
     * @summary Sync a single Salesforce opportunity
     * @param {OpportunitiesApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpportunitiesApi
     */
    public syncSalesforceOpportunity(requestParameters: OpportunitiesApiSyncSalesforceOpportunityRequest, options?: any) {
        const request = OpportunitiesApiFp(this.configuration).syncSalesforceOpportunity(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * OrderApi - axios parameter creator
 * @export
 */
export const OrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Request a change or return for an order 
         * @summary Request a change or a return
         * @param {number} id The id of the order
         * @param {RequestOrderChange} requestOrderChange Parameters for requesting an order change
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOrder: (id: number, requestOrderChange: RequestOrderChange, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeOrder', 'id', id)
            // verify required parameter 'requestOrderChange' is not null or undefined
            assertParamExists('changeOrder', 'requestOrderChange', requestOrderChange)
            const localVarPath = `/order/{id}/event`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestOrderChange, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the current invoice, or package of packing slips 
         * @summary Download Invoice
         * @param {number} id The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInvoice: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadInvoice', 'id', id)
            const localVarPath = `/order/{id}/invoice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the current packing slip, or package of packing slips 
         * @summary Download packing slip
         * @param {number} id The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPackSlip: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadPackSlip', 'id', id)
            const localVarPath = `/order/{id}/packing_slip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single order 
         * @summary Get Order
         * @param {number} id The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrder', 'id', id)
            const localVarPath = `/order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a paginated list of orders for an event 
         * @summary Order events list
         * @param {number} id The id of the order
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {RequestOrderChangeEventType} [type] Filter events by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrderEvents: (id: number, page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', type?: RequestOrderChangeEventType, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listOrderEvents', 'id', id)
            const localVarPath = `/order/{id}/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of orders.  This will either fetch the orders for the current user, or the list of orders for all customers, if you are an admin 
         * @summary List Orders
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {number} [companyId] Filter orders by company.  Ignored for non-admins.  Users will see only their own orders
         * @param {number} [locationId] Filter orders by location
         * @param {boolean} [wholesaler] Filter companies by wholesaler status
         * @param {boolean} [evolution] Filter companies by evolution status
         * @param {string} [orderNumber] Partial match filter on order number
         * @param {OrderStatus} [status] Filter orders by status
         * @param {string} [orderDateStart] Filter by order date, bound by start date
         * @param {string} [orderDateEnd] Filter by order date, bound by end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, companyId?: number, locationId?: number, wholesaler?: boolean, evolution?: boolean, orderNumber?: string, status?: OrderStatus, orderDateStart?: string, orderDateEnd?: string, options: any = {}): RequestArgs => {
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (wholesaler !== undefined) {
                localVarQueryParameter['wholesaler'] = wholesaler;
            }

            if (evolution !== undefined) {
                localVarQueryParameter['evolution'] = evolution;
            }

            if (orderNumber !== undefined) {
                localVarQueryParameter['order_number'] = orderNumber;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderDateStart !== undefined) {
                localVarQueryParameter['order_date_start'] = (orderDateStart as any instanceof Date) ?
                    (orderDateStart as any).toISOString() :
                    orderDateStart;
            }

            if (orderDateEnd !== undefined) {
                localVarQueryParameter['order_date_end'] = (orderDateEnd as any instanceof Date) ?
                    (orderDateEnd as any).toISOString() :
                    orderDateEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Links a quote or submitted order to a real order 
         * @summary Order a quote
         * @param {number} id The id of the quote
         * @param {OrderRequestBody} orderRequestBody Parameters for requesting a quote request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderQuote: (id: number, orderRequestBody: OrderRequestBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderQuote', 'id', id)
            // verify required parameter 'orderRequestBody' is not null or undefined
            assertParamExists('orderQuote', 'orderRequestBody', orderRequestBody)
            const localVarPath = `/quote/{id}/order`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If an order is stale, this will refresh the order from the upstream api 
         * @summary Refresh Order
         * @param {number} id The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshOrder: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshOrder', 'id', id)
            const localVarPath = `/order/{id}/refresh`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderApiAxiosParamCreator(configuration)
    return {
        /**
         * Request a change or return for an order 
         * @summary Request a change or a return
         * @param {OrderApiChangeOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOrder(requestParameters: OrderApiChangeOrderRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Order>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.changeOrder(requestParameters.id, requestParameters.requestOrderChange, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download the current invoice, or package of packing slips 
         * @summary Download Invoice
         * @param {OrderApiDownloadInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInvoice(requestParameters: OrderApiDownloadInvoiceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadInvoice(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download the current packing slip, or package of packing slips 
         * @summary Download packing slip
         * @param {OrderApiDownloadPackSlipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPackSlip(requestParameters: OrderApiDownloadPackSlipRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadPackSlip(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a single order 
         * @summary Get Order
         * @param {OrderApiGetOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder(requestParameters: OrderApiGetOrderRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Order>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getOrder(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a paginated list of orders for an event 
         * @summary Order events list
         * @param {OrderApiListOrderEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrderEvents(requestParameters: OrderApiListOrderEventsRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedOrderEvents>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listOrderEvents(requestParameters.id, requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of orders.  This will either fetch the orders for the current user, or the list of orders for all customers, if you are an admin 
         * @summary List Orders
         * @param {OrderApiListOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders(requestParameters: OrderApiListOrdersRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedOrders>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listOrders(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.companyId, requestParameters.locationId, requestParameters.wholesaler, requestParameters.evolution, requestParameters.orderNumber, requestParameters.status, requestParameters.orderDateStart, requestParameters.orderDateEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Links a quote or submitted order to a real order 
         * @summary Order a quote
         * @param {OrderApiOrderQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderQuote(requestParameters: OrderApiOrderQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Quote>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.orderQuote(requestParameters.id, requestParameters.orderRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * If an order is stale, this will refresh the order from the upstream api 
         * @summary Refresh Order
         * @param {OrderApiRefreshOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshOrder(requestParameters: OrderApiRefreshOrderRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Order>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.refreshOrder(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderApiFp(configuration)

    /**
      * Request a change or return for an order 
      * @summary Request a change or a return
      * @param {OrderApiChangeOrderRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const changeOrder = (requestParameters: OrderApiChangeOrderRequest, options?: any): AxiosPromise<Order> => {
        const request = localVarFp.changeOrder(requestParameters, options);
        return request(axios, basePath);
    };

    changeOrder.getQueryKey = (requestParameters: OrderApiChangeOrderRequest, options?: any) => {
        const request = localVarFp.changeOrder(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Download the current invoice, or package of packing slips 
      * @summary Download Invoice
      * @param {OrderApiDownloadInvoiceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadInvoice = (requestParameters: OrderApiDownloadInvoiceRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadInvoice(requestParameters, options);
        return request(axios, basePath);
    };

    downloadInvoice.getQueryKey = (requestParameters: OrderApiDownloadInvoiceRequest, options?: any) => {
        const request = localVarFp.downloadInvoice(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Download the current packing slip, or package of packing slips 
      * @summary Download packing slip
      * @param {OrderApiDownloadPackSlipRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadPackSlip = (requestParameters: OrderApiDownloadPackSlipRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadPackSlip(requestParameters, options);
        return request(axios, basePath);
    };

    downloadPackSlip.getQueryKey = (requestParameters: OrderApiDownloadPackSlipRequest, options?: any) => {
        const request = localVarFp.downloadPackSlip(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a single order 
      * @summary Get Order
      * @param {OrderApiGetOrderRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getOrder = (requestParameters: OrderApiGetOrderRequest, options?: any): AxiosPromise<Order> => {
        const request = localVarFp.getOrder(requestParameters, options);
        return request(axios, basePath);
    };

    getOrder.getQueryKey = (requestParameters: OrderApiGetOrderRequest, options?: any) => {
        const request = localVarFp.getOrder(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a paginated list of orders for an event 
      * @summary Order events list
      * @param {OrderApiListOrderEventsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listOrderEvents = (requestParameters: OrderApiListOrderEventsRequest, options?: any): AxiosPromise<PaginatedOrderEvents> => {
        const request = localVarFp.listOrderEvents(requestParameters, options);
        return request(axios, basePath);
    };

    listOrderEvents.getQueryKey = (requestParameters: OrderApiListOrderEventsRequest, options?: any) => {
        const request = localVarFp.listOrderEvents(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of orders.  This will either fetch the orders for the current user, or the list of orders for all customers, if you are an admin 
      * @summary List Orders
      * @param {OrderApiListOrdersRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listOrders = (requestParameters: OrderApiListOrdersRequest = {}, options?: any): AxiosPromise<PaginatedOrders> => {
        const request = localVarFp.listOrders(requestParameters, options);
        return request(axios, basePath);
    };

    listOrders.getQueryKey = (requestParameters: OrderApiListOrdersRequest = {}, options?: any) => {
        const request = localVarFp.listOrders(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Links a quote or submitted order to a real order 
      * @summary Order a quote
      * @param {OrderApiOrderQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const orderQuote = (requestParameters: OrderApiOrderQuoteRequest, options?: any): AxiosPromise<Quote> => {
        const request = localVarFp.orderQuote(requestParameters, options);
        return request(axios, basePath);
    };

    orderQuote.getQueryKey = (requestParameters: OrderApiOrderQuoteRequest, options?: any) => {
        const request = localVarFp.orderQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * If an order is stale, this will refresh the order from the upstream api 
      * @summary Refresh Order
      * @param {OrderApiRefreshOrderRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const refreshOrder = (requestParameters: OrderApiRefreshOrderRequest, options?: any): AxiosPromise<Order> => {
        const request = localVarFp.refreshOrder(requestParameters, options);
        return request(axios, basePath);
    };

    refreshOrder.getQueryKey = (requestParameters: OrderApiRefreshOrderRequest, options?: any) => {
        const request = localVarFp.refreshOrder(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        changeOrder,
        downloadInvoice,
        downloadPackSlip,
        getOrder,
        listOrderEvents,
        listOrders,
        orderQuote,
        refreshOrder,
    };
};

/**
 * OrderApi - interface
 * @export
 * @interface OrderApi
 */
export interface OrderApiInterface {
    /**
     * Request a change or return for an order 
     * @summary Request a change or a return
     * @param {OrderApiChangeOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    changeOrder(requestParameters: OrderApiChangeOrderRequest, options?: any): AxiosPromise<Order>;

    /**
     * Download the current invoice, or package of packing slips 
     * @summary Download Invoice
     * @param {OrderApiDownloadInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    downloadInvoice(requestParameters: OrderApiDownloadInvoiceRequest, options?: any): AxiosPromise<any>;

    /**
     * Download the current packing slip, or package of packing slips 
     * @summary Download packing slip
     * @param {OrderApiDownloadPackSlipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    downloadPackSlip(requestParameters: OrderApiDownloadPackSlipRequest, options?: any): AxiosPromise<any>;

    /**
     * Get a single order 
     * @summary Get Order
     * @param {OrderApiGetOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    getOrder(requestParameters: OrderApiGetOrderRequest, options?: any): AxiosPromise<Order>;

    /**
     * Get a paginated list of orders for an event 
     * @summary Order events list
     * @param {OrderApiListOrderEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    listOrderEvents(requestParameters: OrderApiListOrderEventsRequest, options?: any): AxiosPromise<PaginatedOrderEvents>;

    /**
     * Fetch a list of orders.  This will either fetch the orders for the current user, or the list of orders for all customers, if you are an admin 
     * @summary List Orders
     * @param {OrderApiListOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    listOrders(requestParameters?: OrderApiListOrdersRequest, options?: any): AxiosPromise<PaginatedOrders>;

    /**
     * Links a quote or submitted order to a real order 
     * @summary Order a quote
     * @param {OrderApiOrderQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    orderQuote(requestParameters: OrderApiOrderQuoteRequest, options?: any): AxiosPromise<Quote>;

    /**
     * If an order is stale, this will refresh the order from the upstream api 
     * @summary Refresh Order
     * @param {OrderApiRefreshOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApiInterface
     */
    refreshOrder(requestParameters: OrderApiRefreshOrderRequest, options?: any): AxiosPromise<Order>;

}

/**
 * Request parameters for changeOrder operation in OrderApi.
 * @export
 * @interface OrderApiChangeOrderRequest
 */
export interface OrderApiChangeOrderRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof OrderApiChangeOrder
     */
    readonly id: number

    /**
     * Parameters for requesting an order change
     * @type {RequestOrderChange}
     * @memberof OrderApiChangeOrder
     */
    readonly requestOrderChange: RequestOrderChange
}

/**
 * Request parameters for downloadInvoice operation in OrderApi.
 * @export
 * @interface OrderApiDownloadInvoiceRequest
 */
export interface OrderApiDownloadInvoiceRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof OrderApiDownloadInvoice
     */
    readonly id: number
}

/**
 * Request parameters for downloadPackSlip operation in OrderApi.
 * @export
 * @interface OrderApiDownloadPackSlipRequest
 */
export interface OrderApiDownloadPackSlipRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof OrderApiDownloadPackSlip
     */
    readonly id: number
}

/**
 * Request parameters for getOrder operation in OrderApi.
 * @export
 * @interface OrderApiGetOrderRequest
 */
export interface OrderApiGetOrderRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof OrderApiGetOrder
     */
    readonly id: number
}

/**
 * Request parameters for listOrderEvents operation in OrderApi.
 * @export
 * @interface OrderApiListOrderEventsRequest
 */
export interface OrderApiListOrderEventsRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof OrderApiListOrderEvents
     */
    readonly id: number

    /**
     * The page number of results
     * @type {number}
     * @memberof OrderApiListOrderEvents
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof OrderApiListOrderEvents
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof OrderApiListOrderEvents
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof OrderApiListOrderEvents
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Filter events by type
     * @type {RequestOrderChangeEventType}
     * @memberof OrderApiListOrderEvents
     */
    readonly type?: RequestOrderChangeEventType
}

/**
 * Request parameters for listOrders operation in OrderApi.
 * @export
 * @interface OrderApiListOrdersRequest
 */
export interface OrderApiListOrdersRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof OrderApiListOrders
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof OrderApiListOrders
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof OrderApiListOrders
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof OrderApiListOrders
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof OrderApiListOrders
     */
    readonly search?: string

    /**
     * Filter orders by company.  Ignored for non-admins.  Users will see only their own orders
     * @type {number}
     * @memberof OrderApiListOrders
     */
    readonly companyId?: number

    /**
     * Filter orders by location
     * @type {number}
     * @memberof OrderApiListOrders
     */
    readonly locationId?: number

    /**
     * Filter companies by wholesaler status
     * @type {boolean}
     * @memberof OrderApiListOrders
     */
    readonly wholesaler?: boolean

    /**
     * Filter companies by evolution status
     * @type {boolean}
     * @memberof OrderApiListOrders
     */
    readonly evolution?: boolean

    /**
     * Partial match filter on order number
     * @type {string}
     * @memberof OrderApiListOrders
     */
    readonly orderNumber?: string

    /**
     * Filter orders by status
     * @type {OrderStatus}
     * @memberof OrderApiListOrders
     */
    readonly status?: OrderStatus

    /**
     * Filter by order date, bound by start date
     * @type {string}
     * @memberof OrderApiListOrders
     */
    readonly orderDateStart?: string

    /**
     * Filter by order date, bound by end date
     * @type {string}
     * @memberof OrderApiListOrders
     */
    readonly orderDateEnd?: string
}

/**
 * Request parameters for orderQuote operation in OrderApi.
 * @export
 * @interface OrderApiOrderQuoteRequest
 */
export interface OrderApiOrderQuoteRequest {
    /**
     * The id of the quote
     * @type {number}
     * @memberof OrderApiOrderQuote
     */
    readonly id: number

    /**
     * Parameters for requesting a quote request
     * @type {OrderRequestBody}
     * @memberof OrderApiOrderQuote
     */
    readonly orderRequestBody: OrderRequestBody
}

/**
 * Request parameters for refreshOrder operation in OrderApi.
 * @export
 * @interface OrderApiRefreshOrderRequest
 */
export interface OrderApiRefreshOrderRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof OrderApiRefreshOrder
     */
    readonly id: number
}

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI implements OrderApiInterface {
    /**
     * Request a change or return for an order 
     * @summary Request a change or a return
     * @param {OrderApiChangeOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public changeOrder(requestParameters: OrderApiChangeOrderRequest, options?: any) {
        const request = OrderApiFp(this.configuration).changeOrder(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Download the current invoice, or package of packing slips 
     * @summary Download Invoice
     * @param {OrderApiDownloadInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public downloadInvoice(requestParameters: OrderApiDownloadInvoiceRequest, options?: any) {
        const request = OrderApiFp(this.configuration).downloadInvoice(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Download the current packing slip, or package of packing slips 
     * @summary Download packing slip
     * @param {OrderApiDownloadPackSlipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public downloadPackSlip(requestParameters: OrderApiDownloadPackSlipRequest, options?: any) {
        const request = OrderApiFp(this.configuration).downloadPackSlip(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a single order 
     * @summary Get Order
     * @param {OrderApiGetOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getOrder(requestParameters: OrderApiGetOrderRequest, options?: any) {
        const request = OrderApiFp(this.configuration).getOrder(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a paginated list of orders for an event 
     * @summary Order events list
     * @param {OrderApiListOrderEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public listOrderEvents(requestParameters: OrderApiListOrderEventsRequest, options?: any) {
        const request = OrderApiFp(this.configuration).listOrderEvents(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of orders.  This will either fetch the orders for the current user, or the list of orders for all customers, if you are an admin 
     * @summary List Orders
     * @param {OrderApiListOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public listOrders(requestParameters: OrderApiListOrdersRequest = {}, options?: any) {
        const request = OrderApiFp(this.configuration).listOrders(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Links a quote or submitted order to a real order 
     * @summary Order a quote
     * @param {OrderApiOrderQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderQuote(requestParameters: OrderApiOrderQuoteRequest, options?: any) {
        const request = OrderApiFp(this.configuration).orderQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * If an order is stale, this will refresh the order from the upstream api 
     * @summary Refresh Order
     * @param {OrderApiRefreshOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public refreshOrder(requestParameters: OrderApiRefreshOrderRequest, options?: any) {
        const request = OrderApiFp(this.configuration).refreshOrder(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * PricesheetApi - axios parameter creator
 * @export
 */
export const PricesheetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allows an admin to create a price sheet 
         * @summary Create Price Sheet
         * @param {number} [locationId] The location to use for the price sheet.  Only required if the user doesn\&#39;t have a location (eg multiple locations - admin, salesrep, company manager)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriceSheet: (locationId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/pricesheet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a price sheet
         * @param {number} pricesheetId The id of the price sheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriceSheet: (pricesheetId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'pricesheetId' is not null or undefined
            assertParamExists('deletePriceSheet', 'pricesheetId', pricesheetId)
            const localVarPath = `/pricesheet/{pricesheet_id}`
                .replace(`{${"pricesheet_id"}}`, encodeURIComponent(String(pricesheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single price sheet by id 
         * @summary Get PriceSheet
         * @param {number} pricesheetId The id of the price sheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceSheet: (pricesheetId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'pricesheetId' is not null or undefined
            assertParamExists('getPriceSheet', 'pricesheetId', pricesheetId)
            const localVarPath = `/pricesheet/{pricesheet_id}`
                .replace(`{${"pricesheet_id"}}`, encodeURIComponent(String(pricesheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of the price sheet requests the current user has made 
         * @summary List Price Sheets
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [user] 
         * @param {PriceSheetStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPriceSheets: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', user?: string, status?: PriceSheetStatus, options: any = {}): RequestArgs => {
            const localVarPath = `/pricesheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PricesheetApi - functional programming interface
 * @export
 */
export const PricesheetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PricesheetApiAxiosParamCreator(configuration)
    return {
        /**
         * Allows an admin to create a price sheet 
         * @summary Create Price Sheet
         * @param {PricesheetApiCreatePriceSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriceSheet(requestParameters: PricesheetApiCreatePriceSheetRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PriceSheet>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createPriceSheet(requestParameters.locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a price sheet
         * @param {PricesheetApiDeletePriceSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriceSheet(requestParameters: PricesheetApiDeletePriceSheetRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deletePriceSheet(requestParameters.pricesheetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single price sheet by id 
         * @summary Get PriceSheet
         * @param {PricesheetApiGetPriceSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceSheet(requestParameters: PricesheetApiGetPriceSheetRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PriceSheet>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getPriceSheet(requestParameters.pricesheetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a list of the price sheet requests the current user has made 
         * @summary List Price Sheets
         * @param {PricesheetApiListPriceSheetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPriceSheets(requestParameters: PricesheetApiListPriceSheetsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedPriceSheets>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listPriceSheets(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.user, requestParameters.status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PricesheetApi - factory interface
 * @export
 */
export const PricesheetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PricesheetApiFp(configuration)

    /**
      * Allows an admin to create a price sheet 
      * @summary Create Price Sheet
      * @param {PricesheetApiCreatePriceSheetRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createPriceSheet = (requestParameters: PricesheetApiCreatePriceSheetRequest = {}, options?: any): AxiosPromise<PriceSheet> => {
        const request = localVarFp.createPriceSheet(requestParameters, options);
        return request(axios, basePath);
    };

    createPriceSheet.getQueryKey = (requestParameters: PricesheetApiCreatePriceSheetRequest = {}, options?: any) => {
        const request = localVarFp.createPriceSheet(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a user with a specific id 
      * @summary Delete a price sheet
      * @param {PricesheetApiDeletePriceSheetRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deletePriceSheet = (requestParameters: PricesheetApiDeletePriceSheetRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deletePriceSheet(requestParameters, options);
        return request(axios, basePath);
    };

    deletePriceSheet.getQueryKey = (requestParameters: PricesheetApiDeletePriceSheetRequest, options?: any) => {
        const request = localVarFp.deletePriceSheet(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single price sheet by id 
      * @summary Get PriceSheet
      * @param {PricesheetApiGetPriceSheetRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getPriceSheet = (requestParameters: PricesheetApiGetPriceSheetRequest, options?: any): AxiosPromise<PriceSheet> => {
        const request = localVarFp.getPriceSheet(requestParameters, options);
        return request(axios, basePath);
    };

    getPriceSheet.getQueryKey = (requestParameters: PricesheetApiGetPriceSheetRequest, options?: any) => {
        const request = localVarFp.getPriceSheet(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a list of the price sheet requests the current user has made 
      * @summary List Price Sheets
      * @param {PricesheetApiListPriceSheetsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listPriceSheets = (requestParameters: PricesheetApiListPriceSheetsRequest = {}, options?: any): AxiosPromise<PaginatedPriceSheets> => {
        const request = localVarFp.listPriceSheets(requestParameters, options);
        return request(axios, basePath);
    };

    listPriceSheets.getQueryKey = (requestParameters: PricesheetApiListPriceSheetsRequest = {}, options?: any) => {
        const request = localVarFp.listPriceSheets(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createPriceSheet,
        deletePriceSheet,
        getPriceSheet,
        listPriceSheets,
    };
};

/**
 * PricesheetApi - interface
 * @export
 * @interface PricesheetApi
 */
export interface PricesheetApiInterface {
    /**
     * Allows an admin to create a price sheet 
     * @summary Create Price Sheet
     * @param {PricesheetApiCreatePriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricesheetApiInterface
     */
    createPriceSheet(requestParameters?: PricesheetApiCreatePriceSheetRequest, options?: any): AxiosPromise<PriceSheet>;

    /**
     * Delete a user with a specific id 
     * @summary Delete a price sheet
     * @param {PricesheetApiDeletePriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricesheetApiInterface
     */
    deletePriceSheet(requestParameters: PricesheetApiDeletePriceSheetRequest, options?: any): AxiosPromise<void>;

    /**
     * Fetch a single price sheet by id 
     * @summary Get PriceSheet
     * @param {PricesheetApiGetPriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricesheetApiInterface
     */
    getPriceSheet(requestParameters: PricesheetApiGetPriceSheetRequest, options?: any): AxiosPromise<PriceSheet>;

    /**
     * Get a list of the price sheet requests the current user has made 
     * @summary List Price Sheets
     * @param {PricesheetApiListPriceSheetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricesheetApiInterface
     */
    listPriceSheets(requestParameters?: PricesheetApiListPriceSheetsRequest, options?: any): AxiosPromise<PaginatedPriceSheets>;

}

/**
 * Request parameters for createPriceSheet operation in PricesheetApi.
 * @export
 * @interface PricesheetApiCreatePriceSheetRequest
 */
export interface PricesheetApiCreatePriceSheetRequest {
    /**
     * The location to use for the price sheet.  Only required if the user doesn\&#39;t have a location (eg multiple locations - admin, salesrep, company manager)
     * @type {number}
     * @memberof PricesheetApiCreatePriceSheet
     */
    readonly locationId?: number
}

/**
 * Request parameters for deletePriceSheet operation in PricesheetApi.
 * @export
 * @interface PricesheetApiDeletePriceSheetRequest
 */
export interface PricesheetApiDeletePriceSheetRequest {
    /**
     * The id of the price sheet
     * @type {number}
     * @memberof PricesheetApiDeletePriceSheet
     */
    readonly pricesheetId: number
}

/**
 * Request parameters for getPriceSheet operation in PricesheetApi.
 * @export
 * @interface PricesheetApiGetPriceSheetRequest
 */
export interface PricesheetApiGetPriceSheetRequest {
    /**
     * The id of the price sheet
     * @type {number}
     * @memberof PricesheetApiGetPriceSheet
     */
    readonly pricesheetId: number
}

/**
 * Request parameters for listPriceSheets operation in PricesheetApi.
 * @export
 * @interface PricesheetApiListPriceSheetsRequest
 */
export interface PricesheetApiListPriceSheetsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof PricesheetApiListPriceSheets
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof PricesheetApiListPriceSheets
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof PricesheetApiListPriceSheets
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof PricesheetApiListPriceSheets
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * 
     * @type {string}
     * @memberof PricesheetApiListPriceSheets
     */
    readonly user?: string

    /**
     * 
     * @type {PriceSheetStatus}
     * @memberof PricesheetApiListPriceSheets
     */
    readonly status?: PriceSheetStatus
}

/**
 * PricesheetApi - object-oriented interface
 * @export
 * @class PricesheetApi
 * @extends {BaseAPI}
 */
export class PricesheetApi extends BaseAPI implements PricesheetApiInterface {
    /**
     * Allows an admin to create a price sheet 
     * @summary Create Price Sheet
     * @param {PricesheetApiCreatePriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricesheetApi
     */
    public createPriceSheet(requestParameters: PricesheetApiCreatePriceSheetRequest = {}, options?: any) {
        const request = PricesheetApiFp(this.configuration).createPriceSheet(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a user with a specific id 
     * @summary Delete a price sheet
     * @param {PricesheetApiDeletePriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricesheetApi
     */
    public deletePriceSheet(requestParameters: PricesheetApiDeletePriceSheetRequest, options?: any) {
        const request = PricesheetApiFp(this.configuration).deletePriceSheet(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single price sheet by id 
     * @summary Get PriceSheet
     * @param {PricesheetApiGetPriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricesheetApi
     */
    public getPriceSheet(requestParameters: PricesheetApiGetPriceSheetRequest, options?: any) {
        const request = PricesheetApiFp(this.configuration).getPriceSheet(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a list of the price sheet requests the current user has made 
     * @summary List Price Sheets
     * @param {PricesheetApiListPriceSheetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricesheetApi
     */
    public listPriceSheets(requestParameters: PricesheetApiListPriceSheetsRequest = {}, options?: any) {
        const request = PricesheetApiFp(this.configuration).listPriceSheets(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * PricingApi - axios parameter creator
 * @export
 */
export const PricingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch the pricing for a product for the current user 
         * @summary Get Pricing
         * @param {string} modelNumber The product model number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricing: (modelNumber: string, options: any = {}): RequestArgs => {
            // verify required parameter 'modelNumber' is not null or undefined
            assertParamExists('getPricing', 'modelNumber', modelNumber)
            const localVarPath = `/pricing/{model_number}`
                .replace(`{${"model_number"}}`, encodeURIComponent(String(modelNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PricingApi - functional programming interface
 * @export
 */
export const PricingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PricingApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch the pricing for a product for the current user 
         * @summary Get Pricing
         * @param {PricingApiGetPricingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricing(requestParameters: PricingApiGetPricingRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<GetPricingResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getPricing(requestParameters.modelNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PricingApi - factory interface
 * @export
 */
export const PricingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PricingApiFp(configuration)

    /**
      * Fetch the pricing for a product for the current user 
      * @summary Get Pricing
      * @param {PricingApiGetPricingRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getPricing = (requestParameters: PricingApiGetPricingRequest, options?: any): AxiosPromise<GetPricingResponse> => {
        const request = localVarFp.getPricing(requestParameters, options);
        return request(axios, basePath);
    };

    getPricing.getQueryKey = (requestParameters: PricingApiGetPricingRequest, options?: any) => {
        const request = localVarFp.getPricing(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        getPricing,
    };
};

/**
 * PricingApi - interface
 * @export
 * @interface PricingApi
 */
export interface PricingApiInterface {
    /**
     * Fetch the pricing for a product for the current user 
     * @summary Get Pricing
     * @param {PricingApiGetPricingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApiInterface
     */
    getPricing(requestParameters: PricingApiGetPricingRequest, options?: any): AxiosPromise<GetPricingResponse>;

}

/**
 * Request parameters for getPricing operation in PricingApi.
 * @export
 * @interface PricingApiGetPricingRequest
 */
export interface PricingApiGetPricingRequest {
    /**
     * The product model number
     * @type {string}
     * @memberof PricingApiGetPricing
     */
    readonly modelNumber: string
}

/**
 * PricingApi - object-oriented interface
 * @export
 * @class PricingApi
 * @extends {BaseAPI}
 */
export class PricingApi extends BaseAPI implements PricingApiInterface {
    /**
     * Fetch the pricing for a product for the current user 
     * @summary Get Pricing
     * @param {PricingApiGetPricingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public getPricing(requestParameters: PricingApiGetPricingRequest, options?: any) {
        const request = PricingApiFp(this.configuration).getPricing(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search the product database.  This endpoint won\'t be used for the frontend app, but will be designed to support eventual product consumers 
         * @summary Search products
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of products records the current user has access to.
         * @param {string} [title] 
         * @param {string} [sku] 
         * @param {string} [status] 
         * @param {Array<string>} [categories] 
         * @param {Array<string>} [tiers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, title?: string, sku?: string, status?: string, categories?: Array<string>, tiers?: Array<string>, options: any = {}): RequestArgs => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (sku !== undefined) {
                localVarQueryParameter['sku'] = sku;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (categories) {
                localVarQueryParameter['categories[]'] = categories;
            }

            if (tiers) {
                localVarQueryParameter['tiers[]'] = tiers;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApiAxiosParamCreator(configuration)
    return {
        /**
         * Search the product database.  This endpoint won\'t be used for the frontend app, but will be designed to support eventual product consumers 
         * @summary Search products
         * @param {ProductApiListProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts(requestParameters: ProductApiListProductsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedProducts>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listProducts(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.title, requestParameters.sku, requestParameters.status, requestParameters.categories, requestParameters.tiers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApiFp(configuration)

    /**
      * Search the product database.  This endpoint won\'t be used for the frontend app, but will be designed to support eventual product consumers 
      * @summary Search products
      * @param {ProductApiListProductsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listProducts = (requestParameters: ProductApiListProductsRequest = {}, options?: any): AxiosPromise<PaginatedProducts> => {
        const request = localVarFp.listProducts(requestParameters, options);
        return request(axios, basePath);
    };

    listProducts.getQueryKey = (requestParameters: ProductApiListProductsRequest = {}, options?: any) => {
        const request = localVarFp.listProducts(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        listProducts,
    };
};

/**
 * ProductApi - interface
 * @export
 * @interface ProductApi
 */
export interface ProductApiInterface {
    /**
     * Search the product database.  This endpoint won\'t be used for the frontend app, but will be designed to support eventual product consumers 
     * @summary Search products
     * @param {ProductApiListProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApiInterface
     */
    listProducts(requestParameters?: ProductApiListProductsRequest, options?: any): AxiosPromise<PaginatedProducts>;

}

/**
 * Request parameters for listProducts operation in ProductApi.
 * @export
 * @interface ProductApiListProductsRequest
 */
export interface ProductApiListProductsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ProductApiListProducts
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ProductApiListProducts
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ProductApiListProducts
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ProductApiListProducts
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of products records the current user has access to.
     * @type {string}
     * @memberof ProductApiListProducts
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiListProducts
     */
    readonly title?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiListProducts
     */
    readonly sku?: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiListProducts
     */
    readonly status?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof ProductApiListProducts
     */
    readonly categories?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof ProductApiListProducts
     */
    readonly tiers?: Array<string>
}

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI implements ProductApiInterface {
    /**
     * Search the product database.  This endpoint won\'t be used for the frontend app, but will be designed to support eventual product consumers 
     * @summary Search products
     * @param {ProductApiListProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public listProducts(requestParameters: ProductApiListProductsRequest = {}, options?: any) {
        const request = ProductApiFp(this.configuration).listProducts(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ProjectApi - axios parameter creator
 * @export
 */
export const ProjectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a project.  This route will create a project and a new version.  Accepts pages, clients and blocks, but mostly these objects won\'t be available until some editing is done. 
         * @summary Create project
         * @param {ProjectUpdate} projectUpdate Request body for creating a project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: (projectUpdate: ProjectUpdate, options: any = {}): RequestArgs => {
            // verify required parameter 'projectUpdate' is not null or undefined
            assertParamExists('createProject', 'projectUpdate', projectUpdate)
            const localVarPath = `/project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a project with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Project
         * @param {number} id The id of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProject', 'id', id)
            const localVarPath = `/project/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a given id, if the project is published, stream the contents out with the right mime type to force the file to download 
         * @summary Download a published project
         * @param {number} id The id of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProject: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadProject', 'id', id)
            const localVarPath = `/project/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a given id, if the project is published, fetch a particular version and stream the contents out with the right mime type to force the file to download 
         * @summary Download a published project at a particular version
         * @param {number} id The id of the project
         * @param {number} versionId The version_id of the version in the project you want
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProjectVersion: (id: number, versionId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadProjectVersion', 'id', id)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('downloadProjectVersion', 'versionId', versionId)
            const localVarPath = `/project/{id}/download/version/{version_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a given token try to download a project 
         * @summary Download a published project
         * @param {string} publicToken The public_token of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPublicProject: (publicToken: string, options: any = {}): RequestArgs => {
            // verify required parameter 'publicToken' is not null or undefined
            assertParamExists('downloadPublicProject', 'publicToken', publicToken)
            const localVarPath = `/project/public/{public_token}/download`
                .replace(`{${"public_token"}}`, encodeURIComponent(String(publicToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a given token try to download a project at a particular version 
         * @summary Download a specific version of a published project
         * @param {string} publicToken The public_token of the project
         * @param {string} versionId The version_id of the version of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPublicProjectVersion: (publicToken: string, versionId: string, options: any = {}): RequestArgs => {
            // verify required parameter 'publicToken' is not null or undefined
            assertParamExists('downloadPublicProjectVersion', 'publicToken', publicToken)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('downloadPublicProjectVersion', 'versionId', versionId)
            const localVarPath = `/project/public/{public_token}/download/version/{version_id}`
                .replace(`{${"public_token"}}`, encodeURIComponent(String(publicToken)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single project by id 
         * @summary Get Project
         * @param {number} id The id of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProject', 'id', id)
            const localVarPath = `/project/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a specific version of of a project. The version property will contain the full version object. 
         * @summary Get Specific project version
         * @param {number} project The id of the project
         * @param {number} version The id of the version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectVersion: (project: number, version: number, options: any = {}): RequestArgs => {
            // verify required parameter 'project' is not null or undefined
            assertParamExists('getProjectVersion', 'project', project)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getProjectVersion', 'version', version)
            const localVarPath = `/project/{project}/version/{version}`
                .replace(`{${"project"}}`, encodeURIComponent(String(project)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the public version of a project by token 
         * @summary Get Public Project
         * @param {string} token The token of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicProject: (token: string, options: any = {}): RequestArgs => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getPublicProject', 'token', token)
            const localVarPath = `/project/public/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of projects. 
         * @summary List Projects
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {Array<ProjectStatus>} [status] 
         * @param {number} [userId] 
         * @param {number} [customerId] 
         * @param {number} [opportunityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, status?: Array<ProjectStatus>, userId?: number, customerId?: number, opportunityId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customer_id'] = customerId;
            }

            if (opportunityId !== undefined) {
                localVarQueryParameter['opportunity_id'] = opportunityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a project with a specific id.  This update will always change the latest version of the project. 
         * @summary Update Project
         * @param {number} id The id of the project
         * @param {ProjectUpdate} projectUpdate Request body for creating or updating a project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: (id: number, projectUpdate: ProjectUpdate, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProject', 'id', id)
            // verify required parameter 'projectUpdate' is not null or undefined
            assertParamExists('updateProject', 'projectUpdate', projectUpdate)
            const localVarPath = `/project/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectApi - functional programming interface
 * @export
 */
export const ProjectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a project.  This route will create a project and a new version.  Accepts pages, clients and blocks, but mostly these objects won\'t be available until some editing is done. 
         * @summary Create project
         * @param {ProjectApiCreateProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(requestParameters: ProjectApiCreateProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Project>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createProject(requestParameters.projectUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a project with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Project
         * @param {ProjectApiDeleteProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject(requestParameters: ProjectApiDeleteProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteProject(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For a given id, if the project is published, stream the contents out with the right mime type to force the file to download 
         * @summary Download a published project
         * @param {ProjectApiDownloadProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProject(requestParameters: ProjectApiDownloadProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadProject(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For a given id, if the project is published, fetch a particular version and stream the contents out with the right mime type to force the file to download 
         * @summary Download a published project at a particular version
         * @param {ProjectApiDownloadProjectVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProjectVersion(requestParameters: ProjectApiDownloadProjectVersionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadProjectVersion(requestParameters.id, requestParameters.versionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For a given token try to download a project 
         * @summary Download a published project
         * @param {ProjectApiDownloadPublicProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPublicProject(requestParameters: ProjectApiDownloadPublicProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadPublicProject(requestParameters.publicToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For a given token try to download a project at a particular version 
         * @summary Download a specific version of a published project
         * @param {ProjectApiDownloadPublicProjectVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPublicProjectVersion(requestParameters: ProjectApiDownloadPublicProjectVersionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadPublicProjectVersion(requestParameters.publicToken, requestParameters.versionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single project by id 
         * @summary Get Project
         * @param {ProjectApiGetProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject(requestParameters: ProjectApiGetProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Project>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getProject(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a specific version of of a project. The version property will contain the full version object. 
         * @summary Get Specific project version
         * @param {ProjectApiGetProjectVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectVersion(requestParameters: ProjectApiGetProjectVersionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Project>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getProjectVersion(requestParameters.project, requestParameters.version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch the public version of a project by token 
         * @summary Get Public Project
         * @param {ProjectApiGetPublicProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicProject(requestParameters: ProjectApiGetPublicProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Project>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getPublicProject(requestParameters.token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of projects. 
         * @summary List Projects
         * @param {ProjectApiListProjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects(requestParameters: ProjectApiListProjectsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedProjects>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listProjects(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.status, requestParameters.userId, requestParameters.customerId, requestParameters.opportunityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a project with a specific id.  This update will always change the latest version of the project. 
         * @summary Update Project
         * @param {ProjectApiUpdateProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject(requestParameters: ProjectApiUpdateProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Project>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateProject(requestParameters.id, requestParameters.projectUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectApi - factory interface
 * @export
 */
export const ProjectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectApiFp(configuration)

    /**
      * Create a project.  This route will create a project and a new version.  Accepts pages, clients and blocks, but mostly these objects won\'t be available until some editing is done. 
      * @summary Create project
      * @param {ProjectApiCreateProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createProject = (requestParameters: ProjectApiCreateProjectRequest, options?: any): AxiosPromise<Project> => {
        const request = localVarFp.createProject(requestParameters, options);
        return request(axios, basePath);
    };

    createProject.getQueryKey = (requestParameters: ProjectApiCreateProjectRequest, options?: any) => {
        const request = localVarFp.createProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a project with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete Project
      * @param {ProjectApiDeleteProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteProject = (requestParameters: ProjectApiDeleteProjectRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteProject(requestParameters, options);
        return request(axios, basePath);
    };

    deleteProject.getQueryKey = (requestParameters: ProjectApiDeleteProjectRequest, options?: any) => {
        const request = localVarFp.deleteProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * For a given id, if the project is published, stream the contents out with the right mime type to force the file to download 
      * @summary Download a published project
      * @param {ProjectApiDownloadProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadProject = (requestParameters: ProjectApiDownloadProjectRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadProject(requestParameters, options);
        return request(axios, basePath);
    };

    downloadProject.getQueryKey = (requestParameters: ProjectApiDownloadProjectRequest, options?: any) => {
        const request = localVarFp.downloadProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * For a given id, if the project is published, fetch a particular version and stream the contents out with the right mime type to force the file to download 
      * @summary Download a published project at a particular version
      * @param {ProjectApiDownloadProjectVersionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadProjectVersion = (requestParameters: ProjectApiDownloadProjectVersionRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadProjectVersion(requestParameters, options);
        return request(axios, basePath);
    };

    downloadProjectVersion.getQueryKey = (requestParameters: ProjectApiDownloadProjectVersionRequest, options?: any) => {
        const request = localVarFp.downloadProjectVersion(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * For a given token try to download a project 
      * @summary Download a published project
      * @param {ProjectApiDownloadPublicProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadPublicProject = (requestParameters: ProjectApiDownloadPublicProjectRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadPublicProject(requestParameters, options);
        return request(axios, basePath);
    };

    downloadPublicProject.getQueryKey = (requestParameters: ProjectApiDownloadPublicProjectRequest, options?: any) => {
        const request = localVarFp.downloadPublicProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * For a given token try to download a project at a particular version 
      * @summary Download a specific version of a published project
      * @param {ProjectApiDownloadPublicProjectVersionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadPublicProjectVersion = (requestParameters: ProjectApiDownloadPublicProjectVersionRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.downloadPublicProjectVersion(requestParameters, options);
        return request(axios, basePath);
    };

    downloadPublicProjectVersion.getQueryKey = (requestParameters: ProjectApiDownloadPublicProjectVersionRequest, options?: any) => {
        const request = localVarFp.downloadPublicProjectVersion(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single project by id 
      * @summary Get Project
      * @param {ProjectApiGetProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getProject = (requestParameters: ProjectApiGetProjectRequest, options?: any): AxiosPromise<Project> => {
        const request = localVarFp.getProject(requestParameters, options);
        return request(axios, basePath);
    };

    getProject.getQueryKey = (requestParameters: ProjectApiGetProjectRequest, options?: any) => {
        const request = localVarFp.getProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a specific version of of a project. The version property will contain the full version object. 
      * @summary Get Specific project version
      * @param {ProjectApiGetProjectVersionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getProjectVersion = (requestParameters: ProjectApiGetProjectVersionRequest, options?: any): AxiosPromise<Project> => {
        const request = localVarFp.getProjectVersion(requestParameters, options);
        return request(axios, basePath);
    };

    getProjectVersion.getQueryKey = (requestParameters: ProjectApiGetProjectVersionRequest, options?: any) => {
        const request = localVarFp.getProjectVersion(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch the public version of a project by token 
      * @summary Get Public Project
      * @param {ProjectApiGetPublicProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getPublicProject = (requestParameters: ProjectApiGetPublicProjectRequest, options?: any): AxiosPromise<Project> => {
        const request = localVarFp.getPublicProject(requestParameters, options);
        return request(axios, basePath);
    };

    getPublicProject.getQueryKey = (requestParameters: ProjectApiGetPublicProjectRequest, options?: any) => {
        const request = localVarFp.getPublicProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of projects. 
      * @summary List Projects
      * @param {ProjectApiListProjectsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listProjects = (requestParameters: ProjectApiListProjectsRequest = {}, options?: any): AxiosPromise<PaginatedProjects> => {
        const request = localVarFp.listProjects(requestParameters, options);
        return request(axios, basePath);
    };

    listProjects.getQueryKey = (requestParameters: ProjectApiListProjectsRequest = {}, options?: any) => {
        const request = localVarFp.listProjects(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a project with a specific id.  This update will always change the latest version of the project. 
      * @summary Update Project
      * @param {ProjectApiUpdateProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateProject = (requestParameters: ProjectApiUpdateProjectRequest, options?: any): AxiosPromise<Project> => {
        const request = localVarFp.updateProject(requestParameters, options);
        return request(axios, basePath);
    };

    updateProject.getQueryKey = (requestParameters: ProjectApiUpdateProjectRequest, options?: any) => {
        const request = localVarFp.updateProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createProject,
        deleteProject,
        downloadProject,
        downloadProjectVersion,
        downloadPublicProject,
        downloadPublicProjectVersion,
        getProject,
        getProjectVersion,
        getPublicProject,
        listProjects,
        updateProject,
    };
};

/**
 * ProjectApi - interface
 * @export
 * @interface ProjectApi
 */
export interface ProjectApiInterface {
    /**
     * Create a project.  This route will create a project and a new version.  Accepts pages, clients and blocks, but mostly these objects won\'t be available until some editing is done. 
     * @summary Create project
     * @param {ProjectApiCreateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApiInterface
     */
    createProject(requestParameters: ProjectApiCreateProjectRequest, options?: any): AxiosPromise<Project>;

    /**
     * Delete a project with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Project
     * @param {ProjectApiDeleteProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApiInterface
     */
    deleteProject(requestParameters: ProjectApiDeleteProjectRequest, options?: any): AxiosPromise<void>;

    /**
     * For a given id, if the project is published, stream the contents out with the right mime type to force the file to download 
     * @summary Download a published project
     * @param {ProjectApiDownloadProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApiInterface
     */
    downloadProject(requestParameters: ProjectApiDownloadProjectRequest, options?: any): AxiosPromise<any>;

    /**
     * For a given id, if the project is published, fetch a particular version and stream the contents out with the right mime type to force the file to download 
     * @summary Download a published project at a particular version
     * @param {ProjectApiDownloadProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApiInterface
     */
    downloadProjectVersion(requestParameters: ProjectApiDownloadProjectVersionRequest, options?: any): AxiosPromise<any>;

    /**
     * For a given token try to download a project 
     * @summary Download a published project
     * @param {ProjectApiDownloadPublicProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApiInterface
     */
    downloadPublicProject(requestParameters: ProjectApiDownloadPublicProjectRequest, options?: any): AxiosPromise<any>;

    /**
     * For a given token try to download a project at a particular version 
     * @summary Download a specific version of a published project
     * @param {ProjectApiDownloadPublicProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApiInterface
     */
    downloadPublicProjectVersion(requestParameters: ProjectApiDownloadPublicProjectVersionRequest, options?: any): AxiosPromise<any>;

    /**
     * Fetch a single project by id 
     * @summary Get Project
     * @param {ProjectApiGetProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApiInterface
     */
    getProject(requestParameters: ProjectApiGetProjectRequest, options?: any): AxiosPromise<Project>;

    /**
     * Fetch a specific version of of a project. The version property will contain the full version object. 
     * @summary Get Specific project version
     * @param {ProjectApiGetProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApiInterface
     */
    getProjectVersion(requestParameters: ProjectApiGetProjectVersionRequest, options?: any): AxiosPromise<Project>;

    /**
     * Fetch the public version of a project by token 
     * @summary Get Public Project
     * @param {ProjectApiGetPublicProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApiInterface
     */
    getPublicProject(requestParameters: ProjectApiGetPublicProjectRequest, options?: any): AxiosPromise<Project>;

    /**
     * Fetch a list of projects. 
     * @summary List Projects
     * @param {ProjectApiListProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApiInterface
     */
    listProjects(requestParameters?: ProjectApiListProjectsRequest, options?: any): AxiosPromise<PaginatedProjects>;

    /**
     * Update a project with a specific id.  This update will always change the latest version of the project. 
     * @summary Update Project
     * @param {ProjectApiUpdateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApiInterface
     */
    updateProject(requestParameters: ProjectApiUpdateProjectRequest, options?: any): AxiosPromise<Project>;

}

/**
 * Request parameters for createProject operation in ProjectApi.
 * @export
 * @interface ProjectApiCreateProjectRequest
 */
export interface ProjectApiCreateProjectRequest {
    /**
     * Request body for creating a project
     * @type {ProjectUpdate}
     * @memberof ProjectApiCreateProject
     */
    readonly projectUpdate: ProjectUpdate
}

/**
 * Request parameters for deleteProject operation in ProjectApi.
 * @export
 * @interface ProjectApiDeleteProjectRequest
 */
export interface ProjectApiDeleteProjectRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof ProjectApiDeleteProject
     */
    readonly id: number
}

/**
 * Request parameters for downloadProject operation in ProjectApi.
 * @export
 * @interface ProjectApiDownloadProjectRequest
 */
export interface ProjectApiDownloadProjectRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof ProjectApiDownloadProject
     */
    readonly id: number
}

/**
 * Request parameters for downloadProjectVersion operation in ProjectApi.
 * @export
 * @interface ProjectApiDownloadProjectVersionRequest
 */
export interface ProjectApiDownloadProjectVersionRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof ProjectApiDownloadProjectVersion
     */
    readonly id: number

    /**
     * The version_id of the version in the project you want
     * @type {number}
     * @memberof ProjectApiDownloadProjectVersion
     */
    readonly versionId: number
}

/**
 * Request parameters for downloadPublicProject operation in ProjectApi.
 * @export
 * @interface ProjectApiDownloadPublicProjectRequest
 */
export interface ProjectApiDownloadPublicProjectRequest {
    /**
     * The public_token of the project
     * @type {string}
     * @memberof ProjectApiDownloadPublicProject
     */
    readonly publicToken: string
}

/**
 * Request parameters for downloadPublicProjectVersion operation in ProjectApi.
 * @export
 * @interface ProjectApiDownloadPublicProjectVersionRequest
 */
export interface ProjectApiDownloadPublicProjectVersionRequest {
    /**
     * The public_token of the project
     * @type {string}
     * @memberof ProjectApiDownloadPublicProjectVersion
     */
    readonly publicToken: string

    /**
     * The version_id of the version of the project
     * @type {string}
     * @memberof ProjectApiDownloadPublicProjectVersion
     */
    readonly versionId: string
}

/**
 * Request parameters for getProject operation in ProjectApi.
 * @export
 * @interface ProjectApiGetProjectRequest
 */
export interface ProjectApiGetProjectRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof ProjectApiGetProject
     */
    readonly id: number
}

/**
 * Request parameters for getProjectVersion operation in ProjectApi.
 * @export
 * @interface ProjectApiGetProjectVersionRequest
 */
export interface ProjectApiGetProjectVersionRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof ProjectApiGetProjectVersion
     */
    readonly project: number

    /**
     * The id of the version
     * @type {number}
     * @memberof ProjectApiGetProjectVersion
     */
    readonly version: number
}

/**
 * Request parameters for getPublicProject operation in ProjectApi.
 * @export
 * @interface ProjectApiGetPublicProjectRequest
 */
export interface ProjectApiGetPublicProjectRequest {
    /**
     * The token of the project
     * @type {string}
     * @memberof ProjectApiGetPublicProject
     */
    readonly token: string
}

/**
 * Request parameters for listProjects operation in ProjectApi.
 * @export
 * @interface ProjectApiListProjectsRequest
 */
export interface ProjectApiListProjectsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ProjectApiListProjects
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ProjectApiListProjects
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ProjectApiListProjects
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ProjectApiListProjects
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ProjectApiListProjects
     */
    readonly search?: string

    /**
     * 
     * @type {Array<ProjectStatus>}
     * @memberof ProjectApiListProjects
     */
    readonly status?: Array<ProjectStatus>

    /**
     * 
     * @type {number}
     * @memberof ProjectApiListProjects
     */
    readonly userId?: number

    /**
     * 
     * @type {number}
     * @memberof ProjectApiListProjects
     */
    readonly customerId?: number

    /**
     * 
     * @type {number}
     * @memberof ProjectApiListProjects
     */
    readonly opportunityId?: number
}

/**
 * Request parameters for updateProject operation in ProjectApi.
 * @export
 * @interface ProjectApiUpdateProjectRequest
 */
export interface ProjectApiUpdateProjectRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof ProjectApiUpdateProject
     */
    readonly id: number

    /**
     * Request body for creating or updating a project
     * @type {ProjectUpdate}
     * @memberof ProjectApiUpdateProject
     */
    readonly projectUpdate: ProjectUpdate
}

/**
 * ProjectApi - object-oriented interface
 * @export
 * @class ProjectApi
 * @extends {BaseAPI}
 */
export class ProjectApi extends BaseAPI implements ProjectApiInterface {
    /**
     * Create a project.  This route will create a project and a new version.  Accepts pages, clients and blocks, but mostly these objects won\'t be available until some editing is done. 
     * @summary Create project
     * @param {ProjectApiCreateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public createProject(requestParameters: ProjectApiCreateProjectRequest, options?: any) {
        const request = ProjectApiFp(this.configuration).createProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a project with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Project
     * @param {ProjectApiDeleteProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public deleteProject(requestParameters: ProjectApiDeleteProjectRequest, options?: any) {
        const request = ProjectApiFp(this.configuration).deleteProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * For a given id, if the project is published, stream the contents out with the right mime type to force the file to download 
     * @summary Download a published project
     * @param {ProjectApiDownloadProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public downloadProject(requestParameters: ProjectApiDownloadProjectRequest, options?: any) {
        const request = ProjectApiFp(this.configuration).downloadProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * For a given id, if the project is published, fetch a particular version and stream the contents out with the right mime type to force the file to download 
     * @summary Download a published project at a particular version
     * @param {ProjectApiDownloadProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public downloadProjectVersion(requestParameters: ProjectApiDownloadProjectVersionRequest, options?: any) {
        const request = ProjectApiFp(this.configuration).downloadProjectVersion(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * For a given token try to download a project 
     * @summary Download a published project
     * @param {ProjectApiDownloadPublicProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public downloadPublicProject(requestParameters: ProjectApiDownloadPublicProjectRequest, options?: any) {
        const request = ProjectApiFp(this.configuration).downloadPublicProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * For a given token try to download a project at a particular version 
     * @summary Download a specific version of a published project
     * @param {ProjectApiDownloadPublicProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public downloadPublicProjectVersion(requestParameters: ProjectApiDownloadPublicProjectVersionRequest, options?: any) {
        const request = ProjectApiFp(this.configuration).downloadPublicProjectVersion(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single project by id 
     * @summary Get Project
     * @param {ProjectApiGetProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public getProject(requestParameters: ProjectApiGetProjectRequest, options?: any) {
        const request = ProjectApiFp(this.configuration).getProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a specific version of of a project. The version property will contain the full version object. 
     * @summary Get Specific project version
     * @param {ProjectApiGetProjectVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public getProjectVersion(requestParameters: ProjectApiGetProjectVersionRequest, options?: any) {
        const request = ProjectApiFp(this.configuration).getProjectVersion(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch the public version of a project by token 
     * @summary Get Public Project
     * @param {ProjectApiGetPublicProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public getPublicProject(requestParameters: ProjectApiGetPublicProjectRequest, options?: any) {
        const request = ProjectApiFp(this.configuration).getPublicProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of projects. 
     * @summary List Projects
     * @param {ProjectApiListProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public listProjects(requestParameters: ProjectApiListProjectsRequest = {}, options?: any) {
        const request = ProjectApiFp(this.configuration).listProjects(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a project with a specific id.  This update will always change the latest version of the project. 
     * @summary Update Project
     * @param {ProjectApiUpdateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public updateProject(requestParameters: ProjectApiUpdateProjectRequest, options?: any) {
        const request = ProjectApiFp(this.configuration).updateProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * QuoteApi - axios parameter creator
 * @export
 */
export const QuoteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This method creates a quote request for the current user.  This will not automatically update a pending request.  Use POST /quote/pending 
         * @summary Create Quote
         * @param {CreateQuoteBody} createQuoteBody Parameters for requesting a quote request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuote: (createQuoteBody: CreateQuoteBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createQuoteBody' is not null or undefined
            assertParamExists('createQuote', 'createQuoteBody', createQuoteBody)
            const localVarPath = `/quote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuoteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Each user can only have one pending quote at a time.  The quote acts as a cart.  While the quote is pending, this method will return the current quote object.  When the quote is moved from status 1 (pending) to status 2 (sent) the quote will be sent, and this method will return an empty quote object, ready to start a new quote. 
         * @summary Get Current Quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentQuote: (options: any = {}): RequestArgs => {
            const localVarPath = `/quote/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single quote 
         * @summary Get Quote
         * @param {number} id The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuote: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listQuote', 'id', id)
            const localVarPath = `/quote/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of quote requests. 
         * @summary List Quote Requests
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of quote requests the current user has access to.
         * @param {string} [modelNumber] Filters the quotes by a particular model number.
         * @param {string} [city] Partial match on city name
         * @param {string} [state] Two letter ISO state code
         * @param {QuoteStatus} [status] Filters the quotes by a particular status (deleted, pending, sent).  Will only show my quotes unless admin
         * @param {number} [companyId] Filter quote request by company.  Only will have effect for admins.  All others will see only their own company data 
         * @param {number} [locationId] Filter quotes by location.  This will only have effect for an admin now 
         * @param {number} [userId] Fetch quotes for a user.
         * @param {boolean} [directBuyer] Filter quotes by direct buyer status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuotes: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, modelNumber?: string, city?: string, state?: string, status?: QuoteStatus, companyId?: number, locationId?: number, userId?: number, directBuyer?: boolean, options: any = {}): RequestArgs => {
            const localVarPath = `/quotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (modelNumber !== undefined) {
                localVarQueryParameter['model_number'] = modelNumber;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (directBuyer !== undefined) {
                localVarQueryParameter['direct_buyer'] = directBuyer;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Links a quote or submitted order to a real order 
         * @summary Order a quote
         * @param {number} id The id of the quote
         * @param {OrderRequestBody} orderRequestBody Parameters for requesting a quote request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderQuote: (id: number, orderRequestBody: OrderRequestBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderQuote', 'id', id)
            // verify required parameter 'orderRequestBody' is not null or undefined
            assertParamExists('orderQuote', 'orderRequestBody', orderRequestBody)
            const localVarPath = `/quote/{id}/order`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
         * @summary Respond to a quote
         * @param {number} id The id of the order
         * @param {CreateQuoteResponseBody} createQuoteResponseBody Parameters for requesting a quote request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondQuote: (id: number, createQuoteResponseBody: CreateQuoteResponseBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('respondQuote', 'id', id)
            // verify required parameter 'createQuoteResponseBody' is not null or undefined
            assertParamExists('respondQuote', 'createQuoteResponseBody', createQuoteResponseBody)
            const localVarPath = `/quote/{id}/respond`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuoteResponseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is the quote \"cart\" for the current user.  If you post a quote object to this endpoint, it will update the current quote with files, message, and products.  Product should be passed in as the product id, though a model_number will also be accepted. The quote status will accept statuses of 1 (pending) and 2 (sent).  Once a product has been moved from pending to sent, the quote will be sent to the the quoting team, and the quote endpoint will return an empty object, ready to start creating a new quote 
         * @summary Update Current Quote
         * @param {UpdateQuoteBody} updateQuoteBody Parameters for requesting a quote request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentQuote: (updateQuoteBody: UpdateQuoteBody, options: any = {}): RequestArgs => {
            // verify required parameter 'updateQuoteBody' is not null or undefined
            assertParamExists('updateCurrentQuote', 'updateQuoteBody', updateQuoteBody)
            const localVarPath = `/quote/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuoteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuoteApi - functional programming interface
 * @export
 */
export const QuoteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuoteApiAxiosParamCreator(configuration)
    return {
        /**
         * This method creates a quote request for the current user.  This will not automatically update a pending request.  Use POST /quote/pending 
         * @summary Create Quote
         * @param {QuoteApiCreateQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuote(requestParameters: QuoteApiCreateQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Quote>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createQuote(requestParameters.createQuoteBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Each user can only have one pending quote at a time.  The quote acts as a cart.  While the quote is pending, this method will return the current quote object.  When the quote is moved from status 1 (pending) to status 2 (sent) the quote will be sent, and this method will return an empty quote object, ready to start a new quote. 
         * @summary Get Current Quote
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentQuote(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PendingQuote>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getCurrentQuote(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a single quote 
         * @summary Get Quote
         * @param {QuoteApiListQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuote(requestParameters: QuoteApiListQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Quote>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listQuote(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of quote requests. 
         * @summary List Quote Requests
         * @param {QuoteApiListQuotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuotes(requestParameters: QuoteApiListQuotesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedQuotes>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listQuotes(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.modelNumber, requestParameters.city, requestParameters.state, requestParameters.status, requestParameters.companyId, requestParameters.locationId, requestParameters.userId, requestParameters.directBuyer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Links a quote or submitted order to a real order 
         * @summary Order a quote
         * @param {QuoteApiOrderQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderQuote(requestParameters: QuoteApiOrderQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Quote>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.orderQuote(requestParameters.id, requestParameters.orderRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
         * @summary Respond to a quote
         * @param {QuoteApiRespondQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondQuote(requestParameters: QuoteApiRespondQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Response>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.respondQuote(requestParameters.id, requestParameters.createQuoteResponseBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This is the quote \"cart\" for the current user.  If you post a quote object to this endpoint, it will update the current quote with files, message, and products.  Product should be passed in as the product id, though a model_number will also be accepted. The quote status will accept statuses of 1 (pending) and 2 (sent).  Once a product has been moved from pending to sent, the quote will be sent to the the quoting team, and the quote endpoint will return an empty object, ready to start creating a new quote 
         * @summary Update Current Quote
         * @param {QuoteApiUpdateCurrentQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentQuote(requestParameters: QuoteApiUpdateCurrentQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PendingQuote>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateCurrentQuote(requestParameters.updateQuoteBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QuoteApi - factory interface
 * @export
 */
export const QuoteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuoteApiFp(configuration)

    /**
      * This method creates a quote request for the current user.  This will not automatically update a pending request.  Use POST /quote/pending 
      * @summary Create Quote
      * @param {QuoteApiCreateQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createQuote = (requestParameters: QuoteApiCreateQuoteRequest, options?: any): AxiosPromise<Quote> => {
        const request = localVarFp.createQuote(requestParameters, options);
        return request(axios, basePath);
    };

    createQuote.getQueryKey = (requestParameters: QuoteApiCreateQuoteRequest, options?: any) => {
        const request = localVarFp.createQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Each user can only have one pending quote at a time.  The quote acts as a cart.  While the quote is pending, this method will return the current quote object.  When the quote is moved from status 1 (pending) to status 2 (sent) the quote will be sent, and this method will return an empty quote object, ready to start a new quote. 
      * @summary Get Current Quote
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getCurrentQuote = (requestParameters?: undefined, options?: any): AxiosPromise<PendingQuote> => {
        const request = localVarFp.getCurrentQuote(requestParameters, options);
        return request(axios, basePath);
    };

    getCurrentQuote.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.getCurrentQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a single quote 
      * @summary Get Quote
      * @param {QuoteApiListQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listQuote = (requestParameters: QuoteApiListQuoteRequest, options?: any): AxiosPromise<Quote> => {
        const request = localVarFp.listQuote(requestParameters, options);
        return request(axios, basePath);
    };

    listQuote.getQueryKey = (requestParameters: QuoteApiListQuoteRequest, options?: any) => {
        const request = localVarFp.listQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of quote requests. 
      * @summary List Quote Requests
      * @param {QuoteApiListQuotesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listQuotes = (requestParameters: QuoteApiListQuotesRequest = {}, options?: any): AxiosPromise<PaginatedQuotes> => {
        const request = localVarFp.listQuotes(requestParameters, options);
        return request(axios, basePath);
    };

    listQuotes.getQueryKey = (requestParameters: QuoteApiListQuotesRequest = {}, options?: any) => {
        const request = localVarFp.listQuotes(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Links a quote or submitted order to a real order 
      * @summary Order a quote
      * @param {QuoteApiOrderQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const orderQuote = (requestParameters: QuoteApiOrderQuoteRequest, options?: any): AxiosPromise<Quote> => {
        const request = localVarFp.orderQuote(requestParameters, options);
        return request(axios, basePath);
    };

    orderQuote.getQueryKey = (requestParameters: QuoteApiOrderQuoteRequest, options?: any) => {
        const request = localVarFp.orderQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
      * @summary Respond to a quote
      * @param {QuoteApiRespondQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const respondQuote = (requestParameters: QuoteApiRespondQuoteRequest, options?: any): AxiosPromise<Response> => {
        const request = localVarFp.respondQuote(requestParameters, options);
        return request(axios, basePath);
    };

    respondQuote.getQueryKey = (requestParameters: QuoteApiRespondQuoteRequest, options?: any) => {
        const request = localVarFp.respondQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * This is the quote \"cart\" for the current user.  If you post a quote object to this endpoint, it will update the current quote with files, message, and products.  Product should be passed in as the product id, though a model_number will also be accepted. The quote status will accept statuses of 1 (pending) and 2 (sent).  Once a product has been moved from pending to sent, the quote will be sent to the the quoting team, and the quote endpoint will return an empty object, ready to start creating a new quote 
      * @summary Update Current Quote
      * @param {QuoteApiUpdateCurrentQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateCurrentQuote = (requestParameters: QuoteApiUpdateCurrentQuoteRequest, options?: any): AxiosPromise<PendingQuote> => {
        const request = localVarFp.updateCurrentQuote(requestParameters, options);
        return request(axios, basePath);
    };

    updateCurrentQuote.getQueryKey = (requestParameters: QuoteApiUpdateCurrentQuoteRequest, options?: any) => {
        const request = localVarFp.updateCurrentQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createQuote,
        getCurrentQuote,
        listQuote,
        listQuotes,
        orderQuote,
        respondQuote,
        updateCurrentQuote,
    };
};

/**
 * QuoteApi - interface
 * @export
 * @interface QuoteApi
 */
export interface QuoteApiInterface {
    /**
     * This method creates a quote request for the current user.  This will not automatically update a pending request.  Use POST /quote/pending 
     * @summary Create Quote
     * @param {QuoteApiCreateQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApiInterface
     */
    createQuote(requestParameters: QuoteApiCreateQuoteRequest, options?: any): AxiosPromise<Quote>;

    /**
     * Each user can only have one pending quote at a time.  The quote acts as a cart.  While the quote is pending, this method will return the current quote object.  When the quote is moved from status 1 (pending) to status 2 (sent) the quote will be sent, and this method will return an empty quote object, ready to start a new quote. 
     * @summary Get Current Quote
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApiInterface
     */
    getCurrentQuote(requestParameters?: undefined, options?: any): AxiosPromise<PendingQuote>;

    /**
     * Get a single quote 
     * @summary Get Quote
     * @param {QuoteApiListQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApiInterface
     */
    listQuote(requestParameters: QuoteApiListQuoteRequest, options?: any): AxiosPromise<Quote>;

    /**
     * Fetch a list of quote requests. 
     * @summary List Quote Requests
     * @param {QuoteApiListQuotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApiInterface
     */
    listQuotes(requestParameters?: QuoteApiListQuotesRequest, options?: any): AxiosPromise<PaginatedQuotes>;

    /**
     * Links a quote or submitted order to a real order 
     * @summary Order a quote
     * @param {QuoteApiOrderQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApiInterface
     */
    orderQuote(requestParameters: QuoteApiOrderQuoteRequest, options?: any): AxiosPromise<Quote>;

    /**
     * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
     * @summary Respond to a quote
     * @param {QuoteApiRespondQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApiInterface
     */
    respondQuote(requestParameters: QuoteApiRespondQuoteRequest, options?: any): AxiosPromise<Response>;

    /**
     * This is the quote \"cart\" for the current user.  If you post a quote object to this endpoint, it will update the current quote with files, message, and products.  Product should be passed in as the product id, though a model_number will also be accepted. The quote status will accept statuses of 1 (pending) and 2 (sent).  Once a product has been moved from pending to sent, the quote will be sent to the the quoting team, and the quote endpoint will return an empty object, ready to start creating a new quote 
     * @summary Update Current Quote
     * @param {QuoteApiUpdateCurrentQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApiInterface
     */
    updateCurrentQuote(requestParameters: QuoteApiUpdateCurrentQuoteRequest, options?: any): AxiosPromise<PendingQuote>;

}

/**
 * Request parameters for createQuote operation in QuoteApi.
 * @export
 * @interface QuoteApiCreateQuoteRequest
 */
export interface QuoteApiCreateQuoteRequest {
    /**
     * Parameters for requesting a quote request
     * @type {CreateQuoteBody}
     * @memberof QuoteApiCreateQuote
     */
    readonly createQuoteBody: CreateQuoteBody
}

/**
 * Request parameters for listQuote operation in QuoteApi.
 * @export
 * @interface QuoteApiListQuoteRequest
 */
export interface QuoteApiListQuoteRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof QuoteApiListQuote
     */
    readonly id: number
}

/**
 * Request parameters for listQuotes operation in QuoteApi.
 * @export
 * @interface QuoteApiListQuotesRequest
 */
export interface QuoteApiListQuotesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof QuoteApiListQuotes
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof QuoteApiListQuotes
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof QuoteApiListQuotes
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof QuoteApiListQuotes
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of quote requests the current user has access to.
     * @type {string}
     * @memberof QuoteApiListQuotes
     */
    readonly search?: string

    /**
     * Filters the quotes by a particular model number.
     * @type {string}
     * @memberof QuoteApiListQuotes
     */
    readonly modelNumber?: string

    /**
     * Partial match on city name
     * @type {string}
     * @memberof QuoteApiListQuotes
     */
    readonly city?: string

    /**
     * Two letter ISO state code
     * @type {string}
     * @memberof QuoteApiListQuotes
     */
    readonly state?: string

    /**
     * Filters the quotes by a particular status (deleted, pending, sent).  Will only show my quotes unless admin
     * @type {QuoteStatus}
     * @memberof QuoteApiListQuotes
     */
    readonly status?: QuoteStatus

    /**
     * Filter quote request by company.  Only will have effect for admins.  All others will see only their own company data 
     * @type {number}
     * @memberof QuoteApiListQuotes
     */
    readonly companyId?: number

    /**
     * Filter quotes by location.  This will only have effect for an admin now 
     * @type {number}
     * @memberof QuoteApiListQuotes
     */
    readonly locationId?: number

    /**
     * Fetch quotes for a user.
     * @type {number}
     * @memberof QuoteApiListQuotes
     */
    readonly userId?: number

    /**
     * Filter quotes by direct buyer status
     * @type {boolean}
     * @memberof QuoteApiListQuotes
     */
    readonly directBuyer?: boolean
}

/**
 * Request parameters for orderQuote operation in QuoteApi.
 * @export
 * @interface QuoteApiOrderQuoteRequest
 */
export interface QuoteApiOrderQuoteRequest {
    /**
     * The id of the quote
     * @type {number}
     * @memberof QuoteApiOrderQuote
     */
    readonly id: number

    /**
     * Parameters for requesting a quote request
     * @type {OrderRequestBody}
     * @memberof QuoteApiOrderQuote
     */
    readonly orderRequestBody: OrderRequestBody
}

/**
 * Request parameters for respondQuote operation in QuoteApi.
 * @export
 * @interface QuoteApiRespondQuoteRequest
 */
export interface QuoteApiRespondQuoteRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof QuoteApiRespondQuote
     */
    readonly id: number

    /**
     * Parameters for requesting a quote request
     * @type {CreateQuoteResponseBody}
     * @memberof QuoteApiRespondQuote
     */
    readonly createQuoteResponseBody: CreateQuoteResponseBody
}

/**
 * Request parameters for updateCurrentQuote operation in QuoteApi.
 * @export
 * @interface QuoteApiUpdateCurrentQuoteRequest
 */
export interface QuoteApiUpdateCurrentQuoteRequest {
    /**
     * Parameters for requesting a quote request
     * @type {UpdateQuoteBody}
     * @memberof QuoteApiUpdateCurrentQuote
     */
    readonly updateQuoteBody: UpdateQuoteBody
}

/**
 * QuoteApi - object-oriented interface
 * @export
 * @class QuoteApi
 * @extends {BaseAPI}
 */
export class QuoteApi extends BaseAPI implements QuoteApiInterface {
    /**
     * This method creates a quote request for the current user.  This will not automatically update a pending request.  Use POST /quote/pending 
     * @summary Create Quote
     * @param {QuoteApiCreateQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public createQuote(requestParameters: QuoteApiCreateQuoteRequest, options?: any) {
        const request = QuoteApiFp(this.configuration).createQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Each user can only have one pending quote at a time.  The quote acts as a cart.  While the quote is pending, this method will return the current quote object.  When the quote is moved from status 1 (pending) to status 2 (sent) the quote will be sent, and this method will return an empty quote object, ready to start a new quote. 
     * @summary Get Current Quote
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public getCurrentQuote(requestParameters?: undefined, options?: any) {
        const request = QuoteApiFp(this.configuration).getCurrentQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a single quote 
     * @summary Get Quote
     * @param {QuoteApiListQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public listQuote(requestParameters: QuoteApiListQuoteRequest, options?: any) {
        const request = QuoteApiFp(this.configuration).listQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of quote requests. 
     * @summary List Quote Requests
     * @param {QuoteApiListQuotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public listQuotes(requestParameters: QuoteApiListQuotesRequest = {}, options?: any) {
        const request = QuoteApiFp(this.configuration).listQuotes(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Links a quote or submitted order to a real order 
     * @summary Order a quote
     * @param {QuoteApiOrderQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public orderQuote(requestParameters: QuoteApiOrderQuoteRequest, options?: any) {
        const request = QuoteApiFp(this.configuration).orderQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
     * @summary Respond to a quote
     * @param {QuoteApiRespondQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public respondQuote(requestParameters: QuoteApiRespondQuoteRequest, options?: any) {
        const request = QuoteApiFp(this.configuration).respondQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * This is the quote \"cart\" for the current user.  If you post a quote object to this endpoint, it will update the current quote with files, message, and products.  Product should be passed in as the product id, though a model_number will also be accepted. The quote status will accept statuses of 1 (pending) and 2 (sent).  Once a product has been moved from pending to sent, the quote will be sent to the the quoting team, and the quote endpoint will return an empty object, ready to start creating a new quote 
     * @summary Update Current Quote
     * @param {QuoteApiUpdateCurrentQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteApi
     */
    public updateCurrentQuote(requestParameters: QuoteApiUpdateCurrentQuoteRequest, options?: any) {
        const request = QuoteApiFp(this.configuration).updateCurrentQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * RegionApi - axios parameter creator
 * @export
 */
export const RegionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a single region by id with its associated territories 
         * @summary Get Region
         * @param {number} id The id of the region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegion: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRegion', 'id', id)
            const localVarPath = `/regions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of regions with their associated territories 
         * @summary List Regions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegions: (options: any = {}): RequestArgs => {
            const localVarPath = `/regions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegionApi - functional programming interface
 * @export
 */
export const RegionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegionApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a single region by id with its associated territories 
         * @summary Get Region
         * @param {RegionApiGetRegionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegion(requestParameters: RegionApiGetRegionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegionResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getRegion(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of regions with their associated territories 
         * @summary List Regions
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegions(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegionsResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listRegions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegionApi - factory interface
 * @export
 */
export const RegionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegionApiFp(configuration)

    /**
      * Fetch a single region by id with its associated territories 
      * @summary Get Region
      * @param {RegionApiGetRegionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getRegion = (requestParameters: RegionApiGetRegionRequest, options?: any): AxiosPromise<RegionResponse> => {
        const request = localVarFp.getRegion(requestParameters, options);
        return request(axios, basePath);
    };

    getRegion.getQueryKey = (requestParameters: RegionApiGetRegionRequest, options?: any) => {
        const request = localVarFp.getRegion(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of regions with their associated territories 
      * @summary List Regions
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listRegions = (requestParameters?: undefined, options?: any): AxiosPromise<RegionsResponse> => {
        const request = localVarFp.listRegions(requestParameters, options);
        return request(axios, basePath);
    };

    listRegions.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.listRegions(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        getRegion,
        listRegions,
    };
};

/**
 * RegionApi - interface
 * @export
 * @interface RegionApi
 */
export interface RegionApiInterface {
    /**
     * Fetch a single region by id with its associated territories 
     * @summary Get Region
     * @param {RegionApiGetRegionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionApiInterface
     */
    getRegion(requestParameters: RegionApiGetRegionRequest, options?: any): AxiosPromise<RegionResponse>;

    /**
     * Fetch a list of regions with their associated territories 
     * @summary List Regions
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionApiInterface
     */
    listRegions(requestParameters?: undefined, options?: any): AxiosPromise<RegionsResponse>;

}

/**
 * Request parameters for getRegion operation in RegionApi.
 * @export
 * @interface RegionApiGetRegionRequest
 */
export interface RegionApiGetRegionRequest {
    /**
     * The id of the region
     * @type {number}
     * @memberof RegionApiGetRegion
     */
    readonly id: number
}

/**
 * RegionApi - object-oriented interface
 * @export
 * @class RegionApi
 * @extends {BaseAPI}
 */
export class RegionApi extends BaseAPI implements RegionApiInterface {
    /**
     * Fetch a single region by id with its associated territories 
     * @summary Get Region
     * @param {RegionApiGetRegionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionApi
     */
    public getRegion(requestParameters: RegionApiGetRegionRequest, options?: any) {
        const request = RegionApiFp(this.configuration).getRegion(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of regions with their associated territories 
     * @summary List Regions
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionApi
     */
    public listRegions(requestParameters?: undefined, options?: any) {
        const request = RegionApiFp(this.configuration).listRegions(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * RegisterApi - axios parameter creator
 * @export
 */
export const RegisterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Request a new account.  This will create a user account with no access rights, and notify the admins so that they can approve the requested account 
         * @summary Register an Account
         * @param {RequestAccountBody} requestAccountBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: (requestAccountBody: RequestAccountBody, options: any = {}): RequestArgs => {
            // verify required parameter 'requestAccountBody' is not null or undefined
            assertParamExists('register', 'requestAccountBody', requestAccountBody)
            const localVarPath = `/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestAccountBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a new account.  This will create a user account with limited access to resources 
         * @summary Register for a limited resource only account
         * @param {RequestResourceAccountBody} requestResourceAccountBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerResourceAccess: (requestResourceAccountBody: RequestResourceAccountBody, options: any = {}): RequestArgs => {
            // verify required parameter 'requestResourceAccountBody' is not null or undefined
            assertParamExists('registerResourceAccess', 'requestResourceAccountBody', requestResourceAccountBody)
            const localVarPath = `/auth/resource-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestResourceAccountBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegisterApi - functional programming interface
 * @export
 */
export const RegisterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegisterApiAxiosParamCreator(configuration)
    return {
        /**
         * Request a new account.  This will create a user account with no access rights, and notify the admins so that they can approve the requested account 
         * @summary Register an Account
         * @param {RegisterApiRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(requestParameters: RegisterApiRegisterRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<User>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.register(requestParameters.requestAccountBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Request a new account.  This will create a user account with limited access to resources 
         * @summary Register for a limited resource only account
         * @param {RegisterApiRegisterResourceAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerResourceAccess(requestParameters: RegisterApiRegisterResourceAccessRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<User>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.registerResourceAccess(requestParameters.requestResourceAccountBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegisterApi - factory interface
 * @export
 */
export const RegisterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegisterApiFp(configuration)

    /**
      * Request a new account.  This will create a user account with no access rights, and notify the admins so that they can approve the requested account 
      * @summary Register an Account
      * @param {RegisterApiRegisterRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const register = (requestParameters: RegisterApiRegisterRequest, options?: any): AxiosPromise<User> => {
        const request = localVarFp.register(requestParameters, options);
        return request(axios, basePath);
    };

    register.getQueryKey = (requestParameters: RegisterApiRegisterRequest, options?: any) => {
        const request = localVarFp.register(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Request a new account.  This will create a user account with limited access to resources 
      * @summary Register for a limited resource only account
      * @param {RegisterApiRegisterResourceAccessRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const registerResourceAccess = (requestParameters: RegisterApiRegisterResourceAccessRequest, options?: any): AxiosPromise<User> => {
        const request = localVarFp.registerResourceAccess(requestParameters, options);
        return request(axios, basePath);
    };

    registerResourceAccess.getQueryKey = (requestParameters: RegisterApiRegisterResourceAccessRequest, options?: any) => {
        const request = localVarFp.registerResourceAccess(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        register,
        registerResourceAccess,
    };
};

/**
 * RegisterApi - interface
 * @export
 * @interface RegisterApi
 */
export interface RegisterApiInterface {
    /**
     * Request a new account.  This will create a user account with no access rights, and notify the admins so that they can approve the requested account 
     * @summary Register an Account
     * @param {RegisterApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterApiInterface
     */
    register(requestParameters: RegisterApiRegisterRequest, options?: any): AxiosPromise<User>;

    /**
     * Request a new account.  This will create a user account with limited access to resources 
     * @summary Register for a limited resource only account
     * @param {RegisterApiRegisterResourceAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterApiInterface
     */
    registerResourceAccess(requestParameters: RegisterApiRegisterResourceAccessRequest, options?: any): AxiosPromise<User>;

}

/**
 * Request parameters for register operation in RegisterApi.
 * @export
 * @interface RegisterApiRegisterRequest
 */
export interface RegisterApiRegisterRequest {
    /**
     * 
     * @type {RequestAccountBody}
     * @memberof RegisterApiRegister
     */
    readonly requestAccountBody: RequestAccountBody
}

/**
 * Request parameters for registerResourceAccess operation in RegisterApi.
 * @export
 * @interface RegisterApiRegisterResourceAccessRequest
 */
export interface RegisterApiRegisterResourceAccessRequest {
    /**
     * 
     * @type {RequestResourceAccountBody}
     * @memberof RegisterApiRegisterResourceAccess
     */
    readonly requestResourceAccountBody: RequestResourceAccountBody
}

/**
 * RegisterApi - object-oriented interface
 * @export
 * @class RegisterApi
 * @extends {BaseAPI}
 */
export class RegisterApi extends BaseAPI implements RegisterApiInterface {
    /**
     * Request a new account.  This will create a user account with no access rights, and notify the admins so that they can approve the requested account 
     * @summary Register an Account
     * @param {RegisterApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterApi
     */
    public register(requestParameters: RegisterApiRegisterRequest, options?: any) {
        const request = RegisterApiFp(this.configuration).register(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Request a new account.  This will create a user account with limited access to resources 
     * @summary Register for a limited resource only account
     * @param {RegisterApiRegisterResourceAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterApi
     */
    public registerResourceAccess(requestParameters: RegisterApiRegisterResourceAccessRequest, options?: any) {
        const request = RegisterApiFp(this.configuration).registerResourceAccess(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allows an admin to create a report 
         * @summary Create Report
         * @param {ReportType} type The type of report to create
         * @param {number} [companyId] 
         * @param {number} [locationId] 
         * @param {number} [userId] 
         * @param {UserStatus | OrderStatus | QuoteStatus | number} [status] 
         * @param {string} [search] 
         * @param {UserRole} [role] 
         * @param {string} [state] 
         * @param {string} [name] 
         * @param {string} [orderNumber] Partial match filter on order number
         * @param {string} [orderDateStart] Filter by order date, bound by start date
         * @param {string} [orderDateEnd] Filter by order date, bound by end date
         * @param {string} [modelNumber] Filters the quotes by a particular model number.
         * @param {string} [city] Partial match on city name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport: (type: ReportType, companyId?: number, locationId?: number, userId?: number, status?: UserStatus | OrderStatus | QuoteStatus | number, search?: string, role?: UserRole, state?: string, name?: string, orderNumber?: string, orderDateStart?: string, orderDateEnd?: string, modelNumber?: string, city?: string, options: any = {}): RequestArgs => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('createReport', 'type', type)
            const localVarPath = `/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (orderNumber !== undefined) {
                localVarQueryParameter['order_number'] = orderNumber;
            }

            if (orderDateStart !== undefined) {
                localVarQueryParameter['order_date_start'] = (orderDateStart as any instanceof Date) ?
                    (orderDateStart as any).toISOString() :
                    orderDateStart;
            }

            if (orderDateEnd !== undefined) {
                localVarQueryParameter['order_date_end'] = (orderDateEnd as any instanceof Date) ?
                    (orderDateEnd as any).toISOString() :
                    orderDateEnd;
            }

            if (modelNumber !== undefined) {
                localVarQueryParameter['model_number'] = modelNumber;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a report
         * @param {number} reportId The id of the report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReport: (reportId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('deleteReport', 'reportId', reportId)
            const localVarPath = `/report/{report_id}`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single report by id 
         * @summary Get Report
         * @param {number} reportId The id of the report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport: (reportId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReport', 'reportId', reportId)
            const localVarPath = `/report/{report_id}`
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of reports 
         * @summary List Reports
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [user] 
         * @param {ReportType} [type] 
         * @param {ReportStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReports: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', user?: string, type?: ReportType, status?: ReportStatus, options: any = {}): RequestArgs => {
            const localVarPath = `/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration)
    return {
        /**
         * Allows an admin to create a report 
         * @summary Create Report
         * @param {ReportApiCreateReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(requestParameters: ReportApiCreateReportRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Report>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createReport(requestParameters.type, requestParameters.companyId, requestParameters.locationId, requestParameters.userId, requestParameters.status, requestParameters.search, requestParameters.role, requestParameters.state, requestParameters.name, requestParameters.orderNumber, requestParameters.orderDateStart, requestParameters.orderDateEnd, requestParameters.modelNumber, requestParameters.city, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a report
         * @param {ReportApiDeleteReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReport(requestParameters: ReportApiDeleteReportRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteReport(requestParameters.reportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single report by id 
         * @summary Get Report
         * @param {ReportApiGetReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(requestParameters: ReportApiGetReportRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Report>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getReport(requestParameters.reportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a list of reports 
         * @summary List Reports
         * @param {ReportApiListReportsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReports(requestParameters: ReportApiListReportsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedReports>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listReports(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.user, requestParameters.type, requestParameters.status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiFp(configuration)

    /**
      * Allows an admin to create a report 
      * @summary Create Report
      * @param {ReportApiCreateReportRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createReport = (requestParameters: ReportApiCreateReportRequest, options?: any): AxiosPromise<Report> => {
        const request = localVarFp.createReport(requestParameters, options);
        return request(axios, basePath);
    };

    createReport.getQueryKey = (requestParameters: ReportApiCreateReportRequest, options?: any) => {
        const request = localVarFp.createReport(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a user with a specific id 
      * @summary Delete a report
      * @param {ReportApiDeleteReportRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteReport = (requestParameters: ReportApiDeleteReportRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteReport(requestParameters, options);
        return request(axios, basePath);
    };

    deleteReport.getQueryKey = (requestParameters: ReportApiDeleteReportRequest, options?: any) => {
        const request = localVarFp.deleteReport(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single report by id 
      * @summary Get Report
      * @param {ReportApiGetReportRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getReport = (requestParameters: ReportApiGetReportRequest, options?: any): AxiosPromise<Report> => {
        const request = localVarFp.getReport(requestParameters, options);
        return request(axios, basePath);
    };

    getReport.getQueryKey = (requestParameters: ReportApiGetReportRequest, options?: any) => {
        const request = localVarFp.getReport(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get a list of reports 
      * @summary List Reports
      * @param {ReportApiListReportsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listReports = (requestParameters: ReportApiListReportsRequest = {}, options?: any): AxiosPromise<PaginatedReports> => {
        const request = localVarFp.listReports(requestParameters, options);
        return request(axios, basePath);
    };

    listReports.getQueryKey = (requestParameters: ReportApiListReportsRequest = {}, options?: any) => {
        const request = localVarFp.listReports(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createReport,
        deleteReport,
        getReport,
        listReports,
    };
};

/**
 * ReportApi - interface
 * @export
 * @interface ReportApi
 */
export interface ReportApiInterface {
    /**
     * Allows an admin to create a report 
     * @summary Create Report
     * @param {ReportApiCreateReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiInterface
     */
    createReport(requestParameters: ReportApiCreateReportRequest, options?: any): AxiosPromise<Report>;

    /**
     * Delete a user with a specific id 
     * @summary Delete a report
     * @param {ReportApiDeleteReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiInterface
     */
    deleteReport(requestParameters: ReportApiDeleteReportRequest, options?: any): AxiosPromise<void>;

    /**
     * Fetch a single report by id 
     * @summary Get Report
     * @param {ReportApiGetReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiInterface
     */
    getReport(requestParameters: ReportApiGetReportRequest, options?: any): AxiosPromise<Report>;

    /**
     * Get a list of reports 
     * @summary List Reports
     * @param {ReportApiListReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiInterface
     */
    listReports(requestParameters?: ReportApiListReportsRequest, options?: any): AxiosPromise<PaginatedReports>;

}

/**
 * Request parameters for createReport operation in ReportApi.
 * @export
 * @interface ReportApiCreateReportRequest
 */
export interface ReportApiCreateReportRequest {
    /**
     * The type of report to create
     * @type {ReportType}
     * @memberof ReportApiCreateReport
     */
    readonly type: ReportType

    /**
     * 
     * @type {number}
     * @memberof ReportApiCreateReport
     */
    readonly companyId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportApiCreateReport
     */
    readonly locationId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportApiCreateReport
     */
    readonly userId?: number

    /**
     * 
     * @type {UserStatus | OrderStatus | QuoteStatus | number}
     * @memberof ReportApiCreateReport
     */
    readonly status?: UserStatus | OrderStatus | QuoteStatus | number

    /**
     * 
     * @type {string}
     * @memberof ReportApiCreateReport
     */
    readonly search?: string

    /**
     * 
     * @type {UserRole}
     * @memberof ReportApiCreateReport
     */
    readonly role?: UserRole

    /**
     * 
     * @type {string}
     * @memberof ReportApiCreateReport
     */
    readonly state?: string

    /**
     * 
     * @type {string}
     * @memberof ReportApiCreateReport
     */
    readonly name?: string

    /**
     * Partial match filter on order number
     * @type {string}
     * @memberof ReportApiCreateReport
     */
    readonly orderNumber?: string

    /**
     * Filter by order date, bound by start date
     * @type {string}
     * @memberof ReportApiCreateReport
     */
    readonly orderDateStart?: string

    /**
     * Filter by order date, bound by end date
     * @type {string}
     * @memberof ReportApiCreateReport
     */
    readonly orderDateEnd?: string

    /**
     * Filters the quotes by a particular model number.
     * @type {string}
     * @memberof ReportApiCreateReport
     */
    readonly modelNumber?: string

    /**
     * Partial match on city name
     * @type {string}
     * @memberof ReportApiCreateReport
     */
    readonly city?: string
}

/**
 * Request parameters for deleteReport operation in ReportApi.
 * @export
 * @interface ReportApiDeleteReportRequest
 */
export interface ReportApiDeleteReportRequest {
    /**
     * The id of the report
     * @type {number}
     * @memberof ReportApiDeleteReport
     */
    readonly reportId: number
}

/**
 * Request parameters for getReport operation in ReportApi.
 * @export
 * @interface ReportApiGetReportRequest
 */
export interface ReportApiGetReportRequest {
    /**
     * The id of the report
     * @type {number}
     * @memberof ReportApiGetReport
     */
    readonly reportId: number
}

/**
 * Request parameters for listReports operation in ReportApi.
 * @export
 * @interface ReportApiListReportsRequest
 */
export interface ReportApiListReportsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ReportApiListReports
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ReportApiListReports
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ReportApiListReports
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ReportApiListReports
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * 
     * @type {string}
     * @memberof ReportApiListReports
     */
    readonly user?: string

    /**
     * 
     * @type {ReportType}
     * @memberof ReportApiListReports
     */
    readonly type?: ReportType

    /**
     * 
     * @type {ReportStatus}
     * @memberof ReportApiListReports
     */
    readonly status?: ReportStatus
}

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI implements ReportApiInterface {
    /**
     * Allows an admin to create a report 
     * @summary Create Report
     * @param {ReportApiCreateReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public createReport(requestParameters: ReportApiCreateReportRequest, options?: any) {
        const request = ReportApiFp(this.configuration).createReport(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a user with a specific id 
     * @summary Delete a report
     * @param {ReportApiDeleteReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public deleteReport(requestParameters: ReportApiDeleteReportRequest, options?: any) {
        const request = ReportApiFp(this.configuration).deleteReport(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single report by id 
     * @summary Get Report
     * @param {ReportApiGetReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getReport(requestParameters: ReportApiGetReportRequest, options?: any) {
        const request = ReportApiFp(this.configuration).getReport(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get a list of reports 
     * @summary List Reports
     * @param {ReportApiListReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public listReports(requestParameters: ReportApiListReportsRequest = {}, options?: any) {
        const request = ReportApiFp(this.configuration).listReports(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ResetApi - axios parameter creator
 * @export
 */
export const ResetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint accepts an email address to reset. 
         * @summary Request Password Reset
         * @param {RequestPasswordReset} requestPasswordReset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestReset: (requestPasswordReset: RequestPasswordReset, options: any = {}): RequestArgs => {
            // verify required parameter 'requestPasswordReset' is not null or undefined
            assertParamExists('requestReset', 'requestPasswordReset', requestPasswordReset)
            const localVarPath = `/auth/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPasswordReset, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint starts the sso process.  The client should redirect the user here, and this endpoint will sign a request and redirect the user to salesforce to start the sso request.  If successful, the sso will return the user to the client app, with a code that can be sent to the api via the salesforce_sso grant request 
         * @summary Redirect user to salesforce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSalesforceSSO: (options: any = {}): RequestArgs => {
            const localVarPath = `/auth/salesforce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResetApi - functional programming interface
 * @export
 */
export const ResetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResetApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint accepts an email address to reset. 
         * @summary Request Password Reset
         * @param {ResetApiRequestResetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestReset(requestParameters: ResetApiRequestResetRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.requestReset(requestParameters.requestPasswordReset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint starts the sso process.  The client should redirect the user here, and this endpoint will sign a request and redirect the user to salesforce to start the sso request.  If successful, the sso will return the user to the client app, with a code that can be sent to the api via the salesforce_sso grant request 
         * @summary Redirect user to salesforce
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSalesforceSSO(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.requestSalesforceSSO(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResetApi - factory interface
 * @export
 */
export const ResetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResetApiFp(configuration)

    /**
      * This endpoint accepts an email address to reset. 
      * @summary Request Password Reset
      * @param {ResetApiRequestResetRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const requestReset = (requestParameters: ResetApiRequestResetRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.requestReset(requestParameters, options);
        return request(axios, basePath);
    };

    requestReset.getQueryKey = (requestParameters: ResetApiRequestResetRequest, options?: any) => {
        const request = localVarFp.requestReset(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * This endpoint starts the sso process.  The client should redirect the user here, and this endpoint will sign a request and redirect the user to salesforce to start the sso request.  If successful, the sso will return the user to the client app, with a code that can be sent to the api via the salesforce_sso grant request 
      * @summary Redirect user to salesforce
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const requestSalesforceSSO = (requestParameters?: undefined, options?: any): AxiosPromise<void> => {
        const request = localVarFp.requestSalesforceSSO(requestParameters, options);
        return request(axios, basePath);
    };

    requestSalesforceSSO.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.requestSalesforceSSO(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        requestReset,
        requestSalesforceSSO,
    };
};

/**
 * ResetApi - interface
 * @export
 * @interface ResetApi
 */
export interface ResetApiInterface {
    /**
     * This endpoint accepts an email address to reset. 
     * @summary Request Password Reset
     * @param {ResetApiRequestResetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResetApiInterface
     */
    requestReset(requestParameters: ResetApiRequestResetRequest, options?: any): AxiosPromise<void>;

    /**
     * This endpoint starts the sso process.  The client should redirect the user here, and this endpoint will sign a request and redirect the user to salesforce to start the sso request.  If successful, the sso will return the user to the client app, with a code that can be sent to the api via the salesforce_sso grant request 
     * @summary Redirect user to salesforce
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResetApiInterface
     */
    requestSalesforceSSO(requestParameters?: undefined, options?: any): AxiosPromise<void>;

}

/**
 * Request parameters for requestReset operation in ResetApi.
 * @export
 * @interface ResetApiRequestResetRequest
 */
export interface ResetApiRequestResetRequest {
    /**
     * 
     * @type {RequestPasswordReset}
     * @memberof ResetApiRequestReset
     */
    readonly requestPasswordReset: RequestPasswordReset
}

/**
 * ResetApi - object-oriented interface
 * @export
 * @class ResetApi
 * @extends {BaseAPI}
 */
export class ResetApi extends BaseAPI implements ResetApiInterface {
    /**
     * This endpoint accepts an email address to reset. 
     * @summary Request Password Reset
     * @param {ResetApiRequestResetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResetApi
     */
    public requestReset(requestParameters: ResetApiRequestResetRequest, options?: any) {
        const request = ResetApiFp(this.configuration).requestReset(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * This endpoint starts the sso process.  The client should redirect the user here, and this endpoint will sign a request and redirect the user to salesforce to start the sso request.  If successful, the sso will return the user to the client app, with a code that can be sent to the api via the salesforce_sso grant request 
     * @summary Redirect user to salesforce
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResetApi
     */
    public requestSalesforceSSO(requestParameters?: undefined, options?: any) {
        const request = ResetApiFp(this.configuration).requestSalesforceSSO(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ResourceApi - axios parameter creator
 * @export
 */
export const ResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update a resource 
         * @summary Create resource
         * @param {CreateResourceBody} createResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResource: (createResourceBody: CreateResourceBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createResourceBody' is not null or undefined
            assertParamExists('createResource', 'createResourceBody', createResourceBody)
            const localVarPath = `/resource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createResourceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a resource with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete resource
         * @param {number} id The id of the resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteResource', 'id', id)
            const localVarPath = `/resource/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single resource by id 
         * @summary Get Resource
         * @param {number} id The id of the resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getResource', 'id', id)
            const localVarPath = `/resource/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single resource by id 
         * @summary Get Resource
         * @param {number} id The id of the category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceCategory: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getResourceCategory', 'id', id)
            const localVarPath = `/resource/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of resources counts groupped by topic. 
         * @summary Get Resources Dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesDashboard: (options: any = {}): RequestArgs => {
            const localVarPath = `/resources/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of resources. 
         * @summary List Resources
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {Array<ResourceStatus>} [status] 
         * @param {string} [topic] 
         * @param {string} [type] 
         * @param {boolean} [featured] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, status?: Array<ResourceStatus>, topic?: string, type?: string, featured?: boolean, options: any = {}): RequestArgs => {
            const localVarPath = `/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (featured !== undefined) {
                localVarQueryParameter['featured'] = featured;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a resource with a specific id 
         * @summary Update Resource
         * @param {number} id The id of the resource
         * @param {UpdateResourceBody} updateResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResource: (id: number, updateResourceBody: UpdateResourceBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateResource', 'id', id)
            // verify required parameter 'updateResourceBody' is not null or undefined
            assertParamExists('updateResource', 'updateResourceBody', updateResourceBody)
            const localVarPath = `/resource/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateResourceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResourceApi - functional programming interface
 * @export
 */
export const ResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * Update a resource 
         * @summary Create resource
         * @param {ResourceApiCreateResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResource(requestParameters: ResourceApiCreateResourceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Resource>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createResource(requestParameters.createResourceBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a resource with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete resource
         * @param {ResourceApiDeleteResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(requestParameters: ResourceApiDeleteResourceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteResource(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single resource by id 
         * @summary Get Resource
         * @param {ResourceApiGetResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResource(requestParameters: ResourceApiGetResourceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Resource>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getResource(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single resource by id 
         * @summary Get Resource
         * @param {ResourceApiGetResourceCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceCategory(requestParameters: ResourceApiGetResourceCategoryRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TaxonomyTermConnect>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getResourceCategory(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of resources counts groupped by topic. 
         * @summary Get Resources Dashboard
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourcesDashboard(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ResourcesDashboard>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getResourcesDashboard(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of resources. 
         * @summary List Resources
         * @param {ResourceApiListResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(requestParameters: ResourceApiListResourcesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedResources>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listResources(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.status, requestParameters.topic, requestParameters.type, requestParameters.featured, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a resource with a specific id 
         * @summary Update Resource
         * @param {ResourceApiUpdateResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResource(requestParameters: ResourceApiUpdateResourceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Resource>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateResource(requestParameters.id, requestParameters.updateResourceBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResourceApi - factory interface
 * @export
 */
export const ResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResourceApiFp(configuration)

    /**
      * Update a resource 
      * @summary Create resource
      * @param {ResourceApiCreateResourceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createResource = (requestParameters: ResourceApiCreateResourceRequest, options?: any): AxiosPromise<Resource> => {
        const request = localVarFp.createResource(requestParameters, options);
        return request(axios, basePath);
    };

    createResource.getQueryKey = (requestParameters: ResourceApiCreateResourceRequest, options?: any) => {
        const request = localVarFp.createResource(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a resource with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete resource
      * @param {ResourceApiDeleteResourceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteResource = (requestParameters: ResourceApiDeleteResourceRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteResource(requestParameters, options);
        return request(axios, basePath);
    };

    deleteResource.getQueryKey = (requestParameters: ResourceApiDeleteResourceRequest, options?: any) => {
        const request = localVarFp.deleteResource(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single resource by id 
      * @summary Get Resource
      * @param {ResourceApiGetResourceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getResource = (requestParameters: ResourceApiGetResourceRequest, options?: any): AxiosPromise<Resource> => {
        const request = localVarFp.getResource(requestParameters, options);
        return request(axios, basePath);
    };

    getResource.getQueryKey = (requestParameters: ResourceApiGetResourceRequest, options?: any) => {
        const request = localVarFp.getResource(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single resource by id 
      * @summary Get Resource
      * @param {ResourceApiGetResourceCategoryRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getResourceCategory = (requestParameters: ResourceApiGetResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect> => {
        const request = localVarFp.getResourceCategory(requestParameters, options);
        return request(axios, basePath);
    };

    getResourceCategory.getQueryKey = (requestParameters: ResourceApiGetResourceCategoryRequest, options?: any) => {
        const request = localVarFp.getResourceCategory(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of resources counts groupped by topic. 
      * @summary Get Resources Dashboard
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getResourcesDashboard = (requestParameters?: undefined, options?: any): AxiosPromise<ResourcesDashboard> => {
        const request = localVarFp.getResourcesDashboard(requestParameters, options);
        return request(axios, basePath);
    };

    getResourcesDashboard.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.getResourcesDashboard(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of resources. 
      * @summary List Resources
      * @param {ResourceApiListResourcesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listResources = (requestParameters: ResourceApiListResourcesRequest = {}, options?: any): AxiosPromise<PaginatedResources> => {
        const request = localVarFp.listResources(requestParameters, options);
        return request(axios, basePath);
    };

    listResources.getQueryKey = (requestParameters: ResourceApiListResourcesRequest = {}, options?: any) => {
        const request = localVarFp.listResources(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a resource with a specific id 
      * @summary Update Resource
      * @param {ResourceApiUpdateResourceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateResource = (requestParameters: ResourceApiUpdateResourceRequest, options?: any): AxiosPromise<Resource> => {
        const request = localVarFp.updateResource(requestParameters, options);
        return request(axios, basePath);
    };

    updateResource.getQueryKey = (requestParameters: ResourceApiUpdateResourceRequest, options?: any) => {
        const request = localVarFp.updateResource(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createResource,
        deleteResource,
        getResource,
        getResourceCategory,
        getResourcesDashboard,
        listResources,
        updateResource,
    };
};

/**
 * ResourceApi - interface
 * @export
 * @interface ResourceApi
 */
export interface ResourceApiInterface {
    /**
     * Update a resource 
     * @summary Create resource
     * @param {ResourceApiCreateResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApiInterface
     */
    createResource(requestParameters: ResourceApiCreateResourceRequest, options?: any): AxiosPromise<Resource>;

    /**
     * Delete a resource with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete resource
     * @param {ResourceApiDeleteResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApiInterface
     */
    deleteResource(requestParameters: ResourceApiDeleteResourceRequest, options?: any): AxiosPromise<void>;

    /**
     * Fetch a single resource by id 
     * @summary Get Resource
     * @param {ResourceApiGetResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApiInterface
     */
    getResource(requestParameters: ResourceApiGetResourceRequest, options?: any): AxiosPromise<Resource>;

    /**
     * Fetch a single resource by id 
     * @summary Get Resource
     * @param {ResourceApiGetResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApiInterface
     */
    getResourceCategory(requestParameters: ResourceApiGetResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect>;

    /**
     * Fetch a list of resources counts groupped by topic. 
     * @summary Get Resources Dashboard
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApiInterface
     */
    getResourcesDashboard(requestParameters?: undefined, options?: any): AxiosPromise<ResourcesDashboard>;

    /**
     * Fetch a list of resources. 
     * @summary List Resources
     * @param {ResourceApiListResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApiInterface
     */
    listResources(requestParameters?: ResourceApiListResourcesRequest, options?: any): AxiosPromise<PaginatedResources>;

    /**
     * Update a resource with a specific id 
     * @summary Update Resource
     * @param {ResourceApiUpdateResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApiInterface
     */
    updateResource(requestParameters: ResourceApiUpdateResourceRequest, options?: any): AxiosPromise<Resource>;

}

/**
 * Request parameters for createResource operation in ResourceApi.
 * @export
 * @interface ResourceApiCreateResourceRequest
 */
export interface ResourceApiCreateResourceRequest {
    /**
     * 
     * @type {CreateResourceBody}
     * @memberof ResourceApiCreateResource
     */
    readonly createResourceBody: CreateResourceBody
}

/**
 * Request parameters for deleteResource operation in ResourceApi.
 * @export
 * @interface ResourceApiDeleteResourceRequest
 */
export interface ResourceApiDeleteResourceRequest {
    /**
     * The id of the resource
     * @type {number}
     * @memberof ResourceApiDeleteResource
     */
    readonly id: number
}

/**
 * Request parameters for getResource operation in ResourceApi.
 * @export
 * @interface ResourceApiGetResourceRequest
 */
export interface ResourceApiGetResourceRequest {
    /**
     * The id of the resource
     * @type {number}
     * @memberof ResourceApiGetResource
     */
    readonly id: number
}

/**
 * Request parameters for getResourceCategory operation in ResourceApi.
 * @export
 * @interface ResourceApiGetResourceCategoryRequest
 */
export interface ResourceApiGetResourceCategoryRequest {
    /**
     * The id of the category
     * @type {number}
     * @memberof ResourceApiGetResourceCategory
     */
    readonly id: number
}

/**
 * Request parameters for listResources operation in ResourceApi.
 * @export
 * @interface ResourceApiListResourcesRequest
 */
export interface ResourceApiListResourcesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ResourceApiListResources
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ResourceApiListResources
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ResourceApiListResources
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ResourceApiListResources
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ResourceApiListResources
     */
    readonly search?: string

    /**
     * 
     * @type {Array<ResourceStatus>}
     * @memberof ResourceApiListResources
     */
    readonly status?: Array<ResourceStatus>

    /**
     * 
     * @type {string}
     * @memberof ResourceApiListResources
     */
    readonly topic?: string

    /**
     * 
     * @type {string}
     * @memberof ResourceApiListResources
     */
    readonly type?: string

    /**
     * 
     * @type {boolean}
     * @memberof ResourceApiListResources
     */
    readonly featured?: boolean
}

/**
 * Request parameters for updateResource operation in ResourceApi.
 * @export
 * @interface ResourceApiUpdateResourceRequest
 */
export interface ResourceApiUpdateResourceRequest {
    /**
     * The id of the resource
     * @type {number}
     * @memberof ResourceApiUpdateResource
     */
    readonly id: number

    /**
     * 
     * @type {UpdateResourceBody}
     * @memberof ResourceApiUpdateResource
     */
    readonly updateResourceBody: UpdateResourceBody
}

/**
 * ResourceApi - object-oriented interface
 * @export
 * @class ResourceApi
 * @extends {BaseAPI}
 */
export class ResourceApi extends BaseAPI implements ResourceApiInterface {
    /**
     * Update a resource 
     * @summary Create resource
     * @param {ResourceApiCreateResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApi
     */
    public createResource(requestParameters: ResourceApiCreateResourceRequest, options?: any) {
        const request = ResourceApiFp(this.configuration).createResource(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a resource with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete resource
     * @param {ResourceApiDeleteResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApi
     */
    public deleteResource(requestParameters: ResourceApiDeleteResourceRequest, options?: any) {
        const request = ResourceApiFp(this.configuration).deleteResource(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single resource by id 
     * @summary Get Resource
     * @param {ResourceApiGetResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApi
     */
    public getResource(requestParameters: ResourceApiGetResourceRequest, options?: any) {
        const request = ResourceApiFp(this.configuration).getResource(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single resource by id 
     * @summary Get Resource
     * @param {ResourceApiGetResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApi
     */
    public getResourceCategory(requestParameters: ResourceApiGetResourceCategoryRequest, options?: any) {
        const request = ResourceApiFp(this.configuration).getResourceCategory(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of resources counts groupped by topic. 
     * @summary Get Resources Dashboard
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApi
     */
    public getResourcesDashboard(requestParameters?: undefined, options?: any) {
        const request = ResourceApiFp(this.configuration).getResourcesDashboard(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of resources. 
     * @summary List Resources
     * @param {ResourceApiListResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApi
     */
    public listResources(requestParameters: ResourceApiListResourcesRequest = {}, options?: any) {
        const request = ResourceApiFp(this.configuration).listResources(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a resource with a specific id 
     * @summary Update Resource
     * @param {ResourceApiUpdateResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceApi
     */
    public updateResource(requestParameters: ResourceApiUpdateResourceRequest, options?: any) {
        const request = ResourceApiFp(this.configuration).updateResource(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ResourceCategoriesApi - axios parameter creator
 * @export
 */
export const ResourceCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a list of resource categories. 
         * @summary List Resource Categories
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourceCategories: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', options: any = {}): RequestArgs => {
            const localVarPath = `/resources/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResourceCategoriesApi - functional programming interface
 * @export
 */
export const ResourceCategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResourceCategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a list of resource categories. 
         * @summary List Resource Categories
         * @param {ResourceCategoriesApiListResourceCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourceCategories(requestParameters: ResourceCategoriesApiListResourceCategoriesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedTaxonomyTerm>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listResourceCategories(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResourceCategoriesApi - factory interface
 * @export
 */
export const ResourceCategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResourceCategoriesApiFp(configuration)

    /**
      * Fetch a list of resource categories. 
      * @summary List Resource Categories
      * @param {ResourceCategoriesApiListResourceCategoriesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listResourceCategories = (requestParameters: ResourceCategoriesApiListResourceCategoriesRequest = {}, options?: any): AxiosPromise<PaginatedTaxonomyTerm> => {
        const request = localVarFp.listResourceCategories(requestParameters, options);
        return request(axios, basePath);
    };

    listResourceCategories.getQueryKey = (requestParameters: ResourceCategoriesApiListResourceCategoriesRequest = {}, options?: any) => {
        const request = localVarFp.listResourceCategories(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        listResourceCategories,
    };
};

/**
 * ResourceCategoriesApi - interface
 * @export
 * @interface ResourceCategoriesApi
 */
export interface ResourceCategoriesApiInterface {
    /**
     * Fetch a list of resource categories. 
     * @summary List Resource Categories
     * @param {ResourceCategoriesApiListResourceCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceCategoriesApiInterface
     */
    listResourceCategories(requestParameters?: ResourceCategoriesApiListResourceCategoriesRequest, options?: any): AxiosPromise<PaginatedTaxonomyTerm>;

}

/**
 * Request parameters for listResourceCategories operation in ResourceCategoriesApi.
 * @export
 * @interface ResourceCategoriesApiListResourceCategoriesRequest
 */
export interface ResourceCategoriesApiListResourceCategoriesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ResourceCategoriesApiListResourceCategories
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ResourceCategoriesApiListResourceCategories
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ResourceCategoriesApiListResourceCategories
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ResourceCategoriesApiListResourceCategories
     */
    readonly direction?: 'asc' | 'desc'
}

/**
 * ResourceCategoriesApi - object-oriented interface
 * @export
 * @class ResourceCategoriesApi
 * @extends {BaseAPI}
 */
export class ResourceCategoriesApi extends BaseAPI implements ResourceCategoriesApiInterface {
    /**
     * Fetch a list of resource categories. 
     * @summary List Resource Categories
     * @param {ResourceCategoriesApiListResourceCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceCategoriesApi
     */
    public listResourceCategories(requestParameters: ResourceCategoriesApiListResourceCategoriesRequest = {}, options?: any) {
        const request = ResourceCategoriesApiFp(this.configuration).listResourceCategories(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ResourceCategoryApi - axios parameter creator
 * @export
 */
export const ResourceCategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update a resource category 
         * @summary Create resource category
         * @param {CreateCategoryBody} createCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResourceCategory: (createCategoryBody: CreateCategoryBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createCategoryBody' is not null or undefined
            assertParamExists('createResourceCategory', 'createCategoryBody', createCategoryBody)
            const localVarPath = `/resource/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResourceCategoryApi - functional programming interface
 * @export
 */
export const ResourceCategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResourceCategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Update a resource category 
         * @summary Create resource category
         * @param {ResourceCategoryApiCreateResourceCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResourceCategory(requestParameters: ResourceCategoryApiCreateResourceCategoryRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TaxonomyTermConnect>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createResourceCategory(requestParameters.createCategoryBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResourceCategoryApi - factory interface
 * @export
 */
export const ResourceCategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResourceCategoryApiFp(configuration)

    /**
      * Update a resource category 
      * @summary Create resource category
      * @param {ResourceCategoryApiCreateResourceCategoryRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createResourceCategory = (requestParameters: ResourceCategoryApiCreateResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect> => {
        const request = localVarFp.createResourceCategory(requestParameters, options);
        return request(axios, basePath);
    };

    createResourceCategory.getQueryKey = (requestParameters: ResourceCategoryApiCreateResourceCategoryRequest, options?: any) => {
        const request = localVarFp.createResourceCategory(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createResourceCategory,
    };
};

/**
 * ResourceCategoryApi - interface
 * @export
 * @interface ResourceCategoryApi
 */
export interface ResourceCategoryApiInterface {
    /**
     * Update a resource category 
     * @summary Create resource category
     * @param {ResourceCategoryApiCreateResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceCategoryApiInterface
     */
    createResourceCategory(requestParameters: ResourceCategoryApiCreateResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect>;

}

/**
 * Request parameters for createResourceCategory operation in ResourceCategoryApi.
 * @export
 * @interface ResourceCategoryApiCreateResourceCategoryRequest
 */
export interface ResourceCategoryApiCreateResourceCategoryRequest {
    /**
     * 
     * @type {CreateCategoryBody}
     * @memberof ResourceCategoryApiCreateResourceCategory
     */
    readonly createCategoryBody: CreateCategoryBody
}

/**
 * ResourceCategoryApi - object-oriented interface
 * @export
 * @class ResourceCategoryApi
 * @extends {BaseAPI}
 */
export class ResourceCategoryApi extends BaseAPI implements ResourceCategoryApiInterface {
    /**
     * Update a resource category 
     * @summary Create resource category
     * @param {ResourceCategoryApiCreateResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceCategoryApi
     */
    public createResourceCategory(requestParameters: ResourceCategoryApiCreateResourceCategoryRequest, options?: any) {
        const request = ResourceCategoryApiFp(this.configuration).createResourceCategory(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ResponseApi - axios parameter creator
 * @export
 */
export const ResponseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
         * @summary Respond to a quote
         * @param {number} id The id of the order
         * @param {CreateQuoteResponseBody} createQuoteResponseBody Parameters for requesting a quote request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondQuote: (id: number, createQuoteResponseBody: CreateQuoteResponseBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('respondQuote', 'id', id)
            // verify required parameter 'createQuoteResponseBody' is not null or undefined
            assertParamExists('respondQuote', 'createQuoteResponseBody', createQuoteResponseBody)
            const localVarPath = `/quote/{id}/respond`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuoteResponseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResponseApi - functional programming interface
 * @export
 */
export const ResponseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResponseApiAxiosParamCreator(configuration)
    return {
        /**
         * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
         * @summary Respond to a quote
         * @param {ResponseApiRespondQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondQuote(requestParameters: ResponseApiRespondQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Response>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.respondQuote(requestParameters.id, requestParameters.createQuoteResponseBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResponseApi - factory interface
 * @export
 */
export const ResponseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResponseApiFp(configuration)

    /**
      * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
      * @summary Respond to a quote
      * @param {ResponseApiRespondQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const respondQuote = (requestParameters: ResponseApiRespondQuoteRequest, options?: any): AxiosPromise<Response> => {
        const request = localVarFp.respondQuote(requestParameters, options);
        return request(axios, basePath);
    };

    respondQuote.getQueryKey = (requestParameters: ResponseApiRespondQuoteRequest, options?: any) => {
        const request = localVarFp.respondQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        respondQuote,
    };
};

/**
 * ResponseApi - interface
 * @export
 * @interface ResponseApi
 */
export interface ResponseApiInterface {
    /**
     * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
     * @summary Respond to a quote
     * @param {ResponseApiRespondQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResponseApiInterface
     */
    respondQuote(requestParameters: ResponseApiRespondQuoteRequest, options?: any): AxiosPromise<Response>;

}

/**
 * Request parameters for respondQuote operation in ResponseApi.
 * @export
 * @interface ResponseApiRespondQuoteRequest
 */
export interface ResponseApiRespondQuoteRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof ResponseApiRespondQuote
     */
    readonly id: number

    /**
     * Parameters for requesting a quote request
     * @type {CreateQuoteResponseBody}
     * @memberof ResponseApiRespondQuote
     */
    readonly createQuoteResponseBody: CreateQuoteResponseBody
}

/**
 * ResponseApi - object-oriented interface
 * @export
 * @class ResponseApi
 * @extends {BaseAPI}
 */
export class ResponseApi extends BaseAPI implements ResponseApiInterface {
    /**
     * Allows a user to respond to a quote.  Each response from a user creates a threaded event 
     * @summary Respond to a quote
     * @param {ResponseApiRespondQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResponseApi
     */
    public respondQuote(requestParameters: ResponseApiRespondQuoteRequest, options?: any) {
        const request = ResponseApiFp(this.configuration).respondQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * SalesforceApi - axios parameter creator
 * @export
 */
export const SalesforceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a single salesforce customer by id 
         * @summary Get a single Salesforce Customer
         * @param {number} id The id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceCustomer: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesforceCustomer', 'id', id)
            const localVarPath = `/salesforce/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single salesforce opportunity by id 
         * @summary Get a single Salesforce opportunity
         * @param {number} id The id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceOpportunity: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesforceOpportunity', 'id', id)
            const localVarPath = `/salesforce/opportunity/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
         * @summary List Salesforce Customers
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of salesforce customer records the current user has access to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceCustomers: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, options: any = {}): RequestArgs => {
            const localVarPath = `/salesforce/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
         * @summary List Salesforce opportunities
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of salesforce customer opportunities the current user has access to.
         * @param {number} [salesforceCustomerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceOpportunities: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, salesforceCustomerId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/salesforce/opportunities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (salesforceCustomerId !== undefined) {
                localVarQueryParameter['salesforce_customer_id'] = salesforceCustomerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fire a background task to fetch all the salesforce data from the last two days 
         * @summary Refresh the salesforce data
         * @param {string} id The salesforce id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSalesforce: (id: string, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshSalesforce', 'id', id)
            const localVarPath = `/salesforce/refresh`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh a single salesforce customer in the db 
         * @summary Refresh a single salesforce customer in the db
         * @param {string} id The salesforce id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceCustomer: (id: string, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('syncSalesforceCustomer', 'id', id)
            const localVarPath = `/salesforce/customer/{id}/sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single salesforce customer while resyncing the customer from the db 
         * @summary Sync a single Salesforce opportunity
         * @param {string} id The salesforce id of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceOpportunity: (id: string, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('syncSalesforceOpportunity', 'id', id)
            const localVarPath = `/salesforce/opportunity/{id}/sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesforceApi - functional programming interface
 * @export
 */
export const SalesforceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesforceApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a single salesforce customer by id 
         * @summary Get a single Salesforce Customer
         * @param {SalesforceApiGetSalesforceCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceCustomer(requestParameters: SalesforceApiGetSalesforceCustomerRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceCustomer>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getSalesforceCustomer(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single salesforce opportunity by id 
         * @summary Get a single Salesforce opportunity
         * @param {SalesforceApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesforceOpportunity(requestParameters: SalesforceApiGetSalesforceOpportunityRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceOpportunity>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getSalesforceOpportunity(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
         * @summary List Salesforce Customers
         * @param {SalesforceApiListSalesforceCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceCustomers(requestParameters: SalesforceApiListSalesforceCustomersRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedSalesforceCustomers>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listSalesforceCustomers(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
         * @summary List Salesforce opportunities
         * @param {SalesforceApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesforceOpportunities(requestParameters: SalesforceApiListSalesforceOpportunitiesRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedSalesforceOpportunities>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listSalesforceOpportunities(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.salesforceCustomerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fire a background task to fetch all the salesforce data from the last two days 
         * @summary Refresh the salesforce data
         * @param {SalesforceApiRefreshSalesforceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSalesforce(requestParameters: SalesforceApiRefreshSalesforceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.refreshSalesforce(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Refresh a single salesforce customer in the db 
         * @summary Refresh a single salesforce customer in the db
         * @param {SalesforceApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceCustomer(requestParameters: SalesforceApiSyncSalesforceCustomerRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceCustomer>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.syncSalesforceCustomer(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single salesforce customer while resyncing the customer from the db 
         * @summary Sync a single Salesforce opportunity
         * @param {SalesforceApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSalesforceOpportunity(requestParameters: SalesforceApiSyncSalesforceOpportunityRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SalesforceOpportunity>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.syncSalesforceOpportunity(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SalesforceApi - factory interface
 * @export
 */
export const SalesforceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesforceApiFp(configuration)

    /**
      * Fetch a single salesforce customer by id 
      * @summary Get a single Salesforce Customer
      * @param {SalesforceApiGetSalesforceCustomerRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getSalesforceCustomer = (requestParameters: SalesforceApiGetSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer> => {
        const request = localVarFp.getSalesforceCustomer(requestParameters, options);
        return request(axios, basePath);
    };

    getSalesforceCustomer.getQueryKey = (requestParameters: SalesforceApiGetSalesforceCustomerRequest, options?: any) => {
        const request = localVarFp.getSalesforceCustomer(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single salesforce opportunity by id 
      * @summary Get a single Salesforce opportunity
      * @param {SalesforceApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getSalesforceOpportunity = (requestParameters: SalesforceApiGetSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity> => {
        const request = localVarFp.getSalesforceOpportunity(requestParameters, options);
        return request(axios, basePath);
    };

    getSalesforceOpportunity.getQueryKey = (requestParameters: SalesforceApiGetSalesforceOpportunityRequest, options?: any) => {
        const request = localVarFp.getSalesforceOpportunity(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
      * @summary List Salesforce Customers
      * @param {SalesforceApiListSalesforceCustomersRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listSalesforceCustomers = (requestParameters: SalesforceApiListSalesforceCustomersRequest = {}, options?: any): AxiosPromise<PaginatedSalesforceCustomers> => {
        const request = localVarFp.listSalesforceCustomers(requestParameters, options);
        return request(axios, basePath);
    };

    listSalesforceCustomers.getQueryKey = (requestParameters: SalesforceApiListSalesforceCustomersRequest = {}, options?: any) => {
        const request = localVarFp.listSalesforceCustomers(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
      * @summary List Salesforce opportunities
      * @param {SalesforceApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listSalesforceOpportunities = (requestParameters: SalesforceApiListSalesforceOpportunitiesRequest = {}, options?: any): AxiosPromise<PaginatedSalesforceOpportunities> => {
        const request = localVarFp.listSalesforceOpportunities(requestParameters, options);
        return request(axios, basePath);
    };

    listSalesforceOpportunities.getQueryKey = (requestParameters: SalesforceApiListSalesforceOpportunitiesRequest = {}, options?: any) => {
        const request = localVarFp.listSalesforceOpportunities(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fire a background task to fetch all the salesforce data from the last two days 
      * @summary Refresh the salesforce data
      * @param {SalesforceApiRefreshSalesforceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const refreshSalesforce = (requestParameters: SalesforceApiRefreshSalesforceRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.refreshSalesforce(requestParameters, options);
        return request(axios, basePath);
    };

    refreshSalesforce.getQueryKey = (requestParameters: SalesforceApiRefreshSalesforceRequest, options?: any) => {
        const request = localVarFp.refreshSalesforce(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Refresh a single salesforce customer in the db 
      * @summary Refresh a single salesforce customer in the db
      * @param {SalesforceApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const syncSalesforceCustomer = (requestParameters: SalesforceApiSyncSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer> => {
        const request = localVarFp.syncSalesforceCustomer(requestParameters, options);
        return request(axios, basePath);
    };

    syncSalesforceCustomer.getQueryKey = (requestParameters: SalesforceApiSyncSalesforceCustomerRequest, options?: any) => {
        const request = localVarFp.syncSalesforceCustomer(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single salesforce customer while resyncing the customer from the db 
      * @summary Sync a single Salesforce opportunity
      * @param {SalesforceApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const syncSalesforceOpportunity = (requestParameters: SalesforceApiSyncSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity> => {
        const request = localVarFp.syncSalesforceOpportunity(requestParameters, options);
        return request(axios, basePath);
    };

    syncSalesforceOpportunity.getQueryKey = (requestParameters: SalesforceApiSyncSalesforceOpportunityRequest, options?: any) => {
        const request = localVarFp.syncSalesforceOpportunity(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        getSalesforceCustomer,
        getSalesforceOpportunity,
        listSalesforceCustomers,
        listSalesforceOpportunities,
        refreshSalesforce,
        syncSalesforceCustomer,
        syncSalesforceOpportunity,
    };
};

/**
 * SalesforceApi - interface
 * @export
 * @interface SalesforceApi
 */
export interface SalesforceApiInterface {
    /**
     * Fetch a single salesforce customer by id 
     * @summary Get a single Salesforce Customer
     * @param {SalesforceApiGetSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApiInterface
     */
    getSalesforceCustomer(requestParameters: SalesforceApiGetSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer>;

    /**
     * Fetch a single salesforce opportunity by id 
     * @summary Get a single Salesforce opportunity
     * @param {SalesforceApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApiInterface
     */
    getSalesforceOpportunity(requestParameters: SalesforceApiGetSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity>;

    /**
     * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
     * @summary List Salesforce Customers
     * @param {SalesforceApiListSalesforceCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApiInterface
     */
    listSalesforceCustomers(requestParameters?: SalesforceApiListSalesforceCustomersRequest, options?: any): AxiosPromise<PaginatedSalesforceCustomers>;

    /**
     * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
     * @summary List Salesforce opportunities
     * @param {SalesforceApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApiInterface
     */
    listSalesforceOpportunities(requestParameters?: SalesforceApiListSalesforceOpportunitiesRequest, options?: any): AxiosPromise<PaginatedSalesforceOpportunities>;

    /**
     * Fire a background task to fetch all the salesforce data from the last two days 
     * @summary Refresh the salesforce data
     * @param {SalesforceApiRefreshSalesforceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApiInterface
     */
    refreshSalesforce(requestParameters: SalesforceApiRefreshSalesforceRequest, options?: any): AxiosPromise<void>;

    /**
     * Refresh a single salesforce customer in the db 
     * @summary Refresh a single salesforce customer in the db
     * @param {SalesforceApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApiInterface
     */
    syncSalesforceCustomer(requestParameters: SalesforceApiSyncSalesforceCustomerRequest, options?: any): AxiosPromise<SalesforceCustomer>;

    /**
     * Fetch a single salesforce customer while resyncing the customer from the db 
     * @summary Sync a single Salesforce opportunity
     * @param {SalesforceApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApiInterface
     */
    syncSalesforceOpportunity(requestParameters: SalesforceApiSyncSalesforceOpportunityRequest, options?: any): AxiosPromise<SalesforceOpportunity>;

}

/**
 * Request parameters for getSalesforceCustomer operation in SalesforceApi.
 * @export
 * @interface SalesforceApiGetSalesforceCustomerRequest
 */
export interface SalesforceApiGetSalesforceCustomerRequest {
    /**
     * The id of the customer
     * @type {number}
     * @memberof SalesforceApiGetSalesforceCustomer
     */
    readonly id: number
}

/**
 * Request parameters for getSalesforceOpportunity operation in SalesforceApi.
 * @export
 * @interface SalesforceApiGetSalesforceOpportunityRequest
 */
export interface SalesforceApiGetSalesforceOpportunityRequest {
    /**
     * The id of the customer
     * @type {number}
     * @memberof SalesforceApiGetSalesforceOpportunity
     */
    readonly id: number
}

/**
 * Request parameters for listSalesforceCustomers operation in SalesforceApi.
 * @export
 * @interface SalesforceApiListSalesforceCustomersRequest
 */
export interface SalesforceApiListSalesforceCustomersRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof SalesforceApiListSalesforceCustomers
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof SalesforceApiListSalesforceCustomers
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof SalesforceApiListSalesforceCustomers
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof SalesforceApiListSalesforceCustomers
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of salesforce customer records the current user has access to.
     * @type {string}
     * @memberof SalesforceApiListSalesforceCustomers
     */
    readonly search?: string
}

/**
 * Request parameters for listSalesforceOpportunities operation in SalesforceApi.
 * @export
 * @interface SalesforceApiListSalesforceOpportunitiesRequest
 */
export interface SalesforceApiListSalesforceOpportunitiesRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof SalesforceApiListSalesforceOpportunities
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof SalesforceApiListSalesforceOpportunities
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof SalesforceApiListSalesforceOpportunities
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof SalesforceApiListSalesforceOpportunities
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of salesforce customer opportunities the current user has access to.
     * @type {string}
     * @memberof SalesforceApiListSalesforceOpportunities
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof SalesforceApiListSalesforceOpportunities
     */
    readonly salesforceCustomerId?: number
}

/**
 * Request parameters for refreshSalesforce operation in SalesforceApi.
 * @export
 * @interface SalesforceApiRefreshSalesforceRequest
 */
export interface SalesforceApiRefreshSalesforceRequest {
    /**
     * The salesforce id of the customer
     * @type {string}
     * @memberof SalesforceApiRefreshSalesforce
     */
    readonly id: string
}

/**
 * Request parameters for syncSalesforceCustomer operation in SalesforceApi.
 * @export
 * @interface SalesforceApiSyncSalesforceCustomerRequest
 */
export interface SalesforceApiSyncSalesforceCustomerRequest {
    /**
     * The salesforce id of the customer
     * @type {string}
     * @memberof SalesforceApiSyncSalesforceCustomer
     */
    readonly id: string
}

/**
 * Request parameters for syncSalesforceOpportunity operation in SalesforceApi.
 * @export
 * @interface SalesforceApiSyncSalesforceOpportunityRequest
 */
export interface SalesforceApiSyncSalesforceOpportunityRequest {
    /**
     * The salesforce id of the customer
     * @type {string}
     * @memberof SalesforceApiSyncSalesforceOpportunity
     */
    readonly id: string
}

/**
 * SalesforceApi - object-oriented interface
 * @export
 * @class SalesforceApi
 * @extends {BaseAPI}
 */
export class SalesforceApi extends BaseAPI implements SalesforceApiInterface {
    /**
     * Fetch a single salesforce customer by id 
     * @summary Get a single Salesforce Customer
     * @param {SalesforceApiGetSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public getSalesforceCustomer(requestParameters: SalesforceApiGetSalesforceCustomerRequest, options?: any) {
        const request = SalesforceApiFp(this.configuration).getSalesforceCustomer(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single salesforce opportunity by id 
     * @summary Get a single Salesforce opportunity
     * @param {SalesforceApiGetSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public getSalesforceOpportunity(requestParameters: SalesforceApiGetSalesforceOpportunityRequest, options?: any) {
        const request = SalesforceApiFp(this.configuration).getSalesforceOpportunity(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of Salesforce Customers. Can be searched to get a subset of customers 
     * @summary List Salesforce Customers
     * @param {SalesforceApiListSalesforceCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public listSalesforceCustomers(requestParameters: SalesforceApiListSalesforceCustomersRequest = {}, options?: any) {
        const request = SalesforceApiFp(this.configuration).listSalesforceCustomers(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of Salesforce opportunities. Can be searched to get a subset of opportunities 
     * @summary List Salesforce opportunities
     * @param {SalesforceApiListSalesforceOpportunitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public listSalesforceOpportunities(requestParameters: SalesforceApiListSalesforceOpportunitiesRequest = {}, options?: any) {
        const request = SalesforceApiFp(this.configuration).listSalesforceOpportunities(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fire a background task to fetch all the salesforce data from the last two days 
     * @summary Refresh the salesforce data
     * @param {SalesforceApiRefreshSalesforceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public refreshSalesforce(requestParameters: SalesforceApiRefreshSalesforceRequest, options?: any) {
        const request = SalesforceApiFp(this.configuration).refreshSalesforce(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Refresh a single salesforce customer in the db 
     * @summary Refresh a single salesforce customer in the db
     * @param {SalesforceApiSyncSalesforceCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public syncSalesforceCustomer(requestParameters: SalesforceApiSyncSalesforceCustomerRequest, options?: any) {
        const request = SalesforceApiFp(this.configuration).syncSalesforceCustomer(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single salesforce customer while resyncing the customer from the db 
     * @summary Sync a single Salesforce opportunity
     * @param {SalesforceApiSyncSalesforceOpportunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public syncSalesforceOpportunity(requestParameters: SalesforceApiSyncSalesforceOpportunityRequest, options?: any) {
        const request = SalesforceApiFp(this.configuration).syncSalesforceOpportunity(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ScormApi - axios parameter creator
 * @export
 */
export const ScormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a scorm with a specific id 
         * @summary Create Scorm File
         * @param {CreateScormBody} createScormBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScorm: (createScormBody: CreateScormBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createScormBody' is not null or undefined
            assertParamExists('createScorm', 'createScormBody', createScormBody)
            const localVarPath = `/scorm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createScormBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a scorm with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Scorm
         * @param {number} id The id of the Scorm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScorm: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteScorm', 'id', id)
            const localVarPath = `/scorm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single scorm by id 
         * @summary Get Scorm Progress for authenticated user
         * @param {number} id The id of the scorm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgress: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProgress', 'id', id)
            const localVarPath = `/scorm/progress/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single scorm by id 
         * @summary Get Scorm File
         * @param {number} id The id of the scorm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScorm: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getScorm', 'id', id)
            const localVarPath = `/scorm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of scores for a scorm or a user 
         * @summary Get scores list
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {string} [state] Filters scorm list by passed/incomplete state
         * @param {number} [scormId] The id of the scorm
         * @param {number} [userId] The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScormTrackings: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, state?: string, scormId?: number, userId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/scorm/tracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (scormId !== undefined) {
                localVarQueryParameter['scorm_id'] = scormId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of scorms.  This route only is available to symmons admins 
         * @summary List Scorms
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {number} [scormId] Filters scorm files
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScorms: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, scormId?: number, state?: string, options: any = {}): RequestArgs => {
            const localVarPath = `/scorms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (scormId !== undefined) {
                localVarQueryParameter['scorm_id'] = scormId;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset all user progress 
         * @summary Reset all user progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAllUserProgress: (options: any = {}): RequestArgs => {
            const localVarPath = `/scorm/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or Update a scorm progress for authenticated user and scorm 
         * @summary Update Scorm progress for authenticated user
         * @param {number} id The id of the scorm
         * @param {UpdateScormProgressBody} updateScormProgressBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProgress: (id: number, updateScormProgressBody: UpdateScormProgressBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('saveProgress', 'id', id)
            // verify required parameter 'updateScormProgressBody' is not null or undefined
            assertParamExists('saveProgress', 'updateScormProgressBody', updateScormProgressBody)
            const localVarPath = `/scorm/progress/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateScormProgressBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a scorm with a specific id 
         * @summary Update Scorm
         * @param {number} id The id of the scorm
         * @param {UpdateScormBody} updateScormBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScorm: (id: number, updateScormBody: UpdateScormBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateScorm', 'id', id)
            // verify required parameter 'updateScormBody' is not null or undefined
            assertParamExists('updateScorm', 'updateScormBody', updateScormBody)
            const localVarPath = `/scorm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateScormBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScormApi - functional programming interface
 * @export
 */
export const ScormApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScormApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a scorm with a specific id 
         * @summary Create Scorm File
         * @param {ScormApiCreateScormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScorm(requestParameters: ScormApiCreateScormRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Scorm>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createScorm(requestParameters.createScormBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a scorm with a specific id.  Deletes are soft, so they can be recovered 
         * @summary Delete Scorm
         * @param {ScormApiDeleteScormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScorm(requestParameters: ScormApiDeleteScormRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteScorm(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single scorm by id 
         * @summary Get Scorm Progress for authenticated user
         * @param {ScormApiGetProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgress(requestParameters: ScormApiGetProgressRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ScormScoTracking>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getProgress(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single scorm by id 
         * @summary Get Scorm File
         * @param {ScormApiGetScormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScorm(requestParameters: ScormApiGetScormRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Scorm>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getScorm(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of scores for a scorm or a user 
         * @summary Get scores list
         * @param {ScormApiListScormTrackingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScormTrackings(requestParameters: ScormApiListScormTrackingsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedScormScoTracking>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listScormTrackings(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.state, requestParameters.scormId, requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of scorms.  This route only is available to symmons admins 
         * @summary List Scorms
         * @param {ScormApiListScormsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScorms(requestParameters: ScormApiListScormsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedScorms>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listScorms(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.scormId, requestParameters.state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reset all user progress 
         * @summary Reset all user progress
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAllUserProgress(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<SuccessModel>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.resetAllUserProgress(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create or Update a scorm progress for authenticated user and scorm 
         * @summary Update Scorm progress for authenticated user
         * @param {ScormApiSaveProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProgress(requestParameters: ScormApiSaveProgressRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ScormScoTracking>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.saveProgress(requestParameters.id, requestParameters.updateScormProgressBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a scorm with a specific id 
         * @summary Update Scorm
         * @param {ScormApiUpdateScormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScorm(requestParameters: ScormApiUpdateScormRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Scorm>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateScorm(requestParameters.id, requestParameters.updateScormBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ScormApi - factory interface
 * @export
 */
export const ScormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScormApiFp(configuration)

    /**
      * Create a scorm with a specific id 
      * @summary Create Scorm File
      * @param {ScormApiCreateScormRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createScorm = (requestParameters: ScormApiCreateScormRequest, options?: any): AxiosPromise<Scorm> => {
        const request = localVarFp.createScorm(requestParameters, options);
        return request(axios, basePath);
    };

    createScorm.getQueryKey = (requestParameters: ScormApiCreateScormRequest, options?: any) => {
        const request = localVarFp.createScorm(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a scorm with a specific id.  Deletes are soft, so they can be recovered 
      * @summary Delete Scorm
      * @param {ScormApiDeleteScormRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteScorm = (requestParameters: ScormApiDeleteScormRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteScorm(requestParameters, options);
        return request(axios, basePath);
    };

    deleteScorm.getQueryKey = (requestParameters: ScormApiDeleteScormRequest, options?: any) => {
        const request = localVarFp.deleteScorm(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single scorm by id 
      * @summary Get Scorm Progress for authenticated user
      * @param {ScormApiGetProgressRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getProgress = (requestParameters: ScormApiGetProgressRequest, options?: any): AxiosPromise<ScormScoTracking> => {
        const request = localVarFp.getProgress(requestParameters, options);
        return request(axios, basePath);
    };

    getProgress.getQueryKey = (requestParameters: ScormApiGetProgressRequest, options?: any) => {
        const request = localVarFp.getProgress(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single scorm by id 
      * @summary Get Scorm File
      * @param {ScormApiGetScormRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getScorm = (requestParameters: ScormApiGetScormRequest, options?: any): AxiosPromise<Scorm> => {
        const request = localVarFp.getScorm(requestParameters, options);
        return request(axios, basePath);
    };

    getScorm.getQueryKey = (requestParameters: ScormApiGetScormRequest, options?: any) => {
        const request = localVarFp.getScorm(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of scores for a scorm or a user 
      * @summary Get scores list
      * @param {ScormApiListScormTrackingsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listScormTrackings = (requestParameters: ScormApiListScormTrackingsRequest = {}, options?: any): AxiosPromise<PaginatedScormScoTracking> => {
        const request = localVarFp.listScormTrackings(requestParameters, options);
        return request(axios, basePath);
    };

    listScormTrackings.getQueryKey = (requestParameters: ScormApiListScormTrackingsRequest = {}, options?: any) => {
        const request = localVarFp.listScormTrackings(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of scorms.  This route only is available to symmons admins 
      * @summary List Scorms
      * @param {ScormApiListScormsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listScorms = (requestParameters: ScormApiListScormsRequest = {}, options?: any): AxiosPromise<PaginatedScorms> => {
        const request = localVarFp.listScorms(requestParameters, options);
        return request(axios, basePath);
    };

    listScorms.getQueryKey = (requestParameters: ScormApiListScormsRequest = {}, options?: any) => {
        const request = localVarFp.listScorms(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Reset all user progress 
      * @summary Reset all user progress
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const resetAllUserProgress = (requestParameters?: undefined, options?: any): AxiosPromise<SuccessModel> => {
        const request = localVarFp.resetAllUserProgress(requestParameters, options);
        return request(axios, basePath);
    };

    resetAllUserProgress.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.resetAllUserProgress(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Create or Update a scorm progress for authenticated user and scorm 
      * @summary Update Scorm progress for authenticated user
      * @param {ScormApiSaveProgressRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const saveProgress = (requestParameters: ScormApiSaveProgressRequest, options?: any): AxiosPromise<ScormScoTracking> => {
        const request = localVarFp.saveProgress(requestParameters, options);
        return request(axios, basePath);
    };

    saveProgress.getQueryKey = (requestParameters: ScormApiSaveProgressRequest, options?: any) => {
        const request = localVarFp.saveProgress(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a scorm with a specific id 
      * @summary Update Scorm
      * @param {ScormApiUpdateScormRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateScorm = (requestParameters: ScormApiUpdateScormRequest, options?: any): AxiosPromise<Scorm> => {
        const request = localVarFp.updateScorm(requestParameters, options);
        return request(axios, basePath);
    };

    updateScorm.getQueryKey = (requestParameters: ScormApiUpdateScormRequest, options?: any) => {
        const request = localVarFp.updateScorm(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createScorm,
        deleteScorm,
        getProgress,
        getScorm,
        listScormTrackings,
        listScorms,
        resetAllUserProgress,
        saveProgress,
        updateScorm,
    };
};

/**
 * ScormApi - interface
 * @export
 * @interface ScormApi
 */
export interface ScormApiInterface {
    /**
     * Create a scorm with a specific id 
     * @summary Create Scorm File
     * @param {ScormApiCreateScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApiInterface
     */
    createScorm(requestParameters: ScormApiCreateScormRequest, options?: any): AxiosPromise<Scorm>;

    /**
     * Delete a scorm with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Scorm
     * @param {ScormApiDeleteScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApiInterface
     */
    deleteScorm(requestParameters: ScormApiDeleteScormRequest, options?: any): AxiosPromise<void>;

    /**
     * Fetch a single scorm by id 
     * @summary Get Scorm Progress for authenticated user
     * @param {ScormApiGetProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApiInterface
     */
    getProgress(requestParameters: ScormApiGetProgressRequest, options?: any): AxiosPromise<ScormScoTracking>;

    /**
     * Fetch a single scorm by id 
     * @summary Get Scorm File
     * @param {ScormApiGetScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApiInterface
     */
    getScorm(requestParameters: ScormApiGetScormRequest, options?: any): AxiosPromise<Scorm>;

    /**
     * Fetch a list of scores for a scorm or a user 
     * @summary Get scores list
     * @param {ScormApiListScormTrackingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApiInterface
     */
    listScormTrackings(requestParameters?: ScormApiListScormTrackingsRequest, options?: any): AxiosPromise<PaginatedScormScoTracking>;

    /**
     * Fetch a list of scorms.  This route only is available to symmons admins 
     * @summary List Scorms
     * @param {ScormApiListScormsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApiInterface
     */
    listScorms(requestParameters?: ScormApiListScormsRequest, options?: any): AxiosPromise<PaginatedScorms>;

    /**
     * Reset all user progress 
     * @summary Reset all user progress
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApiInterface
     */
    resetAllUserProgress(requestParameters?: undefined, options?: any): AxiosPromise<SuccessModel>;

    /**
     * Create or Update a scorm progress for authenticated user and scorm 
     * @summary Update Scorm progress for authenticated user
     * @param {ScormApiSaveProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApiInterface
     */
    saveProgress(requestParameters: ScormApiSaveProgressRequest, options?: any): AxiosPromise<ScormScoTracking>;

    /**
     * Update a scorm with a specific id 
     * @summary Update Scorm
     * @param {ScormApiUpdateScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApiInterface
     */
    updateScorm(requestParameters: ScormApiUpdateScormRequest, options?: any): AxiosPromise<Scorm>;

}

/**
 * Request parameters for createScorm operation in ScormApi.
 * @export
 * @interface ScormApiCreateScormRequest
 */
export interface ScormApiCreateScormRequest {
    /**
     * 
     * @type {CreateScormBody}
     * @memberof ScormApiCreateScorm
     */
    readonly createScormBody: CreateScormBody
}

/**
 * Request parameters for deleteScorm operation in ScormApi.
 * @export
 * @interface ScormApiDeleteScormRequest
 */
export interface ScormApiDeleteScormRequest {
    /**
     * The id of the Scorm
     * @type {number}
     * @memberof ScormApiDeleteScorm
     */
    readonly id: number
}

/**
 * Request parameters for getProgress operation in ScormApi.
 * @export
 * @interface ScormApiGetProgressRequest
 */
export interface ScormApiGetProgressRequest {
    /**
     * The id of the scorm
     * @type {number}
     * @memberof ScormApiGetProgress
     */
    readonly id: number
}

/**
 * Request parameters for getScorm operation in ScormApi.
 * @export
 * @interface ScormApiGetScormRequest
 */
export interface ScormApiGetScormRequest {
    /**
     * The id of the scorm
     * @type {number}
     * @memberof ScormApiGetScorm
     */
    readonly id: number
}

/**
 * Request parameters for listScormTrackings operation in ScormApi.
 * @export
 * @interface ScormApiListScormTrackingsRequest
 */
export interface ScormApiListScormTrackingsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ScormApiListScormTrackings
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ScormApiListScormTrackings
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ScormApiListScormTrackings
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ScormApiListScormTrackings
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ScormApiListScormTrackings
     */
    readonly search?: string

    /**
     * Filters scorm list by passed/incomplete state
     * @type {string}
     * @memberof ScormApiListScormTrackings
     */
    readonly state?: string

    /**
     * The id of the scorm
     * @type {number}
     * @memberof ScormApiListScormTrackings
     */
    readonly scormId?: number

    /**
     * The id of the user
     * @type {number}
     * @memberof ScormApiListScormTrackings
     */
    readonly userId?: number
}

/**
 * Request parameters for listScorms operation in ScormApi.
 * @export
 * @interface ScormApiListScormsRequest
 */
export interface ScormApiListScormsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof ScormApiListScorms
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof ScormApiListScorms
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof ScormApiListScorms
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof ScormApiListScorms
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof ScormApiListScorms
     */
    readonly search?: string

    /**
     * Filters scorm files
     * @type {number}
     * @memberof ScormApiListScorms
     */
    readonly scormId?: number

    /**
     * 
     * @type {string}
     * @memberof ScormApiListScorms
     */
    readonly state?: string
}

/**
 * Request parameters for saveProgress operation in ScormApi.
 * @export
 * @interface ScormApiSaveProgressRequest
 */
export interface ScormApiSaveProgressRequest {
    /**
     * The id of the scorm
     * @type {number}
     * @memberof ScormApiSaveProgress
     */
    readonly id: number

    /**
     * 
     * @type {UpdateScormProgressBody}
     * @memberof ScormApiSaveProgress
     */
    readonly updateScormProgressBody: UpdateScormProgressBody
}

/**
 * Request parameters for updateScorm operation in ScormApi.
 * @export
 * @interface ScormApiUpdateScormRequest
 */
export interface ScormApiUpdateScormRequest {
    /**
     * The id of the scorm
     * @type {number}
     * @memberof ScormApiUpdateScorm
     */
    readonly id: number

    /**
     * 
     * @type {UpdateScormBody}
     * @memberof ScormApiUpdateScorm
     */
    readonly updateScormBody: UpdateScormBody
}

/**
 * ScormApi - object-oriented interface
 * @export
 * @class ScormApi
 * @extends {BaseAPI}
 */
export class ScormApi extends BaseAPI implements ScormApiInterface {
    /**
     * Create a scorm with a specific id 
     * @summary Create Scorm File
     * @param {ScormApiCreateScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public createScorm(requestParameters: ScormApiCreateScormRequest, options?: any) {
        const request = ScormApiFp(this.configuration).createScorm(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a scorm with a specific id.  Deletes are soft, so they can be recovered 
     * @summary Delete Scorm
     * @param {ScormApiDeleteScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public deleteScorm(requestParameters: ScormApiDeleteScormRequest, options?: any) {
        const request = ScormApiFp(this.configuration).deleteScorm(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single scorm by id 
     * @summary Get Scorm Progress for authenticated user
     * @param {ScormApiGetProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public getProgress(requestParameters: ScormApiGetProgressRequest, options?: any) {
        const request = ScormApiFp(this.configuration).getProgress(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single scorm by id 
     * @summary Get Scorm File
     * @param {ScormApiGetScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public getScorm(requestParameters: ScormApiGetScormRequest, options?: any) {
        const request = ScormApiFp(this.configuration).getScorm(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of scores for a scorm or a user 
     * @summary Get scores list
     * @param {ScormApiListScormTrackingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public listScormTrackings(requestParameters: ScormApiListScormTrackingsRequest = {}, options?: any) {
        const request = ScormApiFp(this.configuration).listScormTrackings(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of scorms.  This route only is available to symmons admins 
     * @summary List Scorms
     * @param {ScormApiListScormsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public listScorms(requestParameters: ScormApiListScormsRequest = {}, options?: any) {
        const request = ScormApiFp(this.configuration).listScorms(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Reset all user progress 
     * @summary Reset all user progress
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public resetAllUserProgress(requestParameters?: undefined, options?: any) {
        const request = ScormApiFp(this.configuration).resetAllUserProgress(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Create or Update a scorm progress for authenticated user and scorm 
     * @summary Update Scorm progress for authenticated user
     * @param {ScormApiSaveProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public saveProgress(requestParameters: ScormApiSaveProgressRequest, options?: any) {
        const request = ScormApiFp(this.configuration).saveProgress(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a scorm with a specific id 
     * @summary Update Scorm
     * @param {ScormApiUpdateScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public updateScorm(requestParameters: ScormApiUpdateScormRequest, options?: any) {
        const request = ScormApiFp(this.configuration).updateScorm(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * SearchApi - axios parameter creator
 * @export
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Give a type of content to search on and a partial match, this will return common search terms that match 
         * @summary Autocomplete Search
         * @param {string} type The entity type that we want to autocomplete on
         * @param {string} query A short string to do a partial match on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autocomplete: (type: string, query: string, options: any = {}): RequestArgs => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('autocomplete', 'type', type)
            // verify required parameter 'query' is not null or undefined
            assertParamExists('autocomplete', 'query', query)
            const localVarPath = `/autocomplete/{type}/{query}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"query"}}`, encodeURIComponent(String(query)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 * @export
 */
export const SearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Give a type of content to search on and a partial match, this will return common search terms that match 
         * @summary Autocomplete Search
         * @param {SearchApiAutocompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autocomplete(requestParameters: SearchApiAutocompleteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Array<AutocompleteResult>>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.autocomplete(requestParameters.type, requestParameters.query, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchApi - factory interface
 * @export
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchApiFp(configuration)

    /**
      * Give a type of content to search on and a partial match, this will return common search terms that match 
      * @summary Autocomplete Search
      * @param {SearchApiAutocompleteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const autocomplete = (requestParameters: SearchApiAutocompleteRequest, options?: any): AxiosPromise<Array<AutocompleteResult>> => {
        const request = localVarFp.autocomplete(requestParameters, options);
        return request(axios, basePath);
    };

    autocomplete.getQueryKey = (requestParameters: SearchApiAutocompleteRequest, options?: any) => {
        const request = localVarFp.autocomplete(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        autocomplete,
    };
};

/**
 * SearchApi - interface
 * @export
 * @interface SearchApi
 */
export interface SearchApiInterface {
    /**
     * Give a type of content to search on and a partial match, this will return common search terms that match 
     * @summary Autocomplete Search
     * @param {SearchApiAutocompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    autocomplete(requestParameters: SearchApiAutocompleteRequest, options?: any): AxiosPromise<Array<AutocompleteResult>>;

}

/**
 * Request parameters for autocomplete operation in SearchApi.
 * @export
 * @interface SearchApiAutocompleteRequest
 */
export interface SearchApiAutocompleteRequest {
    /**
     * The entity type that we want to autocomplete on
     * @type {string}
     * @memberof SearchApiAutocomplete
     */
    readonly type: string

    /**
     * A short string to do a partial match on
     * @type {string}
     * @memberof SearchApiAutocomplete
     */
    readonly query: string
}

/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
export class SearchApi extends BaseAPI implements SearchApiInterface {
    /**
     * Give a type of content to search on and a partial match, this will return common search terms that match 
     * @summary Autocomplete Search
     * @param {SearchApiAutocompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public autocomplete(requestParameters: SearchApiAutocompleteRequest, options?: any) {
        const request = SearchApiFp(this.configuration).autocomplete(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * ShowerConfigurationApi - axios parameter creator
 * @export
 */
export const ShowerConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create product configuration for showers 
         * @summary Create shower configuration
         * @param {CreateShowerConfigurationBody} createShowerConfigurationBody Request body for creating shower configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShowerConfiguration: (createShowerConfigurationBody: CreateShowerConfigurationBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createShowerConfigurationBody' is not null or undefined
            assertParamExists('createShowerConfiguration', 'createShowerConfigurationBody', createShowerConfigurationBody)
            const localVarPath = `/configuration/shower`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShowerConfigurationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return requested shower configuration type record by id 
         * @summary Get shower configuration record
         * @param {string} configurationKey The key of the shower configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowerConfiguration: (configurationKey: string, options: any = {}): RequestArgs => {
            // verify required parameter 'configurationKey' is not null or undefined
            assertParamExists('getShowerConfiguration', 'configurationKey', configurationKey)
            const localVarPath = `/configuration/shower/{configuration_key}`
                .replace(`{${"configuration_key"}}`, encodeURIComponent(String(configurationKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update shower configuration with a specific id 
         * @summary Update shower configuration
         * @param {string} configurationKey The key of shower configuration
         * @param {CreateShowerConfigurationBody} createShowerConfigurationBody Request body for creating or updating a shower configuration
         * @param {string} [authorizationKey] Hashed md5 string used to authenticate product configuration editing for guest users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShowerConfiguration: (configurationKey: string, createShowerConfigurationBody: CreateShowerConfigurationBody, authorizationKey?: string, options: any = {}): RequestArgs => {
            // verify required parameter 'configurationKey' is not null or undefined
            assertParamExists('updateShowerConfiguration', 'configurationKey', configurationKey)
            // verify required parameter 'createShowerConfigurationBody' is not null or undefined
            assertParamExists('updateShowerConfiguration', 'createShowerConfigurationBody', createShowerConfigurationBody)
            const localVarPath = `/configuration/shower/{configuration_key}`
                .replace(`{${"configuration_key"}}`, encodeURIComponent(String(configurationKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (authorizationKey !== undefined && authorizationKey !== null) {
                localVarHeaderParameter['Authorization-Key'] = String(authorizationKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShowerConfigurationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShowerConfigurationApi - functional programming interface
 * @export
 */
export const ShowerConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShowerConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * Create product configuration for showers 
         * @summary Create shower configuration
         * @param {ShowerConfigurationApiCreateShowerConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShowerConfiguration(requestParameters: ShowerConfigurationApiCreateShowerConfigurationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ShowerConfigurationAuthorizationKey>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createShowerConfiguration(requestParameters.createShowerConfigurationBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return requested shower configuration type record by id 
         * @summary Get shower configuration record
         * @param {ShowerConfigurationApiGetShowerConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowerConfiguration(requestParameters: ShowerConfigurationApiGetShowerConfigurationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ShowerConfiguration>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getShowerConfiguration(requestParameters.configurationKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update shower configuration with a specific id 
         * @summary Update shower configuration
         * @param {ShowerConfigurationApiUpdateShowerConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShowerConfiguration(requestParameters: ShowerConfigurationApiUpdateShowerConfigurationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ShowerConfiguration>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateShowerConfiguration(requestParameters.configurationKey, requestParameters.createShowerConfigurationBody, requestParameters.authorizationKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShowerConfigurationApi - factory interface
 * @export
 */
export const ShowerConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShowerConfigurationApiFp(configuration)

    /**
      * Create product configuration for showers 
      * @summary Create shower configuration
      * @param {ShowerConfigurationApiCreateShowerConfigurationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createShowerConfiguration = (requestParameters: ShowerConfigurationApiCreateShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfigurationAuthorizationKey> => {
        const request = localVarFp.createShowerConfiguration(requestParameters, options);
        return request(axios, basePath);
    };

    createShowerConfiguration.getQueryKey = (requestParameters: ShowerConfigurationApiCreateShowerConfigurationRequest, options?: any) => {
        const request = localVarFp.createShowerConfiguration(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Return requested shower configuration type record by id 
      * @summary Get shower configuration record
      * @param {ShowerConfigurationApiGetShowerConfigurationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getShowerConfiguration = (requestParameters: ShowerConfigurationApiGetShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfiguration> => {
        const request = localVarFp.getShowerConfiguration(requestParameters, options);
        return request(axios, basePath);
    };

    getShowerConfiguration.getQueryKey = (requestParameters: ShowerConfigurationApiGetShowerConfigurationRequest, options?: any) => {
        const request = localVarFp.getShowerConfiguration(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update shower configuration with a specific id 
      * @summary Update shower configuration
      * @param {ShowerConfigurationApiUpdateShowerConfigurationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateShowerConfiguration = (requestParameters: ShowerConfigurationApiUpdateShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfiguration> => {
        const request = localVarFp.updateShowerConfiguration(requestParameters, options);
        return request(axios, basePath);
    };

    updateShowerConfiguration.getQueryKey = (requestParameters: ShowerConfigurationApiUpdateShowerConfigurationRequest, options?: any) => {
        const request = localVarFp.updateShowerConfiguration(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createShowerConfiguration,
        getShowerConfiguration,
        updateShowerConfiguration,
    };
};

/**
 * ShowerConfigurationApi - interface
 * @export
 * @interface ShowerConfigurationApi
 */
export interface ShowerConfigurationApiInterface {
    /**
     * Create product configuration for showers 
     * @summary Create shower configuration
     * @param {ShowerConfigurationApiCreateShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowerConfigurationApiInterface
     */
    createShowerConfiguration(requestParameters: ShowerConfigurationApiCreateShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfigurationAuthorizationKey>;

    /**
     * Return requested shower configuration type record by id 
     * @summary Get shower configuration record
     * @param {ShowerConfigurationApiGetShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowerConfigurationApiInterface
     */
    getShowerConfiguration(requestParameters: ShowerConfigurationApiGetShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfiguration>;

    /**
     * Update shower configuration with a specific id 
     * @summary Update shower configuration
     * @param {ShowerConfigurationApiUpdateShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowerConfigurationApiInterface
     */
    updateShowerConfiguration(requestParameters: ShowerConfigurationApiUpdateShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfiguration>;

}

/**
 * Request parameters for createShowerConfiguration operation in ShowerConfigurationApi.
 * @export
 * @interface ShowerConfigurationApiCreateShowerConfigurationRequest
 */
export interface ShowerConfigurationApiCreateShowerConfigurationRequest {
    /**
     * Request body for creating shower configuration
     * @type {CreateShowerConfigurationBody}
     * @memberof ShowerConfigurationApiCreateShowerConfiguration
     */
    readonly createShowerConfigurationBody: CreateShowerConfigurationBody
}

/**
 * Request parameters for getShowerConfiguration operation in ShowerConfigurationApi.
 * @export
 * @interface ShowerConfigurationApiGetShowerConfigurationRequest
 */
export interface ShowerConfigurationApiGetShowerConfigurationRequest {
    /**
     * The key of the shower configuration
     * @type {string}
     * @memberof ShowerConfigurationApiGetShowerConfiguration
     */
    readonly configurationKey: string
}

/**
 * Request parameters for updateShowerConfiguration operation in ShowerConfigurationApi.
 * @export
 * @interface ShowerConfigurationApiUpdateShowerConfigurationRequest
 */
export interface ShowerConfigurationApiUpdateShowerConfigurationRequest {
    /**
     * The key of shower configuration
     * @type {string}
     * @memberof ShowerConfigurationApiUpdateShowerConfiguration
     */
    readonly configurationKey: string

    /**
     * Request body for creating or updating a shower configuration
     * @type {CreateShowerConfigurationBody}
     * @memberof ShowerConfigurationApiUpdateShowerConfiguration
     */
    readonly createShowerConfigurationBody: CreateShowerConfigurationBody

    /**
     * Hashed md5 string used to authenticate product configuration editing for guest users
     * @type {string}
     * @memberof ShowerConfigurationApiUpdateShowerConfiguration
     */
    readonly authorizationKey?: string
}

/**
 * ShowerConfigurationApi - object-oriented interface
 * @export
 * @class ShowerConfigurationApi
 * @extends {BaseAPI}
 */
export class ShowerConfigurationApi extends BaseAPI implements ShowerConfigurationApiInterface {
    /**
     * Create product configuration for showers 
     * @summary Create shower configuration
     * @param {ShowerConfigurationApiCreateShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowerConfigurationApi
     */
    public createShowerConfiguration(requestParameters: ShowerConfigurationApiCreateShowerConfigurationRequest, options?: any) {
        const request = ShowerConfigurationApiFp(this.configuration).createShowerConfiguration(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Return requested shower configuration type record by id 
     * @summary Get shower configuration record
     * @param {ShowerConfigurationApiGetShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowerConfigurationApi
     */
    public getShowerConfiguration(requestParameters: ShowerConfigurationApiGetShowerConfigurationRequest, options?: any) {
        const request = ShowerConfigurationApiFp(this.configuration).getShowerConfiguration(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update shower configuration with a specific id 
     * @summary Update shower configuration
     * @param {ShowerConfigurationApiUpdateShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowerConfigurationApi
     */
    public updateShowerConfiguration(requestParameters: ShowerConfigurationApiUpdateShowerConfigurationRequest, options?: any) {
        const request = ShowerConfigurationApiFp(this.configuration).updateShowerConfiguration(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * StatusApi - axios parameter creator
 * @export
 */
export const StatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the current health status of the application, including pending jobs, api version, cache status, and validation failures 
         * @summary Health Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: (options: any = {}): RequestArgs => {
            const localVarPath = `/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatusApi - functional programming interface
 * @export
 */
export const StatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatusApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the current health status of the application, including pending jobs, api version, cache status, and validation failures 
         * @summary Health Status
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<GetStatusResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatusApi - factory interface
 * @export
 */
export const StatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatusApiFp(configuration)

    /**
      * Get the current health status of the application, including pending jobs, api version, cache status, and validation failures 
      * @summary Health Status
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getStatus = (requestParameters?: undefined, options?: any): AxiosPromise<GetStatusResponse> => {
        const request = localVarFp.getStatus(requestParameters, options);
        return request(axios, basePath);
    };

    getStatus.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.getStatus(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        getStatus,
    };
};

/**
 * StatusApi - interface
 * @export
 * @interface StatusApi
 */
export interface StatusApiInterface {
    /**
     * Get the current health status of the application, including pending jobs, api version, cache status, and validation failures 
     * @summary Health Status
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusApiInterface
     */
    getStatus(requestParameters?: undefined, options?: any): AxiosPromise<GetStatusResponse>;

}

/**
 * StatusApi - object-oriented interface
 * @export
 * @class StatusApi
 * @extends {BaseAPI}
 */
export class StatusApi extends BaseAPI implements StatusApiInterface {
    /**
     * Get the current health status of the application, including pending jobs, api version, cache status, and validation failures 
     * @summary Health Status
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusApi
     */
    public getStatus(requestParameters?: undefined, options?: any) {
        const request = StatusApiFp(this.configuration).getStatus(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * SupportApi - axios parameter creator
 * @export
 */
export const SupportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send a support request 
         * @summary Send Sales Support Request
         * @param {SupportBody} supportBody Send a support request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportRequest: (supportBody: SupportBody, options: any = {}): RequestArgs => {
            // verify required parameter 'supportBody' is not null or undefined
            assertParamExists('supportRequest', 'supportBody', supportBody)
            const localVarPath = `/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportApi - functional programming interface
 * @export
 */
export const SupportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupportApiAxiosParamCreator(configuration)
    return {
        /**
         * Send a support request 
         * @summary Send Sales Support Request
         * @param {SupportApiSupportRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportRequest(requestParameters: SupportApiSupportRequestRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.supportRequest(requestParameters.supportBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupportApi - factory interface
 * @export
 */
export const SupportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupportApiFp(configuration)

    /**
      * Send a support request 
      * @summary Send Sales Support Request
      * @param {SupportApiSupportRequestRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const supportRequest = (requestParameters: SupportApiSupportRequestRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.supportRequest(requestParameters, options);
        return request(axios, basePath);
    };

    supportRequest.getQueryKey = (requestParameters: SupportApiSupportRequestRequest, options?: any) => {
        const request = localVarFp.supportRequest(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        supportRequest,
    };
};

/**
 * SupportApi - interface
 * @export
 * @interface SupportApi
 */
export interface SupportApiInterface {
    /**
     * Send a support request 
     * @summary Send Sales Support Request
     * @param {SupportApiSupportRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApiInterface
     */
    supportRequest(requestParameters: SupportApiSupportRequestRequest, options?: any): AxiosPromise<void>;

}

/**
 * Request parameters for supportRequest operation in SupportApi.
 * @export
 * @interface SupportApiSupportRequestRequest
 */
export interface SupportApiSupportRequestRequest {
    /**
     * Send a support request
     * @type {SupportBody}
     * @memberof SupportApiSupportRequest
     */
    readonly supportBody: SupportBody
}

/**
 * SupportApi - object-oriented interface
 * @export
 * @class SupportApi
 * @extends {BaseAPI}
 */
export class SupportApi extends BaseAPI implements SupportApiInterface {
    /**
     * Send a support request 
     * @summary Send Sales Support Request
     * @param {SupportApiSupportRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public supportRequest(requestParameters: SupportApiSupportRequestRequest, options?: any) {
        const request = SupportApiFp(this.configuration).supportRequest(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * TempcontrolApi - axios parameter creator
 * @export
 */
export const TempcontrolApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Run the sizing engine against the project\'s persisted `inputs`. The `result` is stored on the project and also returned inline. Returns 422 with a per-field message list if the inputs are not yet complete enough to calculate. 
         * @summary Calculate TempControl project
         * @param {string} key TempControl project key
         * @param {string} [authorizationKey] Hashed md5 string used to authenticate guest access
         * @param {CalculateTempControlProjectBody} [calculateTempControlProjectBody] Optional calculation method override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateTempControlProject: (key: string, authorizationKey?: string, calculateTempControlProjectBody?: CalculateTempControlProjectBody, options: any = {}): RequestArgs => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('calculateTempControlProject', 'key', key)
            const localVarPath = `/tempcontrol/projects/{key}/calculate`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (authorizationKey !== undefined && authorizationKey !== null) {
                localVarHeaderParameter['Authorization-Key'] = String(authorizationKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateTempControlProjectBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start a new TempControl sizing project.  For anonymous callers the response includes a non-null `authorization_key` that the client must store (typically in localStorage) and present via the `Authorization-Key` header on subsequent edits.  For authenticated callers the project is hard-bound to their user, no key is issued (`authorization_key` is `null`), and access goes through the bearer-token policy. This prevents a leaked computed key from being used to bypass ownership. 
         * @summary Create TempControl project
         * @param {CreateTempControlProjectBody} createTempControlProjectBody Request body for creating a TempControl project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTempControlProject: (createTempControlProjectBody: CreateTempControlProjectBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createTempControlProjectBody' is not null or undefined
            assertParamExists('createTempControlProject', 'createTempControlProjectBody', createTempControlProjectBody)
            const localVarPath = `/tempcontrol/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTempControlProjectBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete a TempControl project. Owners (and admins / sales reps) can delete; the row stays in the database with `deleted_at` set so it can be recovered if needed. 
         * @summary Delete TempControl project
         * @param {string} key TempControl project key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempControlProject: (key: string, options: any = {}): RequestArgs => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('deleteTempControlProject', 'key', key)
            const localVarPath = `/tempcontrol/projects/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Captures the customer\'s contact details, marks the project as `completed`, sets `last_downloaded_at`, and dispatches a PDF render to the `pdf` queue. Mirrors the SPB publish flow - rendering happens out-of-process on the queue worker (which is the only image with Node + the bundled CLI), and the result is uploaded to the private filesystem.  Responds with the project payload (NOT the PDF bytes). The caller should poll `GET /tempcontrol/projects/{key}` until `pdf_status === \'ready\'`, then fetch the binary stream from `GET /tempcontrol/projects/{key}/download`.  Returns `200` if the cached PDF is still valid (no inputs changed since the last render); `202` if a new render was dispatched; `422` if the project does not yet have a calculation result. 
         * @summary Trigger TempControl project PDF generation
         * @param {string} key TempControl project key
         * @param {DownloadTempControlProjectBody} downloadTempControlProjectBody Customer contact details captured at download time
         * @param {string} [authorizationKey] Hashed md5 string used to authenticate guest access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTempControlProject: (key: string, downloadTempControlProjectBody: DownloadTempControlProjectBody, authorizationKey?: string, options: any = {}): RequestArgs => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('downloadTempControlProject', 'key', key)
            // verify required parameter 'downloadTempControlProjectBody' is not null or undefined
            assertParamExists('downloadTempControlProject', 'downloadTempControlProjectBody', downloadTempControlProjectBody)
            const localVarPath = `/tempcontrol/projects/{key}/download`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (authorizationKey !== undefined && authorizationKey !== null) {
                localVarHeaderParameter['Authorization-Key'] = String(authorizationKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadTempControlProjectBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the TempControl project identified by `key`. Requires either ownership (authenticated user) or a matching `Authorization-Key` header. 
         * @summary Get TempControl project
         * @param {string} key TempControl project key
         * @param {string} [authorizationKey] Hashed md5 string used to authenticate guest access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempControlProject: (key: string, authorizationKey?: string, options: any = {}): RequestArgs => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getTempControlProject', 'key', key)
            const localVarPath = `/tempcontrol/projects/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (authorizationKey !== undefined && authorizationKey !== null) {
                localVarHeaderParameter['Authorization-Key'] = String(authorizationKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Customer-portal list endpoint. Admins and sales reps see every project (including anonymous ones with no `user_id`). Every other authenticated role is hard-scoped server-side to projects they own. 
         * @summary List TempControl projects
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Free-text match across &#x60;project_name&#x60;, &#x60;customer_name&#x60;, &#x60;customer_email&#x60;, and &#x60;customer_company&#x60;. 
         * @param {TempControlProjectStatus} [status] 
         * @param {TempControlValveFamily} [valveFamily] 
         * @param {TempControlCalculationMethod} [method] 
         * @param {number} [userId] Filter by owner. Admin/sales-rep only.
         * @param {'mine' | 'anonymous'} [ownership] &#x60;mine&#x60; keeps the list scoped to the requester\&#39;s own projects (used by the \&quot;Show only my projects\&quot; toggle for sales reps); &#x60;anonymous&#x60; shows only projects with no &#x60;user_id&#x60; (admin/sales-rep only). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTempControlProjects: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, status?: TempControlProjectStatus, valveFamily?: TempControlValveFamily, method?: TempControlCalculationMethod, userId?: number, ownership?: 'mine' | 'anonymous', options: any = {}): RequestArgs => {
            const localVarPath = `/tempcontrol/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (valveFamily !== undefined) {
                localVarQueryParameter['valve_family'] = valveFamily;
            }

            if (method !== undefined) {
                localVarQueryParameter['method'] = method;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (ownership !== undefined) {
                localVarQueryParameter['ownership'] = ownership;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Streams the rendered PDF back from the configured private filesystem. No Node spawn happens here - the PDF must already have been rendered by a prior `POST` call; if `pdf_status` is anything other than `ready` this returns `409` so the client can keep polling or surface the failure. 
         * @summary Stream the rendered TempControl project PDF
         * @param {string} key TempControl project key
         * @param {string} [authorizationKey] Hashed md5 string used to authenticate guest access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamTempControlProjectPdf: (key: string, authorizationKey?: string, options: any = {}): RequestArgs => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('streamTempControlProjectPdf', 'key', key)
            const localVarPath = `/tempcontrol/projects/{key}/download`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (authorizationKey !== undefined && authorizationKey !== null) {
                localVarHeaderParameter['Authorization-Key'] = String(authorizationKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially update a TempControl project. Top-level columns (`project_name`, customer fields, `current_step`) are replaced; the nested `inputs` object is shallow-merged into the persisted inputs JSON so the wizard can stream each step independently. 
         * @summary Update TempControl project
         * @param {string} key TempControl project key
         * @param {UpdateTempControlProjectBody} updateTempControlProjectBody Partial TempControl project update payload
         * @param {string} [authorizationKey] Hashed md5 string used to authenticate guest edits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTempControlProject: (key: string, updateTempControlProjectBody: UpdateTempControlProjectBody, authorizationKey?: string, options: any = {}): RequestArgs => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('updateTempControlProject', 'key', key)
            // verify required parameter 'updateTempControlProjectBody' is not null or undefined
            assertParamExists('updateTempControlProject', 'updateTempControlProjectBody', updateTempControlProjectBody)
            const localVarPath = `/tempcontrol/projects/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (authorizationKey !== undefined && authorizationKey !== null) {
                localVarHeaderParameter['Authorization-Key'] = String(authorizationKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTempControlProjectBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TempcontrolApi - functional programming interface
 * @export
 */
export const TempcontrolApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TempcontrolApiAxiosParamCreator(configuration)
    return {
        /**
         * Run the sizing engine against the project\'s persisted `inputs`. The `result` is stored on the project and also returned inline. Returns 422 with a per-field message list if the inputs are not yet complete enough to calculate. 
         * @summary Calculate TempControl project
         * @param {TempcontrolApiCalculateTempControlProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateTempControlProject(requestParameters: TempcontrolApiCalculateTempControlProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TempControlProject>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.calculateTempControlProject(requestParameters.key, requestParameters.authorizationKey, requestParameters.calculateTempControlProjectBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Start a new TempControl sizing project.  For anonymous callers the response includes a non-null `authorization_key` that the client must store (typically in localStorage) and present via the `Authorization-Key` header on subsequent edits.  For authenticated callers the project is hard-bound to their user, no key is issued (`authorization_key` is `null`), and access goes through the bearer-token policy. This prevents a leaked computed key from being used to bypass ownership. 
         * @summary Create TempControl project
         * @param {TempcontrolApiCreateTempControlProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTempControlProject(requestParameters: TempcontrolApiCreateTempControlProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TempControlProjectAuthorizationKey>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createTempControlProject(requestParameters.createTempControlProjectBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft-delete a TempControl project. Owners (and admins / sales reps) can delete; the row stays in the database with `deleted_at` set so it can be recovered if needed. 
         * @summary Delete TempControl project
         * @param {TempcontrolApiDeleteTempControlProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempControlProject(requestParameters: TempcontrolApiDeleteTempControlProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteTempControlProject(requestParameters.key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Captures the customer\'s contact details, marks the project as `completed`, sets `last_downloaded_at`, and dispatches a PDF render to the `pdf` queue. Mirrors the SPB publish flow - rendering happens out-of-process on the queue worker (which is the only image with Node + the bundled CLI), and the result is uploaded to the private filesystem.  Responds with the project payload (NOT the PDF bytes). The caller should poll `GET /tempcontrol/projects/{key}` until `pdf_status === \'ready\'`, then fetch the binary stream from `GET /tempcontrol/projects/{key}/download`.  Returns `200` if the cached PDF is still valid (no inputs changed since the last render); `202` if a new render was dispatched; `422` if the project does not yet have a calculation result. 
         * @summary Trigger TempControl project PDF generation
         * @param {TempcontrolApiDownloadTempControlProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTempControlProject(requestParameters: TempcontrolApiDownloadTempControlProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TempControlProject>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.downloadTempControlProject(requestParameters.key, requestParameters.downloadTempControlProjectBody, requestParameters.authorizationKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the TempControl project identified by `key`. Requires either ownership (authenticated user) or a matching `Authorization-Key` header. 
         * @summary Get TempControl project
         * @param {TempcontrolApiGetTempControlProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempControlProject(requestParameters: TempcontrolApiGetTempControlProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TempControlProject>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getTempControlProject(requestParameters.key, requestParameters.authorizationKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Customer-portal list endpoint. Admins and sales reps see every project (including anonymous ones with no `user_id`). Every other authenticated role is hard-scoped server-side to projects they own. 
         * @summary List TempControl projects
         * @param {TempcontrolApiListTempControlProjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTempControlProjects(requestParameters: TempcontrolApiListTempControlProjectsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedTempControlProjects>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listTempControlProjects(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.status, requestParameters.valveFamily, requestParameters.method, requestParameters.userId, requestParameters.ownership, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Streams the rendered PDF back from the configured private filesystem. No Node spawn happens here - the PDF must already have been rendered by a prior `POST` call; if `pdf_status` is anything other than `ready` this returns `409` so the client can keep polling or surface the failure. 
         * @summary Stream the rendered TempControl project PDF
         * @param {TempcontrolApiStreamTempControlProjectPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamTempControlProjectPdf(requestParameters: TempcontrolApiStreamTempControlProjectPdfRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<any>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.streamTempControlProjectPdf(requestParameters.key, requestParameters.authorizationKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Partially update a TempControl project. Top-level columns (`project_name`, customer fields, `current_step`) are replaced; the nested `inputs` object is shallow-merged into the persisted inputs JSON so the wizard can stream each step independently. 
         * @summary Update TempControl project
         * @param {TempcontrolApiUpdateTempControlProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTempControlProject(requestParameters: TempcontrolApiUpdateTempControlProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TempControlProject>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateTempControlProject(requestParameters.key, requestParameters.updateTempControlProjectBody, requestParameters.authorizationKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TempcontrolApi - factory interface
 * @export
 */
export const TempcontrolApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TempcontrolApiFp(configuration)

    /**
      * Run the sizing engine against the project\'s persisted `inputs`. The `result` is stored on the project and also returned inline. Returns 422 with a per-field message list if the inputs are not yet complete enough to calculate. 
      * @summary Calculate TempControl project
      * @param {TempcontrolApiCalculateTempControlProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const calculateTempControlProject = (requestParameters: TempcontrolApiCalculateTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject> => {
        const request = localVarFp.calculateTempControlProject(requestParameters, options);
        return request(axios, basePath);
    };

    calculateTempControlProject.getQueryKey = (requestParameters: TempcontrolApiCalculateTempControlProjectRequest, options?: any) => {
        const request = localVarFp.calculateTempControlProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Start a new TempControl sizing project.  For anonymous callers the response includes a non-null `authorization_key` that the client must store (typically in localStorage) and present via the `Authorization-Key` header on subsequent edits.  For authenticated callers the project is hard-bound to their user, no key is issued (`authorization_key` is `null`), and access goes through the bearer-token policy. This prevents a leaked computed key from being used to bypass ownership. 
      * @summary Create TempControl project
      * @param {TempcontrolApiCreateTempControlProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createTempControlProject = (requestParameters: TempcontrolApiCreateTempControlProjectRequest, options?: any): AxiosPromise<TempControlProjectAuthorizationKey> => {
        const request = localVarFp.createTempControlProject(requestParameters, options);
        return request(axios, basePath);
    };

    createTempControlProject.getQueryKey = (requestParameters: TempcontrolApiCreateTempControlProjectRequest, options?: any) => {
        const request = localVarFp.createTempControlProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Soft-delete a TempControl project. Owners (and admins / sales reps) can delete; the row stays in the database with `deleted_at` set so it can be recovered if needed. 
      * @summary Delete TempControl project
      * @param {TempcontrolApiDeleteTempControlProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteTempControlProject = (requestParameters: TempcontrolApiDeleteTempControlProjectRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteTempControlProject(requestParameters, options);
        return request(axios, basePath);
    };

    deleteTempControlProject.getQueryKey = (requestParameters: TempcontrolApiDeleteTempControlProjectRequest, options?: any) => {
        const request = localVarFp.deleteTempControlProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Captures the customer\'s contact details, marks the project as `completed`, sets `last_downloaded_at`, and dispatches a PDF render to the `pdf` queue. Mirrors the SPB publish flow - rendering happens out-of-process on the queue worker (which is the only image with Node + the bundled CLI), and the result is uploaded to the private filesystem.  Responds with the project payload (NOT the PDF bytes). The caller should poll `GET /tempcontrol/projects/{key}` until `pdf_status === \'ready\'`, then fetch the binary stream from `GET /tempcontrol/projects/{key}/download`.  Returns `200` if the cached PDF is still valid (no inputs changed since the last render); `202` if a new render was dispatched; `422` if the project does not yet have a calculation result. 
      * @summary Trigger TempControl project PDF generation
      * @param {TempcontrolApiDownloadTempControlProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const downloadTempControlProject = (requestParameters: TempcontrolApiDownloadTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject> => {
        const request = localVarFp.downloadTempControlProject(requestParameters, options);
        return request(axios, basePath);
    };

    downloadTempControlProject.getQueryKey = (requestParameters: TempcontrolApiDownloadTempControlProjectRequest, options?: any) => {
        const request = localVarFp.downloadTempControlProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Return the TempControl project identified by `key`. Requires either ownership (authenticated user) or a matching `Authorization-Key` header. 
      * @summary Get TempControl project
      * @param {TempcontrolApiGetTempControlProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getTempControlProject = (requestParameters: TempcontrolApiGetTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject> => {
        const request = localVarFp.getTempControlProject(requestParameters, options);
        return request(axios, basePath);
    };

    getTempControlProject.getQueryKey = (requestParameters: TempcontrolApiGetTempControlProjectRequest, options?: any) => {
        const request = localVarFp.getTempControlProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Customer-portal list endpoint. Admins and sales reps see every project (including anonymous ones with no `user_id`). Every other authenticated role is hard-scoped server-side to projects they own. 
      * @summary List TempControl projects
      * @param {TempcontrolApiListTempControlProjectsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listTempControlProjects = (requestParameters: TempcontrolApiListTempControlProjectsRequest = {}, options?: any): AxiosPromise<PaginatedTempControlProjects> => {
        const request = localVarFp.listTempControlProjects(requestParameters, options);
        return request(axios, basePath);
    };

    listTempControlProjects.getQueryKey = (requestParameters: TempcontrolApiListTempControlProjectsRequest = {}, options?: any) => {
        const request = localVarFp.listTempControlProjects(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Streams the rendered PDF back from the configured private filesystem. No Node spawn happens here - the PDF must already have been rendered by a prior `POST` call; if `pdf_status` is anything other than `ready` this returns `409` so the client can keep polling or surface the failure. 
      * @summary Stream the rendered TempControl project PDF
      * @param {TempcontrolApiStreamTempControlProjectPdfRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const streamTempControlProjectPdf = (requestParameters: TempcontrolApiStreamTempControlProjectPdfRequest, options?: any): AxiosPromise<any> => {
        const request = localVarFp.streamTempControlProjectPdf(requestParameters, options);
        return request(axios, basePath);
    };

    streamTempControlProjectPdf.getQueryKey = (requestParameters: TempcontrolApiStreamTempControlProjectPdfRequest, options?: any) => {
        const request = localVarFp.streamTempControlProjectPdf(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Partially update a TempControl project. Top-level columns (`project_name`, customer fields, `current_step`) are replaced; the nested `inputs` object is shallow-merged into the persisted inputs JSON so the wizard can stream each step independently. 
      * @summary Update TempControl project
      * @param {TempcontrolApiUpdateTempControlProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateTempControlProject = (requestParameters: TempcontrolApiUpdateTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject> => {
        const request = localVarFp.updateTempControlProject(requestParameters, options);
        return request(axios, basePath);
    };

    updateTempControlProject.getQueryKey = (requestParameters: TempcontrolApiUpdateTempControlProjectRequest, options?: any) => {
        const request = localVarFp.updateTempControlProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        calculateTempControlProject,
        createTempControlProject,
        deleteTempControlProject,
        downloadTempControlProject,
        getTempControlProject,
        listTempControlProjects,
        streamTempControlProjectPdf,
        updateTempControlProject,
    };
};

/**
 * TempcontrolApi - interface
 * @export
 * @interface TempcontrolApi
 */
export interface TempcontrolApiInterface {
    /**
     * Run the sizing engine against the project\'s persisted `inputs`. The `result` is stored on the project and also returned inline. Returns 422 with a per-field message list if the inputs are not yet complete enough to calculate. 
     * @summary Calculate TempControl project
     * @param {TempcontrolApiCalculateTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApiInterface
     */
    calculateTempControlProject(requestParameters: TempcontrolApiCalculateTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject>;

    /**
     * Start a new TempControl sizing project.  For anonymous callers the response includes a non-null `authorization_key` that the client must store (typically in localStorage) and present via the `Authorization-Key` header on subsequent edits.  For authenticated callers the project is hard-bound to their user, no key is issued (`authorization_key` is `null`), and access goes through the bearer-token policy. This prevents a leaked computed key from being used to bypass ownership. 
     * @summary Create TempControl project
     * @param {TempcontrolApiCreateTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApiInterface
     */
    createTempControlProject(requestParameters: TempcontrolApiCreateTempControlProjectRequest, options?: any): AxiosPromise<TempControlProjectAuthorizationKey>;

    /**
     * Soft-delete a TempControl project. Owners (and admins / sales reps) can delete; the row stays in the database with `deleted_at` set so it can be recovered if needed. 
     * @summary Delete TempControl project
     * @param {TempcontrolApiDeleteTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApiInterface
     */
    deleteTempControlProject(requestParameters: TempcontrolApiDeleteTempControlProjectRequest, options?: any): AxiosPromise<void>;

    /**
     * Captures the customer\'s contact details, marks the project as `completed`, sets `last_downloaded_at`, and dispatches a PDF render to the `pdf` queue. Mirrors the SPB publish flow - rendering happens out-of-process on the queue worker (which is the only image with Node + the bundled CLI), and the result is uploaded to the private filesystem.  Responds with the project payload (NOT the PDF bytes). The caller should poll `GET /tempcontrol/projects/{key}` until `pdf_status === \'ready\'`, then fetch the binary stream from `GET /tempcontrol/projects/{key}/download`.  Returns `200` if the cached PDF is still valid (no inputs changed since the last render); `202` if a new render was dispatched; `422` if the project does not yet have a calculation result. 
     * @summary Trigger TempControl project PDF generation
     * @param {TempcontrolApiDownloadTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApiInterface
     */
    downloadTempControlProject(requestParameters: TempcontrolApiDownloadTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject>;

    /**
     * Return the TempControl project identified by `key`. Requires either ownership (authenticated user) or a matching `Authorization-Key` header. 
     * @summary Get TempControl project
     * @param {TempcontrolApiGetTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApiInterface
     */
    getTempControlProject(requestParameters: TempcontrolApiGetTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject>;

    /**
     * Customer-portal list endpoint. Admins and sales reps see every project (including anonymous ones with no `user_id`). Every other authenticated role is hard-scoped server-side to projects they own. 
     * @summary List TempControl projects
     * @param {TempcontrolApiListTempControlProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApiInterface
     */
    listTempControlProjects(requestParameters?: TempcontrolApiListTempControlProjectsRequest, options?: any): AxiosPromise<PaginatedTempControlProjects>;

    /**
     * Streams the rendered PDF back from the configured private filesystem. No Node spawn happens here - the PDF must already have been rendered by a prior `POST` call; if `pdf_status` is anything other than `ready` this returns `409` so the client can keep polling or surface the failure. 
     * @summary Stream the rendered TempControl project PDF
     * @param {TempcontrolApiStreamTempControlProjectPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApiInterface
     */
    streamTempControlProjectPdf(requestParameters: TempcontrolApiStreamTempControlProjectPdfRequest, options?: any): AxiosPromise<any>;

    /**
     * Partially update a TempControl project. Top-level columns (`project_name`, customer fields, `current_step`) are replaced; the nested `inputs` object is shallow-merged into the persisted inputs JSON so the wizard can stream each step independently. 
     * @summary Update TempControl project
     * @param {TempcontrolApiUpdateTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApiInterface
     */
    updateTempControlProject(requestParameters: TempcontrolApiUpdateTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject>;

}

/**
 * Request parameters for calculateTempControlProject operation in TempcontrolApi.
 * @export
 * @interface TempcontrolApiCalculateTempControlProjectRequest
 */
export interface TempcontrolApiCalculateTempControlProjectRequest {
    /**
     * TempControl project key
     * @type {string}
     * @memberof TempcontrolApiCalculateTempControlProject
     */
    readonly key: string

    /**
     * Hashed md5 string used to authenticate guest access
     * @type {string}
     * @memberof TempcontrolApiCalculateTempControlProject
     */
    readonly authorizationKey?: string

    /**
     * Optional calculation method override
     * @type {CalculateTempControlProjectBody}
     * @memberof TempcontrolApiCalculateTempControlProject
     */
    readonly calculateTempControlProjectBody?: CalculateTempControlProjectBody
}

/**
 * Request parameters for createTempControlProject operation in TempcontrolApi.
 * @export
 * @interface TempcontrolApiCreateTempControlProjectRequest
 */
export interface TempcontrolApiCreateTempControlProjectRequest {
    /**
     * Request body for creating a TempControl project
     * @type {CreateTempControlProjectBody}
     * @memberof TempcontrolApiCreateTempControlProject
     */
    readonly createTempControlProjectBody: CreateTempControlProjectBody
}

/**
 * Request parameters for deleteTempControlProject operation in TempcontrolApi.
 * @export
 * @interface TempcontrolApiDeleteTempControlProjectRequest
 */
export interface TempcontrolApiDeleteTempControlProjectRequest {
    /**
     * TempControl project key
     * @type {string}
     * @memberof TempcontrolApiDeleteTempControlProject
     */
    readonly key: string
}

/**
 * Request parameters for downloadTempControlProject operation in TempcontrolApi.
 * @export
 * @interface TempcontrolApiDownloadTempControlProjectRequest
 */
export interface TempcontrolApiDownloadTempControlProjectRequest {
    /**
     * TempControl project key
     * @type {string}
     * @memberof TempcontrolApiDownloadTempControlProject
     */
    readonly key: string

    /**
     * Customer contact details captured at download time
     * @type {DownloadTempControlProjectBody}
     * @memberof TempcontrolApiDownloadTempControlProject
     */
    readonly downloadTempControlProjectBody: DownloadTempControlProjectBody

    /**
     * Hashed md5 string used to authenticate guest access
     * @type {string}
     * @memberof TempcontrolApiDownloadTempControlProject
     */
    readonly authorizationKey?: string
}

/**
 * Request parameters for getTempControlProject operation in TempcontrolApi.
 * @export
 * @interface TempcontrolApiGetTempControlProjectRequest
 */
export interface TempcontrolApiGetTempControlProjectRequest {
    /**
     * TempControl project key
     * @type {string}
     * @memberof TempcontrolApiGetTempControlProject
     */
    readonly key: string

    /**
     * Hashed md5 string used to authenticate guest access
     * @type {string}
     * @memberof TempcontrolApiGetTempControlProject
     */
    readonly authorizationKey?: string
}

/**
 * Request parameters for listTempControlProjects operation in TempcontrolApi.
 * @export
 * @interface TempcontrolApiListTempControlProjectsRequest
 */
export interface TempcontrolApiListTempControlProjectsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof TempcontrolApiListTempControlProjects
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof TempcontrolApiListTempControlProjects
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof TempcontrolApiListTempControlProjects
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof TempcontrolApiListTempControlProjects
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Free-text match across &#x60;project_name&#x60;, &#x60;customer_name&#x60;, &#x60;customer_email&#x60;, and &#x60;customer_company&#x60;. 
     * @type {string}
     * @memberof TempcontrolApiListTempControlProjects
     */
    readonly search?: string

    /**
     * 
     * @type {TempControlProjectStatus}
     * @memberof TempcontrolApiListTempControlProjects
     */
    readonly status?: TempControlProjectStatus

    /**
     * 
     * @type {TempControlValveFamily}
     * @memberof TempcontrolApiListTempControlProjects
     */
    readonly valveFamily?: TempControlValveFamily

    /**
     * 
     * @type {TempControlCalculationMethod}
     * @memberof TempcontrolApiListTempControlProjects
     */
    readonly method?: TempControlCalculationMethod

    /**
     * Filter by owner. Admin/sales-rep only.
     * @type {number}
     * @memberof TempcontrolApiListTempControlProjects
     */
    readonly userId?: number

    /**
     * &#x60;mine&#x60; keeps the list scoped to the requester\&#39;s own projects (used by the \&quot;Show only my projects\&quot; toggle for sales reps); &#x60;anonymous&#x60; shows only projects with no &#x60;user_id&#x60; (admin/sales-rep only). 
     * @type {'mine' | 'anonymous'}
     * @memberof TempcontrolApiListTempControlProjects
     */
    readonly ownership?: 'mine' | 'anonymous'
}

/**
 * Request parameters for streamTempControlProjectPdf operation in TempcontrolApi.
 * @export
 * @interface TempcontrolApiStreamTempControlProjectPdfRequest
 */
export interface TempcontrolApiStreamTempControlProjectPdfRequest {
    /**
     * TempControl project key
     * @type {string}
     * @memberof TempcontrolApiStreamTempControlProjectPdf
     */
    readonly key: string

    /**
     * Hashed md5 string used to authenticate guest access
     * @type {string}
     * @memberof TempcontrolApiStreamTempControlProjectPdf
     */
    readonly authorizationKey?: string
}

/**
 * Request parameters for updateTempControlProject operation in TempcontrolApi.
 * @export
 * @interface TempcontrolApiUpdateTempControlProjectRequest
 */
export interface TempcontrolApiUpdateTempControlProjectRequest {
    /**
     * TempControl project key
     * @type {string}
     * @memberof TempcontrolApiUpdateTempControlProject
     */
    readonly key: string

    /**
     * Partial TempControl project update payload
     * @type {UpdateTempControlProjectBody}
     * @memberof TempcontrolApiUpdateTempControlProject
     */
    readonly updateTempControlProjectBody: UpdateTempControlProjectBody

    /**
     * Hashed md5 string used to authenticate guest edits
     * @type {string}
     * @memberof TempcontrolApiUpdateTempControlProject
     */
    readonly authorizationKey?: string
}

/**
 * TempcontrolApi - object-oriented interface
 * @export
 * @class TempcontrolApi
 * @extends {BaseAPI}
 */
export class TempcontrolApi extends BaseAPI implements TempcontrolApiInterface {
    /**
     * Run the sizing engine against the project\'s persisted `inputs`. The `result` is stored on the project and also returned inline. Returns 422 with a per-field message list if the inputs are not yet complete enough to calculate. 
     * @summary Calculate TempControl project
     * @param {TempcontrolApiCalculateTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApi
     */
    public calculateTempControlProject(requestParameters: TempcontrolApiCalculateTempControlProjectRequest, options?: any) {
        const request = TempcontrolApiFp(this.configuration).calculateTempControlProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Start a new TempControl sizing project.  For anonymous callers the response includes a non-null `authorization_key` that the client must store (typically in localStorage) and present via the `Authorization-Key` header on subsequent edits.  For authenticated callers the project is hard-bound to their user, no key is issued (`authorization_key` is `null`), and access goes through the bearer-token policy. This prevents a leaked computed key from being used to bypass ownership. 
     * @summary Create TempControl project
     * @param {TempcontrolApiCreateTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApi
     */
    public createTempControlProject(requestParameters: TempcontrolApiCreateTempControlProjectRequest, options?: any) {
        const request = TempcontrolApiFp(this.configuration).createTempControlProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Soft-delete a TempControl project. Owners (and admins / sales reps) can delete; the row stays in the database with `deleted_at` set so it can be recovered if needed. 
     * @summary Delete TempControl project
     * @param {TempcontrolApiDeleteTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApi
     */
    public deleteTempControlProject(requestParameters: TempcontrolApiDeleteTempControlProjectRequest, options?: any) {
        const request = TempcontrolApiFp(this.configuration).deleteTempControlProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Captures the customer\'s contact details, marks the project as `completed`, sets `last_downloaded_at`, and dispatches a PDF render to the `pdf` queue. Mirrors the SPB publish flow - rendering happens out-of-process on the queue worker (which is the only image with Node + the bundled CLI), and the result is uploaded to the private filesystem.  Responds with the project payload (NOT the PDF bytes). The caller should poll `GET /tempcontrol/projects/{key}` until `pdf_status === \'ready\'`, then fetch the binary stream from `GET /tempcontrol/projects/{key}/download`.  Returns `200` if the cached PDF is still valid (no inputs changed since the last render); `202` if a new render was dispatched; `422` if the project does not yet have a calculation result. 
     * @summary Trigger TempControl project PDF generation
     * @param {TempcontrolApiDownloadTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApi
     */
    public downloadTempControlProject(requestParameters: TempcontrolApiDownloadTempControlProjectRequest, options?: any) {
        const request = TempcontrolApiFp(this.configuration).downloadTempControlProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Return the TempControl project identified by `key`. Requires either ownership (authenticated user) or a matching `Authorization-Key` header. 
     * @summary Get TempControl project
     * @param {TempcontrolApiGetTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApi
     */
    public getTempControlProject(requestParameters: TempcontrolApiGetTempControlProjectRequest, options?: any) {
        const request = TempcontrolApiFp(this.configuration).getTempControlProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Customer-portal list endpoint. Admins and sales reps see every project (including anonymous ones with no `user_id`). Every other authenticated role is hard-scoped server-side to projects they own. 
     * @summary List TempControl projects
     * @param {TempcontrolApiListTempControlProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApi
     */
    public listTempControlProjects(requestParameters: TempcontrolApiListTempControlProjectsRequest = {}, options?: any) {
        const request = TempcontrolApiFp(this.configuration).listTempControlProjects(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Streams the rendered PDF back from the configured private filesystem. No Node spawn happens here - the PDF must already have been rendered by a prior `POST` call; if `pdf_status` is anything other than `ready` this returns `409` so the client can keep polling or surface the failure. 
     * @summary Stream the rendered TempControl project PDF
     * @param {TempcontrolApiStreamTempControlProjectPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApi
     */
    public streamTempControlProjectPdf(requestParameters: TempcontrolApiStreamTempControlProjectPdfRequest, options?: any) {
        const request = TempcontrolApiFp(this.configuration).streamTempControlProjectPdf(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Partially update a TempControl project. Top-level columns (`project_name`, customer fields, `current_step`) are replaced; the nested `inputs` object is shallow-merged into the persisted inputs JSON so the wizard can stream each step independently. 
     * @summary Update TempControl project
     * @param {TempcontrolApiUpdateTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TempcontrolApi
     */
    public updateTempControlProject(requestParameters: TempcontrolApiUpdateTempControlProjectRequest, options?: any) {
        const request = TempcontrolApiFp(this.configuration).updateTempControlProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * TerritoryApi - axios parameter creator
 * @export
 */
export const TerritoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a single territory by id with its associated region 
         * @summary Get Territory
         * @param {number} id The id of the territory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerritory: (id: number, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTerritory', 'id', id)
            const localVarPath = `/territories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of territories with their associated regions 
         * @summary List Territories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTerritories: (options: any = {}): RequestArgs => {
            const localVarPath = `/territories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerritoryApi - functional programming interface
 * @export
 */
export const TerritoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerritoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a single territory by id with its associated region 
         * @summary Get Territory
         * @param {TerritoryApiGetTerritoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerritory(requestParameters: TerritoryApiGetTerritoryRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TerritoryResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getTerritory(requestParameters.id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of territories with their associated regions 
         * @summary List Territories
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTerritories(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TerritoriesResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listTerritories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TerritoryApi - factory interface
 * @export
 */
export const TerritoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerritoryApiFp(configuration)

    /**
      * Fetch a single territory by id with its associated region 
      * @summary Get Territory
      * @param {TerritoryApiGetTerritoryRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getTerritory = (requestParameters: TerritoryApiGetTerritoryRequest, options?: any): AxiosPromise<TerritoryResponse> => {
        const request = localVarFp.getTerritory(requestParameters, options);
        return request(axios, basePath);
    };

    getTerritory.getQueryKey = (requestParameters: TerritoryApiGetTerritoryRequest, options?: any) => {
        const request = localVarFp.getTerritory(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of territories with their associated regions 
      * @summary List Territories
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listTerritories = (requestParameters?: undefined, options?: any): AxiosPromise<TerritoriesResponse> => {
        const request = localVarFp.listTerritories(requestParameters, options);
        return request(axios, basePath);
    };

    listTerritories.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.listTerritories(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        getTerritory,
        listTerritories,
    };
};

/**
 * TerritoryApi - interface
 * @export
 * @interface TerritoryApi
 */
export interface TerritoryApiInterface {
    /**
     * Fetch a single territory by id with its associated region 
     * @summary Get Territory
     * @param {TerritoryApiGetTerritoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerritoryApiInterface
     */
    getTerritory(requestParameters: TerritoryApiGetTerritoryRequest, options?: any): AxiosPromise<TerritoryResponse>;

    /**
     * Fetch a list of territories with their associated regions 
     * @summary List Territories
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerritoryApiInterface
     */
    listTerritories(requestParameters?: undefined, options?: any): AxiosPromise<TerritoriesResponse>;

}

/**
 * Request parameters for getTerritory operation in TerritoryApi.
 * @export
 * @interface TerritoryApiGetTerritoryRequest
 */
export interface TerritoryApiGetTerritoryRequest {
    /**
     * The id of the territory
     * @type {number}
     * @memberof TerritoryApiGetTerritory
     */
    readonly id: number
}

/**
 * TerritoryApi - object-oriented interface
 * @export
 * @class TerritoryApi
 * @extends {BaseAPI}
 */
export class TerritoryApi extends BaseAPI implements TerritoryApiInterface {
    /**
     * Fetch a single territory by id with its associated region 
     * @summary Get Territory
     * @param {TerritoryApiGetTerritoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerritoryApi
     */
    public getTerritory(requestParameters: TerritoryApiGetTerritoryRequest, options?: any) {
        const request = TerritoryApiFp(this.configuration).getTerritory(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of territories with their associated regions 
     * @summary List Territories
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerritoryApi
     */
    public listTerritories(requestParameters?: undefined, options?: any) {
        const request = TerritoryApiFp(this.configuration).listTerritories(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * TrackingApi - axios parameter creator
 * @export
 */
export const TrackingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a list of scores for a scorm or a user 
         * @summary Get scores list
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {string} [state] Filters scorm list by passed/incomplete state
         * @param {number} [scormId] The id of the scorm
         * @param {number} [userId] The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScormTrackings: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', search?: string, state?: string, scormId?: number, userId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/scorm/tracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (scormId !== undefined) {
                localVarQueryParameter['scorm_id'] = scormId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackingApi - functional programming interface
 * @export
 */
export const TrackingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrackingApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a list of scores for a scorm or a user 
         * @summary Get scores list
         * @param {TrackingApiListScormTrackingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScormTrackings(requestParameters: TrackingApiListScormTrackingsRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedScormScoTracking>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listScormTrackings(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.search, requestParameters.state, requestParameters.scormId, requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrackingApi - factory interface
 * @export
 */
export const TrackingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrackingApiFp(configuration)

    /**
      * Fetch a list of scores for a scorm or a user 
      * @summary Get scores list
      * @param {TrackingApiListScormTrackingsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listScormTrackings = (requestParameters: TrackingApiListScormTrackingsRequest = {}, options?: any): AxiosPromise<PaginatedScormScoTracking> => {
        const request = localVarFp.listScormTrackings(requestParameters, options);
        return request(axios, basePath);
    };

    listScormTrackings.getQueryKey = (requestParameters: TrackingApiListScormTrackingsRequest = {}, options?: any) => {
        const request = localVarFp.listScormTrackings(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        listScormTrackings,
    };
};

/**
 * TrackingApi - interface
 * @export
 * @interface TrackingApi
 */
export interface TrackingApiInterface {
    /**
     * Fetch a list of scores for a scorm or a user 
     * @summary Get scores list
     * @param {TrackingApiListScormTrackingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApiInterface
     */
    listScormTrackings(requestParameters?: TrackingApiListScormTrackingsRequest, options?: any): AxiosPromise<PaginatedScormScoTracking>;

}

/**
 * Request parameters for listScormTrackings operation in TrackingApi.
 * @export
 * @interface TrackingApiListScormTrackingsRequest
 */
export interface TrackingApiListScormTrackingsRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof TrackingApiListScormTrackings
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof TrackingApiListScormTrackings
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof TrackingApiListScormTrackings
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof TrackingApiListScormTrackings
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof TrackingApiListScormTrackings
     */
    readonly search?: string

    /**
     * Filters scorm list by passed/incomplete state
     * @type {string}
     * @memberof TrackingApiListScormTrackings
     */
    readonly state?: string

    /**
     * The id of the scorm
     * @type {number}
     * @memberof TrackingApiListScormTrackings
     */
    readonly scormId?: number

    /**
     * The id of the user
     * @type {number}
     * @memberof TrackingApiListScormTrackings
     */
    readonly userId?: number
}

/**
 * TrackingApi - object-oriented interface
 * @export
 * @class TrackingApi
 * @extends {BaseAPI}
 */
export class TrackingApi extends BaseAPI implements TrackingApiInterface {
    /**
     * Fetch a list of scores for a scorm or a user 
     * @summary Get scores list
     * @param {TrackingApiListScormTrackingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public listScormTrackings(requestParameters: TrackingApiListScormTrackingsRequest = {}, options?: any) {
        const request = TrackingApiFp(this.configuration).listScormTrackings(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * UpdateApi - axios parameter creator
 * @export
 */
export const UpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Request a change or return for an order 
         * @summary Request a change or a return
         * @param {number} id The id of the order
         * @param {RequestOrderChange} requestOrderChange Parameters for requesting an order change
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOrder: (id: number, requestOrderChange: RequestOrderChange, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeOrder', 'id', id)
            // verify required parameter 'requestOrderChange' is not null or undefined
            assertParamExists('changeOrder', 'requestOrderChange', requestOrderChange)
            const localVarPath = `/order/{id}/event`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestOrderChange, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows an admin to create a price sheet 
         * @summary Create Price Sheet
         * @param {number} [locationId] The location to use for the price sheet.  Only required if the user doesn\&#39;t have a location (eg multiple locations - admin, salesrep, company manager)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriceSheet: (locationId?: number, options: any = {}): RequestArgs => {
            const localVarPath = `/pricesheet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows an admin to create a report 
         * @summary Create Report
         * @param {ReportType} type The type of report to create
         * @param {number} [companyId] 
         * @param {number} [locationId] 
         * @param {number} [userId] 
         * @param {UserStatus | OrderStatus | QuoteStatus | number} [status] 
         * @param {string} [search] 
         * @param {UserRole} [role] 
         * @param {string} [state] 
         * @param {string} [name] 
         * @param {string} [orderNumber] Partial match filter on order number
         * @param {string} [orderDateStart] Filter by order date, bound by start date
         * @param {string} [orderDateEnd] Filter by order date, bound by end date
         * @param {string} [modelNumber] Filters the quotes by a particular model number.
         * @param {string} [city] Partial match on city name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport: (type: ReportType, companyId?: number, locationId?: number, userId?: number, status?: UserStatus | OrderStatus | QuoteStatus | number, search?: string, role?: UserRole, state?: string, name?: string, orderNumber?: string, orderDateStart?: string, orderDateEnd?: string, modelNumber?: string, city?: string, options: any = {}): RequestArgs => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('createReport', 'type', type)
            const localVarPath = `/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (orderNumber !== undefined) {
                localVarQueryParameter['order_number'] = orderNumber;
            }

            if (orderDateStart !== undefined) {
                localVarQueryParameter['order_date_start'] = (orderDateStart as any instanceof Date) ?
                    (orderDateStart as any).toISOString() :
                    orderDateStart;
            }

            if (orderDateEnd !== undefined) {
                localVarQueryParameter['order_date_end'] = (orderDateEnd as any instanceof Date) ?
                    (orderDateEnd as any).toISOString() :
                    orderDateEnd;
            }

            if (modelNumber !== undefined) {
                localVarQueryParameter['model_number'] = modelNumber;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move Billto to new company 
         * @summary Move Billto
         * @param {number} id The id of the company
         * @param {MoveBillToBody} moveBillToBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveBillToCompany: (id: number, moveBillToBody: MoveBillToBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moveBillToCompany', 'id', id)
            // verify required parameter 'moveBillToBody' is not null or undefined
            assertParamExists('moveBillToCompany', 'moveBillToBody', moveBillToBody)
            const localVarPath = `/company/{id}/billto`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveBillToBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or Update a scorm progress for authenticated user and scorm 
         * @summary Update Scorm progress for authenticated user
         * @param {number} id The id of the scorm
         * @param {UpdateScormProgressBody} updateScormProgressBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProgress: (id: number, updateScormProgressBody: UpdateScormProgressBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('saveProgress', 'id', id)
            // verify required parameter 'updateScormProgressBody' is not null or undefined
            assertParamExists('saveProgress', 'updateScormProgressBody', updateScormProgressBody)
            const localVarPath = `/scorm/progress/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateScormProgressBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a agency with a specific id 
         * @summary Update Agency
         * @param {number} id The id of the agency
         * @param {UpdateAgencyBody} updateAgencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgency: (id: number, updateAgencyBody: UpdateAgencyBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAgency', 'id', id)
            // verify required parameter 'updateAgencyBody' is not null or undefined
            assertParamExists('updateAgency', 'updateAgencyBody', updateAgencyBody)
            const localVarPath = `/agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAgencyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a company with a specific id 
         * @summary Update Company
         * @param {number} id The id of the company
         * @param {UpdateCompanyBody} updateCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: (id: number, updateCompanyBody: UpdateCompanyBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCompany', 'id', id)
            // verify required parameter 'updateCompanyBody' is not null or undefined
            assertParamExists('updateCompany', 'updateCompanyBody', updateCompanyBody)
            const localVarPath = `/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is the quote \"cart\" for the current user.  If you post a quote object to this endpoint, it will update the current quote with files, message, and products.  Product should be passed in as the product id, though a model_number will also be accepted. The quote status will accept statuses of 1 (pending) and 2 (sent).  Once a product has been moved from pending to sent, the quote will be sent to the the quoting team, and the quote endpoint will return an empty object, ready to start creating a new quote 
         * @summary Update Current Quote
         * @param {UpdateQuoteBody} updateQuoteBody Parameters for requesting a quote request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentQuote: (updateQuoteBody: UpdateQuoteBody, options: any = {}): RequestArgs => {
            // verify required parameter 'updateQuoteBody' is not null or undefined
            assertParamExists('updateCurrentQuote', 'updateQuoteBody', updateQuoteBody)
            const localVarPath = `/quote/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuoteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a file you own 
         * @summary Update File
         * @param {number} id The id of the order
         * @param {FileModelMetadataRequestBody} fileModelMetadataRequestBody Parameters for requesting an order change
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFile: (id: number, fileModelMetadataRequestBody: FileModelMetadataRequestBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFile', 'id', id)
            // verify required parameter 'fileModelMetadataRequestBody' is not null or undefined
            assertParamExists('updateFile', 'fileModelMetadataRequestBody', fileModelMetadataRequestBody)
            const localVarPath = `/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileModelMetadataRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Introduction with a specific id 
         * @summary Update Introduction
         * @param {number} id The id of the Introduction
         * @param {UpdateIntroductionBody} updateIntroductionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntroduction: (id: number, updateIntroductionBody: UpdateIntroductionBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateIntroduction', 'id', id)
            // verify required parameter 'updateIntroductionBody' is not null or undefined
            assertParamExists('updateIntroduction', 'updateIntroductionBody', updateIntroductionBody)
            const localVarPath = `/introduction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateIntroductionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a location with a specific id 
         * @summary Update Location
         * @param {number} locationId The id of the location
         * @param {UpdateLocationBody} updateLocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: (locationId: number, updateLocationBody: UpdateLocationBody, options: any = {}): RequestArgs => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateLocation', 'locationId', locationId)
            // verify required parameter 'updateLocationBody' is not null or undefined
            assertParamExists('updateLocation', 'updateLocationBody', updateLocationBody)
            const localVarPath = `/location/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the profile of the current user 
         * @summary Update Profile
         * @param {UserUpdate | UserUpdate & PasswordUpdate} userUpdateUserUpdatePasswordUpdate Request body for updating profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: (userUpdateUserUpdatePasswordUpdate: UserUpdate | UserUpdate & PasswordUpdate, options: any = {}): RequestArgs => {
            // verify required parameter 'userUpdateUserUpdatePasswordUpdate' is not null or undefined
            assertParamExists('updateProfile', 'userUpdateUserUpdatePasswordUpdate', userUpdateUserUpdatePasswordUpdate)
            const localVarPath = `/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateUserUpdatePasswordUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a project with a specific id.  This update will always change the latest version of the project. 
         * @summary Update Project
         * @param {number} id The id of the project
         * @param {ProjectUpdate} projectUpdate Request body for creating or updating a project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: (id: number, projectUpdate: ProjectUpdate, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProject', 'id', id)
            // verify required parameter 'projectUpdate' is not null or undefined
            assertParamExists('updateProject', 'projectUpdate', projectUpdate)
            const localVarPath = `/project/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a resource with a specific id 
         * @summary Update Resource
         * @param {number} id The id of the resource
         * @param {UpdateResourceBody} updateResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResource: (id: number, updateResourceBody: UpdateResourceBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateResource', 'id', id)
            // verify required parameter 'updateResourceBody' is not null or undefined
            assertParamExists('updateResource', 'updateResourceBody', updateResourceBody)
            const localVarPath = `/resource/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateResourceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a resource with a specific id 
         * @summary Update Category
         * @param {number} id The id of the category
         * @param {UpdateResourceCategory} updateResourceCategory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResourceCategory: (id: number, updateResourceCategory: UpdateResourceCategory, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateResourceCategory', 'id', id)
            // verify required parameter 'updateResourceCategory' is not null or undefined
            assertParamExists('updateResourceCategory', 'updateResourceCategory', updateResourceCategory)
            const localVarPath = `/resource/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateResourceCategory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a scorm with a specific id 
         * @summary Update Scorm
         * @param {number} id The id of the scorm
         * @param {UpdateScormBody} updateScormBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScorm: (id: number, updateScormBody: UpdateScormBody, options: any = {}): RequestArgs => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateScorm', 'id', id)
            // verify required parameter 'updateScormBody' is not null or undefined
            assertParamExists('updateScorm', 'updateScormBody', updateScormBody)
            const localVarPath = `/scorm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateScormBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update shower configuration with a specific id 
         * @summary Update shower configuration
         * @param {string} configurationKey The key of shower configuration
         * @param {CreateShowerConfigurationBody} createShowerConfigurationBody Request body for creating or updating a shower configuration
         * @param {string} [authorizationKey] Hashed md5 string used to authenticate product configuration editing for guest users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShowerConfiguration: (configurationKey: string, createShowerConfigurationBody: CreateShowerConfigurationBody, authorizationKey?: string, options: any = {}): RequestArgs => {
            // verify required parameter 'configurationKey' is not null or undefined
            assertParamExists('updateShowerConfiguration', 'configurationKey', configurationKey)
            // verify required parameter 'createShowerConfigurationBody' is not null or undefined
            assertParamExists('updateShowerConfiguration', 'createShowerConfigurationBody', createShowerConfigurationBody)
            const localVarPath = `/configuration/shower/{configuration_key}`
                .replace(`{${"configuration_key"}}`, encodeURIComponent(String(configurationKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (authorizationKey !== undefined && authorizationKey !== null) {
                localVarHeaderParameter['Authorization-Key'] = String(authorizationKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShowerConfigurationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially update a TempControl project. Top-level columns (`project_name`, customer fields, `current_step`) are replaced; the nested `inputs` object is shallow-merged into the persisted inputs JSON so the wizard can stream each step independently. 
         * @summary Update TempControl project
         * @param {string} key TempControl project key
         * @param {UpdateTempControlProjectBody} updateTempControlProjectBody Partial TempControl project update payload
         * @param {string} [authorizationKey] Hashed md5 string used to authenticate guest edits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTempControlProject: (key: string, updateTempControlProjectBody: UpdateTempControlProjectBody, authorizationKey?: string, options: any = {}): RequestArgs => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('updateTempControlProject', 'key', key)
            // verify required parameter 'updateTempControlProjectBody' is not null or undefined
            assertParamExists('updateTempControlProject', 'updateTempControlProjectBody', updateTempControlProjectBody)
            const localVarPath = `/tempcontrol/projects/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (authorizationKey !== undefined && authorizationKey !== null) {
                localVarHeaderParameter['Authorization-Key'] = String(authorizationKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTempControlProjectBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a user with a specific id 
         * @summary Update user
         * @param {number} userId The id of the user
         * @param {UserUpdate} userUpdate Request body for updating user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: (userId: number, userUpdate: UserUpdate, options: any = {}): RequestArgs => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'userUpdate' is not null or undefined
            assertParamExists('updateUser', 'userUpdate', userUpdate)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send the onboarding email to a user.  Right now no request body is required, though this might change 
         * @summary Send User Welcome
         * @param {number} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userWelcome: (userId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userWelcome', 'userId', userId)
            const localVarPath = `/user/{user_id}/welcome`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpdateApi - functional programming interface
 * @export
 */
export const UpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Request a change or return for an order 
         * @summary Request a change or a return
         * @param {UpdateApiChangeOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOrder(requestParameters: UpdateApiChangeOrderRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Order>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.changeOrder(requestParameters.id, requestParameters.requestOrderChange, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows an admin to create a price sheet 
         * @summary Create Price Sheet
         * @param {UpdateApiCreatePriceSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriceSheet(requestParameters: UpdateApiCreatePriceSheetRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PriceSheet>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createPriceSheet(requestParameters.locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows an admin to create a report 
         * @summary Create Report
         * @param {UpdateApiCreateReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(requestParameters: UpdateApiCreateReportRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Report>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createReport(requestParameters.type, requestParameters.companyId, requestParameters.locationId, requestParameters.userId, requestParameters.status, requestParameters.search, requestParameters.role, requestParameters.state, requestParameters.name, requestParameters.orderNumber, requestParameters.orderDateStart, requestParameters.orderDateEnd, requestParameters.modelNumber, requestParameters.city, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Move Billto to new company 
         * @summary Move Billto
         * @param {UpdateApiMoveBillToCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveBillToCompany(requestParameters: UpdateApiMoveBillToCompanyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Company>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.moveBillToCompany(requestParameters.id, requestParameters.moveBillToBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create or Update a scorm progress for authenticated user and scorm 
         * @summary Update Scorm progress for authenticated user
         * @param {UpdateApiSaveProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProgress(requestParameters: UpdateApiSaveProgressRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ScormScoTracking>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.saveProgress(requestParameters.id, requestParameters.updateScormProgressBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a agency with a specific id 
         * @summary Update Agency
         * @param {UpdateApiUpdateAgencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgency(requestParameters: UpdateApiUpdateAgencyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Agency>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateAgency(requestParameters.id, requestParameters.updateAgencyBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a company with a specific id 
         * @summary Update Company
         * @param {UpdateApiUpdateCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(requestParameters: UpdateApiUpdateCompanyRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Company>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateCompany(requestParameters.id, requestParameters.updateCompanyBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This is the quote \"cart\" for the current user.  If you post a quote object to this endpoint, it will update the current quote with files, message, and products.  Product should be passed in as the product id, though a model_number will also be accepted. The quote status will accept statuses of 1 (pending) and 2 (sent).  Once a product has been moved from pending to sent, the quote will be sent to the the quoting team, and the quote endpoint will return an empty object, ready to start creating a new quote 
         * @summary Update Current Quote
         * @param {UpdateApiUpdateCurrentQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentQuote(requestParameters: UpdateApiUpdateCurrentQuoteRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PendingQuote>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateCurrentQuote(requestParameters.updateQuoteBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a file you own 
         * @summary Update File
         * @param {UpdateApiUpdateFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFile(requestParameters: UpdateApiUpdateFileRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<FileModel>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateFile(requestParameters.id, requestParameters.fileModelMetadataRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a Introduction with a specific id 
         * @summary Update Introduction
         * @param {UpdateApiUpdateIntroductionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntroduction(requestParameters: UpdateApiUpdateIntroductionRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Introduction>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateIntroduction(requestParameters.id, requestParameters.updateIntroductionBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a location with a specific id 
         * @summary Update Location
         * @param {UpdateApiUpdateLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(requestParameters: UpdateApiUpdateLocationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Location>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateLocation(requestParameters.locationId, requestParameters.updateLocationBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the profile of the current user 
         * @summary Update Profile
         * @param {UpdateApiUpdateProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(requestParameters: UpdateApiUpdateProfileRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegisteredUser>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateProfile(requestParameters.userUpdateUserUpdatePasswordUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a project with a specific id.  This update will always change the latest version of the project. 
         * @summary Update Project
         * @param {UpdateApiUpdateProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject(requestParameters: UpdateApiUpdateProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Project>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateProject(requestParameters.id, requestParameters.projectUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a resource with a specific id 
         * @summary Update Resource
         * @param {UpdateApiUpdateResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResource(requestParameters: UpdateApiUpdateResourceRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Resource>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateResource(requestParameters.id, requestParameters.updateResourceBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a resource with a specific id 
         * @summary Update Category
         * @param {UpdateApiUpdateResourceCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResourceCategory(requestParameters: UpdateApiUpdateResourceCategoryRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TaxonomyTermConnect>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateResourceCategory(requestParameters.id, requestParameters.updateResourceCategory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a scorm with a specific id 
         * @summary Update Scorm
         * @param {UpdateApiUpdateScormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScorm(requestParameters: UpdateApiUpdateScormRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Scorm>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateScorm(requestParameters.id, requestParameters.updateScormBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update shower configuration with a specific id 
         * @summary Update shower configuration
         * @param {UpdateApiUpdateShowerConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShowerConfiguration(requestParameters: UpdateApiUpdateShowerConfigurationRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<ShowerConfiguration>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateShowerConfiguration(requestParameters.configurationKey, requestParameters.createShowerConfigurationBody, requestParameters.authorizationKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Partially update a TempControl project. Top-level columns (`project_name`, customer fields, `current_step`) are replaced; the nested `inputs` object is shallow-merged into the persisted inputs JSON so the wizard can stream each step independently. 
         * @summary Update TempControl project
         * @param {UpdateApiUpdateTempControlProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTempControlProject(requestParameters: UpdateApiUpdateTempControlProjectRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<TempControlProject>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateTempControlProject(requestParameters.key, requestParameters.updateTempControlProjectBody, requestParameters.authorizationKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a user with a specific id 
         * @summary Update user
         * @param {UpdateApiUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(requestParameters: UpdateApiUpdateUserRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<User>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateUser(requestParameters.userId, requestParameters.userUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send the onboarding email to a user.  Right now no request body is required, though this might change 
         * @summary Send User Welcome
         * @param {UpdateApiUserWelcomeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userWelcome(requestParameters: UpdateApiUserWelcomeRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegisteredUser>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.userWelcome(requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UpdateApi - factory interface
 * @export
 */
export const UpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpdateApiFp(configuration)

    /**
      * Request a change or return for an order 
      * @summary Request a change or a return
      * @param {UpdateApiChangeOrderRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const changeOrder = (requestParameters: UpdateApiChangeOrderRequest, options?: any): AxiosPromise<Order> => {
        const request = localVarFp.changeOrder(requestParameters, options);
        return request(axios, basePath);
    };

    changeOrder.getQueryKey = (requestParameters: UpdateApiChangeOrderRequest, options?: any) => {
        const request = localVarFp.changeOrder(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Allows an admin to create a price sheet 
      * @summary Create Price Sheet
      * @param {UpdateApiCreatePriceSheetRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createPriceSheet = (requestParameters: UpdateApiCreatePriceSheetRequest = {}, options?: any): AxiosPromise<PriceSheet> => {
        const request = localVarFp.createPriceSheet(requestParameters, options);
        return request(axios, basePath);
    };

    createPriceSheet.getQueryKey = (requestParameters: UpdateApiCreatePriceSheetRequest = {}, options?: any) => {
        const request = localVarFp.createPriceSheet(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Allows an admin to create a report 
      * @summary Create Report
      * @param {UpdateApiCreateReportRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createReport = (requestParameters: UpdateApiCreateReportRequest, options?: any): AxiosPromise<Report> => {
        const request = localVarFp.createReport(requestParameters, options);
        return request(axios, basePath);
    };

    createReport.getQueryKey = (requestParameters: UpdateApiCreateReportRequest, options?: any) => {
        const request = localVarFp.createReport(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Move Billto to new company 
      * @summary Move Billto
      * @param {UpdateApiMoveBillToCompanyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const moveBillToCompany = (requestParameters: UpdateApiMoveBillToCompanyRequest, options?: any): AxiosPromise<Company> => {
        const request = localVarFp.moveBillToCompany(requestParameters, options);
        return request(axios, basePath);
    };

    moveBillToCompany.getQueryKey = (requestParameters: UpdateApiMoveBillToCompanyRequest, options?: any) => {
        const request = localVarFp.moveBillToCompany(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Create or Update a scorm progress for authenticated user and scorm 
      * @summary Update Scorm progress for authenticated user
      * @param {UpdateApiSaveProgressRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const saveProgress = (requestParameters: UpdateApiSaveProgressRequest, options?: any): AxiosPromise<ScormScoTracking> => {
        const request = localVarFp.saveProgress(requestParameters, options);
        return request(axios, basePath);
    };

    saveProgress.getQueryKey = (requestParameters: UpdateApiSaveProgressRequest, options?: any) => {
        const request = localVarFp.saveProgress(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a agency with a specific id 
      * @summary Update Agency
      * @param {UpdateApiUpdateAgencyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateAgency = (requestParameters: UpdateApiUpdateAgencyRequest, options?: any): AxiosPromise<Agency> => {
        const request = localVarFp.updateAgency(requestParameters, options);
        return request(axios, basePath);
    };

    updateAgency.getQueryKey = (requestParameters: UpdateApiUpdateAgencyRequest, options?: any) => {
        const request = localVarFp.updateAgency(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a company with a specific id 
      * @summary Update Company
      * @param {UpdateApiUpdateCompanyRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateCompany = (requestParameters: UpdateApiUpdateCompanyRequest, options?: any): AxiosPromise<Company> => {
        const request = localVarFp.updateCompany(requestParameters, options);
        return request(axios, basePath);
    };

    updateCompany.getQueryKey = (requestParameters: UpdateApiUpdateCompanyRequest, options?: any) => {
        const request = localVarFp.updateCompany(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * This is the quote \"cart\" for the current user.  If you post a quote object to this endpoint, it will update the current quote with files, message, and products.  Product should be passed in as the product id, though a model_number will also be accepted. The quote status will accept statuses of 1 (pending) and 2 (sent).  Once a product has been moved from pending to sent, the quote will be sent to the the quoting team, and the quote endpoint will return an empty object, ready to start creating a new quote 
      * @summary Update Current Quote
      * @param {UpdateApiUpdateCurrentQuoteRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateCurrentQuote = (requestParameters: UpdateApiUpdateCurrentQuoteRequest, options?: any): AxiosPromise<PendingQuote> => {
        const request = localVarFp.updateCurrentQuote(requestParameters, options);
        return request(axios, basePath);
    };

    updateCurrentQuote.getQueryKey = (requestParameters: UpdateApiUpdateCurrentQuoteRequest, options?: any) => {
        const request = localVarFp.updateCurrentQuote(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a file you own 
      * @summary Update File
      * @param {UpdateApiUpdateFileRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateFile = (requestParameters: UpdateApiUpdateFileRequest, options?: any): AxiosPromise<FileModel> => {
        const request = localVarFp.updateFile(requestParameters, options);
        return request(axios, basePath);
    };

    updateFile.getQueryKey = (requestParameters: UpdateApiUpdateFileRequest, options?: any) => {
        const request = localVarFp.updateFile(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a Introduction with a specific id 
      * @summary Update Introduction
      * @param {UpdateApiUpdateIntroductionRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateIntroduction = (requestParameters: UpdateApiUpdateIntroductionRequest, options?: any): AxiosPromise<Introduction> => {
        const request = localVarFp.updateIntroduction(requestParameters, options);
        return request(axios, basePath);
    };

    updateIntroduction.getQueryKey = (requestParameters: UpdateApiUpdateIntroductionRequest, options?: any) => {
        const request = localVarFp.updateIntroduction(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a location with a specific id 
      * @summary Update Location
      * @param {UpdateApiUpdateLocationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateLocation = (requestParameters: UpdateApiUpdateLocationRequest, options?: any): AxiosPromise<Location> => {
        const request = localVarFp.updateLocation(requestParameters, options);
        return request(axios, basePath);
    };

    updateLocation.getQueryKey = (requestParameters: UpdateApiUpdateLocationRequest, options?: any) => {
        const request = localVarFp.updateLocation(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update the profile of the current user 
      * @summary Update Profile
      * @param {UpdateApiUpdateProfileRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateProfile = (requestParameters: UpdateApiUpdateProfileRequest, options?: any): AxiosPromise<RegisteredUser> => {
        const request = localVarFp.updateProfile(requestParameters, options);
        return request(axios, basePath);
    };

    updateProfile.getQueryKey = (requestParameters: UpdateApiUpdateProfileRequest, options?: any) => {
        const request = localVarFp.updateProfile(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a project with a specific id.  This update will always change the latest version of the project. 
      * @summary Update Project
      * @param {UpdateApiUpdateProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateProject = (requestParameters: UpdateApiUpdateProjectRequest, options?: any): AxiosPromise<Project> => {
        const request = localVarFp.updateProject(requestParameters, options);
        return request(axios, basePath);
    };

    updateProject.getQueryKey = (requestParameters: UpdateApiUpdateProjectRequest, options?: any) => {
        const request = localVarFp.updateProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a resource with a specific id 
      * @summary Update Resource
      * @param {UpdateApiUpdateResourceRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateResource = (requestParameters: UpdateApiUpdateResourceRequest, options?: any): AxiosPromise<Resource> => {
        const request = localVarFp.updateResource(requestParameters, options);
        return request(axios, basePath);
    };

    updateResource.getQueryKey = (requestParameters: UpdateApiUpdateResourceRequest, options?: any) => {
        const request = localVarFp.updateResource(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a resource with a specific id 
      * @summary Update Category
      * @param {UpdateApiUpdateResourceCategoryRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateResourceCategory = (requestParameters: UpdateApiUpdateResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect> => {
        const request = localVarFp.updateResourceCategory(requestParameters, options);
        return request(axios, basePath);
    };

    updateResourceCategory.getQueryKey = (requestParameters: UpdateApiUpdateResourceCategoryRequest, options?: any) => {
        const request = localVarFp.updateResourceCategory(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a scorm with a specific id 
      * @summary Update Scorm
      * @param {UpdateApiUpdateScormRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateScorm = (requestParameters: UpdateApiUpdateScormRequest, options?: any): AxiosPromise<Scorm> => {
        const request = localVarFp.updateScorm(requestParameters, options);
        return request(axios, basePath);
    };

    updateScorm.getQueryKey = (requestParameters: UpdateApiUpdateScormRequest, options?: any) => {
        const request = localVarFp.updateScorm(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update shower configuration with a specific id 
      * @summary Update shower configuration
      * @param {UpdateApiUpdateShowerConfigurationRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateShowerConfiguration = (requestParameters: UpdateApiUpdateShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfiguration> => {
        const request = localVarFp.updateShowerConfiguration(requestParameters, options);
        return request(axios, basePath);
    };

    updateShowerConfiguration.getQueryKey = (requestParameters: UpdateApiUpdateShowerConfigurationRequest, options?: any) => {
        const request = localVarFp.updateShowerConfiguration(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Partially update a TempControl project. Top-level columns (`project_name`, customer fields, `current_step`) are replaced; the nested `inputs` object is shallow-merged into the persisted inputs JSON so the wizard can stream each step independently. 
      * @summary Update TempControl project
      * @param {UpdateApiUpdateTempControlProjectRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateTempControlProject = (requestParameters: UpdateApiUpdateTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject> => {
        const request = localVarFp.updateTempControlProject(requestParameters, options);
        return request(axios, basePath);
    };

    updateTempControlProject.getQueryKey = (requestParameters: UpdateApiUpdateTempControlProjectRequest, options?: any) => {
        const request = localVarFp.updateTempControlProject(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a user with a specific id 
      * @summary Update user
      * @param {UpdateApiUpdateUserRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateUser = (requestParameters: UpdateApiUpdateUserRequest, options?: any): AxiosPromise<User> => {
        const request = localVarFp.updateUser(requestParameters, options);
        return request(axios, basePath);
    };

    updateUser.getQueryKey = (requestParameters: UpdateApiUpdateUserRequest, options?: any) => {
        const request = localVarFp.updateUser(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Send the onboarding email to a user.  Right now no request body is required, though this might change 
      * @summary Send User Welcome
      * @param {UpdateApiUserWelcomeRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const userWelcome = (requestParameters: UpdateApiUserWelcomeRequest, options?: any): AxiosPromise<RegisteredUser> => {
        const request = localVarFp.userWelcome(requestParameters, options);
        return request(axios, basePath);
    };

    userWelcome.getQueryKey = (requestParameters: UpdateApiUserWelcomeRequest, options?: any) => {
        const request = localVarFp.userWelcome(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        changeOrder,
        createPriceSheet,
        createReport,
        moveBillToCompany,
        saveProgress,
        updateAgency,
        updateCompany,
        updateCurrentQuote,
        updateFile,
        updateIntroduction,
        updateLocation,
        updateProfile,
        updateProject,
        updateResource,
        updateResourceCategory,
        updateScorm,
        updateShowerConfiguration,
        updateTempControlProject,
        updateUser,
        userWelcome,
    };
};

/**
 * UpdateApi - interface
 * @export
 * @interface UpdateApi
 */
export interface UpdateApiInterface {
    /**
     * Request a change or return for an order 
     * @summary Request a change or a return
     * @param {UpdateApiChangeOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    changeOrder(requestParameters: UpdateApiChangeOrderRequest, options?: any): AxiosPromise<Order>;

    /**
     * Allows an admin to create a price sheet 
     * @summary Create Price Sheet
     * @param {UpdateApiCreatePriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    createPriceSheet(requestParameters?: UpdateApiCreatePriceSheetRequest, options?: any): AxiosPromise<PriceSheet>;

    /**
     * Allows an admin to create a report 
     * @summary Create Report
     * @param {UpdateApiCreateReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    createReport(requestParameters: UpdateApiCreateReportRequest, options?: any): AxiosPromise<Report>;

    /**
     * Move Billto to new company 
     * @summary Move Billto
     * @param {UpdateApiMoveBillToCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    moveBillToCompany(requestParameters: UpdateApiMoveBillToCompanyRequest, options?: any): AxiosPromise<Company>;

    /**
     * Create or Update a scorm progress for authenticated user and scorm 
     * @summary Update Scorm progress for authenticated user
     * @param {UpdateApiSaveProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    saveProgress(requestParameters: UpdateApiSaveProgressRequest, options?: any): AxiosPromise<ScormScoTracking>;

    /**
     * Update a agency with a specific id 
     * @summary Update Agency
     * @param {UpdateApiUpdateAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateAgency(requestParameters: UpdateApiUpdateAgencyRequest, options?: any): AxiosPromise<Agency>;

    /**
     * Update a company with a specific id 
     * @summary Update Company
     * @param {UpdateApiUpdateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateCompany(requestParameters: UpdateApiUpdateCompanyRequest, options?: any): AxiosPromise<Company>;

    /**
     * This is the quote \"cart\" for the current user.  If you post a quote object to this endpoint, it will update the current quote with files, message, and products.  Product should be passed in as the product id, though a model_number will also be accepted. The quote status will accept statuses of 1 (pending) and 2 (sent).  Once a product has been moved from pending to sent, the quote will be sent to the the quoting team, and the quote endpoint will return an empty object, ready to start creating a new quote 
     * @summary Update Current Quote
     * @param {UpdateApiUpdateCurrentQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateCurrentQuote(requestParameters: UpdateApiUpdateCurrentQuoteRequest, options?: any): AxiosPromise<PendingQuote>;

    /**
     * Update a file you own 
     * @summary Update File
     * @param {UpdateApiUpdateFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateFile(requestParameters: UpdateApiUpdateFileRequest, options?: any): AxiosPromise<FileModel>;

    /**
     * Update a Introduction with a specific id 
     * @summary Update Introduction
     * @param {UpdateApiUpdateIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateIntroduction(requestParameters: UpdateApiUpdateIntroductionRequest, options?: any): AxiosPromise<Introduction>;

    /**
     * Update a location with a specific id 
     * @summary Update Location
     * @param {UpdateApiUpdateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateLocation(requestParameters: UpdateApiUpdateLocationRequest, options?: any): AxiosPromise<Location>;

    /**
     * Update the profile of the current user 
     * @summary Update Profile
     * @param {UpdateApiUpdateProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateProfile(requestParameters: UpdateApiUpdateProfileRequest, options?: any): AxiosPromise<RegisteredUser>;

    /**
     * Update a project with a specific id.  This update will always change the latest version of the project. 
     * @summary Update Project
     * @param {UpdateApiUpdateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateProject(requestParameters: UpdateApiUpdateProjectRequest, options?: any): AxiosPromise<Project>;

    /**
     * Update a resource with a specific id 
     * @summary Update Resource
     * @param {UpdateApiUpdateResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateResource(requestParameters: UpdateApiUpdateResourceRequest, options?: any): AxiosPromise<Resource>;

    /**
     * Update a resource with a specific id 
     * @summary Update Category
     * @param {UpdateApiUpdateResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateResourceCategory(requestParameters: UpdateApiUpdateResourceCategoryRequest, options?: any): AxiosPromise<TaxonomyTermConnect>;

    /**
     * Update a scorm with a specific id 
     * @summary Update Scorm
     * @param {UpdateApiUpdateScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateScorm(requestParameters: UpdateApiUpdateScormRequest, options?: any): AxiosPromise<Scorm>;

    /**
     * Update shower configuration with a specific id 
     * @summary Update shower configuration
     * @param {UpdateApiUpdateShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateShowerConfiguration(requestParameters: UpdateApiUpdateShowerConfigurationRequest, options?: any): AxiosPromise<ShowerConfiguration>;

    /**
     * Partially update a TempControl project. Top-level columns (`project_name`, customer fields, `current_step`) are replaced; the nested `inputs` object is shallow-merged into the persisted inputs JSON so the wizard can stream each step independently. 
     * @summary Update TempControl project
     * @param {UpdateApiUpdateTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateTempControlProject(requestParameters: UpdateApiUpdateTempControlProjectRequest, options?: any): AxiosPromise<TempControlProject>;

    /**
     * Update a user with a specific id 
     * @summary Update user
     * @param {UpdateApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    updateUser(requestParameters: UpdateApiUpdateUserRequest, options?: any): AxiosPromise<User>;

    /**
     * Send the onboarding email to a user.  Right now no request body is required, though this might change 
     * @summary Send User Welcome
     * @param {UpdateApiUserWelcomeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApiInterface
     */
    userWelcome(requestParameters: UpdateApiUserWelcomeRequest, options?: any): AxiosPromise<RegisteredUser>;

}

/**
 * Request parameters for changeOrder operation in UpdateApi.
 * @export
 * @interface UpdateApiChangeOrderRequest
 */
export interface UpdateApiChangeOrderRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof UpdateApiChangeOrder
     */
    readonly id: number

    /**
     * Parameters for requesting an order change
     * @type {RequestOrderChange}
     * @memberof UpdateApiChangeOrder
     */
    readonly requestOrderChange: RequestOrderChange
}

/**
 * Request parameters for createPriceSheet operation in UpdateApi.
 * @export
 * @interface UpdateApiCreatePriceSheetRequest
 */
export interface UpdateApiCreatePriceSheetRequest {
    /**
     * The location to use for the price sheet.  Only required if the user doesn\&#39;t have a location (eg multiple locations - admin, salesrep, company manager)
     * @type {number}
     * @memberof UpdateApiCreatePriceSheet
     */
    readonly locationId?: number
}

/**
 * Request parameters for createReport operation in UpdateApi.
 * @export
 * @interface UpdateApiCreateReportRequest
 */
export interface UpdateApiCreateReportRequest {
    /**
     * The type of report to create
     * @type {ReportType}
     * @memberof UpdateApiCreateReport
     */
    readonly type: ReportType

    /**
     * 
     * @type {number}
     * @memberof UpdateApiCreateReport
     */
    readonly companyId?: number

    /**
     * 
     * @type {number}
     * @memberof UpdateApiCreateReport
     */
    readonly locationId?: number

    /**
     * 
     * @type {number}
     * @memberof UpdateApiCreateReport
     */
    readonly userId?: number

    /**
     * 
     * @type {UserStatus | OrderStatus | QuoteStatus | number}
     * @memberof UpdateApiCreateReport
     */
    readonly status?: UserStatus | OrderStatus | QuoteStatus | number

    /**
     * 
     * @type {string}
     * @memberof UpdateApiCreateReport
     */
    readonly search?: string

    /**
     * 
     * @type {UserRole}
     * @memberof UpdateApiCreateReport
     */
    readonly role?: UserRole

    /**
     * 
     * @type {string}
     * @memberof UpdateApiCreateReport
     */
    readonly state?: string

    /**
     * 
     * @type {string}
     * @memberof UpdateApiCreateReport
     */
    readonly name?: string

    /**
     * Partial match filter on order number
     * @type {string}
     * @memberof UpdateApiCreateReport
     */
    readonly orderNumber?: string

    /**
     * Filter by order date, bound by start date
     * @type {string}
     * @memberof UpdateApiCreateReport
     */
    readonly orderDateStart?: string

    /**
     * Filter by order date, bound by end date
     * @type {string}
     * @memberof UpdateApiCreateReport
     */
    readonly orderDateEnd?: string

    /**
     * Filters the quotes by a particular model number.
     * @type {string}
     * @memberof UpdateApiCreateReport
     */
    readonly modelNumber?: string

    /**
     * Partial match on city name
     * @type {string}
     * @memberof UpdateApiCreateReport
     */
    readonly city?: string
}

/**
 * Request parameters for moveBillToCompany operation in UpdateApi.
 * @export
 * @interface UpdateApiMoveBillToCompanyRequest
 */
export interface UpdateApiMoveBillToCompanyRequest {
    /**
     * The id of the company
     * @type {number}
     * @memberof UpdateApiMoveBillToCompany
     */
    readonly id: number

    /**
     * 
     * @type {MoveBillToBody}
     * @memberof UpdateApiMoveBillToCompany
     */
    readonly moveBillToBody: MoveBillToBody
}

/**
 * Request parameters for saveProgress operation in UpdateApi.
 * @export
 * @interface UpdateApiSaveProgressRequest
 */
export interface UpdateApiSaveProgressRequest {
    /**
     * The id of the scorm
     * @type {number}
     * @memberof UpdateApiSaveProgress
     */
    readonly id: number

    /**
     * 
     * @type {UpdateScormProgressBody}
     * @memberof UpdateApiSaveProgress
     */
    readonly updateScormProgressBody: UpdateScormProgressBody
}

/**
 * Request parameters for updateAgency operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateAgencyRequest
 */
export interface UpdateApiUpdateAgencyRequest {
    /**
     * The id of the agency
     * @type {number}
     * @memberof UpdateApiUpdateAgency
     */
    readonly id: number

    /**
     * 
     * @type {UpdateAgencyBody}
     * @memberof UpdateApiUpdateAgency
     */
    readonly updateAgencyBody: UpdateAgencyBody
}

/**
 * Request parameters for updateCompany operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateCompanyRequest
 */
export interface UpdateApiUpdateCompanyRequest {
    /**
     * The id of the company
     * @type {number}
     * @memberof UpdateApiUpdateCompany
     */
    readonly id: number

    /**
     * 
     * @type {UpdateCompanyBody}
     * @memberof UpdateApiUpdateCompany
     */
    readonly updateCompanyBody: UpdateCompanyBody
}

/**
 * Request parameters for updateCurrentQuote operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateCurrentQuoteRequest
 */
export interface UpdateApiUpdateCurrentQuoteRequest {
    /**
     * Parameters for requesting a quote request
     * @type {UpdateQuoteBody}
     * @memberof UpdateApiUpdateCurrentQuote
     */
    readonly updateQuoteBody: UpdateQuoteBody
}

/**
 * Request parameters for updateFile operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateFileRequest
 */
export interface UpdateApiUpdateFileRequest {
    /**
     * The id of the order
     * @type {number}
     * @memberof UpdateApiUpdateFile
     */
    readonly id: number

    /**
     * Parameters for requesting an order change
     * @type {FileModelMetadataRequestBody}
     * @memberof UpdateApiUpdateFile
     */
    readonly fileModelMetadataRequestBody: FileModelMetadataRequestBody
}

/**
 * Request parameters for updateIntroduction operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateIntroductionRequest
 */
export interface UpdateApiUpdateIntroductionRequest {
    /**
     * The id of the Introduction
     * @type {number}
     * @memberof UpdateApiUpdateIntroduction
     */
    readonly id: number

    /**
     * 
     * @type {UpdateIntroductionBody}
     * @memberof UpdateApiUpdateIntroduction
     */
    readonly updateIntroductionBody: UpdateIntroductionBody
}

/**
 * Request parameters for updateLocation operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateLocationRequest
 */
export interface UpdateApiUpdateLocationRequest {
    /**
     * The id of the location
     * @type {number}
     * @memberof UpdateApiUpdateLocation
     */
    readonly locationId: number

    /**
     * 
     * @type {UpdateLocationBody}
     * @memberof UpdateApiUpdateLocation
     */
    readonly updateLocationBody: UpdateLocationBody
}

/**
 * Request parameters for updateProfile operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateProfileRequest
 */
export interface UpdateApiUpdateProfileRequest {
    /**
     * Request body for updating profile
     * @type {UserUpdate | UserUpdate & PasswordUpdate}
     * @memberof UpdateApiUpdateProfile
     */
    readonly userUpdateUserUpdatePasswordUpdate: UserUpdate | UserUpdate & PasswordUpdate
}

/**
 * Request parameters for updateProject operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateProjectRequest
 */
export interface UpdateApiUpdateProjectRequest {
    /**
     * The id of the project
     * @type {number}
     * @memberof UpdateApiUpdateProject
     */
    readonly id: number

    /**
     * Request body for creating or updating a project
     * @type {ProjectUpdate}
     * @memberof UpdateApiUpdateProject
     */
    readonly projectUpdate: ProjectUpdate
}

/**
 * Request parameters for updateResource operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateResourceRequest
 */
export interface UpdateApiUpdateResourceRequest {
    /**
     * The id of the resource
     * @type {number}
     * @memberof UpdateApiUpdateResource
     */
    readonly id: number

    /**
     * 
     * @type {UpdateResourceBody}
     * @memberof UpdateApiUpdateResource
     */
    readonly updateResourceBody: UpdateResourceBody
}

/**
 * Request parameters for updateResourceCategory operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateResourceCategoryRequest
 */
export interface UpdateApiUpdateResourceCategoryRequest {
    /**
     * The id of the category
     * @type {number}
     * @memberof UpdateApiUpdateResourceCategory
     */
    readonly id: number

    /**
     * 
     * @type {UpdateResourceCategory}
     * @memberof UpdateApiUpdateResourceCategory
     */
    readonly updateResourceCategory: UpdateResourceCategory
}

/**
 * Request parameters for updateScorm operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateScormRequest
 */
export interface UpdateApiUpdateScormRequest {
    /**
     * The id of the scorm
     * @type {number}
     * @memberof UpdateApiUpdateScorm
     */
    readonly id: number

    /**
     * 
     * @type {UpdateScormBody}
     * @memberof UpdateApiUpdateScorm
     */
    readonly updateScormBody: UpdateScormBody
}

/**
 * Request parameters for updateShowerConfiguration operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateShowerConfigurationRequest
 */
export interface UpdateApiUpdateShowerConfigurationRequest {
    /**
     * The key of shower configuration
     * @type {string}
     * @memberof UpdateApiUpdateShowerConfiguration
     */
    readonly configurationKey: string

    /**
     * Request body for creating or updating a shower configuration
     * @type {CreateShowerConfigurationBody}
     * @memberof UpdateApiUpdateShowerConfiguration
     */
    readonly createShowerConfigurationBody: CreateShowerConfigurationBody

    /**
     * Hashed md5 string used to authenticate product configuration editing for guest users
     * @type {string}
     * @memberof UpdateApiUpdateShowerConfiguration
     */
    readonly authorizationKey?: string
}

/**
 * Request parameters for updateTempControlProject operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateTempControlProjectRequest
 */
export interface UpdateApiUpdateTempControlProjectRequest {
    /**
     * TempControl project key
     * @type {string}
     * @memberof UpdateApiUpdateTempControlProject
     */
    readonly key: string

    /**
     * Partial TempControl project update payload
     * @type {UpdateTempControlProjectBody}
     * @memberof UpdateApiUpdateTempControlProject
     */
    readonly updateTempControlProjectBody: UpdateTempControlProjectBody

    /**
     * Hashed md5 string used to authenticate guest edits
     * @type {string}
     * @memberof UpdateApiUpdateTempControlProject
     */
    readonly authorizationKey?: string
}

/**
 * Request parameters for updateUser operation in UpdateApi.
 * @export
 * @interface UpdateApiUpdateUserRequest
 */
export interface UpdateApiUpdateUserRequest {
    /**
     * The id of the user
     * @type {number}
     * @memberof UpdateApiUpdateUser
     */
    readonly userId: number

    /**
     * Request body for updating user
     * @type {UserUpdate}
     * @memberof UpdateApiUpdateUser
     */
    readonly userUpdate: UserUpdate
}

/**
 * Request parameters for userWelcome operation in UpdateApi.
 * @export
 * @interface UpdateApiUserWelcomeRequest
 */
export interface UpdateApiUserWelcomeRequest {
    /**
     * The id of the user
     * @type {number}
     * @memberof UpdateApiUserWelcome
     */
    readonly userId: number
}

/**
 * UpdateApi - object-oriented interface
 * @export
 * @class UpdateApi
 * @extends {BaseAPI}
 */
export class UpdateApi extends BaseAPI implements UpdateApiInterface {
    /**
     * Request a change or return for an order 
     * @summary Request a change or a return
     * @param {UpdateApiChangeOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public changeOrder(requestParameters: UpdateApiChangeOrderRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).changeOrder(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Allows an admin to create a price sheet 
     * @summary Create Price Sheet
     * @param {UpdateApiCreatePriceSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public createPriceSheet(requestParameters: UpdateApiCreatePriceSheetRequest = {}, options?: any) {
        const request = UpdateApiFp(this.configuration).createPriceSheet(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Allows an admin to create a report 
     * @summary Create Report
     * @param {UpdateApiCreateReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public createReport(requestParameters: UpdateApiCreateReportRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).createReport(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Move Billto to new company 
     * @summary Move Billto
     * @param {UpdateApiMoveBillToCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public moveBillToCompany(requestParameters: UpdateApiMoveBillToCompanyRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).moveBillToCompany(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Create or Update a scorm progress for authenticated user and scorm 
     * @summary Update Scorm progress for authenticated user
     * @param {UpdateApiSaveProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public saveProgress(requestParameters: UpdateApiSaveProgressRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).saveProgress(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a agency with a specific id 
     * @summary Update Agency
     * @param {UpdateApiUpdateAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateAgency(requestParameters: UpdateApiUpdateAgencyRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateAgency(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a company with a specific id 
     * @summary Update Company
     * @param {UpdateApiUpdateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateCompany(requestParameters: UpdateApiUpdateCompanyRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateCompany(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * This is the quote \"cart\" for the current user.  If you post a quote object to this endpoint, it will update the current quote with files, message, and products.  Product should be passed in as the product id, though a model_number will also be accepted. The quote status will accept statuses of 1 (pending) and 2 (sent).  Once a product has been moved from pending to sent, the quote will be sent to the the quoting team, and the quote endpoint will return an empty object, ready to start creating a new quote 
     * @summary Update Current Quote
     * @param {UpdateApiUpdateCurrentQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateCurrentQuote(requestParameters: UpdateApiUpdateCurrentQuoteRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateCurrentQuote(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a file you own 
     * @summary Update File
     * @param {UpdateApiUpdateFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateFile(requestParameters: UpdateApiUpdateFileRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateFile(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a Introduction with a specific id 
     * @summary Update Introduction
     * @param {UpdateApiUpdateIntroductionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateIntroduction(requestParameters: UpdateApiUpdateIntroductionRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateIntroduction(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a location with a specific id 
     * @summary Update Location
     * @param {UpdateApiUpdateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateLocation(requestParameters: UpdateApiUpdateLocationRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateLocation(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update the profile of the current user 
     * @summary Update Profile
     * @param {UpdateApiUpdateProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateProfile(requestParameters: UpdateApiUpdateProfileRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateProfile(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a project with a specific id.  This update will always change the latest version of the project. 
     * @summary Update Project
     * @param {UpdateApiUpdateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateProject(requestParameters: UpdateApiUpdateProjectRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a resource with a specific id 
     * @summary Update Resource
     * @param {UpdateApiUpdateResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateResource(requestParameters: UpdateApiUpdateResourceRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateResource(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a resource with a specific id 
     * @summary Update Category
     * @param {UpdateApiUpdateResourceCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateResourceCategory(requestParameters: UpdateApiUpdateResourceCategoryRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateResourceCategory(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a scorm with a specific id 
     * @summary Update Scorm
     * @param {UpdateApiUpdateScormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateScorm(requestParameters: UpdateApiUpdateScormRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateScorm(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update shower configuration with a specific id 
     * @summary Update shower configuration
     * @param {UpdateApiUpdateShowerConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateShowerConfiguration(requestParameters: UpdateApiUpdateShowerConfigurationRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateShowerConfiguration(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Partially update a TempControl project. Top-level columns (`project_name`, customer fields, `current_step`) are replaced; the nested `inputs` object is shallow-merged into the persisted inputs JSON so the wizard can stream each step independently. 
     * @summary Update TempControl project
     * @param {UpdateApiUpdateTempControlProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateTempControlProject(requestParameters: UpdateApiUpdateTempControlProjectRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateTempControlProject(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a user with a specific id 
     * @summary Update user
     * @param {UpdateApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public updateUser(requestParameters: UpdateApiUpdateUserRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).updateUser(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Send the onboarding email to a user.  Right now no request body is required, though this might change 
     * @summary Send User Welcome
     * @param {UpdateApiUserWelcomeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateApi
     */
    public userWelcome(requestParameters: UpdateApiUserWelcomeRequest, options?: any) {
        const request = UpdateApiFp(this.configuration).userWelcome(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a file attached to a specific user, and returns a 
         * @summary Upload a File
         * @param {any} image 
         * @param {FileType} type 
         * @param {string} [title] 
         * @param {string} [alt] 
         * @param {FileStatus} [status] 
         * @param {FileVisibility} [visibility] This allows privileged users to set the visibility level to allow other users to see a files. This will default to hidden, which means no one will see it, even the current user.  Setting to private will add the file to my file library.  Setting to location and company will allow anyone in my location or company respectively.  Setting to public is only available to admins and will add it to the global library 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: (image: any, type: FileType, title?: string, alt?: string, status?: FileStatus, visibility?: FileVisibility, options: any = {}): RequestArgs => {
            // verify required parameter 'image' is not null or undefined
            assertParamExists('upload', 'image', image)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('upload', 'type', type)
            const localVarPath = `/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
    
            if (alt !== undefined) { 
                localVarFormParams.append('alt', alt as any);
            }
    
            if (status !== undefined) { 
                localVarFormParams.append('status', status as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.append('type', type as any);
            }
    
            if (visibility !== undefined) { 
                localVarFormParams.append('visibility', visibility as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a file attached to a specific user, and returns a 
         * @summary Upload a File
         * @param {UploadApiUploadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(requestParameters: UploadApiUploadRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<FileModel>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.upload(requestParameters.image, requestParameters.type, requestParameters.title, requestParameters.alt, requestParameters.status, requestParameters.visibility, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadApiFp(configuration)

    /**
      * Creates a file attached to a specific user, and returns a 
      * @summary Upload a File
      * @param {UploadApiUploadRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const upload = (requestParameters: UploadApiUploadRequest, options?: any): AxiosPromise<FileModel> => {
        const request = localVarFp.upload(requestParameters, options);
        return request(axios, basePath);
    };

    upload.getQueryKey = (requestParameters: UploadApiUploadRequest, options?: any) => {
        const request = localVarFp.upload(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        upload,
    };
};

/**
 * UploadApi - interface
 * @export
 * @interface UploadApi
 */
export interface UploadApiInterface {
    /**
     * Creates a file attached to a specific user, and returns a 
     * @summary Upload a File
     * @param {UploadApiUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApiInterface
     */
    upload(requestParameters: UploadApiUploadRequest, options?: any): AxiosPromise<FileModel>;

}

/**
 * Request parameters for upload operation in UploadApi.
 * @export
 * @interface UploadApiUploadRequest
 */
export interface UploadApiUploadRequest {
    /**
     * 
     * @type {any}
     * @memberof UploadApiUpload
     */
    readonly image: any

    /**
     * 
     * @type {FileType}
     * @memberof UploadApiUpload
     */
    readonly type: FileType

    /**
     * 
     * @type {string}
     * @memberof UploadApiUpload
     */
    readonly title?: string

    /**
     * 
     * @type {string}
     * @memberof UploadApiUpload
     */
    readonly alt?: string

    /**
     * 
     * @type {FileStatus}
     * @memberof UploadApiUpload
     */
    readonly status?: FileStatus

    /**
     * This allows privileged users to set the visibility level to allow other users to see a files. This will default to hidden, which means no one will see it, even the current user.  Setting to private will add the file to my file library.  Setting to location and company will allow anyone in my location or company respectively.  Setting to public is only available to admins and will add it to the global library 
     * @type {FileVisibility}
     * @memberof UploadApiUpload
     */
    readonly visibility?: FileVisibility
}

/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI implements UploadApiInterface {
    /**
     * Creates a file attached to a specific user, and returns a 
     * @summary Upload a File
     * @param {UploadApiUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public upload(requestParameters: UploadApiUploadRequest, options?: any) {
        const request = UploadApiFp(this.configuration).upload(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new user for a company 
         * @summary Create User
         * @param {CreateUserBody} createUserBody Request body for creating user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: (createUserBody: CreateUserBody, options: any = {}): RequestArgs => {
            // verify required parameter 'createUserBody' is not null or undefined
            assertParamExists('createUser', 'createUserBody', createUserBody)
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a user
         * @param {number} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: (userId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current user 
         * @summary Get Current User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: (options: any = {}): RequestArgs => {
            const localVarPath = `/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single user by id 
         * @summary Get User
         * @param {number} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: (userId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Impersonate a user 
         * @summary Impersonate a user
         * @param {number} userId The id of the user to impersonate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonate: (userId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('impersonate', 'userId', userId)
            const localVarPath = `/auth/impersonate/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of users, open only to admins and managers 
         * @summary List users
         * @param {number} [page] The page number of results
         * @param {number} [perPage] The number of results per page
         * @param {string} [sort] The field to sort on
         * @param {'asc' | 'desc'} [direction] The direction to sort
         * @param {number} [agencyId] The id of the agency.  This this will only be callable by admins
         * @param {number} [companyId] The id of the company.  This this will only be callable by admins and company managers
         * @param {number} [locationId] The id of the location.  This this will only be callable by admins and company managers
         * @param {number} [territoryId] The id of the territory.  This will only be callable by admins and company managers
         * @param {number} [userId] The id of the company.  This this will only be callable by admins and company managers
         * @param {UserStatus} [status] The status of the user.  This this will only be callable by admins and company managers
         * @param {string} [search] Indexed search of order records the current user has access to.
         * @param {boolean} [withProjects] Only show users that have at least one project
         * @param {UserRole} [role] The role the user belongs to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: (page?: number, perPage?: number, sort?: string, direction?: 'asc' | 'desc', agencyId?: number, companyId?: number, locationId?: number, territoryId?: number, userId?: number, status?: UserStatus, search?: string, withProjects?: boolean, role?: UserRole, options: any = {}): RequestArgs => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (agencyId !== undefined) {
                localVarQueryParameter['agency_id'] = agencyId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (territoryId !== undefined) {
                localVarQueryParameter['territory_id'] = territoryId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (withProjects !== undefined) {
                localVarQueryParameter['with_projects'] = withProjects;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a new account.  This will create a user account with no access rights, and notify the admins so that they can approve the requested account 
         * @summary Register an Account
         * @param {RequestAccountBody} requestAccountBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: (requestAccountBody: RequestAccountBody, options: any = {}): RequestArgs => {
            // verify required parameter 'requestAccountBody' is not null or undefined
            assertParamExists('register', 'requestAccountBody', requestAccountBody)
            const localVarPath = `/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestAccountBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a new account.  This will create a user account with limited access to resources 
         * @summary Register for a limited resource only account
         * @param {RequestResourceAccountBody} requestResourceAccountBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerResourceAccess: (requestResourceAccountBody: RequestResourceAccountBody, options: any = {}): RequestArgs => {
            // verify required parameter 'requestResourceAccountBody' is not null or undefined
            assertParamExists('registerResourceAccess', 'requestResourceAccountBody', requestResourceAccountBody)
            const localVarPath = `/auth/resource-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestResourceAccountBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User representations
         * @param {number} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        represents: (userId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('represents', 'userId', userId)
            const localVarPath = `/user/{user_id}/represents`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stop impersonating a user 
         * @summary Stop impersonating a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopImpersonate: (options: any = {}): RequestArgs => {
            const localVarPath = `/auth/stop-impersonate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the profile of the current user 
         * @summary Update Profile
         * @param {UserUpdate | UserUpdate & PasswordUpdate} userUpdateUserUpdatePasswordUpdate Request body for updating profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: (userUpdateUserUpdatePasswordUpdate: UserUpdate | UserUpdate & PasswordUpdate, options: any = {}): RequestArgs => {
            // verify required parameter 'userUpdateUserUpdatePasswordUpdate' is not null or undefined
            assertParamExists('updateProfile', 'userUpdateUserUpdatePasswordUpdate', userUpdateUserUpdatePasswordUpdate)
            const localVarPath = `/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateUserUpdatePasswordUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a user with a specific id 
         * @summary Update user
         * @param {number} userId The id of the user
         * @param {UserUpdate} userUpdate Request body for updating user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: (userId: number, userUpdate: UserUpdate, options: any = {}): RequestArgs => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'userUpdate' is not null or undefined
            assertParamExists('updateUser', 'userUpdate', userUpdate)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send the onboarding email to a user.  Right now no request body is required, though this might change 
         * @summary Send User Welcome
         * @param {number} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userWelcome: (userId: number, options: any = {}): RequestArgs => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userWelcome', 'userId', userId)
            const localVarPath = `/user/{user_id}/welcome`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new user for a company 
         * @summary Create User
         * @param {UserApiCreateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(requestParameters: UserApiCreateUserRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<User>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.createUser(requestParameters.createUserBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a user with a specific id 
         * @summary Delete a user
         * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(requestParameters: UserApiDeleteUserRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<void>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.deleteUser(requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the current user 
         * @summary Get Current User
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegisteredUser>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getCurrentUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a single user by id 
         * @summary Get User
         * @param {UserApiGetUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(requestParameters: UserApiGetUserRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<User>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.getUser(requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Impersonate a user 
         * @summary Impersonate a user
         * @param {UserApiImpersonateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonate(requestParameters: UserApiImpersonateRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<StartImpersonatingResponse>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.impersonate(requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a list of users, open only to admins and managers 
         * @summary List users
         * @param {UserApiListUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(requestParameters: UserApiListUsersRequest = {}, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<PaginatedUsers>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.listUsers(requestParameters.page, requestParameters.perPage, requestParameters.sort, requestParameters.direction, requestParameters.agencyId, requestParameters.companyId, requestParameters.locationId, requestParameters.territoryId, requestParameters.userId, requestParameters.status, requestParameters.search, requestParameters.withProjects, requestParameters.role, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Request a new account.  This will create a user account with no access rights, and notify the admins so that they can approve the requested account 
         * @summary Register an Account
         * @param {UserApiRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(requestParameters: UserApiRegisterRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<User>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.register(requestParameters.requestAccountBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Request a new account.  This will create a user account with limited access to resources 
         * @summary Register for a limited resource only account
         * @param {UserApiRegisterResourceAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerResourceAccess(requestParameters: UserApiRegisterResourceAccessRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<User>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.registerResourceAccess(requestParameters.requestResourceAccountBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get User representations
         * @param {UserApiRepresentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        represents(requestParameters: UserApiRepresentsRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<Array<CompanyWithLocations>>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.represents(requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Stop impersonating a user 
         * @summary Stop impersonating a user
         * @param {undefined} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopImpersonate(requestParameters?: undefined, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegisteredUser>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.stopImpersonate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the profile of the current user 
         * @summary Update Profile
         * @param {UserApiUpdateProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(requestParameters: UserApiUpdateProfileRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegisteredUser>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateProfile(requestParameters.userUpdateUserUpdatePasswordUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a user with a specific id 
         * @summary Update user
         * @param {UserApiUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(requestParameters: UserApiUpdateUserRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<User>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.updateUser(requestParameters.userId, requestParameters.userUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send the onboarding email to a user.  Right now no request body is required, though this might change 
         * @summary Send User Welcome
         * @param {UserApiUserWelcomeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userWelcome(requestParameters: UserApiUserWelcomeRequest, options?: any): {
            (axios?: AxiosInstance, basePath?: string): AxiosPromise<RegisteredUser>;
            getQueryKey(axios?: AxiosInstance, basePath?: string): string[];
        } {
            const localVarAxiosArgs = localVarAxiosParamCreator.userWelcome(requestParameters.userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)

    /**
      * Create a new user for a company 
      * @summary Create User
      * @param {UserApiCreateUserRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const createUser = (requestParameters: UserApiCreateUserRequest, options?: any): AxiosPromise<User> => {
        const request = localVarFp.createUser(requestParameters, options);
        return request(axios, basePath);
    };

    createUser.getQueryKey = (requestParameters: UserApiCreateUserRequest, options?: any) => {
        const request = localVarFp.createUser(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Delete a user with a specific id 
      * @summary Delete a user
      * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const deleteUser = (requestParameters: UserApiDeleteUserRequest, options?: any): AxiosPromise<void> => {
        const request = localVarFp.deleteUser(requestParameters, options);
        return request(axios, basePath);
    };

    deleteUser.getQueryKey = (requestParameters: UserApiDeleteUserRequest, options?: any) => {
        const request = localVarFp.deleteUser(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Get the current user 
      * @summary Get Current User
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getCurrentUser = (requestParameters?: undefined, options?: any): AxiosPromise<RegisteredUser> => {
        const request = localVarFp.getCurrentUser(requestParameters, options);
        return request(axios, basePath);
    };

    getCurrentUser.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.getCurrentUser(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a single user by id 
      * @summary Get User
      * @param {UserApiGetUserRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const getUser = (requestParameters: UserApiGetUserRequest, options?: any): AxiosPromise<User> => {
        const request = localVarFp.getUser(requestParameters, options);
        return request(axios, basePath);
    };

    getUser.getQueryKey = (requestParameters: UserApiGetUserRequest, options?: any) => {
        const request = localVarFp.getUser(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Impersonate a user 
      * @summary Impersonate a user
      * @param {UserApiImpersonateRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const impersonate = (requestParameters: UserApiImpersonateRequest, options?: any): AxiosPromise<StartImpersonatingResponse> => {
        const request = localVarFp.impersonate(requestParameters, options);
        return request(axios, basePath);
    };

    impersonate.getQueryKey = (requestParameters: UserApiImpersonateRequest, options?: any) => {
        const request = localVarFp.impersonate(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Fetch a list of users, open only to admins and managers 
      * @summary List users
      * @param {UserApiListUsersRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const listUsers = (requestParameters: UserApiListUsersRequest = {}, options?: any): AxiosPromise<PaginatedUsers> => {
        const request = localVarFp.listUsers(requestParameters, options);
        return request(axios, basePath);
    };

    listUsers.getQueryKey = (requestParameters: UserApiListUsersRequest = {}, options?: any) => {
        const request = localVarFp.listUsers(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Request a new account.  This will create a user account with no access rights, and notify the admins so that they can approve the requested account 
      * @summary Register an Account
      * @param {UserApiRegisterRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const register = (requestParameters: UserApiRegisterRequest, options?: any): AxiosPromise<User> => {
        const request = localVarFp.register(requestParameters, options);
        return request(axios, basePath);
    };

    register.getQueryKey = (requestParameters: UserApiRegisterRequest, options?: any) => {
        const request = localVarFp.register(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Request a new account.  This will create a user account with limited access to resources 
      * @summary Register for a limited resource only account
      * @param {UserApiRegisterResourceAccessRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const registerResourceAccess = (requestParameters: UserApiRegisterResourceAccessRequest, options?: any): AxiosPromise<User> => {
        const request = localVarFp.registerResourceAccess(requestParameters, options);
        return request(axios, basePath);
    };

    registerResourceAccess.getQueryKey = (requestParameters: UserApiRegisterResourceAccessRequest, options?: any) => {
        const request = localVarFp.registerResourceAccess(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * 
      * @summary Get User representations
      * @param {UserApiRepresentsRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const represents = (requestParameters: UserApiRepresentsRequest, options?: any): AxiosPromise<Array<CompanyWithLocations>> => {
        const request = localVarFp.represents(requestParameters, options);
        return request(axios, basePath);
    };

    represents.getQueryKey = (requestParameters: UserApiRepresentsRequest, options?: any) => {
        const request = localVarFp.represents(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Stop impersonating a user 
      * @summary Stop impersonating a user
      * @param {undefined} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const stopImpersonate = (requestParameters?: undefined, options?: any): AxiosPromise<RegisteredUser> => {
        const request = localVarFp.stopImpersonate(requestParameters, options);
        return request(axios, basePath);
    };

    stopImpersonate.getQueryKey = (requestParameters?: undefined, options?: any) => {
        const request = localVarFp.stopImpersonate(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update the profile of the current user 
      * @summary Update Profile
      * @param {UserApiUpdateProfileRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateProfile = (requestParameters: UserApiUpdateProfileRequest, options?: any): AxiosPromise<RegisteredUser> => {
        const request = localVarFp.updateProfile(requestParameters, options);
        return request(axios, basePath);
    };

    updateProfile.getQueryKey = (requestParameters: UserApiUpdateProfileRequest, options?: any) => {
        const request = localVarFp.updateProfile(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Update a user with a specific id 
      * @summary Update user
      * @param {UserApiUpdateUserRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const updateUser = (requestParameters: UserApiUpdateUserRequest, options?: any): AxiosPromise<User> => {
        const request = localVarFp.updateUser(requestParameters, options);
        return request(axios, basePath);
    };

    updateUser.getQueryKey = (requestParameters: UserApiUpdateUserRequest, options?: any) => {
        const request = localVarFp.updateUser(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };
    /**
      * Send the onboarding email to a user.  Right now no request body is required, though this might change 
      * @summary Send User Welcome
      * @param {UserApiUserWelcomeRequest} requestParameters Request parameters.
      * @param {*} [options] Override http request option.
      * @throws {RequiredError}
      */
    const userWelcome = (requestParameters: UserApiUserWelcomeRequest, options?: any): AxiosPromise<RegisteredUser> => {
        const request = localVarFp.userWelcome(requestParameters, options);
        return request(axios, basePath);
    };

    userWelcome.getQueryKey = (requestParameters: UserApiUserWelcomeRequest, options?: any) => {
        const request = localVarFp.userWelcome(requestParameters, options);
        return request.getQueryKey(axios, basePath);
    };

    return {
        createUser,
        deleteUser,
        getCurrentUser,
        getUser,
        impersonate,
        listUsers,
        register,
        registerResourceAccess,
        represents,
        stopImpersonate,
        updateProfile,
        updateUser,
        userWelcome,
    };
};

/**
 * UserApi - interface
 * @export
 * @interface UserApi
 */
export interface UserApiInterface {
    /**
     * Create a new user for a company 
     * @summary Create User
     * @param {UserApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    createUser(requestParameters: UserApiCreateUserRequest, options?: any): AxiosPromise<User>;

    /**
     * Delete a user with a specific id 
     * @summary Delete a user
     * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    deleteUser(requestParameters: UserApiDeleteUserRequest, options?: any): AxiosPromise<void>;

    /**
     * Get the current user 
     * @summary Get Current User
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    getCurrentUser(requestParameters?: undefined, options?: any): AxiosPromise<RegisteredUser>;

    /**
     * Fetch a single user by id 
     * @summary Get User
     * @param {UserApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    getUser(requestParameters: UserApiGetUserRequest, options?: any): AxiosPromise<User>;

    /**
     * Impersonate a user 
     * @summary Impersonate a user
     * @param {UserApiImpersonateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    impersonate(requestParameters: UserApiImpersonateRequest, options?: any): AxiosPromise<StartImpersonatingResponse>;

    /**
     * Fetch a list of users, open only to admins and managers 
     * @summary List users
     * @param {UserApiListUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    listUsers(requestParameters?: UserApiListUsersRequest, options?: any): AxiosPromise<PaginatedUsers>;

    /**
     * Request a new account.  This will create a user account with no access rights, and notify the admins so that they can approve the requested account 
     * @summary Register an Account
     * @param {UserApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    register(requestParameters: UserApiRegisterRequest, options?: any): AxiosPromise<User>;

    /**
     * Request a new account.  This will create a user account with limited access to resources 
     * @summary Register for a limited resource only account
     * @param {UserApiRegisterResourceAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    registerResourceAccess(requestParameters: UserApiRegisterResourceAccessRequest, options?: any): AxiosPromise<User>;

    /**
     * 
     * @summary Get User representations
     * @param {UserApiRepresentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    represents(requestParameters: UserApiRepresentsRequest, options?: any): AxiosPromise<Array<CompanyWithLocations>>;

    /**
     * Stop impersonating a user 
     * @summary Stop impersonating a user
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    stopImpersonate(requestParameters?: undefined, options?: any): AxiosPromise<RegisteredUser>;

    /**
     * Update the profile of the current user 
     * @summary Update Profile
     * @param {UserApiUpdateProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    updateProfile(requestParameters: UserApiUpdateProfileRequest, options?: any): AxiosPromise<RegisteredUser>;

    /**
     * Update a user with a specific id 
     * @summary Update user
     * @param {UserApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    updateUser(requestParameters: UserApiUpdateUserRequest, options?: any): AxiosPromise<User>;

    /**
     * Send the onboarding email to a user.  Right now no request body is required, though this might change 
     * @summary Send User Welcome
     * @param {UserApiUserWelcomeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    userWelcome(requestParameters: UserApiUserWelcomeRequest, options?: any): AxiosPromise<RegisteredUser>;

}

/**
 * Request parameters for createUser operation in UserApi.
 * @export
 * @interface UserApiCreateUserRequest
 */
export interface UserApiCreateUserRequest {
    /**
     * Request body for creating user
     * @type {CreateUserBody}
     * @memberof UserApiCreateUser
     */
    readonly createUserBody: CreateUserBody
}

/**
 * Request parameters for deleteUser operation in UserApi.
 * @export
 * @interface UserApiDeleteUserRequest
 */
export interface UserApiDeleteUserRequest {
    /**
     * The id of the user
     * @type {number}
     * @memberof UserApiDeleteUser
     */
    readonly userId: number
}

/**
 * Request parameters for getUser operation in UserApi.
 * @export
 * @interface UserApiGetUserRequest
 */
export interface UserApiGetUserRequest {
    /**
     * The id of the user
     * @type {number}
     * @memberof UserApiGetUser
     */
    readonly userId: number
}

/**
 * Request parameters for impersonate operation in UserApi.
 * @export
 * @interface UserApiImpersonateRequest
 */
export interface UserApiImpersonateRequest {
    /**
     * The id of the user to impersonate
     * @type {number}
     * @memberof UserApiImpersonate
     */
    readonly userId: number
}

/**
 * Request parameters for listUsers operation in UserApi.
 * @export
 * @interface UserApiListUsersRequest
 */
export interface UserApiListUsersRequest {
    /**
     * The page number of results
     * @type {number}
     * @memberof UserApiListUsers
     */
    readonly page?: number

    /**
     * The number of results per page
     * @type {number}
     * @memberof UserApiListUsers
     */
    readonly perPage?: number

    /**
     * The field to sort on
     * @type {string}
     * @memberof UserApiListUsers
     */
    readonly sort?: string

    /**
     * The direction to sort
     * @type {'asc' | 'desc'}
     * @memberof UserApiListUsers
     */
    readonly direction?: 'asc' | 'desc'

    /**
     * The id of the agency.  This this will only be callable by admins
     * @type {number}
     * @memberof UserApiListUsers
     */
    readonly agencyId?: number

    /**
     * The id of the company.  This this will only be callable by admins and company managers
     * @type {number}
     * @memberof UserApiListUsers
     */
    readonly companyId?: number

    /**
     * The id of the location.  This this will only be callable by admins and company managers
     * @type {number}
     * @memberof UserApiListUsers
     */
    readonly locationId?: number

    /**
     * The id of the territory.  This will only be callable by admins and company managers
     * @type {number}
     * @memberof UserApiListUsers
     */
    readonly territoryId?: number

    /**
     * The id of the company.  This this will only be callable by admins and company managers
     * @type {number}
     * @memberof UserApiListUsers
     */
    readonly userId?: number

    /**
     * The status of the user.  This this will only be callable by admins and company managers
     * @type {UserStatus}
     * @memberof UserApiListUsers
     */
    readonly status?: UserStatus

    /**
     * Indexed search of order records the current user has access to.
     * @type {string}
     * @memberof UserApiListUsers
     */
    readonly search?: string

    /**
     * Only show users that have at least one project
     * @type {boolean}
     * @memberof UserApiListUsers
     */
    readonly withProjects?: boolean

    /**
     * The role the user belongs to.
     * @type {UserRole}
     * @memberof UserApiListUsers
     */
    readonly role?: UserRole
}

/**
 * Request parameters for register operation in UserApi.
 * @export
 * @interface UserApiRegisterRequest
 */
export interface UserApiRegisterRequest {
    /**
     * 
     * @type {RequestAccountBody}
     * @memberof UserApiRegister
     */
    readonly requestAccountBody: RequestAccountBody
}

/**
 * Request parameters for registerResourceAccess operation in UserApi.
 * @export
 * @interface UserApiRegisterResourceAccessRequest
 */
export interface UserApiRegisterResourceAccessRequest {
    /**
     * 
     * @type {RequestResourceAccountBody}
     * @memberof UserApiRegisterResourceAccess
     */
    readonly requestResourceAccountBody: RequestResourceAccountBody
}

/**
 * Request parameters for represents operation in UserApi.
 * @export
 * @interface UserApiRepresentsRequest
 */
export interface UserApiRepresentsRequest {
    /**
     * The id of the user
     * @type {number}
     * @memberof UserApiRepresents
     */
    readonly userId: number
}

/**
 * Request parameters for updateProfile operation in UserApi.
 * @export
 * @interface UserApiUpdateProfileRequest
 */
export interface UserApiUpdateProfileRequest {
    /**
     * Request body for updating profile
     * @type {UserUpdate | UserUpdate & PasswordUpdate}
     * @memberof UserApiUpdateProfile
     */
    readonly userUpdateUserUpdatePasswordUpdate: UserUpdate | UserUpdate & PasswordUpdate
}

/**
 * Request parameters for updateUser operation in UserApi.
 * @export
 * @interface UserApiUpdateUserRequest
 */
export interface UserApiUpdateUserRequest {
    /**
     * The id of the user
     * @type {number}
     * @memberof UserApiUpdateUser
     */
    readonly userId: number

    /**
     * Request body for updating user
     * @type {UserUpdate}
     * @memberof UserApiUpdateUser
     */
    readonly userUpdate: UserUpdate
}

/**
 * Request parameters for userWelcome operation in UserApi.
 * @export
 * @interface UserApiUserWelcomeRequest
 */
export interface UserApiUserWelcomeRequest {
    /**
     * The id of the user
     * @type {number}
     * @memberof UserApiUserWelcome
     */
    readonly userId: number
}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI implements UserApiInterface {
    /**
     * Create a new user for a company 
     * @summary Create User
     * @param {UserApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public createUser(requestParameters: UserApiCreateUserRequest, options?: any) {
        const request = UserApiFp(this.configuration).createUser(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Delete a user with a specific id 
     * @summary Delete a user
     * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteUser(requestParameters: UserApiDeleteUserRequest, options?: any) {
        const request = UserApiFp(this.configuration).deleteUser(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Get the current user 
     * @summary Get Current User
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getCurrentUser(requestParameters?: undefined, options?: any) {
        const request = UserApiFp(this.configuration).getCurrentUser(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a single user by id 
     * @summary Get User
     * @param {UserApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUser(requestParameters: UserApiGetUserRequest, options?: any) {
        const request = UserApiFp(this.configuration).getUser(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Impersonate a user 
     * @summary Impersonate a user
     * @param {UserApiImpersonateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public impersonate(requestParameters: UserApiImpersonateRequest, options?: any) {
        const request = UserApiFp(this.configuration).impersonate(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Fetch a list of users, open only to admins and managers 
     * @summary List users
     * @param {UserApiListUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public listUsers(requestParameters: UserApiListUsersRequest = {}, options?: any) {
        const request = UserApiFp(this.configuration).listUsers(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Request a new account.  This will create a user account with no access rights, and notify the admins so that they can approve the requested account 
     * @summary Register an Account
     * @param {UserApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public register(requestParameters: UserApiRegisterRequest, options?: any) {
        const request = UserApiFp(this.configuration).register(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Request a new account.  This will create a user account with limited access to resources 
     * @summary Register for a limited resource only account
     * @param {UserApiRegisterResourceAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public registerResourceAccess(requestParameters: UserApiRegisterResourceAccessRequest, options?: any) {
        const request = UserApiFp(this.configuration).registerResourceAccess(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get User representations
     * @param {UserApiRepresentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public represents(requestParameters: UserApiRepresentsRequest, options?: any) {
        const request = UserApiFp(this.configuration).represents(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Stop impersonating a user 
     * @summary Stop impersonating a user
     * @param {undefined} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public stopImpersonate(requestParameters?: undefined, options?: any) {
        const request = UserApiFp(this.configuration).stopImpersonate(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update the profile of the current user 
     * @summary Update Profile
     * @param {UserApiUpdateProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateProfile(requestParameters: UserApiUpdateProfileRequest, options?: any) {
        const request = UserApiFp(this.configuration).updateProfile(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Update a user with a specific id 
     * @summary Update user
     * @param {UserApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateUser(requestParameters: UserApiUpdateUserRequest, options?: any) {
        const request = UserApiFp(this.configuration).updateUser(requestParameters, options);
        return request(this.axios, this.basePath);
    }

    /**
     * Send the onboarding email to a user.  Right now no request body is required, though this might change 
     * @summary Send User Welcome
     * @param {UserApiUserWelcomeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userWelcome(requestParameters: UserApiUserWelcomeRequest, options?: any) {
        const request = UserApiFp(this.configuration).userWelcome(requestParameters, options);
        return request(this.axios, this.basePath);
    }
}

export const apiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        agency: AgencyApiFactory(configuration, basePath, axios),
        agencyGoal: AgencyGoalApiFactory(configuration, basePath, axios),
        auth: AuthApiFactory(configuration, basePath, axios),
        category: CategoryApiFactory(configuration, basePath, axios),
        company: CompanyApiFactory(configuration, basePath, axios),
        create: CreateApiFactory(configuration, basePath, axios),
        customers: CustomersApiFactory(configuration, basePath, axios),
        dashboard: DashboardApiFactory(configuration, basePath, axios),
        delete: DeleteApiFactory(configuration, basePath, axios),
        file: FileApiFactory(configuration, basePath, axios),
        get: GetApiFactory(configuration, basePath, axios),
        impersonate: ImpersonateApiFactory(configuration, basePath, axios),
        introduction: IntroductionApiFactory(configuration, basePath, axios),
        list: ListApiFactory(configuration, basePath, axios),
        location: LocationApiFactory(configuration, basePath, axios),
        login: LoginApiFactory(configuration, basePath, axios),
        opportunities: OpportunitiesApiFactory(configuration, basePath, axios),
        order: OrderApiFactory(configuration, basePath, axios),
        pricesheet: PricesheetApiFactory(configuration, basePath, axios),
        pricing: PricingApiFactory(configuration, basePath, axios),
        product: ProductApiFactory(configuration, basePath, axios),
        project: ProjectApiFactory(configuration, basePath, axios),
        quote: QuoteApiFactory(configuration, basePath, axios),
        region: RegionApiFactory(configuration, basePath, axios),
        register: RegisterApiFactory(configuration, basePath, axios),
        report: ReportApiFactory(configuration, basePath, axios),
        reset: ResetApiFactory(configuration, basePath, axios),
        resource: ResourceApiFactory(configuration, basePath, axios),
        resourceCategories: ResourceCategoriesApiFactory(configuration, basePath, axios),
        resourceCategory: ResourceCategoryApiFactory(configuration, basePath, axios),
        response: ResponseApiFactory(configuration, basePath, axios),
        salesforce: SalesforceApiFactory(configuration, basePath, axios),
        scorm: ScormApiFactory(configuration, basePath, axios),
        search: SearchApiFactory(configuration, basePath, axios),
        showerConfiguration: ShowerConfigurationApiFactory(configuration, basePath, axios),
        status: StatusApiFactory(configuration, basePath, axios),
        support: SupportApiFactory(configuration, basePath, axios),
        tempcontrol: TempcontrolApiFactory(configuration, basePath, axios),
        territory: TerritoryApiFactory(configuration, basePath, axios),
        tracking: TrackingApiFactory(configuration, basePath, axios),
        update: UpdateApiFactory(configuration, basePath, axios),
        upload: UploadApiFactory(configuration, basePath, axios),
        user: UserApiFactory(configuration, basePath, axios),
    };
};
